webpackJsonp([1,31,32],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(346),
    isIterateeCall = __webpack_require__(154),
    toInteger = __webpack_require__(147);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1007),
  /* template */
  __webpack_require__(1048),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a19aa926",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1008),
  /* template */
  __webpack_require__(1047),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a17e7a24",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1629)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1378),
  /* template */
  __webpack_require__(1785),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="M0 14.286h20V0H0v14.286zM16.85 1.65l1.054 1.01-4.701 4.506 4.652 4.46-1.054 1.01-4.652-4.46-2.146 2.057L10 10.23l-.002.002L7.85 8.176l-4.653 4.46-1.054-1.01 4.654-4.46L2.096 2.66l1.053-1.01L10 8.216l6.85-6.566z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _Label = __webpack_require__(927);

var _Label2 = _interopRequireDefault(_Label);

var _SpeechBalloonLabel = __webpack_require__(915);

var _SpeechBalloonLabel2 = _interopRequireDefault(_SpeechBalloonLabel);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _lazyloadImage = __webpack_require__(914);

var _lazyloadImage2 = _interopRequireDefault(_lazyloadImage);

var _utilities = __webpack_require__(51);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-level-one',
  mixins: [_lazyloadImage2.default],
  props: {
    nid: [Number, String],
    destinationTid: [Number, String],
    gtmType: {
      type: String,
      default: ''
    }
  },
  components: {
    NodeLink: _Link2.default,
    NodeLabel: _Label2.default,
    SpeechBalloonLabel: _SpeechBalloonLabel2.default
  },
  computed: {
    node: function node() {
      return this.$store.getters.node(this.nid);
    },
    title: function title() {
      return (0, _utilities.getSocialHeadLingAsTitle)(this.node);
    },
    image: function image() {
      return (0, _get2.default)(this, 'node.images[0].style_140x140');
    },
    articleType: function articleType() {
      return (0, _utilities.getArticleType)(this.node);
    },
    getGtmEvents: function getGtmEvents() {
      if (!(0, _isEmpty2.default)(this.gtmType)) {
        return _gtmManager2.default.getDynamicGtmEventsByType(this.gtmType, {
          label: (0, _get2.default)(this, 'node.relative_url', '')
        });
      }
      return false;
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _ProgressiveImage = __webpack_require__(917);

var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);

var _utilities = __webpack_require__(51);

var _lazyloadImage = __webpack_require__(914);

var _lazyloadImage2 = _interopRequireDefault(_lazyloadImage);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-level-three',
  mixins: [_lazyloadImage2.default, _section2.default],
  props: {
    node: {
      type: Object,
      default: {}
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  components: {
    NodeLink: _Link2.default,
    ProgressiveImage: _ProgressiveImage2.default
  },
  computed: {
    title: function title() {
      return (0, _utilities.getSocialHeadLingAsTitle)(this.node);
    },
    image: function image() {
      return (0, _get2.default)(this, 'node.images[0]', {});
    },
    destinationTid: function destinationTid() {
      return (0, _get2.default)(this.getLastSection((0, _get2.default)(this, 'node.sections', [])), 'tid', false);
    },
    progressiveImage: function progressiveImage() {
      return {
        src: this.image.style_600x600,
        loading: this.image.style_140x140,
        holder: '/image/placeholder/1/1/5A9CB5/20',
        error: '/image/placeholder/1/1/5A9CB5/20'
      };
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-level-four',
  mixins: [_section2.default],
  props: {
    node: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  components: {
    NodeLink: _Link2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    title: function title() {
      return (0, _utilities.getSocialHeadLingAsTitle)(this.node);
    },
    destinationTid: function destinationTid() {
      return (0, _get2.default)(this.getLastSection((0, _get2.default)(this, 'node.sections', [])), 'tid', false);
    }
  }
};

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lv = __webpack_require__(1001);

var _Lv2 = _interopRequireDefault(_Lv);

var _Lv3 = __webpack_require__(1002);

var _Lv4 = _interopRequireDefault(_Lv3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'also-read',
  props: {
    article: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ArticleLevelThree: _Lv2.default,
    ArticleLevelFour: _Lv4.default
  }
};

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1016), __esModule: true };

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1017), __esModule: true };

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(350);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1013);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1012);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(150);
module.exports = __webpack_require__(1018);


/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(150);
module.exports = __webpack_require__(1019);


/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var get = __webpack_require__(235);
module.exports = __webpack_require__(16).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(234);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(86);
module.exports = __webpack_require__(16).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".also-read-wrapper[data-v-13fa9f8d]{margin-top:1.75rem}@media (min-width:1024px){.also-read-wrapper[data-v-13fa9f8d]{margin-top:2.5rem}}.also-read-article-wrapper[data-v-13fa9f8d],.also-read-wrapper[data-v-13fa9f8d]{margin-bottom:1.75rem}@media (min-width:1024px){.also-read-article-wrapper[data-v-13fa9f8d],.also-read-wrapper[data-v-13fa9f8d]{margin-bottom:2.5rem}}.also-read-tag[data-v-13fa9f8d]{color:#000;position:relative;background-color:#18ffff;text-transform:uppercase;font-weight:700;display:inline-block;font-size:.875rem;line-height:1.625rem;padding:.125rem .75rem 0 1rem;font-family:Barlow,sans-serif}.also-read-tag[data-v-13fa9f8d]:before{width:0;height:0;border-style:solid;border-width:.75rem 0 0 .75rem;border-color:transparent transparent transparent #fff;content:\"\";position:absolute;left:0;bottom:0}.also-read-content[data-v-13fa9f8d]{border-style:solid;border-color:#18ffff;border-width:.25rem 0}", "", {"version":3,"sources":["/app/components/node/AlsoRead.vue"],"names":[],"mappings":"AAgCA,oCACE,kBAAoB,CAErB,AACD,0BACA,oCACM,iBAAmB,CACxB,CACA,AACD,gFAEE,qBAAuB,CAExB,AACD,0BACA,gFAEM,oBAAsB,CAC3B,CACA,AACD,gCACE,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,yBAA0B,AAC1B,gBAAkB,AAClB,qBAAsB,AACtB,kBAAoB,AACpB,qBAAsB,AACtB,8BAAiC,AACjC,6BAAkC,CACnC,AACD,uCACI,QAAS,AACT,SAAU,AACV,mBAAoB,AACpB,+BAAkC,AAClC,sDAA0D,AAC1D,WAAY,AACZ,kBAAmB,AACnB,OAAQ,AACR,QAAU,CACb,AACD,oCACE,mBAAoB,AACpB,qBAAsB,AACtB,qBAAwB,CACzB","file":"AlsoRead.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.also-read-wrapper[data-v-13fa9f8d] {\n  margin-top: 1.75rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.also-read-wrapper[data-v-13fa9f8d] {\n      margin-top: 2.5rem;\n}\n}\n.also-read-article-wrapper[data-v-13fa9f8d],\n.also-read-wrapper[data-v-13fa9f8d] {\n  margin-bottom: 1.75rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.also-read-article-wrapper[data-v-13fa9f8d],\n    .also-read-wrapper[data-v-13fa9f8d] {\n      margin-bottom: 2.5rem;\n}\n}\n.also-read-tag[data-v-13fa9f8d] {\n  color: #000000;\n  position: relative;\n  background-color: #18FFFF;\n  text-transform: uppercase;\n  font-weight: bold;\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 1.625rem;\n  padding: 0.125rem 0.75rem 0 1rem;\n  font-family: \"Barlow\", sans-serif;\n}\n.also-read-tag[data-v-13fa9f8d]:before {\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0.75rem 0 0 0.75rem;\n    border-color: transparent transparent transparent #FFFFFF;\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n.also-read-content[data-v-13fa9f8d] {\n  border-style: solid;\n  border-color: #18FFFF;\n  border-width: 0.25rem 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".article-level-four[data-v-a17e7a24]{font-family:Barlow,sans-serif}.article-level-four.theme-dark .card-title a[data-v-a17e7a24]{color:#fff}.article-level-four .card[data-v-a17e7a24]{border:none;background-color:transparent}@media (min-width:1024px){.article-level-four .card-block[data-v-a17e7a24]{padding:.625rem 0 .875rem}}@media (min-width:0) and (max-width:1023px){.article-level-four .card-block[data-v-a17e7a24]{padding:.5rem 0 .75rem}}.article-level-four .card-title[data-v-a17e7a24]{margin-bottom:0}.article-level-four .card-title a[data-v-a17e7a24]{color:#000;font-weight:700;padding-bottom:.125rem}@media (min-width:1024px){.article-level-four .card-title a[data-v-a17e7a24]{font-size:1.75rem;line-height:2.125rem}}@media (min-width:0) and (max-width:1023px){.article-level-four .card-title a[data-v-a17e7a24]{font-size:1.25rem;line-height:1.625rem}}.article-level-four .card-title a.theme-dark[data-v-a17e7a24]{color:#fff}", "", {"version":3,"sources":["/app/components/article-levels/Lv4.vue"],"names":[],"mappings":"AAgCA,qCACE,6BAAkC,CACnC,AACD,8DACI,UAAe,CAClB,AACD,2CACI,YAAa,AACb,4BAA8B,CACjC,AAKD,0BACA,iDACQ,yBAA6B,CACpC,CACA,AACD,4CACA,iDACQ,sBAA0B,CACjC,CACA,AACD,iDACI,eAAiB,CACpB,AACD,mDAGM,WAAe,AACf,gBAAkB,AAClB,sBAAyB,CAC9B,AACD,0BACA,mDACU,kBAAmB,AACnB,oBAAsB,CAC/B,CACA,AACD,4CACA,mDACU,kBAAmB,AACnB,oBAAsB,CAC/B,CACA,AACD,8DACQ,UAAe,CACtB","file":"Lv4.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-level-four[data-v-a17e7a24] {\n  font-family: \"Barlow\", sans-serif;\n}\n.article-level-four.theme-dark .card-title a[data-v-a17e7a24] {\n    color: #FFFFFF;\n}\n.article-level-four .card[data-v-a17e7a24] {\n    border: none;\n    background-color: transparent;\n}\n.article-level-four .card-block[data-v-a17e7a24] {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-level-four .card-block[data-v-a17e7a24] {\n        padding: 0.625rem 0 0.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-four .card-block[data-v-a17e7a24] {\n        padding: 0.5rem 0 0.75rem;\n}\n}\n.article-level-four .card-title[data-v-a17e7a24] {\n    margin-bottom: 0;\n}\n.article-level-four .card-title a[data-v-a17e7a24] {\n      /* Mobile breakpoints */\n      /* Mobile breakpoints */\n      color: #000000;\n      font-weight: bold;\n      padding-bottom: 0.125rem;\n}\n@media (min-width: 1024px) {\n.article-level-four .card-title a[data-v-a17e7a24] {\n          font-size: 1.75rem;\n          line-height: 2.125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-four .card-title a[data-v-a17e7a24] {\n          font-size: 1.25rem;\n          line-height: 1.625rem;\n}\n}\n.article-level-four .card-title a.theme-dark[data-v-a17e7a24] {\n        color: #FFFFFF;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".article-level-three[data-v-a19aa926]{font-family:Barlow,sans-serif}.article-level-three.theme-dark .card-title[data-v-a19aa926]{color:#fff}.article-level-three .card[data-v-a19aa926]{border:none;background-color:transparent}.article-level-three .card a[data-v-a19aa926]{min-height:1px}.article-level-three .card img[data-v-a19aa926]{width:100%;height:auto}.article-level-three a:focus img[data-v-a19aa926],.article-level-three a:hover img[data-v-a19aa926]{-webkit-filter:brightness(70%);color:#fff}@media (min-width:1024px){.article-level-three .card-block[data-v-a19aa926]{padding:.625rem 0 .875rem}}@media (min-width:0) and (max-width:1023px){.article-level-three .card-block[data-v-a19aa926]{padding:.5rem 0 .625rem}}.article-level-three .card-title[data-v-a19aa926]{margin-bottom:0;color:#000;font-weight:700;padding-bottom:.125rem}@media (min-width:1024px){.article-level-three .card-title[data-v-a19aa926]{font-size:1.75rem;line-height:2.125rem}}@media (min-width:0) and (max-width:1023px){.article-level-three .card-title[data-v-a19aa926]{font-size:1.25rem;line-height:1.625rem}}", "", {"version":3,"sources":["/app/components/article-levels/Lv3.vue"],"names":[],"mappings":"AAgCA,sCACE,6BAAkC,CACnC,AACD,6DACI,UAAe,CAClB,AACD,4CACI,YAAa,AACb,4BAA8B,CACjC,AACD,8CACM,cAAgB,CACrB,AACD,gDACM,WAAY,AACZ,WAAa,CAClB,AACD,oGACI,+BAAgC,AAChC,UAAe,CAClB,AAKD,0BACA,kDACQ,yBAA6B,CACpC,CACA,AACD,4CACA,kDACQ,uBAA2B,CAClC,CACA,AACD,kDACI,gBAAiB,AAGjB,WAAe,AACf,gBAAkB,AAClB,sBAAyB,CAC5B,AACD,0BACA,kDACQ,kBAAmB,AACnB,oBAAsB,CAC7B,CACA,AACD,4CACA,kDACQ,kBAAmB,AACnB,oBAAsB,CAC7B,CACA","file":"Lv3.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-level-three[data-v-a19aa926] {\n  font-family: \"Barlow\", sans-serif;\n}\n.article-level-three.theme-dark .card-title[data-v-a19aa926] {\n    color: #FFFFFF;\n}\n.article-level-three .card[data-v-a19aa926] {\n    border: none;\n    background-color: transparent;\n}\n.article-level-three .card a[data-v-a19aa926] {\n      min-height: 1px;\n}\n.article-level-three .card img[data-v-a19aa926] {\n      width: 100%;\n      height: auto;\n}\n.article-level-three a:hover img[data-v-a19aa926], .article-level-three a:focus img[data-v-a19aa926] {\n    -webkit-filter: brightness(70%);\n    color: #FFFFFF;\n}\n.article-level-three .card-block[data-v-a19aa926] {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-level-three .card-block[data-v-a19aa926] {\n        padding: 0.625rem 0 0.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-three .card-block[data-v-a19aa926] {\n        padding: 0.5rem 0 0.625rem;\n}\n}\n.article-level-three .card-title[data-v-a19aa926] {\n    margin-bottom: 0;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n    color: #000000;\n    font-weight: bold;\n    padding-bottom: 0.125rem;\n}\n@media (min-width: 1024px) {\n.article-level-three .card-title[data-v-a19aa926] {\n        font-size: 1.75rem;\n        line-height: 2.125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-three .card-title[data-v-a19aa926] {\n        font-size: 1.25rem;\n        line-height: 1.625rem;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, "img[data-v-a1d3072a]{width:6.625rem;height:6.625rem}a[data-v-a1d3072a]{color:#fff}a:focus img[data-v-a1d3072a],a:hover img[data-v-a1d3072a]{-webkit-filter:brightness(70%)}.card[data-v-a1d3072a]{border:none;background-color:transparent}.card-image[data-v-a1d3072a]{margin-right:.5rem;max-width:6.625rem}@media (min-width:1024px){.card-image[data-v-a1d3072a]{margin-right:1rem}}.card-block[data-v-a1d3072a]{padding:0}.card-section[data-v-a1d3072a]{color:#fff;font-weight:700;text-transform:uppercase;vertical-align:top;margin-top:.1875rem;margin-bottom:.25rem;font-size:.875rem;line-height:.875rem}@media (min-width:1024px){.card-section[data-v-a1d3072a]{font-size:1.25rem;line-height:1.5rem}}.card-section a[data-v-a1d3072a]{color:#fff}.card-title[data-v-a1d3072a]{margin-bottom:0;color:#fff;font-size:1.5rem;line-height:1.75rem}@media (min-width:1024px){.card-title[data-v-a1d3072a]{font-size:1.75rem;line-height:2.125rem}}.article-level-one[data-v-a1d3072a]{font-family:Barlow,sans-serif}.article-level-one[data-v-a1d3072a] .fields{vertical-align:top}.article-level-one[data-v-a1d3072a] .icon-wrapper{vertical-align:unset}.article-level-one[data-v-a1d3072a] .icon-wrapper svg{vertical-align:text-top;margin-top:-.125rem}.article-level-one--opinion .card-section[data-v-a1d3072a]{margin-bottom:0}.article-level-one--opinion[data-v-a1d3072a] .fields{display:inline-block;margin-right:.5rem;margin-bottom:.25rem}", "", {"version":3,"sources":["/app/components/article-levels/Lv1.vue"],"names":[],"mappings":"AAgCA,qBACE,eAAgB,AAChB,eAAiB,CAClB,AACD,mBACE,UAAe,CAChB,AACD,0DACE,8BAAgC,CACjC,AACD,uBACE,YAAa,AACb,4BAA8B,CAC/B,AACD,6BACE,mBAAqB,AACrB,kBAAoB,CAErB,AACD,0BACA,6BACM,iBAAmB,CACxB,CACA,AACD,6BACE,SAAW,CACZ,AACD,+BACE,WAAe,AACf,gBAAkB,AAClB,yBAA0B,AAC1B,mBAAoB,AACpB,oBAAsB,AACtB,qBAAuB,AACvB,kBAAoB,AACpB,mBAAsB,CAEvB,AACD,0BACA,+BACM,kBAAmB,AACnB,kBAAoB,CACzB,CACA,AACD,iCACI,UAAe,CAClB,AACD,6BACE,gBAAiB,AACjB,WAAe,AACf,iBAAkB,AAClB,mBAAqB,CAEtB,AACD,0BACA,6BACM,kBAAmB,AACnB,oBAAsB,CAC3B,CACA,AACD,oCACE,6BAAkC,CACnC,AACD,4CACI,kBAAoB,CACvB,AACD,kDACI,oBAAsB,CACzB,AACD,sDACM,wBAAyB,AACzB,mBAAsB,CAC3B,AACD,2DACI,eAAiB,CACpB,AACD,qDACI,qBAAsB,AAGtB,mBAAqB,AACrB,oBAAuB,CAH1B","file":"Lv1.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\nimg[data-v-a1d3072a] {\n  width: 6.625rem;\n  height: 6.625rem;\n}\na[data-v-a1d3072a] {\n  color: #FFFFFF;\n}\na:focus img[data-v-a1d3072a], a:hover img[data-v-a1d3072a] {\n  -webkit-filter: brightness(70%);\n}\n.card[data-v-a1d3072a] {\n  border: none;\n  background-color: transparent;\n}\n.card-image[data-v-a1d3072a] {\n  margin-right: 0.5rem;\n  max-width: 6.625rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.card-image[data-v-a1d3072a] {\n      margin-right: 1rem;\n}\n}\n.card-block[data-v-a1d3072a] {\n  padding: 0;\n}\n.card-section[data-v-a1d3072a] {\n  color: #FFFFFF;\n  font-weight: bold;\n  text-transform: uppercase;\n  vertical-align: top;\n  margin-top: 0.1875rem;\n  margin-bottom: 0.25rem;\n  font-size: 0.875rem;\n  line-height: 0.875rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.card-section[data-v-a1d3072a] {\n      font-size: 1.25rem;\n      line-height: 1.5rem;\n}\n}\n.card-section a[data-v-a1d3072a] {\n    color: #FFFFFF;\n}\n.card-title[data-v-a1d3072a] {\n  margin-bottom: 0;\n  color: #FFFFFF;\n  font-size: 1.5rem;\n  line-height: 1.75rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.card-title[data-v-a1d3072a] {\n      font-size: 1.75rem;\n      line-height: 2.125rem;\n}\n}\n.article-level-one[data-v-a1d3072a] {\n  font-family: \"Barlow\", sans-serif;\n}\n.article-level-one[data-v-a1d3072a] .fields {\n    vertical-align: top;\n}\n.article-level-one[data-v-a1d3072a] .icon-wrapper {\n    vertical-align: unset;\n}\n.article-level-one[data-v-a1d3072a] .icon-wrapper svg {\n      vertical-align: text-top;\n      margin-top: -0.125rem;\n}\n.article-level-one--opinion .card-section[data-v-a1d3072a] {\n    margin-bottom: 0;\n}\n.article-level-one--opinion[data-v-a1d3072a] .fields {\n    display: inline-block;\n}\n.article-level-one--opinion[data-v-a1d3072a] .fields {\n    margin-right: 0.5rem;\n    margin-bottom: 0.25rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(1074)
var getISOWeek = __webpack_require__(1075)
var getISOYear = __webpack_require__(998)
var parse = __webpack_require__(334)
var isValid = __webpack_require__(1076)
var enLocale = __webpack_require__(1080)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1020);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("586dd008", content, true, {});

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("44893320", content, true, {});

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1024);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("611cf104", content, true, {});

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1026);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("12ff29c2", content, true, {});

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(158),
    baseFlatten = __webpack_require__(157),
    copyArray = __webpack_require__(337),
    isArray = __webpack_require__(10);

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31),
    now = __webpack_require__(1038),
    toNumber = __webpack_require__(339);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(33);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1034)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1005),
  /* template */
  __webpack_require__(1050),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a1d3072a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1011),
  /* template */
  __webpack_require__(1044),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13fa9f8d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "also-read-wrapper"
  }, [_c('div', {
    class: ("also-read-article-wrapper " + (_vm.article.isLast ? 'last': ''))
  }, [_c('span', {
    staticClass: "also-read-tag"
  }, [_vm._v("also read")]), _c('div', {
    staticClass: "also-read-content",
    attrs: {
      "gtm-event-category": "Scroll Article"
    }
  }, [(_vm.article.layoutType === 3) ? _c('article-level-three', {
    attrs: {
      "node": _vm.article.node
    }
  }) : _c('article-level-four', {
    attrs: {
      "node": _vm.article.node
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper article-level-four",
    class: 'theme-' + _vm.theme
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": "click",
      "gtm-event-action": "Scroll Article/Click/Also Read",
      "gtm-event-label": ("" + (_vm.node.relative_url))
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper article-level-three",
    class: 'theme-' + _vm.theme
  }, [_c('div', {
    staticClass: "card"
  }, [_c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": "click",
      "gtm-event-action": "Scroll Article/Click/Also Read",
      "gtm-event-label": ("" + (_vm.node.relative_url))
    }
  }, [_c('progressive-image', {
    staticClass: "disable-photoslider",
    attrs: {
      "progressiveImage": _vm.progressiveImage,
      "alt": _vm.image.alt,
      "width": "320",
      "height": "320"
    }
  }), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1050:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper article-level-one",
    class: {
      'article-level-one--opinion': _vm.articleType === 'opinion'
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "d-flex align-self-top card-image"
  }, [(_vm.articleType === 'live') ? [(_vm.image) ? _c('SpeechBalloonLabel', {
    attrs: {
      "node": _vm.node,
      "size": "small",
      "mainComponent": "article-level-one",
      "shadow": ""
    }
  }) : _vm._e()] : _vm._e(), _c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": _vm.getGtmEvents.on,
      "gtm-event-action": _vm.getGtmEvents.action,
      "gtm-event-label": _vm.getGtmEvents.label
    }
  }, [(_vm.image) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.getArticleLazyloadImage(_vm.image, 1, 1, '5A9CB5', 20)),
      expression: "getArticleLazyloadImage(image, 1, 1, '5A9CB5', 20)"
    }],
    attrs: {
      "alt": _vm.node.title,
      "width": "106",
      "height": "106"
    }
  }) : _vm._e()])], 2), _c('div', {
    staticClass: "media-body"
  }, [_c('node-label', {
    staticClass: "card-section",
    attrs: {
      "node": _vm.node,
      "noColor": true
    }
  }, [(_vm.articleType === 'opinion') ? [_c('SpeechBalloonLabel', {
    attrs: {
      "slot": "speechBalloonLabel",
      "node": _vm.node,
      "size": "small-20-responsive",
      "mainComponent": "article-level-one__node-label",
      "shadow": ""
    },
    slot: "speechBalloonLabel"
  })] : _vm._e()], 2), _c('div', {
    staticClass: "card-title"
  }, [_c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": _vm.getGtmEvents.on,
      "gtm-event-action": _vm.getGtmEvents.action,
      "gtm-event-label": _vm.getGtmEvents.label
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1052:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="303" height="107" viewBox="0 0 303 107" xmlns="http://www.w3.org/2000/svg"><path d="M106.882.714H53.47v17.709H35.648v17.72H17.83v17.714H0v17.709h35.647v17.72h17.824V107H71.3V89.286h17.817v-17.72h35.653v17.72H178.242v-17.72h35.64v17.72h17.83V107h17.817V89.286h17.824v-17.72H303V53.857h-17.818V36.143h-17.83v-17.72H249.53V.714h-53.47z" fill="#F8008E" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(1054)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1064),
  /* template */
  __webpack_require__(1100),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ff55563",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utilities = __webpack_require__(51);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _forEachRight = __webpack_require__(1094);

var _forEachRight2 = _interopRequireDefault(_forEachRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    repositionOverlappingQuotes: function repositionOverlappingQuotes() {
      if (this.isBodyLeftQuoteMode) {
        var quotesList = document.querySelectorAll('.article-body-blockquote');

        if (quotesList.length !== 0) {
          this.moveDownOverlappingQuotes(quotesList);

          this.moveQuotesWithinContainerLimit(quotesList);
        }
      }
      return false;
    },
    getMoveUpPos: function getMoveUpPos(currentOffsetTop, currentDOMRect, comparedToDOMRect) {
      return (0, _utilities.numberToRem)(currentOffsetTop - ((0, _get2.default)(currentDOMRect, 'bottom', 0) - (0, _get2.default)(comparedToDOMRect, 'top', 0)));
    },
    getMoveDownPos: function getMoveDownPos(currentOffsetTop, currentDOMRect) {
      return (0, _utilities.numberToRem)(currentOffsetTop + (0, _get2.default)(currentDOMRect, 'height', 0));
    },
    moveDownOverlappingQuotes: function moveDownOverlappingQuotes(quotesList) {
      var _this = this;

      (0, _forEach2.default)(quotesList, function (currentBq, index) {
        if (index <= quotesList.length - 1) {
          var nextBq = quotesList[index + 1];
          var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;
          var nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false;

          if (currentDOMRect) {
            if (nextBq && currentDOMRect.bottom >= nextDOMRect.top) {
              nextBq.style.top = _this.getMoveDownPos(currentBq.offsetTop, currentDOMRect);
            }
          }
        }
      });
    },
    moveQuotesWithinContainerLimit: function moveQuotesWithinContainerLimit(quotesList) {
      var _this2 = this;

      var containerEl = (0, _get2.default)(this, '$refs[articleBody]', false);
      var containerElDOMRect = containerEl ? containerEl.getBoundingClientRect() : false;

      var nonQuoteEl = (0, _get2.default)(document.querySelectorAll('.unblock-left-quote'), '[0]', false);
      var nonQuoteElDOMRect = nonQuoteEl ? nonQuoteEl.getBoundingClientRect() : false;

      if (containerElDOMRect) {
        (0, _forEachRight2.default)(quotesList, function (currentBq, index) {
          if (index <= quotesList.length - 1) {
            var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;

            if (currentDOMRect) {
              if (currentDOMRect.bottom >= containerElDOMRect.bottom) {
                var breaklimitBottomPos = containerElDOMRect.bottom - currentDOMRect.top;
                var moveToBottomPos = currentBq.offsetTop + breaklimitBottomPos;
                var getMoveUpPos = moveToBottomPos - currentDOMRect.height;
                currentBq.style.top = (0, _utilities.numberToRem)(getMoveUpPos);
              }
            }
          }
        });

        if (nonQuoteElDOMRect) {
          (0, _forEachRight2.default)(quotesList, function (currentBq, index) {
            if (index <= quotesList.length - 1) {
              var prevBq = quotesList[index - 1];
              var nextBq = quotesList[index + 1];
              var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;
              var nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false;

              if (currentDOMRect) {
                if (currentDOMRect.bottom >= nonQuoteElDOMRect.top && currentDOMRect.top <= nonQuoteElDOMRect.bottom) {
                  currentBq.style.top = currentDOMRect.bottom >= nextDOMRect.top ? _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect) : _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nonQuoteElDOMRect);
                } else if (prevBq && currentDOMRect.bottom >= nextDOMRect.top) {
                  currentBq.style.top = _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect);
                }
              }
            }
          });
        }

        (0, _forEachRight2.default)(quotesList, function (currentBq, index) {
          if (index <= quotesList.length - 1) {
            var nextBq = quotesList[index + 1];
            var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;
            var nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false;

            if (currentDOMRect && nextDOMRect) {
              if (currentDOMRect.bottom >= nextDOMRect.top) {
                currentBq.style.top = _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect);
              }
            }
          }
        });

        (0, _forEach2.default)(quotesList, function (currentBq, index) {
          if (index <= quotesList.length - 1) {
            var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;

            if (currentDOMRect) {
              if (currentDOMRect.top <= containerElDOMRect.top) {
                var breaklimitTopPos = containerElDOMRect.top - currentDOMRect.top;
                var moveToTopPos = currentBq.offsetTop + breaklimitTopPos;
                currentBq.style.top = (0, _utilities.numberToRem)(moveToTopPos);
              }
            }
          }
        });

        this.moveDownOverlappingQuotes(quotesList);

        if (nonQuoteElDOMRect) {
          (0, _forEach2.default)(quotesList, function (currentBq, index) {
            if (index <= quotesList.length - 1) {
              var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;

              if (currentDOMRect) {
                if (currentDOMRect.bottom >= containerElDOMRect.bottom) {
                  if (currentDOMRect.bottom >= nonQuoteElDOMRect.top && currentDOMRect.top <= nonQuoteElDOMRect.bottom) {
                    var breaklimitBottomPos = currentDOMRect.bottom - nonQuoteElDOMRect.top;
                    var moveToBottomPos = nonQuoteEl.offsetTop + breaklimitBottomPos;
                    nonQuoteEl.style.top = (0, _utilities.numberToRem)(moveToBottomPos);
                  }
                }
              }
            }
          });
        }
      }
    }
  }
};

/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _words = __webpack_require__(361);

var _words2 = _interopRequireDefault(_words);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    var self = this;

    if ((0, _get2.default)(self, 'getBodyOptions.photoOverlay', false)) {
      var fetchPhotos = [];
      if (!(0, _isEmpty2.default)(self.node.images)) {
        var attrTitle = '';
        (0, _forEach2.default)(self.$refs.articleBody.querySelectorAll('.article-body img'), function (v) {
          if (!(0, _includes2.default)(v.classList, 'disable-photoslider')) {
            attrTitle = v.getAttribute('title') || '';

            var imgSrc = v.parentNode.className.match(/colorbox/i) ? (0, _words2.default)(v.parentNode.getAttribute('href'), /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i) : (0, _words2.default)(v.getAttribute('tmp-src'), /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i);
            imgSrc = (0, _head2.default)(imgSrc) || false;
            if (imgSrc) {
              (0, _forEach2.default)(self.node.images, function (images) {
                var image = (0, _words2.default)(images.style_1320w, /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i);
                image = (0, _head2.default)(image) || false;
                if (v.parentNode.className.match(/colorbox/i) && imgSrc === image) {
                  fetchPhotos.push({ title: attrTitle, caption: attrTitle, enlarge: images.style_1320w, el: v });
                } else if (image === imgSrc) {
                  fetchPhotos.push({ title: attrTitle, caption: attrTitle, enlarge: images.style_1320w, el: v });
                }
              });
            }
          }
        });

        if (!(0, _isEmpty2.default)(fetchPhotos)) {
          (0, _forEach2.default)(fetchPhotos, function (v, i) {
            v.el.onclick = function (e) {
              e.preventDefault();
              _eventBus2.default.$emit('openPhotoSlider', i, false, fetchPhotos, self.node.title);
            };
          });
          var getPhotoFromUrl = (0, _get2.default)(this, '$route.fullPath').match(/(photo)\/(\d{1,2})\/?/);
          if (getPhotoFromUrl) {
            _eventBus2.default.$emit('openPhotoSlider', parseInt(getPhotoFromUrl[2], 0) - 1, false, fetchPhotos, self.node.title);
          }
        }
      }
    }
  }
};

/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(1015);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(1014);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vueResize = __webpack_require__(338);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _find = __webpack_require__(228);

var _find2 = _interopRequireDefault(_find);

var _assignIn2 = __webpack_require__(155);

var _assignIn3 = _interopRequireDefault(_assignIn2);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _reduce3 = __webpack_require__(976);

var _reduce4 = _interopRequireDefault(_reduce3);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _filter = __webpack_require__(156);

var _filter2 = _interopRequireDefault(_filter);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _AlsoRead = __webpack_require__(1043);

var _AlsoRead2 = _interopRequireDefault(_AlsoRead);

var _photoSlider = __webpack_require__(1059);

var _photoSlider2 = _interopRequireDefault(_photoSlider);

var _overlappingQuotes = __webpack_require__(1058);

var _overlappingQuotes2 = _interopRequireDefault(_overlappingQuotes);

var _InlineNewsletterForm = __webpack_require__(1057);

var _InlineNewsletterForm2 = _interopRequireDefault(_InlineNewsletterForm);

var _utilities = __webpack_require__(51);

var _Text = __webpack_require__(1097);

var _Text2 = _interopRequireDefault(_Text);

var _Image = __webpack_require__(1096);

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'field-body',
  components: {
    AlsoRead: _AlsoRead2.default,
    InlineNewsletterForm: _InlineNewsletterForm2.default,
    BodyText: _Text2.default,
    BodyImage: _Image2.default,
    BodyIframe: function BodyIframe() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1167));
    },
    BodyTwitter: function BodyTwitter() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1170));
    },
    BodyInstagram: function BodyInstagram() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1168));
    },
    BodyChart: function BodyChart() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1166));
    },
    BodyBlockquote: function BodyBlockquote() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1165));
    },
    BodyRelatedWidget: function BodyRelatedWidget() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1169));
    },
    ResizeObserver: _vueResize.ResizeObserver
  },
  props: {
    body: [String],
    bodyOptions: Object,
    node: Object
  },
  data: function data() {
    return {
      isDesktop: false
    };
  },

  mixins: [_photoSlider2.default, _overlappingQuotes2.default],
  computed: {
    getNewsLetterType: function getNewsLetterType() {
      return (0, _utilities.getNewsLetterMapping)((0, _get2.default)(this, 'node.sections', {}));
    },
    articleType: function articleType() {
      return (0, _utilities.getArticleType)((0, _get2.default)(this, 'node', {}));
    },
    newsLetterTheme: function newsLetterTheme() {
      switch ((0, _utilities.getArticleType)((0, _get2.default)(this, 'node', {}))) {
        case 'countdown':
          return 'white';
        case 'live':
          return 'white';
        case 'opinion':
          return 'white';
        case 'photo-essay':
          return 'black';
        case 'review':
          return 'white';
        case 'video':
          return 'black';
        default:
          return 'white';
      }
    },
    getBodyOptions: function getBodyOptions() {
      return (0, _assignIn3.default)({
        countDown: false,
        photoOverlay: false,
        inlineNewsletter: true,
        hideParagraphArrow: false,
        alsoRead: {
          enable: true,
          alsoReadLayout: [4, 3, 4, 4, 4],
          insertPosition: [6, 9, 12, 15, 18]
        }
      }, this.bodyOptions);
    },
    filterBody: function filterBody() {
      return this.node.body;
    },
    contentList: function contentList() {
      var counter = {};
      (0, _forEach2.default)((0, _get2.default)(this, 'node.contentList', []), function (value) {
        counter = (0, _assignIn3.default)(counter, (0, _defineProperty3.default)({}, '' + value.type, (0, _get2.default)(counter, '[' + value.type + ']', 0) + 1));
        value.itemTypeIndex = counter['' + value.type];
      });
      return (0, _get2.default)(this, 'node.contentList', []);
    },
    relatedArticles: function relatedArticles() {
      return (0, _get2.default)(this, 'node.related_articles', []);
    },
    isBodyLeftQuoteMode: function isBodyLeftQuoteMode() {
      switch ((0, _get2.default)(this, 'node.type', {})) {
        case 'article':
          {
            var exemptedArticleTypes = ['photo-essay', 'video'];
            return !(0, _includes2.default)(exemptedArticleTypes, (0, _utilities.getArticleType)((0, _get2.default)(this, 'node', {})));
          }
        case 'comparison':
          return false;
        default:
          return false;
      }
    },
    inlineNewsletterIndex: function inlineNewsletterIndex() {
      var contentListLength = this.contentList.length || 0;
      var firstAlsoReadPosition = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition[0]', false);
      var index = false;
      if (contentListLength) {
        if ((0, _isEmpty2.default)(this.alsoReadArticles)) {
          if (firstAlsoReadPosition) {
            index = contentListLength >= firstAlsoReadPosition ? firstAlsoReadPosition - 1 : contentListLength - 1;
          }
        } else if (this.alsoReadArticles.length === 1) {
          var lastAlsoReadPosition = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition[0]', false);

          if (lastAlsoReadPosition && contentListLength >= lastAlsoReadPosition + 4) {
            index = contentListLength - 2 - 1;
          }
        }
      }

      while ((0, _get2.default)(this, 'contentList[' + index + '].content.html') && this.contentList[index].content.html.match(/<h[1-5]>(.*)?<\/h[1-5]>/)) {
        index -= 1;
      }return index;
    },
    alsoReadArticlesIndexesAvailable: function alsoReadArticlesIndexesAvailable() {
      var _this = this;

      var bodyOptionPositionsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition', []);

      var _reduce = (0, _reduce4.default)(bodyOptionPositionsArray, function (result, position) {
        result[position - 1 <= _this.contentList.length ? 0 : 1].push(position - 1);
        return result;
      }, [[], []]),
          _reduce2 = (0, _slicedToArray3.default)(_reduce, 2),
          pass = _reduce2[0],
          fail = _reduce2[1];

      var indexesAvailableForAlsoRead = { pass: pass, fail: fail };
      return indexesAvailableForAlsoRead;
    },
    alsoReadArticles: function alsoReadArticles() {
      var _this2 = this;

      var isEnabled = (0, _get2.default)(this, 'getBodyOptions.alsoRead.enable', false);
      var alsoReadArticles = [];

      if (isEnabled) {
        var bodyOptionPositionsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition', []);
        var bodyOptionsLayoutsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.alsoReadLayout', []);
        var indexesAvailablePass = (0, _get2.default)(this, 'alsoReadArticlesIndexesAvailable[pass]', []);

        (0, _forEach2.default)(this.relatedArticles, function (article, articleIndex) {
          var getLayoutType = 4;
          var getInsertAtIndex = _this2.contentList.length;
          var getIsIndexAvailable = false;

          (0, _forEach2.default)(bodyOptionsLayoutsArray, function (type, typeIndex) {
            if (articleIndex === typeIndex) {
              getLayoutType = type;
              return false;
            }
            return true;
          });

          (0, _forEach2.default)(bodyOptionPositionsArray, function (position, positionIndex) {
            if (articleIndex === positionIndex) {
              getInsertAtIndex = position - 1;
              return false;
            }
            return true;
          });

          (0, _forEach2.default)(indexesAvailablePass, function (Available) {
            if (getInsertAtIndex === Available) {
              getIsIndexAvailable = true;
              return false;
            }
            return true;
          });

          while ((0, _get2.default)(_this2, 'contentList[' + getInsertAtIndex + '].content.html') && _this2.contentList[getInsertAtIndex].content.html.match(/<h[1-5]>(.*)?<\/h[1-5]>/)) {
            getInsertAtIndex -= 1;
          }var alsoReadDetails = {
            node: article,
            layoutType: getLayoutType,
            insertAtIndex: getInsertAtIndex,
            isIndexAvailable: getIsIndexAvailable,
            isLast: articleIndex === _this2.relatedArticles.length - 1
          };

          alsoReadArticles.push(alsoReadDetails);
        });
      }
      return alsoReadArticles;
    }
  },
  mounted: function mounted() {
    this.isDesktop = (0, _utilities.isDesktop)();

    this.arrowPlacement();
  },
  updated: function updated() {
    this.repositionOverlappingQuotes();
  },

  methods: {
    isShowingWhatisWidget: function isShowingWhatisWidget() {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var item = arguments[1];

      var whatisNid = (0, _get2.default)(item, 'content.attr.data-whatis-id', false);
      var whatis = (0, _find2.default)((0, _get2.default)(node, 'what_is_articles', []), ['nid', whatisNid]) || {};
      return (0, _get2.default)(whatis, 'short_title');
    },
    shareData: function shareData() {
      var obj = {
        url: (0, _get2.default)(this.node, 'url', ''),
        shortenUrl: (0, _get2.default)(this.node, 'shorten_url', ''),
        title: (0, _get2.default)(this.node, 'title', '')
      };
      return obj;
    },
    setElementRef: function setElementRef(key, index) {
      return 'processed-' + key + '-' + index;
    },
    arrowPlacement: function arrowPlacement() {
      var _this3 = this;

      if (!this.getBodyOptions.hideParagraphArrow) {
        (0, _forEach2.default)((0, _get2.default)(this, 'contentList', []), function (item, index) {
          if (index === 0 && (0, _get2.default)(item, 'type', '') !== 'image') {
            _this3.addClassToBodyRef(item.type, index, 'arrow-placement');
            return false;
          }

          if ((0, _get2.default)(item, 'type', '') === 'image') {
            var nextIndex = index + 1;
            var nextItem = (0, _get2.default)(_this3, 'contentList[' + nextIndex + ']', false);

            if (nextItem && (0, _get2.default)(nextItem, 'type', '') !== 'image') {
              _this3.addClassToBodyRef(nextItem.type, nextIndex, 'arrow-placement');
              return false;
            }
          }
          return true;
        });
      }
    },
    addClassToBodyRef: function addClassToBodyRef(key, index, className) {
      var referenceElement = (0, _get2.default)(this, '$refs[processed-' + key + '-' + index + ']', false);

      if (referenceElement) {
        var elementClassList = (0, _get2.default)((0, _head2.default)(referenceElement), '$el.classList', false);

        if (elementClassList) {
          elementClassList.add(className);
        }
      }
    },
    resizeBody: function resizeBody() {
      var bq = (0, _map2.default)((0, _filter2.default)(this.$refs, function (element, key) {
        return (0, _includes2.default)(key, 'processed-blockquote-');
      }), '[0].$el');
      this.isDesktop = (0, _utilities.isDesktop)();
      if ((0, _utilities.isDesktop)()) {
        if (bq.length !== 0 && this.isBodyLeftQuoteMode) {
          _eventBus2.default.$emit('repositionQuoteToRelatedEl');
          this.$nextTick(function () {
            this.repositionOverlappingQuotes();
          });
        } else {
          _eventBus2.default.$off('repositionQuoteToRelatedEl');
        }
      }
    }
  }
};

/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _utilities = __webpack_require__(51);

var _vueResize = __webpack_require__(338);

var _ShareButtons = __webpack_require__(335);

var _ShareButtons2 = _interopRequireDefault(_ShareButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'body-image',
  props: ['item', 'type', 'shareData', 'itemIndex', 'inlinePhotoList'],
  data: function data() {
    return {
      imageWrapperHeight: 0
    };
  },

  components: {
    ResizeObserver: _vueResize.ResizeObserver,
    ShareButtons: _ShareButtons2.default
  },
  mounted: function mounted() {
    var _this = this;

    this.$Lazyload.$on('loaded', function (_ref) {
      var el = _ref.el;

      if (el === _this.$refs.lazyload) {
        _this.imageWrapperHeight = 0;
      }
    });
    this.calculateWrapperHeight();
  },

  methods: {
    calculateWrapperHeight: function calculateWrapperHeight() {
      if (this.imageHeight > 0 && this.imageWidth > 0 && this.$refs.container.offsetWidth > 0) {
        if ((0, _utilities.isDesktop)()) {
          this.imageWrapperHeight = 'calc( (' + this.$refs.container.offsetWidth + 'px) * (' + this.imageHeight / this.imageWidth + '))';
        } else {
          this.imageWrapperHeight = 'calc( 100vw * (' + this.imageHeight / this.imageWidth + '))';
        }
      }
    },
    onResize: function onResize() {
      this.calculateWrapperHeight();
    }
  },
  computed: {
    styleObj: function styleObj() {
      var output = {};
      if (this.imageWrapperHeight) {
        output.height = this.imageWrapperHeight;
      }
      return output;
    },
    shareUrl: function shareUrl() {
      return (0, _get2.default)(this, 'inlinePhotoList[' + (this.itemIndex - 1) + '][sizes].style_700x400') ? this.shareData.url + '/photo/' + this.itemIndex : this.shareData.url;
    },
    shareThumbnail: function shareThumbnail() {
      return (0, _get2.default)(this, 'inlinePhotoList[' + (this.itemIndex - 1) + '][sizes].style_700x400');
    },
    imageAttribs: function imageAttribs() {
      return (0, _get2.default)(this, 'item.content.attribs', {});
    },
    imageStyle: function imageStyle() {
      return (0, _get2.default)(this, 'imageAttribs.style', '');
    },
    imageUrl: function imageUrl() {
      return (0, _get2.default)(this, 'imageAttribs.src', '');
    },
    imageHeight: function imageHeight() {
      var height = (0, _get2.default)(this, 'imageAttribs.height', '').replace(/px/g, '');
      if (height.length === 0 && this.imageStyle.length > 0) {
        var styleHeight = (0, _head2.default)(this.imageStyle.match(/height(.*?)px;/g));
        if (styleHeight.length > 0) height = styleHeight.match(/\d/g).join('');
      }
      return height;
    },
    imageWidth: function imageWidth() {
      var width = (0, _get2.default)(this, 'imageAttribs.width', '').replace(/px/g, '');
      if (width.length === 0 && this.imageStyle.length > 0) {
        var styleWidth = (0, _head2.default)(this.imageStyle.match(/width(.*?)px;/g));
        if (styleWidth.length > 0) width = styleWidth.match(/\d/g).join('');
      }
      return width;
    },
    imageClass: function imageClass() {
      return (0, _get2.default)(this, 'imageAttribs.class', '');
    },
    imageDataStyleType: function imageDataStyleType() {
      return (0, _get2.default)(this, 'imageAttribs[\'data-style-type\']', '');
    },
    imageDataWriter: function imageDataWriter() {
      return (0, _get2.default)(this, 'imageAttribs[\'data-writer\']', '');
    },
    imageTitle: function imageTitle() {
      return (0, _get2.default)(this, 'imageAttribs.title', '');
    }
  }
};

/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'body-text',
  props: ['item'],
  mounted: function mounted() {
    var bodyHtml = (0, _get2.default)(this, '$refs[body-html]');

    var currentDomain = (0, _get2.default)(this, '$store.state.requestDomain', '').replace(/^https?:\/\//i, '');
    var regexp = new RegExp(currentDomain, 'gi');

    if (bodyHtml) {
      (0, _forEach2.default)(bodyHtml.querySelectorAll('a'), function (value) {
        if (!value.getAttribute('href').match(regexp) && !value.getAttribute('href').match(/^\//i)) {
          if (!value.getAttribute('href').match(/mailto:/gi)) {
            value.setAttribute('target', '_blank');
          }
        }
      });
    }
  }
};

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _icon_email = __webpack_require__(1004);

var _icon_email2 = _interopRequireDefault(_icon_email);

var _icon_email3 = __webpack_require__(347);

var _icon_email4 = _interopRequireDefault(_icon_email3);

var _newsletter = __webpack_require__(953);

var _newsletter2 = _interopRequireDefault(_newsletter);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_newsletter2.default],
  props: {
    newsletterType: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    theme: {
      type: String,
      default: 'white' }
  },
  data: function data() {
    return {
      color: '#F8008E',
      submit: false,
      email: '',
      warning: false,
      subscition: false,
      lastText: false
    };
  },

  components: {
    SvgEmailLargeIcon: _icon_email2.default,
    SvgEmailIcon: _icon_email4.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['showNewsletter']), {
    colorTheme: function colorTheme() {
      var colorTheme = '';
      switch (this.newsletterType.color) {
        case 'blue':
          {
            colorTheme = 'innerbox-blue';
            break;
          }
        case 'yellow':
          {
            colorTheme = 'innerbox-yellow';
            break;
          }
        case 'green':
          {
            colorTheme = 'innerbox-green';
            break;
          }
        default:
          {
            colorTheme = 'innerbox-blue';
          }
      }
      return colorTheme + ' ' + this.theme;
    },
    gtmNewsletterCategory: function gtmNewsletterCategory() {
      var gtmType = 'gtmType_newsletter-inline';
      return (0, _get2.default)(_gtmManager2.default.getDynamicGtmEventsByType(gtmType, {}), 'category', false);
    }
  }),
  methods: {
    afterLeave: function afterLeave() {
      this.subscition = true;
      this.play2();
    },
    afterEnter: function afterEnter() {
      this.subscition = false;
    },
    thankyouEnter: function thankyouEnter() {
      this.lastText = true;
    },
    thankyouLeave: function thankyouLeave() {
      this.lastText = true;
    },
    onSubmit: function onSubmit(e) {
      if (this.validateEmail(this.email)) {
        this.play1();
        this.warning = false;
        this.submit = true;
        e.target.style.display = 'none';
        this.subscribeNewsletter(this.email, this.newsletterType, this.gtmNewsletterCategory);
      } else {
        this.warning = true;
        this.submit = false;
        this.subscition = false;
        e.target.style.display = 'block';
      }
    }
  },
  mounted: function mounted() {
    this.checkSubscribedToList(this.newsletterType);
  }
};

/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _vueResize = __webpack_require__(338);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isFunction = __webpack_require__(84);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _enews_diamondshape = __webpack_require__(1110);

var _enews_diamondshape2 = _interopRequireDefault(_enews_diamondshape);

var _emailBlack = __webpack_require__(1109);

var _emailBlack2 = _interopRequireDefault(_emailBlack);

var _email_monster = __webpack_require__(1052);

var _email_monster2 = _interopRequireDefault(_email_monster);

var _newsletter = __webpack_require__(953);

var _newsletter2 = _interopRequireDefault(_newsletter);

var _utilities = __webpack_require__(51);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_newsletter2.default],
  props: {
    sections: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    gtmType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      submit: false,
      monsterEmail: '',
      warning: false,
      subscription: false,
      subscriptionText: false,
      lastInnerBox: false,
      newsletterWrapperHeight: 'auto'
    };
  },

  components: {
    SvgDiamondShapeIcon: _enews_diamondshape2.default,
    SvgEmailBlackIcon: _emailBlack2.default,
    SvgEmailMonsterIcon: _email_monster2.default,
    ResizeObserver: _vueResize.ResizeObserver
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['showNewsletter']), {
    newsletterType: function newsletterType() {
      return (0, _utilities.getNewsLetterMapping)(this.sections) || {};
    },
    gtmNewsletterCategory: function gtmNewsletterCategory() {
      return (0, _get2.default)(_gtmManager2.default.getDynamicGtmEventsByType(this.gtmType, {}), 'category', false);
    }
  }),
  methods: {
    onResize: function onResize() {
      this.setNewsletterWrapperHeight();
    },
    onSubmit: function onSubmit() {
      if (this.validateEmail(this.monsterEmail)) {
        this.warning = false;
        this.submit = true;
        this.subscribeNewsletter(this.monsterEmail, this.newsletterType, this.gtmNewsletterCategory);
      } else {
        this.warning = true;
        this.submit = false;
      }
    },
    animation: function animation(e) {
      for (var i = 0; i < 5; i += 1) {
        var _classList = (0, _get2.default)(this, '$refs[\'innerbox-' + i + '\'].classList', []);
        if ((0, _isFunction2.default)(_classList[e])) _classList[e]('animated-inner-box');

        if (i === 0 && (0, _includes2.default)(_classList, 'animated-inner-box')) this.setNewsletterWrapperHeight();
      }
      var classList = (0, _get2.default)(this, '$refs.newsletterTextBox.classList', []);
      if ((0, _isFunction2.default)(classList[e])) classList[e]('animated-newsletter-text-box');
    },
    setNewsletterWrapperHeight: function setNewsletterWrapperHeight() {
      var firstInnerbox = (0, _get2.default)(this, '$refs.innerbox-0', false);

      if (!(0, _utilities.isDesktop)() && firstInnerbox) {
        var addHeightAllowance = 64;
        this.newsletterWrapperHeight = firstInnerbox.offsetHeight + addHeightAllowance + 'px';
      }
    }
  },
  mounted: function mounted() {
    this.checkSubscribedToList(this.newsletterType);
  }
};

/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".newsletter[data-v-2ff55563]{font-family:Barlow,sans-serif;height:14.8125rem}.newsletter.white .newsletter-form[data-v-2ff55563]{background:#fff}.newsletter.white .newsletter-form .title[data-v-2ff55563]{color:#979797}.newsletter.white .newsletter-form .title span[data-v-2ff55563]{color:#000}.newsletter.white .InputEmail[data-v-2ff55563]{background-color:#fff}.newsletter.black .newsletter-form[data-v-2ff55563]{background:#000}.newsletter.black .newsletter-form .title[data-v-2ff55563]{color:#979797}.newsletter.black .newsletter-form .title span[data-v-2ff55563]{color:#fff}.newsletter.black .newsletter-form .InputEmail[data-v-2ff55563]{background-color:#000;color:#fff}.newsletter .nested-border-1.white[data-v-2ff55563],.newsletter .nested-border-2.white[data-v-2ff55563],.newsletter .nested-border-3.white[data-v-2ff55563],.newsletter .nested-border-4.white[data-v-2ff55563],.newsletter .nested-border-5.white[data-v-2ff55563]{border-color:#fff!important}.newsletter .nested-border-1.black[data-v-2ff55563],.newsletter .nested-border-2.black[data-v-2ff55563],.newsletter .nested-border-3.black[data-v-2ff55563],.newsletter .nested-border-4.black[data-v-2ff55563],.newsletter .nested-border-5.black[data-v-2ff55563]{border-color:#000!important}.newsletter .warning[data-v-2ff55563]{margin-top:-.1875rem;margin-bottom:.1875rem;height:1.25rem}.newsletter .warning p[data-v-2ff55563]{background:#ff5cbe;font-size:.75rem;line-height:1.25rem;color:#fff;font-weight:700}.newsletter .mail-icon[data-v-2ff55563]{width:1.5rem;height:1.125rem}.newsletter .newsletter-form[data-v-2ff55563]{position:absolute;top:.4375rem;left:0;right:0;margin:0 auto;margin-right:.4375rem;margin-left:.4375rem;height:10.9375rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]{font-family:Barlow,sans-serif;font-size:1.5rem;border-radius:unset;border-bottom:3px solid #979797}.newsletter .newsletter-form .InputEmail.warning-color[data-v-2ff55563]{color:#ff5cbe}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-webkit-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-ms-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form input[data-v-2ff55563]{caret-color:#f8008e;outline-width:2px}.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]{height:2.5625rem;width:10rem;font-family:Barlow,sans-serif;background:#f8008e;border-radius:unset;color:#fff;font-size:1.125rem;padding-left:2.625rem;padding-right:2.625rem}.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover{background:#ff5cbe;-webkit-box-shadow:none;box-shadow:none}@media (min-width:0) and (max-width:1023px){.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover{background:#bf0061}}.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:focus{background:#bf0061;-webkit-box-shadow:none;box-shadow:none}.newsletter .newsletter-form .title[data-v-2ff55563]{font-size:.875rem;line-height:1rem;font-weight:700}.newsletter.innerbox-blue[data-v-2ff55563]{background:#00e8ff}.newsletter.innerbox-yellow[data-v-2ff55563]{background:#fceb40}.newsletter.innerbox-green[data-v-2ff55563]{background:#5bf3a6}.newsletter .innerbox[data-v-2ff55563]{height:13.6875rem;border:.1875rem solid;margin:.625rem}.newsletter .innerbox .innerbox[data-v-2ff55563]{height:12.1875rem;position:relative;border:.1875rem solid}.newsletter .innerbox .innerbox .innerbox[data-v-2ff55563]{border:.125rem solid;height:10.4375rem}.newsletter .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563]{border:.0625rem solid;height:8.8125rem}.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563]{border:.0625rem solid;height:7.3125rem;position:relative}.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox div[data-v-2ff55563]{height:7.3125rem}.newsletter .subscition-box[data-v-2ff55563]{height:11.8125rem;position:absolute;top:.25rem;left:0;right:0;margin:0 auto;height:7.1875rem;width:15.0625rem;top:15%}.newsletter .subscition-box .subscition[data-v-2ff55563]{padding:.625rem}.newsletter .subscition-box .subscition .inner-subscrition[data-v-2ff55563]{height:6.9375rem}.newsletter .subscition-box .subscition .inner-subscrition .mail-icon[data-v-2ff55563]{margin-bottom:.74125rem}.newsletter .subscition-box .subscition .inner-subscrition .subscrition-text[data-v-2ff55563]{font-size:.875rem;line-height:1rem;font-weight:700}@-webkit-keyframes newsletter-zoomIn{0%{opacity:1;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes newsletter-zoomIn-data-v-2ff55563{0%{opacity:1;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}.newsletter .newsletter-zoomIn[data-v-2ff55563]{-webkit-animation-name:newsletter-zoomIn-data-v-2ff55563;animation-name:newsletter-zoomIn-data-v-2ff55563}@-webkit-keyframes newsletter-zoomOut{0%{opacity:1}to{-webkit-transform:scale3d(0,0,0);transform:scale3d(0,0,0);opacity:1}}@keyframes newsletter-zoomOut-data-v-2ff55563{0%{opacity:1}to{-webkit-transform:scale3d(0,0,0);transform:scale3d(0,0,0);opacity:1}}.newsletter .newsletter-zoomOut[data-v-2ff55563]{-webkit-animation-name:newsletter-zoomOut-data-v-2ff55563;animation-name:newsletter-zoomOut-data-v-2ff55563}.newsletter .animated-last[data-v-2ff55563]{-webkit-animation-duration:.8s;animation-duration:.8s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.newsletter .animated-newsletter-form[data-v-2ff55563]{-webkit-animation-duration:.4s;animation-duration:.4s;-webkit-animation-fill-mode:both;animation-fill-mode:both}", "", {"version":3,"sources":["/app/components/widgets/InlineNewsletterForm.vue"],"names":[],"mappings":"AAgCA,6BACE,8BAAkC,AAClC,iBAAmB,CACpB,AACD,oDACI,eAAoB,CACvB,AACD,2DACM,aAAe,CACpB,AACD,gEACQ,UAAe,CACtB,AACD,+CACI,qBAA0B,CAC7B,AACD,oDACI,eAAoB,CACvB,AACD,2DACM,aAAe,CACpB,AACD,gEACQ,UAAe,CACtB,AACD,gEACM,sBAA0B,AAC1B,UAAe,CACpB,AACD,oQACI,2BAAiC,CACpC,AACD,oQACI,2BAAiC,CACpC,AACD,sCACI,qBAAuB,AACvB,uBAAyB,AACzB,cAAgB,CACnB,AACD,wCACM,mBAAoB,AACpB,iBAAmB,AACnB,oBAAqB,AACrB,WAAe,AACf,eAAkB,CACvB,AACD,wCACI,aAAc,AACd,eAAiB,CACpB,AACD,8CACI,kBAAmB,AACnB,aAAe,AACf,OAAQ,AACR,QAAS,AACT,cAAe,AACf,sBAAwB,AACxB,qBAAuB,AACvB,iBAAmB,CACtB,AACD,0DACM,8BAAkC,AAClC,iBAAkB,AAClB,oBAAqB,AACrB,+BAAiC,CACtC,AACD,wEACQ,aAAe,CACtB,AACD,qFAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,4EAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,gFAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,2EAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,oDACM,oBAAqB,AACrB,iBAAmB,CACxB,AACD,iEACM,iBAAkB,AAClB,YAAa,AACb,8BAAkC,AAClC,mBAAoB,AACpB,oBAAqB,AACrB,WAAe,AACf,mBAAoB,AACpB,sBAAuB,AACvB,sBAAwB,CAC7B,AACD,uEACQ,mBAAoB,AACpB,wBAAyB,AACjB,eAAiB,CAEhC,AACD,4CACA,uEACY,kBAAoB,CAC/B,CACA,AACD,uEACQ,mBAAoB,AACpB,wBAAyB,AACjB,eAAiB,CAChC,AACD,qDACM,kBAAoB,AACpB,iBAAkB,AAClB,eAAkB,CACvB,AACD,2CACI,kBAAoB,CACvB,AACD,6CACI,kBAAoB,CACvB,AACD,4CACI,kBAAoB,CACvB,AACD,uCACI,kBAAmB,AACnB,sBAAwB,AACxB,cAAiB,CACpB,AACD,iDACM,kBAAmB,AACnB,kBAAmB,AACnB,qBAAwB,CAC7B,AACD,2DACQ,qBAAuB,AACvB,iBAAmB,CAC1B,AACD,qEACU,sBAAwB,AACxB,gBAAkB,CAC3B,AACD,+EACY,sBAAwB,AACxB,iBAAkB,AAClB,iBAAmB,CAC9B,AACD,mFACc,gBAAkB,CAC/B,AACD,6CACI,kBAAmB,AACnB,kBAAmB,AACnB,WAAa,AACb,OAAQ,AACR,QAAS,AACT,cAAe,AACf,iBAAkB,AAClB,iBAAkB,AAClB,OAAS,CACZ,AACD,yDACM,eAAkB,CACvB,AACD,4EACQ,gBAAkB,CACzB,AACD,uFACU,uBAA0B,CACnC,AACD,8FACU,kBAAoB,AACpB,iBAAkB,AAClB,eAAkB,CAC3B,AACD,qCACA,GACI,UAAW,AACX,oCAA0C,AAClC,2BAAkC,CAC7C,AACD,IACI,SAAW,CACd,CACA,AACD,6CACA,GACI,UAAW,AACX,oCAA0C,AAClC,2BAAkC,CAC7C,AACD,IACI,SAAW,CACd,CACA,AACD,gDACI,yDAA0D,AAClD,gDAAkD,CAC7D,AACD,sCACA,GACI,SAAW,CACd,AACD,GACI,iCAAoC,AAC5B,yBAA4B,AACpC,SAAW,CACd,CACA,AACD,8CACA,GACI,SAAW,CACd,AACD,GACI,iCAAoC,AAC5B,yBAA4B,AACpC,SAAW,CACd,CACA,AACD,iDACI,0DAA2D,AACnD,iDAAmD,CAC9D,AACD,4CACI,+BAAiC,AACzB,uBAAyB,AACjC,iCAAkC,AAC1B,wBAA0B,CACrC,AACD,uDACI,+BAAiC,AACzB,uBAAyB,AACjC,iCAAkC,AAC1B,wBAA0B,CACrC","file":"InlineNewsletterForm.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.newsletter[data-v-2ff55563] {\n  font-family: \"Barlow\", sans-serif;\n  height: 14.8125rem;\n}\n.newsletter.white .newsletter-form[data-v-2ff55563] {\n    background: #FFFFFF;\n}\n.newsletter.white .newsletter-form .title[data-v-2ff55563] {\n      color: #979797;\n}\n.newsletter.white .newsletter-form .title span[data-v-2ff55563] {\n        color: #000000;\n}\n.newsletter.white .InputEmail[data-v-2ff55563] {\n    background-color: #FFFFFF;\n}\n.newsletter.black .newsletter-form[data-v-2ff55563] {\n    background: #000000;\n}\n.newsletter.black .newsletter-form .title[data-v-2ff55563] {\n      color: #979797;\n}\n.newsletter.black .newsletter-form .title span[data-v-2ff55563] {\n        color: #FFFFFF;\n}\n.newsletter.black .newsletter-form .InputEmail[data-v-2ff55563] {\n      background-color: #000000;\n      color: #FFFFFF;\n}\n.newsletter .nested-border-1.white[data-v-2ff55563], .newsletter .nested-border-2.white[data-v-2ff55563], .newsletter .nested-border-3.white[data-v-2ff55563], .newsletter .nested-border-4.white[data-v-2ff55563], .newsletter .nested-border-5.white[data-v-2ff55563] {\n    border-color: #FFFFFF !important;\n}\n.newsletter .nested-border-1.black[data-v-2ff55563], .newsletter .nested-border-2.black[data-v-2ff55563], .newsletter .nested-border-3.black[data-v-2ff55563], .newsletter .nested-border-4.black[data-v-2ff55563], .newsletter .nested-border-5.black[data-v-2ff55563] {\n    border-color: #000000 !important;\n}\n.newsletter .warning[data-v-2ff55563] {\n    margin-top: -0.1875rem;\n    margin-bottom: 0.1875rem;\n    height: 1.25rem;\n}\n.newsletter .warning p[data-v-2ff55563] {\n      background: #FF5CBE;\n      font-size: 0.75rem;\n      line-height: 1.25rem;\n      color: #FFFFFF;\n      font-weight: bold;\n}\n.newsletter .mail-icon[data-v-2ff55563] {\n    width: 1.5rem;\n    height: 1.125rem;\n}\n.newsletter .newsletter-form[data-v-2ff55563] {\n    position: absolute;\n    top: 0.4375rem;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    margin-right: 0.4375rem;\n    margin-left: 0.4375rem;\n    height: 10.9375rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563] {\n      font-family: \"Barlow\", sans-serif;\n      font-size: 1.5rem;\n      border-radius: unset;\n      border-bottom: 3px solid #979797;\n}\n.newsletter .newsletter-form .InputEmail.warning-color[data-v-2ff55563] {\n        color: #FF5CBE;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-webkit-input-placeholder {\n        /* Chrome/Opera/Safari */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-moz-placeholder {\n        /* Firefox 19+ */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-ms-input-placeholder {\n        /* IE 10+ */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-moz-placeholder {\n        /* Firefox 18- */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form input[data-v-2ff55563] {\n      caret-color: #F8008E;\n      outline-width: 2px;\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563] {\n      height: 2.5625rem;\n      width: 10rem;\n      font-family: \"Barlow\", sans-serif;\n      background: #F8008E;\n      border-radius: unset;\n      color: #FFFFFF;\n      font-size: 1.125rem;\n      padding-left: 2.625rem;\n      padding-right: 2.625rem;\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover {\n        background: #FF5CBE;\n        -webkit-box-shadow: none;\n                box-shadow: none;\n        /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover {\n            background: #BF0061;\n}\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:focus {\n        background: #BF0061;\n        -webkit-box-shadow: none;\n                box-shadow: none;\n}\n.newsletter .newsletter-form .title[data-v-2ff55563] {\n      font-size: 0.875rem;\n      line-height: 1rem;\n      font-weight: bold;\n}\n.newsletter.innerbox-blue[data-v-2ff55563] {\n    background: #00E8FF;\n}\n.newsletter.innerbox-yellow[data-v-2ff55563] {\n    background: #FCEB40;\n}\n.newsletter.innerbox-green[data-v-2ff55563] {\n    background: #5BF3A6;\n}\n.newsletter .innerbox[data-v-2ff55563] {\n    height: 13.6875rem;\n    border: 0.1875rem solid;\n    margin: 0.625rem;\n}\n.newsletter .innerbox .innerbox[data-v-2ff55563] {\n      height: 12.1875rem;\n      position: relative;\n      border: 0.1875rem solid;\n}\n.newsletter .innerbox .innerbox .innerbox[data-v-2ff55563] {\n        border: 0.125rem solid;\n        height: 10.4375rem;\n}\n.newsletter .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563] {\n          border: 0.0625rem solid;\n          height: 8.8125rem;\n}\n.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563] {\n            border: 0.0625rem solid;\n            height: 7.3125rem;\n            position: relative;\n}\n.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox div[data-v-2ff55563] {\n              height: 7.3125rem;\n}\n.newsletter .subscition-box[data-v-2ff55563] {\n    height: 11.8125rem;\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    height: 7.1875rem;\n    width: 15.0625rem;\n    top: 15%;\n}\n.newsletter .subscition-box .subscition[data-v-2ff55563] {\n      padding: 0.625rem;\n}\n.newsletter .subscition-box .subscition .inner-subscrition[data-v-2ff55563] {\n        height: 6.9375rem;\n}\n.newsletter .subscition-box .subscition .inner-subscrition .mail-icon[data-v-2ff55563] {\n          margin-bottom: 0.74125rem;\n}\n.newsletter .subscition-box .subscition .inner-subscrition .subscrition-text[data-v-2ff55563] {\n          font-size: 0.875rem;\n          line-height: 1rem;\n          font-weight: bold;\n}\n@-webkit-keyframes newsletter-zoomIn {\nfrom {\n    opacity: 1;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n            transform: scale3d(0.3, 0.3, 0.3);\n}\n50% {\n    opacity: 1;\n}\n}\n@keyframes newsletter-zoomIn-data-v-2ff55563 {\nfrom {\n    opacity: 1;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n            transform: scale3d(0.3, 0.3, 0.3);\n}\n50% {\n    opacity: 1;\n}\n}\n.newsletter .newsletter-zoomIn[data-v-2ff55563] {\n    -webkit-animation-name: newsletter-zoomIn-data-v-2ff55563;\n            animation-name: newsletter-zoomIn-data-v-2ff55563;\n}\n@-webkit-keyframes newsletter-zoomOut {\nfrom {\n    opacity: 1;\n}\nto {\n    -webkit-transform: scale3d(0, 0, 0);\n            transform: scale3d(0, 0, 0);\n    opacity: 1;\n}\n}\n@keyframes newsletter-zoomOut-data-v-2ff55563 {\nfrom {\n    opacity: 1;\n}\nto {\n    -webkit-transform: scale3d(0, 0, 0);\n            transform: scale3d(0, 0, 0);\n    opacity: 1;\n}\n}\n.newsletter .newsletter-zoomOut[data-v-2ff55563] {\n    -webkit-animation-name: newsletter-zoomOut-data-v-2ff55563;\n            animation-name: newsletter-zoomOut-data-v-2ff55563;\n}\n.newsletter .animated-last[data-v-2ff55563] {\n    -webkit-animation-duration: 0.8s;\n            animation-duration: 0.8s;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n.newsletter .animated-newsletter-form[data-v-2ff55563] {\n    -webkit-animation-duration: 0.4s;\n            animation-duration: 0.4s;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".img-caption-processed .image[data-v-54eacdd7]{background-color:rgba(90,156,181,.2);background-clip:content-box}.img-caption-processed img[data-v-54eacdd7]:focus,.img-caption-processed img[data-v-54eacdd7]:hover{-webkit-filter:brightness(70%)}@media (min-width:1024px){.img-caption-processed[data-v-54eacdd7]{margin-top:2.5rem;margin-bottom:2.5rem}}@media (min-width:0) and (max-width:1023px){.img-caption-processed[data-v-54eacdd7]{padding-bottom:.75rem}}.img-caption-processed .photo-share[data-v-54eacdd7]{padding-top:1.25rem}@media (min-width:0) and (max-width:1023px){.img-caption-processed .photo-share[data-v-54eacdd7]{padding-top:1rem;margin:0 1.6875rem}}.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper{width:0}.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper a{padding-right:1.25rem}", "", {"version":3,"sources":["/app/components/node/fields/body-items/Image.vue"],"names":[],"mappings":"AAoCA,+CACI,qCAA0C,AAC1C,2BAA6B,CAChC,AACD,oGACI,8BAAgC,CACnC,AACD,0BACA,wCACM,kBAAmB,AACnB,oBAAsB,CAC3B,CACA,AACD,4CACA,wCACM,qBAAwB,CAC7B,CACA,AACD,qDACI,mBAAqB,CAExB,AACD,4CACA,qDACQ,iBAAkB,AAClB,kBAAoB,CAC3B,CACA,AACD,gHACM,OAAS,CACd,AACD,kHACQ,qBAAuB,CAC9B","file":"Image.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.img-caption-processed[data-v-54eacdd7] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n.img-caption-processed .image[data-v-54eacdd7] {\n    background-color: rgba(90, 156, 181, 0.2);\n    background-clip: content-box;\n}\n.img-caption-processed img[data-v-54eacdd7]:hover, .img-caption-processed img[data-v-54eacdd7]:focus {\n    -webkit-filter: brightness(70%);\n}\n@media (min-width: 1024px) {\n.img-caption-processed[data-v-54eacdd7] {\n      margin-top: 2.5rem;\n      margin-bottom: 2.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.img-caption-processed[data-v-54eacdd7] {\n      padding-bottom: 0.75rem;\n}\n}\n.img-caption-processed .photo-share[data-v-54eacdd7] {\n    padding-top: 1.25rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.img-caption-processed .photo-share[data-v-54eacdd7] {\n        padding-top: 1rem;\n        margin: 0 1.6875rem;\n}\n}\n.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper {\n      width: 0;\n}\n.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper a {\n        padding-right: 1.25rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".newsletter-inner-wrapper[data-v-59c8e79a]{overflow:hidden}.newsletter-inner-wrapper>.innerbox[data-v-59c8e79a]{margin-right:-50%}.blue[data-v-59c8e79a]{color:#00e8ff!important;border-color:#00e8ff!important}.green[data-v-59c8e79a]{color:#00c078!important;border-color:#00c078!important}.yellow[data-v-59c8e79a]{color:#fceb40!important;border-color:#fceb40!important}.newsletter[data-v-59c8e79a]{font-family:Silkscreen,sans-serif;position:relative;height:auto}.newsletter.hidden-overflow[data-v-59c8e79a]{overflow:hidden}.newsletter .input-group-btn[data-v-59c8e79a]{-webkit-box-flex:0;-ms-flex:0 0 100%;flex:0 0 100%}.newsletter .form-btn[data-v-59c8e79a]{width:7.1875rem;border:.25rem solid #f8008e;border-left:none;background-color:#f8008e;display:-webkit-box;display:-ms-flexbox;display:flex}.newsletter .diamond-icon[data-v-59c8e79a]{position:absolute;z-index:2;top:-.625rem;right:1.25rem;-webkit-transform:translateZ(100px);transform:translateZ(100px)}.newsletter .diamond-icon svg-email-black-icon[data-v-59c8e79a]{z-index:2;position:absolute;top:.625rem;right:.625rem}.newsletter .diamond-icon[data-v-59c8e79a]:after{content:url(/static/svg/raw/email-black.svg);position:absolute;left:50%;margin-left:-15px;top:50%;margin-top:-15px}.newsletter .notification.warning-color[data-v-59c8e79a]{background:#ff5cbe}.newsletter .notification.warning-color>div[data-v-59c8e79a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:700;color:#fff;font-size:.875rem}.newsletter input.warning-color[data-v-59c8e79a]{color:#ff5cbe}.newsletter .warning[data-v-59c8e79a]{height:2.1875rem}.newsletter .warning div[data-v-59c8e79a]{font-family:Barlow,sans-serif;font-size:.75rem;line-height:.875rem}.newsletter .mail-icon[data-v-59c8e79a]{width:1.5rem;height:1.125rem}.newsletter .newsletter-form[data-v-59c8e79a]{position:absolute;top:auto;bottom:-1px;left:0;right:0;margin:0 auto;z-index:2;-webkit-transform:translateZ(100px);transform:translateZ(100px)}.newsletter .newsletter-form .input-email[data-v-59c8e79a]{font-family:Barlow,sans-serif;font-size:1.5rem;border-radius:unset;border-bottom:3px solid #979797}.newsletter .newsletter-form .input-email[data-v-59c8e79a]::-webkit-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .input-email[data-v-59c8e79a]::-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .input-email[data-v-59c8e79a]:-ms-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .input-email[data-v-59c8e79a]:-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .form-input[data-v-59c8e79a]{border:.25rem solid #f8008e;border-right:none;background-color:#f8008e;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.newsletter .newsletter-form .form-btn[data-v-59c8e79a]{width:7.1875rem;border:.25rem solid #f8008e;border-left:none;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.newsletter .newsletter-form input[data-v-59c8e79a]{caret-color:#f8008e;outline-width:2px;height:2.8125rem}.newsletter .newsletter-form .submit-newsletter[data-v-59c8e79a]{height:2.8125rem;font-family:Barlow,sans-serif;background:#f8008e;border-radius:unset;color:#fff;font-size:1.125rem;padding-left:2.625rem;padding-right:2.625rem}.newsletter .newsletter-form .submit-newsletter[data-v-59c8e79a]:focus{-webkit-box-shadow:none;box-shadow:none}.newsletter .newsletter-form .submit-newsletter span[data-v-59c8e79a]{font-size:1.25rem;color:#fff;font-family:Silkscreen,sans-serif}.newsletter.innerbox-black[data-v-59c8e79a]{background:#000}.newsletter .section-type[data-v-59c8e79a]{font-weight:700;font-size:1.75rem;line-height:1.75rem;text-shadow:.125rem .125rem 0 #f8008e}@media (min-width:1024px){.newsletter .section-type[data-v-59c8e79a]{font-size:2rem;line-height:2rem}}.newsletter .newsletter-text-box[data-v-59c8e79a]{z-index:2;position:relative}.newsletter .newsletter-text-box .newsletter[data-v-59c8e79a]{padding:0;height:auto;margin-right:29%}.newsletter .newsletter-text-box .newsletter p.title[data-v-59c8e79a]{color:#f8008e;font-size:1.25rem;line-height:1.875rem}.newsletter .newsletter-text-box .newsletter p.title.brand-title[data-v-59c8e79a]{font-size:1.5rem;line-height:1;font-family:\"04bregular\";margin-left:.25rem}.newsletter .newsletter-text-box .newsletter p.title[data-v-59c8e79a]:first-child{margin-top:.3125rem;margin-bottom:.3125rem}.newsletter .newsletter-text-box .newsletter p span[data-v-59c8e79a]{color:#00e8ff}.newsletter .newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);margin:0}.newsletter .animated-newsletter-text-box[data-v-59c8e79a]{-webkit-animation-duration:.5s;animation-duration:.5s}.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]{margin-left:.625rem;-webkit-animation:slideInRight .3s ease-in-out;animation:slideInRight .3s ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper p[data-v-59c8e79a]{-webkit-animation:bounce-in-data-v-59c8e79a .6s ease-in-out;animation:bounce-in-data-v-59c8e79a .6s ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]:first-child{-webkit-animation-delay:.3s;animation-delay:.3s}.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper:first-child p[data-v-59c8e79a],.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]:nth-child(2){-webkit-animation-delay:.5s;animation-delay:.5s}.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper:nth-child(2) p[data-v-59c8e79a],.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]:nth-child(3){-webkit-animation-delay:.7s;animation-delay:.7s}.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper:nth-child(3) p[data-v-59c8e79a]{-webkit-animation-delay:.9s;animation-delay:.9s}.newsletter .innerbox[data-v-59c8e79a]{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;border-style:solid;border-color:#00e8ff;-webkit-animation-delay:0s;animation-delay:0s;padding:.625rem;-webkit-transition:opacity .4s,-webkit-transform .4s;transition:opacity .4s,-webkit-transform .4s;-o-transition:transform .4s,opacity .4s;transition:transform .4s,opacity .4s;transition:transform .4s,opacity .4s,-webkit-transform .4s;-webkit-transition-timing-function:ease-in-out;-o-transition-timing-function:ease-in-out;transition-timing-function:ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}.newsletter .innerbox.first[data-v-59c8e79a]{margin-left:100%;-webkit-transition-delay:0s;-o-transition-delay:0s;transition-delay:0s;border-width:.375rem}.newsletter .innerbox.second[data-v-59c8e79a]{-webkit-transition-delay:.1s;-o-transition-delay:.1s;transition-delay:.1s;border-width:.25rem;-webkit-animation-delay:1s;animation-delay:1s}.newsletter .innerbox.third[data-v-59c8e79a]{-webkit-transition-delay:.2s;-o-transition-delay:.2s;transition-delay:.2s;border-width:.1875rem;-webkit-animation-delay:2s;animation-delay:2s}.newsletter .innerbox.forth[data-v-59c8e79a]{-webkit-transition-delay:.3s;-o-transition-delay:.3s;transition-delay:.3s;border-width:.125rem;position:relative;-webkit-animation-delay:3s;animation-delay:3s}.newsletter .innerbox.fifth[data-v-59c8e79a]{-webkit-transition-delay:.4s;-o-transition-delay:.4s;transition-delay:.4s;padding:.15625rem 0;border-width:.0625rem;-webkit-animation-delay:4s;animation-delay:4s}.newsletter .subscription-box .subscription[data-v-59c8e79a]{padding-bottom:.375rem;border-style:solid;border-color:#00e8ff;padding-bottom:.625rem}.newsletter .subscription-box .subscription.first[data-v-59c8e79a]{border-width:0 0 .3125rem}.newsletter .subscription-box .subscription.second[data-v-59c8e79a]{border-width:0 0 .25rem}.newsletter .subscription-box .subscription.third[data-v-59c8e79a]{border-width:0 0 .1875rem}.newsletter .subscription-box .subscription.forth[data-v-59c8e79a]{border-width:0 0 .125rem}.newsletter .subscription-box .subscription.fifth[data-v-59c8e79a]{border-width:0 0 .0625rem;position:relative}.newsletter .subscription-box .subscription.fifth svg[data-v-59c8e79a]{margin-top:-.0625rem}.newsletter .subscription-box .subscription.fifth .monster-email[data-v-59c8e79a]{margin-left:auto;margin-right:auto;left:0;right:0;width:18.9375rem;height:7.0625rem;position:absolute;top:-9px;z-index:2}.newsletter .subscription-box .subscription.fifth .monster-subscription[data-v-59c8e79a]{padding-top:.5rem;width:14.8125rem}.newsletter .subscription-box .subscription.fifth .monster-subscription .section-type[data-v-59c8e79a]{font-size:2rem;font-weight:700;line-height:1.6875rem}.newsletter .subscription-box .subscription.fifth .monster-subscription .subscription-text[data-v-59c8e79a]{color:#00e8ff;font-size:1.25rem;line-height:1.375rem}.newsletter .animated-submit-form[data-v-59c8e79a]{-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-delay:1.5s;animation-delay:1.5s}.newsletter .animated-newsletter-des1[data-v-59c8e79a]{-webkit-animation-duration:.8s;animation-duration:.8s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.newsletter .animated-newsletter-des2[data-v-59c8e79a]{-webkit-animation-duration:.5s;animation-duration:.5s}.newsletter .animated-newsletter-des2[data-v-59c8e79a],.newsletter .animated-subscription-box[data-v-59c8e79a]{-webkit-animation-fill-mode:both;animation-fill-mode:both}.newsletter .animated-subscription-box.first[data-v-59c8e79a]{-webkit-animation-duration:.4s;animation-duration:.4s;-webkit-animation-delay:0ms;animation-delay:0ms}.newsletter .animated-subscription-box.second[data-v-59c8e79a]{-webkit-animation-duration:.4s;animation-duration:.4s;-webkit-animation-delay:.15s;animation-delay:.15s}.newsletter .animated-subscription-box.third[data-v-59c8e79a]{-webkit-animation-duration:.4s;animation-duration:.4s;-webkit-animation-delay:.2s;animation-delay:.2s}.newsletter .animated-subscription-box.forth[data-v-59c8e79a]{-webkit-animation-duration:.4s;animation-duration:.4s;-webkit-animation-delay:.25s;animation-delay:.25s}.newsletter .animated-subscription-box.fifth[data-v-59c8e79a]{-webkit-animation-duration:.4s;animation-duration:.4s;-webkit-animation-delay:.3s;animation-delay:.3s}.newsletter .animated-newsletter-monster[data-v-59c8e79a]{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-delay:.8s;animation-delay:.8s;-webkit-animation-timing-function:ease;animation-timing-function:ease}.newsletter .animated-inner-box[data-v-59c8e79a]{-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);opacity:1}.newsletter .animated-inner-box.first[data-v-59c8e79a]{margin-left:0}.newsletter .animated-monster[data-v-59c8e79a]{-webkit-animation:move 15s steps(2) infinite alternate;animation:move 15s steps(2) infinite alternate;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:monster-shake-data-v-59c8e79a;animation-name:monster-shake-data-v-59c8e79a}.newsletter .animated-email[data-v-59c8e79a]{-webkit-animation:move 15s steps(2) infinite alternate;animation:move 15s steps(2) infinite alternate;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:email-shake-data-v-59c8e79a;animation-name:email-shake-data-v-59c8e79a}.newsletter .fadeInDownDes1[data-v-59c8e79a]{-webkit-animation-name:fadeInDownDes1-data-v-59c8e79a;animation-name:fadeInDownDes1-data-v-59c8e79a}.newsletter .fadeInDownDes2[data-v-59c8e79a]{-webkit-animation-name:fadeInDownDes2-data-v-59c8e79a;animation-name:fadeInDownDes2-data-v-59c8e79a}.newsletter .fadeInDown-subscription[data-v-59c8e79a]{-webkit-animation-timing-function:cubic-bezier(.6,0,.23,1);animation-timing-function:cubic-bezier(.6,0,.23,1);-webkit-animation-name:fadeInDown-subscription-data-v-59c8e79a;animation-name:fadeInDown-subscription-data-v-59c8e79a}@-webkit-keyframes bounce-in{0%{-webkit-transform:translate3d(-8px,0,0);transform:translate3d(-8px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounce-in-data-v-59c8e79a{0%{-webkit-transform:translate3d(-8px,0,0);transform:translate3d(-8px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@-webkit-keyframes monster-shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-7px,0,0);transform:translate3d(-7px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(7px,0,0);transform:translate3d(7px,0,0)}}@keyframes monster-shake-data-v-59c8e79a{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-7px,0,0);transform:translate3d(-7px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(7px,0,0);transform:translate3d(7px,0,0)}}@-webkit-keyframes email-shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}}@keyframes email-shake-data-v-59c8e79a{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}}@-webkit-keyframes fadeInDownDes1{0%{opacity:0;-webkit-transform:translate3d(-10px,-100%,0);transform:translate3d(-10px,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDownDes1-data-v-59c8e79a{0%{opacity:0;-webkit-transform:translate3d(-10px,-100%,0);transform:translate3d(-10px,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@-webkit-keyframes fadeInDownDes2{0%{opacity:0;-webkit-transform:translate3d(10px,-120%,0);transform:translate3d(10px,-120%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDownDes2-data-v-59c8e79a{0%{opacity:0;-webkit-transform:translate3d(10px,-120%,0);transform:translate3d(10px,-120%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@-webkit-keyframes fadeInDown-subscription{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDown-subscription-data-v-59c8e79a{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.newsletter-form .justify-content-center:hover .form-btn[data-v-59c8e79a],.newsletter-form .justify-content-center:hover .form-input[data-v-59c8e79a]{border-color:#bf0061}.newsletter-form .justify-content-center:hover .form-btn button[data-v-59c8e79a]{background:#bf0061}", "", {"version":3,"sources":["/app/components/widgets/MonsterNewsletterForm.vue"],"names":[],"mappings":"AAgCA,2CACE,eAAiB,CAClB,AACD,qDACI,iBAAmB,CACtB,AACD,uBACE,wBAA0B,AAC1B,8BAAiC,CAClC,AACD,wBACE,wBAA0B,AAC1B,8BAAiC,CAClC,AACD,yBACE,wBAA0B,AAC1B,8BAAiC,CAClC,AACD,6BACE,kCAAoC,AACpC,kBAAmB,AACnB,WAAa,CACd,AACD,6CACI,eAAiB,CACpB,AACD,8CACI,mBAAoB,AAChB,kBAAmB,AACf,aAAe,CAC1B,AACD,uCACI,gBAAiB,AACjB,4BAA8B,AAC9B,iBAAkB,AAClB,yBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,2CACI,kBAAmB,AACnB,UAAW,AACX,aAAe,AACf,cAAe,AACf,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,gEACM,UAAW,AACX,kBAAmB,AACnB,YAAc,AACd,aAAgB,CACrB,AACD,iDACM,6CAA8C,AAC9C,kBAAmB,AACnB,SAAU,AACV,kBAAmB,AACnB,QAAS,AACT,gBAAkB,CACvB,AACD,yDACI,kBAAoB,CACvB,AACD,6DACM,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAkB,AAClB,WAAe,AACf,iBAAoB,CACzB,AACD,iDACI,aAAe,CAClB,AACD,sCACI,gBAAkB,CACrB,AACD,0CACM,8BAAkC,AAClC,iBAAmB,AACnB,mBAAsB,CAC3B,AACD,wCACI,aAAc,AACd,eAAiB,CACpB,AACD,8CACI,kBAAmB,AACnB,SAAU,AACV,YAAa,AACb,OAAQ,AACR,QAAS,AACT,cAAe,AACf,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,2DACM,8BAAkC,AAClC,iBAAkB,AAClB,oBAAqB,AACrB,+BAAiC,CACtC,AACD,sFAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,6EAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,iFAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,4EAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,0DACM,4BAA8B,AAC9B,kBAAmB,AACnB,yBAA0B,AAC1B,uCAAyC,AACzC,kCAAoC,AACpC,8BAAiC,CACtC,AACD,wDACM,gBAAiB,AACjB,4BAA8B,AAC9B,iBAAkB,AAClB,uCAAyC,AACzC,kCAAoC,AACpC,8BAAiC,CACtC,AACD,oDACM,oBAAqB,AACrB,kBAAmB,AACnB,gBAAkB,CACvB,AACD,iEACM,iBAAkB,AAClB,8BAAkC,AAClC,mBAAoB,AACpB,oBAAqB,AACrB,WAAe,AACf,mBAAoB,AACpB,sBAAuB,AACvB,sBAAwB,CAC7B,AACD,uEACQ,wBAAyB,AACjB,eAAiB,CAChC,AACD,sEACQ,kBAAmB,AACnB,WAAe,AACf,iCAAoC,CAC3C,AACD,4CACI,eAAoB,CACvB,AACD,2CACI,gBAAkB,AAClB,kBAAmB,AACnB,oBAAqB,AACrB,qCAAyC,CAE5C,AACD,0BACA,2CACQ,eAAgB,AAChB,gBAAkB,CACzB,CACA,AACD,kDACI,UAAW,AACX,iBAAmB,CACtB,AACD,8DACM,UAAW,AACX,YAAa,AACb,gBAAkB,CACvB,AACD,sEACQ,cAAe,AACf,kBAAmB,AACnB,oBAAsB,CAC7B,AACD,kFACU,iBAAkB,AAClB,cAAe,AACf,yBAA0B,AAC1B,kBAAqB,CAC9B,AACD,kFACU,oBAAsB,AACtB,sBAAyB,CAClC,AACD,qEACQ,aAAe,CACtB,AACD,iGACM,wCAA2C,AACnC,gCAAmC,AAC3C,QAAU,CACf,AACD,2DACI,+BAAkC,AAC1B,sBAA0B,CACrC,AACD,0GACM,oBAAsB,AACtB,+CAAgD,AACxC,uCAAwC,AAChD,iCAAkC,AAC1B,wBAA0B,CACvC,AACD,4GACQ,4DAA6D,AACrD,oDAAqD,AAC7D,iCAAkC,AAC1B,wBAA0B,CACzC,AACD,sHACQ,4BAA8B,AACtB,mBAAsB,CACrC,AAKD,+OACQ,4BAA8B,AACtB,mBAAsB,CACrC,AAKD,gPACQ,4BAA8B,AACtB,mBAAsB,CACrC,AACD,yHACU,4BAA8B,AACtB,mBAAsB,CACvC,AACD,uCACI,2BAA+B,AAC3B,uBAA2B,AACvB,mBAAuB,AAC/B,UAAW,AACX,mBAAoB,AACpB,qBAAsB,AACtB,2BAA4B,AACpB,mBAAoB,AAC5B,gBAAkB,AAClB,qDAAuD,AACvD,6CAA+C,AAC/C,wCAA0C,AAC1C,qCAAuC,AACvC,2DAA8D,AAC9D,+CAAgD,AAC3C,0CAA2C,AACxC,uCAAwC,AAChD,iCAAkC,AAC1B,wBAA0B,CACrC,AACD,6CACM,iBAAkB,AAClB,4BAA6B,AACxB,uBAAwB,AACrB,oBAAqB,AAC7B,oBAAuB,CAC5B,AACD,8CACM,6BAA8B,AACzB,wBAAyB,AACtB,qBAAsB,AAC9B,oBAAsB,AACtB,2BAA4B,AACpB,kBAAoB,CACjC,AACD,6CACM,6BAA8B,AACzB,wBAAyB,AACtB,qBAAsB,AAC9B,sBAAwB,AACxB,2BAA4B,AACpB,kBAAoB,CACjC,AACD,6CACM,6BAA8B,AACzB,wBAAyB,AACtB,qBAAsB,AAC9B,qBAAuB,AACvB,kBAAmB,AACnB,2BAA4B,AACpB,kBAAoB,CACjC,AACD,6CACM,6BAA8B,AACzB,wBAAyB,AACtB,qBAAsB,AAC9B,oBAAsB,AACtB,sBAAwB,AACxB,2BAA4B,AACpB,kBAAoB,CACjC,AACD,6DACI,uBAAyB,AACzB,mBAAoB,AACpB,qBAAsB,AACtB,sBAAyB,CAC5B,AACD,mEACM,yBAA4B,CACjC,AACD,oEACM,uBAA0B,CAC/B,AACD,mEACM,yBAA4B,CACjC,AACD,mEACM,wBAA2B,CAChC,AACD,mEACM,0BAA4B,AAC5B,iBAAmB,CACxB,AACD,uEACQ,oBAAuB,CAC9B,AACD,kFACQ,iBAAkB,AAClB,kBAAmB,AACnB,OAAQ,AACR,QAAS,AACT,iBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,SAAU,AACV,SAAW,CAClB,AACD,yFACQ,kBAAoB,AACpB,gBAAkB,CACzB,AACD,uGACU,eAAgB,AAChB,gBAAkB,AAClB,qBAAuB,CAChC,AACD,4GACU,cAAe,AACf,kBAAmB,AACnB,oBAAsB,CAC/B,AACD,mDACI,+BAAgC,AACxB,uBAAwB,AAChC,iCAAkC,AAC1B,yBAA0B,AAClC,6BAA8B,AACtB,oBAAsB,CACjC,AACD,uDACI,+BAAgC,AACxB,uBAAwB,AAChC,iCAAkC,AAC1B,wBAA0B,CACrC,AACD,uDACI,+BAAgC,AACxB,sBAAwB,CAGnC,AACD,+GAHI,iCAAkC,AAC1B,wBAA0B,CAKrC,AACD,8DACM,+BAAkC,AAC1B,uBAA0B,AAClC,4BAA6B,AACrB,mBAAqB,CAClC,AACD,+DACM,+BAAkC,AAC1B,uBAA0B,AAClC,6BAA+B,AACvB,oBAAuB,CACpC,AACD,8DACM,+BAAkC,AAC1B,uBAA0B,AAClC,4BAA+B,AACvB,mBAAuB,CACpC,AACD,8DACM,+BAAkC,AAC1B,uBAA0B,AAClC,6BAA+B,AACvB,oBAAuB,CACpC,AACD,8DACM,+BAAkC,AAC1B,uBAA0B,AAClC,4BAA+B,AACvB,mBAAuB,CACpC,AACD,0DACI,8BAAmC,AAC3B,sBAA2B,AACnC,iCAAkC,AAC1B,yBAA0B,AAClC,4BAA+B,AACvB,oBAAuB,AAC/B,uCAAwC,AAChC,8BAAgC,CAC3C,AACD,iDACI,+BAAkC,AAC1B,uBAA0B,AAClC,2BAA+B,AAC3B,uBAA2B,AACvB,mBAAuB,AAC/B,SAAW,CACd,AACD,uDACM,aAAe,CACpB,AACD,+CACI,uDAAwD,AAChD,+CAAgD,AACxD,iCAAkC,AAC1B,yBAA0B,AAClC,qDAAsD,AAC9C,4CAA8C,CACzD,AACD,6CACI,uDAAwD,AAChD,+CAAgD,AACxD,iCAAkC,AAC1B,yBAA0B,AAClC,mDAAoD,AAC5C,0CAA4C,CACvD,AACD,6CACI,sDAAuD,AAC/C,6CAA+C,CAC1D,AACD,6CACI,sDAAuD,AAC/C,6CAA+C,CAC1D,AACD,sDACI,2DAAiE,AACzD,mDAAyD,AACjE,+DAAgE,AACxD,sDAAwD,CACnE,AACD,6BACA,GACI,wCAA2C,AACnC,+BAAmC,CAC9C,AACD,GACI,gCAAwC,AAChC,uBAAgC,CAC3C,CACA,AACD,qCACA,GACI,wCAA2C,AACnC,+BAAmC,CAC9C,AACD,GACI,gCAAwC,AAChC,uBAAgC,CAC3C,CACA,AACD,iCACA,MAEI,gCAAwC,AAChC,uBAAgC,CAC3C,AACD,oBAKI,wCAA2C,AACnC,+BAAmC,CAC9C,AACD,gBAII,uCAA0C,AAClC,8BAAkC,CAC7C,CACA,AACD,yCACA,MAEI,gCAAwC,AAChC,uBAAgC,CAC3C,AACD,oBAKI,wCAA2C,AACnC,+BAAmC,CAC9C,AACD,gBAII,uCAA0C,AAClC,8BAAkC,CAC7C,CACA,AACD,+BACA,MAEI,gCAAwC,AAChC,uBAAgC,CAC3C,AACD,oBAKI,uCAA0C,AAClC,8BAAkC,CAC7C,AACD,gBAII,wCAA2C,AACnC,+BAAmC,CAC9C,CACA,AACD,uCACA,MAEI,gCAAwC,AAChC,uBAAgC,CAC3C,AACD,oBAKI,uCAA0C,AAClC,8BAAkC,CAC7C,AACD,gBAII,wCAA2C,AACnC,+BAAmC,CAC9C,CACA,AACD,kCACA,GACI,UAAW,AACX,6CAAgD,AACxC,oCAAwC,CACnD,AACD,GACI,UAAW,AACX,uBAAwB,AAChB,cAAgB,CAC3B,CACA,AACD,0CACA,GACI,UAAW,AACX,6CAAgD,AACxC,oCAAwC,CACnD,AACD,GACI,UAAW,AACX,uBAAwB,AAChB,cAAgB,CAC3B,CACA,AACD,kCACA,GACI,UAAW,AACX,4CAA+C,AACvC,mCAAuC,CAClD,AACD,GACI,UAAW,AACX,uBAAwB,AAChB,cAAgB,CAC3B,CACA,AACD,0CACA,GACI,UAAW,AACX,4CAA+C,AACvC,mCAAuC,CAClD,AACD,GACI,UAAW,AACX,uBAAwB,AAChB,cAAgB,CAC3B,CACA,AACD,2CACA,GACI,UAAW,AACX,yCAA4C,AACpC,gCAAoC,CAC/C,AACD,GACI,UAAW,AACX,uBAAwB,AAChB,cAAgB,CAC3B,CACA,AACD,mDACA,GACI,UAAW,AACX,yCAA4C,AACpC,gCAAoC,CAC/C,AACD,GACI,UAAW,AACX,uBAAwB,AAChB,cAAgB,CAC3B,CACA,AACD,sJACE,oBAAsB,CACvB,AACD,iFACE,kBAAoB,CACrB","file":"MonsterNewsletterForm.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.newsletter-inner-wrapper[data-v-59c8e79a] {\n  overflow: hidden;\n}\n.newsletter-inner-wrapper > .innerbox[data-v-59c8e79a] {\n    margin-right: -50%;\n}\n.blue[data-v-59c8e79a] {\n  color: #00E8FF !important;\n  border-color: #00E8FF !important;\n}\n.green[data-v-59c8e79a] {\n  color: #00C078 !important;\n  border-color: #00C078 !important;\n}\n.yellow[data-v-59c8e79a] {\n  color: #FCEB40 !important;\n  border-color: #FCEB40 !important;\n}\n.newsletter[data-v-59c8e79a] {\n  font-family: Silkscreen, sans-serif;\n  position: relative;\n  height: auto;\n}\n.newsletter.hidden-overflow[data-v-59c8e79a] {\n    overflow: hidden;\n}\n.newsletter .input-group-btn[data-v-59c8e79a] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n}\n.newsletter .form-btn[data-v-59c8e79a] {\n    width: 7.1875rem;\n    border: 0.25rem solid #F8008E;\n    border-left: none;\n    background-color: #F8008E;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.newsletter .diamond-icon[data-v-59c8e79a] {\n    position: absolute;\n    z-index: 2;\n    top: -0.625rem;\n    right: 1.25rem;\n    -webkit-transform: translateZ(100px);\n            transform: translateZ(100px);\n}\n.newsletter .diamond-icon svg-email-black-icon[data-v-59c8e79a] {\n      z-index: 2;\n      position: absolute;\n      top: 0.625rem;\n      right: 0.625rem;\n}\n.newsletter .diamond-icon[data-v-59c8e79a]:after {\n      content: url(/static/svg/raw/email-black.svg);\n      position: absolute;\n      left: 50%;\n      margin-left: -15px;\n      top: 50%;\n      margin-top: -15px;\n}\n.newsletter .notification.warning-color[data-v-59c8e79a] {\n    background: #FF5CBE;\n}\n.newsletter .notification.warning-color > div[data-v-59c8e79a] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      font-weight: bold;\n      color: #FFFFFF;\n      font-size: 0.875rem;\n}\n.newsletter input.warning-color[data-v-59c8e79a] {\n    color: #FF5CBE;\n}\n.newsletter .warning[data-v-59c8e79a] {\n    height: 2.1875rem;\n}\n.newsletter .warning div[data-v-59c8e79a] {\n      font-family: \"Barlow\", sans-serif;\n      font-size: 0.75rem;\n      line-height: 0.875rem;\n}\n.newsletter .mail-icon[data-v-59c8e79a] {\n    width: 1.5rem;\n    height: 1.125rem;\n}\n.newsletter .newsletter-form[data-v-59c8e79a] {\n    position: absolute;\n    top: auto;\n    bottom: -1px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    z-index: 2;\n    -webkit-transform: translateZ(100px);\n            transform: translateZ(100px);\n}\n.newsletter .newsletter-form .input-email[data-v-59c8e79a] {\n      font-family: \"Barlow\", sans-serif;\n      font-size: 1.5rem;\n      border-radius: unset;\n      border-bottom: 3px solid #979797;\n}\n.newsletter .newsletter-form .input-email[data-v-59c8e79a]::-webkit-input-placeholder {\n        /* Chrome/Opera/Safari */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .input-email[data-v-59c8e79a]::-moz-placeholder {\n        /* Firefox 19+ */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .input-email[data-v-59c8e79a]:-ms-input-placeholder {\n        /* IE 10+ */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .input-email[data-v-59c8e79a]:-moz-placeholder {\n        /* Firefox 18- */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .form-input[data-v-59c8e79a] {\n      border: 0.25rem solid #F8008E;\n      border-right: none;\n      background-color: #F8008E;\n      -webkit-transition: all 0.2s ease-in-out;\n      -o-transition: all 0.2s ease-in-out;\n      transition: all 0.2s ease-in-out;\n}\n.newsletter .newsletter-form .form-btn[data-v-59c8e79a] {\n      width: 7.1875rem;\n      border: 0.25rem solid #F8008E;\n      border-left: none;\n      -webkit-transition: all 0.2s ease-in-out;\n      -o-transition: all 0.2s ease-in-out;\n      transition: all 0.2s ease-in-out;\n}\n.newsletter .newsletter-form input[data-v-59c8e79a] {\n      caret-color: #F8008E;\n      outline-width: 2px;\n      height: 2.8125rem;\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-59c8e79a] {\n      height: 2.8125rem;\n      font-family: \"Barlow\", sans-serif;\n      background: #F8008E;\n      border-radius: unset;\n      color: #FFFFFF;\n      font-size: 1.125rem;\n      padding-left: 2.625rem;\n      padding-right: 2.625rem;\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-59c8e79a]:focus {\n        -webkit-box-shadow: none;\n                box-shadow: none;\n}\n.newsletter .newsletter-form .submit-newsletter span[data-v-59c8e79a] {\n        font-size: 1.25rem;\n        color: #FFFFFF;\n        font-family: Silkscreen, sans-serif;\n}\n.newsletter.innerbox-black[data-v-59c8e79a] {\n    background: #000000;\n}\n.newsletter .section-type[data-v-59c8e79a] {\n    font-weight: bold;\n    font-size: 1.75rem;\n    line-height: 1.75rem;\n    text-shadow: 0.125rem 0.125rem 0 #F8008E;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.newsletter .section-type[data-v-59c8e79a] {\n        font-size: 2rem;\n        line-height: 2rem;\n}\n}\n.newsletter .newsletter-text-box[data-v-59c8e79a] {\n    z-index: 2;\n    position: relative;\n}\n.newsletter .newsletter-text-box .newsletter[data-v-59c8e79a] {\n      padding: 0;\n      height: auto;\n      margin-right: 29%;\n}\n.newsletter .newsletter-text-box .newsletter p.title[data-v-59c8e79a] {\n        color: #F8008E;\n        font-size: 1.25rem;\n        line-height: 1.875rem;\n}\n.newsletter .newsletter-text-box .newsletter p.title.brand-title[data-v-59c8e79a] {\n          font-size: 1.5rem;\n          line-height: 1;\n          font-family: \"04bregular\";\n          margin-left: 0.25rem;\n}\n.newsletter .newsletter-text-box .newsletter p.title[data-v-59c8e79a]:first-child {\n          margin-top: 0.3125rem;\n          margin-bottom: 0.3125rem;\n}\n.newsletter .newsletter-text-box .newsletter p span[data-v-59c8e79a] {\n        color: #00E8FF;\n}\n.newsletter .newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a] {\n      -webkit-transform: translate3d(100%, 0, 0);\n              transform: translate3d(100%, 0, 0);\n      margin: 0;\n}\n.newsletter .animated-newsletter-text-box[data-v-59c8e79a] {\n    -webkit-animation-duration: 500ms;\n            animation-duration: 500ms;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a] {\n      margin-left: 0.625rem;\n      -webkit-animation: slideInRight .3s ease-in-out;\n              animation: slideInRight .3s ease-in-out;\n      -webkit-animation-fill-mode: both;\n              animation-fill-mode: both;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper p[data-v-59c8e79a] {\n        -webkit-animation: bounce-in-data-v-59c8e79a .6s ease-in-out;\n                animation: bounce-in-data-v-59c8e79a .6s ease-in-out;\n        -webkit-animation-fill-mode: both;\n                animation-fill-mode: both;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]:nth-child(1) {\n        -webkit-animation-delay: 0.3s;\n                animation-delay: 0.3s;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper:nth-child(1) p[data-v-59c8e79a] {\n          -webkit-animation-delay: 0.5s;\n                  animation-delay: 0.5s;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]:nth-child(2) {\n        -webkit-animation-delay: 0.5s;\n                animation-delay: 0.5s;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper:nth-child(2) p[data-v-59c8e79a] {\n          -webkit-animation-delay: 0.7s;\n                  animation-delay: 0.7s;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper[data-v-59c8e79a]:nth-child(3) {\n        -webkit-animation-delay: 0.7s;\n                animation-delay: 0.7s;\n}\n.newsletter .animated-newsletter-text-box .newsletter-text-content-wrapper .text-wrapper:nth-child(3) p[data-v-59c8e79a] {\n          -webkit-animation-delay: 0.9s;\n                  animation-delay: 0.9s;\n}\n.newsletter .innerbox[data-v-59c8e79a] {\n    -webkit-transform: scale(0, 0);\n        -ms-transform: scale(0, 0);\n            transform: scale(0, 0);\n    opacity: 0;\n    border-style: solid;\n    border-color: #00E8FF;\n    -webkit-animation-delay: 0s;\n            animation-delay: 0s;\n    padding: 0.625rem;\n    -webkit-transition: opacity .4s, -webkit-transform .4s;\n    transition: opacity .4s, -webkit-transform .4s;\n    -o-transition: transform .4s, opacity .4s;\n    transition: transform .4s, opacity .4s;\n    transition: transform .4s, opacity .4s, -webkit-transform .4s;\n    -webkit-transition-timing-function: ease-in-out;\n         -o-transition-timing-function: ease-in-out;\n            transition-timing-function: ease-in-out;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n.newsletter .innerbox.first[data-v-59c8e79a] {\n      margin-left: 100%;\n      -webkit-transition-delay: 0s;\n           -o-transition-delay: 0s;\n              transition-delay: 0s;\n      border-width: 0.375rem;\n}\n.newsletter .innerbox.second[data-v-59c8e79a] {\n      -webkit-transition-delay: .1s;\n           -o-transition-delay: .1s;\n              transition-delay: .1s;\n      border-width: 0.25rem;\n      -webkit-animation-delay: 1s;\n              animation-delay: 1s;\n}\n.newsletter .innerbox.third[data-v-59c8e79a] {\n      -webkit-transition-delay: .2s;\n           -o-transition-delay: .2s;\n              transition-delay: .2s;\n      border-width: 0.1875rem;\n      -webkit-animation-delay: 2s;\n              animation-delay: 2s;\n}\n.newsletter .innerbox.forth[data-v-59c8e79a] {\n      -webkit-transition-delay: .3s;\n           -o-transition-delay: .3s;\n              transition-delay: .3s;\n      border-width: 0.125rem;\n      position: relative;\n      -webkit-animation-delay: 3s;\n              animation-delay: 3s;\n}\n.newsletter .innerbox.fifth[data-v-59c8e79a] {\n      -webkit-transition-delay: .4s;\n           -o-transition-delay: .4s;\n              transition-delay: .4s;\n      padding: 0.15625rem 0;\n      border-width: 0.0625rem;\n      -webkit-animation-delay: 4s;\n              animation-delay: 4s;\n}\n.newsletter .subscription-box .subscription[data-v-59c8e79a] {\n    padding-bottom: 0.375rem;\n    border-style: solid;\n    border-color: #00E8FF;\n    padding-bottom: 0.625rem;\n}\n.newsletter .subscription-box .subscription.first[data-v-59c8e79a] {\n      border-width: 0 0 0.3125rem;\n}\n.newsletter .subscription-box .subscription.second[data-v-59c8e79a] {\n      border-width: 0 0 0.25rem;\n}\n.newsletter .subscription-box .subscription.third[data-v-59c8e79a] {\n      border-width: 0 0 0.1875rem;\n}\n.newsletter .subscription-box .subscription.forth[data-v-59c8e79a] {\n      border-width: 0 0 0.125rem;\n}\n.newsletter .subscription-box .subscription.fifth[data-v-59c8e79a] {\n      border-width: 0 0 0.0625rem;\n      position: relative;\n}\n.newsletter .subscription-box .subscription.fifth svg[data-v-59c8e79a] {\n        margin-top: -0.0625rem;\n}\n.newsletter .subscription-box .subscription.fifth .monster-email[data-v-59c8e79a] {\n        margin-left: auto;\n        margin-right: auto;\n        left: 0;\n        right: 0;\n        width: 18.9375rem;\n        height: 7.0625rem;\n        position: absolute;\n        top: -9px;\n        z-index: 2;\n}\n.newsletter .subscription-box .subscription.fifth .monster-subscription[data-v-59c8e79a] {\n        padding-top: 0.5rem;\n        width: 14.8125rem;\n}\n.newsletter .subscription-box .subscription.fifth .monster-subscription .section-type[data-v-59c8e79a] {\n          font-size: 2rem;\n          font-weight: bold;\n          line-height: 1.6875rem;\n}\n.newsletter .subscription-box .subscription.fifth .monster-subscription .subscription-text[data-v-59c8e79a] {\n          color: #00E8FF;\n          font-size: 1.25rem;\n          line-height: 1.375rem;\n}\n.newsletter .animated-submit-form[data-v-59c8e79a] {\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    -webkit-animation-delay: 1.5s;\n            animation-delay: 1.5s;\n}\n.newsletter .animated-newsletter-des1[data-v-59c8e79a] {\n    -webkit-animation-duration: .8s;\n            animation-duration: .8s;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n.newsletter .animated-newsletter-des2[data-v-59c8e79a] {\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n.newsletter .animated-subscription-box[data-v-59c8e79a] {\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n.newsletter .animated-subscription-box.first[data-v-59c8e79a] {\n      -webkit-animation-duration: 400ms;\n              animation-duration: 400ms;\n      -webkit-animation-delay: 0ms;\n              animation-delay: 0ms;\n}\n.newsletter .animated-subscription-box.second[data-v-59c8e79a] {\n      -webkit-animation-duration: 400ms;\n              animation-duration: 400ms;\n      -webkit-animation-delay: 150ms;\n              animation-delay: 150ms;\n}\n.newsletter .animated-subscription-box.third[data-v-59c8e79a] {\n      -webkit-animation-duration: 400ms;\n              animation-duration: 400ms;\n      -webkit-animation-delay: 200ms;\n              animation-delay: 200ms;\n}\n.newsletter .animated-subscription-box.forth[data-v-59c8e79a] {\n      -webkit-animation-duration: 400ms;\n              animation-duration: 400ms;\n      -webkit-animation-delay: 250ms;\n              animation-delay: 250ms;\n}\n.newsletter .animated-subscription-box.fifth[data-v-59c8e79a] {\n      -webkit-animation-duration: 400ms;\n              animation-duration: 400ms;\n      -webkit-animation-delay: 300ms;\n              animation-delay: 300ms;\n}\n.newsletter .animated-newsletter-monster[data-v-59c8e79a] {\n    -webkit-animation-duration: 1000ms;\n            animation-duration: 1000ms;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    -webkit-animation-delay: 800ms;\n            animation-delay: 800ms;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n}\n.newsletter .animated-inner-box[data-v-59c8e79a] {\n    -webkit-animation-duration: 500ms;\n            animation-duration: 500ms;\n    -webkit-transform: scale(1, 1);\n        -ms-transform: scale(1, 1);\n            transform: scale(1, 1);\n    opacity: 1;\n}\n.newsletter .animated-inner-box.first[data-v-59c8e79a] {\n      margin-left: 0;\n}\n.newsletter .animated-monster[data-v-59c8e79a] {\n    -webkit-animation: move 15s steps(2) infinite alternate;\n            animation: move 15s steps(2) infinite alternate;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    -webkit-animation-name: monster-shake-data-v-59c8e79a;\n            animation-name: monster-shake-data-v-59c8e79a;\n}\n.newsletter .animated-email[data-v-59c8e79a] {\n    -webkit-animation: move 15s steps(2) infinite alternate;\n            animation: move 15s steps(2) infinite alternate;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    -webkit-animation-name: email-shake-data-v-59c8e79a;\n            animation-name: email-shake-data-v-59c8e79a;\n}\n.newsletter .fadeInDownDes1[data-v-59c8e79a] {\n    -webkit-animation-name: fadeInDownDes1-data-v-59c8e79a;\n            animation-name: fadeInDownDes1-data-v-59c8e79a;\n}\n.newsletter .fadeInDownDes2[data-v-59c8e79a] {\n    -webkit-animation-name: fadeInDownDes2-data-v-59c8e79a;\n            animation-name: fadeInDownDes2-data-v-59c8e79a;\n}\n.newsletter .fadeInDown-subscription[data-v-59c8e79a] {\n    -webkit-animation-timing-function: cubic-bezier(0.6, 0, 0.23, 1);\n            animation-timing-function: cubic-bezier(0.6, 0, 0.23, 1);\n    -webkit-animation-name: fadeInDown-subscription-data-v-59c8e79a;\n            animation-name: fadeInDown-subscription-data-v-59c8e79a;\n}\n@-webkit-keyframes bounce-in {\n0% {\n    -webkit-transform: translate3d(-8px, 0, 0);\n            transform: translate3d(-8px, 0, 0);\n}\n100% {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n}\n@keyframes bounce-in-data-v-59c8e79a {\n0% {\n    -webkit-transform: translate3d(-8px, 0, 0);\n            transform: translate3d(-8px, 0, 0);\n}\n100% {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n}\n@-webkit-keyframes monster-shake {\nfrom,\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(-7px, 0, 0);\n            transform: translate3d(-7px, 0, 0);\n}\n20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(7px, 0, 0);\n            transform: translate3d(7px, 0, 0);\n}\n}\n@keyframes monster-shake-data-v-59c8e79a {\nfrom,\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(-7px, 0, 0);\n            transform: translate3d(-7px, 0, 0);\n}\n20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(7px, 0, 0);\n            transform: translate3d(7px, 0, 0);\n}\n}\n@-webkit-keyframes email-shake {\nfrom,\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n            transform: translate3d(5px, 0, 0);\n}\n20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n            transform: translate3d(-5px, 0, 0);\n}\n}\n@keyframes email-shake-data-v-59c8e79a {\nfrom,\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    -webkit-transform: translate3d(5px, 0, 0);\n            transform: translate3d(5px, 0, 0);\n}\n20%,\n  40%,\n  60%,\n  80% {\n    -webkit-transform: translate3d(-5px, 0, 0);\n            transform: translate3d(-5px, 0, 0);\n}\n}\n@-webkit-keyframes fadeInDownDes1 {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(-10px, -100%, 0);\n            transform: translate3d(-10px, -100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n@keyframes fadeInDownDes1-data-v-59c8e79a {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(-10px, -100%, 0);\n            transform: translate3d(-10px, -100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n@-webkit-keyframes fadeInDownDes2 {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(10px, -120%, 0);\n            transform: translate3d(10px, -120%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n@keyframes fadeInDownDes2-data-v-59c8e79a {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(10px, -120%, 0);\n            transform: translate3d(10px, -120%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n@-webkit-keyframes fadeInDown-subscription {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n@keyframes fadeInDown-subscription-data-v-59c8e79a {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n.newsletter-form .justify-content-center:hover .form-input[data-v-59c8e79a], .newsletter-form .justify-content-center:hover .form-btn[data-v-59c8e79a] {\n  border-color: #BF0061;\n}\n.newsletter-form .justify-content-center:hover .form-btn button[data-v-59c8e79a] {\n  background: #BF0061;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, "@media (min-width:0) and (max-width:1023px){.newsletter-form-wrapper{margin-bottom:1.7675rem}}@media (min-width:1024px){.newsletter-form-wrapper{width:33.75rem;margin-bottom:2.5rem}}.article-body{word-wrap:break-word;position:relative}@media (min-width:1024px){.article-body{margin-bottom:2.5rem;font-size:1.25rem;line-height:1.875rem}}@media (min-width:0) and (max-width:1023px){.article-body{margin-bottom:1.75rem}}.article-body div[class$=-wrapper]{margin-bottom:1.75rem;text-align:center}@media (min-width:1024px){.article-body iframe{margin:0 auto 2rem}}@media (min-width:0) and (max-width:1023px){.article-body iframe{margin:0 auto 1.75rem}}.article-body iframe,.article-body img{max-width:100%}.article-body img{height:auto}.also-read-wrapper .also-read-article-wrapper .article-body:nth-child(n+2) .also-read-tag{display:none}.article-body .also-read-article-wrapper{text-align:left}@media (min-width:1024px){.article-body .also-read-article-wrapper{margin:auto;max-width:30rem}.article-body .also-read-article-wrapper .article-level-four .card-title a{font-size:1.5rem;line-height:2.125rem}}.article-body .img-caption-processed{margin-left:-3.125rem;margin-right:-3.125rem}@media (min-width:0) and (max-width:1023px){.article-body .img-caption-processed{margin-left:-1.25rem;margin-right:-1.25rem}.article-body .img-caption-processed figcaption{padding-left:1.25rem;padding-right:1.25rem}}@media (min-width:1024px){.article-body .related-person-wrapper{margin-left:-3.125rem;margin-right:-3.125rem}}@media (min-width:0) and (max-width:1023px){.article-body .related-person-wrapper{margin-left:-1.25rem;margin-right:-1.25rem}}.article-body .no-link{pointer-events:none}.body-components{position:relative}", "", {"version":3,"sources":["/app/components/node/fields/Body.vue"],"names":[],"mappings":"AAoCA,4CACA,yBACM,uBAAyB,CAC9B,CACA,AACD,0BACA,yBACM,eAAgB,AAChB,oBAAsB,CAC3B,CACA,AACD,cACE,qBAAsB,AACtB,iBAAmB,CAGpB,AACD,0BACA,cACM,qBAAsB,AACtB,kBAAmB,AACnB,oBAAsB,CAC3B,CACA,AACD,4CACA,cACM,qBAAuB,CAC5B,CACA,AACD,mCACI,sBAAuB,AACvB,iBAAmB,CACtB,AAKD,0BACA,qBAEQ,kBAAkB,CAGzB,CACA,AACD,4CACA,qBAEQ,qBAAkB,CAGzB,CACA,AACD,uCACI,cAAgB,CACnB,AACD,kBACI,WAAa,CAChB,AACD,0FACI,YAAc,CACjB,AACD,yCACI,eAAiB,CAEpB,AACD,0BACA,yCACQ,YAAa,AACb,eAAiB,CACxB,AACD,2EACU,iBAAkB,AAClB,oBAAsB,CAC/B,CACA,AACD,qCAEI,sBAAuB,AACvB,sBAAwB,CAC3B,AACD,4CACA,qCACQ,qBAAsB,AACtB,qBAAuB,CAC9B,AACD,gDACU,qBAAsB,AACtB,qBAAuB,CAChC,CACA,AAKD,0BACA,sCACQ,sBAAuB,AACvB,sBAAwB,CAC/B,CACA,AACD,4CACA,sCACQ,qBAAsB,AACtB,qBAAuB,CAC9B,CACA,AACD,uBACI,mBAAqB,CACxB,AACD,iBACE,iBAAmB,CACpB","file":"Body.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.newsletter-form-wrapper {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.newsletter-form-wrapper {\n      margin-bottom: 1.7675rem;\n}\n}\n@media (min-width: 1024px) {\n.newsletter-form-wrapper {\n      width: 33.75rem;\n      margin-bottom: 2.5rem;\n}\n}\n.article-body {\n  word-wrap: break-word;\n  position: relative;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body {\n      margin-bottom: 2.5rem;\n      font-size: 1.25rem;\n      line-height: 1.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body {\n      margin-bottom: 1.75rem;\n}\n}\n.article-body div[class$=\"-wrapper\"] {\n    margin-bottom: 1.75rem;\n    text-align: center;\n}\n.article-body iframe {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body iframe {\n        margin-top: 0;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 2rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body iframe {\n        margin-top: 0;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 1.75rem;\n}\n}\n.article-body iframe, .article-body img {\n    max-width: 100%;\n}\n.article-body img {\n    height: auto;\n}\n.also-read-wrapper .also-read-article-wrapper .article-body:nth-child(n+2) .also-read-tag {\n    display: none;\n}\n.article-body .also-read-article-wrapper {\n    text-align: left;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body .also-read-article-wrapper {\n        margin: auto;\n        max-width: 30rem;\n}\n.article-body .also-read-article-wrapper .article-level-four .card-title a {\n          font-size: 1.5rem;\n          line-height: 2.125rem;\n}\n}\n.article-body .img-caption-processed {\n    /* Mobile breakpoints */\n    margin-left: -3.125rem;\n    margin-right: -3.125rem;\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body .img-caption-processed {\n        margin-left: -1.25rem;\n        margin-right: -1.25rem;\n}\n.article-body .img-caption-processed figcaption {\n          padding-left: 1.25rem;\n          padding-right: 1.25rem;\n}\n}\n.article-body .related-person-wrapper {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body .related-person-wrapper {\n        margin-left: -3.125rem;\n        margin-right: -3.125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body .related-person-wrapper {\n        margin-left: -1.25rem;\n        margin-right: -1.25rem;\n}\n}\n.article-body .no-link {\n    pointer-events: none;\n}\n.body-components {\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".arrow-right-wrapper[data-v-dc463cd0]{position:absolute;left:0;height:1.5625rem;width:.9375rem}.arrow-right-wrapper svg[data-v-dc463cd0]{fill:#f8008e;height:100%;width:100%}@media (min-width:0) and (max-width:1023px){.arrow-right-wrapper[data-v-dc463cd0]{margin-left:-1.25rem}}@media (min-width:1024px){.arrow-right-wrapper[data-v-dc463cd0]{margin-top:.25rem;margin-left:-3.375rem}}@media (min-width:1024px){.center-wrapper[data-v-dc463cd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.arrow-placement[data-v-dc463cd0]:before{content:\"\";display:block;height:1.5625rem;width:.9375rem;background-image:url(\"/static/svg/raw/icon_arrow_right1.svg\");background-size:contain;position:absolute;left:-3.375rem;margin-top:.25rem}", "", {"version":3,"sources":["/app/components/node/fields/Body.vue"],"names":[],"mappings":"AAgCA,sCACE,kBAAmB,AACnB,OAAQ,AACR,iBAAkB,AAClB,cAAiB,CAGlB,AACD,0CACI,aAAc,AACd,YAAa,AACb,UAAY,CACf,AACD,4CACA,sCACM,oBAAsB,CAC3B,CACA,AACD,0BACA,sCACM,kBAAoB,AACpB,qBAAuB,CAC5B,CACA,AAGD,0BACA,iCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,CACA,AACD,yCACE,WAAY,AACZ,cAAe,AACf,iBAAkB,AAClB,eAAiB,AACjB,8DAA+D,AAC/D,wBAAyB,AACzB,kBAAmB,AACnB,eAAgB,AAChB,iBAAoB,CACrB","file":"Body.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.arrow-right-wrapper[data-v-dc463cd0] {\n  position: absolute;\n  left: 0;\n  height: 1.5625rem;\n  width: 0.9375rem;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n.arrow-right-wrapper svg[data-v-dc463cd0] {\n    fill: #F8008E;\n    height: 100%;\n    width: 100%;\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.arrow-right-wrapper[data-v-dc463cd0] {\n      margin-left: -1.25rem;\n}\n}\n@media (min-width: 1024px) {\n.arrow-right-wrapper[data-v-dc463cd0] {\n      margin-top: 0.25rem;\n      margin-left: -3.375rem;\n}\n}\n\n/* Mobile breakpoints */\n@media (min-width: 1024px) {\n.center-wrapper[data-v-dc463cd0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n}\n.arrow-placement[data-v-dc463cd0]::before {\n  content: \"\";\n  display: block;\n  height: 1.5625rem;\n  width: 0.9375rem;\n  background-image: url(\"/static/svg/raw/icon_arrow_right1.svg\");\n  background-size: contain;\n  position: absolute;\n  left: -3.375rem;\n  margin-top: 0.25rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)
var startOfYear = __webpack_require__(1083)
var differenceInCalendarDays = __webpack_require__(1053)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)
var startOfISOWeek = __webpack_require__(956)
var startOfISOYear = __webpack_require__(1081)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(357)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(1077)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(1078)
var buildFormatLocale = __webpack_require__(1079)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(998)
var startOfISOWeek = __webpack_require__(956)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("217c2fab", content, true, {});

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("0b842c65", content, true, {});

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1071);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("756b4a14", content, true, {});

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1072);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("60b0af1b", content, true, {});

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("0e0f3cca", content, true, {});

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;

  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEachRight;


/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

var baseForOwnRight = __webpack_require__(1092),
    createBaseEach = __webpack_require__(358);

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

module.exports = baseEachRight;


/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(1093),
    keys = __webpack_require__(38);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(359);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

var arrayEachRight = __webpack_require__(1090),
    baseEachRight = __webpack_require__(1091),
    castFunction = __webpack_require__(236),
    isArray = __webpack_require__(10);

/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = isArray(collection) ? arrayEachRight : baseEachRight;
  return func(collection, castFunction(iteratee));
}

module.exports = forEachRight;


/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1628)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1379),
  /* template */
  __webpack_require__(1784),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d1889cb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1061),
  /* template */
  __webpack_require__(1102),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54eacdd7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1062),
  /* template */
  __webpack_require__(1104),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1065),
  /* template */
  __webpack_require__(1103),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59c8e79a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showNewsletter) ? _c('div', {
    staticClass: "row newsletter no-gutters w-100 gtm-onElementVisiblity",
    class: _vm.colorTheme,
    attrs: {
      "gtm-on": "elementVisibility",
      "gtm-visibility-category": _vm.gtmNewsletterCategory,
      "gtm-visibility-action": "Newsletter widget impression",
      "gtm-visibility-label": _vm.newsletterType.name
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "innerbox nested-border-1",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "innerbox nested-border-2",
    class: _vm.theme
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [(_vm.submit) ? _c('div', {
    staticClass: "innerbox nested-border-3",
    class: _vm.theme
  }, [_c('transition', {
    attrs: {
      "duration": 1000,
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "innerbox nested-border-4",
    class: _vm.theme
  }, [_c('transition', {
    attrs: {
      "duration": 1000,
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "innerbox nested-border-5",
    class: _vm.theme
  }, [_c('div')])])], 1)])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "duration": 1000,
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-newsletter-form newsletter-zoomIn",
      "leave-active-class": "animated-newsletter-form newsletter-zoomOut",
      "appear": ""
    },
    on: {
      "after-enter": _vm.afterEnter,
      "after-leave": _vm.afterLeave
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "newsletter-form p-3"
  }, [_c('form', {
    staticClass: "mx-auto",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-between"
  }, [_c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("GET OUR")]), _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.newsletterType.name))]), _vm._v(" NEWSLETTER")])]), _c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "mail-icon float-right"
  }, [_c('svg-email-large-icon', {
    attrs: {
      "fill": _vm.color,
      "width": "100%",
      "height": "100%"
    }
  })], 1)])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control border-right-0 border-left-0 border-top-0 pl-0 InputEmail",
    class: {
      'warning-color': _vm.warning
    },
    attrs: {
      "type": "email",
      "id": "InputEmail1",
      "placeholder": "your email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "warning"
  }, [(_vm.warning) ? _c('p', {
    staticClass: "pr-1 pl-1 m-0 h-100"
  }, [_vm._v("Email Address is not valid.")]) : _vm._e()]), _c('button', {
    staticClass: "btn submit-newsletter btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SIGN UP")])])]) : _vm._e()]), (_vm.subscition) ? _c('div', {
    staticClass: "subscition-box"
  }, [_c('div', {
    staticClass: "subscition"
  }, [_c('div', {
    staticClass: "row align-items-center w-100 h-100 no-gutters"
  }, [_c('div', {
    staticClass: "col-12 d-flex align-items-center inner-subscrition"
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeInUP",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "mail-icon mx-auto animated rotateIn"
  }, [_c('svg-email-large-icon', {
    attrs: {
      "fill": _vm.color,
      "width": "100%",
      "height": "100%"
    }
  })], 1)]), _c('div', {
    staticClass: "subscrite"
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeInUP",
      "appear": ""
    },
    on: {
      "enter": _vm.thankyouEnter,
      "after-leave": _vm.thankyouLeave
    }
  }, [_c('div', {
    staticClass: "text-center subscrition-text"
  }, [_vm._v("\n                        THANK YOU\n                      ")])]), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-last fadeInUp",
      "leave-active-class": "animated-last fadeInUP",
      "appear": ""
    }
  }, [(_vm.lastText) ? _c('div', {
    staticClass: "text-center subscrition-text"
  }, [_vm._v("\n                        YOU ARE NOW ON THE LIST.\n                      ")]) : _vm._e()])], 1)], 1)])])])]) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "img-caption-processed"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.onResize
    }
  }), _c('div', {
    staticClass: "image",
    style: (_vm.styleObj)
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    ref: "lazyload",
    class: _vm.imageClass,
    attrs: {
      "data-style-type": _vm.imageDataStyleType,
      "tmp-src": _vm.imageUrl,
      "data-writer": _vm.imageDataWriter,
      "height": _vm.imageHeight,
      "width": _vm.imageWidth,
      "title": _vm.imageTitle
    }
  })]), (_vm.type === 'photo-essay') ? _c('div', {
    staticClass: "photo-share"
  }, [_c('share-buttons', {
    attrs: {
      "url": _vm.shareUrl,
      "title": _vm.imageTitle || _vm.shareData.title,
      "thumbnail": _vm.shareThumbnail,
      "avaliableIcons": {
        pinterest: true,
        email: false,
        whatsapp: false,
        messenger: false
      }
    }
  })], 1) : _vm._e(), (_vm.imageTitle.length > 0) ? _c('figcaption', [_vm._v(_vm._s(_vm.imageTitle))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showNewsletter) ? _c('div', {
    staticClass: "row newsletter no-gutters w-100 innerbox-black gtm-onElementVisiblity",
    class: [{
      'hidden-overflow': _vm.submit
    }],
    style: ({
      height: _vm.newsletterWrapperHeight
    }),
    attrs: {
      "gtm-on": "elementVisibility",
      "gtm-visibility-category": _vm.gtmNewsletterCategory,
      "gtm-visibility-action": "Newsletter widget impression",
      "gtm-visibility-label": _vm.newsletterType.name
    }
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.onResize
    }
  }), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-submit-form fadeInUp",
      "appear": ""
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "newsletter-form"
  }, [_c('form', {
    staticClass: "mx-auto",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center no-gutters",
    class: [{
      'active': _vm.submit
    }]
  }, [_c('div', {
    staticClass: "col-7 form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.monsterEmail),
      expression: "monsterEmail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-100 form-control border-0 pl-2 pr-2 input-email",
    class: {
      'warning-color': _vm.warning
    },
    attrs: {
      "type": "email",
      "placeholder": "your email"
    },
    domProps: {
      "value": (_vm.monsterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.monsterEmail = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "col-4 form-btn"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn submit-newsletter pl-0 pr-0",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', [_vm._v("SIGN UP")])])])])]), _c('div', {
    staticClass: "notification warning",
    class: {
      'warning-color': _vm.warning
    }
  }, [(_vm.warning) ? _c('div', {
    staticClass: "d-flex align-items-center pr-3 pl-3 h-100"
  }, [_vm._v("Email Address is not valid.")]) : _vm._e()])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-submit-form fadeIn",
      "appear": ""
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "diamond-icon"
  }, [_c('svg-diamond-shape-icon')], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "appear": ""
    },
    on: {
      "after-enter": function($event) {
        _vm.animation('add')
      },
      "leave": function($event) {
        _vm.animation('remove')
      }
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "col-12 newsletter-inner-wrapper"
  }, [_c('div', {
    ref: "innerbox-0",
    staticClass: "innerbox first",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-1",
    staticClass: "innerbox second",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-2",
    staticClass: "innerbox third",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-3",
    staticClass: "innerbox forth",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-4",
    staticClass: "innerbox fifth",
    class: _vm.newsletterType.color
  }, [_c('div', {
    staticClass: " w-100"
  }, [(!_vm.submit) ? _c('div', {
    ref: "newsletterTextBox",
    staticClass: "w-100 newsletter-text-box d-flex align-items-center"
  }, [_c('div', {
    staticClass: "row no-gutters newsletter w-100 justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 newsletter-text-content-wrapper"
  }, [_c('div', {
    staticClass: "text-wrapper"
  }, [_c('p', {
    staticClass: "title brand-title"
  }, [_vm._v("GET OUR")])]), _c('div', {
    staticClass: "text-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "section-type",
    class: _vm.newsletterType.color
  }, [_vm._v(_vm._s(_vm.newsletterType.name))])])]), _c('div', {
    staticClass: "text-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', {
    class: _vm.newsletterType.color
  }, [_vm._v("NEWSLETTER")])])])])])]) : _vm._e()])])])])])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    },
    on: {
      "enter": _vm.play1
    }
  }, [(_vm.submit) ? _c('div', {
    staticClass: "subscription-box w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription first w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription second w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription third w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription forth w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription fifth monster-box w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-newsletter-monster slideInDown",
      "leave-active-class": "animated-newsletter-mosnter fadeOut",
      "appear": ""
    },
    on: {
      "after-enter": function($event) {
        _vm.subscriptionText = true
      },
      "after-leave": function($event) {
        _vm.subscriptionText = false
      }
    }
  }, [_c('div', {
    staticClass: "monster-wrapper"
  }, [_c('div', {
    staticClass: "w-100 text-center monster"
  }, [_c('svg-email-monster-icon', {
    staticClass: "animated-monster"
  })], 1), _c('div', {
    staticClass: "monster-email animated-email"
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-center mx-100 h-100"
  }, [_c('div', {
    staticClass: "col-3 text-center align-self-center"
  }, [_c('svg-email-black-icon')], 1), _c('div', {
    staticClass: "col-3 text-center align-self-center"
  }, [_c('svg-email-black-icon')], 1), _c('div', {
    staticClass: "col-3 text-center align-self-center"
  }, [_c('svg-email-black-icon')], 1)])])])]), (_vm.subscriptionText) ? _c('div', {
    staticClass: "monster-subscription mx-auto"
  }, [_c('transition', {
    attrs: {
      "duration": 500,
      "name": "monster-subscription-des1",
      "enter-active-class": "animated-newsletter-des1 fadeInDownDes1",
      "leave-active-class": "animated-newsletter-des1 fadeOut",
      "appear": ""
    },
    on: {
      "enter": _vm.play2
    }
  }, [(_vm.subscriptionText) ? _c('div', {
    staticClass: "section-type text-center"
  }, [_vm._v("THANK YOU")]) : _vm._e()]), _c('transition', {
    attrs: {
      "duration": 500,
      "name": "newsletter-subscription-des2",
      "enter-active-class": "animated-newsletter-des2 fadeInDownDes2",
      "leave-active-class": "animated-newsletter-des2 fadeOut",
      "appear": ""
    }
  }, [(_vm.subscriptionText) ? _c('div', {
    staticClass: "subscription-text pt-2 pl-1 pr-1 mx-auto"
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-center"
  }, [_c('div', {
    staticClass: "col-11 text-center",
    class: _vm.newsletterType.color
  }, [_vm._v("\n                                    YOU ARE NOW ON THE EMAIL LIST\n                                  ")])])]) : _vm._e()])], 1) : _vm._e()], 1)])], 1)])], 1)])], 1)])], 1)])], 1) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-body-text"
  }, [_c('div', {
    ref: "body-html",
    domProps: {
      "innerHTML": _vm._s(_vm.item.content.html)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body-components",
    staticClass: "body-components"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.resizeBody
    }
  }), _c('div', {
    ref: "articleBody",
    staticClass: "article-body"
  }, [_vm._l((_vm.contentList), function(item, index) {
    return [(item.type === 'text') ? _c('body-text', {
      ref: _vm.setElementRef('text', index),
      refInFor: true,
      attrs: {
        "item": item,
        "node": _vm.node
      }
    }) : (item.type === 'image') ? _c('body-image', {
      ref: _vm.setElementRef('image', index),
      refInFor: true,
      attrs: {
        "item": item,
        "type": _vm.articleType,
        "shareData": _vm.shareData(),
        "itemIndex": item.itemTypeIndex,
        "inlinePhotoList": _vm.node.inlinePhotoList
      }
    }) : (item.type === 'iframe') ? _c('body-iframe', {
      ref: _vm.setElementRef('iframe', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'twitter') ? _c('body-twitter', {
      ref: _vm.setElementRef('twitter', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'instagram') ? _c('body-instagram', {
      ref: _vm.setElementRef('instagram', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'chart') ? _c('body-chart', {
      ref: _vm.setElementRef('chart', index),
      refInFor: true,
      attrs: {
        "item": item,
        "nid": _vm.node.nid
      }
    }) : (item.type === 'blockquote') ? _c('body-blockquote', {
      ref: _vm.setElementRef('blockquote', index),
      refInFor: true,
      attrs: {
        "item": item,
        "node": _vm.node,
        "isBodyLeftQuoteMode": _vm.isBodyLeftQuoteMode
      }
    }) : (item.type === 'person') ? _c('div', {
      ref: _vm.setElementRef('person', index),
      refInFor: true,
      staticClass: "related-person-group"
    }, [_c('body-related-widget', {
      staticClass: "hidden-sm-down",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "desktop"
      }
    }), _c('body-related-widget', {
      staticClass: "hidden-sm-up",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "mobile"
      }
    })], 1) : (item.type === 'whatis' && _vm.isShowingWhatisWidget(_vm.node, item)) ? _c('div', {
      ref: _vm.setElementRef('whatis', index),
      refInFor: true,
      staticClass: "whatis-widget-group"
    }, [_c('body-related-widget', {
      staticClass: "hidden-sm-down",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "desktop"
      }
    }), _c('body-related-widget', {
      staticClass: "hidden-sm-up",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "mobile"
      }
    })], 1) : _vm._e(), _vm._l((_vm.alsoReadArticles), function(article, articleIndex) {
      return (_vm.getBodyOptions.alsoRead.enable) ? [(article.insertAtIndex === index && article.isIndexAvailable) ? _c('also-read', {
        attrs: {
          "data-index": index,
          "article": article
        }
      }) : _vm._e()] : _vm._e()
    }), (_vm.inlineNewsletterIndex && _vm.inlineNewsletterIndex === index) ? _c('div', {
      staticClass: "center-wrapper hidden-md-up"
    }, [(_vm.getBodyOptions.inlineNewsletter) ? _c('div', {
      staticClass: "newsletter-form-wrapper no-article-gutter-mobile"
    }, [_c('inline-newsletter-form', {
      attrs: {
        "newsletterType": _vm.getNewsLetterType,
        "theme": _vm.newsLetterTheme
      }
    })], 1) : _vm._e()]) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="21" height="18" viewBox="0 0 21 18" xmlns="http://www.w3.org/2000/svg"><path d="M2 0h19v16h-2V2H2V0zM0 18V4h17v14H0z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="36" height="45" viewBox="0 0 36 45" xmlns="http://www.w3.org/2000/svg"><path d="M17 9.5l-17 17 17.607 17.607 17.5-17.5L26 17.5V0l-9 9.5z"/></svg>'};

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="30" height="22" viewBox="0 0 30 22" xmlns="http://www.w3.org/2000/svg"><path d="M18.007 0l-.034.034V0h-8.97v.059L8.97 0H0v9.116l.041.034H0v12.166h8.97v-.166l.033.166H30V0H18.007zm2.99 9.116v-3.04h2.99V3.04h2.99V2.99l.033.049v3.038l-.034.089v-.09h-2.99v3.04h.086l-.086.034h-2.99v3.039h2.99v3.038h2.99v-.085l.034.085v3.039h.025l-.025.012-.034.038v-.038h-2.99v-3.051h-2.99V12.19h-2.99l-.024.028-.01-.028H9.004v3.038l-.034.035v-.035H5.98v3.039h.012l-.012.012H2.99l-.026-.012h.027v-3.039h2.99V12.19h2.99V9.15H5.937l.041-.034v-3.04H2.99V3.04h2.99v3.038h2.99l.034-.058v3.097h8.97v-.034l.034.034h2.99z" fill="#000" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg"><path d="M37.468 0v6.076h-6.076v6.075h-6.075v6.077H19.24v6.076h-6.075v6.076H7.088v6.075H0v6.076h7.088v6.076h6.077v6.077h6.075v6.075h6.077v6.076h6.075v6.076h6.076V80h6.076v-7.089h6.076v-6.076h6.076v-6.076h6.077v-6.075h6.076v-6.077h6.075v-6.076H80v-6.076h-6.076V30.38H67.85v-6.076h-6.076v-6.076h-6.077V12.15H49.62V6.076h-6.076V0z" fill="#F8008E" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1599)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1335),
  /* template */
  __webpack_require__(1761),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64caa5e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(351);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assignIn = __webpack_require__(155);

var _assignIn2 = _interopRequireDefault(_assignIn);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _slice = __webpack_require__(1000);

var _slice2 = _interopRequireDefault(_slice);

var _floor = __webpack_require__(999);

var _floor2 = _interopRequireDefault(_floor);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isUndefined = __webpack_require__(85);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _utilities = __webpack_require__(51);

var _animationHandler = __webpack_require__(348);

var _animationHandler2 = _interopRequireDefault(_animationHandler);

var _vueResize = __webpack_require__(338);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    sliderOptions: {
      type: Object,
      default: function _default() {
        return this.getDefault();
      }
    },
    extraSlots: {
      type: Array
    },
    selector: {
      type: String
    }
  },
  mixins: [_animationHandler2.default],
  data: function data() {
    return {
      sliderId: {},
      currentSlide: 0,
      numOfSlide: 0,
      sliderOptionsData: {},
      sliderInfos: {},
      allowSlide: true,
      zoom: false,
      articleLimit: 3,
      preventSwipe: false,
      resetPreventSwipe: false,
      slideChangeEndResponse: {},
      isAnimating: false,
      leftStartingX: 0
    };
  },
  computed: {},
  components: {
    ResizeObserver: _vueResize.ResizeObserver
  },
  mounted: function mounted() {
    this.sliderOptionsData = (0, _assignIn2.default)(this.getDefault(), this.sliderOptions);
    var self = this;
    self.sliderInfos.activeSlide = 0;
    if (this.sliderOptions.initFromMount) {
      self.init();
    }
  },
  updated: function updated() {
    if ((0, _get2.default)(this, '$refs.container.childElementCount')) {
      this.sliderInfos.slideCount = this.$refs.container.childElementCount;
    }
  },
  render: function render(h) {
    var _this = this;

    var renderH = [];
    this.numOfSlide = this.$slots.default ? this.$slots.default.length : 0;
    renderH.push(h('div', {
      class: { slider: true }, style: { width: this.$slots.default ? this.$slots.default.length * 100 + '%' : 0 }, ref: 'container'
    }, this.$slots.default));
    renderH.push(this.$slots.caption);
    if (this.$slots.prev) {
      renderH.push(h('div', {
        on: {
          click: this.prev
        }
      }, this.$slots.prev));
    }

    if (this.$slots.next) {
      renderH.push(h('div', {
        on: {
          click: this.next
        }
      }, this.$slots.next));
    }

    if (this.extraSlots) {
      (0, _forEach2.default)(this.extraSlots, function (extraSlot) {
        var key = (0, _get2.default)(extraSlot, 'key', false);

        if (key && _this.$slots[key]) {
          var renderClass = {};
          renderClass[key] = true;

          renderH.push(h('div', {
            class: renderClass,
            ref: key
          }, _this.$slots[key]));
        }
      });
    }

    if (this.$slots.pagination) {
      var activeSlide = this.sliderInfos.activeSlide;
      var limit = this.sliderOptions.articleLimit || 10;
      var page = (0, _floor2.default)(activeSlide / limit);

      var dots = (0, _map2.default)((0, _slice2.default)(this.$slots.default, page * limit, (page + 1) * limit), function (item, key) {
        return h('div', {
          class: {
            'is-active': key === activeSlide % limit
          },
          on: {
            click: function click() {
              if ((0, _utilities.isDesktop)()) _this.goTo(page * limit + key, false);
            }
          }
        }, item.name);
      });

      renderH.push(h('div', {
        class: { 'slider-pagination': true },
        ref: 'pagination'
      }, dots));
    }

    renderH.push(h('resize-observer', {
      on: {
        notify: this.handleResize
      }
    }, ''));

    return h('div', {
      class: { carousel: true, 'has-slider': true }
    }, renderH);
  },

  methods: {
    toggleContainerAnimation: function toggleContainerAnimation(isOn) {
      var containerAnimationClass = 'is-animating';
      var animationElements = [this.$refs.container].concat((0, _toConsumableArray3.default)(this.getExtraSlotAnimationElements()));
      (0, _forEach2.default)(animationElements, function (element) {
        if (isOn) {
          element.classList.add(containerAnimationClass);
        } else {
          element.classList.remove(containerAnimationClass);
        }
      });
    },
    updateExtraSlotsPositionX: function updateExtraSlotsPositionX(value, isHide) {
      var _this2 = this;

      var extraSlotAnimationElements = this.getExtraSlotAnimationElements();
      if (!(0, _isEmpty2.default)(extraSlotAnimationElements)) {
        var startingLeftX = window.innerWidth * this.sliderInfos.activeSlide * -1;
        (0, _forEach2.default)(extraSlotAnimationElements, function (element) {
          if (value === startingLeftX || value === 0) {
            if (isHide) {
              element.style['transition-duration'] = '';
              if (_this2.sliderInfos.currentSlide > _this2.sliderInfos.activeSlide) {
                element.style.transform = 'translateX( 100vw )';
              } else {
                element.style.transform = 'translateX( -100vw )';
              }
            } else {
              element.style['transition-duration'] = '';
              element.style.transform = 'translateX( 0px )';
            }
          } else {
            element.style['transition-duration'] = '0s';
            element.style.transform = 'translateX( ' + (value - startingLeftX) + 'px )';
          }
        });
      }
    },
    updateContainerPositionX: function updateContainerPositionX(value) {
      this.$refs.container.style.transform = 'translateX( ' + value + 'px )';
    },
    getExtraSlotAnimationElements: function getExtraSlotAnimationElements() {
      var _this3 = this;

      var result = [];
      if (this.extraSlots) {
        (0, _forEach2.default)(this.extraSlots, function (extraSlot) {
          var key = (0, _get2.default)(extraSlot, 'key', false);
          var animationClass = (0, _get2.default)(extraSlot, 'animationClass', false);
          var targetElement = (0, _get2.default)(_this3, '$refs[' + key + ']', false);
          if (targetElement) {
            var animationElement = targetElement.querySelector('.' + animationClass);
            if (key && animationClass && animationElement) {
              result.push(animationElement);
            }
          }
        });
      }
      return result;
    },
    getWidth: function getWidth() {
      var w = (0, _get2.default)(this, '$refs.container.offsetParent');

      w = w ? w.getBoundingClientRect().width : window.innerWidth;
      return w;
    },
    handleResize: function handleResize() {
      var moveX = -this.getWidth() * this.sliderInfos.activeSlide;
      this.updateContainerPositionX(moveX);
      this.updateExtraSlotsPositionX(moveX);
    },
    getDefault: function getDefault() {
      return {
        width: '100%',
        allowScroll: true,
        realTimeAnimate: false,
        sensitivity: 25,
        exactAngle: [],
        tapToHideCaption: false,
        tapToHideTitle: false,
        childProcessed: false,
        forceStop: false,
        disableSwipe: false,
        initFromMount: false,
        isPhotoSlider: false
      };
    },
    init: function init() {
      var _this4 = this;

      this.bindAnimation(this.$refs.container, [this.slideAnimationEnd]);
      var self = this;
      self.sliderInfos.Hammer = __webpack_require__(1055);
      self.sliderInfos.sliderPanelSelector = '.slider-panel';
      self.sliderInfos.sensitivity = self.sliderOptions.sensitivity;
      self.sliderInfos.slideCount = 0;
      self.sliderInfos.currentSlide = 0;
      self.sliderInfos.percentage = '';
      self.sliderInfos.slideCount = self.$refs.container.childElementCount;
      self.$refs.container.style.width = self.sliderInfos.slideCount * 100 + '%';
      var sliderManager = new self.sliderInfos.Hammer.Manager(self.$refs.container, {
        touchAction: 'pan-y',
        recognizers: [[self.sliderInfos.Hammer.Pan, { direction: self.sliderInfos.Hammer.DIRECTION_ALL }], [self.sliderInfos.Hammer.Tap]]
      });
      sliderManager.add(new self.sliderInfos.Hammer.Pan({ threshold: 0, pointers: 0 }));
      sliderManager.on('panend', function (e) {
        if (_this4.closest(e.target, '.no-article-swipe', 'body') !== null) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.disableSwipe) && self.sliderOptions.disableSwipe === true) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.forceStop) && self.sliderOptions.forceStop) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.childScrolling) && self.sliderOptions.childScrolling) {
          return;
        }
        if (!self.sliderInfos.percentage) {
          return;
        }

        if (self.sliderOptionsData.velocityX) {
          if (Math.abs(e.velocityX) < self.sliderOptionsData.velocityX) {
            self.sliderInfos.goTo(self.sliderInfos.activeSlide);
            return;
          }
        }
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX / window.innerWidth) * 100 > self.sliderInfos.sensitivity) {
          if (e.velocityX > 1) {
            self.goTo(self.sliderInfos.activeSlide - 1);
          } else if (e.velocityX < -1) {
            self.goTo(self.sliderInfos.activeSlide + 1);
          } else if (self.sliderInfos.percentage <= -(self.sliderInfos.sensitivity / self.sliderInfos.slideCount)) {
            self.goTo(self.sliderInfos.activeSlide + 1);
          } else if (self.sliderInfos.percentage >= self.sliderInfos.sensitivity / self.sliderInfos.slideCount) {
            self.goTo(self.sliderInfos.activeSlide - 1);
          } else {
            self.goTo(self.sliderInfos.activeSlide);
          }
        } else if (!self.sliderOptions.childScrolling) {
          self.goTo(self.sliderInfos.activeSlide);
        }
        self.sliderInfos.percentage = false;
      });

      sliderManager.on('panstart', function (e) {
        if (_this4.closest(e.target, '.no-article-swipe', 'body') !== null) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.disableSwipe) && self.sliderOptions.disableSwipe === true) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.forceStop) && self.sliderOptions.forceStop) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.childScrolling) && self.sliderOptions.childScrolling) {
          return;
        }
        if (_this4.resetPreventSwipe) {
          _this4.preventSwipe = false;
          _this4.resetPreventSwipe = false;
        }
      });

      sliderManager.on('pan', function (e) {
        if (_this4.preventSwipe && !_this4.sliderOptions.isPhotoSlider) return;
        if (_this4.closest(e.target, '.no-article-swipe', 'body') !== null) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.disableSwipe) && self.sliderOptions.disableSwipe === true) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.childProcessed) && !self.sliderOptions.childProcessed) {
          return;
        }
        if (!(0, _isUndefined2.default)(self.sliderOptions.forceStop) && self.sliderOptions.forceStop) {
          return;
        }
        if (_this4.zoom) return;
        if (!self.sliderOptions.childScrolling) {
          self.sliderInfos.percentage = 100 / self.sliderInfos.slideCount * (e.deltaX / window.innerWidth);
          if (self.sliderOptionsData.realTimeAnimate) {
            var moveX = _this4.leftStartingX - e.deltaX;

            if (self.sliderInfos.activeSlide === 0 && moveX < 0) moveX = 0;

            self.updateContainerPositionX(moveX * -1);
            self.updateExtraSlotsPositionX(moveX * -1);
            _this4.$emit('slideProgress', {
              additionalEvent: e.additionalEvent || false,
              deltaX: e.deltaX,
              deltaY: e.deltaY,
              angle: e.angle,
              isFinal: e.isFinal,
              isFirst: e.isFirst
            });
          }
        }
        _this4.updateIsAnimating();
      });

      self.sliderInfos.goTo = function (number) {
        var animation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        self.goTo(number, animation);
      };
    },
    slideChangeEnd: function slideChangeEnd() {
      this.resetPreventSwipe = true;
      if ((0, _get2.default)(this, 'slideChangeEndResponse.change')) this.updateExtraSlotsPositionX(0);
      this.$emit('slideChangeEnd', {
        response: this.slideChangeEndResponse
      }, { ps: 'on event slideChangeEnd' });
      this.slideChangeEndResponse = false;
      this.leftStartingX = window.innerWidth * this.sliderInfos.activeSlide;
      this.updateIsAnimating(false);
    },
    prev: function prev() {
      var animation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.sliderInfos.activeSlide > 0) {
        this.sliderInfos.activeSlide -= 1;
      }
      this.goTo(this.sliderInfos.activeSlide, animation);
    },
    next: function next() {
      var animation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.sliderInfos.activeSlide < this.numOfSlide - 1) {
        this.sliderInfos.activeSlide += 1;
      }
      this.goTo(this.sliderInfos.activeSlide, animation);
    },
    goTo: function goTo(number) {
      var animation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (this.zoom) return;
      var slideBeforeGoto = this.sliderInfos.currentSlide;
      if (number < 0) {
        this.sliderInfos.activeSlide = 0;
      } else if (number > this.sliderInfos.slideCount - 1) {
        this.sliderInfos.activeSlide = this.sliderInfos.slideCount - 1;
      } else {
        this.sliderInfos.activeSlide = number;
      }
      if (animation) {
        this.updateIsAnimating(true);
      }
      var slideBehavior = false;
      if (this.sliderInfos.activeSlide > slideBeforeGoto) {
        slideBehavior = 'next';
      } else if (this.sliderInfos.activeSlide < slideBeforeGoto) {
        slideBehavior = 'prev';
      }
      if ((0, _utilities.isDomElement)(this.$refs.container)) {
        var moveX = -this.getWidth() * this.sliderInfos.activeSlide;
        this.updateContainerPositionX(moveX);
        this.updateExtraSlotsPositionX(moveX, slideBehavior);
      }
      this.$emit('slideChangeStart', {
        response: {
          beforeSlide: slideBeforeGoto,
          activeSlide: this.sliderInfos.activeSlide,
          slideCount: this.sliderInfos.slideCount,
          change: slideBeforeGoto !== this.sliderInfos.activeSlide,
          behavior: slideBehavior
        }
      }, { ps: 'on event slideChangeStart' });

      this.slideChangeEndResponse = {
        beforeSlide: slideBeforeGoto,
        activeSlide: this.sliderInfos.activeSlide,
        slideCount: this.sliderInfos.slideCount,
        change: slideBeforeGoto !== this.sliderInfos.activeSlide,
        behavior: slideBehavior
      };
      if (!animation) {
        this.slideChangeEnd();
      }
      this.sliderInfos.currentSlide = this.sliderInfos.activeSlide;
    },
    updateSlideCount: function updateSlideCount(count) {
      this.sliderInfos.slideCount = count || this.$refs.container.childElementCount;
    },
    updateIsAnimating: function updateIsAnimating(value) {
      if ((0, _utilities.isDomElement)(this.$refs.container)) {
        if (!(0, _isUndefined2.default)(value)) {
          if (value) {
            this.toggleContainerAnimation(true);
            if (!this.preventSwipe && !this.resetPreventSwipe && !this.sliderOptions.isPhotoSlider && this.$refs.container.getBoundingClientRect().left !== -1 * this.leftStartingX) {
              this.preventSwipe = true;
            }
          } else {
            this.toggleContainerAnimation(false);
            this.preventSwipe = false;
          }
          this.isAnimating = value;
        } else if (this.$refs.container.getBoundingClientRect().left === -1 * this.leftStartingX) {
          this.toggleContainerAnimation(false);
          this.preventSwipe = false;
          this.leftStartingX = window.innerWidth * this.sliderInfos.activeSlide;
          this.isAnimating = false;
        }
      }
    },
    closest: function closest(el, selector, stopSelector) {
      var retval = null;
      if ((0, _utilities.isDomElement)(el)) {
        while (el) {
          if (el.matches(selector)) {
            retval = el;
            break;
          } else if (stopSelector && el.matches(stopSelector)) {
            break;
          }
          el = el.parentElement;
        }
      }
      return retval;
    },
    slideAnimationEnd: function slideAnimationEnd(ele) {
      if (ele.className.match(/slider/)) {
        this.slideChangeEnd();
      }
    }
  }
};

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon_single_quote_blue = __webpack_require__(1108);

var _icon_single_quote_blue2 = _interopRequireDefault(_icon_single_quote_blue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'quoteBlock',
  components: {
    SingleQuoteSvg: _icon_single_quote_blue2.default
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    quoteType: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    mainClassName: function mainClassName() {
      switch (this.quoteType) {
        case 'default':
          return 'blockquote-quote';
        case 'author':
          return 'blockquote-author';
        default:
          {
            return 'blockquote-quote';
          }
      }
    }
  }
};

/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _icon_email_8bit = __webpack_require__(1182);

var _icon_email_8bit2 = _interopRequireDefault(_icon_email_8bit);

var _email_monster = __webpack_require__(1052);

var _email_monster2 = _interopRequireDefault(_email_monster);

var _newsletter = __webpack_require__(953);

var _newsletter2 = _interopRequireDefault(_newsletter);

var _utilities = __webpack_require__(51);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_newsletter2.default],
  props: {
    sections: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    gtmType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      submit: false,
      monsterEmail: '',
      warning: false,
      subscription: false,
      flag: false
    };
  },

  components: {
    SvgEmailEightBitIcon: _icon_email_8bit2.default,
    SvgEmailMonsterIcon: _email_monster2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['showNewsletter']), {
    newsletterType: function newsletterType() {
      return (0, _utilities.getNewsLetterMapping)(this.sections) || {};
    },
    gtmNewsletterCategory: function gtmNewsletterCategory() {
      return (0, _get2.default)(_gtmManager2.default.getDynamicGtmEventsByType(this.gtmType, {}), 'category', false);
    },
    inHomeView: function inHomeView() {
      return this.$route.name === 'Home';
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.validateEmail(this.monsterEmail)) {
        this.warning = false;
        this.submit = true;
        this.play1();
        setTimeout(function () {
          _this.play2();
        }, 2300);
        this.subscribeNewsletter(this.monsterEmail, this.newsletterType, this.gtmNewsletterCategory);
      } else {
        this.warning = true;
        this.submit = false;
      }
    }
  },
  watch: {
    submit: function submit(val) {
      if (val) {
        this.$refs.rectWrappersContainer.classList.remove('animated');
        this.$refs.rectWrappersContainer.classList.add('subscribe-animated');
      }
    }
  },
  mounted: function mounted() {
    this.checkSubscribedToList(this.newsletterType);
  }
};

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".carousel{width:100%}.slider-panel{width:100%;position:relative;overflow:hidden}img{width:100%;height:auto}.has-slider{overflow:hidden;position:relative;width:100%}.has-slider .slider{display:-webkit-box;display:-ms-flexbox;display:flex}.has-slider .is-animating{-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;-o-transition:transform .4s;transition:transform .4s,-webkit-transform .4s;transition:transform .4s}.has-slider .slider-pagination{text-align:center;width:100%;display:inline-block}.has-slider .slider-pagination>*{cursor:pointer;border-radius:50%;-webkit-box-shadow:0 0 0 2px #000;box-shadow:0 0 0 2px #000;display:inline-block;height:6px;margin-left:4px;margin-right:4px;-webkit-transition:opacity .25s;-o-transition:opacity .25s;transition:opacity .25s;width:6px;background:#000;opacity:0}.has-slider .slider-pagination>.is-active{opacity:.75}", "", {"version":3,"sources":["/app/components/custom-carousel/CusCarousel.vue"],"names":[],"mappings":"AAgCA,UACE,UAAY,CACb,AACD,cACE,WAAY,AACZ,kBAAmB,AACnB,eAAiB,CAClB,AACD,IACE,WAAY,AACZ,WAAa,CACd,AACD,YACE,gBAAiB,AACjB,kBAAmB,AACnB,UAAY,CACb,AACD,oBACI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,0BACI,yCAA4C,AAC5C,iCAAoC,AACpC,4BAA+B,AAE/B,+CAAqD,AACrD,wBAA4B,CAC/B,AACD,+BACI,kBAAmB,AACnB,WAAY,AACZ,oBAAsB,CACzB,AACD,iCACM,eAAgB,AAChB,kBAAmB,AACnB,kCAAoC,AAC5B,0BAA4B,AACpC,qBAAsB,AACtB,WAAY,AACZ,gBAAiB,AACjB,iBAAkB,AAClB,gCAAkC,AAClC,2BAA6B,AAC7B,wBAA0B,AAC1B,UAAW,AACX,gBAAoB,AACpB,SAAW,CAChB,AACD,0CACQ,WAAc,CACrB","file":"CusCarousel.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.carousel {\n  width: 100%;\n}\n.slider-panel {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\nimg {\n  width: 100%;\n  height: auto;\n}\n.has-slider {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.has-slider .slider {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.has-slider .is-animating {\n    -webkit-transition: -webkit-transform 400ms;\n    transition: -webkit-transform 400ms;\n    -o-transition: transform 400ms;\n    transition: transform 400ms;\n    transition: transform 400ms, -webkit-transform 400ms;\n    transition: transform 400ms;\n}\n.has-slider .slider-pagination {\n    text-align: center;\n    width: 100%;\n    display: inline-block;\n}\n.has-slider .slider-pagination > * {\n      cursor: pointer;\n      border-radius: 50%;\n      -webkit-box-shadow: 0 0 0 2px black;\n              box-shadow: 0 0 0 2px black;\n      display: inline-block;\n      height: 6px;\n      margin-left: 4px;\n      margin-right: 4px;\n      -webkit-transition: opacity 250ms;\n      -o-transition: opacity 250ms;\n      transition: opacity 250ms;\n      width: 6px;\n      background: #000000;\n      opacity: 0;\n}\n.has-slider .slider-pagination > *.is-active {\n        opacity: 0.75;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".quote[data-v-3c593d01]{position:relative;background-color:#fff}.quote-container[data-v-3c593d01]{font-family:Barlow,sans-serif}.blockquote-quote[data-v-3c593d01]{font-size:1.625rem;line-height:2.0625rem;font-style:italic;-o-border-image:-o-linear-gradient(left,#f8008e,#00e8ff);border-image:-webkit-gradient(linear,left top,right top,from(#f8008e),to(#00e8ff));border-image:linear-gradient(90deg,#f8008e,#00e8ff);border-image-slice:1;border-style:solid;border-width:.1875rem 0 0;margin-top:3.125rem;padding:1.25rem .625rem;color:#f8008e;font-family:Barlow,sans-serif;font-weight:700}.blockquote-quote .quotes[data-v-3c593d01]{position:absolute;top:-2.0625rem;left:.625rem;width:5rem;height:2.75rem}.blockquote-quote .quotes__icon[data-v-3c593d01]{display:inline-block;position:relative;width:2.1875rem;margin-right:.1875rem}.blockquote-quote .quotes__icon:first-child svg[data-v-3c593d01]{fill:#76ffff;-webkit-animation:quoteFlickering 1s step-start infinite alternate;animation:quoteFlickering 1s step-start infinite alternate}.blockquote-quote .quotes__icon:last-child svg[data-v-3c593d01]{fill:#18ffff;-webkit-animation:quoteFlickeringReverse 1s step-start infinite alternate;animation:quoteFlickeringReverse 1s step-start infinite alternate}.blockquote-author[data-v-3c593d01]{color:#00cbcc;padding:0 .625rem 1.25rem;text-transform:uppercase;z-index:2}@media (min-width:1024px){.blockquote-author[data-v-3c593d01]{font-size:.875rem;line-height:1.3125rem;font-weight:400}}@media (min-width:0) and (max-width:1023px){.blockquote-author[data-v-3c593d01]{font-size:.875rem;line-height:1rem}}.blockquote-author .quotes[data-v-3c593d01]{display:none}", "", {"version":3,"sources":["/app/components/node/QuoteBlock.vue"],"names":[],"mappings":"AAgCA,wBACE,kBAAmB,AACnB,qBAA0B,CAC3B,AACD,kCACE,6BAAkC,CACnC,AACD,mCACE,mBAAoB,AACpB,sBAAuB,AACvB,kBAAmB,AACnB,yDAA4D,AACzD,mFAAwF,AACxF,oDAA0D,AAC7D,qBAAsB,AACtB,mBAAoB,AACpB,0BAA8B,AAC9B,oBAAqB,AACrB,wBAA0B,AAC1B,cAAe,AACf,8BAAkC,AAClC,eAAkB,CACnB,AACD,2CACI,kBAAmB,AACnB,eAAgB,AAChB,aAAe,AACf,WAAY,AACZ,cAAgB,CACnB,AACD,iDACM,qBAAsB,AACtB,kBAAmB,AACnB,gBAAiB,AACjB,qBAAwB,CAC7B,AACD,iEACQ,aAAc,AACd,mEAAoE,AAC5D,0DAA4D,CAC3E,AACD,gEACQ,aAAc,AACd,0EAA2E,AACnE,iEAAmE,CAClF,AACD,oCAGE,cAAe,AACf,0BAA4B,AAC5B,yBAA0B,AAC1B,SAAW,CACZ,AACD,0BACA,oCACM,kBAAoB,AACpB,sBAAuB,AACvB,eAAqB,CAC1B,CACA,AACD,4CACA,oCACM,kBAAoB,AACpB,gBAAkB,CACvB,CACA,AACD,4CACI,YAAc,CACjB","file":"QuoteBlock.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.quote[data-v-3c593d01] {\n  position: relative;\n  background-color: #FFFFFF;\n}\n.quote-container[data-v-3c593d01] {\n  font-family: \"Barlow\", sans-serif;\n}\n.blockquote-quote[data-v-3c593d01] {\n  font-size: 1.625rem;\n  line-height: 2.0625rem;\n  font-style: italic;\n  -o-border-image: -o-linear-gradient(left, #F8008E, #00E8FF);\n     border-image: -webkit-gradient(linear, left top, right top, from(#F8008E), to(#00E8FF));\n     border-image: linear-gradient(to right, #F8008E, #00E8FF);\n  border-image-slice: 1;\n  border-style: solid;\n  border-width: 0.1875rem 0 0 0;\n  margin-top: 3.125rem;\n  padding: 1.25rem 0.625rem;\n  color: #F8008E;\n  font-family: \"Barlow\", sans-serif;\n  font-weight: bold;\n}\n.blockquote-quote .quotes[data-v-3c593d01] {\n    position: absolute;\n    top: -2.0625rem;\n    left: 0.625rem;\n    width: 5rem;\n    height: 2.75rem;\n}\n.blockquote-quote .quotes__icon[data-v-3c593d01] {\n      display: inline-block;\n      position: relative;\n      width: 2.1875rem;\n      margin-right: 0.1875rem;\n}\n.blockquote-quote .quotes__icon:first-child svg[data-v-3c593d01] {\n        fill: #76FFFF;\n        -webkit-animation: quoteFlickering 1s step-start infinite alternate;\n                animation: quoteFlickering 1s step-start infinite alternate;\n}\n.blockquote-quote .quotes__icon:last-child svg[data-v-3c593d01] {\n        fill: #18FFFF;\n        -webkit-animation: quoteFlickeringReverse 1s step-start infinite alternate;\n                animation: quoteFlickeringReverse 1s step-start infinite alternate;\n}\n.blockquote-author[data-v-3c593d01] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n  color: #00CBCC;\n  padding: 0 0.625rem 1.25rem;\n  text-transform: uppercase;\n  z-index: 2;\n}\n@media (min-width: 1024px) {\n.blockquote-author[data-v-3c593d01] {\n      font-size: 0.875rem;\n      line-height: 1.3125rem;\n      font-weight: initial;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.blockquote-author[data-v-3c593d01] {\n      font-size: 0.875rem;\n      line-height: 1rem;\n}\n}\n.blockquote-author .quotes[data-v-3c593d01] {\n    display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".blue[data-v-50a5fd5c]{color:#00e8ff;border-color:#00e8ff}.green[data-v-50a5fd5c]{color:#00c078;border-color:#00c078}.yellow[data-v-50a5fd5c]{color:#fceb40;border-color:#fceb40}@-webkit-keyframes toWhiteBorderOne{20%,40%,60%,80%,to{-webkit-transform:scale(0);transform:scale(0)}0%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes toWhiteBorderOne-data-v-50a5fd5c{20%,40%,60%,80%,to{-webkit-transform:scale(0);transform:scale(0)}0%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes toWhiteBorderTwo{0%,40%,60%,80%,to{-webkit-transform:scale(0);transform:scale(0)}20%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes toWhiteBorderTwo-data-v-50a5fd5c{0%,40%,60%,80%,to{-webkit-transform:scale(0);transform:scale(0)}20%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes toWhiteBorderThree{0%,20%,60%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes toWhiteBorderThree-data-v-50a5fd5c{0%,20%,60%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes emailTranslateLeft{50%{-webkit-transform:translateX(-25px);transform:translateX(-25px)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes emailTranslateLeft-data-v-50a5fd5c{50%{-webkit-transform:translateX(-25px);transform:translateX(-25px)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes emailTranslateLeftReverse{50%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-25px);transform:translateX(-25px)}}@keyframes emailTranslateLeftReverse-data-v-50a5fd5c{50%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-25px);transform:translateX(-25px)}}@-webkit-keyframes emailTranslateRight{50%{-webkit-transform:translateX(25px);transform:translateX(25px)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes emailTranslateRight-data-v-50a5fd5c{50%{-webkit-transform:translateX(25px);transform:translateX(25px)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes emailTranslateRightReverse{50%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(25px);transform:translateX(25px)}}@keyframes emailTranslateRightReverse-data-v-50a5fd5c{50%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(25px);transform:translateX(25px)}}@-webkit-keyframes monsterEnvelopTranslate{0%,50%,to{-webkit-transform:translateX(0);transform:translateX(0)}25%{-webkit-transform:translateX(-5px);transform:translateX(-5px)}75%{-webkit-transform:translateX(5px);transform:translateX(5px)}}@keyframes monsterEnvelopTranslate-data-v-50a5fd5c{0%,50%,to{-webkit-transform:translateX(0);transform:translateX(0)}25%{-webkit-transform:translateX(-5px);transform:translateX(-5px)}75%{-webkit-transform:translateX(5px);transform:translateX(5px)}}@-webkit-keyframes frameEnlarge{to{-webkit-transform:scale(1.3);transform:scale(1.3);opacity:0}}@keyframes frameEnlarge-data-v-50a5fd5c{to{-webkit-transform:scale(1.3);transform:scale(1.3);opacity:0}}.monster-newsletter-widget[data-v-50a5fd5c]{position:relative;background-color:#000;padding-top:1.5rem;padding-bottom:4.1875rem;overflow:hidden}.envelopes-wrapper[data-v-50a5fd5c]{margin-top:1.3125rem}.envelopes-wrapper.left .envelope-row[data-v-50a5fd5c]:nth-child(2n){-webkit-transform:translateX(-25px);-ms-transform:translateX(-25px);transform:translateX(-25px)}.envelopes-wrapper.right .envelope-row[data-v-50a5fd5c]:nth-child(2n){-webkit-transform:translateX(25px);-ms-transform:translateX(25px);transform:translateX(25px)}.content-row[data-v-50a5fd5c]{text-align:center;width:87.5rem;left:50%;margin-left:-43.75rem;position:relative}.content-row>div[data-v-50a5fd5c]{vertical-align:top;display:inline-block}.envelope-row[data-v-50a5fd5c]{margin-top:.5rem;margin-bottom:.5rem}.envelope-row .email-icon[data-v-50a5fd5c]:not(.last){margin-right:1.5rem}.envelope-row.animated[data-v-50a5fd5c]{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-delay:0;animation-delay:0;-webkit-animation-duration:6s;animation-duration:6s;-webkit-animation-timing-function:steps(5);animation-timing-function:steps(5)}.envelopes-wrapper.left .envelope-row.animated.odd[data-v-50a5fd5c]{-webkit-animation-name:emailTranslateLeft-data-v-50a5fd5c;animation-name:emailTranslateLeft-data-v-50a5fd5c}#app[data-browser=safari] .envelopes-wrapper.left .envelope-row.animated.odd[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.envelopes-wrapper.left .envelope-row.animated.even[data-v-50a5fd5c]{-webkit-animation-name:emailTranslateLeftReverse-data-v-50a5fd5c;animation-name:emailTranslateLeftReverse-data-v-50a5fd5c}#app[data-browser=safari] .envelopes-wrapper.left .envelope-row.animated.even[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.envelopes-wrapper.right .envelope-row.animated.odd[data-v-50a5fd5c]{-webkit-animation-name:emailTranslateRight-data-v-50a5fd5c;animation-name:emailTranslateRight-data-v-50a5fd5c}#app[data-browser=safari] .envelopes-wrapper.right .envelope-row.animated.odd[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.envelopes-wrapper.right .envelope-row.animated.even[data-v-50a5fd5c]{-webkit-animation-name:emailTranslateRightReverse-data-v-50a5fd5c;animation-name:emailTranslateRightReverse-data-v-50a5fd5c}#app[data-browser=safari] .envelopes-wrapper.right .envelope-row.animated.even[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.rect-wrappers-container[data-v-50a5fd5c]{width:32.5rem;margin-left:1.875rem;margin-right:1.875rem;position:relative}.rect-wrappers-container.animated .rect-wrapper-parent[data-v-50a5fd5c]{width:100%;height:100%}.rect-wrappers-container.animated .rect-wrapper[data-v-50a5fd5c]{-webkit-animation-duration:1.6s;animation-duration:1.6s;-webkit-animation-timing-function:steps(1);animation-timing-function:steps(1);-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-delay:0;animation-delay:0}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-1[data-v-50a5fd5c]{-webkit-animation-name:toWhiteBorderOne-data-v-50a5fd5c;animation-name:toWhiteBorderOne-data-v-50a5fd5c}#app[data-browser=safari] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-1[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-1 .fifth[data-v-50a5fd5c]{border-color:#fff}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-2[data-v-50a5fd5c]{-webkit-animation-name:toWhiteBorderTwo-data-v-50a5fd5c;animation-name:toWhiteBorderTwo-data-v-50a5fd5c}#app[data-browser=safari] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-2[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-2 .forth[data-v-50a5fd5c]{border-color:#fff}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-3[data-v-50a5fd5c]{-webkit-animation-name:toWhiteBorderThree-data-v-50a5fd5c;animation-name:toWhiteBorderThree-data-v-50a5fd5c}#app[data-browser=safari] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-3[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-3 .third[data-v-50a5fd5c]{border-color:#fff}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-4[data-v-50a5fd5c]{-webkit-animation-name:toWhiteBorderTwo-data-v-50a5fd5c;animation-name:toWhiteBorderTwo-data-v-50a5fd5c;animation-direction:reverse}#app[data-browser=safari] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-4[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-4 .second[data-v-50a5fd5c]{border-color:#fff}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-5[data-v-50a5fd5c]{-webkit-animation-name:toWhiteBorderOne-data-v-50a5fd5c;animation-name:toWhiteBorderOne-data-v-50a5fd5c;animation-direction:reverse}#app[data-browser=safari] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-5[data-v-50a5fd5c]{-webkit-animation-name:none;animation-name:none}.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-5.first[data-v-50a5fd5c]{border-color:#fff}.rect-wrappers-container.animated .rect-wrapper.first[data-v-50a5fd5c]{position:absolute;top:0;left:0;width:100%}.rect-wrappers-container.subscribe-animated .rect-wrapper-content[data-v-50a5fd5c]{opacity:0}.rect-wrappers-container.subscribe-animated .monster-wrappers[data-v-50a5fd5c]{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.rect-wrappers-container.subscribe-animated .monster-email-row[data-v-50a5fd5c],.rect-wrappers-container.subscribe-animated .monster-icon[data-v-50a5fd5c]{-webkit-animation-name:monsterEnvelopTranslate-data-v-50a5fd5c;animation-name:monsterEnvelopTranslate-data-v-50a5fd5c;-webkit-animation-duration:2.4s;animation-duration:2.4s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:steps(1);animation-timing-function:steps(1);-webkit-animation-delay:1s;animation-delay:1s}.rect-wrappers-container.subscribe-animated .monster-email-row[data-v-50a5fd5c]{-webkit-animation-delay:2.2s;animation-delay:2.2s}.rect-wrappers-container.subscribe-animated .message-content[data-v-50a5fd5c],.rect-wrappers-container.subscribe-animated .message-headline[data-v-50a5fd5c]{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}.rect-wrappers-container.subscribe-animated .rect-wrapper-frame-1[data-v-50a5fd5c]{position:absolute;top:0;left:0;width:100%}.rect-wrappers-container.subscribe-animated .rect-wrapper-frame-2[data-v-50a5fd5c],.rect-wrappers-container.subscribe-animated .rect-wrapper-frame-3[data-v-50a5fd5c],.rect-wrappers-container.subscribe-animated .rect-wrapper-frame-4[data-v-50a5fd5c],.rect-wrappers-container.subscribe-animated .rect-wrapper-frame-5[data-v-50a5fd5c]{display:none}.rect-wrappers-container.subscribe-animated .rect-wrapper[data-v-50a5fd5c]{-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-timing-function:ease;animation-timing-function:ease;-webkit-animation-delay:0;animation-delay:0;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-name:frameEnlarge-data-v-50a5fd5c;animation-name:frameEnlarge-data-v-50a5fd5c}.rect-wrappers-container.subscribe-animated .rect-wrapper.first[data-v-50a5fd5c]{-webkit-animation-delay:.4s;animation-delay:.4s}.rect-wrappers-container.subscribe-animated .rect-wrapper.second[data-v-50a5fd5c]{-webkit-animation-delay:.3s;animation-delay:.3s}.rect-wrappers-container.subscribe-animated .rect-wrapper.third[data-v-50a5fd5c]{-webkit-animation-delay:.2s;animation-delay:.2s}.rect-wrappers-container.subscribe-animated .rect-wrapper.forth[data-v-50a5fd5c]{-webkit-animation-delay:.1s;animation-delay:.1s}.rect-wrapper-content[data-v-50a5fd5c]{overflow:hidden;font-family:Silkscreen,sans-serif;opacity:1;-webkit-transition:all .6s ease-in-out;-o-transition:all .6s ease-in-out;transition:all .6s ease-in-out;padding:4.0625rem 0}.rect-wrapper-content .brand-title[data-v-50a5fd5c]{font-family:\"04bregular\";font-size:1.5rem;line-height:1.5rem;margin-bottom:.25rem;color:#f8008e}.rect-wrapper-content .newsletter-type[data-v-50a5fd5c]{font-size:2rem;line-height:1.6875rem;font-weight:700;text-shadow:.125rem .125rem 0 #f8008e;margin-bottom:.4375rem}.rect-wrapper-content .newsletter-title[data-v-50a5fd5c]{font-size:1.5rem;line-height:1.5rem}.rect-wrapper[data-v-50a5fd5c]{border-style:solid;opacity:1}.rect-wrapper.first[data-v-50a5fd5c]{border-width:.375rem;padding:.625rem 1.25rem .5625rem}.rect-wrapper.second[data-v-50a5fd5c]{border-width:.25rem;padding:.5625rem 1.25rem}.rect-wrapper.third[data-v-50a5fd5c]{border-width:.1875rem;padding:.625rem .875rem}.rect-wrapper.forth[data-v-50a5fd5c]{border-width:.125rem;padding:.625rem .875rem}.rect-wrapper.fifth[data-v-50a5fd5c]{border-width:.0625rem;padding-top:.6875rem;padding-bottom:.5625rem;height:108px}.monster-wrappers[data-v-50a5fd5c]{position:absolute;width:100%;text-align:center;-webkit-transform:translateY(-140px);-ms-transform:translateY(-140px);transform:translateY(-140px);margin-top:-1.5625rem;-webkit-transition:-webkit-transform 1s ease 1s;transition:-webkit-transform 1s ease 1s;-o-transition:transform 1s ease 1s;transition:transform 1s ease 1s;transition:transform 1s ease 1s,-webkit-transform 1s ease 1s}.monster-wrappers .monster-content[data-v-50a5fd5c]{display:inline-block;position:relative;margin-bottom:.625rem;z-index:1;width:24.625rem;height:9rem}.monster-wrappers .monster-icon[data-v-50a5fd5c]{position:absolute}.monster-wrappers .monster-email-row[data-v-50a5fd5c]{position:absolute;bottom:0;top:35%;left:0;width:100%}.monster-wrappers .monster-email-row svg[data-v-50a5fd5c]{margin:0 1.9375rem}.monster-wrappers .message-content[data-v-50a5fd5c],.monster-wrappers .message-headline[data-v-50a5fd5c]{font-family:Silkscreen,sans-serif;text-transform:uppercase;max-width:14.8125rem;margin:0 auto}.monster-wrappers .message-headline[data-v-50a5fd5c]{font-size:2rem;line-height:1.6875rem;font-weight:700;text-shadow:.125rem .125rem 0 #f8008e;-webkit-transform:translate(-40px,-110px);-ms-transform:translate(-40px,-110px);transform:translate(-40px,-110px);-webkit-transition:-webkit-transform .5s ease-in-out 2.6s;transition:-webkit-transform .5s ease-in-out 2.6s;-o-transition:transform .5s ease-in-out 2.6s;transition:transform .5s ease-in-out 2.6s;transition:transform .5s ease-in-out 2.6s,-webkit-transform .5s ease-in-out 2.6s;margin-bottom:.5rem}.monster-wrappers .message-content[data-v-50a5fd5c]{font-size:1.5rem;line-height:1.5rem;-webkit-transform:translate(30px,-160px);-ms-transform:translate(30px,-160px);transform:translate(30px,-160px);-webkit-transition:-webkit-transform .5s ease-in-out 2.5s;transition:-webkit-transform .5s ease-in-out 2.5s;-o-transition:transform .5s ease-in-out 2.5s;transition:transform .5s ease-in-out 2.5s;transition:transform .5s ease-in-out 2.5s,-webkit-transform .5s ease-in-out 2.5s}.warning[data-v-50a5fd5c]{height:2.1875rem;margin-top:3.25rem}.warning div[data-v-50a5fd5c]{font-family:Barlow,sans-serif;font-size:.75rem;line-height:.875rem}.notification.warning-color[data-v-50a5fd5c]{background:#ff5cbe}@media (min-width:1024px){.notification.warning-color[data-v-50a5fd5c]{margin-left:-50vw;margin-right:-50vw}.notification.warning-color>div[data-v-50a5fd5c]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:700;color:#fff;font-size:.875rem}}input.warning-color[data-v-50a5fd5c]{color:#ff5cbe}.newsletter-form[data-v-50a5fd5c]{position:absolute;bottom:0;left:0;right:0;margin:0 auto;z-index:2;top:11.875rem;max-width:21.6875rem}.newsletter-form .input-email[data-v-50a5fd5c]{font-family:Barlow,sans-serif;font-size:1.5rem;border-radius:unset;border-bottom:3px solid #979797}.newsletter-form .input-email[data-v-50a5fd5c]::-webkit-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter-form .input-email[data-v-50a5fd5c]::-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter-form .input-email[data-v-50a5fd5c]:-ms-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter-form .input-email[data-v-50a5fd5c]:-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter-form .form-input[data-v-50a5fd5c]{margin:4px;background:#fff;padding:0;-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%;z-index:3}.newsletter-form .form-btn[data-v-50a5fd5c],.newsletter-form .form-input[data-v-50a5fd5c]{-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;-webkit-box-flex:0;position:absolute;left:0;right:0;top:0}.newsletter-form .form-btn[data-v-50a5fd5c]{width:7.1875rem;border:4px solid #f8008e;border-left:none;background:#f8008e;-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%;-webkit-box-sizing:content-box;box-sizing:content-box;padding-left:13.25rem;height:1.75rem;text-align:right}.newsletter-form .form-btn[data-v-50a5fd5c]:hover{border-color:#ff5cbe;background-color:#ff5cbe}@media (min-width:0) and (max-width:1023px){.newsletter-form .form-btn[data-v-50a5fd5c]:hover{background:#bf0061;border-color:#bf0061}}.newsletter-form .form-btn[data-v-50a5fd5c]:focus{border-color:#bf0061;background-color:#bf0061}.newsletter-form input[data-v-50a5fd5c]{caret-color:#f8008e;outline-width:.125rem;height:2.8125rem}.newsletter-form .submit-newsletter[data-v-50a5fd5c]{background:#f8008e;border-radius:unset;font-size:1.25rem;color:#fff;font-family:Silkscreen,sans-serif}.newsletter-form .submit-newsletter[data-v-50a5fd5c]:focus{-webkit-box-shadow:none;box-shadow:none}.newsletter-form .submit-newsletter span[data-v-50a5fd5c]{font-size:1.25rem;color:#fff;font-family:Silkscreen,sans-serif}", "", {"version":3,"sources":["/app/components/widgets/MonsterNewsletterFormDesktop.vue"],"names":[],"mappings":"AAgCA,uBACE,cAAe,AACf,oBAAsB,CACvB,AACD,wBACE,cAAe,AACf,oBAAsB,CACvB,AACD,yBACE,cAAe,AACf,oBAAsB,CACvB,AACD,oCACA,mBACI,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,GACI,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,4CACA,mBACI,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,GACI,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,oCACA,kBACI,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,IACI,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,4CACA,kBACI,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,IACI,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,sCACA,kBACI,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,IACI,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,8CACA,kBACI,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,IACI,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,sCACA,IACI,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,8CACA,IACI,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,6CACA,IACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,GACI,oCAAqC,AAC7B,2BAA6B,CACxC,CACA,AACD,qDACA,IACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,GACI,oCAAqC,AAC7B,2BAA6B,CACxC,CACA,AACD,uCACA,IACI,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,+CACA,IACI,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,8CACA,IACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,GACI,mCAAoC,AAC5B,0BAA4B,CACvC,CACA,AACD,sDACA,IACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,GACI,mCAAoC,AAC5B,0BAA4B,CACvC,CACA,AACD,2CACA,UACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,IACI,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,IACI,kCAAmC,AAC3B,yBAA2B,CACtC,CACA,AACD,mDACA,UACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,IACI,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,IACI,kCAAmC,AAC3B,yBAA2B,CACtC,CACA,AACD,gCACA,GACI,6BAA8B,AACtB,qBAAsB,AAC9B,SAAW,CACd,CACA,AACD,wCACA,GACI,6BAA8B,AACtB,qBAAsB,AAC9B,SAAW,CACd,CACA,AACD,4CACE,kBAAmB,AACnB,sBAA0B,AAC1B,mBAAoB,AACpB,yBAA0B,AAC1B,eAAiB,CAClB,AAID,oCACE,oBAAsB,CACvB,AACD,qEACI,oCAAqC,AACjC,gCAAiC,AAC7B,2BAA6B,CACxC,AACD,sEACI,mCAAoC,AAChC,+BAAgC,AAC5B,0BAA4B,CACvC,AACD,8BACE,kBAAmB,AACnB,cAAe,AACf,SAAU,AACV,sBAAuB,AACvB,iBAAmB,CACpB,AACD,kCACI,mBAAoB,AACpB,oBAAsB,CACzB,AACD,+BACE,iBAAmB,AACnB,mBAAsB,CACvB,AACD,sDACI,mBAAqB,CACxB,AACD,wCACI,2CAA4C,AACpC,mCAAoC,AAC5C,0BAA2B,AACnB,kBAAmB,AAC3B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAAiD,AACzC,kCAAyC,CACpD,AACD,oEACE,0DAA2D,AACnD,iDAAmD,CAC5D,AACD,8FACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,qEACE,iEAAkE,AAC1D,wDAA0D,CACnE,AACD,+FACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,qEACE,2DAA4D,AACpD,kDAAoD,CAC7D,AACD,+FACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,sEACE,kEAAmE,AAC3D,yDAA2D,CACpE,AACD,gGACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,0CACE,cAAe,AACf,qBAAsB,AACtB,sBAAuB,AACvB,iBAAmB,CACpB,AACD,wEACI,WAAY,AACZ,WAAa,CAChB,AACD,iEACI,gCAAiC,AACzB,wBAAyB,AACjC,2CAAiD,AACzC,mCAAyC,AACjD,2CAA4C,AACpC,mCAAoC,AAC5C,0BAA2B,AACnB,iBAAmB,CAC9B,AACD,sFACM,wDAAyD,AACjD,+CAAiD,CAC9D,AACD,gHACQ,4BAA6B,AACrB,mBAAqB,CACpC,AACD,6FACQ,iBAAsB,CAC7B,AACD,sFACM,wDAAyD,AACjD,+CAAiD,CAC9D,AACD,gHACQ,4BAA6B,AACrB,mBAAqB,CACpC,AACD,6FACQ,iBAAsB,CAC7B,AACD,sFACM,0DAA2D,AACnD,iDAAmD,CAChE,AACD,gHACQ,4BAA6B,AACrB,mBAAqB,CACpC,AACD,6FACQ,iBAAsB,CAC7B,AACD,sFACM,wDAAyD,AACjD,gDAAiD,AACzD,2BAA6B,CAClC,AACD,gHACQ,4BAA6B,AACrB,mBAAqB,CACpC,AACD,8FACQ,iBAAsB,CAC7B,AACD,sFACM,wDAAyD,AACjD,gDAAiD,AACzD,2BAA6B,CAClC,AACD,gHACQ,4BAA6B,AACrB,mBAAqB,CACpC,AACD,4FACQ,iBAAsB,CAC7B,AACD,uEACM,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,UAAY,CACjB,AACD,mFACI,SAAW,CACd,AACD,+EACI,gCAAiC,AAC7B,4BAA6B,AACzB,uBAAyB,CACpC,AACD,2JAEI,+DAAgE,AACxD,uDAAwD,AAChE,gCAAiC,AACzB,wBAAyB,AACjC,2CAA4C,AACpC,mCAAoC,AAC5C,2CAAiD,AACzC,mCAAyC,AACjD,2BAA4B,AACpB,kBAAoB,CAC/B,AACD,gFACI,6BAA8B,AACtB,oBAAsB,CACjC,AACD,6JAEI,+BAAmC,AAC/B,2BAA+B,AAC3B,sBAA2B,CACtC,AACD,mFACI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,UAAY,CACf,AACD,4UAII,YAAc,CACjB,AACD,2EACI,+BAAgC,AACxB,uBAAwB,AAChC,uCAAwC,AAChC,+BAAgC,AACxC,0BAA2B,AACnB,kBAAmB,AAC3B,qCAAsC,AAC9B,6BAA8B,AACtC,oDAAqD,AAC7C,2CAA6C,CACxD,AACD,iFACM,4BAA6B,AACrB,mBAAqB,CAClC,AACD,kFACM,4BAA6B,AACrB,mBAAqB,CAClC,AACD,iFACM,4BAA6B,AACrB,mBAAqB,CAClC,AACD,iFACM,4BAA6B,AACrB,mBAAqB,CAClC,AACD,uCACE,gBAAiB,AACjB,kCAAoC,AACpC,UAAW,AACX,uCAAwC,AACxC,kCAAmC,AACnC,+BAAgC,AAChC,mBAAqB,CACtB,AACD,oDACI,yBAA0B,AAC1B,iBAAkB,AAClB,mBAAoB,AACpB,qBAAuB,AACvB,aAAe,CAClB,AACD,wDACI,eAAgB,AAChB,sBAAuB,AACvB,gBAAkB,AAClB,sCAAyC,AACzC,sBAAyB,CAC5B,AACD,yDACI,iBAAkB,AAClB,kBAAoB,CACvB,AACD,+BACE,mBAAoB,AACpB,SAAW,CACZ,AACD,qCACI,qBAAuB,AACvB,gCAAoC,CACvC,AACD,sCACI,oBAAsB,AACtB,wBAA2B,CAC9B,AACD,qCACI,sBAAwB,AACxB,uBAA2B,CAC9B,AACD,qCACI,qBAAuB,AACvB,uBAA2B,CAC9B,AACD,qCACI,sBAAwB,AACxB,qBAAuB,AACvB,wBAA0B,AAC1B,YAAc,CACjB,AACD,mCACE,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,qCAAsC,AAClC,iCAAkC,AAC9B,6BAA8B,AACtC,sBAAuB,AACvB,gDAAiD,AACjD,wCAAyC,AACzC,mCAAoC,AACpC,gCAAiC,AACjC,4DAA+D,CAChE,AACD,oDACI,qBAAsB,AACtB,kBAAmB,AACnB,sBAAwB,AACxB,UAAW,AACX,gBAAiB,AACjB,WAAa,CAChB,AACD,iDACI,iBAAmB,CACtB,AACD,sDACI,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,OAAQ,AACR,UAAY,CACf,AACD,0DACM,kBAAoB,CACzB,AACD,yGAEI,kCAAoC,AACpC,yBAA0B,AAC1B,qBAAsB,AACtB,aAAe,CAClB,AACD,qDACI,eAAgB,AAChB,sBAAuB,AACvB,gBAAkB,AAClB,sCAAyC,AACzC,0CAA4C,AACxC,sCAAwC,AACpC,kCAAoC,AAC5C,0DAA2D,AAC3D,kDAAmD,AACnD,6CAA8C,AAC9C,0CAA2C,AAC3C,iFAAmF,AACnF,mBAAsB,CACzB,AACD,oDACI,iBAAkB,AAClB,mBAAoB,AACpB,yCAA2C,AACvC,qCAAuC,AACnC,iCAAmC,AAC3C,0DAA2D,AAC3D,kDAAmD,AACnD,6CAA8C,AAC9C,0CAA2C,AAC3C,gFAAmF,CACtF,AACD,0BACE,iBAAkB,AAClB,kBAAoB,CACrB,AACD,8BACI,8BAAkC,AAClC,iBAAmB,AACnB,mBAAsB,CACzB,AACD,6CACE,kBAAoB,CAErB,AACD,0BACA,6CACM,kBAAmB,AACnB,kBAAoB,CACzB,AACD,iDACQ,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAkB,AAClB,WAAe,AACf,iBAAoB,CAC3B,CACA,AACD,qCACE,aAAe,CAChB,AACD,kCACE,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,UAAW,AACX,cAAe,AACf,oBAAsB,CACvB,AACD,+CACI,8BAAkC,AAClC,iBAAkB,AAClB,oBAAqB,AACrB,+BAAiC,CACpC,AACD,0EAEM,WAAe,AACf,kBAAqB,CAC1B,AACD,iEAEM,WAAe,AACf,kBAAqB,CAC1B,AACD,qEAEM,WAAe,AACf,kBAAqB,CAC1B,AACD,gEAEM,WAAe,AACf,kBAAqB,CAC1B,AACD,8CACI,WAAY,AACZ,gBAAoB,AACpB,UAAW,AAKX,wBAAyB,AACzB,oBAAqB,AACrB,qBAAsB,AAEtB,SAAW,CAId,AACD,0FAbI,uCAAyC,AACzC,kCAAoC,AACpC,+BAAiC,AACjC,mBAAoB,AAIpB,kBAAmB,AAEnB,OAAQ,AACR,QAAS,AACT,KAAO,CAuBV,AArBD,4CACI,gBAAiB,AACjB,yBAA0B,AAC1B,iBAAkB,AAClB,mBAAoB,AAKpB,wBAAyB,AACzB,oBAAqB,AACrB,qBAAsB,AACtB,+BAAgC,AACxB,uBAAwB,AAChC,sBAAuB,AAKvB,eAAgB,AAChB,gBAAkB,CACrB,AACD,kDACM,qBAAsB,AACtB,wBAA0B,CAE/B,AACD,4CACA,kDACU,mBAAoB,AACpB,oBAAsB,CAC/B,CACA,AACD,kDACM,qBAAsB,AACtB,wBAA0B,CAC/B,AACD,wCACI,oBAAqB,AACrB,sBAAwB,AACxB,gBAAkB,CACrB,AACD,qDACI,mBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,WAAe,AACf,iCAAoC,CACvC,AACD,2DACM,wBAAyB,AACjB,eAAiB,CAC9B,AACD,0DACM,kBAAmB,AACnB,WAAe,AACf,iCAAoC,CACzC","file":"MonsterNewsletterFormDesktop.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.blue[data-v-50a5fd5c] {\n  color: #00E8FF;\n  border-color: #00E8FF;\n}\n.green[data-v-50a5fd5c] {\n  color: #00C078;\n  border-color: #00C078;\n}\n.yellow[data-v-50a5fd5c] {\n  color: #FCEB40;\n  border-color: #FCEB40;\n}\n@-webkit-keyframes toWhiteBorderOne {\n20%, 40%, 60%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@keyframes toWhiteBorderOne-data-v-50a5fd5c {\n20%, 40%, 60%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@-webkit-keyframes toWhiteBorderTwo {\n0%, 40%, 60%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n20% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@keyframes toWhiteBorderTwo-data-v-50a5fd5c {\n0%, 40%, 60%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n20% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@-webkit-keyframes toWhiteBorderThree {\n0%, 20%, 60%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n40% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@keyframes toWhiteBorderThree-data-v-50a5fd5c {\n0%, 20%, 60%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n}\n40% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@-webkit-keyframes emailTranslateLeft {\n50% {\n    -webkit-transform: translateX(-25px);\n            transform: translateX(-25px);\n}\n100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@keyframes emailTranslateLeft-data-v-50a5fd5c {\n50% {\n    -webkit-transform: translateX(-25px);\n            transform: translateX(-25px);\n}\n100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@-webkit-keyframes emailTranslateLeftReverse {\n50% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n100% {\n    -webkit-transform: translateX(-25px);\n            transform: translateX(-25px);\n}\n}\n@keyframes emailTranslateLeftReverse-data-v-50a5fd5c {\n50% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n100% {\n    -webkit-transform: translateX(-25px);\n            transform: translateX(-25px);\n}\n}\n@-webkit-keyframes emailTranslateRight {\n50% {\n    -webkit-transform: translateX(25px);\n            transform: translateX(25px);\n}\n100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@keyframes emailTranslateRight-data-v-50a5fd5c {\n50% {\n    -webkit-transform: translateX(25px);\n            transform: translateX(25px);\n}\n100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@-webkit-keyframes emailTranslateRightReverse {\n50% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n100% {\n    -webkit-transform: translateX(25px);\n            transform: translateX(25px);\n}\n}\n@keyframes emailTranslateRightReverse-data-v-50a5fd5c {\n50% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n100% {\n    -webkit-transform: translateX(25px);\n            transform: translateX(25px);\n}\n}\n@-webkit-keyframes monsterEnvelopTranslate {\n0%, 50%, 100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n25% {\n    -webkit-transform: translateX(-5px);\n            transform: translateX(-5px);\n}\n75% {\n    -webkit-transform: translateX(5px);\n            transform: translateX(5px);\n}\n}\n@keyframes monsterEnvelopTranslate-data-v-50a5fd5c {\n0%, 50%, 100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n25% {\n    -webkit-transform: translateX(-5px);\n            transform: translateX(-5px);\n}\n75% {\n    -webkit-transform: translateX(5px);\n            transform: translateX(5px);\n}\n}\n@-webkit-keyframes frameEnlarge {\nto {\n    -webkit-transform: scale(1.3);\n            transform: scale(1.3);\n    opacity: 0;\n}\n}\n@keyframes frameEnlarge-data-v-50a5fd5c {\nto {\n    -webkit-transform: scale(1.3);\n            transform: scale(1.3);\n    opacity: 0;\n}\n}\n.monster-newsletter-widget[data-v-50a5fd5c] {\n  position: relative;\n  background-color: #000000;\n  padding-top: 1.5rem;\n  padding-bottom: 4.1875rem;\n  overflow: hidden;\n}\n.newsletter-form[data-v-50a5fd5c] {\n  position: absolute;\n}\n.envelopes-wrapper[data-v-50a5fd5c] {\n  margin-top: 1.3125rem;\n}\n.envelopes-wrapper.left .envelope-row[data-v-50a5fd5c]:nth-child(even) {\n    -webkit-transform: translateX(-25px);\n        -ms-transform: translateX(-25px);\n            transform: translateX(-25px);\n}\n.envelopes-wrapper.right .envelope-row[data-v-50a5fd5c]:nth-child(even) {\n    -webkit-transform: translateX(25px);\n        -ms-transform: translateX(25px);\n            transform: translateX(25px);\n}\n.content-row[data-v-50a5fd5c] {\n  text-align: center;\n  width: 87.5rem;\n  left: 50%;\n  margin-left: -43.75rem;\n  position: relative;\n}\n.content-row > div[data-v-50a5fd5c] {\n    vertical-align: top;\n    display: inline-block;\n}\n.envelope-row[data-v-50a5fd5c] {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.envelope-row .email-icon[data-v-50a5fd5c]:not(.last) {\n    margin-right: 1.5rem;\n}\n.envelope-row.animated[data-v-50a5fd5c] {\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n    -webkit-animation-delay: 0;\n            animation-delay: 0;\n    -webkit-animation-duration: 6s;\n            animation-duration: 6s;\n    -webkit-animation-timing-function: steps(5, end);\n            animation-timing-function: steps(5, end);\n}\n.envelopes-wrapper.left .envelope-row.animated.odd[data-v-50a5fd5c] {\n  -webkit-animation-name: emailTranslateLeft-data-v-50a5fd5c;\n          animation-name: emailTranslateLeft-data-v-50a5fd5c;\n}\n#app[data-browser=\"safari\"] .envelopes-wrapper.left .envelope-row.animated.odd[data-v-50a5fd5c] {\n    -webkit-animation-name: none;\n            animation-name: none;\n}\n.envelopes-wrapper.left .envelope-row.animated.even[data-v-50a5fd5c] {\n  -webkit-animation-name: emailTranslateLeftReverse-data-v-50a5fd5c;\n          animation-name: emailTranslateLeftReverse-data-v-50a5fd5c;\n}\n#app[data-browser=\"safari\"] .envelopes-wrapper.left .envelope-row.animated.even[data-v-50a5fd5c] {\n    -webkit-animation-name: none;\n            animation-name: none;\n}\n.envelopes-wrapper.right .envelope-row.animated.odd[data-v-50a5fd5c] {\n  -webkit-animation-name: emailTranslateRight-data-v-50a5fd5c;\n          animation-name: emailTranslateRight-data-v-50a5fd5c;\n}\n#app[data-browser=\"safari\"] .envelopes-wrapper.right .envelope-row.animated.odd[data-v-50a5fd5c] {\n    -webkit-animation-name: none;\n            animation-name: none;\n}\n.envelopes-wrapper.right .envelope-row.animated.even[data-v-50a5fd5c] {\n  -webkit-animation-name: emailTranslateRightReverse-data-v-50a5fd5c;\n          animation-name: emailTranslateRightReverse-data-v-50a5fd5c;\n}\n#app[data-browser=\"safari\"] .envelopes-wrapper.right .envelope-row.animated.even[data-v-50a5fd5c] {\n    -webkit-animation-name: none;\n            animation-name: none;\n}\n.rect-wrappers-container[data-v-50a5fd5c] {\n  width: 32.5rem;\n  margin-left: 1.875rem;\n  margin-right: 1.875rem;\n  position: relative;\n}\n.rect-wrappers-container.animated .rect-wrapper-parent[data-v-50a5fd5c] {\n    width: 100%;\n    height: 100%;\n}\n.rect-wrappers-container.animated .rect-wrapper[data-v-50a5fd5c] {\n    -webkit-animation-duration: 1.6s;\n            animation-duration: 1.6s;\n    -webkit-animation-timing-function: steps(1, end);\n            animation-timing-function: steps(1, end);\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n    -webkit-animation-delay: 0;\n            animation-delay: 0;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-1[data-v-50a5fd5c] {\n      -webkit-animation-name: toWhiteBorderOne-data-v-50a5fd5c;\n              animation-name: toWhiteBorderOne-data-v-50a5fd5c;\n}\n#app[data-browser=\"safari\"] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-1[data-v-50a5fd5c] {\n        -webkit-animation-name: none;\n                animation-name: none;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-1 .fifth[data-v-50a5fd5c] {\n        border-color: #FFFFFF;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-2[data-v-50a5fd5c] {\n      -webkit-animation-name: toWhiteBorderTwo-data-v-50a5fd5c;\n              animation-name: toWhiteBorderTwo-data-v-50a5fd5c;\n}\n#app[data-browser=\"safari\"] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-2[data-v-50a5fd5c] {\n        -webkit-animation-name: none;\n                animation-name: none;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-2 .forth[data-v-50a5fd5c] {\n        border-color: #FFFFFF;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-3[data-v-50a5fd5c] {\n      -webkit-animation-name: toWhiteBorderThree-data-v-50a5fd5c;\n              animation-name: toWhiteBorderThree-data-v-50a5fd5c;\n}\n#app[data-browser=\"safari\"] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-3[data-v-50a5fd5c] {\n        -webkit-animation-name: none;\n                animation-name: none;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-3 .third[data-v-50a5fd5c] {\n        border-color: #FFFFFF;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-4[data-v-50a5fd5c] {\n      -webkit-animation-name: toWhiteBorderTwo-data-v-50a5fd5c;\n              animation-name: toWhiteBorderTwo-data-v-50a5fd5c;\n      animation-direction: reverse;\n}\n#app[data-browser=\"safari\"] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-4[data-v-50a5fd5c] {\n        -webkit-animation-name: none;\n                animation-name: none;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-4 .second[data-v-50a5fd5c] {\n        border-color: #FFFFFF;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-5[data-v-50a5fd5c] {\n      -webkit-animation-name: toWhiteBorderOne-data-v-50a5fd5c;\n              animation-name: toWhiteBorderOne-data-v-50a5fd5c;\n      animation-direction: reverse;\n}\n#app[data-browser=\"safari\"] .rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-5[data-v-50a5fd5c] {\n        -webkit-animation-name: none;\n                animation-name: none;\n}\n.rect-wrappers-container.animated .rect-wrapper.rect-wrapper-frame-5.first[data-v-50a5fd5c] {\n        border-color: #FFFFFF;\n}\n.rect-wrappers-container.animated .rect-wrapper.first[data-v-50a5fd5c] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper-content[data-v-50a5fd5c] {\n    opacity: 0;\n}\n.rect-wrappers-container.subscribe-animated .monster-wrappers[data-v-50a5fd5c] {\n    -webkit-transform: translateY(0);\n        -ms-transform: translateY(0);\n            transform: translateY(0);\n}\n.rect-wrappers-container.subscribe-animated .monster-icon[data-v-50a5fd5c],\n  .rect-wrappers-container.subscribe-animated .monster-email-row[data-v-50a5fd5c] {\n    -webkit-animation-name: monsterEnvelopTranslate-data-v-50a5fd5c;\n            animation-name: monsterEnvelopTranslate-data-v-50a5fd5c;\n    -webkit-animation-duration: 2.4s;\n            animation-duration: 2.4s;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n    -webkit-animation-timing-function: steps(1, end);\n            animation-timing-function: steps(1, end);\n    -webkit-animation-delay: 1s;\n            animation-delay: 1s;\n}\n.rect-wrappers-container.subscribe-animated .monster-email-row[data-v-50a5fd5c] {\n    -webkit-animation-delay: 2.2s;\n            animation-delay: 2.2s;\n}\n.rect-wrappers-container.subscribe-animated .message-headline[data-v-50a5fd5c],\n  .rect-wrappers-container.subscribe-animated .message-content[data-v-50a5fd5c] {\n    -webkit-transform: translate(0, 0);\n        -ms-transform: translate(0, 0);\n            transform: translate(0, 0);\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper-frame-1[data-v-50a5fd5c] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper-frame-2[data-v-50a5fd5c],\n  .rect-wrappers-container.subscribe-animated .rect-wrapper-frame-3[data-v-50a5fd5c],\n  .rect-wrappers-container.subscribe-animated .rect-wrapper-frame-4[data-v-50a5fd5c],\n  .rect-wrappers-container.subscribe-animated .rect-wrapper-frame-5[data-v-50a5fd5c] {\n    display: none;\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper[data-v-50a5fd5c] {\n    -webkit-animation-duration: .2s;\n            animation-duration: .2s;\n    -webkit-animation-timing-function: ease;\n            animation-timing-function: ease;\n    -webkit-animation-delay: 0;\n            animation-delay: 0;\n    -webkit-animation-fill-mode: forwards;\n            animation-fill-mode: forwards;\n    -webkit-animation-name: frameEnlarge-data-v-50a5fd5c;\n            animation-name: frameEnlarge-data-v-50a5fd5c;\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper.first[data-v-50a5fd5c] {\n      -webkit-animation-delay: .4s;\n              animation-delay: .4s;\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper.second[data-v-50a5fd5c] {\n      -webkit-animation-delay: .3s;\n              animation-delay: .3s;\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper.third[data-v-50a5fd5c] {\n      -webkit-animation-delay: .2s;\n              animation-delay: .2s;\n}\n.rect-wrappers-container.subscribe-animated .rect-wrapper.forth[data-v-50a5fd5c] {\n      -webkit-animation-delay: .1s;\n              animation-delay: .1s;\n}\n.rect-wrapper-content[data-v-50a5fd5c] {\n  overflow: hidden;\n  font-family: Silkscreen, sans-serif;\n  opacity: 1;\n  -webkit-transition: all .6s ease-in-out;\n  -o-transition: all .6s ease-in-out;\n  transition: all .6s ease-in-out;\n  padding: 4.0625rem 0;\n}\n.rect-wrapper-content .brand-title[data-v-50a5fd5c] {\n    font-family: \"04bregular\";\n    font-size: 1.5rem;\n    line-height: 1.5rem;\n    margin-bottom: 0.25rem;\n    color: #F8008E;\n}\n.rect-wrapper-content .newsletter-type[data-v-50a5fd5c] {\n    font-size: 2rem;\n    line-height: 1.6875rem;\n    font-weight: bold;\n    text-shadow: 0.125rem 0.125rem 0 #F8008E;\n    margin-bottom: 0.4375rem;\n}\n.rect-wrapper-content .newsletter-title[data-v-50a5fd5c] {\n    font-size: 1.5rem;\n    line-height: 1.5rem;\n}\n.rect-wrapper[data-v-50a5fd5c] {\n  border-style: solid;\n  opacity: 1;\n}\n.rect-wrapper.first[data-v-50a5fd5c] {\n    border-width: 0.375rem;\n    padding: 0.625rem 1.25rem 0.5625rem;\n}\n.rect-wrapper.second[data-v-50a5fd5c] {\n    border-width: 0.25rem;\n    padding: 0.5625rem 1.25rem;\n}\n.rect-wrapper.third[data-v-50a5fd5c] {\n    border-width: 0.1875rem;\n    padding: 0.625rem 0.875rem;\n}\n.rect-wrapper.forth[data-v-50a5fd5c] {\n    border-width: 0.125rem;\n    padding: 0.625rem 0.875rem;\n}\n.rect-wrapper.fifth[data-v-50a5fd5c] {\n    border-width: 0.0625rem;\n    padding-top: 0.6875rem;\n    padding-bottom: 0.5625rem;\n    height: 108px;\n}\n.monster-wrappers[data-v-50a5fd5c] {\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  -webkit-transform: translateY(-140px);\n      -ms-transform: translateY(-140px);\n          transform: translateY(-140px);\n  margin-top: -1.5625rem;\n  -webkit-transition: -webkit-transform 1s ease 1s;\n  transition: -webkit-transform 1s ease 1s;\n  -o-transition: transform 1s ease 1s;\n  transition: transform 1s ease 1s;\n  transition: transform 1s ease 1s, -webkit-transform 1s ease 1s;\n}\n.monster-wrappers .monster-content[data-v-50a5fd5c] {\n    display: inline-block;\n    position: relative;\n    margin-bottom: 0.625rem;\n    z-index: 1;\n    width: 24.625rem;\n    height: 9rem;\n}\n.monster-wrappers .monster-icon[data-v-50a5fd5c] {\n    position: absolute;\n}\n.monster-wrappers .monster-email-row[data-v-50a5fd5c] {\n    position: absolute;\n    bottom: 0;\n    top: 35%;\n    left: 0;\n    width: 100%;\n}\n.monster-wrappers .monster-email-row svg[data-v-50a5fd5c] {\n      margin: 0 1.9375rem;\n}\n.monster-wrappers .message-headline[data-v-50a5fd5c],\n  .monster-wrappers .message-content[data-v-50a5fd5c] {\n    font-family: Silkscreen, sans-serif;\n    text-transform: uppercase;\n    max-width: 14.8125rem;\n    margin: 0 auto;\n}\n.monster-wrappers .message-headline[data-v-50a5fd5c] {\n    font-size: 2rem;\n    line-height: 1.6875rem;\n    font-weight: bold;\n    text-shadow: 0.125rem 0.125rem 0 #F8008E;\n    -webkit-transform: translate(-40px, -110px);\n        -ms-transform: translate(-40px, -110px);\n            transform: translate(-40px, -110px);\n    -webkit-transition: -webkit-transform .5s ease-in-out 2.6s;\n    transition: -webkit-transform .5s ease-in-out 2.6s;\n    -o-transition: transform .5s ease-in-out 2.6s;\n    transition: transform .5s ease-in-out 2.6s;\n    transition: transform .5s ease-in-out 2.6s, -webkit-transform .5s ease-in-out 2.6s;\n    margin-bottom: 0.5rem;\n}\n.monster-wrappers .message-content[data-v-50a5fd5c] {\n    font-size: 1.5rem;\n    line-height: 1.5rem;\n    -webkit-transform: translate(30px, -160px);\n        -ms-transform: translate(30px, -160px);\n            transform: translate(30px, -160px);\n    -webkit-transition: -webkit-transform .5s ease-in-out 2.5s;\n    transition: -webkit-transform .5s ease-in-out 2.5s;\n    -o-transition: transform .5s ease-in-out 2.5s;\n    transition: transform .5s ease-in-out 2.5s;\n    transition: transform .5s ease-in-out 2.5s, -webkit-transform .5s ease-in-out 2.5s;\n}\n.warning[data-v-50a5fd5c] {\n  height: 2.1875rem;\n  margin-top: 3.25rem;\n}\n.warning div[data-v-50a5fd5c] {\n    font-family: \"Barlow\", sans-serif;\n    font-size: 0.75rem;\n    line-height: 0.875rem;\n}\n.notification.warning-color[data-v-50a5fd5c] {\n  background: #FF5CBE;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.notification.warning-color[data-v-50a5fd5c] {\n      margin-left: -50vw;\n      margin-right: -50vw;\n}\n.notification.warning-color > div[data-v-50a5fd5c] {\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        font-weight: bold;\n        color: #FFFFFF;\n        font-size: 0.875rem;\n}\n}\ninput.warning-color[data-v-50a5fd5c] {\n  color: #FF5CBE;\n}\n.newsletter-form[data-v-50a5fd5c] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  z-index: 2;\n  top: 11.875rem;\n  max-width: 21.6875rem;\n}\n.newsletter-form .input-email[data-v-50a5fd5c] {\n    font-family: \"Barlow\", sans-serif;\n    font-size: 1.5rem;\n    border-radius: unset;\n    border-bottom: 3px solid #979797;\n}\n.newsletter-form .input-email[data-v-50a5fd5c]::-webkit-input-placeholder {\n      /* Chrome/Opera/Safari */\n      color: #cccccc;\n      padding-left: 0.5rem;\n}\n.newsletter-form .input-email[data-v-50a5fd5c]::-moz-placeholder {\n      /* Firefox 19+ */\n      color: #cccccc;\n      padding-left: 0.5rem;\n}\n.newsletter-form .input-email[data-v-50a5fd5c]:-ms-input-placeholder {\n      /* IE 10+ */\n      color: #cccccc;\n      padding-left: 0.5rem;\n}\n.newsletter-form .input-email[data-v-50a5fd5c]:-moz-placeholder {\n      /* Firefox 18- */\n      color: #cccccc;\n      padding-left: 0.5rem;\n}\n.newsletter-form .form-input[data-v-50a5fd5c] {\n    margin: 4px;\n    background: #FFFFFF;\n    padding: 0;\n    -webkit-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n    position: absolute;\n    z-index: 3;\n    left: 0;\n    right: 0;\n    top: 0;\n}\n.newsletter-form .form-btn[data-v-50a5fd5c] {\n    width: 7.1875rem;\n    border: 4px solid #F8008E;\n    border-left: none;\n    background: #F8008E;\n    -webkit-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n    -webkit-box-sizing: content-box;\n            box-sizing: content-box;\n    padding-left: 13.25rem;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 1.75rem;\n    text-align: right;\n}\n.newsletter-form .form-btn[data-v-50a5fd5c]:hover {\n      border-color: #FF5CBE;\n      background-color: #FF5CBE;\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.newsletter-form .form-btn[data-v-50a5fd5c]:hover {\n          background: #BF0061;\n          border-color: #BF0061;\n}\n}\n.newsletter-form .form-btn[data-v-50a5fd5c]:focus {\n      border-color: #BF0061;\n      background-color: #BF0061;\n}\n.newsletter-form input[data-v-50a5fd5c] {\n    caret-color: #F8008E;\n    outline-width: 0.125rem;\n    height: 2.8125rem;\n}\n.newsletter-form .submit-newsletter[data-v-50a5fd5c] {\n    background: #F8008E;\n    border-radius: unset;\n    font-size: 1.25rem;\n    color: #FFFFFF;\n    font-family: Silkscreen, sans-serif;\n}\n.newsletter-form .submit-newsletter[data-v-50a5fd5c]:focus {\n      -webkit-box-shadow: none;\n              box-shadow: none;\n}\n.newsletter-form .submit-newsletter span[data-v-50a5fd5c] {\n      font-size: 1.25rem;\n      color: #FFFFFF;\n      font-family: Silkscreen, sans-serif;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("26b6b4c0", content, true, {});

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("471850d8", content, true, {});

/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1137);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("43881bc4", content, true, {});

/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1144)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1127),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1147)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1130),
  /* template */
  __webpack_require__(1174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c593d01",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1132),
  /* template */
  __webpack_require__(1175),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50a5fd5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.mainClassName, 'quote']
  }, [_c('div', {
    staticClass: "quotes"
  }, [_c('div', {
    staticClass: "quotes__icon"
  }, [_c('single-quote-svg')], 1), _c('div', {
    staticClass: "quotes__icon"
  }, [_c('single-quote-svg')], 1)]), _vm._v("\n  " + _vm._s(_vm.value) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1175:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.inHomeView ? true : _vm.showNewsletter) ? _c('div', {
    staticClass: "monster-newsletter-widget gtm-onElementVisiblity",
    class: ("theme-" + (_vm.newsletterType.color)),
    attrs: {
      "gtm-on": "elementVisibility",
      "gtm-visibility-category": _vm.gtmNewsletterCategory,
      "gtm-visibility-action": "Newsletter widget impression",
      "gtm-visibility-label": _vm.newsletterType.name
    }
  }, [_c('div', {
    staticClass: "content-row"
  }, [_c('div', {
    staticClass: "envelopes-wrapper left"
  }, _vm._l((5), function(x) {
    return _c('div', {
      key: x,
      staticClass: "envelope-row animated",
      class: {
        odd: x % 2 === 1, even: x % 2 === 0
      }
    }, _vm._l((7), function(y) {
      return _c('svg-email-eight-bit-icon', {
        key: y,
        staticClass: "email-icon",
        class: {
          first: y === 1, last: y === 7
        },
        attrs: {
          "fill": "#F8008E",
          "width": "30",
          "height": "21"
        }
      })
    }))
  })), _c('div', {
    ref: "rectWrappersContainer",
    staticClass: "rect-wrappers-container animated"
  }, [_c('div', {
    staticClass: "monster-wrappers"
  }, [_c('div', {
    staticClass: "monster-content"
  }, [_c('div', {
    staticClass: "monster-icon"
  }, [_c('svg-email-monster-icon', {
    attrs: {
      "width": "394",
      "height": "138"
    }
  })], 1), _c('div', {
    staticClass: "monster-email-row"
  }, _vm._l((3), function(n) {
    return _c('svg-email-eight-bit-icon', {
      key: n,
      class: {
        first: n === 1, last: n === 3
      },
      attrs: {
        "width": "39",
        "height": "28"
      }
    })
  }))]), _c('div', {
    staticClass: "message-headline",
    class: _vm.newsletterType.color
  }, [_vm._v("thank you")]), _c('div', {
    staticClass: "message-content",
    class: _vm.newsletterType.color
  }, [_vm._v("you are now on the email list")])]), _c('div', {
    staticClass: "rect-wrapper-parent"
  }, [_c('div', {
    staticClass: "rect-wrapper-content"
  }, [_c('div', {
    staticClass: "brand-title"
  }, [_vm._v("GET OUR")]), _c('div', {
    staticClass: "newsletter-type",
    class: _vm.newsletterType.color
  }, [_vm._v(_vm._s(_vm.newsletterType.name))]), _c('div', {
    staticClass: "newsletter-title",
    class: _vm.newsletterType.color
  }, [_vm._v("NEWSLETTER")])]), _vm._l((5), function(n) {
    return _c('div', {
      staticClass: "rect-wrapper first",
      class: [_vm.newsletterType.color, 'rect-wrapper-frame-' + n]
    }, [_c('div', {
      staticClass: "rect-wrapper second",
      class: _vm.newsletterType.color
    }, [_c('div', {
      staticClass: "rect-wrapper third",
      class: _vm.newsletterType.color
    }, [_c('div', {
      staticClass: "rect-wrapper forth",
      class: _vm.newsletterType.color
    }, [_c('div', {
      staticClass: "rect-wrapper fifth",
      class: _vm.newsletterType.color
    })])])])])
  })], 2), (!_vm.submit) ? _c('div', {
    staticClass: "newsletter-form"
  }, [_c('form', {
    staticClass: "mx-auto disable-translate3d",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center disable-translate3d"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.monsterEmail),
      expression: "monsterEmail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-100 form-control border-0 pl-2 pr-2 input-email",
    class: {
      'warning-color': _vm.warning
    },
    attrs: {
      "type": "email",
      "placeholder": "your email"
    },
    domProps: {
      "value": (_vm.monsterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.monsterEmail = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('button', {
    staticClass: "form-btn btn submit-newsletter",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SIGN UP")])]), _c('div', {
    staticClass: "warning notification",
    class: {
      'warning-color': _vm.warning
    }
  }, [(_vm.warning) ? _c('div', {
    staticClass: "d-flex align-items-center pr-3 pl-3 h-100"
  }, [_vm._v("Email Address is not valid.")]) : _vm._e()])])]) : _vm._e()]), _c('div', {
    staticClass: "envelopes-wrapper right"
  }, _vm._l((5), function(x) {
    return _c('div', {
      key: x,
      staticClass: "envelope-row animated",
      class: {
        odd: x % 2 === 1, even: x % 2 === 0
      }
    }, _vm._l((7), function(y) {
      return _c('svg-email-eight-bit-icon', {
        key: y,
        staticClass: "email-icon",
        class: {
          first: y === 1, last: y === 7
        },
        attrs: {
          "fill": "#F8008E",
          "width": "30",
          "height": "21"
        }
      })
    }))
  }))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1181:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg"><path d="M19.266 9.61H2.437l8.72-8.72-.891-.89L0 10.266l10.266 10.218.89-.89-8.719-8.719h16.829z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1182:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="30" height="22" viewBox="0 0 30 22" xmlns="http://www.w3.org/2000/svg"><path d="M18.007 0l-.034.034V0h-8.97v.059L8.97 0H0v9.116l.041.034H0v12.166h8.97v-.166l.033.166H30V0H18.007zm2.99 9.116v-3.04h2.99V3.04h2.99v-.05l.033.049v3.038l-.034.089v-.09h-2.99v3.04h.086l-.086.034h-2.99v3.039h2.99v3.038h2.99v-.085l.034.085v3.039h.025l-.025.012-.034.038v-.038h-2.99v-3.051h-2.99V12.19h-2.99l-.024.028-.01-.028H9.004v3.038l-.034.035v-.035H5.98v3.039h.012l-.012.012H2.99l-.026-.012h.027v-3.039h2.99V12.19h2.99V9.15H5.937l.041-.034v-3.04H2.99V3.04h2.99v3.038h2.99l.034-.058v3.097h8.97v-.034l.034.034h2.99z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1189:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)
var differenceInCalendarDays = __webpack_require__(1053)
var compareAsc = __webpack_require__(1549)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),

/***/ 1190:
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(1143)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),

/***/ 1191:
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(1143)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),

/***/ 1192:
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(1643);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1600)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1357),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1619)
  __webpack_require__(1620)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1389),
  /* template */
  __webpack_require__(1777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6d8d51e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1586)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1392),
  /* template */
  __webpack_require__(1750),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1624)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1400),
  /* template */
  __webpack_require__(1781),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c0028458",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg"><path d="M10.725 0v16.596l8.599-8.598.878.878L10.124 19 0 8.876l.878-.878 8.599 8.598V0z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(355);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(1410);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _keys = __webpack_require__(356);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(372);

var _typeof3 = _interopRequireDefault(_typeof2);

var _create = __webpack_require__(1409);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (root) {
  window.TL = {
    VERSION: '0.1'
  };
})(undefined);

TL.debug = false;

TL.Bind = function (fn, obj) {
  return function () {
    return fn.apply(obj, arguments);
  };
};

TL.trace = function (msg) {
  if (TL.debug) {
    if (window.console) {
      console.log(msg);
    } else if (typeof jsTrace != 'undefined') {
      jsTrace.send(msg);
    } else {}
  }
};

function TL_Error(message_key, detail) {
  this.name = 'TL.Error';
  this.message = message_key || 'error';
  this.message_key = this.message;
  this.detail = detail || '';

  var e = new Error();
  if (e.hasOwnProperty('stack')) {
    this.stack = e.stack;
  }
}

TL_Error.prototype = (0, _create2.default)(Error.prototype);
TL_Error.prototype.constructor = TL_Error;

TL.Error = TL_Error;

TL.Util = {
  mergeData: function mergeData(data_main, data_to_merge) {
    var x;
    for (x in data_to_merge) {
      if (Object.prototype.hasOwnProperty.call(data_to_merge, x)) {
        data_main[x] = data_to_merge[x];
      }
    }
    return data_main;
  },

  extend: function extend(dest) {
    var sources = Array.prototype.slice.call(arguments, 1);
    for (var j = 0, len = sources.length, src; j < len; j++) {
      src = sources[j] || {};
      TL.Util.mergeData(dest, src);
    }
    return dest;
  },

  isEven: function isEven(n) {
    return n == parseFloat(n) ? !(n % 2) : void 0;
  },

  isTrue: function isTrue(s) {
    if (s == null) return false;
    return s == true || String(s).toLowerCase() == 'true' || Number(s) == 1;
  },

  findArrayNumberByUniqueID: function findArrayNumberByUniqueID(id, array, prop, defaultVal) {
    var _n = defaultVal || 0;

    for (var i = 0; i < array.length; i++) {
      if (array[i].data[prop] == id) {
        _n = i;
      }
    };

    return _n;
  },

  convertUnixTime: function convertUnixTime(str) {
    var _date,
        _months,
        _year,
        _month,
        _day,
        _time,
        _date_array = [],
        _date_str = {
      ymd: "",
      time: "",
      time_array: [],
      date_array: [],
      full_array: []
    };

    _date_str.ymd = str.split(" ")[0];
    _date_str.time = str.split(" ")[1];
    _date_str.date_array = _date_str.ymd.split("-");
    _date_str.time_array = _date_str.time.split(":");
    _date_str.full_array = _date_str.date_array.concat(_date_str.time_array);

    for (var i = 0; i < _date_str.full_array.length; i++) {
      _date_array.push(parseInt(_date_str.full_array[i]));
    }

    _date = new Date(_date_array[0], _date_array[1], _date_array[2], _date_array[3], _date_array[4], _date_array[5]);
    _months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    _year = _date.getFullYear();
    _month = _months[_date.getMonth()];
    _day = _date.getDate();
    _time = _month + ', ' + _day + ' ' + _year;

    return _time;
  },

  setData: function setData(obj, data) {
    obj.data = TL.Util.extend({}, obj.data, data);
    if (obj.data.unique_id === "") {
      obj.data.unique_id = TL.Util.unique_ID(6);
    }
  },

  stamp: function () {
    var lastId = 0,
        key = '_tl_id';

    return function (obj) {
      obj[key] = obj[key] || ++lastId;
      return obj[key];
    };
  }(),

  isArray: function () {
    if (Array.isArray) {
      return Array.isArray;
    }

    var objectToStringFn = Object.prototype.toString,
        arrayToStringResult = objectToStringFn.call([]);

    return function (subject) {
      return objectToStringFn.call(subject) === arrayToStringResult;
    };
  }(),

  getRandomNumber: function getRandomNumber(range) {
    return Math.floor(Math.random() * range);
  },

  unique_ID: function unique_ID(size, prefix) {

    var getRandomNumber = function getRandomNumber(range) {
      return Math.floor(Math.random() * range);
    };

    var getRandomChar = function getRandomChar() {
      var chars = "abcdefghijklmnopqurstuvwxyz";
      return chars.substr(getRandomNumber(32), 1);
    };

    var randomID = function randomID(size) {
      var str = "";
      for (var i = 0; i < size; i++) {
        str += getRandomChar();
      }
      return str;
    };

    if (prefix) {
      return prefix + "-" + randomID(size);
    } else {
      return "tl-" + randomID(size);
    }
  },

  ensureUniqueKey: function ensureUniqueKey(obj, candidate) {
    if (!candidate) {
      candidate = TL.Util.unique_ID(6);
    }

    if (!(candidate in obj)) {
      return candidate;
    }

    var root = candidate.match(/^(.+)(-\d+)?$/)[1];
    var similar_ids = [];

    for (key in obj) {
      if (key.match(/^(.+?)(-\d+)?$/)[1] == root) {
        similar_ids.push(key);
      }
    }
    candidate = root + "-" + (similar_ids.length + 1);

    for (var counter = similar_ids.length; similar_ids.indexOf(candidate) != -1; counter++) {
      candidate = root + '-' + counter;
    }

    return candidate;
  },

  htmlify: function htmlify(str) {
    if (str.match(/<p>[\s\S]*?<\/p>/)) {

      return str;
    } else {
      return "<p>" + str + "</p>";
    }
  },

  unhtmlify: function unhtmlify(str) {
    str = str.replace(/(<[^>]*>)+/g, '');
    return str.replace('"', "'");
  },

  linkify: function linkify(text, targets, is_touch) {

    var make_link = function make_link(url, link_text, prefix) {
      if (!prefix) {
        prefix = "";
      }
      var MAX_LINK_TEXT_LENGTH = 30;
      if (link_text && link_text.length > MAX_LINK_TEXT_LENGTH) {
        link_text = link_text.substring(0, MAX_LINK_TEXT_LENGTH) + '\u2026';
      }
      return prefix + "<a class='tl-makelink' href='" + url + "' onclick='void(0)'>" + link_text + "</a>";
    };

    var urlPattern = /\b(?:https?|ftp):\/\/([a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|])/gim;

    var pseudoUrlPattern = /(^|[^\/>])(www\.[\S]+(\b|$))/gim;

    var emailAddressPattern = /([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)/gim;

    return text.replace(urlPattern, function (match, url_sans_protocol, offset, string) {
      if (offset > 0) {
        var prechar = string[offset - 1];
        if (prechar == '"' || prechar == "'" || prechar == "=") {
          return match;
        }
      }
      return make_link(match, url_sans_protocol);
    }).replace(pseudoUrlPattern, function (match, beforePseudo, pseudoUrl, offset, string) {
      return make_link('http://' + pseudoUrl, pseudoUrl, beforePseudo);
    }).replace(emailAddressPattern, function (match, email, offset, string) {
      return make_link('mailto:' + email, email);
    });
  },

  unlinkify: function unlinkify(text) {
    if (!text) return text;
    text = text.replace(/<a\b[^>]*>/i, "");
    text = text.replace(/<\/a>/i, "");
    return text;
  },

  getParamString: function getParamString(obj) {
    var params = [];
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        params.push(i + '=' + obj[i]);
      }
    }
    return '?' + params.join('&');
  },

  formatNum: function formatNum(num, digits) {
    var pow = Math.pow(10, digits || 5);
    return Math.round(num * pow) / pow;
  },

  falseFn: function falseFn() {
    return false;
  },

  requestAnimFrame: function () {
    function timeoutDefer(callback) {
      window.setTimeout(callback, 1000 / 60);
    }

    var requestFn = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || timeoutDefer;

    return function (callback, context, immediate, contextEl) {
      callback = context ? TL.Util.bind(callback, context) : callback;
      if (immediate && requestFn === timeoutDefer) {
        callback();
      } else {
        requestFn(callback, contextEl);
      }
    };
  }(),

  bind: function bind(fn, obj) {
    return function () {
      return fn.apply(obj, arguments);
    };
  },

  template: function template(str, data) {
    return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
      var value = data[key];
      if (!data.hasOwnProperty(key)) {
        throw new TL.Error("template_value_err", str);
      }
      return value;
    });
  },

  hexToRgb: function hexToRgb(hex) {
    if (TL.Util.css_named_colors[hex.toLowerCase()]) {
      hex = TL.Util.css_named_colors[hex.toLowerCase()];
    }
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  rgbToHex: function rgbToHex(rgb) {
    var r, g, b;
    if ((typeof rgb === 'undefined' ? 'undefined' : (0, _typeof3.default)(rgb)) == 'object') {
      r = rgb.r;
      g = rgb.g;
      b = rgb.b;
    } else if (typeof rgb.match == 'function') {
      var parts = rgb.match(/^rgb\((\d+),(\d+),(\d+)\)$/);
      if (parts) {
        r = parts[1];
        g = parts[2];
        b = parts[3];
      }
    }
    if (isNaN(r) || isNaN(b) || isNaN(g)) {
      throw new TL.Error("invalid_rgb_err");
    }
    return "#" + TL.Util.intToHexString(r) + TL.Util.intToHexString(g) + TL.Util.intToHexString(b);
  },
  colorObjToHex: function colorObjToHex(o) {
    var parts = [o.r, o.g, o.b];
    return TL.Util.rgbToHex("rgb(" + parts.join(',') + ")");
  },
  css_named_colors: {
    "aliceblue": "#f0f8ff",
    "antiquewhite": "#faebd7",
    "aqua": "#00ffff",
    "aquamarine": "#7fffd4",
    "azure": "#f0ffff",
    "beige": "#f5f5dc",
    "bisque": "#ffe4c4",
    "black": "#000000",
    "blanchedalmond": "#ffebcd",
    "blue": "#0000ff",
    "blueviolet": "#8a2be2",
    "brown": "#a52a2a",
    "burlywood": "#deb887",
    "cadetblue": "#5f9ea0",
    "chartreuse": "#7fff00",
    "chocolate": "#d2691e",
    "coral": "#ff7f50",
    "cornflowerblue": "#6495ed",
    "cornsilk": "#fff8dc",
    "crimson": "#dc143c",
    "cyan": "#00ffff",
    "darkblue": "#00008b",
    "darkcyan": "#008b8b",
    "darkgoldenrod": "#b8860b",
    "darkgray": "#a9a9a9",
    "darkgreen": "#006400",
    "darkkhaki": "#bdb76b",
    "darkmagenta": "#8b008b",
    "darkolivegreen": "#556b2f",
    "darkorange": "#ff8c00",
    "darkorchid": "#9932cc",
    "darkred": "#8b0000",
    "darksalmon": "#e9967a",
    "darkseagreen": "#8fbc8f",
    "darkslateblue": "#483d8b",
    "darkslategray": "#2f4f4f",
    "darkturquoise": "#00ced1",
    "darkviolet": "#9400d3",
    "deeppink": "#ff1493",
    "deepskyblue": "#00bfff",
    "dimgray": "#696969",
    "dodgerblue": "#1e90ff",
    "firebrick": "#b22222",
    "floralwhite": "#fffaf0",
    "forestgreen": "#228b22",
    "fuchsia": "#ff00ff",
    "gainsboro": "#dcdcdc",
    "ghostwhite": "#f8f8ff",
    "gold": "#ffd700",
    "goldenrod": "#daa520",
    "gray": "#808080",
    "green": "#008000",
    "greenyellow": "#adff2f",
    "honeydew": "#f0fff0",
    "hotpink": "#ff69b4",
    "indianred": "#cd5c5c",
    "indigo": "#4b0082",
    "ivory": "#fffff0",
    "khaki": "#f0e68c",
    "lavender": "#e6e6fa",
    "lavenderblush": "#fff0f5",
    "lawngreen": "#7cfc00",
    "lemonchiffon": "#fffacd",
    "lightblue": "#add8e6",
    "lightcoral": "#f08080",
    "lightcyan": "#e0ffff",
    "lightgoldenrodyellow": "#fafad2",
    "lightgray": "#d3d3d3",
    "lightgreen": "#90ee90",
    "lightpink": "#ffb6c1",
    "lightsalmon": "#ffa07a",
    "lightseagreen": "#20b2aa",
    "lightskyblue": "#87cefa",
    "lightslategray": "#778899",
    "lightsteelblue": "#b0c4de",
    "lightyellow": "#ffffe0",
    "lime": "#00ff00",
    "limegreen": "#32cd32",
    "linen": "#faf0e6",
    "magenta": "#ff00ff",
    "maroon": "#800000",
    "mediumaquamarine": "#66cdaa",
    "mediumblue": "#0000cd",
    "mediumorchid": "#ba55d3",
    "mediumpurple": "#9370db",
    "mediumseagreen": "#3cb371",
    "mediumslateblue": "#7b68ee",
    "mediumspringgreen": "#00fa9a",
    "mediumturquoise": "#48d1cc",
    "mediumvioletred": "#c71585",
    "midnightblue": "#191970",
    "mintcream": "#f5fffa",
    "mistyrose": "#ffe4e1",
    "moccasin": "#ffe4b5",
    "navajowhite": "#ffdead",
    "navy": "#000080",
    "oldlace": "#fdf5e6",
    "olive": "#808000",
    "olivedrab": "#6b8e23",
    "orange": "#ffa500",
    "orangered": "#ff4500",
    "orchid": "#da70d6",
    "palegoldenrod": "#eee8aa",
    "palegreen": "#98fb98",
    "paleturquoise": "#afeeee",
    "palevioletred": "#db7093",
    "papayawhip": "#ffefd5",
    "peachpuff": "#ffdab9",
    "peru": "#cd853f",
    "pink": "#ffc0cb",
    "plum": "#dda0dd",
    "powderblue": "#b0e0e6",
    "purple": "#800080",
    "rebeccapurple": "#663399",
    "red": "#ff0000",
    "rosybrown": "#bc8f8f",
    "royalblue": "#4169e1",
    "saddlebrown": "#8b4513",
    "salmon": "#fa8072",
    "sandybrown": "#f4a460",
    "seagreen": "#2e8b57",
    "seashell": "#fff5ee",
    "sienna": "#a0522d",
    "silver": "#c0c0c0",
    "skyblue": "#87ceeb",
    "slateblue": "#6a5acd",
    "slategray": "#708090",
    "snow": "#fffafa",
    "springgreen": "#00ff7f",
    "steelblue": "#4682b4",
    "tan": "#d2b48c",
    "teal": "#008080",
    "thistle": "#d8bfd8",
    "tomato": "#ff6347",
    "turquoise": "#40e0d0",
    "violet": "#ee82ee",
    "wheat": "#f5deb3",
    "white": "#ffffff",
    "whitesmoke": "#f5f5f5",
    "yellow": "#ffff00",
    "yellowgreen": "#9acd32"
  },
  ratio: {
    square: function square(size) {
      var s = {
        w: 0,
        h: 0
      };
      if (size.w > size.h && size.h > 0) {
        s.h = size.h;
        s.w = size.h;
      } else {
        s.w = size.w;
        s.h = size.w;
      }
      return s;
    },

    r16_9: function r16_9(size) {
      if (size.w !== null && size.w !== "") {
        return Math.round(size.w / 16 * 9);
      } else if (size.h !== null && size.h !== "") {
        return Math.round(size.h / 9 * 16);
      } else {
        return 0;
      }
    },
    r4_3: function r4_3(size) {
      if (size.w !== null && size.w !== "") {
        return Math.round(size.w / 4 * 3);
      } else if (size.h !== null && size.h !== "") {
        return Math.round(size.h / 3 * 4);
      }
    }
  },
  getObjectAttributeByIndex: function getObjectAttributeByIndex(obj, index) {
    if (typeof obj != 'undefined') {
      var i = 0;
      for (var attr in obj) {
        if (index === i) {
          return obj[attr];
        }
        i++;
      }
      return "";
    } else {
      return "";
    }
  },
  getUrlVars: function getUrlVars(string) {
    var str,
        vars = [],
        hash,
        hashes;

    str = string.toString();

    if (str.match('&#038;')) {
      str = str.replace("&#038;", "&");
    } else if (str.match('&#38;')) {
      str = str.replace("&#38;", "&");
    } else if (str.match('&amp;')) {
      str = str.replace("&amp;", "&");
    }

    hashes = str.slice(str.indexOf('?') + 1).split('&');

    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }

    return vars;
  },

  trim: function trim(str) {
    if (str && typeof str.replace == 'function') {
      return str.replace(/^\s+|\s+$/g, '');
    }
    return "";
  },

  slugify: function slugify(str) {
    str = TL.Util.trim(str);
    str = str.toLowerCase();

    var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    var to = "aaaaaeeeeeiiiiooooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

    str = str.replace(/^([0-9])/, '_$1');
    return str;
  },
  maxDepth: function maxDepth(ary) {
    var stack = [];
    var max_depth = 0;
    for (var i = 0; i < ary.length; i++) {

      stack.push(ary[i]);
      if (stack.length > 1) {
        var top = stack[stack.length - 1];
        var bottom_idx = -1;
        for (var j = 0; j < stack.length - 1; j++) {
          if (stack[j][1] < top[0]) {
            bottom_idx = j;
          }
        };
        if (bottom_idx >= 0) {
          stack = stack.slice(bottom_idx + 1);
        }
      }

      if (stack.length > max_depth) {
        max_depth = stack.length;
      }
    };
    return max_depth;
  },

  pad: function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
      val = "0" + val;
    }return val;
  },
  intToHexString: function intToHexString(i) {
    return TL.Util.pad(parseInt(i, 10).toString(16));
  },
  findNextGreater: function findNextGreater(list, current, default_value) {
    for (var i = 0; i < list.length; i++) {
      if (current < list[i]) {
        return list[i];
      }
    }

    return default_value ? default_value : current;
  },

  findNextLesser: function findNextLesser(list, current, default_value) {
    for (var i = list.length - 1; i >= 0; i--) {
      if (current > list[i]) {
        return list[i];
      }
    }

    return default_value ? default_value : current;
  },

  isEmptyObject: function isEmptyObject(o) {
    var properties = [];
    if (_keys2.default) {
      properties = (0, _keys2.default)(o);
    } else {
      for (var p in o) {
        if (Object.prototype.hasOwnProperty.call(o, p)) properties.push(p);
      }
    }
    for (var i = 0; i < properties.length; i++) {
      var k = properties[i];
      if (o[k] != null && typeof o[k] != "string") return false;
      if (TL.Util.trim(o[k]).length != 0) return false;
    }
    return true;
  },
  parseYouTubeTime: function parseYouTubeTime(s) {
    if (typeof s == 'string') {
      parts = s.match(/^\s*(\d+h)?(\d+m)?(\d+s)?\s*/i);
      if (parts) {
        var hours = parseInt(parts[1]) || 0;
        var minutes = parseInt(parts[2]) || 0;
        var seconds = parseInt(parts[3]) || 0;
        return seconds + minutes * 60 + hours * 60 * 60;
      }
    } else if (typeof s == 'number') {
      return s;
    }
    return 0;
  },

  transformImageURL: function transformImageURL(url) {
    return url.replace(/(.*)www.dropbox.com\/(.*)/, '$1dl.dropboxusercontent.com/$2');
  },

  base58: function (alpha) {
    var alphabet = alpha || '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ',
        base = alphabet.length;
    return {
      encode: function encode(enc) {
        if (typeof enc !== 'number' || enc !== parseInt(enc)) throw '"encode" only accepts integers.';
        var encoded = '';
        while (enc) {
          var remainder = enc % base;
          enc = Math.floor(enc / base);
          encoded = alphabet[remainder].toString() + encoded;
        }
        return encoded;
      },
      decode: function decode(dec) {
        if (typeof dec !== 'string') throw '"decode" only accepts strings.';
        var decoded = 0;
        while (dec) {
          var alphabetPosition = alphabet.indexOf(dec[0]);
          if (alphabetPosition < 0) throw '"decode" can\'t find "' + dec[0] + '" in the alphabet: "' + alphabet + '"';
          var powerOf = dec.length - 1;
          decoded += alphabetPosition * Math.pow(base, powerOf);
          dec = dec.substring(1);
        }
        return decoded;
      }
    };
  }()

};

;(function (TL) {

  var Zepto = function () {
    var undefined,
        key,
        $,
        classList,
        emptyArray = [],
        _slice = emptyArray.slice,
        _filter = emptyArray.filter,
        document = window.document,
        elementDisplay = {},
        classCache = {},
        cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1, 'opacity': 1, 'z-index': 1, 'zoom': 1 },
        fragmentRE = /^\s*<(\w+|!)[^>]*>/,
        singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
        tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
        rootNodeRE = /^(?:body|html)$/i,
        capitalRE = /([A-Z])/g,
        methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],
        adjacencyOperators = ['after', 'prepend', 'before', 'append'],
        table = document.createElement('table'),
        tableRow = document.createElement('tr'),
        containers = {
      'tr': document.createElement('tbody'),
      'tbody': table, 'thead': table, 'tfoot': table,
      'td': tableRow, 'th': tableRow,
      '*': document.createElement('div')
    },
        readyRE = /complete|loaded|interactive/,
        classSelectorRE = /^\.([\w-]+)$/,
        idSelectorRE = /^#([\w-]*)$/,
        simpleSelectorRE = /^[\w-]*$/,
        class2type = {},
        toString = class2type.toString,
        zepto = {},
        camelize,
        uniq,
        tempParent = document.createElement('div'),
        propMap = {
      'tabindex': 'tabIndex',
      'readonly': 'readOnly',
      'for': 'htmlFor',
      'class': 'className',
      'maxlength': 'maxLength',
      'cellspacing': 'cellSpacing',
      'cellpadding': 'cellPadding',
      'rowspan': 'rowSpan',
      'colspan': 'colSpan',
      'usemap': 'useMap',
      'frameborder': 'frameBorder',
      'contenteditable': 'contentEditable'
    },
        isArray = Array.isArray || function (object) {
      return object instanceof Array;
    };

    zepto.matches = function (element, selector) {
      if (!selector || !element || element.nodeType !== 1) return false;
      var matchesSelector = element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
      if (matchesSelector) return matchesSelector.call(element, selector);

      var match,
          parent = element.parentNode,
          temp = !parent;
      if (temp) (parent = tempParent).appendChild(element);
      match = ~zepto.qsa(parent, selector).indexOf(element);
      temp && tempParent.removeChild(element);
      return match;
    };

    function type(obj) {
      return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
    }

    function isFunction(value) {
      return type(value) == "function";
    }
    function isWindow(obj) {
      return obj != null && obj == obj.window;
    }
    function isDocument(obj) {
      return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
    }
    function isObject(obj) {
      return type(obj) == "object";
    }
    function isPlainObject(obj) {
      return isObject(obj) && !isWindow(obj) && (0, _getPrototypeOf2.default)(obj) == Object.prototype;
    }
    function likeArray(obj) {
      return typeof obj.length == 'number';
    }

    function compact(array) {
      return _filter.call(array, function (item) {
        return item != null;
      });
    }
    function flatten(array) {
      return array.length > 0 ? $.fn.concat.apply([], array) : array;
    }
    camelize = function camelize(str) {
      return str.replace(/-+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : '';
      });
    };
    function dasherize(str) {
      return str.replace(/::/g, '/').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').replace(/([a-z\d])([A-Z])/g, '$1_$2').replace(/_/g, '-').toLowerCase();
    }
    uniq = function uniq(array) {
      return _filter.call(array, function (item, idx) {
        return array.indexOf(item) == idx;
      });
    };

    function classRE(name) {
      return name in classCache ? classCache[name] : classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)');
    }

    function maybeAddPx(name, value) {
      return typeof value == "number" && !cssNumber[dasherize(name)] ? value + "px" : value;
    }

    function defaultDisplay(nodeName) {
      var element, display;
      if (!elementDisplay[nodeName]) {
        element = document.createElement(nodeName);
        document.body.appendChild(element);
        display = getComputedStyle(element, '').getPropertyValue("display");
        element.parentNode.removeChild(element);
        display == "none" && (display = "block");
        elementDisplay[nodeName] = display;
      }
      return elementDisplay[nodeName];
    }

    function _children(element) {
      return 'children' in element ? _slice.call(element.children) : $.map(element.childNodes, function (node) {
        if (node.nodeType == 1) return node;
      });
    }

    zepto.fragment = function (html, name, properties) {
      var dom, nodes, container;

      if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1));

      if (!dom) {
        if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>");
        if (name === undefined) name = fragmentRE.test(html) && RegExp.$1;
        if (!(name in containers)) name = '*';

        container = containers[name];
        container.innerHTML = '' + html;
        dom = $.each(_slice.call(container.childNodes), function () {
          container.removeChild(this);
        });
      }

      if (isPlainObject(properties)) {
        nodes = $(dom);
        $.each(properties, function (key, value) {
          if (methodAttributes.indexOf(key) > -1) nodes[key](value);else nodes.attr(key, value);
        });
      }

      return dom;
    };

    zepto.Z = function (dom, selector) {
      dom = dom || [];
      dom.__proto__ = $.fn;
      dom.selector = selector || '';
      return dom;
    };

    zepto.isZ = function (object) {
      return object instanceof zepto.Z;
    };

    zepto.init = function (selector, context) {
      var dom;

      if (!selector) return zepto.Z();else if (typeof selector == 'string') {
          selector = selector.trim();

          if (selector[0] == '<' && fragmentRE.test(selector)) dom = zepto.fragment(selector, RegExp.$1, context), selector = null;else if (context !== undefined) return $(context).find(selector);else dom = zepto.qsa(document, selector);
        } else if (isFunction(selector)) return $(document).ready(selector);else if (zepto.isZ(selector)) return selector;else {
              if (isArray(selector)) dom = compact(selector);else if (isObject(selector)) dom = [selector], selector = null;else if (fragmentRE.test(selector)) dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null;else if (context !== undefined) return $(context).find(selector);else dom = zepto.qsa(document, selector);
            }

      return zepto.Z(dom, selector);
    };

    $ = function $(selector, context) {
      return zepto.init(selector, context);
    };

    function extend(target, source, deep) {
      for (key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
          if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {};
          if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
          extend(target[key], source[key], deep);
        } else if (source[key] !== undefined) target[key] = source[key];
      }
    }

    $.extend = function (target) {
      var deep,
          args = _slice.call(arguments, 1);
      if (typeof target == 'boolean') {
        deep = target;
        target = args.shift();
      }
      args.forEach(function (arg) {
        extend(target, arg, deep);
      });
      return target;
    };

    zepto.qsa = function (element, selector) {
      var found,
          maybeID = selector[0] == '#',
          maybeClass = !maybeID && selector[0] == '.',
          nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
          isSimple = simpleSelectorRE.test(nameOnly);
      return isDocument(element) && isSimple && maybeID ? (found = element.getElementById(nameOnly)) ? [found] : [] : element.nodeType !== 1 && element.nodeType !== 9 ? [] : _slice.call(isSimple && !maybeID ? maybeClass ? element.getElementsByClassName(nameOnly) : element.getElementsByTagName(selector) : element.querySelectorAll(selector));
    };

    function filtered(nodes, selector) {
      return selector == null ? $(nodes) : $(nodes).filter(selector);
    }

    $.contains = function (parent, node) {
      return parent !== node && parent.contains(node);
    };

    function funcArg(context, arg, idx, payload) {
      return isFunction(arg) ? arg.call(context, idx, payload) : arg;
    }

    function setAttribute(node, name, value) {
      value == null ? node.removeAttribute(name) : node.setAttribute(name, value);
    }

    function className(node, value) {
      var klass = node.className,
          svg = klass && klass.baseVal !== undefined;

      if (value === undefined) return svg ? klass.baseVal : klass;
      svg ? klass.baseVal = value : node.className = value;
    }

    function deserializeValue(value) {
      var num;
      try {
        return value ? value == "true" || (value == "false" ? false : value == "null" ? null : !/^0/.test(value) && !isNaN(num = Number(value)) ? num : /^[\[\{]/.test(value) ? $.parseJSON(value) : value) : value;
      } catch (e) {
        return value;
      }
    }

    $.type = type;
    $.isFunction = isFunction;
    $.isWindow = isWindow;
    $.isArray = isArray;
    $.isPlainObject = isPlainObject;

    $.isEmptyObject = function (obj) {
      var name;
      for (name in obj) {
        return false;
      }return true;
    };

    $.inArray = function (elem, array, i) {
      return emptyArray.indexOf.call(array, elem, i);
    };

    $.camelCase = camelize;
    $.trim = function (str) {
      return str == null ? "" : String.prototype.trim.call(str);
    };

    $.uuid = 0;
    $.support = {};
    $.expr = {};

    $.map = function (elements, callback) {
      var value,
          values = [],
          i,
          key;
      if (likeArray(elements)) for (i = 0; i < elements.length; i++) {
        value = callback(elements[i], i);
        if (value != null) values.push(value);
      } else for (key in elements) {
        value = callback(elements[key], key);
        if (value != null) values.push(value);
      }
      return flatten(values);
    };

    $.each = function (elements, callback) {
      var i, key;
      if (likeArray(elements)) {
        for (i = 0; i < elements.length; i++) {
          if (callback.call(elements[i], i, elements[i]) === false) return elements;
        }
      } else {
        for (key in elements) {
          if (callback.call(elements[key], key, elements[key]) === false) return elements;
        }
      }

      return elements;
    };

    $.grep = function (elements, callback) {
      return _filter.call(elements, callback);
    };

    if (window.JSON) $.parseJSON = JSON.parse;

    $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
      class2type["[object " + name + "]"] = name.toLowerCase();
    });

    $.fn = {
      forEach: emptyArray.forEach,
      reduce: emptyArray.reduce,
      push: emptyArray.push,
      sort: emptyArray.sort,
      indexOf: emptyArray.indexOf,
      concat: emptyArray.concat,

      map: function map(fn) {
        return $($.map(this, function (el, i) {
          return fn.call(el, i, el);
        }));
      },
      slice: function slice() {
        return $(_slice.apply(this, arguments));
      },

      ready: function ready(callback) {
        if (readyRE.test(document.readyState) && document.body) callback($);else document.addEventListener('DOMContentLoaded', function () {
          callback($);
        }, false);
        return this;
      },
      get: function get(idx) {
        return idx === undefined ? _slice.call(this) : this[idx >= 0 ? idx : idx + this.length];
      },
      toArray: function toArray() {
        return this.get();
      },
      size: function size() {
        return this.length;
      },
      remove: function remove() {
        return this.each(function () {
          if (this.parentNode != null) this.parentNode.removeChild(this);
        });
      },
      each: function each(callback) {
        emptyArray.every.call(this, function (el, idx) {
          return callback.call(el, idx, el) !== false;
        });
        return this;
      },
      filter: function filter(selector) {
        if (isFunction(selector)) return this.not(this.not(selector));
        return $(_filter.call(this, function (element) {
          return zepto.matches(element, selector);
        }));
      },
      add: function add(selector, context) {
        return $(uniq(this.concat($(selector, context))));
      },
      is: function is(selector) {
        return this.length > 0 && zepto.matches(this[0], selector);
      },
      not: function not(selector) {
        var nodes = [];
        if (isFunction(selector) && selector.call !== undefined) this.each(function (idx) {
          if (!selector.call(this, idx)) nodes.push(this);
        });else {
          var excludes = typeof selector == 'string' ? this.filter(selector) : likeArray(selector) && isFunction(selector.item) ? _slice.call(selector) : $(selector);
          this.forEach(function (el) {
            if (excludes.indexOf(el) < 0) nodes.push(el);
          });
        }
        return $(nodes);
      },
      has: function has(selector) {
        return this.filter(function () {
          return isObject(selector) ? $.contains(this, selector) : $(this).find(selector).size();
        });
      },
      eq: function eq(idx) {
        return idx === -1 ? this.slice(idx) : this.slice(idx, +idx + 1);
      },
      first: function first() {
        var el = this[0];
        return el && !isObject(el) ? el : $(el);
      },
      last: function last() {
        var el = this[this.length - 1];
        return el && !isObject(el) ? el : $(el);
      },
      find: function find(selector) {
        var result,
            $this = this;
        if ((typeof selector === 'undefined' ? 'undefined' : (0, _typeof3.default)(selector)) == 'object') result = $(selector).filter(function () {
          var node = this;
          return emptyArray.some.call($this, function (parent) {
            return $.contains(parent, node);
          });
        });else if (this.length == 1) result = $(zepto.qsa(this[0], selector));else result = this.map(function () {
          return zepto.qsa(this, selector);
        });
        return result;
      },
      closest: function closest(selector, context) {
        var node = this[0],
            collection = false;
        if ((typeof selector === 'undefined' ? 'undefined' : (0, _typeof3.default)(selector)) == 'object') collection = $(selector);
        while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector))) {
          node = node !== context && !isDocument(node) && node.parentNode;
        }return $(node);
      },
      parents: function parents(selector) {
        var ancestors = [],
            nodes = this;
        while (nodes.length > 0) {
          nodes = $.map(nodes, function (node) {
            if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
              ancestors.push(node);
              return node;
            }
          });
        }return filtered(ancestors, selector);
      },
      parent: function parent(selector) {
        return filtered(uniq(this.pluck('parentNode')), selector);
      },
      children: function children(selector) {
        return filtered(this.map(function () {
          return _children(this);
        }), selector);
      },
      contents: function contents() {
        return this.map(function () {
          return _slice.call(this.childNodes);
        });
      },
      siblings: function siblings(selector) {
        return filtered(this.map(function (i, el) {
          return _filter.call(_children(el.parentNode), function (child) {
            return child !== el;
          });
        }), selector);
      },
      empty: function empty() {
        return this.each(function () {
          this.innerHTML = '';
        });
      },

      pluck: function pluck(property) {
        return $.map(this, function (el) {
          return el[property];
        });
      },
      show: function show() {
        return this.each(function () {
          this.style.display == "none" && (this.style.display = '');
          if (getComputedStyle(this, '').getPropertyValue("display") == "none") this.style.display = defaultDisplay(this.nodeName);
        });
      },
      replaceWith: function replaceWith(newContent) {
        return this.before(newContent).remove();
      },
      wrap: function wrap(structure) {
        var func = isFunction(structure);
        if (this[0] && !func) var dom = $(structure).get(0),
            clone = dom.parentNode || this.length > 1;

        return this.each(function (index) {
          $(this).wrapAll(func ? structure.call(this, index) : clone ? dom.cloneNode(true) : dom);
        });
      },
      wrapAll: function wrapAll(structure) {
        if (this[0]) {
          $(this[0]).before(structure = $(structure));
          var children;

          while ((children = structure.children()).length) {
            structure = children.first();
          }$(structure).append(this);
        }
        return this;
      },
      wrapInner: function wrapInner(structure) {
        var func = isFunction(structure);
        return this.each(function (index) {
          var self = $(this),
              contents = self.contents(),
              dom = func ? structure.call(this, index) : structure;
          contents.length ? contents.wrapAll(dom) : self.append(dom);
        });
      },
      unwrap: function unwrap() {
        this.parent().each(function () {
          $(this).replaceWith($(this).children());
        });
        return this;
      },
      clone: function clone() {
        return this.map(function () {
          return this.cloneNode(true);
        });
      },
      hide: function hide() {
        return this.css("display", "none");
      },
      toggle: function toggle(setting) {
        return this.each(function () {
          var el = $(this);(setting === undefined ? el.css("display") == "none" : setting) ? el.show() : el.hide();
        });
      },
      prev: function prev(selector) {
        return $(this.pluck('previousElementSibling')).filter(selector || '*');
      },
      next: function next(selector) {
        return $(this.pluck('nextElementSibling')).filter(selector || '*');
      },
      html: function html(_html) {
        return arguments.length === 0 ? this.length > 0 ? this[0].innerHTML : null : this.each(function (idx) {
          var originHtml = this.innerHTML;
          $(this).empty().append(funcArg(this, _html, idx, originHtml));
        });
      },
      text: function text(_text) {
        return arguments.length === 0 ? this.length > 0 ? this[0].textContent : null : this.each(function () {
          this.textContent = _text === undefined ? '' : '' + _text;
        });
      },
      attr: function attr(name, value) {
        var result;
        return typeof name == 'string' && value === undefined ? this.length == 0 || this[0].nodeType !== 1 ? undefined : name == 'value' && this[0].nodeName == 'INPUT' ? this.val() : !(result = this[0].getAttribute(name)) && name in this[0] ? this[0][name] : result : this.each(function (idx) {
          if (this.nodeType !== 1) return;
          if (isObject(name)) for (key in name) {
            setAttribute(this, key, name[key]);
          } else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)));
        });
      },
      removeAttr: function removeAttr(name) {
        return this.each(function () {
          this.nodeType === 1 && setAttribute(this, name);
        });
      },
      prop: function prop(name, value) {
        name = propMap[name] || name;
        return value === undefined ? this[0] && this[0][name] : this.each(function (idx) {
          this[name] = funcArg(this, value, idx, this[name]);
        });
      },
      data: function data(name, value) {
        var data = this.attr('data-' + name.replace(capitalRE, '-$1').toLowerCase(), value);
        return data !== null ? deserializeValue(data) : undefined;
      },
      val: function val(value) {
        return arguments.length === 0 ? this[0] && (this[0].multiple ? $(this[0]).find('option').filter(function () {
          return this.selected;
        }).pluck('value') : this[0].value) : this.each(function (idx) {
          this.value = funcArg(this, value, idx, this.value);
        });
      },
      offset: function offset(coordinates) {
        if (coordinates) return this.each(function (index) {
          var $this = $(this),
              coords = funcArg(this, coordinates, index, $this.offset()),
              parentOffset = $this.offsetParent().offset(),
              props = {
            top: coords.top - parentOffset.top,
            left: coords.left - parentOffset.left
          };

          if ($this.css('position') == 'static') props['position'] = 'relative';
          $this.css(props);
        });
        if (this.length == 0) return null;
        var obj = this[0].getBoundingClientRect();
        return {
          left: obj.left + window.pageXOffset,
          top: obj.top + window.pageYOffset,
          width: Math.round(obj.width),
          height: Math.round(obj.height)
        };
      },
      css: function css(property, value) {
        if (arguments.length < 2) {
          var element = this[0],
              computedStyle = getComputedStyle(element, '');
          if (!element) return;
          if (typeof property == 'string') return element.style[camelize(property)] || computedStyle.getPropertyValue(property);else if (isArray(property)) {
            var props = {};
            $.each(isArray(property) ? property : [property], function (_, prop) {
              props[prop] = element.style[camelize(prop)] || computedStyle.getPropertyValue(prop);
            });
            return props;
          }
        }

        var css = '';
        if (type(property) == 'string') {
          if (!value && value !== 0) this.each(function () {
            this.style.removeProperty(dasherize(property));
          });else css = dasherize(property) + ":" + maybeAddPx(property, value);
        } else {
          for (key in property) {
            if (!property[key] && property[key] !== 0) this.each(function () {
              this.style.removeProperty(dasherize(key));
            });else css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';';
          }
        }

        return this.each(function () {
          this.style.cssText += ';' + css;
        });
      },
      index: function index(element) {
        return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0]);
      },
      hasClass: function hasClass(name) {
        if (!name) return false;
        return emptyArray.some.call(this, function (el) {
          return this.test(className(el));
        }, classRE(name));
      },
      addClass: function addClass(name) {
        if (!name) return this;
        return this.each(function (idx) {
          classList = [];
          var cls = className(this),
              newName = funcArg(this, name, idx, cls);
          newName.split(/\s+/g).forEach(function (klass) {
            if (!$(this).hasClass(klass)) classList.push(klass);
          }, this);
          classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "));
        });
      },
      removeClass: function removeClass(name) {
        return this.each(function (idx) {
          if (name === undefined) return className(this, '');
          classList = className(this);
          funcArg(this, name, idx, classList).split(/\s+/g).forEach(function (klass) {
            classList = classList.replace(classRE(klass), " ");
          });
          className(this, classList.trim());
        });
      },
      toggleClass: function toggleClass(name, when) {
        if (!name) return this;
        return this.each(function (idx) {
          var $this = $(this),
              names = funcArg(this, name, idx, className(this));
          names.split(/\s+/g).forEach(function (klass) {
            (when === undefined ? !$this.hasClass(klass) : when) ? $this.addClass(klass) : $this.removeClass(klass);
          });
        });
      },
      scrollTop: function scrollTop(value) {
        if (!this.length) return;
        var hasScrollTop = 'scrollTop' in this[0];
        if (value === undefined) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset;
        return this.each(hasScrollTop ? function () {
          this.scrollTop = value;
        } : function () {
          this.scrollTo(this.scrollX, value);
        });
      },
      scrollLeft: function scrollLeft(value) {
        if (!this.length) return;
        var hasScrollLeft = 'scrollLeft' in this[0];
        if (value === undefined) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset;
        return this.each(hasScrollLeft ? function () {
          this.scrollLeft = value;
        } : function () {
          this.scrollTo(value, this.scrollY);
        });
      },
      position: function position() {
        if (!this.length) return;

        var elem = this[0],
            offsetParent = this.offsetParent(),
            offset = this.offset(),
            parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset();

        offset.top -= parseFloat($(elem).css('margin-top')) || 0;
        offset.left -= parseFloat($(elem).css('margin-left')) || 0;

        parentOffset.top += parseFloat($(offsetParent[0]).css('border-top-width')) || 0;
        parentOffset.left += parseFloat($(offsetParent[0]).css('border-left-width')) || 0;

        return {
          top: offset.top - parentOffset.top,
          left: offset.left - parentOffset.left
        };
      },
      offsetParent: function offsetParent() {
        return this.map(function () {
          var parent = this.offsetParent || document.body;
          while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static") {
            parent = parent.offsetParent;
          }return parent;
        });
      }
    };

    $.fn.detach = $.fn.remove;['width', 'height'].forEach(function (dimension) {
      var dimensionProperty = dimension.replace(/./, function (m) {
        return m[0].toUpperCase();
      });

      $.fn[dimension] = function (value) {
        var offset,
            el = this[0];
        if (value === undefined) return isWindow(el) ? el['inner' + dimensionProperty] : isDocument(el) ? el.documentElement['scroll' + dimensionProperty] : (offset = this.offset()) && offset[dimension];else return this.each(function (idx) {
          el = $(this);
          el.css(dimension, funcArg(this, value, idx, el[dimension]()));
        });
      };
    });

    function traverseNode(node, fun) {
      fun(node);
      for (var key in node.childNodes) {
        traverseNode(node.childNodes[key], fun);
      }
    }

    adjacencyOperators.forEach(function (operator, operatorIndex) {
      var inside = operatorIndex % 2;

      $.fn[operator] = function () {
        var argType,
            nodes = $.map(arguments, function (arg) {
          argType = type(arg);
          return argType == "object" || argType == "array" || arg == null ? arg : zepto.fragment(arg);
        }),
            parent,
            copyByClone = this.length > 1;
        if (nodes.length < 1) return this;

        return this.each(function (_, target) {
          parent = inside ? target : target.parentNode;

          target = operatorIndex == 0 ? target.nextSibling : operatorIndex == 1 ? target.firstChild : operatorIndex == 2 ? target : null;

          nodes.forEach(function (node) {
            if (copyByClone) node = node.cloneNode(true);else if (!parent) return $(node).remove();

            traverseNode(parent.insertBefore(node, target), function (el) {
              if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' && (!el.type || el.type === 'text/javascript') && !el.src) window['eval'].call(window, el.innerHTML);
            });
          });
        });
      };

      $.fn[inside ? operator + 'To' : 'insert' + (operatorIndex ? 'Before' : 'After')] = function (html) {
        $(html)[operator](this);
        return this;
      };
    });

    zepto.Z.prototype = $.fn;

    zepto.uniq = uniq;
    zepto.deserializeValue = deserializeValue;
    $.zepto = zepto;

    return $;
  }();

  window.Zepto = Zepto;
  window.$ === undefined && (window.$ = Zepto);(function ($) {
    var $$ = $.zepto.qsa,
        _zid = 1,
        undefined,
        slice = Array.prototype.slice,
        isFunction = $.isFunction,
        isString = function isString(obj) {
      return typeof obj == 'string';
    },
        handlers = {},
        specialEvents = {},
        focusinSupported = 'onfocusin' in window,
        focus = { focus: 'focusin', blur: 'focusout' },
        hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' };

    specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents';

    function zid(element) {
      return element._zid || (element._zid = _zid++);
    }
    function findHandlers(element, event, fn, selector) {
      event = parse(event);
      if (event.ns) var matcher = matcherFor(event.ns);
      return (handlers[zid(element)] || []).filter(function (handler) {
        return handler && (!event.e || handler.e == event.e) && (!event.ns || matcher.test(handler.ns)) && (!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector);
      });
    }
    function parse(event) {
      var parts = ('' + event).split('.');
      return { e: parts[0], ns: parts.slice(1).sort().join(' ') };
    }
    function matcherFor(ns) {
      return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)');
    }

    function eventCapture(handler, captureSetting) {
      return handler.del && !focusinSupported && handler.e in focus || !!captureSetting;
    }

    function realEvent(type) {
      return hover[type] || focusinSupported && focus[type] || type;
    }

    function add(element, events, fn, data, selector, delegator, capture) {
      var id = zid(element),
          set = handlers[id] || (handlers[id] = []);
      events.split(/\s/).forEach(function (event) {
        if (event == 'ready') return $(document).ready(fn);
        var handler = parse(event);
        handler.fn = fn;
        handler.sel = selector;

        if (handler.e in hover) fn = function fn(e) {
          var related = e.relatedTarget;
          if (!related || related !== this && !$.contains(this, related)) return handler.fn.apply(this, arguments);
        };
        handler.del = delegator;
        var callback = delegator || fn;
        handler.proxy = function (e) {
          e = compatible(e);
          if (e.isImmediatePropagationStopped()) return;
          e.data = data;
          var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args));
          if (result === false) e.preventDefault(), e.stopPropagation();
          return result;
        };
        handler.i = set.length;
        set.push(handler);
        if ('addEventListener' in element) element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
      });
    }
    function remove(element, events, fn, selector, capture) {
      var id = zid(element);(events || '').split(/\s/).forEach(function (event) {
        findHandlers(element, event, fn, selector).forEach(function (handler) {
          delete handlers[id][handler.i];
          if ('removeEventListener' in element) element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
        });
      });
    }

    $.event = { add: add, remove: remove };

    $.proxy = function (fn, context) {
      if (isFunction(fn)) {
        var proxyFn = function proxyFn() {
          return fn.apply(context, arguments);
        };
        proxyFn._zid = zid(fn);
        return proxyFn;
      } else if (isString(context)) {
        return $.proxy(fn[context], fn);
      } else {
        throw new TypeError("expected function");
      }
    };

    $.fn.bind = function (event, data, callback) {
      return this.on(event, data, callback);
    };
    $.fn.unbind = function (event, callback) {
      return this.off(event, callback);
    };
    $.fn.one = function (event, selector, data, callback) {
      return this.on(event, selector, data, callback, 1);
    };

    var returnTrue = function returnTrue() {
      return true;
    },
        returnFalse = function returnFalse() {
      return false;
    },
        ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$)/,
        eventMethods = {
      preventDefault: 'isDefaultPrevented',
      stopImmediatePropagation: 'isImmediatePropagationStopped',
      stopPropagation: 'isPropagationStopped'
    };

    function compatible(event, source) {
      if (source || !event.isDefaultPrevented) {
        source || (source = event);

        $.each(eventMethods, function (name, predicate) {
          var sourceMethod = source[name];
          event[name] = function () {
            this[predicate] = returnTrue;
            return sourceMethod && sourceMethod.apply(source, arguments);
          };
          event[predicate] = returnFalse;
        });

        if (source.defaultPrevented !== undefined ? source.defaultPrevented : 'returnValue' in source ? source.returnValue === false : source.getPreventDefault && source.getPreventDefault()) event.isDefaultPrevented = returnTrue;
      }
      return event;
    }

    function createProxy(event) {
      var key,
          proxy = { originalEvent: event };
      for (key in event) {
        if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key];
      }return compatible(proxy, event);
    }

    $.fn.delegate = function (selector, event, callback) {
      return this.on(event, selector, callback);
    };
    $.fn.undelegate = function (selector, event, callback) {
      return this.off(event, selector, callback);
    };

    $.fn.live = function (event, callback) {
      $(document.body).delegate(this.selector, event, callback);
      return this;
    };
    $.fn.die = function (event, callback) {
      $(document.body).undelegate(this.selector, event, callback);
      return this;
    };

    $.fn.on = function (event, selector, data, callback, one) {
      var autoRemove,
          delegator,
          $this = this;
      if (event && !isString(event)) {
        $.each(event, function (type, fn) {
          $this.on(type, selector, data, fn, one);
        });
        return $this;
      }

      if (!isString(selector) && !isFunction(callback) && callback !== false) callback = data, data = selector, selector = undefined;
      if (isFunction(data) || data === false) callback = data, data = undefined;

      if (callback === false) callback = returnFalse;

      return $this.each(function (_, element) {
        if (one) autoRemove = function autoRemove(e) {
          remove(element, e.type, callback);
          return callback.apply(this, arguments);
        };

        if (selector) delegator = function delegator(e) {
          var evt,
              match = $(e.target).closest(selector, element).get(0);
          if (match && match !== element) {
            evt = $.extend(createProxy(e), { currentTarget: match, liveFired: element });
            return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)));
          }
        };

        add(element, event, callback, data, selector, delegator || autoRemove);
      });
    };
    $.fn.off = function (event, selector, callback) {
      var $this = this;
      if (event && !isString(event)) {
        $.each(event, function (type, fn) {
          $this.off(type, selector, fn);
        });
        return $this;
      }

      if (!isString(selector) && !isFunction(callback) && callback !== false) callback = selector, selector = undefined;

      if (callback === false) callback = returnFalse;

      return $this.each(function () {
        remove(this, event, callback, selector);
      });
    };

    $.fn.trigger = function (event, args) {
      event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
      event._args = args;
      return this.each(function () {
        if ('dispatchEvent' in this) this.dispatchEvent(event);else $(this).triggerHandler(event, args);
      });
    };

    $.fn.triggerHandler = function (event, args) {
      var e, result;
      this.each(function (i, element) {
        e = createProxy(isString(event) ? $.Event(event) : event);
        e._args = args;
        e.target = element;
        $.each(findHandlers(element, event.type || event), function (i, handler) {
          result = handler.proxy(e);
          if (e.isImmediatePropagationStopped()) return false;
        });
      });
      return result;
    };('focusin focusout load resize scroll unload click dblclick ' + 'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave ' + 'change select keydown keypress keyup error').split(' ').forEach(function (event) {
      $.fn[event] = function (callback) {
        return callback ? this.bind(event, callback) : this.trigger(event);
      };
    });['focus', 'blur'].forEach(function (name) {
      $.fn[name] = function (callback) {
        if (callback) this.bind(name, callback);else this.each(function () {
          try {
            this[name]();
          } catch (e) {}
        });
        return this;
      };
    });

    $.Event = function (type, props) {
      if (!isString(type)) props = type, type = props.type;
      var event = document.createEvent(specialEvents[type] || 'Events'),
          bubbles = true;
      if (props) for (var name in props) {
        name == 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
      }event.initEvent(type, bubbles, true);
      return compatible(event);
    };
  })(Zepto);(function ($) {
    var jsonpID = 0,
        document = window.document,
        key,
        name,
        rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
        scriptTypeRE = /^(?:text|application)\/javascript/i,
        xmlTypeRE = /^(?:text|application)\/xml/i,
        jsonType = 'application/json',
        htmlType = 'text/html',
        blankRE = /^\s*$/;

    function triggerAndReturn(context, eventName, data) {
      var event = $.Event(eventName);
      $(context).trigger(event, data);
      return !event.isDefaultPrevented();
    }

    function triggerGlobal(settings, context, eventName, data) {
      if (settings.global) return triggerAndReturn(context || document, eventName, data);
    }

    $.active = 0;

    function ajaxStart(settings) {
      if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart');
    }
    function ajaxStop(settings) {
      if (settings.global && ! --$.active) triggerGlobal(settings, null, 'ajaxStop');
    }

    function ajaxBeforeSend(xhr, settings) {
      var context = settings.context;
      if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false) return false;

      triggerGlobal(settings, context, 'ajaxSend', [xhr, settings]);
    }
    function ajaxSuccess(data, xhr, settings, deferred) {
      var context = settings.context,
          status = 'success';
      settings.success.call(context, data, status, xhr);
      if (deferred) deferred.resolveWith(context, [data, status, xhr]);
      triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data]);
      ajaxComplete(status, xhr, settings);
    }

    function ajaxError(error, type, xhr, settings, deferred) {
      var context = settings.context;
      settings.error.call(context, xhr, type, error);
      if (deferred) deferred.rejectWith(context, [xhr, type, error]);
      triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error || type]);
      ajaxComplete(type, xhr, settings);
    }

    function ajaxComplete(status, xhr, settings) {
      var context = settings.context;
      settings.complete.call(context, xhr, status);
      triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings]);
      ajaxStop(settings);
    }

    function empty() {}

    $.ajaxJSONP = function (options, deferred) {
      if (!('type' in options)) return $.ajax(options);

      var _callbackName = options.jsonpCallback,
          callbackName = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || 'jsonp' + ++jsonpID,
          script = document.createElement('script'),
          originalCallback = window[callbackName],
          responseData,
          abort = function abort(errorType) {
        $(script).triggerHandler('error', errorType || 'abort');
      },
          xhr = { abort: abort },
          abortTimeout;

      if (deferred) deferred.promise(xhr);

      $(script).on('load error', function (e, errorType) {
        clearTimeout(abortTimeout);
        $(script).off().remove();

        if (e.type == 'error' || !responseData) {
          ajaxError(null, errorType || 'error', xhr, options, deferred);
        } else {
          ajaxSuccess(responseData[0], xhr, options, deferred);
        }

        window[callbackName] = originalCallback;
        if (responseData && $.isFunction(originalCallback)) originalCallback(responseData[0]);

        originalCallback = responseData = undefined;
      });

      if (ajaxBeforeSend(xhr, options) === false) {
        abort('abort');
        return xhr;
      }

      window[callbackName] = function () {
        responseData = arguments;
      };

      script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName);
      document.head.appendChild(script);

      if (options.timeout > 0) abortTimeout = setTimeout(function () {
        abort('timeout');
      }, options.timeout);

      return xhr;
    };

    $.ajaxSettings = {
      type: 'GET',

      beforeSend: empty,

      success: empty,

      error: empty,

      complete: empty,

      context: null,

      global: true,

      xhr: function xhr() {
        return new window.XMLHttpRequest();
      },

      accepts: {
        script: 'text/javascript, application/javascript, application/x-javascript',
        json: jsonType,
        xml: 'application/xml, text/xml',
        html: htmlType,
        text: 'text/plain'
      },

      crossDomain: false,

      timeout: 0,

      processData: true,

      cache: true
    };

    function mimeToDataType(mime) {
      if (mime) mime = mime.split(';', 2)[0];
      return mime && (mime == htmlType ? 'html' : mime == jsonType ? 'json' : scriptTypeRE.test(mime) ? 'script' : xmlTypeRE.test(mime) && 'xml') || 'text';
    }

    function appendQuery(url, query) {
      if (query == '') return url;
      return (url + '&' + query).replace(/[&?]{1,2}/, '?');
    }

    function serializeData(options) {
      if (options.processData && options.data && $.type(options.data) != "string") options.data = $.param(options.data, options.traditional);
      if (options.data && (!options.type || options.type.toUpperCase() == 'GET')) options.url = appendQuery(options.url, options.data), options.data = undefined;
    }

    $.ajax = function (options) {
      var settings = $.extend({}, options || {}),
          deferred = $.Deferred && $.Deferred();
      for (key in $.ajaxSettings) {
        if (settings[key] === undefined) settings[key] = $.ajaxSettings[key];
      }ajaxStart(settings);

      if (!settings.crossDomain) settings.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(settings.url) && RegExp.$2 != window.location.host;

      if (!settings.url) settings.url = window.location.toString();
      serializeData(settings);
      if (settings.cache === false) settings.url = appendQuery(settings.url, '_=' + Date.now());

      var dataType = settings.dataType,
          hasPlaceholder = /\?.+=\?/.test(settings.url);
      if (dataType == 'jsonp' || hasPlaceholder) {
        if (!hasPlaceholder) settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + '=?' : settings.jsonp === false ? '' : 'callback=?');
        return $.ajaxJSONP(settings, deferred);
      }

      var mime = settings.accepts[dataType],
          headers = {},
          setHeader = function setHeader(name, value) {
        headers[name.toLowerCase()] = [name, value];
      },
          protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
          xhr = settings.xhr(),
          nativeSetHeader = xhr.setRequestHeader,
          abortTimeout;

      if (deferred) deferred.promise(xhr);

      if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest');
      setHeader('Accept', mime || '*/*');
      if (mime = settings.mimeType || mime) {
        if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0];
        xhr.overrideMimeType && xhr.overrideMimeType(mime);
      }
      if (settings.contentType || settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET') setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded');

      if (settings.headers) for (name in settings.headers) {
        setHeader(name, settings.headers[name]);
      }xhr.setRequestHeader = setHeader;

      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          xhr.onreadystatechange = empty;
          clearTimeout(abortTimeout);
          var result,
              error = false;
          if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == 'file:') {
            dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'));
            result = xhr.responseText;

            try {
              if (dataType == 'script') (1, eval)(result);else if (dataType == 'xml') result = xhr.responseXML;else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result);
            } catch (e) {
              error = e;
            }

            if (error) ajaxError(error, 'parsererror', xhr, settings, deferred);else ajaxSuccess(result, xhr, settings, deferred);
          } else {
            ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred);
          }
        }
      };

      if (ajaxBeforeSend(xhr, settings) === false) {
        xhr.abort();
        ajaxError(null, 'abort', xhr, settings, deferred);
        return xhr;
      }

      if (settings.xhrFields) for (name in settings.xhrFields) {
        xhr[name] = settings.xhrFields[name];
      }var async = 'async' in settings ? settings.async : true;
      xhr.open(settings.type, settings.url, async, settings.username, settings.password);

      for (name in headers) {
        nativeSetHeader.apply(xhr, headers[name]);
      }if (settings.timeout > 0) abortTimeout = setTimeout(function () {
        xhr.onreadystatechange = empty;
        xhr.abort();
        ajaxError(null, 'timeout', xhr, settings, deferred);
      }, settings.timeout);

      xhr.send(settings.data ? settings.data : null);
      return xhr;
    };

    function parseArguments(url, data, success, dataType) {
      var hasData = !$.isFunction(data);
      return {
        url: url,
        data: hasData ? data : undefined,
        success: !hasData ? data : $.isFunction(success) ? success : undefined,
        dataType: hasData ? dataType || success : success
      };
    }

    $.get = function (url, data, success, dataType) {
      return $.ajax(parseArguments.apply(null, arguments));
    };

    $.post = function (url, data, success, dataType) {
      var options = parseArguments.apply(null, arguments);
      options.type = 'POST';
      return $.ajax(options);
    };

    $.getJSON = function (url, data, success) {
      var options = parseArguments.apply(null, arguments);
      options.dataType = 'json';
      return $.ajax(options);
    };

    $.fn.load = function (url, data, success) {
      if (!this.length) return this;
      var self = this,
          parts = url.split(/\s/),
          selector,
          options = parseArguments(url, data, success),
          callback = options.success;
      if (parts.length > 1) options.url = parts[0], selector = parts[1];
      options.success = function (response) {
        self.html(selector ? $('<div>').html(response.replace(rscript, "")).find(selector) : response);
        callback && callback.apply(self, arguments);
      };
      $.ajax(options);
      return this;
    };

    var escape = encodeURIComponent;

    function serialize(params, obj, traditional, scope) {
      var type,
          array = $.isArray(obj),
          hash = $.isPlainObject(obj);
      $.each(obj, function (key, value) {
        type = $.type(value);
        if (scope) key = traditional ? scope : scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']';

        if (!scope && array) params.add(value.name, value.value);else if (type == "array" || !traditional && type == "object") serialize(params, value, traditional, key);else params.add(key, value);
      });
    }

    $.param = function (obj, traditional) {
      var params = [];
      params.add = function (k, v) {
        this.push(escape(k) + '=' + escape(v));
      };
      serialize(params, obj, traditional);
      return params.join('&').replace(/%20/g, '+');
    };
  })(Zepto);(function ($) {
    $.fn.serializeArray = function () {
      var result = [],
          el;
      $([].slice.call(this.get(0).elements)).each(function () {
        el = $(this);
        var type = el.attr('type');
        if (this.nodeName.toLowerCase() != 'fieldset' && !this.disabled && type != 'submit' && type != 'reset' && type != 'button' && (type != 'radio' && type != 'checkbox' || this.checked)) result.push({
          name: el.attr('name'),
          value: el.val()
        });
      });
      return result;
    };

    $.fn.serialize = function () {
      var result = [];
      this.serializeArray().forEach(function (elm) {
        result.push(encodeURIComponent(elm.name) + '=' + encodeURIComponent(elm.value));
      });
      return result.join('&');
    };

    $.fn.submit = function (callback) {
      if (callback) this.bind('submit', callback);else if (this.length) {
        var event = $.Event('submit');
        this.eq(0).trigger(event);
        if (!event.isDefaultPrevented()) this.get(0).submit();
      }
      return this;
    };
  })(Zepto);(function ($) {
    if (!('__proto__' in {})) {
      $.extend($.zepto, {
        Z: function Z(dom, selector) {
          dom = dom || [];
          $.extend(dom, $.fn);
          dom.selector = selector || '';
          dom.__Z = true;
          return dom;
        },

        isZ: function isZ(object) {
          return $.type(object) === 'array' && '__Z' in object;
        }
      });
    }

    try {
      getComputedStyle(undefined);
    } catch (e) {
      var nativeGetComputedStyle = getComputedStyle;
      window.getComputedStyle = function (element, pseudoElement) {
        try {
          return nativeGetComputedStyle(element, pseudoElement);
        } catch (e) {
          return null;
        }
      };
    }
  })(Zepto);

  TL.getJSON = Zepto.getJSON;
  TL.ajax = Zepto.ajax;
})(TL);

TL.Class = function () {};

TL.Class.extend = function (props) {
  var NewClass = function NewClass() {
    if (this.initialize) {
      this.initialize.apply(this, arguments);
    }
  };

  var F = function F() {};
  F.prototype = this.prototype;
  var proto = new F();

  proto.constructor = NewClass;
  NewClass.prototype = proto;

  NewClass.superclass = this.prototype;

  for (var i in this) {
    if (this.hasOwnProperty(i) && i !== 'prototype' && i !== 'superclass') {
      NewClass[i] = this[i];
    }
  }

  if (props.statics) {
    TL.Util.extend(NewClass, props.statics);
    delete props.statics;
  }

  if (props.includes) {
    TL.Util.extend.apply(null, [proto].concat(props.includes));
    delete props.includes;
  }

  if (props.options && proto.options) {
    props.options = TL.Util.extend({}, proto.options, props.options);
  }

  TL.Util.extend(proto, props);

  NewClass.extend = TL.Class.extend;

  NewClass.include = function (props) {
    TL.Util.extend(this.prototype, props);
  };

  return NewClass;
};

TL.Events = {
  addEventListener: function addEventListener(type, fn, context) {
    var events = this._tl_events = this._tl_events || {};
    events[type] = events[type] || [];
    events[type].push({
      action: fn,
      context: context || this
    });
    return this;
  },

  hasEventListeners: function hasEventListeners(type) {
    var k = '_tl_events';
    return k in this && type in this[k] && this[k][type].length > 0;
  },

  removeEventListener: function removeEventListener(type, fn, context) {
    if (!this.hasEventListeners(type)) {
      return this;
    }

    for (var i = 0, events = this._tl_events, len = events[type].length; i < len; i++) {
      if (events[type][i].action === fn && (!context || events[type][i].context === context)) {
        events[type].splice(i, 1);
        return this;
      }
    }
    return this;
  },

  fireEvent: function fireEvent(type, data) {
    if (!this.hasEventListeners(type)) {
      return this;
    }

    var event = TL.Util.mergeData({
      type: type,
      target: this
    }, data);

    var listeners = this._tl_events[type].slice();

    for (var i = 0, len = listeners.length; i < len; i++) {
      listeners[i].action.call(listeners[i].context || this, event);
    }

    return this;
  }
};

TL.Events.on = TL.Events.addEventListener;
TL.Events.off = TL.Events.removeEventListener;
TL.Events.fire = TL.Events.fireEvent;

(function () {

  var ua = navigator.userAgent.toLowerCase(),
      doc = document.documentElement,
      ie = 'ActiveXObject' in window,
      webkit = ua.indexOf('webkit') !== -1,
      phantomjs = ua.indexOf('phantom') !== -1,
      android23 = ua.search('android [23]') !== -1,
      mobile = typeof orientation !== 'undefined',
      msPointer = navigator.msPointerEnabled && navigator.msMaxTouchPoints && !window.PointerEvent,
      pointer = window.PointerEvent && navigator.pointerEnabled && navigator.maxTouchPoints || msPointer,
      ie3d = ie && 'transition' in doc.style,
      webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23,
      gecko3d = 'MozPerspective' in doc.style,
      opera3d = 'OTransition' in doc.style,
      opera = window.opera;

  var retina = 'devicePixelRatio' in window && window.devicePixelRatio > 1;

  if (!retina && 'matchMedia' in window) {
    var matches = window.matchMedia('(min-resolution:144dpi)');
    retina = matches && matches.matches;
  }

  var touch = !window.L_NO_TOUCH && !phantomjs && (pointer || 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);

  TL.Browser = {
    ie: ie,
    ua: ua,
    ie9: Boolean(ie && ua.match(/MSIE 9/i)),
    ielt9: ie && !document.addEventListener,
    webkit: webkit,

    firefox: ua.indexOf('gecko') !== -1 && !webkit && !window.opera && !ie,
    android: ua.indexOf('android') !== -1,
    android23: android23,
    chrome: ua.indexOf('chrome') !== -1,
    edge: ua.indexOf('edge/') !== -1,

    ie3d: ie3d,
    webkit3d: webkit3d,
    gecko3d: gecko3d,
    opera3d: opera3d,
    any3d: !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d || opera3d) && !phantomjs,

    mobile: mobile,
    mobileWebkit: mobile && webkit,
    mobileWebkit3d: mobile && webkit3d,
    mobileOpera: mobile && window.opera,

    touch: !!touch,
    msPointer: !!msPointer,
    pointer: !!pointer,

    retina: !!retina,
    orientation: function orientation() {
      var w = window.innerWidth,
          h = window.innerHeight,
          _orientation = "portrait";

      if (w > h) {
        _orientation = "landscape";
      }
      if (Math.abs(window.orientation) == 90) {}
      TL.trace(_orientation);
      return _orientation;
    }
  };
})();

TL.Load = function (doc) {
  var loaded = [];

  function isLoaded(url) {

    var i = 0,
        has_loaded = false;

    for (i = 0; i < loaded.length; i++) {
      if (loaded[i] == url) {
        has_loaded = true;
      }
    }

    if (has_loaded) {
      return true;
    } else {
      loaded.push(url);
      return false;
    }
  }

  return {

    css: function css(urls, callback, obj, context) {
      if (!isLoaded(urls)) {
        TL.LoadIt.css(urls, callback, obj, context);
      } else {
        callback();
      }
    },

    js: function js(urls, callback, obj, context) {
      if (!isLoaded(urls)) {
        TL.LoadIt.js(urls, callback, obj, context);
      } else {
        callback();
      }
    }
  };
}(window.document);

TL.LoadIt = function (doc) {
  var env,
      head,
      pending = {},
      pollCount = 0,
      queue = { css: [], js: [] },
      styleSheets = doc.styleSheets;

  function createNode(name, attrs) {
    var node = doc.createElement(name),
        attr;

    for (attr in attrs) {
      if (attrs.hasOwnProperty(attr)) {
        node.setAttribute(attr, attrs[attr]);
      }
    }

    return node;
  }

  function finish(type) {
    var p = pending[type],
        callback,
        urls;

    if (p) {
      callback = p.callback;
      urls = p.urls;

      urls.shift();
      pollCount = 0;

      if (!urls.length) {
        callback && callback.call(p.context, p.obj);
        pending[type] = null;
        queue[type].length && load(type);
      }
    }
  }

  function getEnv() {
    var ua = navigator.userAgent;

    env = {
      async: doc.createElement('script').async === true
    };

    (env.webkit = /AppleWebKit\//.test(ua)) || (env.ie = /MSIE/.test(ua)) || (env.opera = /Opera/.test(ua)) || (env.gecko = /Gecko\//.test(ua)) || (env.unknown = true);
  }

  function load(type, urls, callback, obj, context) {
    var _finish = function _finish() {
      finish(type);
    },
        isCSS = type === 'css',
        nodes = [],
        i,
        len,
        node,
        p,
        pendingUrls,
        url;

    env || getEnv();

    if (urls) {
      urls = typeof urls === 'string' ? [urls] : urls.concat();

      if (isCSS || env.async || env.gecko || env.opera) {
        queue[type].push({
          urls: urls,
          callback: callback,
          obj: obj,
          context: context
        });
      } else {
        for (i = 0, len = urls.length; i < len; ++i) {
          queue[type].push({
            urls: [urls[i]],
            callback: i === len - 1 ? callback : null,
            obj: obj,
            context: context
          });
        }
      }
    }

    if (pending[type] || !(p = pending[type] = queue[type].shift())) {
      return;
    }

    head || (head = doc.head || doc.getElementsByTagName('head')[0]);
    pendingUrls = p.urls;

    for (i = 0, len = pendingUrls.length; i < len; ++i) {
      url = pendingUrls[i];

      if (isCSS) {
        node = env.gecko ? createNode('style') : createNode('link', {
          href: url,
          rel: 'stylesheet'
        });
      } else {
        node = createNode('script', { src: url });
        node.async = false;
      }

      node.className = 'lazyload';
      node.setAttribute('charset', 'utf-8');

      if (env.ie && !isCSS) {
        node.onreadystatechange = function () {
          if (/loaded|complete/.test(node.readyState)) {
            node.onreadystatechange = null;
            _finish();
          }
        };
      } else if (isCSS && (env.gecko || env.webkit)) {
        if (env.webkit) {
          p.urls[i] = node.href;
          pollWebKit();
        } else {
          node.innerHTML = '@import "' + url + '";';
          pollGecko(node);
        }
      } else {
        node.onload = node.onerror = _finish;
      }

      nodes.push(node);
    }

    for (i = 0, len = nodes.length; i < len; ++i) {
      head.appendChild(nodes[i]);
    }
  }

  function pollGecko(node) {
    var hasRules;

    try {
      hasRules = !!node.sheet.cssRules;
    } catch (ex) {
      pollCount += 1;

      if (pollCount < 200) {
        setTimeout(function () {
          pollGecko(node);
        }, 50);
      } else {
        hasRules && finish('css');
      }

      return;
    }

    finish('css');
  }

  function pollWebKit() {
    var css = pending.css,
        i;

    if (css) {
      i = styleSheets.length;

      while (--i >= 0) {
        if (styleSheets[i].href === css.urls[0]) {
          finish('css');
          break;
        }
      }

      pollCount += 1;

      if (css) {
        if (pollCount < 200) {
          setTimeout(pollWebKit, 50);
        } else {
          finish('css');
        }
      }
    }
  }

  return {
    css: function css(urls, callback, obj, context) {
      load('css', urls, callback, obj, context);
    },

    js: function js(urls, callback, obj, context) {
      load('js', urls, callback, obj, context);
    }

  };
}(window.document);

TL.TimelineConfig = TL.Class.extend({

  includes: [],
  initialize: function initialize(data) {
    this.title = '';
    this.scale = '';
    this.events = [];
    this.eras = [];
    this.event_dict = {};
    this.messages = {
      errors: [],
      warnings: []
    };

    if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object' && data.events) {
      this.scale = data.scale;
      this.events = [];
      this._ensureValidScale(data.events);

      if (data.title) {
        var title_id = this._assignID(data.title);
        this._tidyFields(data.title);
        this.title = data.title;
        this.event_dict[title_id] = this.title;
      }

      for (var i = 0; i < data.events.length; i++) {
        try {
          this.addEvent(data.events[i], true);
        } catch (e) {
          this.logError(e);
        }
      }

      if (data.eras) {
        for (var i = 0; i < data.eras.length; i++) {
          try {
            this.addEra(data.eras[i], true);
          } catch (e) {
            this.logError("Era " + i + ": " + e);
          }
        }
      }

      TL.DateUtil.sortByDate(this.events);
      TL.DateUtil.sortByDate(this.eras);
    }
  },
  logError: function logError(msg) {
    TL.trace(msg);
    this.messages.errors.push(msg);
  },

  getErrors: function getErrors(sep) {
    if (sep) {
      return this.messages.errors.join(sep);
    } else {
      return this.messages.errors;
    }
  },

  validate: function validate() {
    if (typeof this.events == "undefined" || typeof this.events.length == "undefined" || this.events.length == 0) {
      this.logError("Timeline configuration has no events.");
    }

    for (var i = 0; i < this.eras.length; i++) {
      if (typeof this.eras[i].start_date == 'undefined' || typeof this.eras[i].end_date == 'undefined') {
        var era_identifier;
        if (this.eras[i].text && this.eras[i].text.headline) {
          era_identifier = this.eras[i].text.headline;
        } else {
          era_identifier = "era " + (i + 1);
        }
        this.logError("All eras must have start and end dates. [" + era_identifier + "]");
      }
    };
  },

  isValid: function isValid() {
    return this.messages.errors.length == 0;
  },

  addEvent: function addEvent(data, defer_sort) {
    var event_id = this._assignID(data);

    if (typeof data.start_date == 'undefined') {
      throw new TL.Error("missing_start_date_err", event_id);
    } else {
      this._processDates(data);
      this._tidyFields(data);
    }

    this.events.push(data);
    this.event_dict[event_id] = data;

    if (!defer_sort) {
      TL.DateUtil.sortByDate(this.events);
    }
    return event_id;
  },

  addEra: function addEra(data, defer_sort) {
    var event_id = this._assignID(data);

    if (typeof data.start_date == 'undefined') {
      throw new TL.Error("missing_start_date_err", event_id);
    } else {
      this._processDates(data);
      this._tidyFields(data);
    }

    this.eras.push(data);
    this.event_dict[event_id] = data;

    if (!defer_sort) {
      TL.DateUtil.sortByDate(this.eras);
    }
    return event_id;
  },

  _assignID: function _assignID(slide) {
    var slide_id = slide.unique_id;
    if (!TL.Util.trim(slide_id)) {
      slide_id = slide.text ? TL.Util.slugify(slide.text.headline) : null;
    }

    slide.unique_id = TL.Util.ensureUniqueKey(this.event_dict, slide_id);
    return slide.unique_id;
  },

  _makeUniqueIdentifiers: function _makeUniqueIdentifiers(title_id, array) {
    var used = [title_id];

    for (var i = 0; i < array.length; i++) {
      if (TL.Util.trim(array[i].unique_id)) {
        array[i].unique_id = TL.Util.slugify(array[i].unique_id);
        if (used.indexOf(array[i].unique_id) == -1) {
          used.push(array[i].unique_id);
        } else {
          array[i].unique_id = '';
        }
      }
    };

    if (used.length != array.length + 1) {
      for (var i = 0; i < array.length; i++) {
        if (!array[i].unique_id) {
          var slug = array[i].text ? TL.Util.slugify(array[i].text.headline) : null;
          if (!slug) {
            slug = TL.Util.unique_ID(6);
          }
          if (used.indexOf(slug) != -1) {
            slug = slug + '-' + i;
          }
          used.push(slug);
          array[i].unique_id = slug;
        }
      }
    }
  },
  _ensureValidScale: function _ensureValidScale(events) {
    if (!this.scale) {
      TL.trace("Determining scale dynamically");
      this.scale = "human";

      for (var i = 0; i < events.length; i++) {
        if (events[i].scale == 'cosmological') {
          this.scale = 'cosmological';
          break;
        }
        if (events[i].start_date && typeof events[i].start_date.year != "undefined") {
          var d = new TL.BigDate(events[i].start_date);
          var year = d.data.date_obj.year;
          if (year < -271820 || year > 275759) {
            this.scale = "cosmological";
            break;
          }
        }
      }
    }
    var dateCls = TL.DateUtil.SCALE_DATE_CLASSES[this.scale];
    if (!dateCls) {
      this.logError("Don't know how to process dates on scale " + this.scale);
    }
  },

  _processDates: function _processDates(slide_or_era) {
    var dateCls = TL.DateUtil.SCALE_DATE_CLASSES[this.scale];
    if (!(slide_or_era.start_date instanceof dateCls)) {
      var start_date = slide_or_era.start_date;
      slide_or_era.start_date = new dateCls(start_date);

      if (typeof slide_or_era.end_date != 'undefined' && !(slide_or_era.end_date instanceof dateCls)) {
        var end_date = slide_or_era.end_date;
        var equal = true;
        for (property in start_date) {
          equal = equal && start_date[property] == end_date[property];
        }
        if (equal) {
          TL.trace("End date same as start date is redundant; dropping end date");
          delete slide_or_era.end_date;
        } else {
          slide_or_era.end_date = new dateCls(end_date);
        }
      }
    }
  },

  getEarliestDate: function getEarliestDate() {
    var date = this.events[0].start_date;
    if (this.eras && this.eras.length > 0) {
      if (this.eras[0].start_date.isBefore(date)) {
        return this.eras[0].start_date;
      }
    }
    return date;
  },

  getLatestDate: function getLatestDate() {
    var dates = [];
    for (var i = 0; i < this.events.length; i++) {
      if (this.events[i].end_date) {
        dates.push({ date: this.events[i].end_date });
      } else {
        dates.push({ date: this.events[i].start_date });
      }
    }
    for (var i = 0; i < this.eras.length; i++) {
      if (this.eras[i].end_date) {
        dates.push({ date: this.eras[i].end_date });
      } else {
        dates.push({ date: this.eras[i].start_date });
      }
    }
    TL.DateUtil.sortByDate(dates, 'date');
    return dates.slice(-1)[0].date;
  },
  _tidyFields: function _tidyFields(slide) {

    function fillIn(obj, key, default_value) {
      if (!default_value) default_value = '';
      if (!obj.hasOwnProperty(key)) {
        obj[key] = default_value;
      }
    }

    if (slide.group) {
      slide.group = TL.Util.trim(slide.group);
    }

    if (!slide.text) {
      slide.text = {};
    }
    fillIn(slide.text, 'text');
    fillIn(slide.text, 'headline');
  }
});

;(function (TL) {
  function parseGoogleSpreadsheetURL(url) {
    var parts = {
      key: null,
      worksheet: 0 };

    var key_pat = /\bkey=([-_A-Za-z0-9]+)&?/i;
    var url_pat = /docs.google.com\/spreadsheets(.*?)\/d\//;

    if (url.match(key_pat)) {
      parts.key = url.match(key_pat)[1];
    } else if (url.match(url_pat)) {
      var pos = url.search(url_pat) + url.match(url_pat)[0].length;
      var tail = url.substr(pos);
      parts.key = tail.split('/')[0];
      if (url.match(/\?gid=(\d+)/)) {
        parts.worksheet = url.match(/\?gid=(\d+)/)[1];
      }
    } else if (url.match(/^\b[-_A-Za-z0-9]+$/)) {
      parts.key = url;
    }

    if (parts.key) {
      return parts;
    } else {
      return null;
    }
  }

  function extractGoogleEntryData_V1(item) {
    var item_data = {};
    for (k in item) {
      if (k.indexOf('gsx$') == 0) {
        item_data[k.substr(4)] = item[k].$t;
      }
    }
    if (TL.Util.isEmptyObject(item_data)) return null;
    var d = {
      media: {
        caption: item_data.mediacaption || '',
        credit: item_data.mediacredit || '',
        url: item_data.media || '',
        thumbnail: item_data.mediathumbnail || ''
      },
      text: {
        headline: item_data.headline || '',
        text: item_data.text || ''
      },
      group: item_data.tag || '',
      type: item_data.type || ''
    };
    if (item_data.startdate) {
      d['start_date'] = TL.Date.parseDate(item_data.startdate);
    }
    if (item_data.enddate) {
      d['end_date'] = TL.Date.parseDate(item_data.enddate);
    }

    return d;
  }

  function extractGoogleEntryData_V3(item) {

    function clean_integer(s) {
      if (s) {
        return s.replace(/[\s,]+/g, '');
      }
    }

    var item_data = {};
    for (k in item) {
      if (k.indexOf('gsx$') == 0) {
        item_data[k.substr(4)] = TL.Util.trim(item[k].$t);
      }
    }
    if (TL.Util.isEmptyObject(item_data)) return null;
    var d = {
      media: {
        caption: item_data.mediacaption || '',
        credit: item_data.mediacredit || '',
        url: item_data.media || '',
        thumbnail: item_data.mediathumbnail || ''
      },
      text: {
        headline: item_data.headline || '',
        text: item_data.text || ''
      },
      start_date: {
        year: clean_integer(item_data.year),
        month: clean_integer(item_data.month) || '',
        day: clean_integer(item_data.day) || ''
      },
      end_date: {
        year: clean_integer(item_data.endyear) || '',
        month: clean_integer(item_data.endmonth) || '',
        day: clean_integer(item_data.endday) || ''
      },
      display_date: item_data.displaydate || '',

      type: item_data.type || ''
    };

    if (item_data.time) {
      TL.Util.mergeData(d.start_date, TL.DateUtil.parseTime(item_data.time));
    }

    if (item_data.endtime) {
      TL.Util.mergeData(d.end_date, TL.DateUtil.parseTime(item_data.endtime));
    }

    if (item_data.group) {
      d.group = item_data.group;
    }

    if (d.end_date.year == '') {
      var bad_date = d.end_date;
      delete d.end_date;
      if (bad_date.month != '' || bad_date.day != '' || bad_date.time != '') {
        var label = d.text.headline || TL.trace("Invalid end date for spreadsheet row. Must have a year if any other date fields are specified.");
        TL.trace(item);
      }
    }

    if (item_data.background) {
      if (item_data.background.match(/^(https?:)?\/\/?/)) {
        d['background'] = { 'url': item_data.background };
      } else {
        d['background'] = { 'color': item_data.background };
      }
    }

    return d;
  }

  var getGoogleItemExtractor = function getGoogleItemExtractor(data) {
    if (typeof data.feed.entry === 'undefined' || data.feed.entry.length == 0) {
      throw new TL.Error("empty_feed_err");
    }
    var entry = data.feed.entry[0];

    if (typeof entry.gsx$startdate !== 'undefined') {
      return extractGoogleEntryData_V1;
    } else if (typeof entry.gsx$year !== 'undefined') {
      var headers_V3 = ['month', 'day', 'time', 'endmonth', 'endyear', 'endday', 'endtime', 'displaydate', 'headline', 'text', 'media', 'mediacredit', 'mediacaption', 'mediathumbnail', 'type', 'group', 'background'];

      return extractGoogleEntryData_V3;
    }
    throw new TL.Error("invalid_data_format_err");
  };

  var buildGoogleFeedURL = function buildGoogleFeedURL(parts) {
    return "https://spreadsheets.google.com/feeds/list/" + parts.key + "/1/public/values?alt=json";
  };

  var jsonFromGoogleURL = function jsonFromGoogleURL(url) {
    var url = buildGoogleFeedURL(parseGoogleSpreadsheetURL(url));
    var timeline_config = { 'events': [] };
    var data = TL.ajax({
      url: url,
      async: false
    });
    data = JSON.parse(data.responseText);
    return googleFeedJSONtoTimelineJSON(data);
  };

  var googleFeedJSONtoTimelineJSON = function googleFeedJSONtoTimelineJSON(data) {
    var timeline_config = { 'events': [], 'errors': [], 'warnings': [], 'eras': [] };
    var extract = getGoogleItemExtractor(data);
    for (var i = 0; i < data.feed.entry.length; i++) {
      try {
        var event = extract(data.feed.entry[i]);
        if (event) {
          var row_type = 'event';
          if (typeof event.type != 'undefined') {
            row_type = event.type;
            delete event.type;
          }
          if (row_type == 'title') {
            if (!timeline_config.title) {
              timeline_config.title = event;
            } else {
              timeline_config.warnings.push("Multiple title slides detected.");
              timeline_config.events.push(event);
            }
          } else if (row_type == 'era') {
            timeline_config.eras.push(event);
          } else {
            timeline_config.events.push(event);
          }
        }
      } catch (e) {
        if (e.message) {
          e = e.message;
        }
        timeline_config.errors.push(e + " [" + i + "]");
      }
    };
    return timeline_config;
  };

  var makeConfig = function makeConfig(url, callback) {
    var tc,
        key = parseGoogleSpreadsheetURL(url);

    if (key) {
      try {
        var json = jsonFromGoogleURL(url);
      } catch (e) {
        tc = new TL.TimelineConfig();
        if (e.name == 'NetworkError') {
          tc.logError(new TL.Error("network_err"));
        } else if (e.name == 'TL.Error') {
          tc.logError(e);
        } else {
          tc.logError(new TL.Error("unknown_read_err", e.name));
        }
        callback(tc);
        return;
      }
      tc = new TL.TimelineConfig(json);
      if (json.errors) {
        for (var i = 0; i < json.errors.length; i++) {
          tc.logError(json.errors[i]);
        };
      }
      callback(tc);
    } else {
      TL.ajax({
        url: url,
        dataType: 'json',
        success: function success(data) {
          try {
            tc = new TL.TimelineConfig(data);
          } catch (e) {
            tc = new TL.TimelineConfig();
            tc.logError(e);
          }
          callback(tc);
        },
        error: function error(xhr, errorType, error) {
          tc = new TL.TimelineConfig();
          if (errorType == 'parsererror') {
            var error = new TL.Error("invalid_url_err");
          } else {
            var error = new TL.Error("unknown_read_err", errorType);
          }
          tc.logError(error);
          callback(tc);
        }
      });
    }
  };

  TL.ConfigFactory = {
    parseGoogleSpreadsheetURL: parseGoogleSpreadsheetURL,

    googleFeedJSONtoTimelineJSON: googleFeedJSONtoTimelineJSON,

    fromGoogle: function fromGoogle(url) {
      console.warn("TL.ConfigFactory.fromGoogle is deprecated and will be removed soon. Use TL.ConfigFactory.makeConfig(url,callback)");
      return jsonFromGoogleURL(url);
    },

    makeConfig: makeConfig
  };
})(TL);

TL.Language = function (options) {
  for (var k in TL.Language.languages.en) {
    this[k] = TL.Language.languages.en[k];
  }
  if (options && options.language && typeof options.language == 'string' && options.language != 'en') {
    var code = options.language;
    if (!(code in TL.Language.languages)) {
      if (/\.json$/.test(code)) {
        var url = code;
      } else {
        var fragment = "/locale/" + code + ".json";
        var script_path = options.script_path || TL.Timeline.source_path;
        if (/\/$/.test(script_path)) {
          fragment = fragment.substr(1);
        }
        var url = script_path + fragment;
      }
      var self = this;
      var xhr = TL.ajax({
        url: url, async: false
      });
      if (xhr.status == 200) {
        TL.Language.languages[code] = JSON.parse(xhr.responseText);
      } else {
        throw "Could not load language [" + code + "]: " + xhr.statusText;
      }
    }
    TL.Util.mergeData(this, TL.Language.languages[code]);
  }
};

TL.Language.formatNumber = function (val, mask) {
  if (mask.match(/%(\.(\d+))?f/)) {
    var match = mask.match(/%(\.(\d+))?f/);
    var token = match[0];
    if (match[2]) {
      val = val.toFixed(match[2]);
    }
    return mask.replace(token, val);
  }

  return mask;
};

TL.Language.prototype.mergeData = function (lang_json) {
  for (k in TL.Language.languages.en) {
    if (lang_json[k]) {
      if ((0, _typeof3.default)(this[k]) == 'object') {
        TL.Util.mergeData(lang_json[k], this[k]);
      } else {
        this[k] = lang_json[k];
      }
    }
  }
};

TL.Language.fallback = { messages: {} };
TL.Language.prototype.getMessage = function (k) {
  return this.messages[k] || TL.Language.fallback.messages[k] || k;
};

TL.Language.prototype._ = TL.Language.prototype.getMessage;

TL.Language.prototype.formatDate = function (date, format_name) {

  if (date.constructor == Date) {
    return this.formatJSDate(date, format_name);
  }

  if (date.constructor == TL.BigYear) {
    return this.formatBigYear(date, format_name);
  }

  if (date.data && date.data.date_obj) {
    return this.formatDate(date.data.date_obj, format_name);
  }

  TL.trace("Unfamiliar date presented for formatting");
  return date.toString();
};

TL.Language.prototype.formatBigYear = function (bigyear, format_name) {
  var the_year = bigyear.year;
  var format_list = this.bigdateformats[format_name] || this.bigdateformats['fallback'];

  if (format_list) {
    for (var i = 0; i < format_list.length; i++) {
      var tuple = format_list[i];
      if (Math.abs(the_year / tuple[0]) > 1) {
        return TL.Language.formatNumber(Math.abs(the_year / tuple[0]), tuple[1]);
      }
    };

    return the_year.toString();
  } else {
    TL.trace("Language file dateformats missing cosmological. Falling back.");
    return TL.Language.formatNumber(the_year, format_name);
  }
};

TL.Language.prototype.formatJSDate = function (js_date, format_name) {
  var self = this;
  var formatPeriod = function formatPeriod(fmt, value) {
    var formats = self.period_labels[fmt];
    if (formats) {
      var fmt = value < 12 ? formats[0] : formats[1];
    }
    return "<span class='tl-timeaxis-timesuffix'>" + fmt + "</span>";
  };

  var utc = false,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g;

  if (!format_name) {
    format_name = 'full';
  }

  var mask = this.dateformats[format_name] || TL.Language.fallback.dateformats[format_name];
  if (!mask) {
    mask = format_name;
  }

  var _ = utc ? "getUTC" : "get",
      d = js_date[_ + "Date"](),
      D = js_date[_ + "Day"](),
      m = js_date[_ + "Month"](),
      y = js_date[_ + "FullYear"](),
      H = js_date[_ + "Hours"](),
      M = js_date[_ + "Minutes"](),
      s = js_date[_ + "Seconds"](),
      L = js_date[_ + "Milliseconds"](),
      o = utc ? 0 : js_date.getTimezoneOffset(),
      year = "",
      flags = {
    d: d,
    dd: TL.Util.pad(d),
    ddd: this.date.day_abbr[D],
    dddd: this.date.day[D],
    m: m + 1,
    mm: TL.Util.pad(m + 1),
    mmm: this.date.month_abbr[m],
    mmmm: this.date.month[m],
    yy: String(y).slice(2),
    yyyy: y < 0 && this.has_negative_year_modifier() ? Math.abs(y) : y,
    h: H % 12 || 12,
    hh: TL.Util.pad(H % 12 || 12),
    H: H,
    HH: TL.Util.pad(H),
    M: M,
    MM: TL.Util.pad(M),
    s: s,
    ss: TL.Util.pad(s),
    l: TL.Util.pad(L, 3),
    L: TL.Util.pad(L > 99 ? Math.round(L / 10) : L),
    t: formatPeriod('t', H),
    tt: formatPeriod('tt', H),
    T: formatPeriod('T', H),
    TT: formatPeriod('TT', H),
    Z: utc ? "UTC" : (String(js_date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
    o: (o > 0 ? "-" : "+") + TL.Util.pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
    S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
  };

  var formatted = mask.replace(TL.Language.DATE_FORMAT_TOKENS, function ($0) {
    return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
  });

  return this._applyEra(formatted, y);
};

TL.Language.prototype.has_negative_year_modifier = function () {
  return Boolean(this.era_labels.negative_year.prefix || this.era_labels.negative_year.suffix);
};

TL.Language.prototype._applyEra = function (formatted_date, original_year) {
  var labels = original_year < 0 ? this.era_labels.negative_year : this.era_labels.positive_year;
  var result = '';
  if (labels.prefix) {
    result += '<span>' + labels.prefix + '</span> ';
  }
  result += formatted_date;
  if (labels.suffix) {
    result += ' <span>' + labels.suffix + '</span>';
  }
  return result;
};

TL.Language.DATE_FORMAT_TOKENS = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g;

TL.Language.languages = {
  en: {
    name: "English",
    lang: "en",
    api: {
      wikipedia: "en" },
    messages: {
      loading: "Loading",
      wikipedia: "From Wikipedia, the free encyclopedia",
      error: "Error",
      contract_timeline: "Contract Timeline",
      return_to_title: "Return to Title",
      loading_content: "Loading Content",
      expand_timeline: "Expand Timeline",
      loading_timeline: "Loading Timeline... ",
      swipe_to_navigate: "Swipe to Navigate<br><span class='tl-button'>OK</span>",
      unknown_read_err: "An unexpected error occurred trying to read your spreadsheet data",
      invalid_url_err: "Unable to read Timeline data. Make sure your URL is for a Google Spreadsheet or a Timeline JSON file.",
      network_err: "Unable to read your Google Spreadsheet. Make sure you have published it to the web.",
      empty_feed_err: "No data entries found",
      missing_start_date_err: "Missing start_date",
      invalid_data_format_err: "Header row has been modified.",
      date_compare_err: "Can't compare TL.Dates on different scales",
      invalid_scale_err: "Invalid scale",
      invalid_date_err: "Invalid date: month, day and year must be numbers.",
      invalid_separator_error: "Invalid time: misuse of : or . as separator.",
      invalid_hour_err: "Invalid time (hour)",
      invalid_minute_err: "Invalid time (minute)",
      invalid_second_err: "Invalid time (second)",
      invalid_fractional_err: "Invalid time (fractional seconds)",
      invalid_second_fractional_err: "Invalid time (seconds and fractional seconds)",
      invalid_year_err: "Invalid year",
      flickr_notfound_err: "Photo not found or private",
      flickr_invalidurl_err: "Invalid Flickr URL",
      imgur_invalidurl_err: "Invalid Imgur URL",
      twitter_invalidurl_err: "Invalid Twitter URL",
      twitter_load_err: "Unable to load Tweet",
      twitterembed_invalidurl_err: "Invalid Twitter Embed url",
      wikipedia_load_err: "Unable to load Wikipedia entry",
      youtube_invalidurl_err: "Invalid YouTube URL",
      spotify_invalid_url: "Invalid Spotify URL",
      template_value_err: "No value provided for variable",
      invalid_rgb_err: "Invalid RGB argument",
      time_scale_scale_err: "Don't know how to get date from time for scale",
      axis_helper_no_options_err: "Axis helper must be configured with options",
      axis_helper_scale_err: "No AxisHelper available for scale",
      invalid_integer_option: "Invalid option value—must be a whole number."
    },
    date: {
      month: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      month_abbr: ["Jan.", "Feb.", "March", "April", "May", "June", "July", "Aug.", "Sept.", "Oct.", "Nov.", "Dec."],
      day: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      day_abbr: ["Sun.", "Mon.", "Tues.", "Wed.", "Thurs.", "Fri.", "Sat."]
    },
    era_labels: {
      positive_year: {
        prefix: '',
        suffix: ''
      },
      negative_year: {
        prefix: '',
        suffix: 'BCE'
      }
    },
    period_labels: {
      t: ['a', 'p'],
      tt: ['am', 'pm'],
      T: ['A', 'P'],
      TT: ['AM', 'PM']
    },
    dateformats: {
      year: "yyyy",
      month_short: "mmm",
      month: "mmmm yyyy",
      full_short: "mmm d",
      full: "mmmm d',' yyyy",
      time: "h:MM:ss TT' <small>'mmmm d',' yyyy'</small>'",
      time_short: "h:MM:ss TT",
      time_no_seconds_short: "h:MM TT",
      time_no_minutes_short: "h TT",
      time_no_seconds_small_date: "h:MM TT' <small>'mmmm d',' yyyy'</small>'",
      time_milliseconds: "l",
      full_long: "mmm d',' yyyy 'at' h:MM TT",
      full_long_small_date: "h:MM TT' <small>mmm d',' yyyy'</small>'"
    },
    bigdateformats: {
      fallback: [[1000000000, "%.2f billion years ago"], [1000000, "%.1f million years ago"], [1000, "%.1f thousand years ago"], [1, "%f years ago"]],
      compact: [[1000000000, "%.2f bya"], [1000000, "%.1f mya"], [1000, "%.1f kya"], [1, "%f years ago"]],
      verbose: [[1000000000, "%.2f billion years ago"], [1000000, "%.1f million years ago"], [1000, "%.1f thousand years ago"], [1, "%f years ago"]]
    }
  }
};

TL.Language.fallback = new TL.Language();

TL.I18NMixins = {
  getLanguage: function getLanguage() {
    if (this.options && this.options.language) {
      return this.options.language;
    }
    TL.trace("Expected a language option");
    return TL.Language.fallback;
  },

  _: function _(msg) {
    return this.getLanguage()._(msg);
  }
};

TL.Easings = {
  ease: [0.25, 0.1, 0.25, 1.0],
  linear: [0.00, 0.0, 1.00, 1.0],
  easein: [0.42, 0.0, 1.00, 1.0],
  easeout: [0.00, 0.0, 0.58, 1.0],
  easeinout: [0.42, 0.0, 0.58, 1.0]
};

TL.Ease = {
  KeySpline: function KeySpline(a) {
    this.get = function (aX) {
      if (a[0] == a[1] && a[2] == a[3]) return aX;
      return CalcBezier(GetTForX(aX), a[1], a[3]);
    };

    function A(aA1, aA2) {
      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }

    function B(aA1, aA2) {
      return 3.0 * aA2 - 6.0 * aA1;
    }

    function C(aA1) {
      return 3.0 * aA1;
    }

    function CalcBezier(aT, aA1, aA2) {
      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }

    function GetSlope(aT, aA1, aA2) {
      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function GetTForX(aX) {
      var aGuessT = aX;
      for (var i = 0; i < 4; ++i) {
        var currentSlope = GetSlope(aGuessT, a[0], a[2]);
        if (currentSlope == 0.0) return aGuessT;
        var currentX = CalcBezier(aGuessT, a[0], a[2]) - aX;
        aGuessT -= currentX / currentSlope;
      }
      return aGuessT;
    }
  },

  easeInSpline: function easeInSpline(t) {
    var spline = new TL.Ease.KeySpline(TL.Easings.easein);
    return spline.get(t);
  },

  easeInOutExpo: function easeInOutExpo(t) {
    var spline = new TL.Ease.KeySpline(TL.Easings.easein);
    return spline.get(t);
  },

  easeOut: function easeOut(t) {
    return Math.sin(t * Math.PI / 2);
  },
  easeOutStrong: function easeOutStrong(t) {
    return t == 1 ? 1 : 1 - Math.pow(2, -10 * t);
  },
  easeIn: function easeIn(t) {
    return t * t;
  },
  easeInStrong: function easeInStrong(t) {
    return t == 0 ? 0 : Math.pow(2, 10 * (t - 1));
  },
  easeOutBounce: function easeOutBounce(pos) {
    if (pos < 1 / 2.75) {
      return 7.5625 * pos * pos;
    } else if (pos < 2 / 2.75) {
      return 7.5625 * (pos -= 1.5 / 2.75) * pos + .75;
    } else if (pos < 2.5 / 2.75) {
      return 7.5625 * (pos -= 2.25 / 2.75) * pos + .9375;
    } else {
      return 7.5625 * (pos -= 2.625 / 2.75) * pos + .984375;
    }
  },
  easeInBack: function easeInBack(pos) {
    var s = 1.70158;
    return pos * pos * ((s + 1) * pos - s);
  },
  easeOutBack: function easeOutBack(pos) {
    var s = 1.70158;
    return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
  },
  bounce: function bounce(t) {
    if (t < 1 / 2.75) {
      return 7.5625 * t * t;
    }
    if (t < 2 / 2.75) {
      return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
    }
    if (t < 2.5 / 2.75) {
      return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
    }
    return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  bouncePast: function bouncePast(pos) {
    if (pos < 1 / 2.75) {
      return 7.5625 * pos * pos;
    } else if (pos < 2 / 2.75) {
      return 2 - (7.5625 * (pos -= 1.5 / 2.75) * pos + .75);
    } else if (pos < 2.5 / 2.75) {
      return 2 - (7.5625 * (pos -= 2.25 / 2.75) * pos + .9375);
    } else {
      return 2 - (7.5625 * (pos -= 2.625 / 2.75) * pos + .984375);
    }
  },
  swingTo: function swingTo(pos) {
    var s = 1.70158;
    return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
  },
  swingFrom: function swingFrom(pos) {
    var s = 1.70158;
    return pos * pos * ((s + 1) * pos - s);
  },
  elastic: function elastic(pos) {
    return -1 * Math.pow(4, -8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
  },
  spring: function spring(pos) {
    return 1 - Math.cos(pos * 4.5 * Math.PI) * Math.exp(-pos * 6);
  },
  blink: function blink(pos, blinks) {
    return Math.round(pos * (blinks || 5)) % 2;
  },
  pulse: function pulse(pos, pulses) {
    return -Math.cos(pos * ((pulses || 5) - .5) * 2 * Math.PI) / 2 + .5;
  },
  wobble: function wobble(pos) {
    return -Math.cos(pos * Math.PI * (9 * pos)) / 2 + 0.5;
  },
  sinusoidal: function sinusoidal(pos) {
    return -Math.cos(pos * Math.PI) / 2 + 0.5;
  },
  flicker: function flicker(pos) {
    var pos = pos + (Math.random() - 0.5) / 5;
    return easings.sinusoidal(pos < 0 ? 0 : pos > 1 ? 1 : pos);
  },
  mirror: function mirror(pos) {
    if (pos < 0.5) return easings.sinusoidal(pos * 2);else return easings.sinusoidal(1 - (pos - 0.5) * 2);
  },

  easeInQuad: function easeInQuad(t) {
    return t * t;
  },

  easeOutQuad: function easeOutQuad(t) {
    return t * (2 - t);
  },

  easeInOutQuad: function easeInOutQuad(t) {
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },

  easeInCubic: function easeInCubic(t) {
    return t * t * t;
  },

  easeOutCubic: function easeOutCubic(t) {
    return --t * t * t + 1;
  },

  easeInOutCubic: function easeInOutCubic(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },

  easeInQuart: function easeInQuart(t) {
    return t * t * t * t;
  },

  easeOutQuart: function easeOutQuart(t) {
    return 1 - --t * t * t * t;
  },

  easeInOutQuart: function easeInOutQuart(t) {
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },

  easeInQuint: function easeInQuint(t) {
    return t * t * t * t * t;
  },

  easeOutQuint: function easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
  },

  easeInOutQuint: function easeInOutQuint(t) {
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  }
};

TL.Animate = function (el, options) {
  var animation = new tlanimate(el, options),
      webkit_timeout;

  return animation;
};

window.tlanimate = function () {

  var doc = document,
      win = window,
      perf = win.performance,
      perfNow = perf && (perf.now || perf.webkitNow || perf.msNow || perf.mozNow),
      now = perfNow ? function () {
    return perfNow.call(perf);
  } : function () {
    return +new Date();
  },
      html = doc.documentElement,
      fixTs = false,
      thousand = 1000,
      rgbOhex = /^rgb\(|#/,
      relVal = /^([+\-])=([\d\.]+)/,
      numUnit = /^(?:[\+\-]=?)?\d+(?:\.\d+)?(%|in|cm|mm|em|ex|pt|pc|px)$/,
      rotate = /rotate\(((?:[+\-]=)?([\-\d\.]+))deg\)/,
      scale = /scale\(((?:[+\-]=)?([\d\.]+))\)/,
      skew = /skew\(((?:[+\-]=)?([\-\d\.]+))deg, ?((?:[+\-]=)?([\-\d\.]+))deg\)/,
      translate = /translate\(((?:[+\-]=)?([\-\d\.]+))px, ?((?:[+\-]=)?([\-\d\.]+))px\)/,
      unitless = { lineHeight: 1, zoom: 1, zIndex: 1, opacity: 1, transform: 1 };

  var transform = function () {
    var styles = doc.createElement('a').style,
        props = ['webkitTransform', 'MozTransform', 'OTransform', 'msTransform', 'Transform'],
        i;

    for (i = 0; i < props.length; i++) {
      if (props[i] in styles) return props[i];
    };
  }();

  var opacity = function () {
    return typeof doc.createElement('a').style.opacity !== 'undefined';
  }();

  var getStyle = doc.defaultView && doc.defaultView.getComputedStyle ? function (el, property) {
    property = property == 'transform' ? transform : property;
    property = camelize(property);
    var value = null,
        computed = doc.defaultView.getComputedStyle(el, '');

    computed && (value = computed[property]);
    return el.style[property] || value;
  } : html.currentStyle ? function (el, property) {
    property = camelize(property);

    if (property == 'opacity') {
      var val = 100;
      try {
        val = el.filters['DXImageTransform.Microsoft.Alpha'].opacity;
      } catch (e1) {
        try {
          val = el.filters('alpha').opacity;
        } catch (e2) {}
      }
      return val / 100;
    }
    var value = el.currentStyle ? el.currentStyle[property] : null;
    return el.style[property] || value;
  } : function (el, property) {
    return el.style[camelize(property)];
  };

  var frame = function () {
    return win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || win.oRequestAnimationFrame || function (callback) {
      win.setTimeout(function () {
        callback(+new Date());
      }, 17);
    };
  }();

  var children = [];

  frame(function (timestamp) {
    fixTs = timestamp > 1e12 != now() > 1e12;
  });

  function has(array, elem, i) {
    if (Array.prototype.indexOf) return array.indexOf(elem);
    for (i = 0; i < array.length; ++i) {
      if (array[i] === elem) return i;
    }
  }

  function render(timestamp) {
    var i,
        count = children.length;

    if (perfNow && timestamp > 1e12) timestamp = now();
    if (fixTs) timestamp = now();
    for (i = count; i--;) {
      children[i](timestamp);
    }
    children.length && frame(render);
  }

  function live(f) {
    if (children.push(f) === 1) frame(render);
  }

  function die(f) {
    var rest,
        index = has(children, f);
    if (index >= 0) {
      rest = children.slice(index + 1);
      children.length = index;
      children = children.concat(rest);
    }
  }

  function parseTransform(style, base) {
    var values = {},
        m;
    if (m = style.match(rotate)) values.rotate = by(m[1], base ? base.rotate : null);
    if (m = style.match(scale)) values.scale = by(m[1], base ? base.scale : null);
    if (m = style.match(skew)) {
      values.skewx = by(m[1], base ? base.skewx : null);values.skewy = by(m[3], base ? base.skewy : null);
    }
    if (m = style.match(translate)) {
      values.translatex = by(m[1], base ? base.translatex : null);values.translatey = by(m[3], base ? base.translatey : null);
    }
    return values;
  }

  function formatTransform(v) {
    var s = '';
    if ('rotate' in v) s += 'rotate(' + v.rotate + 'deg) ';
    if ('scale' in v) s += 'scale(' + v.scale + ') ';
    if ('translatex' in v) s += 'translate(' + v.translatex + 'px,' + v.translatey + 'px) ';
    if ('skewx' in v) s += 'skew(' + v.skewx + 'deg,' + v.skewy + 'deg)';
    return s;
  }

  function rgb(r, g, b) {
    return '#' + (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
  }

  function toHex(c) {
    var m = c.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    return (m ? rgb(m[1], m[2], m[3]) : c).replace(/#(\w)(\w)(\w)$/, '#$1$1$2$2$3$3');
  }

  function camelize(s) {
    return s.replace(/-(.)/g, function (m, m1) {
      return m1.toUpperCase();
    });
  }

  function fun(f) {
    return typeof f == 'function';
  }

  function nativeTween(t) {
    return Math.sin(t * Math.PI / 2);
  }

  function tween(duration, fn, done, ease, from, to) {
    ease = fun(ease) ? ease : morpheus.easings[ease] || nativeTween;
    var time = duration || thousand,
        self = this,
        diff = to - from,
        start = now(),
        _stop = 0,
        end = 0;

    function run(t) {
      var delta = t - start;
      if (delta > time || _stop) {
        to = isFinite(to) ? to : 1;
        _stop ? end && fn(to) : fn(to);
        die(run);
        return done && done.apply(self);
      }

      isFinite(to) ? fn(diff * ease(delta / time) + from) : fn(ease(delta / time));
    }

    live(run);

    return {
      stop: function stop(jump) {
        _stop = 1;
        end = jump;
        if (!jump) done = null;
      }
    };
  }

  function bezier(points, pos) {
    var n = points.length,
        r = [],
        i,
        j;
    for (i = 0; i < n; ++i) {
      r[i] = [points[i][0], points[i][1]];
    }
    for (j = 1; j < n; ++j) {
      for (i = 0; i < n - j; ++i) {
        r[i][0] = (1 - pos) * r[i][0] + pos * r[parseInt(i + 1, 10)][0];
        r[i][1] = (1 - pos) * r[i][1] + pos * r[parseInt(i + 1, 10)][1];
      }
    }
    return [r[0][0], r[0][1]];
  }

  function nextColor(pos, start, finish) {
    var r = [],
        i,
        e,
        from,
        to;
    for (i = 0; i < 6; i++) {
      from = Math.min(15, parseInt(start.charAt(i), 16));
      to = Math.min(15, parseInt(finish.charAt(i), 16));
      e = Math.floor((to - from) * pos + from);
      e = e > 15 ? 15 : e < 0 ? 0 : e;
      r[i] = e.toString(16);
    }
    return '#' + r.join('');
  }

  function getTweenVal(pos, units, begin, end, k, i, v) {
    if (k == 'transform') {
      v = {};
      for (var t in begin[i][k]) {
        v[t] = t in end[i][k] ? Math.round(((end[i][k][t] - begin[i][k][t]) * pos + begin[i][k][t]) * thousand) / thousand : begin[i][k][t];
      }
      return v;
    } else if (typeof begin[i][k] == 'string') {
      return nextColor(pos, begin[i][k], end[i][k]);
    } else {
      v = Math.round(((end[i][k] - begin[i][k]) * pos + begin[i][k]) * thousand) / thousand;

      if (!(k in unitless)) v += units[i][k] || 'px';
      return v;
    }
  }

  function by(val, start, m, r, i) {
    return (m = relVal.exec(val)) ? (i = parseFloat(m[2])) && start + (m[1] == '+' ? 1 : -1) * i : parseFloat(val);
  }

  function morpheus(elements, options) {
    var els = elements ? els = isFinite(elements.length) ? elements : [elements] : [],
        i,
        complete = options.complete,
        duration = options.duration,
        ease = options.easing,
        points = options.bezier,
        begin = [],
        end = [],
        units = [],
        bez = [],
        originalLeft,
        originalTop;

    if (points) {
      originalLeft = options.left;
      originalTop = options.top;
      delete options.right;
      delete options.bottom;
      delete options.left;
      delete options.top;
    }

    for (i = els.length; i--;) {
      begin[i] = {};
      end[i] = {};
      units[i] = {};

      if (points) {

        var left = getStyle(els[i], 'left'),
            top = getStyle(els[i], 'top'),
            xy = [by(fun(originalLeft) ? originalLeft(els[i]) : originalLeft || 0, parseFloat(left)), by(fun(originalTop) ? originalTop(els[i]) : originalTop || 0, parseFloat(top))];

        bez[i] = fun(points) ? points(els[i], xy) : points;
        bez[i].push(xy);
        bez[i].unshift([parseInt(left, 10), parseInt(top, 10)]);
      }

      for (var k in options) {
        switch (k) {
          case 'complete':
          case 'duration':
          case 'easing':
          case 'bezier':
            continue;
        }
        var v = getStyle(els[i], k),
            unit,
            tmp = fun(options[k]) ? options[k](els[i]) : options[k];
        if (typeof tmp == 'string' && rgbOhex.test(tmp) && !rgbOhex.test(v)) {
          delete options[k];
          continue;
        }

        begin[i][k] = k == 'transform' ? parseTransform(v) : typeof tmp == 'string' && rgbOhex.test(tmp) ? toHex(v).slice(1) : parseFloat(v);
        end[i][k] = k == 'transform' ? parseTransform(tmp, begin[i][k]) : typeof tmp == 'string' && tmp.charAt(0) == '#' ? toHex(tmp).slice(1) : by(tmp, parseFloat(v));

        typeof tmp == 'string' && (unit = tmp.match(numUnit)) && (units[i][k] = unit[1]);
      }
    }

    return tween.apply(els, [duration, function (pos, v, xy) {
      for (i = els.length; i--;) {
        if (points) {
          xy = bezier(bez[i], pos);
          els[i].style.left = xy[0] + 'px';
          els[i].style.top = xy[1] + 'px';
        }
        for (var k in options) {
          v = getTweenVal(pos, units, begin, end, k, i);
          k == 'transform' ? els[i].style[transform] = formatTransform(v) : k == 'opacity' && !opacity ? els[i].style.filter = 'alpha(opacity=' + v * 100 + ')' : els[i].style[camelize(k)] = v;
        }
      }
    }, complete, ease]);
  }

  morpheus.tween = tween;
  morpheus.getStyle = getStyle;
  morpheus.bezier = bezier;
  morpheus.transform = transform;
  morpheus.parseTransform = parseTransform;
  morpheus.formatTransform = formatTransform;
  morpheus.easings = {};

  return morpheus;
}();

TL.Point = function (x, y, round) {
  this.x = round ? Math.round(x) : x;
  this.y = round ? Math.round(y) : y;
};

TL.Point.prototype = {
  add: function add(point) {
    return this.clone()._add(point);
  },

  _add: function _add(point) {
    this.x += point.x;
    this.y += point.y;
    return this;
  },

  subtract: function subtract(point) {
    return this.clone()._subtract(point);
  },

  _subtract: function _subtract(point) {
    this.x -= point.x;
    this.y -= point.y;
    return this;
  },

  divideBy: function divideBy(num, round) {
    return new TL.Point(this.x / num, this.y / num, round);
  },

  multiplyBy: function multiplyBy(num) {
    return new TL.Point(this.x * num, this.y * num);
  },

  distanceTo: function distanceTo(point) {
    var x = point.x - this.x,
        y = point.y - this.y;
    return Math.sqrt(x * x + y * y);
  },

  round: function round() {
    return this.clone()._round();
  },

  _round: function _round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  },

  clone: function clone() {
    return new TL.Point(this.x, this.y);
  },

  toString: function toString() {
    return 'Point(' + TL.Util.formatNum(this.x) + ', ' + TL.Util.formatNum(this.y) + ')';
  }
};

TL.DomMixins = {
  show: function show(animate) {
    if (animate) {} else {
      this._el.container.style.display = "block";
    }
  },

  hide: function hide(animate) {
    this._el.container.style.display = "none";
  },

  addTo: function addTo(container) {
    container.appendChild(this._el.container);
    this.onAdd();
  },

  removeFrom: function removeFrom(container) {
    container.removeChild(this._el.container);
    this.onRemove();
  },

  animatePosition: function animatePosition(pos, el) {
    var ani = {
      duration: this.options.duration,
      easing: this.options.ease
    };
    for (var name in pos) {
      if (pos.hasOwnProperty(name)) {
        ani[name] = pos[name] + "px";
      }
    }

    if (this.animator) {
      this.animator.stop();
    }
    this.animator = TL.Animate(el, ani);
  },

  onLoaded: function onLoaded() {
    this.fire("loaded", this.data);
  },

  onAdd: function onAdd() {
    this.fire("added", this.data);
  },

  onRemove: function onRemove() {
    this.fire("removed", this.data);
  },

  setPosition: function setPosition(pos, el) {
    for (var name in pos) {
      if (pos.hasOwnProperty(name)) {
        if (el) {
          el.style[name] = pos[name] + "px";
        } else {
          this._el.container.style[name] = pos[name] + "px";
        };
      }
    }
  },

  getPosition: function getPosition() {
    return TL.Dom.getPosition(this._el.container);
  }

};

TL.Dom = {

  get: function get(id) {
    return typeof id === 'string' ? document.getElementById(id) : id;
  },

  getByClass: function getByClass(id) {
    if (id) {
      return document.getElementsByClassName(id);
    }
  },

  create: function create(tagName, className, container) {
    var el = document.createElement(tagName);
    el.className = className;
    if (container) {
      container.appendChild(el);
    }
    return el;
  },

  createText: function createText(content, container) {
    var el = document.createTextNode(content);
    if (container) {
      container.appendChild(el);
    }
    return el;
  },

  getTranslateString: function getTranslateString(point) {
    return TL.Dom.TRANSLATE_OPEN + point.x + 'px,' + point.y + 'px' + TL.Dom.TRANSLATE_CLOSE;
  },

  setPosition: function setPosition(el, point) {
    el._tl_pos = point;
    if (TL.Browser.webkit3d) {
      el.style[TL.Dom.TRANSFORM] = TL.Dom.getTranslateString(point);

      if (TL.Browser.android) {
        el.style['-webkit-perspective'] = '1000';
        el.style['-webkit-backface-visibility'] = 'hidden';
      }
    } else {
      el.style.left = point.x + 'px';
      el.style.top = point.y + 'px';
    }
  },

  getPosition: function getPosition(el) {
    var pos = {
      x: 0,
      y: 0
    };
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
      pos.x += el.offsetLeft;
      pos.y += el.offsetTop;
      el = el.offsetParent;
    }
    return pos;
  },

  testProp: function testProp(props) {
    var style = document.documentElement.style;

    for (var i = 0; i < props.length; i++) {
      if (props[i] in style) {
        return props[i];
      }
    }
    return false;
  }

};

TL.Util.mergeData(TL.Dom, {
  TRANSITION: TL.Dom.testProp(['transition', 'webkitTransition', 'OTransition', 'MozTransition', 'msTransition']),
  TRANSFORM: TL.Dom.testProp(['transformProperty', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']),

  TRANSLATE_OPEN: 'translate' + (TL.Browser.webkit3d ? '3d(' : '('),
  TRANSLATE_CLOSE: TL.Browser.webkit3d ? ',0)' : ')'
});

TL.DomUtil = {
  get: function get(id) {
    return typeof id === 'string' ? document.getElementById(id) : id;
  },

  getStyle: function getStyle(el, style) {
    var value = el.style[style];
    if (!value && el.currentStyle) {
      value = el.currentStyle[style];
    }
    if (!value || value === 'auto') {
      var css = document.defaultView.getComputedStyle(el, null);
      value = css ? css[style] : null;
    }
    return value === 'auto' ? null : value;
  },

  getViewportOffset: function getViewportOffset(element) {
    var top = 0,
        left = 0,
        el = element,
        docBody = document.body;

    do {
      top += el.offsetTop || 0;
      left += el.offsetLeft || 0;

      if (el.offsetParent === docBody && TL.DomUtil.getStyle(el, 'position') === 'absolute') {
        break;
      }
      el = el.offsetParent;
    } while (el);

    el = element;

    do {
      if (el === docBody) {
        break;
      }

      top -= el.scrollTop || 0;
      left -= el.scrollLeft || 0;

      el = el.parentNode;
    } while (el);

    return new TL.Point(left, top);
  },

  create: function create(tagName, className, container) {
    var el = document.createElement(tagName);
    el.className = className;
    if (container) {
      container.appendChild(el);
    }
    return el;
  },

  disableTextSelection: function disableTextSelection() {
    if (document.selection && document.selection.empty) {
      document.selection.empty();
    }
    if (!this._onselectstart) {
      this._onselectstart = document.onselectstart;
      document.onselectstart = TL.Util.falseFn;
    }
  },

  enableTextSelection: function enableTextSelection() {
    document.onselectstart = this._onselectstart;
    this._onselectstart = null;
  },

  hasClass: function hasClass(el, name) {
    return el.className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(el.className);
  },

  addClass: function addClass(el, name) {
    if (!TL.DomUtil.hasClass(el, name)) {
      el.className += (el.className ? ' ' : '') + name;
    }
  },

  removeClass: function removeClass(el, name) {
    el.className = el.className.replace(/(\S+)\s*/g, function (w, match) {
      if (match === name) {
        return '';
      }
      return w;
    }).replace(/^\s+/, '');
  },

  setOpacity: function setOpacity(el, value) {
    if (TL.Browser.ie) {
      el.style.filter = 'alpha(opacity=' + Math.round(value * 100) + ')';
    } else {
      el.style.opacity = value;
    }
  },

  testProp: function testProp(props) {
    var style = document.documentElement.style;

    for (var i = 0; i < props.length; i++) {
      if (props[i] in style) {
        return props[i];
      }
    }
    return false;
  },

  getTranslateString: function getTranslateString(point) {

    return TL.DomUtil.TRANSLATE_OPEN + point.x + 'px,' + point.y + 'px' + TL.DomUtil.TRANSLATE_CLOSE;
  },

  getScaleString: function getScaleString(scale, origin) {
    var preTranslateStr = TL.DomUtil.getTranslateString(origin),
        scaleStr = ' scale(' + scale + ') ',
        postTranslateStr = TL.DomUtil.getTranslateString(origin.multiplyBy(-1));

    return preTranslateStr + scaleStr + postTranslateStr;
  },

  setPosition: function setPosition(el, point) {
    el._tl_pos = point;
    if (TL.Browser.webkit3d) {
      el.style[TL.DomUtil.TRANSFORM] = TL.DomUtil.getTranslateString(point);

      if (TL.Browser.android) {
        el.style['-webkit-perspective'] = '1000';
        el.style['-webkit-backface-visibility'] = 'hidden';
      }
    } else {
      el.style.left = point.x + 'px';
      el.style.top = point.y + 'px';
    }
  },

  getPosition: function getPosition(el) {
    return el._tl_pos;
  }
};

TL.DomEvent = {
  addListener: function addListener(obj, type, fn, context) {
    var id = TL.Util.stamp(fn),
        key = '_tl_' + type + id;

    if (obj[key]) {
      return;
    }

    var handler = function handler(e) {
      return fn.call(context || obj, e || TL.DomEvent._getEvent());
    };

    if (TL.Browser.touch && type === 'dblclick' && this.addDoubleTapListener) {
      this.addDoubleTapListener(obj, handler, id);
    } else if ('addEventListener' in obj) {
      if (type === 'mousewheel') {
        obj.addEventListener('DOMMouseScroll', handler, false);
        obj.addEventListener(type, handler, false);
      } else if (type === 'mouseenter' || type === 'mouseleave') {
        var originalHandler = handler,
            newType = type === 'mouseenter' ? 'mouseover' : 'mouseout';
        handler = function handler(e) {
          if (!TL.DomEvent._checkMouse(obj, e)) {
            return;
          }
          return originalHandler(e);
        };
        obj.addEventListener(newType, handler, false);
      } else {
        obj.addEventListener(type, handler, false);
      }
    } else if ('attachEvent' in obj) {
      obj.attachEvent("on" + type, handler);
    }

    obj[key] = handler;
  },

  removeListener: function removeListener(obj, type, fn) {
    var id = TL.Util.stamp(fn),
        key = '_tl_' + type + id,
        handler = obj[key];

    if (!handler) {
      return;
    }

    if (TL.Browser.touch && type === 'dblclick' && this.removeDoubleTapListener) {
      this.removeDoubleTapListener(obj, id);
    } else if ('removeEventListener' in obj) {
      if (type === 'mousewheel') {
        obj.removeEventListener('DOMMouseScroll', handler, false);
        obj.removeEventListener(type, handler, false);
      } else if (type === 'mouseenter' || type === 'mouseleave') {
        obj.removeEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
      } else {
        obj.removeEventListener(type, handler, false);
      }
    } else if ('detachEvent' in obj) {
      obj.detachEvent("on" + type, handler);
    }
    obj[key] = null;
  },

  _checkMouse: function _checkMouse(el, e) {
    var related = e.relatedTarget;

    if (!related) {
      return true;
    }

    try {
      while (related && related !== el) {
        related = related.parentNode;
      }
    } catch (err) {
      return false;
    }

    return related !== el;
  },

  _getEvent: function _getEvent() {
    var e = window.event;
    if (!e) {
      var caller = arguments.callee.caller;
      while (caller) {
        e = caller['arguments'][0];
        if (e && window.Event === e.constructor) {
          break;
        }
        caller = caller.caller;
      }
    }
    return e;
  },


  stopPropagation: function stopPropagation(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true;
    }
  },

  disableClickPropagation: function disableClickPropagation(el) {
    TL.DomEvent.addListener(el, TL.Draggable.START, TL.DomEvent.stopPropagation);
    TL.DomEvent.addListener(el, 'click', TL.DomEvent.stopPropagation);
    TL.DomEvent.addListener(el, 'dblclick', TL.DomEvent.stopPropagation);
  },

  preventDefault: function preventDefault(e) {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }
  },

  stop: function stop(e) {
    TL.DomEvent.preventDefault(e);
    TL.DomEvent.stopPropagation(e);
  },

  getWheelDelta: function getWheelDelta(e) {
    var delta = 0;
    if (e.wheelDelta) {
      delta = e.wheelDelta / 120;
    }
    if (e.detail) {
      delta = -e.detail / 3;
    }
    return delta;
  }
};

TL.StyleSheet = TL.Class.extend({

  includes: [TL.Events],

  _el: {},

  initialize: function initialize() {
    this.style = document.createElement("style");

    this.style.appendChild(document.createTextNode(""));

    document.head.appendChild(this.style);

    this.sheet = this.style.sheet;
  },

  addRule: function addRule(selector, rules, index) {
    var _index = 0;

    if (index) {
      _index = index;
    }

    if ("insertRule" in this.sheet) {
      this.sheet.insertRule(selector + "{" + rules + "}", _index);
    } else if ("addRule" in this.sheet) {
      this.sheet.addRule(selector, rules, _index);
    }
  },

  onLoaded: function onLoaded(error) {
    this._state.loaded = true;
    this.fire("loaded", this.data);
  }

});

TL.Date = TL.Class.extend({
  initialize: function initialize(data, format, format_short) {
    if (typeof data == 'number') {
      this.data = {
        format: "yyyy mmmm",
        date_obj: new Date(data)
      };
    } else if (Date == data.constructor) {
      this.data = {
        format: "yyyy mmmm",
        date_obj: data
      };
    } else {
      this.data = JSON.parse((0, _stringify2.default)(data));
      this._createDateObj();
    }

    this._setFormat(format, format_short);
  },

  setDateFormat: function setDateFormat(format) {
    this.data.format = format;
  },

  getDisplayDate: function getDisplayDate(language, format) {
    if (this.data.display_date) {
      return this.data.display_date;
    }
    if (!language) {
      language = TL.Language.fallback;
    }
    if (language.constructor != TL.Language) {
      TL.trace("First argument to getDisplayDate must be TL.Language");
      language = TL.Language.fallback;
    }

    var format_key = format || this.data.format;
    return language.formatDate(this.data.date_obj, format_key);
  },

  getMillisecond: function getMillisecond() {
    return this.getTime();
  },

  getTime: function getTime() {
    return this.data.date_obj.getTime();
  },

  isBefore: function isBefore(other_date) {
    if (!this.data.date_obj.constructor == other_date.data.date_obj.constructor) {
      throw new TL.Error("date_compare_err");
    }
    if ('isBefore' in this.data.date_obj) {
      return this.data.date_obj['isBefore'](other_date.data.date_obj);
    }
    return this.data.date_obj < other_date.data.date_obj;
  },

  isAfter: function isAfter(other_date) {
    if (!this.data.date_obj.constructor == other_date.data.date_obj.constructor) {
      throw new TL.Error("date_compare_err");
    }
    if ('isAfter' in this.data.date_obj) {
      return this.data.date_obj['isAfter'](other_date.data.date_obj);
    }
    return this.data.date_obj > other_date.data.date_obj;
  },

  floor: function floor(scale) {
    var d = new Date(this.data.date_obj.getTime());
    for (var i = 0; i < TL.Date.SCALES.length; i++) {
      TL.Date.SCALES[i][2](d);
      if (TL.Date.SCALES[i][0] == scale) return new TL.Date(d);
    };

    throw new TL.Error("invalid_scale_err", scale);
  },

  _getDateData: function _getDateData() {
    var _date = {
      year: 0,
      month: 1,
      day: 1,
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    };

    TL.Util.mergeData(_date, this.data);

    var DATE_PARTS = TL.Date.DATE_PARTS;

    for (var ix in DATE_PARTS) {
      var x = TL.Util.trim(_date[DATE_PARTS[ix]]);
      if (!x.match(/^-?\d*$/)) {
        throw new TL.Error("invalid_date_err", DATE_PARTS[ix] + " = '" + _date[DATE_PARTS[ix]] + "'");
      }

      var parsed = parseInt(_date[DATE_PARTS[ix]]);
      if (isNaN(parsed)) {
        parsed = ix == 4 || ix == 5 ? 1 : 0;
      }
      _date[DATE_PARTS[ix]] = parsed;
    }

    if (_date.month > 0 && _date.month <= 12) {
      _date.month = _date.month - 1;
    }

    return _date;
  },

  _createDateObj: function _createDateObj() {
    var _date = this._getDateData();
    this.data.date_obj = new Date(_date.year, _date.month, _date.day, _date.hour, _date.minute, _date.second, _date.millisecond);
    if (this.data.date_obj.getFullYear() != _date.year) {
      this.data.date_obj.setFullYear(_date.year);
    }
  },

  findBestFormat: function findBestFormat(variant) {
    var eval_array = TL.Date.DATE_PARTS,
        format = "";

    for (var i = 0; i < eval_array.length; i++) {
      if (this.data[eval_array[i]]) {
        if (variant) {
          if (!(variant in TL.Date.BEST_DATEFORMATS)) {
            variant = 'short';
          }
        } else {
          variant = 'base';
        }
        return TL.Date.BEST_DATEFORMATS[variant][eval_array[i]];
      }
    };
    return "";
  },
  _setFormat: function _setFormat(format, format_short) {
    if (format) {
      this.data.format = format;
    } else if (!this.data.format) {
      this.data.format = this.findBestFormat();
    }

    if (format_short) {
      this.data.format_short = format_short;
    } else if (!this.data.format_short) {
      this.data.format_short = this.findBestFormat(true);
    }
  }
});

TL.Date.makeDate = function (data) {
  var date = new TL.Date(data);
  if (!isNaN(date.getTime())) {
    return date;
  }
  return new TL.BigDate(data);
};

TL.BigYear = TL.Class.extend({
  initialize: function initialize(year) {
    this.year = parseInt(year);
    if (isNaN(this.year)) {
      throw new TL.Error('invalid_year_err', year);
    }
  },

  isBefore: function isBefore(that) {
    return this.year < that.year;
  },

  isAfter: function isAfter(that) {
    return this.year > that.year;
  },

  getTime: function getTime() {
    return this.year;
  }
});

(function (cls) {
  cls.SCALES = [['millisecond', 1, function (d) {}], ['second', 1000, function (d) {
    d.setMilliseconds(0);
  }], ['minute', 1000 * 60, function (d) {
    d.setSeconds(0);
  }], ['hour', 1000 * 60 * 60, function (d) {
    d.setMinutes(0);
  }], ['day', 1000 * 60 * 60 * 24, function (d) {
    d.setHours(0);
  }], ['month', 1000 * 60 * 60 * 24 * 30, function (d) {
    d.setDate(1);
  }], ['year', 1000 * 60 * 60 * 24 * 365, function (d) {
    d.setMonth(0);
  }], ['decade', 1000 * 60 * 60 * 24 * 365 * 10, function (d) {
    var real_year = d.getFullYear();
    d.setFullYear(real_year - real_year % 10);
  }], ['century', 1000 * 60 * 60 * 24 * 365 * 100, function (d) {
    var real_year = d.getFullYear();
    d.setFullYear(real_year - real_year % 100);
  }], ['millennium', 1000 * 60 * 60 * 24 * 365 * 1000, function (d) {
    var real_year = d.getFullYear();
    d.setFullYear(real_year - real_year % 1000);
  }]];

  cls.DATE_PARTS = ["millisecond", "second", "minute", "hour", "day", "month", "year"];

  var ISO8601_SHORT_PATTERN = /^([\+-]?\d+?)(-\d{2}?)?(-\d{2}?)?$/;

  var ISO8601_PATTERN = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;

  cls.parseISODate = function (str) {
    var d = new Date(str);
    if (isNaN(d)) {
      throw new TL.Error("invalid_date_err", str);
    }
    return {
      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate(),
      hour: d.getHours(),
      minute: d.getMinutes(),
      second: d.getSeconds(),
      millisecond: d.getMilliseconds()
    };
  };

  cls.parseDate = function (str) {

    if (str.match(ISO8601_SHORT_PATTERN)) {
      var parts = str.match(ISO8601_SHORT_PATTERN).slice(1);
      var d = { year: parts[0].replace('+', '') };
      if (parts[1]) {
        d['month'] = parts[1].replace('-', '');
      }
      if (parts[2]) {
        d['day'] = parts[2].replace('-', '');
      }
      return d;
    }

    if (str.match(ISO8601_PATTERN)) {
      return cls.parseISODate(str);
    }

    if (str.match(/^\-?\d+$/)) {
      return { year: str };
    }

    var parsed = {};
    if (str.match(/\d+\/\d+\/\d+/)) {
      var date = str.match(/\d+\/\d+\/\d+/)[0];
      str = TL.Util.trim(str.replace(date, ''));
      var date_parts = date.split('/');
      parsed.month = date_parts[0];
      parsed.day = date_parts[1];
      parsed.year = date_parts[2];
    }

    if (str.match(/\d+\/\d+/)) {
      var date = str.match(/\d+\/\d+/)[0];
      str = TL.Util.trim(str.replace(date, ''));
      var date_parts = date.split('/');
      parsed.month = date_parts[0];
      parsed.year = date_parts[1];
    }

    if (str.match(':')) {
      var time_parts = str.split(':');
      parsed.hour = time_parts[0];
      parsed.minute = time_parts[1];
      if (time_parts[2]) {
        second_parts = time_parts[2].split('.');
        parsed.second = second_parts[0];
        parsed.millisecond = second_parts[1];
      }
    }
    return parsed;
  };

  cls.BEST_DATEFORMATS = {
    base: {
      millisecond: 'time_short',
      second: 'time',
      minute: 'time_no_seconds_small_date',
      hour: 'time_no_seconds_small_date',
      day: 'full',
      month: 'month',
      year: 'year',
      decade: 'year',
      century: 'year',
      millennium: 'year',
      age: 'fallback',
      epoch: 'fallback',
      era: 'fallback',
      eon: 'fallback',
      eon2: 'fallback'
    },

    short: {
      millisecond: 'time_short',
      second: 'time_short',
      minute: 'time_no_seconds_short',
      hour: 'time_no_minutes_short',
      day: 'full_short',
      month: 'month_short',
      year: 'year',
      decade: 'year',
      century: 'year',
      millennium: 'year',
      age: 'fallback',
      epoch: 'fallback',
      era: 'fallback',
      eon: 'fallback',
      eon2: 'fallback'
    }
  };
})(TL.Date);

TL.BigDate = TL.Date.extend({
  initialize: function initialize(data, format, format_short) {
    if (TL.BigYear == data.constructor) {
      this.data = {
        date_obj: data
      };
    } else {
      this.data = JSON.parse((0, _stringify2.default)(data));
      this._createDateObj();
    }

    this._setFormat(format, format_short);
  },

  _createDateObj: function _createDateObj() {
    var _date = this._getDateData();
    this.data.date_obj = new TL.BigYear(_date.year);
  },

  floor: function floor(scale) {
    for (var i = 0; i < TL.BigDate.SCALES.length; i++) {
      if (TL.BigDate.SCALES[i][0] == scale) {
        var floored = TL.BigDate.SCALES[i][2](this.data.date_obj);
        return new TL.BigDate(floored);
      }
    };

    throw new TL.Error("invalid_scale_err", scale);
  }
});

(function (cls) {
  var AGE = 1000000;
  var EPOCH = AGE * 10;
  var ERA = EPOCH * 10;
  var EON = ERA * 10;

  var Floorer = function Floorer(unit) {
    return function (a_big_year) {
      var year = a_big_year.getTime();
      return new TL.BigYear(Math.floor(year / unit) * unit);
    };
  };

  cls.SCALES = [['year', 1, new Floorer(1)], ['decade', 10, new Floorer(10)], ['century', 100, new Floorer(100)], ['millennium', 1000, new Floorer(1000)], ['age', AGE, new Floorer(AGE)], ['epoch', EPOCH, new Floorer(EPOCH)], ['era', ERA, new Floorer(ERA)], ['eon', EON, new Floorer(EON)]];
})(TL.BigDate);

TL.DateUtil = {
  get: function get(id) {
    return typeof id === 'string' ? document.getElementById(id) : id;
  },

  sortByDate: function sortByDate(array, prop_name) {
    var prop_name = prop_name || 'start_date';
    array.sort(function (a, b) {
      if (a[prop_name].isBefore(b[prop_name])) return -1;
      if (a[prop_name].isAfter(b[prop_name])) return 1;
      return 0;
    });
  },

  parseTime: function parseTime(time_str) {
    var parsed = {
      hour: null, minute: null, second: null, millisecond: null };
    var period = null;
    var match = time_str.match(/(\s*[AaPp]\.?[Mm]\.?\s*)$/);
    if (match) {
      period = TL.Util.trim(match[0]);
      time_str = TL.Util.trim(time_str.substring(0, time_str.lastIndexOf(period)));
    }

    var parts = [];
    var no_separators = time_str.match(/^\s*(\d{1,2})(\d{2})\s*$/);
    if (no_separators) {
      parts = no_separators.slice(1);
    } else {
      parts = time_str.split(':');
      if (parts.length == 1) {
        parts = time_str.split('.');
      }
    }

    if (parts.length > 4) {
      throw new TL.Error("invalid_separator_error");
    }

    parsed.hour = parseInt(parts[0]);

    if (period && period.toLowerCase()[0] == 'p' && parsed.hour != 12) {
      parsed.hour += 12;
    } else if (period && period.toLowerCase()[0] == 'a' && parsed.hour == 12) {
      parsed.hour = 0;
    }

    if (isNaN(parsed.hour) || parsed.hour < 0 || parsed.hour > 23) {
      throw new TL.Error("invalid_hour_err", parsed.hour);
    }

    if (parts.length > 1) {
      parsed.minute = parseInt(parts[1]);
      if (isNaN(parsed.minute)) {
        throw new TL.Error("invalid_minute_err", parsed.minute);
      }
    }

    if (parts.length > 2) {
      var sec_parts = parts[2].split(/[\.,]/);
      parts = sec_parts.concat(parts.slice(3));
      if (parts.length > 2) {
        throw new TL.Error("invalid_second_fractional_err");
      }
      parsed.second = parseInt(parts[0]);
      if (isNaN(parsed.second)) {
        throw new TL.Error("invalid_second_err");
      }
      if (parts.length == 2) {
        var frac_secs = parseInt(parts[1]);
        if (isNaN(frac_secs)) {
          throw new TL.Error("invalid_fractional_err");
        }
        parsed.millisecond = 100 * frac_secs;
      }
    }

    return parsed;
  },

  SCALE_DATE_CLASSES: {
    human: TL.Date,
    cosmological: TL.BigDate
  }

};

TL.Draggable = TL.Class.extend({

  includes: TL.Events,

  _el: {},

  mousedrag: {
    down: "mousedown",
    up: "mouseup",
    leave: "mouseleave",
    move: "mousemove"
  },

  touchdrag: {
    down: "touchstart",
    up: "touchend",
    leave: "mouseleave",
    move: "touchmove"
  },

  initialize: function initialize(drag_elem, options, move_elem) {
    this._el = {
      drag: drag_elem,
      move: drag_elem
    };

    if (move_elem) {
      this._el.move = move_elem;
    }

    this.options = {
      enable: {
        x: true,
        y: true
      },
      constraint: {
        top: false,
        bottom: false,
        left: false,
        right: false
      },
      momentum_multiplier: 2000,
      duration: 1000,
      ease: TL.Ease.easeInOutQuint
    };

    this.animator = null;

    this.dragevent = this.mousedrag;

    if (TL.Browser.touch) {
      this.dragevent = this.touchdrag;
    }

    this.data = {
      sliding: false,
      direction: "none",
      pagex: {
        start: 0,
        end: 0
      },
      pagey: {
        start: 0,
        end: 0
      },
      pos: {
        start: {
          x: 0,
          y: 0
        },
        end: {
          x: 0,
          y: 0
        }
      },
      new_pos: {
        x: 0,
        y: 0
      },
      new_pos_parent: {
        x: 0,
        y: 0
      },
      time: {
        start: 0,
        end: 0
      },
      touch: false
    };

    TL.Util.mergeData(this.options, options);
  },

  enable: function enable(e) {

    this.data.pos.start = 0;
    this._el.move.style.left = this.data.pos.start.x + "px";
    this._el.move.style.top = this.data.pos.start.y + "px";
    this._el.move.style.position = "absolute";
  },

  disable: function disable() {
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.down, this._onDragStart, this);
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.up, this._onDragEnd, this);
  },

  stopMomentum: function stopMomentum() {
    if (this.animator) {
      this.animator.stop();
    }
  },

  updateConstraint: function updateConstraint(c) {
    this.options.constraint = c;
  },

  _onDragStart: function _onDragStart(e) {
    if (TL.Browser.touch) {
      if (e.originalEvent) {
        this.data.pagex.start = e.originalEvent.touches[0].screenX;
        this.data.pagey.start = e.originalEvent.touches[0].screenY;
      } else {
        this.data.pagex.start = e.targetTouches[0].screenX;
        this.data.pagey.start = e.targetTouches[0].screenY;
      }
    } else {
      this.data.pagex.start = e.pageX;
      this.data.pagey.start = e.pageY;
    }

    if (this.options.enable.x) {
      this._el.move.style.left = this.data.pagex.start - this._el.move.offsetWidth / 2 + "px";
    }

    if (this.options.enable.y) {
      this._el.move.style.top = this.data.pagey.start - this._el.move.offsetHeight / 2 + "px";
    }

    this.data.pos.start = TL.Dom.getPosition(this._el.drag);
    this.data.time.start = new Date().getTime();

    this.fire("dragstart", this.data);
    TL.DomEvent.addListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
    TL.DomEvent.addListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
  },

  _onDragEnd: function _onDragEnd(e) {
    this.data.sliding = false;
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
    this.fire("dragend", this.data);

    this._momentum();
  },

  _onDragMove: function _onDragMove(e) {
    e.preventDefault();
    this.data.sliding = true;

    if (TL.Browser.touch) {
      if (e.originalEvent) {
        this.data.pagex.end = e.originalEvent.touches[0].screenX;
        this.data.pagey.end = e.originalEvent.touches[0].screenY;
      } else {
        this.data.pagex.end = e.targetTouches[0].screenX;
        this.data.pagey.end = e.targetTouches[0].screenY;
      }
    } else {
      this.data.pagex.end = e.pageX;
      this.data.pagey.end = e.pageY;
    }

    this.data.pos.end = TL.Dom.getPosition(this._el.drag);
    this.data.new_pos.x = -(this.data.pagex.start - this.data.pagex.end - this.data.pos.start.x);
    this.data.new_pos.y = -(this.data.pagey.start - this.data.pagey.end - this.data.pos.start.y);

    if (this.options.enable.x) {
      this._el.move.style.left = this.data.new_pos.x + "px";
    }

    if (this.options.enable.y) {
      this._el.move.style.top = this.data.new_pos.y + "px";
    }

    this.fire("dragmove", this.data);
  },

  _momentum: function _momentum() {
    var pos_adjust = {
      x: 0,
      y: 0,
      time: 0
    },
        pos_change = {
      x: 0,
      y: 0,
      time: 0
    },
        swipe = false,
        swipe_direction = "";

    if (TL.Browser.touch) {}

    pos_adjust.time = (new Date().getTime() - this.data.time.start) * 10;
    pos_change.time = (new Date().getTime() - this.data.time.start) * 10;

    pos_change.x = this.options.momentum_multiplier * (Math.abs(this.data.pagex.end) - Math.abs(this.data.pagex.start));
    pos_change.y = this.options.momentum_multiplier * (Math.abs(this.data.pagey.end) - Math.abs(this.data.pagey.start));

    pos_adjust.x = Math.round(pos_change.x / pos_change.time);
    pos_adjust.y = Math.round(pos_change.y / pos_change.time);

    this.data.new_pos.x = Math.min(this.data.pos.end.x + pos_adjust.x);
    this.data.new_pos.y = Math.min(this.data.pos.end.y + pos_adjust.y);

    if (!this.options.enable.x) {
      this.data.new_pos.x = this.data.pos.start.x;
    } else if (this.data.new_pos.x < 0) {
      this.data.new_pos.x = 0;
    }

    if (!this.options.enable.y) {
      this.data.new_pos.y = this.data.pos.start.y;
    } else if (this.data.new_pos.y < 0) {
      this.data.new_pos.y = 0;
    }

    if (pos_change.time < 3000) {
      swipe = true;
    }

    if (Math.abs(pos_change.x) > 10000) {
      this.data.direction = "left";
      if (pos_change.x > 0) {
        this.data.direction = "right";
      }
    }

    if (Math.abs(pos_change.y) > 10000) {
      this.data.direction = "up";
      if (pos_change.y > 0) {
        this.data.direction = "down";
      }
    }
    this._animateMomentum();
    if (swipe) {
      this.fire("swipe_" + this.data.direction, this.data);
    }
  },

  _animateMomentum: function _animateMomentum() {
    var pos = {
      x: this.data.new_pos.x,
      y: this.data.new_pos.y
    },
        animate = {
      duration: this.options.duration,
      easing: TL.Ease.easeOutStrong
    };

    if (this.options.enable.y) {
      if (this.options.constraint.top || this.options.constraint.bottom) {
        if (pos.y > this.options.constraint.bottom) {
          pos.y = this.options.constraint.bottom;
        } else if (pos.y < this.options.constraint.top) {
          pos.y = this.options.constraint.top;
        }
      }
      animate.top = Math.floor(pos.y) + "px";
    }

    if (this.options.enable.x) {
      if (this.options.constraint.left || this.options.constraint.right) {
        if (pos.x > this.options.constraint.left) {
          pos.x = this.options.constraint.left;
        } else if (pos.x < this.options.constraint.right) {
          pos.x = this.options.constraint.right;
        }
      }
      animate.left = Math.floor(pos.x) + "px";
    }

    this.animator = TL.Animate(this._el.move, animate);

    this.fire("momentum", this.data);
  }
});

TL.Swipable = TL.Class.extend({

  includes: TL.Events,

  _el: {},

  mousedrag: {
    down: "mousedown",
    up: "mouseup",
    leave: "mouseleave",
    move: "mousemove"
  },

  touchdrag: {
    down: "touchstart",
    up: "touchend",
    leave: "mouseleave",
    move: "touchmove"
  },

  initialize: function initialize(drag_elem, move_elem, options) {
    this._el = {
      drag: drag_elem,
      move: drag_elem
    };

    if (move_elem) {
      this._el.move = move_elem;
    }

    this.options = {
      snap: false,
      enable: {
        x: true,
        y: true
      },
      constraint: {
        top: false,
        bottom: false,
        left: 0,
        right: false
      },
      momentum_multiplier: 2000,
      duration: 1000,
      ease: TL.Ease.easeInOutQuint
    };

    this.animator = null;

    this.dragevent = this.mousedrag;

    if (TL.Browser.touch) {
      this.dragevent = this.touchdrag;
    }

    this.data = {
      sliding: false,
      direction: "none",
      pagex: {
        start: 0,
        end: 0
      },
      pagey: {
        start: 0,
        end: 0
      },
      pos: {
        start: {
          x: 0,
          y: 0
        },
        end: {
          x: 0,
          y: 0
        }
      },
      new_pos: {
        x: 0,
        y: 0
      },
      new_pos_parent: {
        x: 0,
        y: 0
      },
      time: {
        start: 0,
        end: 0
      },
      touch: false
    };

    TL.Util.mergeData(this.options, options);
  },

  enable: function enable(e) {
    TL.DomEvent.addListener(this._el.drag, this.dragevent.down, this._onDragStart, this);
    TL.DomEvent.addListener(this._el.drag, this.dragevent.up, this._onDragEnd, this);

    this.data.pos.start = 0;
    this._el.move.style.left = this.data.pos.start.x + "px";
    this._el.move.style.top = this.data.pos.start.y + "px";
    this._el.move.style.position = "absolute";
  },

  disable: function disable() {
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.down, this._onDragStart, this);
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.up, this._onDragEnd, this);
  },

  stopMomentum: function stopMomentum() {
    if (this.animator) {
      this.animator.stop();
    }
  },

  updateConstraint: function updateConstraint(c) {
    this.options.constraint = c;
  },

  _onDragStart: function _onDragStart(e) {

    if (this.animator) {
      this.animator.stop();
    }

    if (TL.Browser.touch) {
      if (e.originalEvent) {
        this.data.pagex.start = e.originalEvent.touches[0].screenX;
        this.data.pagey.start = e.originalEvent.touches[0].screenY;
      } else {
        this.data.pagex.start = e.targetTouches[0].screenX;
        this.data.pagey.start = e.targetTouches[0].screenY;
      }
    } else {
      this.data.pagex.start = e.pageX;
      this.data.pagey.start = e.pageY;
    }

    if (this.options.enable.x) {}

    if (this.options.enable.y) {}

    this.data.pos.start = { x: this._el.move.offsetLeft, y: this._el.move.offsetTop };

    this.data.time.start = new Date().getTime();

    this.fire("dragstart", this.data);
    TL.DomEvent.addListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
    TL.DomEvent.addListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
  },

  _onDragEnd: function _onDragEnd(e) {
    this.data.sliding = false;
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.move, this._onDragMove, this);
    TL.DomEvent.removeListener(this._el.drag, this.dragevent.leave, this._onDragEnd, this);
    this.fire("dragend", this.data);

    this._momentum();
  },

  _onDragMove: function _onDragMove(e) {
    var change = {
      x: 0,
      y: 0
    };

    this.data.sliding = true;

    if (TL.Browser.touch) {
      if (e.originalEvent) {
        this.data.pagex.end = e.originalEvent.touches[0].screenX;
        this.data.pagey.end = e.originalEvent.touches[0].screenY;
      } else {
        this.data.pagex.end = e.targetTouches[0].screenX;
        this.data.pagey.end = e.targetTouches[0].screenY;
      }
    } else {
      this.data.pagex.end = e.pageX;
      this.data.pagey.end = e.pageY;
    }

    change.x = this.data.pagex.start - this.data.pagex.end;
    change.y = this.data.pagey.start - this.data.pagey.end;

    this.data.pos.end = { x: this._el.drag.offsetLeft, y: this._el.drag.offsetTop };

    this.data.new_pos.x = -(change.x - this.data.pos.start.x);
    this.data.new_pos.y = -(change.y - this.data.pos.start.y);

    if (this.options.enable.x && Math.abs(change.x) > Math.abs(change.y)) {
      e.preventDefault();
      this._el.move.style.left = this.data.new_pos.x + "px";
    }

    if (this.options.enable.y && Math.abs(change.y) > Math.abs(change.y)) {
      e.preventDefault();
      this._el.move.style.top = this.data.new_pos.y + "px";
    }

    this.fire("dragmove", this.data);
  },

  _momentum: function _momentum() {
    var pos_adjust = {
      x: 0,
      y: 0,
      time: 0
    },
        pos_change = {
      x: 0,
      y: 0,
      time: 0
    },
        swipe_detect = {
      x: false,
      y: false
    },
        swipe = false,
        swipe_direction = "";

    this.data.direction = null;

    pos_adjust.time = (new Date().getTime() - this.data.time.start) * 10;
    pos_change.time = (new Date().getTime() - this.data.time.start) * 10;

    pos_change.x = this.options.momentum_multiplier * (Math.abs(this.data.pagex.end) - Math.abs(this.data.pagex.start));
    pos_change.y = this.options.momentum_multiplier * (Math.abs(this.data.pagey.end) - Math.abs(this.data.pagey.start));

    pos_adjust.x = Math.round(pos_change.x / pos_change.time);
    pos_adjust.y = Math.round(pos_change.y / pos_change.time);

    this.data.new_pos.x = Math.min(this.data.new_pos.x + pos_adjust.x);
    this.data.new_pos.y = Math.min(this.data.new_pos.y + pos_adjust.y);

    if (!this.options.enable.x) {
      this.data.new_pos.x = this.data.pos.start.x;
    } else if (this.options.constraint.left && this.data.new_pos.x > this.options.constraint.left) {
      this.data.new_pos.x = this.options.constraint.left;
    }

    if (!this.options.enable.y) {
      this.data.new_pos.y = this.data.pos.start.y;
    } else if (this.data.new_pos.y < 0) {
      this.data.new_pos.y = 0;
    }

    if (pos_change.time < 2000) {
      swipe = true;
    }

    if (this.options.enable.x && this.options.enable.y) {
      if (Math.abs(pos_change.x) > Math.abs(pos_change.y)) {
        swipe_detect.x = true;
      } else {
        swipe_detect.y = true;
      }
    } else if (this.options.enable.x) {
      if (Math.abs(pos_change.x) > Math.abs(pos_change.y)) {
        swipe_detect.x = true;
      }
    } else {
      if (Math.abs(pos_change.y) > Math.abs(pos_change.x)) {
        swipe_detect.y = true;
      }
    }

    if (swipe_detect.x) {
      if (Math.abs(pos_change.x) > this._el.drag.offsetWidth / 2) {
        swipe = true;
      }

      if (Math.abs(pos_change.x) > 10000) {
        this.data.direction = "left";
        if (pos_change.x > 0) {
          this.data.direction = "right";
        }
      }
    }

    if (swipe_detect.y) {
      if (Math.abs(pos_change.y) > this._el.drag.offsetHeight / 2) {
        swipe = true;
      }

      if (Math.abs(pos_change.y) > 10000) {
        this.data.direction = "up";
        if (pos_change.y > 0) {
          this.data.direction = "down";
        }
      }
    }

    if (pos_change.time < 1000) {} else {
      this._animateMomentum();
    }

    if (swipe && this.data.direction) {
      this.fire("swipe_" + this.data.direction, this.data);
    } else if (this.data.direction) {
      this.fire("swipe_nodirection", this.data);
    } else if (this.options.snap) {
      this.animator.stop();

      this.animator = TL.Animate(this._el.move, {
        top: this.data.pos.start.y,
        left: this.data.pos.start.x,
        duration: this.options.duration,
        easing: TL.Ease.easeOutStrong
      });
    }
  },

  _animateMomentum: function _animateMomentum() {
    var pos = {
      x: this.data.new_pos.x,
      y: this.data.new_pos.y
    },
        animate = {
      duration: this.options.duration,
      easing: TL.Ease.easeOutStrong
    };

    if (this.options.enable.y) {
      if (this.options.constraint.top || this.options.constraint.bottom) {
        if (pos.y > this.options.constraint.bottom) {
          pos.y = this.options.constraint.bottom;
        } else if (pos.y < this.options.constraint.top) {
          pos.y = this.options.constraint.top;
        }
      }
      animate.top = Math.floor(pos.y) + "px";
    }

    if (this.options.enable.x) {
      if (this.options.constraint.left && pos.x >= this.options.constraint.left) {
        pos.x = this.options.constraint.left;
      }
      if (this.options.constraint.right && pos.x < this.options.constraint.right) {
        pos.x = this.options.constraint.right;
      }

      animate.left = Math.floor(pos.x) + "px";
    }

    this.animator = TL.Animate(this._el.move, animate);

    this.fire("momentum", this.data);
  }
});

TL.MenuBar = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins],

  _el: {},

  initialize: function initialize(elem, parent_elem, options) {
    this._el = {
      parent: {},
      container: {},
      button_backtostart: {},
      button_zoomin: {},
      button_zoomout: {},
      arrow: {},
      line: {},
      coverbar: {},
      grip: {}
    };

    this.collapsed = false;

    if ((typeof elem === 'undefined' ? 'undefined' : (0, _typeof3.default)(elem)) === 'object') {
      this._el.container = elem;
    } else {
      this._el.container = TL.Dom.get(elem);
    }

    if (parent_elem) {
      this._el.parent = parent_elem;
    }

    this.options = {
      width: 600,
      height: 600,
      duration: 1000,
      ease: TL.Ease.easeInOutQuint,
      menubar_default_y: 0
    };

    this.animator = {};

    TL.Util.mergeData(this.options, options);

    this._initLayout();
    this._initEvents();
  },

  show: function show(d) {

    var duration = this.options.duration;
    if (d) {
      duration = d;
    }
  },

  hide: function hide(top) {},

  toogleZoomIn: function toogleZoomIn(show) {
    if (show) {
      TL.DomUtil.removeClass(this._el.button_zoomin, 'tl-menubar-button-inactive');
    } else {
      TL.DomUtil.addClass(this._el.button_zoomin, 'tl-menubar-button-inactive');
    }
  },

  toogleZoomOut: function toogleZoomOut(show) {
    if (show) {
      TL.DomUtil.removeClass(this._el.button_zoomout, 'tl-menubar-button-inactive');
    } else {
      TL.DomUtil.addClass(this._el.button_zoomout, 'tl-menubar-button-inactive');
    }
  },

  setSticky: function setSticky(y) {
    this.options.menubar_default_y = y;
  },

  setColor: function setColor(inverted) {
    if (inverted) {
      this._el.container.className = 'tl-menubar tl-menubar-inverted';
    } else {
      this._el.container.className = 'tl-menubar';
    }
  },

  updateDisplay: function updateDisplay(w, h, a, l) {
    this._updateDisplay(w, h, a, l);
  },

  _onButtonZoomIn: function _onButtonZoomIn(e) {
    this.fire("zoom_in", e);
  },

  _onButtonZoomOut: function _onButtonZoomOut(e) {
    this.fire("zoom_out", e);
  },

  _onButtonBackToStart: function _onButtonBackToStart(e) {
    this.fire("back_to_start", e);
  },

  _initLayout: function _initLayout() {
    this._el.button_zoomin = TL.Dom.create('span', 'tl-menubar-button', this._el.container);
    this._el.button_zoomout = TL.Dom.create('span', 'tl-menubar-button', this._el.container);
    this._el.button_backtostart = TL.Dom.create('span', 'tl-menubar-button', this._el.container);

    if (TL.Browser.mobile) {
      this._el.container.setAttribute("ontouchstart", " ");
    }

    this._el.button_backtostart.innerHTML = "<span class='tl-icon-goback'></span>";
    this._el.button_zoomin.innerHTML = "<span class='tl-icon-zoom-in'></span>";
    this._el.button_zoomout.innerHTML = "<span class='tl-icon-zoom-out'></span>";
  },

  _initEvents: function _initEvents() {
    TL.DomEvent.addListener(this._el.button_backtostart, 'click', this._onButtonBackToStart, this);
    TL.DomEvent.addListener(this._el.button_zoomin, 'click', this._onButtonZoomIn, this);
    TL.DomEvent.addListener(this._el.button_zoomout, 'click', this._onButtonZoomOut, this);
  },

  _updateDisplay: function _updateDisplay(width, height, animate) {

    if (width) {
      this.options.width = width;
    }
    if (height) {
      this.options.height = height;
    }
  }

});

TL.Message = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins, TL.I18NMixins],

  _el: {},

  initialize: function initialize(data, options, add_to_container) {
    this._el = {
      parent: {},
      container: {},
      message_container: {},
      loading_icon: {},
      message: {}
    };

    this.options = {
      width: 600,
      height: 600,
      message_class: "tl-message",
      message_icon_class: "tl-loading-icon"
    };

    this._add_to_container = add_to_container || {};
    TL.Util.mergeData(this.data, data);
    TL.Util.mergeData(this.options, options);

    this._el.container = TL.Dom.create("div", this.options.message_class);

    if (add_to_container) {
      add_to_container.appendChild(this._el.container);
      this._el.parent = add_to_container;
    }

    this.animator = {};

    this._initLayout();
    this._initEvents();
  },

  updateMessage: function updateMessage(t) {
    this._updateMessage(t);
  },

  updateDisplay: function updateDisplay(w, h) {
    this._updateDisplay(w, h);
  },

  _updateMessage: function _updateMessage(t) {
    if (!t) {
      this._el.message.innerHTML = this._('loading');
    } else {
      this._el.message.innerHTML = t;
    }

    if (!this._el.parent.atrributes && this._add_to_container.attributes) {
      this._add_to_container.appendChild(this._el.container);
      this._el.parent = this._add_to_container;
    }
  },

  _onMouseClick: function _onMouseClick() {
    this.fire("clicked", this.options);
  },

  _onRemove: function _onRemove() {
    this._el.parent = {};
  },

  _initLayout: function _initLayout() {
    this._el.message_container = TL.Dom.create("div", "tl-message-container", this._el.container);
    this._el.loading_icon = TL.Dom.create("div", this.options.message_icon_class, this._el.message_container);
    this._el.message = TL.Dom.create("div", "tl-message-content", this._el.message_container);

    this._updateMessage();
  },

  _initEvents: function _initEvents() {
    TL.DomEvent.addListener(this._el.container, 'click', this._onMouseClick, this);
    TL.DomEvent.addListener(this, 'removed', this._onRemove, this);
  },

  _updateDisplay: function _updateDisplay(width, height, animate) {}

});

TL.MediaType = function (m, image_only) {
  var media = {},
      media_types = [{
    type: "youtube",
    name: "YouTube",
    match_str: "^(https?:)?\/*(www.)?youtube|youtu\.be",
    cls: TL.Media.YouTube
  }, {
    type: "vimeo",
    name: "Vimeo",
    match_str: "^(https?:)?\/*(player.)?vimeo\.com",
    cls: TL.Media.Vimeo
  }, {
    type: "dailymotion",
    name: "DailyMotion",
    match_str: "^(https?:)?\/*(www.)?dailymotion\.com",
    cls: TL.Media.DailyMotion
  }, {
    type: "vine",
    name: "Vine",
    match_str: "^(https?:)?\/*(www.)?vine\.co",
    cls: TL.Media.Vine
  }, {
    type: "soundcloud",
    name: "SoundCloud",
    match_str: "^(https?:)?\/*(player.)?soundcloud\.com",
    cls: TL.Media.SoundCloud
  }, {
    type: "twitter",
    name: "Twitter",
    match_str: "^(https?:)?\/*(www.)?twitter\.com",
    cls: TL.Media.Twitter
  }, {
    type: "twitterembed",
    name: "TwitterEmbed",
    match_str: "<blockquote class=['\"]twitter-tweet['\"]",
    cls: TL.Media.Twitter
  }, {
    type: "googlemaps",
    name: "Google Map",
    match_str: /google.+?\/maps\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)|google.+?\/maps\/search\/([\w\W]+)\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)|google.+?\/maps\/place\/([\w\W]+)\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)|google.+?\/maps\/dir\/([\w\W]+)\/([\w\W]+)\/@([-\d.]+),([-\d.]+),((?:[-\d.]+[zmayht],?)*)/,
    cls: TL.Media.GoogleMap
  }, {
    type: "googleplus",
    name: "Google+",
    match_str: "^(https?:)?\/*plus.google",
    cls: TL.Media.GooglePlus
  }, {
    type: "flickr",
    name: "Flickr",
    match_str: "^(https?:)?\/*(www.)?flickr.com\/photos",
    cls: TL.Media.Flickr
  }, {
    type: "flickr",
    name: "Flickr",
    match_str: "^(https?:\/\/)?flic.kr\/.*",
    cls: TL.Media.Flickr
  }, {
    type: "instagram",
    name: "Instagram",
    match_str: /^(https?:)?\/*(www.)?(instagr.am|^(https?:)?\/*(www.)?instagram.com)\/p\//,
    cls: TL.Media.Instagram
  }, {
    type: "profile",
    name: "Profile",
    match_str: /^(https?:)?\/*(www.)?instagr.am\/[a-zA-Z0-9]{2,}|^(https?:)?\/*(www.)?instagram.com\/[a-zA-Z0-9]{2,}/,
    cls: TL.Media.Profile
  }, {
    type: "documentcloud",
    name: "Document Cloud",
    match_str: /documentcloud.org\//,
    cls: TL.Media.DocumentCloud
  }, {
    type: "image",
    name: "Image",
    match_str: /(jpg|jpeg|png|gif|svg)(\?.*)?$/i,
    cls: TL.Media.Image
  }, {
    type: "imgur",
    name: "Imgur",
    match_str: /^.*imgur.com\/.+$|<blockquote class=['\"]imgur-embed-pub['\"]/i,
    cls: TL.Media.Imgur
  }, {
    type: "googledocs",
    name: "Google Doc",
    match_str: "^(https?:)?\/*[^.]*.google.com\/[^\/]*\/d\/[^\/]*\/[^\/]*\?usp=sharing|^(https?:)?\/*drive.google.com\/open\?id=[^\&]*\&authuser=0|^(https?:)?\/*drive.google.com\/open\?id=[^\&]*|^(https?:)?\/*[^.]*.googledrive.com\/host\/[^\/]*\/",
    cls: TL.Media.GoogleDoc
  }, {
    type: "pdf",
    name: "PDF",
    match_str: /^.*\.pdf(\?.*)?(\#.*)?/,
    cls: TL.Media.PDF
  }, {
    type: "wikipedia",
    name: "Wikipedia",
    match_str: "^(https?:)?\/*(www.)?wikipedia\.org|^(https?:)?\/*([a-z][a-z].)?wikipedia\.org",
    cls: TL.Media.Wikipedia
  }, {
    type: "spotify",
    name: "spotify",
    match_str: "spotify",
    cls: TL.Media.Spotify
  }, {
    type: "iframe",
    name: "iFrame",
    match_str: "iframe",
    cls: TL.Media.IFrame
  }, {
    type: "storify",
    name: "Storify",
    match_str: "storify",
    cls: TL.Media.Storify
  }, {
    type: "blockquote",
    name: "Quote",
    match_str: "blockquote",
    cls: TL.Media.Blockquote
  }, {
    type: "video",
    name: "Video",
    match_str: /(mp4)(\?.*)?$/i,
    cls: TL.Media.Video
  }, {
    type: "wistia",
    name: "Wistia",
    match_str: /https?:\/\/(.+)?(wistia\.com|wi\.st)\/.*/i,
    cls: TL.Media.Wistia
  }, {
    type: "audio",
    name: "Audio",
    match_str: /(mp3|wav|m4a)(\?.*)?$/i,
    cls: TL.Media.Audio
  }, {
    type: "imageblank",
    name: "Imageblank",
    match_str: "",
    cls: TL.Media.Image
  }];

  if (image_only) {
    if (m instanceof Array) {
      return false;
    }
    for (var i = 0; i < media_types.length; i++) {
      switch (media_types[i].type) {
        case "flickr":
        case "image":
        case "instagram":
          if (m.url.match(media_types[i].match_str)) {
            media = media_types[i];
            return media;
          }
          break;
        default:
          break;
      }
    }
  } else {
    for (var i = 0; i < media_types.length; i++) {
      if (m instanceof Array) {
        return media = {
          type: "slider",
          cls: TL.Media.Slider
        };
      } else if (m.url.match(media_types[i].match_str)) {
        media = media_types[i];
        return media;
      }
    }
  }
  return false;
};

TL.Media = TL.Class.extend({

  includes: [TL.Events, TL.I18NMixins],

  _el: {},

  initialize: function initialize(data, options, add_to_container) {
    this._el = {
      container: {},
      content_container: {},
      content: {},
      content_item: {},
      content_link: {},
      caption: null,
      credit: null,
      parent: {},
      link: null
    };

    this.player = null;

    this.timer = null;
    this.load_timer = null;

    this.message = null;

    this.media_id = null;

    this._state = {
      loaded: false,
      show_meta: false,
      media_loaded: false
    };

    this.data = {
      unique_id: null,
      url: null,
      credit: null,
      caption: null,
      credit_alternate: null,
      caption_alternate: null,
      link: null,
      link_target: null
    };

    this.options = {
      api_key_flickr: "f2cc870b4d233dd0a5bfe73fd0d64ef0",
      api_key_googlemaps: "AIzaSyB9dW8e_iRrATFa8g24qB6BDBGdkrLDZYI",
      api_key_embedly: "",
      credit_height: 0,
      caption_height: 0,
      background: 0 };

    this.animator = {};

    TL.Util.mergeData(this.options, options);
    TL.Util.mergeData(this.data, data);

    if (!this.options.background) {
      this._el.container = TL.Dom.create("div", "tl-media");

      if (this.data.unique_id) {
        this._el.container.id = this.data.unique_id;
      }

      this._initLayout();

      if (add_to_container) {
        add_to_container.appendChild(this._el.container);
        this._el.parent = add_to_container;
      }
    }
  },

  loadMedia: function loadMedia() {
    var self = this;

    if (!this._state.loaded) {
      try {
        this.load_timer = setTimeout(function () {
          self.loadingMessage();
          self._loadMedia();

          self._updateDisplay();
        }, 1200);
      } catch (e) {
        TL.trace("Error loading media for ", this._media);
        TL.trace(e);
      }
    }
  },

  _updateMessage: function _updateMessage(msg) {
    if (this.message) {
      this.message.updateMessage(msg);
    }
  },

  loadingMessage: function loadingMessage() {
    this._updateMessage(this._('loading') + " " + this.options.media_name);
  },

  errorMessage: function errorMessage(msg) {
    if (msg) {
      msg = this._('error') + ": " + msg;
    } else {
      msg = this._('error');
    }
    this._updateMessage(msg);
  },

  updateMediaDisplay: function updateMediaDisplay(layout) {
    if (this._state.loaded && !this.options.background) {

      if (TL.Browser.mobile) {
        this._el.content_item.style.maxHeight = this.options.height / 2 + "px";
      } else {
        this._el.content_item.style.maxHeight = this.options.height - this.options.credit_height - this.options.caption_height - 30 + "px";
      }

      this._el.container.style.maxWidth = this.options.width + "px";

      if (TL.Browser.firefox) {
        if (this._el.content_item.offsetWidth > this._el.content_item.offsetHeight) {}
      }

      this._updateMediaDisplay(layout);

      if (this._state.media_loaded) {
        if (this._el.credit) {
          this._el.credit.style.width = this._el.content_item.offsetWidth + "px";
        }
        if (this._el.caption) {
          this._el.caption.style.width = this._el.content_item.offsetWidth + "px";
        }
      }
    }
  },

  _loadMedia: function _loadMedia() {
    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay(l) {
    if (TL.Browser.firefox) {
      this._el.content_item.style.maxWidth = this.options.width + "px";
      this._el.content_item.style.width = "auto";
    }
  },

  _getMeta: function _getMeta() {},

  _getImageURL: function _getImageURL(w, h) {
    return "";
  },

  show: function show() {},

  hide: function hide() {},

  addTo: function addTo(container) {
    container.appendChild(this._el.container);
    this.onAdd();
  },

  removeFrom: function removeFrom(container) {
    container.removeChild(this._el.container);
    this.onRemove();
  },

  getImageURL: function getImageURL(w, h) {
    return this._getImageURL(w, h);
  },

  updateDisplay: function updateDisplay(w, h, l) {
    this._updateDisplay(w, h, l);
  },

  stopMedia: function stopMedia() {
    this._stopMedia();
  },

  loadErrorDisplay: function loadErrorDisplay(message) {
    try {
      this._el.content.removeChild(this._el.content_item);
    } catch (e) {}
    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-loaderror", this._el.content);
    this._el.content_item.innerHTML = "<div class='tl-icon-" + this.options.media_type + "'></div><p>" + message + "</p>";

    this.onLoaded(true);
  },

  onLoaded: function onLoaded(error) {
    this._state.loaded = true;
    this.fire("loaded", this.data);
    if (this.message) {
      this.message.hide();
    }
    if (!(error || this.options.background)) {
      this.showMeta();
    }
    this.updateDisplay();
  },

  onMediaLoaded: function onMediaLoaded(e) {
    this._state.media_loaded = true;
    this.fire("media_loaded", this.data);
    if (this._el.credit) {
      this._el.credit.style.width = this._el.content_item.offsetWidth + "px";
    }
    if (this._el.caption) {
      this._el.caption.style.width = this._el.content_item.offsetWidth + "px";
    }
  },

  showMeta: function showMeta(credit, caption) {
    this._state.show_meta = true;

    if (this.data.credit && this.data.credit != "") {
      this._el.credit = TL.Dom.create("div", "tl-credit", this._el.content_container);
      this._el.credit.innerHTML = this.options.autolink == true ? TL.Util.linkify(this.data.credit) : this.data.credit;
      this.options.credit_height = this._el.credit.offsetHeight;
    }

    if (this.data.caption && this.data.caption != "") {
      this._el.caption = TL.Dom.create("div", "tl-caption", this._el.content_container);
      this._el.caption.innerHTML = this.options.autolink == true ? TL.Util.linkify(this.data.caption) : this.data.caption;
      this.options.caption_height = this._el.caption.offsetHeight;
    }

    if (!this.data.caption || !this.data.credit) {
      this.getMeta();
    }
  },

  getMeta: function getMeta() {
    this._getMeta();
  },

  updateMeta: function updateMeta() {
    if (!this.data.credit && this.data.credit_alternate) {
      this._el.credit = TL.Dom.create("div", "tl-credit", this._el.content_container);
      this._el.credit.innerHTML = this.data.credit_alternate;
      this.options.credit_height = this._el.credit.offsetHeight;
    }

    if (!this.data.caption && this.data.caption_alternate) {
      this._el.caption = TL.Dom.create("div", "tl-caption", this._el.content_container);
      this._el.caption.innerHTML = this.data.caption_alternate;
      this.options.caption_height = this._el.caption.offsetHeight;
    }

    this.updateDisplay();
  },

  onAdd: function onAdd() {
    this.fire("added", this.data);
  },

  onRemove: function onRemove() {
    this.fire("removed", this.data);
  },

  _initLayout: function _initLayout() {
    this.message = new TL.Message({}, this.options);
    this.message.addTo(this._el.container);

    this._el.content_container = TL.Dom.create("div", "tl-media-content-container", this._el.container);

    if (this.data.link && this.data.link != "") {

      this._el.link = TL.Dom.create("a", "tl-media-link", this._el.content_container);
      this._el.link.href = this.data.link;
      if (this.data.link_target && this.data.link_target != "") {
        this._el.link.target = this.data.link_target;
      } else {
        this._el.link.target = "_blank";
      }

      this._el.content = TL.Dom.create("div", "tl-media-content", this._el.link);
    } else {
      this._el.content = TL.Dom.create("div", "tl-media-content", this._el.content_container);
    }
  },

  _updateDisplay: function _updateDisplay(w, h, l) {
    if (w) {
      this.options.width = w;
    }

    if (h) {
      this.options.height = h;
    }

    if (l) {
      this.options.layout = l;
    }

    if (this._el.credit) {
      this.options.credit_height = this._el.credit.offsetHeight;
    }
    if (this._el.caption) {
      this.options.caption_height = this._el.caption.offsetHeight + 5;
    }

    this.updateMediaDisplay(this.options.layout);
  },

  _stopMedia: function _stopMedia() {}

});

TL.Media.Blockquote = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-blockquote", this._el.content);
    this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";

    this.media_id = this.data.url;

    this._el.content_item.innerHTML = this.media_id;

    this.onLoaded();
  },

  updateMediaDisplay: function updateMediaDisplay() {},

  _updateMediaDisplay: function _updateMediaDisplay() {}

});

TL.Media.DailyMotion = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe tl-media-dailymotion", this._el.content);

    if (this.data.url.match("video")) {
      this.media_id = this.data.url.split("video\/")[1].split(/[?&]/)[0];
    } else {
      this.media_id = this.data.url.split("embed\/")[1].split(/[?&]/)[0];
    }

    api_url = "https://www.dailymotion.com/embed/video/" + this.media_id + "?api=postMessage";

    this._el.content_item.innerHTML = "<iframe autostart='false' frameborder='0' width='100%' height='100%' src='" + api_url + "'></iframe>";

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = TL.Util.ratio.r16_9({ w: this._el.content_item.offsetWidth }) + "px";
  },

  _stopMedia: function _stopMedia() {
    this._el.content_item.querySelector("iframe").contentWindow.postMessage('{"command":"pause","parameters":[]}', "*");
  }

});

TL.Media.DocumentCloud = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-documentcloud tl-media-shadow", this._el.content);
    this._el.content_item.id = TL.Util.unique_ID(7);

    if (this.data.url.match(/\.html$/)) {
      this.data.url = this._transformURL(this.data.url);
    } else if (!this.data.url.match(/.(json|js)$/)) {
      TL.trace("DOCUMENT CLOUD IN URL BUT INVALID SUFFIX");
    }

    TL.Load.js(['https://assets.documentcloud.org/viewer/loader.js', 'https://assets.documentcloud.org/viewer/viewer.js'], function () {
      self.createMedia();
    });
  },

  _transformURL: function _transformURL(url) {
    return url.replace(/(.*)\.html$/, '$1.js');
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = this.options.height + "px";
  },

  createMedia: function createMedia() {
    DV.load(this.data.url, {
      container: '#' + this._el.content_item.id,
      showSidebar: false
    });
    this.onLoaded();
  }

});

TL.Media.Flickr = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    try {
      this.establishMediaID();

      api_url = "https://api.flickr.com/services/rest/?method=flickr.photos.getSizes&api_key=" + this.options.api_key_flickr + "&photo_id=" + this.media_id + "&format=json&jsoncallback=?";

      TL.getJSON(api_url, function (d) {
        if (d.stat == "ok") {
          self.sizes = d.sizes.size;

          if (!self.options.background) {
            self.createMedia();
          }

          self.onLoaded();
        } else {
          self.loadErrorDisplay(self._("flickr_notfound_err"));
        }
      });
    } catch (e) {
      self.loadErrorDisplay(self._(e.message_key));
    }
  },

  establishMediaID: function establishMediaID() {
    if (this.data.url.match(/flic.kr\/.+/i)) {
      var encoded = this.data.url.split('/').slice(-1)[0];
      this.media_id = TL.Util.base58.decode(encoded);
    } else {
      var marker = 'flickr.com/photos/';
      var idx = this.data.url.indexOf(marker);
      if (idx == -1) {
        throw new TL.Error("flickr_invalidurl_err");
      }
      var pos = idx + marker.length;
      this.media_id = this.data.url.substr(pos).split("/")[1];
    }
  },

  createMedia: function createMedia() {
    var self = this;

    this._el.content_link = TL.Dom.create("a", "", this._el.content);
    this._el.content_link.href = this.data.url;
    this._el.content_link.target = "_blank";

    this._el.content_item = TL.Dom.create("img", "tl-media-item tl-media-image tl-media-flickr tl-media-shadow", this._el.content_link);

    if (this.data.alt) {
      this._el.content_item.alt = this.data.alt;
    } else if (this.data.caption) {
      this._el.content_item.alt = TL.Util.unhtmlify(this.data.caption);
    }

    if (this.data.title) {
      this._el.content_item.title = this.data.title;
    } else if (this.data.caption) {
      this._el.content_item.title = TL.Util.unhtmlify(this.data.caption);
    }

    this._el.content_item.addEventListener('load', function (e) {
      self.onMediaLoaded();
    });

    this._el.content_item.src = this.getImageURL(this.options.width, this.options.height);
  },

  getImageURL: function getImageURL(w, h) {
    var best_size = this.size_label(h),
        source = this.sizes[this.sizes.length - 2].source;

    for (var i = 0; i < this.sizes.length; i++) {
      if (this.sizes[i].label == best_size) {
        source = this.sizes[i].source;
      }
    }

    return source;
  },

  _getMeta: function _getMeta() {
    var self = this,
        api_url;

    api_url = "https://api.flickr.com/services/rest/?method=flickr.photos.getInfo&api_key=" + this.options.api_key_flickr + "&photo_id=" + this.media_id + "&format=json&jsoncallback=?";

    TL.getJSON(api_url, function (d) {
      self.data.credit_alternate = "<a href='" + self.data.url + "' target='_blank'>" + d.photo.owner.realname + "</a>";
      self.data.caption_alternate = d.photo.title._content + " " + d.photo.description._content;
      self.updateMeta();
    });
  },

  size_label: function size_label(s) {
    var _size = "";

    if (s <= 75) {
      if (s <= 0) {
        _size = "Large";
      } else {
        _size = "Thumbnail";
      }
    } else if (s <= 180) {
      _size = "Small";
    } else if (s <= 240) {
      _size = "Small 320";
    } else if (s <= 375) {
      _size = "Medium";
    } else if (s <= 480) {
      _size = "Medium 640";
    } else if (s <= 600) {
      _size = "Large";
    } else {
      _size = "Large";
    }

    return _size;
  }

});

TL.Media.GoogleDoc = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe", this._el.content);

    if (this.data.url.match("open\?id\=")) {
      this.media_id = this.data.url.split("open\?id\=")[1];
      if (this.data.url.match("\&authuser\=0")) {
        url = this.media_id.match("\&authuser\=0")[0];
      };
    } else if (this.data.url.match(/file\/d\/([^/]*)\/?/)) {
      var doc_id = this.data.url.match(/file\/d\/([^/]*)\/?/)[1];
      url = 'https://drive.google.com/file/d/' + doc_id + '/preview';
    } else {
      url = this.data.url;
    }

    this._el.content_item.innerHTML = "<iframe class='doc' frameborder='0' width='100%' height='100%' src='" + url + "'></iframe>";

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = this.options.height + "px";
  }

});

TL.Media.GooglePlus = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-googleplus", this._el.content);

    this.media_id = this.data.url;

    api_url = this.media_id;

    this._el.content_item.innerHTML = "<iframe frameborder='0' width='100%' height='100%' src='" + api_url + "'></iframe>";

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = this.options.height + "px";
  }

});

TL.Media.IFrame = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe", this._el.content);

    this.media_id = this.data.url;

    api_url = this.media_id;

    this._el.content_item.innerHTML = api_url;

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = this.options.height + "px";
  }

});

TL.Media.Image = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    this.loadingMessage();

    if (!this.options.background) {
      this.createMedia();
    }

    this.onLoaded();
  },

  createMedia: function createMedia() {
    var self = this,
        image_class = "tl-media-item tl-media-image tl-media-shadow";

    if (this.data.url.match(/.png(\?.*)?$/) || this.data.url.match(/.svg(\?.*)?$/)) {
      image_class = "tl-media-item tl-media-image";
    }

    if (this.data.link) {
      this._el.content_link = TL.Dom.create("a", "", this._el.content);
      this._el.content_link.href = this.data.link;
      this._el.content_link.target = "_blank";
      this._el.content_item = TL.Dom.create("img", image_class, this._el.content_link);
    } else {
      this._el.content_item = TL.Dom.create("img", image_class, this._el.content);
    }

    if (this.data.alt) {
      this._el.content_item.alt = this.data.alt;
    } else if (this.data.caption) {
      this._el.content_item.alt = TL.Util.unhtmlify(this.data.caption);
    }

    if (this.data.title) {
      this._el.content_item.title = this.data.title;
    } else if (this.data.caption) {
      this._el.content_item.title = TL.Util.unhtmlify(this.data.caption);
    }

    this._el.content_item.addEventListener('load', function (e) {
      self.onMediaLoaded();
    });

    this._el.content_item.src = this.getImageURL();
  },

  getImageURL: function getImageURL(w, h) {
    return TL.Util.transformImageURL(this.data.url);
  },

  _updateMediaDisplay: function _updateMediaDisplay(layout) {
    if (TL.Browser.firefox) {
      this._el.content_item.style.width = "auto";
    }
  }

});

TL.Media.Imgur = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    try {
      var self = this;

      if (this.data.url.match("<blockquote class=['\"]imgur-embed-pub['\"]")) {
        var found = this.data.url.match(/(imgur\.com)\/(\w+)/);
        this.media_id = found[2];
        this.data.url = "http://imgur.com/gallery/" + this.media_id;
      } else if (this.data.url) {
        this.media_id = this.data.url.split('/').slice(-1)[0];
      }

      TL.Load.js(['https://s.imgur.com/min/embed.js'], function () {
        self.createMedia();
      });
    } catch (e) {
      this.loadErrorDisplay(this._("imgur_invalidurl_err"));
    }
  },

  createMedia: function createMedia() {
    var self = this;
    var api_url = "https://api.imgur.com/oembed.json?url=" + this.data.url;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-image tl-media-imgur", this._el.content);

    TL.ajax({
      type: 'GET',
      url: api_url,
      dataType: 'json',
      success: function success(data) {
        try {
          self._el.content_item.innerHTML = data.html;
          setInterval(function () {
            if (document.querySelector("blockquote.imgur-embed-pub") == null) {
              clearInterval();
            } else {
              imgurEmbed.createIframe();
              document.getElementById("imageElement").removeAttribute("style");
              document.getElementById("image").removeAttribute("style");
            }
          }, 2000);
        } catch (e) {}
      },
      error: function error(xhr, errorType, error) {
        tc = new TL.TimelineConfig();
        if (errorType == 'parsererror') {
          var error = new TL.Error("invalid_url_err");
        } else {
          var error = new TL.Error("unknown_read_err", errorType);
        }
        self.loadErrorDisplay(self._("imgur_invalidurl_err"));
        tc.logError(error);
      }
    });

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.width = this.options.width + "px";
    this._el.content_item.style.height = TL.Util.ratio.r16_9({ w: this.options.width }) + "px";
  }

});

TL.Media.Instagram = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    this.media_id = this.data.url.split("\/p\/")[1].split("/")[0];

    if (!this.options.background) {
      this.createMedia();
    }

    this.onLoaded();
  },

  createMedia: function createMedia() {
    var self = this;

    this._el.content_link = TL.Dom.create("a", "", this._el.content);
    this._el.content_link.href = this.data.url;
    this._el.content_link.target = "_blank";

    this._el.content_item = TL.Dom.create("img", "tl-media-item tl-media-image tl-media-instagram tl-media-shadow", this._el.content_link);

    if (this.data.alt) {
      this._el.content_item.alt = this.data.alt;
    } else if (this.data.caption) {
      this._el.content_item.alt = TL.Util.unhtmlify(this.data.caption);
    }

    if (this.data.title) {
      this._el.content_item.title = this.data.title;
    } else if (this.data.caption) {
      this._el.content_item.title = TL.Util.unhtmlify(this.data.caption);
    }

    this._el.content_item.addEventListener('load', function (e) {
      self.onMediaLoaded();
    });

    this._el.content_item.src = this.getImageURL(this._el.content.offsetWidth);
  },

  getImageURL: function getImageURL(w, h) {
    return "https://instagram.com/p/" + this.media_id + "/media/?size=" + this.sizes(w);
  },

  _getMeta: function _getMeta() {
    var self = this,
        api_url;

    api_url = "https://api.instagram.com/oembed?url=https://instagr.am/p/" + this.media_id + "&callback=?";

    TL.getJSON(api_url, function (d) {
      self.data.credit_alternate = "<a href='" + d.author_url + "' target='_blank'>" + d.author_name + "</a>";
      self.data.caption_alternate = d.title;
      self.updateMeta();
    });
  },

  sizes: function sizes(s) {
    var _size = "";
    if (s <= 150) {
      _size = "t";
    } else if (s <= 306) {
      _size = "m";
    } else {
      _size = "l";
    }

    return _size;
  }

});

TL.Media.GoogleMap = TL.Media.extend({
  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-map tl-media-shadow", this._el.content);

    this.media_id = this.data.url;

    this.mapframe = TL.Dom.create("iframe", "", this._el.content_item);
    window.stash = this;
    this.mapframe.width = "100%";
    this.mapframe.height = "100%";
    this.mapframe.frameBorder = "0";
    this.mapframe.src = this.makeGoogleMapsEmbedURL(this.media_id, this.options.api_key_googlemaps);

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    if (this._state.loaded) {
      var dimensions = TL.Util.ratio.square({ w: this._el.content_item.offsetWidth });
      this._el.content_item.style.height = dimensions.h + "px";
    }
  },

  makeGoogleMapsEmbedURL: function makeGoogleMapsEmbedURL(url, api_key) {
    var Streetview = false;

    function determineMapMode(url) {
      function parseDisplayMode(display_mode, param_string) {
        if (display_mode.slice(-1) == "z") {
          param_string["zoom"] = display_mode;
        } else if (display_mode.slice(-1) == "m") {
          param_string["zoom"] = 14;
          param_string["maptype"] = "satellite";
        } else if (display_mode.slice(-1) == "t") {
          Streetview = true;

          if (mapmode == "place") {
            var center = url.match(regexes["place"])[3] + "," + url.match(regexes["place"])[4];
          } else {
            var center = param_string["center"];
            delete param_string["center"];
          }

          param_string = {};
          param_string["location"] = center;
          streetview_params = display_mode.split(",");
          for (param in param_defs["streetview"]) {
            var i = parseInt(param) + 1;
            if (param_defs["streetview"][param] == "pitch" && streetview_params[i] == "90t") {
              param_string[param_defs["streetview"][param]] = 0;
            } else {
              param_string[param_defs["streetview"][param]] = streetview_params[i].slice(0, -1);
            }
          }
        }
        return param_string;
      }
      function determineMapModeURL(mapmode, match) {
        var param_string = {};
        var url_root = match[1],
            display_mode = match[match.length - 1];
        for (param in param_defs[mapmode]) {
          var i = parseInt(param) + 2;
          if (param_defs[mapmode][param] == "center") {
            param_string[param_defs[mapmode][param]] = match[i] + "," + match[++i];
          } else {
            param_string[param_defs[mapmode][param]] = match[i];
          }
        }

        param_string = parseDisplayMode(display_mode, param_string);
        param_string["key"] = api_key;
        if (Streetview == true) {
          mapmode = "streetview";
        } else {}
        return url_root + "/embed/v1/" + mapmode + TL.Util.getParamString(param_string);
      }

      mapmode = "view";
      if (url.match(regexes["place"])) {
        mapmode = "place";
      } else if (url.match(regexes["directions"])) {
        mapmode = "directions";
      } else if (url.match(regexes["search"])) {
        mapmode = "search";
      }
      return determineMapModeURL(mapmode, url.match(regexes[mapmode]));
    }

    var param_defs = {
      "view": ["center"],
      "place": ["q", "center"],
      "directions": ["origin", "destination", "center"],
      "search": ["q", "center"],
      "streetview": ["fov", "heading", "pitch"]
    };

    var root_url_regex = /(https:\/\/.+google.+?\/maps)/;
    var coords_regex = /@([-\d.]+),([-\d.]+)/;
    var address_regex = /([\w\W]+)/;

    var data_regex = /data=[\S]*/;

    var display_mode_regex = /,((?:[-\d.]+[zmayht],?)*)/;

    var regexes = {
      view: new RegExp(root_url_regex.source + "/" + coords_regex.source + display_mode_regex.source),
      place: new RegExp(root_url_regex.source + "/place/" + address_regex.source + "/" + coords_regex.source + display_mode_regex.source),
      directions: new RegExp(root_url_regex.source + "/dir/" + address_regex.source + "/" + address_regex.source + "/" + coords_regex.source + display_mode_regex.source),
      search: new RegExp(root_url_regex.source + "/search/" + address_regex.source + "/" + coords_regex.source + display_mode_regex.source)
    };
    return determineMapMode(url);
  }

});

TL.Media.PDF = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var url = TL.Util.transformImageURL(this.data.url),
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe", this._el.content);
    var markup = "";

    if (TL.Browser.ie || TL.Browser.edge || url.match(/dl.dropboxusercontent.com/)) {
      markup = "<iframe class='doc' frameborder='0' width='100%' height='100%' src='//docs.google.com/viewer?url=" + url + "&amp;embedded=true'></iframe>";
    } else {
      markup = "<iframe class='doc' frameborder='0' width='100%' height='100%' src='" + url + "'></iframe>";
    }
    this._el.content_item.innerHTML = markup;
    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = this.options.height + "px";
  }

});

TL.Media.Profile = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {

    this._el.content_item = TL.Dom.create("img", "tl-media-item tl-media-image tl-media-profile tl-media-shadow", this._el.content);
    this._el.content_item.src = this.data.url;

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay(layout) {

    if (TL.Browser.firefox) {
      this._el.content_item.style.maxWidth = this.options.width / 2 - 40 + "px";
    }
  }

});

TL.Media.Slider = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {

    this._el.content_item = TL.Dom.create("img", "tl-media-item tl-media-image", this._el.content);
    this._el.content_item.src = this.data.url;

    this.onLoaded();
  }

});

var soundCoudCreated = false;

TL.Media.SoundCloud = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe tl-media-soundcloud tl-media-shadow", this._el.content);

    this.media_id = this.data.url;

    api_url = "https://soundcloud.com/oembed?url=" + this.media_id + "&format=js&callback=?";

    TL.getJSON(api_url, function (d) {
      TL.Load.js("https://w.soundcloud.com/player/api.js", function () {
        self.createMedia(d);
      });
    });
  },

  createMedia: function createMedia(d) {
    this._el.content_item.innerHTML = d.html;

    this.soundCloudCreated = true;

    self.widget = SC.Widget(this._el.content_item.querySelector("iframe"));
    this.onLoaded();
  },

  _stopMedia: function _stopMedia() {
    if (this.soundCloudCreated) {
      self.widget.pause();
    }
  }

});

TL.Media.Spotify = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe tl-media-spotify", this._el.content);

    if (this.data.url.match(/^spotify:track/) || this.data.url.match(/^spotify:album/) || this.data.url.match(/^spotify:user:.+:playlist:/)) {
      this.media_id = this.data.url;
    }

    if (this.data.url.match(/spotify\.com\/track\/(.+)/)) {
      this.media_id = "spotify:track:" + this.data.url.match(/spotify\.com\/track\/(.+)/)[1];
    } else if (this.data.url.match(/spotify\.com\/album\/(.+)/)) {
      this.media_id = "spotify:album:" + this.data.url.match(/spotify\.com\/album\/(.+)/)[1];
    } else if (this.data.url.match(/spotify\.com\/user\/(.+?)\/playlist\/(.+)/)) {
      var user = this.data.url.match(/spotify\.com\/user\/(.+?)\/playlist\/(.+)/)[1];
      var playlist = this.data.url.match(/spotify\.com\/user\/(.+?)\/playlist\/(.+)/)[2];
      this.media_id = "spotify:user:" + user + ":playlist:" + playlist;
    } else if (this.data.url.match(/spotify\.com\/artist\/(.+)/)) {
      var artist = this.data.url.match(/spotify\.com\/artist\/(.+)/)[1];
      this.media_id = "spotify:artist:" + artist;
    }

    if (this.media_id) {
      api_url = "https://embed.spotify.com/?uri=" + this.media_id + "&theme=white&view=coverart";

      this.player = TL.Dom.create("iframe", "tl-media-shadow", this._el.content_item);
      this.player.width = "100%";
      this.player.height = "100%";
      this.player.frameBorder = "0";
      this.player.src = api_url;

      this.onLoaded();
    } else {
      this.loadErrorDisplay(this._('spotify_invalid_url'));
    }
  },

  _updateMediaDisplay: function _updateMediaDisplay(l) {
    var _height = this.options.height,
        _player_height = 0,
        _player_width = 0;

    if (TL.Browser.mobile) {
      _height = this.options.height / 2;
    } else {
      _height = this.options.height - this.options.credit_height - this.options.caption_height - 30;
    }

    this._el.content_item.style.maxHeight = "none";
    TL.trace(_height);
    TL.trace(this.options.width);
    if (_height > this.options.width) {
      TL.trace("height is greater");
      _player_height = this.options.width + 80 + "px";
      _player_width = this.options.width + "px";
    } else {
      TL.trace("width is greater");
      TL.trace(this.options.width);
      _player_height = _height + "px";
      _player_width = _height - 80 + "px";
    }

    this.player.style.width = _player_width;
    this.player.style.height = _player_height;

    if (this._el.credit) {
      this._el.credit.style.width = _player_width;
    }
    if (this._el.caption) {
      this._el.caption.style.width = _player_width;
    }
  },

  _stopMedia: function _stopMedia() {}

});

TL.Media.Storify = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var content;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe tl-media-storify", this._el.content);

    this.media_id = this.data.url;

    content = "<iframe frameborder='0' width='100%' height='100%' src='" + this.media_id + "/embed'></iframe>";
    content += "<script src='" + this.media_id + ".js'></script>";

    this._el.content_item.innerHTML = content;

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = this.options.height + "px";
  }

});

TL.Media.Text = TL.Class.extend({

  includes: [TL.Events],

  _el: {
    container: {},
    content_container: {},
    content: {},
    headline: {},
    date: {}
  },

  data: {
    unique_id: "",
    headline: "headline",
    text: "text"
  },

  options: {
    title: false
  },

  initialize: function initialize(data, options, add_to_container) {

    TL.Util.setData(this, data);

    TL.Util.mergeData(this.options, options);

    this._el.container = TL.Dom.create("div", "tl-text");
    this._el.container.id = this.data.unique_id;

    this._initLayout();

    if (add_to_container) {
      add_to_container.appendChild(this._el.container);
    };
  },

  show: function show() {},

  hide: function hide() {},

  addTo: function addTo(container) {
    container.appendChild(this._el.container);
  },

  removeFrom: function removeFrom(container) {
    container.removeChild(this._el.container);
  },

  headlineHeight: function headlineHeight() {
    return this._el.headline.offsetHeight + 40;
  },

  addDateText: function addDateText(str) {
    this._el.date.innerHTML = str;
  },

  onLoaded: function onLoaded() {
    this.fire("loaded", this.data);
  },

  onAdd: function onAdd() {
    this.fire("added", this.data);
  },

  onRemove: function onRemove() {
    this.fire("removed", this.data);
  },

  _initLayout: function _initLayout() {
    this._el.content_container = TL.Dom.create("div", "tl-text-content-container", this._el.container);

    this._el.date = TL.Dom.create("h3", "tl-headline-date", this._el.content_container);

    if (this.data.headline != "") {
      var headline_class = "tl-headline";
      if (this.options.title) {
        headline_class = "tl-headline tl-headline-title";
      }
      this._el.headline = TL.Dom.create("h2", headline_class, this._el.content_container);
      this._el.headline.innerHTML = this.data.headline;
    }

    if (this.data.text != "") {
      var text_content = "";

      text_content += TL.Util.htmlify(this.options.autolink == true ? TL.Util.linkify(this.data.text) : this.data.text);
      TL.trace(this.data.text);
      this._el.content = TL.Dom.create("div", "tl-text-content", this._el.content_container);
      this._el.content.innerHTML = text_content;
      TL.trace(text_content);
      TL.trace(this._el.content);
    }

    this.onLoaded();
  }

});

TL.Media.Twitter = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-twitter", this._el.content);
    this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";

    if (this.data.url.match("^(https?:)?\/*(www.)?twitter\.com")) {
      if (this.data.url.match("status\/")) {
        this.media_id = this.data.url.split("status\/")[1];
      } else if (this.data.url.match("statuses\/")) {
        this.media_id = this.data.url.split("statuses\/")[1];
      } else {
        this.media_id = "";
      }
    } else if (this.data.url.match("<blockquote class=['\"]twitter-tweet['\"]")) {

      var found = this.data.url.match(/(status|statuses)\/(\d+)/);
      if (found && found.length > 2) {
        this.media_id = found[2];
      } else {
        self.loadErrorDisplay(self._("twitterembed_invalidurl_err"));
        return;
      }
    }

    api_url = "https://api.twitter.com/1/statuses/oembed.json?id=" + this.media_id + "&omit_script=true&include_entities=true&callback=?";

    TL.ajax({
      type: 'GET',
      url: api_url,
      dataType: 'json',
      success: function success(d) {
        self.createMedia(d);
      },
      error: function error(xhr, type) {
        var error_text = "";
        error_text += self._("twitter_load_err") + "<br/>" + self.media_id + "<br/>" + type;
        self.loadErrorDisplay(error_text);
      }
    });
  },

  createMedia: function createMedia(d) {
    TL.trace("create_media");
    var tweet = "",
        tweet_text = "",
        tweetuser = "",
        tweet_status_temp = "",
        tweet_status_url = "",
        tweet_status_date = "",
        self = this;

    tweet_text = d.html.split("<\/p>\&mdash;")[0] + "</p></blockquote>";
    tweetuser = d.author_url.split("twitter.com\/")[1];
    tweet_status_temp = d.html.split("<\/p>\&mdash;")[1].split("<a href=\"")[1];
    tweet_status_url = tweet_status_temp.split("\"\>")[0];
    tweet_status_date = tweet_status_temp.split("\"\>")[1].split("<\/a>")[0];

    tweet_text = tweet_text.replace(/<a href/ig, '<a target="_blank" href');

    if (tweet_text.includes("pic.twitter.com")) {

      TL.Load.js('https://platform.twitter.com/widgets.js', function () {
        twttr.widgets.createTweet(self.media_id, self._el.content_item, {
          conversation: 'none',
          linkColor: '#cc0000',
          theme: 'light' });
      });

      this.onLoaded();
    } else {
      tweet += tweet_text;

      tweet += "<div class='vcard'>";
      tweet += "<a href='" + tweet_status_url + "' class='twitter-date' target='_blank'>" + tweet_status_date + "</a>";
      tweet += "<img src='" + "' class='tl-media-item tl-media-image' target='_blank'>" + "</a>";
      tweet += "<div class='author'>";
      tweet += "<a class='screen-name url' href='" + d.author_url + "' target='_blank'>";
      tweet += "<span class='avatar'></span>";
      tweet += "<span class='fn'>" + d.author_name + " <span class='tl-icon-twitter'></span></span>";
      tweet += "<span class='nickname'>@" + tweetuser + "<span class='thumbnail-inline'></span></span>";
      tweet += "</a>";
      tweet += "</div>";
      tweet += "</div>";

      this._el.content_item.innerHTML = tweet;

      this.onLoaded();
    }
  },

  updateMediaDisplay: function updateMediaDisplay() {},

  _updateMediaDisplay: function _updateMediaDisplay() {}

});

var mediaID;

TL.Media.TwitterEmbed = TL.Media.extend({
  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-twitter", this._el.content);
    this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";

    var found = this.data.url.match(/(status|statuses)\/(\d+)/);
    if (found && found.length > 2) {
      this.media_id = found[2];
    } else {
      self.loadErrorDisplay(self._("twitterembed_invalidurl_err"));
      return;
    }

    api_url = "https://api.twitter.com/1/statuses/oembed.json?id=" + this.media_id + "&omit_script=true&include_entities=true&callback=?";

    window.twttr = function (d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0],
          t = window.twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function (f) {
        t._e.push(f);
      };

      return t;
    }(document, "script", "twitter-wjs");

    mediaID = this.media_id;

    TL.ajax({
      type: 'GET',
      url: api_url,
      dataType: 'json',
      success: function success(d) {
        self.createMedia(d);
      },
      error: function error(xhr, type) {
        var error_text = "";
        error_text += self._("twitter_load_err") + "<br/>" + self.media_id + "<br/>" + type;
        self.loadErrorDisplay(error_text);
      }
    });
  },

  createMedia: function createMedia(d) {
    TL.trace("create_media");
    var tweet = "",
        tweet_text = "",
        tweetuser = "",
        tweet_status_temp = "",
        tweet_status_url = "",
        tweet_status_date = "";

    tweet_text = d.html.split("<\/p>\&mdash;")[0] + "</p></blockquote>";
    console.log(tweet_text);
    tweetuser = d.author_url.split("twitter.com\/")[1];
    tweet_status_temp = d.html.split("<\/p>\&mdash;")[1].split("<a href=\"")[1];
    tweet_status_url = tweet_status_temp.split("\"\>")[0];
    tweet_status_date = tweet_status_temp.split("\"\>")[1].split("<\/a>")[0];

    tweet_text = tweet_text.replace(/<a href/ig, '<a target="_blank" href');

    if (tweet_text.includes("pic.twitter.com")) {
      twttr.ready(function (evt) {
        tweet = document.getElementsByClassName("tl-media-twitter")[0];
        var id = String(mediaID);
        twttr.widgets.createTweet(id, tweet, {
          conversation: 'none',
          linkColor: '#cc0000',
          theme: 'light' }).then(function (evt) {
          this.onLoaded();
        });
      });
      this._el.content_item.innerHTML = tweet;
      this.onLoaded();
    } else {
      tweet += tweet_text;

      tweet += "<div class='vcard'>";
      tweet += "<a href='" + tweet_status_url + "' class='twitter-date' target='_blank'>" + tweet_status_date + "</a>";
      tweet += "<div class='author'>";
      tweet += "<a class='screen-name url' href='" + d.author_url + "' target='_blank'>";
      tweet += "<span class='avatar'></span>";
      tweet += "<span class='fn'>" + d.author_name + " <span class='tl-icon-twitter'></span></span>";
      tweet += "<span class='nickname'>@" + tweetuser + "<span class='thumbnail-inline'></span></span>";
      tweet += "</a>";
      tweet += "</div>";
      tweet += "</div>";

      this._el.content_item.innerHTML = tweet;

      this.onLoaded();
    }
  },

  updateMediaDisplay: function updateMediaDisplay() {},

  _updateMediaDisplay: function _updateMediaDisplay() {}

});

TL.Media.Vimeo = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe tl-media-vimeo tl-media-shadow", this._el.content);

    this.media_id = this.data.url.split(/video\/|\/\/vimeo\.com\//)[1].split(/[?&]/)[0];

    api_url = "https://player.vimeo.com/video/" + this.media_id + "?api=1&title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff";

    this.player = TL.Dom.create("iframe", "", this._el.content_item);

    this.player.addEventListener('load', function (e) {
      self.onMediaLoaded();
    });

    this.player.width = "100%";
    this.player.height = "100%";
    this.player.frameBorder = "0";
    this.player.src = api_url;

    this.player.setAttribute('allowfullscreen', '');
    this.player.setAttribute('webkitallowfullscreen', '');
    this.player.setAttribute('mozallowfullscreen', '');

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = TL.Util.ratio.r16_9({ w: this._el.content_item.offsetWidth }) + "px";
  },

  _stopMedia: function _stopMedia() {

    try {
      this.player.contentWindow.postMessage((0, _stringify2.default)({ method: "pause" }), "https://player.vimeo.com");
    } catch (err) {
      TL.trace(err);
    }
  }
});

TL.Media.Vine = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe tl-media-vine tl-media-shadow", this._el.content);

    this.media_id = this.data.url.split("vine.co/v/")[1];

    api_url = "https://vine.co/v/" + this.media_id + "/embed/simple";

    this._el.content_item.innerHTML = "<iframe frameborder='0' width='100%' height='100%' src='" + api_url + "'></iframe><script async src='https://platform.vine.co/static/scripts/embed.js' charset='utf-8'></script>";

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    var size = TL.Util.ratio.square({ w: this._el.content_item.offsetWidth, h: this.options.height });
    this._el.content_item.style.height = size.h + "px";
  },

  _stopMedia: function _stopMedia() {
    this._el.content_item.querySelector("iframe").contentWindow.postMessage('pause', '*');
  }

});

TL.Media.Website = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var self = this;

    this.media_id = this.data.url.replace(/.*?:\/\//g, "");

    if (this.options.api_key_embedly) {
      api_url = "https://api.embed.ly/1/extract?key=" + this.options.api_key_embedly + "&url=" + this.media_id + "&callback=?";

      TL.getJSON(api_url, function (d) {
        self.createMedia(d);
      });
    } else {
      this.createCardContent();
    }
  },

  createCardContent: function createCardContent() {
    (function (w, d) {
      var id = 'embedly-platform',
          n = 'script';
      if (!d.getElementById(id)) {
        w.embedly = w.embedly || function () {
          (w.embedly.q = w.embedly.q || []).push(arguments);
        };
        var e = d.createElement(n);e.id = id;e.async = 1;
        e.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.embedly.com/widgets/platform.js';
        var s = d.getElementsByTagName(n)[0];
        s.parentNode.insertBefore(e, s);
      }
    })(window, document);

    var content = "<a href=\"" + this.data.url + "\" class=\"embedly-card\">" + this.data.url + "</a>";
    this._setContent(content);
  },
  createMedia: function createMedia(d) {
    var content = "";

    content += "<h4><a href='" + this.data.url + "' target='_blank'>" + d.title + "</a></h4>";
    if (d.images) {
      if (d.images[0]) {
        TL.trace(d.images[0].url);
        content += "<img src='" + d.images[0].url + "' />";
      }
    }
    if (d.favicon_url) {
      content += "<img class='tl-media-website-icon' src='" + d.favicon_url + "' />";
    }
    content += "<span class='tl-media-website-description'>" + d.provider_name + "</span><br/>";
    content += "<p>" + d.description + "</p>";

    this._setContent(content);
  },

  _setContent: function _setContent(content) {
    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-website", this._el.content);
    this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";
    this._el.content_item.innerHTML = content;

    this.onLoaded();
  },

  updateMediaDisplay: function updateMediaDisplay() {},

  _updateMediaDisplay: function _updateMediaDisplay() {}

});

TL.Media.Wikipedia = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        api_language,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-wikipedia", this._el.content);
    this._el.content_container.className = "tl-media-content-container tl-media-content-container-text";

    this.media_id = this.data.url.split("wiki\/")[1].split("#")[0].replace("_", " ");
    this.media_id = this.media_id.replace(" ", "%20");
    api_language = this.data.url.split("//")[1].split(".wikipedia")[0];

    api_url = "https://" + api_language + ".wikipedia.org/w/api.php?action=query&prop=extracts|pageimages&redirects=&titles=" + this.media_id + "&exintro=1&format=json&callback=?";

    TL.ajax({
      type: 'GET',
      url: api_url,
      dataType: 'json',

      success: function success(d) {
        self.createMedia(d);
      },
      error: function error(xhr, type) {
        var error_text = "";
        error_text += self._("wikipedia_load_err") + "<br/>" + self.media_id + "<br/>" + type;
        self.loadErrorDisplay(error_text);
      }
    });
  },

  createMedia: function createMedia(d) {
    var wiki = "";

    if (d.query) {
      var content = "",
          wiki = {
        entry: {},
        title: "",
        text: "",
        extract: "",
        paragraphs: 1,
        page_image: "",
        text_array: []
      };

      wiki.entry = TL.Util.getObjectAttributeByIndex(d.query.pages, 0);
      wiki.extract = wiki.entry.extract;
      wiki.title = wiki.entry.title;
      wiki.page_image = wiki.entry.thumbnail;

      if (wiki.extract.match("<p>")) {
        wiki.text_array = wiki.extract.split("<p>");
      } else {
        wiki.text_array.push(wiki.extract);
      }

      for (var i = 0; i < wiki.text_array.length; i++) {
        if (i + 1 <= wiki.paragraphs && i + 1 < wiki.text_array.length) {
          wiki.text += "<p>" + wiki.text_array[i + 1];
        }
      }

      content += "<span class='tl-icon-wikipedia'></span>";
      content += "<div class='tl-wikipedia-title'><h4><a href='" + this.data.url + "' target='_blank'>" + wiki.title + "</a></h4>";
      content += "<span class='tl-wikipedia-source'>" + this._('wikipedia') + "</span></div>";

      if (wiki.page_image) {}

      content += wiki.text;

      if (wiki.extract.match("REDIRECT")) {} else {
        this._el.content_item.innerHTML = content;

        this.onLoaded();
      }
    }
  },

  updateMediaDisplay: function updateMediaDisplay() {},

  _updateMediaDisplay: function _updateMediaDisplay() {}

});

TL.Media.Wistia = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var api_url,
        self = this;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-iframe tl-media-wistia tl-media-shadow", this._el.content);

    this.media_id = this.data.url.split(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/medias\/(.*)/)[3];

    api_url = "https://fast.wistia.com/embed/iframe/" + this.media_id + "?version=v1&controlsVisibleOnLoad=true&playerColor=aae3d8";

    this.player = TL.Dom.create("iframe", "", this._el.content_item);

    this.player.addEventListener('load', function (e) {
      self.onMediaLoaded();
    });

    this.player.width = "100%";
    this.player.height = "100%";
    this.player.frameBorder = "0";
    this.player.src = api_url;

    this.player.setAttribute('allowfullscreen', '');
    this.player.setAttribute('webkitallowfullscreen', '');
    this.player.setAttribute('mozallowfullscreen', '');

    this.onLoaded();
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = TL.Util.ratio.r16_9({ w: this._el.content_item.offsetWidth }) + "px";
  },

  _stopMedia: function _stopMedia() {
    try {
      this.player.contentWindow.postMessage((0, _stringify2.default)({ method: "pause" }), "https://player.vimeo.com");
    } catch (err) {
      TL.trace(err);
    }
  }
});

TL.Media.YouTube = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    var self = this,
        url_vars;

    this.youtube_loaded = false;

    this._el.content_item = TL.Dom.create("div", "tl-media-item tl-media-youtube tl-media-shadow", this._el.content);
    this._el.content_item.id = TL.Util.unique_ID(7);

    url_vars = TL.Util.getUrlVars(this.data.url);

    this.media_id = {};

    if (this.data.url.match('v=')) {
      this.media_id.id = url_vars["v"];
    } else if (this.data.url.match('\/embed\/')) {
      this.media_id.id = this.data.url.split("embed\/")[1].split(/[?&]/)[0];
    } else if (this.data.url.match(/v\/|v=|youtu\.be\//)) {
      this.media_id.id = this.data.url.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0];
    } else {
      TL.trace("YOUTUBE IN URL BUT NOT A VALID VIDEO");
    }

    this.media_id.start = parseInt(url_vars["start"]);

    if (isNaN(this.media_id.start)) {
      this.media_id.start = TL.Util.parseYouTubeTime(url_vars["t"]);
    }

    this.media_id.end = parseInt(url_vars["end"]);

    this.media_id.hd = Boolean(typeof url_vars["hd"] != 'undefined');

    TL.Load.js('https://www.youtube.com/iframe_api', function () {
      self.createMedia();
    });
  },

  _updateMediaDisplay: function _updateMediaDisplay() {
    this._el.content_item.style.height = TL.Util.ratio.r16_9({ w: this.options.width }) + "px";
    this._el.content_item.style.width = this.options.width + "px";
  },

  _stopMedia: function _stopMedia() {
    if (this.youtube_loaded) {
      try {
        if (this.player.getPlayerState() == YT.PlayerState.PLAYING) {
          this.player.pauseVideo();
        }
      } catch (err) {
        TL.trace(err);
      }
    }
  },
  createMedia: function createMedia() {
    var self = this;

    clearTimeout(this.timer);

    if (typeof YT != 'undefined' && typeof YT.Player != 'undefined') {
      this.player = new YT.Player(this._el.content_item.id, {
        playerVars: {
          enablejsapi: 1,
          color: 'white',
          autohide: 1,
          showinfo: 0,
          theme: 'light',
          start: this.media_id.start,
          end: this.media_id.end,
          fs: 0,
          rel: 0
        },
        videoId: this.media_id.id,
        events: {
          onReady: function onReady() {
            self.onPlayerReady();

            self.onLoaded();
          },
          'onStateChange': self.onStateChange
        }
      });
    } else {
      this.timer = setTimeout(function () {
        self.createMedia();
      }, 1000);
    }
  },

  onPlayerReady: function onPlayerReady(e) {
    this.youtube_loaded = true;
    this._el.content_item = document.getElementById(this._el.content_item.id);
    this.onMediaLoaded();
  },

  onStateChange: function onStateChange(e) {
    if (e.data == YT.PlayerState.ENDED) {
      e.target.seekTo(0);
      e.target.pauseVideo();
    }
  }

});

TL.Media.Audio = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    this.loadingMessage();

    if (!this.options.background) {
      this.createMedia();
    }

    this.onLoaded();
  },

  createMedia: function createMedia() {
    var self = this,
        audio_class = "tl-media-item tl-media-audio tl-media-shadow";

    if (this.data.link) {
      this._el.content_link = TL.Dom.create("a", "", this._el.content);
      this._el.content_link.href = this.data.link;
      this._el.content_link.target = "_blank";
      this._el.content_item = TL.Dom.create("audio", audio_class, this._el.content_link);
    } else {
      this._el.content_item = TL.Dom.create("audio", audio_class, this._el.content);
    }

    this._el.content_item.controls = true;
    this._el.source_item = TL.Dom.create("source", "", this._el.content_item);

    this._el.content_item.addEventListener('load', function (e) {
      self.onMediaLoaded();
    });

    this._el.source_item.src = this.data.url;
    this._el.source_item.type = this._getType(this.data.url, this.data.mediatype.match_str);
    this._el.content_item.innerHTML += "Your browser doesn't support HTML5 audio with " + this._el.source_item.type;
  },

  _updateMediaDisplay: function _updateMediaDisplay(layout) {
    if (TL.Browser.firefox) {
      this._el.content_item.style.width = "auto";
    }
  },

  _getType: function _getType(url, reg) {
    var ext = url.match(reg);
    var type = "audio/";
    switch (ext[1]) {
      case "mp3":
        type += "mpeg";
        break;
      case "wav":
        type += "wav";
        break;
      case "m4a":
        type += "mp4";
        break;
      default:
        type = "audio";
        break;
    }
    return type;
  }

});

TL.Media.Video = TL.Media.extend({

  includes: [TL.Events],

  _loadMedia: function _loadMedia() {
    this.loadingMessage();

    if (!this.options.background) {
      this.createMedia();
    }

    this.onLoaded();
  },

  createMedia: function createMedia() {
    var self = this,
        video_class = "tl-media-item tl-media-video tl-media-shadow";

    if (this.data.link) {
      this._el.content_link = TL.Dom.create("a", "", this._el.content);
      this._el.content_link.href = this.data.link;
      this._el.content_link.target = "_blank";
      this._el.content_item = TL.Dom.create("video", video_class, this._el.content_link);
    } else {
      this._el.content_item = TL.Dom.create("video", video_class, this._el.content);
    }

    this._el.content_item.controls = true;
    this._el.source_item = TL.Dom.create("source", "", this._el.content_item);

    this._el.content_item.addEventListener('load', function (e) {
      self.onMediaLoaded();
    });

    this._el.source_item.src = this.data.url;
    this._el.source_item.type = this._getType(this.data.url, this.data.mediatype.match_str);
    this._el.content_item.innerHTML += "Your browser doesn't support HTML5 video with " + this._el.source_item.type;
  },

  _updateMediaDisplay: function _updateMediaDisplay(layout) {
    if (TL.Browser.firefox) {
      this._el.content_item.style.width = "auto";
    }
  },

  _getType: function _getType(url, reg) {
    var ext = url.match(reg);
    var type = "video/";
    switch (ext[1]) {
      case "mp4":
        type += "mp4";
        break;
      default:
        type = "video";
        break;
    }
    return type;
  }

});

TL.Slide = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins, TL.I18NMixins],

  _el: {},

  initialize: function initialize(data, options, title_slide) {
    this._el = {
      container: {},
      scroll_container: {},
      background: {},
      content_container: {},
      content: {}
    };

    this._media = null;
    this._mediaclass = {};
    this._text = {};
    this._background_media = null;

    this._state = {
      loaded: false
    };

    this.has = {
      headline: false,
      text: false,
      media: false,
      title: false,
      background: {
        image: false,
        color: false,
        color_value: ""
      }
    };

    this.has.title = title_slide;

    this.data = {
      unique_id: null,
      background: null,
      start_date: null,
      end_date: null,
      location: null,
      text: null,
      media: null,
      autolink: true
    };

    this.options = {
      duration: 1000,
      slide_padding_lr: 40,
      ease: TL.Ease.easeInSpline,
      width: 600,
      height: 600,
      skinny_size: 650,
      media_name: ""
    };

    this.active = false;

    this.animator = {};

    TL.Util.mergeData(this.options, options);
    TL.Util.mergeData(this.data, data);

    this._initLayout();
    this._initEvents();
  },

  show: function show() {
    this.animator = TL.Animate(this._el.slider_container, {
      left: -(this._el.container.offsetWidth * n) + "px",
      duration: this.options.duration,
      easing: this.options.ease
    });
  },

  hide: function hide() {},

  setActive: function setActive(is_active) {
    this.active = is_active;

    if (this.active) {
      if (this.data.background) {
        this.fire("background_change", this.has.background);
      }
      this.loadMedia();
    } else {
      this.stopMedia();
    }
  },

  addTo: function addTo(container) {
    container.appendChild(this._el.container);
  },

  removeFrom: function removeFrom(container) {
    container.removeChild(this._el.container);
  },

  updateDisplay: function updateDisplay(w, h, l) {
    this._updateDisplay(w, h, l);
  },

  loadMedia: function loadMedia() {
    var self = this;

    if (this._media && !this._state.loaded) {
      this._media.loadMedia();
      this._state.loaded = true;
    }

    if (this._background_media && !this._background_media._state.loaded) {
      this._background_media.on("loaded", function () {
        self._updateBackgroundDisplay();
      });
      this._background_media.loadMedia();
    }
  },

  stopMedia: function stopMedia() {
    if (this._media && this._state.loaded) {
      this._media.stopMedia();
    }
  },

  getBackground: function getBackground() {
    return this.has.background;
  },

  scrollToTop: function scrollToTop() {
    this._el.container.scrollTop = 0;
  },

  getFormattedDate: function getFormattedDate() {

    if (TL.Util.trim(this.data.display_date).length > 0) {
      return this.data.display_date;
    }
    var date_text = "";

    if (!this.has.title) {
      if (this.data.end_date) {
        date_text = " &mdash; " + this.data.end_date.getDisplayDate(this.getLanguage());
      }
      if (this.data.start_date) {
        date_text = this.data.start_date.getDisplayDate(this.getLanguage()) + date_text;
      }
    }
    return date_text;
  },

  _initLayout: function _initLayout() {
    this._el.container = TL.Dom.create("div", "tl-slide");

    if (this.has.title) {
      this._el.container.className = "tl-slide tl-slide-titleslide";
    }

    if (this.data.unique_id) {
      this._el.container.id = this.data.unique_id;
    }
    this._el.scroll_container = TL.Dom.create("div", "tl-slide-scrollable-container", this._el.container);
    this._el.content_container = TL.Dom.create("div", "tl-slide-content-container", this._el.scroll_container);
    this._el.content = TL.Dom.create("div", "tl-slide-content", this._el.content_container);
    this._el.background = TL.Dom.create("div", "tl-slide-background", this._el.container);

    if (this.data.background) {
      if (this.data.background.url) {
        var media_type = TL.MediaType(this.data.background, true);
        if (media_type) {
          this._background_media = new media_type.cls(this.data.background, { background: 1 });

          this.has.background.image = true;
          this._el.container.className += ' tl-full-image-background';
          this.has.background.color_value = "#000";
          this._el.background.style.display = "block";
        }
      }
      if (this.data.background.color) {
        this.has.background.color = true;
        this._el.container.className += ' tl-full-color-background';
        this.has.background.color_value = this.data.background.color;
      }
      if (this.data.background.text_background) {
        this._el.container.className += ' tl-text-background';
      }
    }

    if (this.data.media && this.data.media.url && this.data.media.url != "") {
      this.has.media = true;
    }
    if (this.data.text && this.data.text.text) {
      this.has.text = true;
    }
    if (this.data.text && this.data.text.headline) {
      this.has.headline = true;
    }

    if (this.has.media) {
      this.data.media.mediatype = TL.MediaType(this.data.media);
      this.options.media_name = this.data.media.mediatype.name;
      this.options.media_type = this.data.media.mediatype.type;
      this.options.autolink = this.data.autolink;

      this._media = new this.data.media.mediatype.cls(this.data.media, this.options);
    }

    if (this.has.text || this.has.headline) {
      this._text = new TL.Media.Text(this.data.text, { title: this.has.title, language: this.options.language, autolink: this.data.autolink });
      this._text.addDateText(this.getFormattedDate());
    }

    if (!this.has.text && !this.has.headline && this.has.media) {
      TL.DomUtil.addClass(this._el.container, 'tl-slide-media-only');
      this._media.addTo(this._el.content);
    } else if (this.has.headline && this.has.media && !this.has.text) {
      TL.DomUtil.addClass(this._el.container, 'tl-slide-media-only');
      this._text.addTo(this._el.content);
      this._media.addTo(this._el.content);
    } else if (this.has.text && this.has.media) {
      this._media.addTo(this._el.content);
      this._text.addTo(this._el.content);
    } else if (this.has.text || this.has.headline) {
      TL.DomUtil.addClass(this._el.container, 'tl-slide-text-only');
      this._text.addTo(this._el.content);
    }

    this.onLoaded();
  },

  _initEvents: function _initEvents() {},

  _updateDisplay: function _updateDisplay(width, height, layout) {
    var content_width,
        content_padding_left = this.options.slide_padding_lr,
        content_padding_right = this.options.slide_padding_lr;

    if (width) {
      this.options.width = width;
    } else {
      this.options.width = this._el.container.offsetWidth;
    }

    content_width = this.options.width - this.options.slide_padding_lr * 2;

    if (TL.Browser.mobile && this.options.width <= this.options.skinny_size) {
      content_padding_left = 0;
      content_padding_right = 0;
      content_width = this.options.width;
    } else if (layout == "landscape") {} else if (this.options.width <= this.options.skinny_size) {
      content_padding_left = 50;
      content_padding_right = 50;
      content_width = this.options.width - content_padding_left - content_padding_right;
    } else {}

    this._el.content.style.paddingLeft = content_padding_left + "px";
    this._el.content.style.paddingRight = content_padding_right + "px";
    this._el.content.style.width = content_width + "px";

    if (height) {
      this.options.height = height;
    } else {
      this.options.height = this._el.container.offsetHeight;
    }

    if (this._media) {

      if (!this.has.text && this.has.headline) {
        this._media.updateDisplay(content_width, this.options.height - this._text.headlineHeight(), layout);
      } else if (!this.has.text && !this.has.headline) {
        this._media.updateDisplay(content_width, this.options.height, layout);
      } else if (this.options.width <= this.options.skinny_size) {
        this._media.updateDisplay(content_width, this.options.height, layout);
      } else {
        this._media.updateDisplay(content_width / 2, this.options.height, layout);
      }
    }

    this._updateBackgroundDisplay();
  },

  _updateBackgroundDisplay: function _updateBackgroundDisplay() {
    if (this._background_media && this._background_media._state.loaded) {
      this._el.background.style.backgroundImage = "url('" + this._background_media.getImageURL(this.options.width, this.options.height) + "')";
    }
  }

});

TL.SlideNav = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins],

  _el: {},

  initialize: function initialize(data, options, add_to_container) {
    this._el = {
      container: {},
      content_container: {},
      icon: {},
      title: {},
      description: {}
    };

    this.mediatype = {};

    this.data = {
      title: "Navigation",
      description: "Description",
      date: "Date"
    };

    this.options = {
      direction: "previous"
    };

    this.animator = null;

    TL.Util.mergeData(this.options, options);
    TL.Util.mergeData(this.data, data);

    this._el.container = TL.Dom.create("div", "tl-slidenav-" + this.options.direction);

    if (TL.Browser.mobile) {
      this._el.container.setAttribute("ontouchstart", " ");
    }

    this._initLayout();
    this._initEvents();

    if (add_to_container) {
      add_to_container.appendChild(this._el.container);
    };
  },

  update: function update(slide) {
    var d = {
      title: "",
      description: "",
      date: slide.getFormattedDate()
    };

    if (slide.data.text) {
      if (slide.data.text.headline) {
        d.title = slide.data.text.headline;
      }
    }

    this._update(d);
  },

  setColor: function setColor(inverted) {
    if (inverted) {
      this._el.content_container.className = 'tl-slidenav-content-container tl-slidenav-inverted';
    } else {
      this._el.content_container.className = 'tl-slidenav-content-container';
    }
  },

  _onMouseClick: function _onMouseClick() {
    this.fire("clicked", this.options);
  },

  _update: function _update(d) {
    this.data = TL.Util.mergeData(this.data, d);

    this._el.title.innerHTML = TL.Util.unlinkify(this.data.title);

    this._el.description.innerHTML = TL.Util.unlinkify(this.data.date);
  },

  _initLayout: function _initLayout() {
    this._el.content_container = TL.Dom.create("div", "tl-slidenav-content-container", this._el.container);
    this._el.icon = TL.Dom.create("div", "tl-slidenav-icon", this._el.content_container);
    this._el.title = TL.Dom.create("div", "tl-slidenav-title", this._el.content_container);
    this._el.description = TL.Dom.create("div", "tl-slidenav-description", this._el.content_container);

    this._el.icon.innerHTML = "&nbsp;";

    this._update();
  },

  _initEvents: function _initEvents() {
    TL.DomEvent.addListener(this._el.container, 'click', this._onMouseClick, this);
  }

});

TL.StorySlider = TL.Class.extend({

  includes: [TL.Events, TL.I18NMixins],

  initialize: function initialize(elem, data, options, init) {
    this._el = {
      container: {},
      background: {},
      slider_container_mask: {},
      slider_container: {},
      slider_item_container: {}
    };

    this._nav = {};
    this._nav.previous = {};
    this._nav.next = {};

    this.slide_spacing = 0;

    this._slides = [];

    this._swipable;

    this.preloadTimer;

    this._message;

    this.current_id = '';

    this.data = {};

    this.options = {
      id: "",
      layout: "portrait",
      width: 600,
      height: 600,
      default_bg_color: { r: 255, g: 255, b: 255 },
      slide_padding_lr: 40,
      start_at_slide: 1,
      slide_default_fade: "0%",
      duration: 1000,
      ease: TL.Ease.easeInOutQuint,

      dragging: true,
      trackResize: true
    };

    if ((typeof elem === 'undefined' ? 'undefined' : (0, _typeof3.default)(elem)) === 'object') {
      this._el.container = elem;
      this.options.id = TL.Util.unique_ID(6, "tl");
    } else {
      this.options.id = elem;
      this._el.container = TL.Dom.get(elem);
    }

    if (!this._el.container.id) {
      this._el.container.id = this.options.id;
    }

    this.animator = null;

    TL.Util.mergeData(this.options, options);
    TL.Util.mergeData(this.data, data);

    if (init) {
      this.init();
    }
  },

  init: function init() {
    this._initLayout();
    this._initEvents();
    this._initData();
    this._updateDisplay();

    this.goTo(this.options.start_at_slide);

    this._onLoaded();
  },

  _addSlide: function _addSlide(slide) {
    slide.addTo(this._el.slider_item_container);
    slide.on('added', this._onSlideAdded, this);
    slide.on('background_change', this._onBackgroundChange, this);
  },

  _createSlide: function _createSlide(d, title_slide, n) {
    var slide = new TL.Slide(d, this.options, title_slide);
    this._addSlide(slide);
    if (n < 0) {
      this._slides.push(slide);
    } else {
      this._slides.splice(n, 0, slide);
    }
  },

  _createSlides: function _createSlides(array) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].unique_id == "") {
        array[i].unique_id = TL.Util.unique_ID(6, "tl-slide");
      }
      this._createSlide(array[i], false, -1);
    }
  },

  _removeSlide: function _removeSlide(slide) {
    slide.removeFrom(this._el.slider_item_container);
    slide.off('added', this._onSlideRemoved, this);
    slide.off('background_change', this._onBackgroundChange);
  },

  _destroySlide: function _destroySlide(n) {
    this._removeSlide(this._slides[n]);
    this._slides.splice(n, 1);
  },

  _findSlideIndex: function _findSlideIndex(n) {
    var _n = n;
    if (typeof n == 'string' || n instanceof String) {
      _n = TL.Util.findArrayNumberByUniqueID(n, this._slides, "unique_id");
    }
    return _n;
  },

  updateDisplay: function updateDisplay(w, h, a, l) {
    this._updateDisplay(w, h, a, l);
  },

  createSlide: function createSlide(d, n) {
    this._createSlide(d, false, n);
  },

  createSlides: function createSlides(array) {
    this._createSlides(array);
  },

  destroySlide: function destroySlide(n) {
    this._destroySlide(n);
  },

  destroySlideId: function destroySlideId(id) {
    this.destroySlide(this._findSlideIndex(id));
  },

  goTo: function goTo(n, fast, displayupdate) {
    n = parseInt(n);
    if (isNaN(n)) n = 0;

    var self = this;

    this.changeBackground({ color_value: "", image: false });

    if (this.preloadTimer) {
      clearTimeout(this.preloadTimer);
    }

    for (var i = 0; i < this._slides.length; i++) {
      this._slides[i].setActive(false);
    }

    if (n < this._slides.length && n >= 0) {
      this.current_id = this._slides[n].data.unique_id;

      if (this.animator) {
        this.animator.stop();
      }
      if (this._swipable) {
        this._swipable.stopMomentum();
      }

      if (fast) {
        this._el.slider_container.style.left = -(this.slide_spacing * n) + "px";
        this._onSlideChange(displayupdate);
      } else {
        this.animator = TL.Animate(this._el.slider_container, {
          left: -(this.slide_spacing * n) + "px",
          duration: this.options.duration,
          easing: this.options.ease,
          complete: this._onSlideChange(displayupdate)
        });
      }

      this._slides[n].setActive(true);

      if (this._slides[n + 1]) {
        this.showNav(this._nav.next, true);
        this._nav.next.update(this._slides[n + 1]);
      } else {
        this.showNav(this._nav.next, false);
      }
      if (this._slides[n - 1]) {
        this.showNav(this._nav.previous, true);
        this._nav.previous.update(this._slides[n - 1]);
      } else {
        this.showNav(this._nav.previous, false);
      }

      this.preloadTimer = setTimeout(function () {
        self.preloadSlides(n);
      }, this.options.duration);
    }
  },

  goToId: function goToId(id, fast, displayupdate) {
    this.goTo(this._findSlideIndex(id), fast, displayupdate);
  },

  preloadSlides: function preloadSlides(n) {
    if (this._slides[n + 1]) {
      this._slides[n + 1].loadMedia();
      this._slides[n + 1].scrollToTop();
    }
    if (this._slides[n + 2]) {
      this._slides[n + 2].loadMedia();
      this._slides[n + 2].scrollToTop();
    }
    if (this._slides[n - 1]) {
      this._slides[n - 1].loadMedia();
      this._slides[n - 1].scrollToTop();
    }
    if (this._slides[n - 2]) {
      this._slides[n - 2].loadMedia();
      this._slides[n - 2].scrollToTop();
    }
  },

  next: function next() {
    var n = this._findSlideIndex(this.current_id);
    if (n + 1 < this._slides.length) {
      this.goTo(n + 1);
    } else {
      this.goTo(n);
    }
  },

  previous: function previous() {
    var n = this._findSlideIndex(this.current_id);
    if (n - 1 >= 0) {
      this.goTo(n - 1);
    } else {
      this.goTo(n);
    }
  },

  showNav: function showNav(nav_obj, show) {

    if (this.options.width <= 500 && TL.Browser.mobile) {} else {
      if (show) {
        nav_obj.show();
      } else {
        nav_obj.hide();
      }
    }
  },

  changeBackground: function changeBackground(bg) {
    var bg_color = { r: 256, g: 256, b: 256 },
        bg_color_rgb;

    if (bg.color_value && bg.color_value != "") {
      bg_color = TL.Util.hexToRgb(bg.color_value);
      if (!bg_color) {
        TL.trace("Invalid color value " + bg.color_value);
        bg_color = this.options.default_bg_color;
      }
    } else {
      bg_color = this.options.default_bg_color;
      bg.color_value = "rgb(" + bg_color.r + " , " + bg_color.g + ", " + bg_color.b + ")";
    }

    bg_color_rgb = bg_color.r + "," + bg_color.g + "," + bg_color.b;
    this._el.background.style.backgroundImage = "none";

    if (bg.color_value) {
      this._el.background.style.backgroundColor = bg.color_value;
    } else {
      this._el.background.style.backgroundColor = "transparent";
    }

    if (bg_color.r < 255 || bg_color.g < 255 || bg_color.b < 255 || bg.image) {
      this._nav.next.setColor(true);
      this._nav.previous.setColor(true);
    } else {
      this._nav.next.setColor(false);
      this._nav.previous.setColor(false);
    }
  },

  _updateDisplay: function _updateDisplay(width, height, animate, layout) {
    var nav_pos, _layout;

    if (typeof layout === 'undefined') {
      _layout = this.options.layout;
    } else {
      _layout = layout;
    }

    this.options.layout = _layout;

    this.slide_spacing = this.options.width * 2;

    if (width) {
      this.options.width = width;
    } else {
      this.options.width = this._el.container.offsetWidth;
    }

    if (height) {
      this.options.height = height;
    } else {
      this.options.height = this._el.container.offsetHeight;
    }

    nav_pos = this.options.height / 2;
    this._nav.next.setPosition({ top: nav_pos });
    this._nav.previous.setPosition({ top: nav_pos });

    for (var i = 0; i < this._slides.length; i++) {
      this._slides[i].updateDisplay(this.options.width, this.options.height, _layout);
      this._slides[i].setPosition({ left: this.slide_spacing * i, top: 0 });
    };

    this.goToId(this.current_id, true, true);
  },

  _updateDrawSlides: function _updateDrawSlides() {
    var _layout = this.options.layout;

    for (var i = 0; i < this._slides.length; i++) {
      this._slides[i].updateDisplay(this.options.width, this.options.height, _layout);
      this._slides[i].setPosition({ left: this.slide_spacing * i, top: 0 });
    };

    this.goToId(this.current_id, true, false);
  },

  _initLayout: function _initLayout() {

    TL.DomUtil.addClass(this._el.container, 'tl-storyslider');

    this._el.slider_container_mask = TL.Dom.create('div', 'tl-slider-container-mask', this._el.container);
    this._el.background = TL.Dom.create('div', 'tl-slider-background tl-animate', this._el.container);
    this._el.slider_container = TL.Dom.create('div', 'tl-slider-container tlanimate', this._el.slider_container_mask);
    this._el.slider_item_container = TL.Dom.create('div', 'tl-slider-item-container', this._el.slider_container);

    this.options.width = this._el.container.offsetWidth;
    this.options.height = this._el.container.offsetHeight;

    this._nav.previous = new TL.SlideNav({ title: "Previous", description: "description" }, { direction: "previous" });
    this._nav.next = new TL.SlideNav({ title: "Next", description: "description" }, { direction: "next" });

    this._nav.next.addTo(this._el.container);
    this._nav.previous.addTo(this._el.container);

    this._el.slider_container.style.left = "0px";

    if (TL.Browser.touch) {
      this._swipable = new TL.Swipable(this._el.slider_container_mask, this._el.slider_container, {
        enable: { x: true, y: false },
        snap: true
      });
      this._swipable.enable();

      this._message = new TL.Message({}, {
        message_class: "tl-message-full",
        message_icon_class: "tl-icon-swipe-left"
      });
      this._message.updateMessage(this._("swipe_to_navigate"));
      this._message.addTo(this._el.container);
    }
  },

  _initEvents: function _initEvents() {
    this._nav.next.on('clicked', this._onNavigation, this);
    this._nav.previous.on('clicked', this._onNavigation, this);

    if (this._message) {
      this._message.on('clicked', this._onMessageClick, this);
    }

    if (this._swipable) {
      this._swipable.on('swipe_left', this._onNavigation, this);
      this._swipable.on('swipe_right', this._onNavigation, this);
      this._swipable.on('swipe_nodirection', this._onSwipeNoDirection, this);
    }
  },

  _initData: function _initData() {
    if (this.data.title) {
      this._createSlide(this.data.title, true, -1);
    }
    this._createSlides(this.data.events);
  },

  _onBackgroundChange: function _onBackgroundChange(e) {
    var n = this._findSlideIndex(this.current_id);
    var slide_background = this._slides[n].getBackground();
    this.changeBackground(e);
    this.fire("colorchange", slide_background);
  },

  _onMessageClick: function _onMessageClick(e) {
    this._message.hide();
  },

  _onSwipeNoDirection: function _onSwipeNoDirection(e) {
    this.goToId(this.current_id);
  },

  _onNavigation: function _onNavigation(e) {

    if (e.direction == "next" || e.direction == "left") {
      this.next();
    } else if (e.direction == "previous" || e.direction == "right") {
      this.previous();
    }
    this.fire("nav_" + e.direction, this.data);
  },

  _onSlideAdded: function _onSlideAdded(e) {
    TL.trace("slideadded");
    this.fire("slideAdded", this.data);
  },

  _onSlideRemoved: function _onSlideRemoved(e) {
    this.fire("slideRemoved", this.data);
  },

  _onSlideChange: function _onSlideChange(displayupdate) {
    if (!displayupdate) {
      this.fire("change", { unique_id: this.current_id });
    }
  },

  _onMouseClick: function _onMouseClick(e) {},

  _fireMouseEvent: function _fireMouseEvent(e) {
    if (!this._loaded) {
      return;
    }

    var type = e.type;
    type = type === 'mouseenter' ? 'mouseover' : type === 'mouseleave' ? 'mouseout' : type;

    if (!this.hasEventListeners(type)) {
      return;
    }

    if (type === 'contextmenu') {
      TL.DomEvent.preventDefault(e);
    }

    this.fire(type, {
      latlng: "something",
      layerPoint: "something else" });
  },

  _onLoaded: function _onLoaded() {
    this.fire("loaded", this.data);
  }

});

TL.TimeNav = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins],

  _el: {},

  initialize: function initialize(elem, timeline_config, options, init) {
    this._el = {
      parent: {},
      container: {},
      slider: {},
      slider_background: {},
      line: {},
      marker_container_mask: {},
      marker_container: {},
      marker_item_container: {},
      timeaxis: {},
      timeaxis_background: {},
      attribution: {}
    };

    this.collapsed = false;

    if ((typeof elem === 'undefined' ? 'undefined' : (0, _typeof3.default)(elem)) === 'object') {
      this._el.container = elem;
    } else {
      this._el.container = TL.Dom.get(elem);
    }

    this.config = timeline_config;

    this.options = {
      width: 600,
      height: 600,
      duration: 1000,
      ease: TL.Ease.easeInOutQuint,
      has_groups: false,
      optimal_tick_width: 50,
      scale_factor: 2,
      marker_padding: 5,
      timenav_height_min: 150,
      marker_height_min: 30,
      marker_width_min: 100,
      zoom_sequence: [0.5, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89] };

    this.animator = null;

    this.ready = false;

    this._markers = [];

    this._eras = [];
    this.has_eras = false;

    this._groups = [];

    this._calculated_row_height = 100;

    this.current_id = "";

    this.timescale = {};

    this.timeaxis = {};
    this.axishelper = {};

    this.max_rows = 6;

    this.animate_css = false;

    this._swipable;

    TL.Util.mergeData(this.options, options);

    if (init) {
      this.init();
    }
  },

  init: function init() {
    this._initLayout();
    this._initEvents();
    this._initData();
    this._updateDisplay();

    this._onLoaded();
  },

  positionMarkers: function positionMarkers() {
    this._positionMarkers();
  },

  updateDisplay: function updateDisplay(w, h, a, l) {
    this._updateDisplay(w, h, a, l);
  },

  _getTimeScale: function _getTimeScale() {
    var marker_height_min = 0;
    try {
      marker_height_min = parseInt(this.options.marker_height_min);
    } catch (e) {
      TL.trace("Invalid value for marker_height_min option.");
      marker_height_min = 30;
    }
    if (marker_height_min == 0) {
      TL.trace("marker_height_min option must not be zero.");
      marker_height_min = 30;
    }
    this.max_rows = Math.round((this.options.height - this._el.timeaxis_background.offsetHeight - this.options.marker_padding) / marker_height_min);
    if (this.max_rows < 1) {
      this.max_rows = 1;
    }
    return new TL.TimeScale(this.config, {
      display_width: this._el.container.offsetWidth,
      screen_multiplier: this.options.scale_factor,
      max_rows: this.max_rows

    });
  },

  _updateTimeScale: function _updateTimeScale(new_scale) {
    this.options.scale_factor = new_scale;
    this._updateDrawTimeline();
  },

  zoomIn: function zoomIn() {
    var new_scale = TL.Util.findNextGreater(this.options.zoom_sequence, this.options.scale_factor);
    this.setZoomFactor(new_scale);
  },

  zoomOut: function zoomOut() {
    var new_scale = TL.Util.findNextLesser(this.options.zoom_sequence, this.options.scale_factor);
    this.setZoomFactor(new_scale);
  },

  setZoom: function setZoom(level) {
    var zoom_factor = this.options.zoom_sequence[level];
    if (typeof zoom_factor == 'number') {
      this.setZoomFactor(zoom_factor);
    } else {
      console.warn("Invalid zoom level. Please use an index number between 0 and " + (this.options.zoom_sequence.length - 1));
    }
  },

  setZoomFactor: function setZoomFactor(factor) {
    if (factor <= this.options.zoom_sequence[0]) {
      this.fire("zoomtoggle", { zoom: "out", show: false });
    } else {
      this.fire("zoomtoggle", { zoom: "out", show: true });
    }

    if (factor >= this.options.zoom_sequence[this.options.zoom_sequence.length - 1]) {
      this.fire("zoomtoggle", { zoom: "in", show: false });
    } else {
      this.fire("zoomtoggle", { zoom: "in", show: true });
    }

    if (factor == 0) {
      console.warn("Zoom factor must be greater than zero. Using 0.1");
      factor = 0.1;
    }
    this.options.scale_factor = factor;

    this.goToId(this.current_id, !this._updateDrawTimeline(true), true);
  },

  _createGroups: function _createGroups() {
    this._groups = [];
    var group_labels = this.timescale.getGroupLabels();

    if (group_labels) {
      this.options.has_groups = true;
      for (var i = 0; i < group_labels.length; i++) {
        this._createGroup(group_labels[i]);
      }
    }
  },

  _createGroup: function _createGroup(group_label) {
    var group = new TL.TimeGroup(group_label);
    this._addGroup(group);
    this._groups.push(group);
  },

  _addGroup: function _addGroup(group) {
    group.addTo(this._el.container);
  },

  _positionGroups: function _positionGroups() {
    if (this.options.has_groups) {
      var available_height = this.options.height - this._el.timeaxis_background.offsetHeight,
          group_height = Math.floor(available_height / this.timescale.getNumberOfRows() - this.options.marker_padding),
          group_labels = this.timescale.getGroupLabels();

      for (var i = 0, group_rows = 0; i < this._groups.length; i++) {
        var group_y = Math.floor(group_rows * (group_height + this.options.marker_padding));
        var group_hide = false;
        if (group_y > available_height - this.options.marker_padding) {
          group_hide = true;
        }

        this._groups[i].setRowPosition(group_y, this._calculated_row_height + this.options.marker_padding / 2);
        this._groups[i].setAlternateRowColor(TL.Util.isEven(i), group_hide);

        group_rows += this._groups[i].data.rows;
      }
    }
  },

  _addMarker: function _addMarker(marker) {
    marker.addTo(this._el.marker_item_container);
    marker.on('markerclick', this._onMarkerClick, this);
    marker.on('added', this._onMarkerAdded, this);
  },

  _createMarker: function _createMarker(data, n) {
    var marker = new TL.TimeMarker(data, this.options);
    this._addMarker(marker);
    if (n < 0) {
      this._markers.push(marker);
    } else {
      this._markers.splice(n, 0, marker);
    }
  },

  _createMarkers: function _createMarkers(array) {
    for (var i = 0; i < array.length; i++) {
      this._createMarker(array[i], -1);
    }
  },

  _removeMarker: function _removeMarker(marker) {
    marker.removeFrom(this._el.marker_item_container);
  },

  _destroyMarker: function _destroyMarker(n) {
    this._removeMarker(this._markers[n]);
    this._markers.splice(n, 1);
  },

  _positionMarkers: function _positionMarkers(fast) {
    for (var i = 0; i < this._markers.length; i++) {
      var pos = this.timescale.getPositionInfo(i);
      if (fast) {
        this._markers[i].setClass("tl-timemarker tl-timemarker-fast");
      } else {
        this._markers[i].setClass("tl-timemarker");
      }
      this._markers[i].setPosition({ left: pos.start });
      this._markers[i].setWidth(pos.width);
    };
  },

  _calculateMarkerHeight: function _calculateMarkerHeight(h) {
    return h / this.timescale.getNumberOfRows() - this.options.marker_padding;
  },

  _calculateRowHeight: function _calculateRowHeight(h) {
    return h / this.timescale.getNumberOfRows();
  },

  _calculateAvailableHeight: function _calculateAvailableHeight() {
    return this.options.height - this._el.timeaxis_background.offsetHeight - this.options.marker_padding;
  },

  _calculateMinimumTimeNavHeight: function _calculateMinimumTimeNavHeight() {
    return this.timescale.getNumberOfRows() * this.options.marker_height_min + this._el.timeaxis_background.offsetHeight + this.options.marker_padding;
  },

  getMinimumHeight: function getMinimumHeight() {
    return this._calculateMinimumTimeNavHeight();
  },

  _assignRowsToMarkers: function _assignRowsToMarkers() {
    var available_height = this._calculateAvailableHeight(),
        marker_height = this._calculateMarkerHeight(available_height);

    this._positionGroups();

    this._calculated_row_height = this._calculateRowHeight(available_height);

    for (var i = 0; i < this._markers.length; i++) {
      this._markers[i].setHeight(marker_height);

      var row = this.timescale.getPositionInfo(i).row;

      var marker_y = Math.floor(row * (marker_height + this.options.marker_padding)) + this.options.marker_padding;

      var remainder_height = available_height - marker_y + this.options.marker_padding;
      this._markers[i].setRowPosition(marker_y, remainder_height);
    };
  },

  _resetMarkersActive: function _resetMarkersActive() {
    for (var i = 0; i < this._markers.length; i++) {
      this._markers[i].setActive(false);
    };
  },

  _findMarkerIndex: function _findMarkerIndex(n) {
    var _n = -1;
    if (typeof n == 'string' || n instanceof String) {
      _n = TL.Util.findArrayNumberByUniqueID(n, this._markers, "unique_id", _n);
    }
    return _n;
  },

  _createEras: function _createEras(array) {
    for (var i = 0; i < array.length; i++) {
      this._createEra(array[i], -1);
    }
  },

  _createEra: function _createEra(data, n) {
    var era = new TL.TimeEra(data, this.options);
    this._addEra(era);
    if (n < 0) {
      this._eras.push(era);
    } else {
      this._eras.splice(n, 0, era);
    }
  },

  _addEra: function _addEra(era) {
    era.addTo(this._el.marker_item_container);
    era.on('added', this._onEraAdded, this);
  },

  _removeEra: function _removeEra(era) {
    era.removeFrom(this._el.marker_item_container);
  },

  _destroyEra: function _destroyEra(n) {
    this._removeEra(this._eras[n]);
    this._eras.splice(n, 1);
  },

  _positionEras: function _positionEras(fast) {

    var era_color = 0;

    for (var i = 0; i < this._eras.length; i++) {
      var pos = {
        start: 0,
        end: 0,
        width: 0
      };

      pos.start = this.timescale.getPosition(this._eras[i].data.start_date.getTime());
      pos.end = this.timescale.getPosition(this._eras[i].data.end_date.getTime());
      pos.width = pos.end - pos.start;

      if (fast) {
        this._eras[i].setClass("tl-timeera tl-timeera-fast");
      } else {
        this._eras[i].setClass("tl-timeera");
      }
      this._eras[i].setPosition({ left: pos.start });
      this._eras[i].setWidth(pos.width);

      era_color++;
      if (era_color > 5) {
        era_color = 0;
      }
      this._eras[i].setColor(era_color);
    };
  },

  createMarker: function createMarker(d, n) {
    this._createMarker(d, n);
  },

  createMarkers: function createMarkers(array) {
    this._createMarkers(array);
  },

  destroyMarker: function destroyMarker(n) {
    this._destroyMarker(n);
  },

  destroyMarkerId: function destroyMarkerId(id) {
    this.destroyMarker(this._findMarkerIndex(id));
  },

  goTo: function goTo(n, fast, css_animation) {
    var self = this,
        _ease = this.options.ease,
        _duration = this.options.duration,
        _n = n < 0 ? 0 : n;

    this._resetMarkersActive();
    if (n >= 0 && n < this._markers.length) {
      this._markers[n].setActive(true);
    }

    if (this.animator) {
      this.animator.stop();
    }

    if (fast) {
      this._el.slider.className = "tl-timenav-slider";
      this._el.slider.style.left = -this._markers[_n].getLeft() + this.options.width / 2 + "px";
    } else {
      if (css_animation) {
        this._el.slider.className = "tl-timenav-slider tl-timenav-slider-animate";
        this.animate_css = true;
        this._el.slider.style.left = -this._markers[_n].getLeft() + this.options.width / 2 + "px";
      } else {
        this._el.slider.className = "tl-timenav-slider";
        this.animator = TL.Animate(this._el.slider, {
          left: -this._markers[_n].getLeft() + this.options.width / 2 + "px",
          duration: _duration,
          easing: _ease
        });
      }
    }

    if (n >= 0 && n < this._markers.length) {
      this.current_id = this._markers[n].data.unique_id;
    } else {
      this.current_id = '';
    }
  },

  goToId: function goToId(id, fast, css_animation) {
    this.goTo(this._findMarkerIndex(id), fast, css_animation);
  },

  _onLoaded: function _onLoaded() {
    this.ready = true;
    this.fire("loaded", this.config);
  },

  _onMarkerAdded: function _onMarkerAdded(e) {
    this.fire("dateAdded", this.config);
  },

  _onEraAdded: function _onEraAdded(e) {
    this.fire("eraAdded", this.config);
  },

  _onMarkerRemoved: function _onMarkerRemoved(e) {
    this.fire("dateRemoved", this.config);
  },

  _onMarkerClick: function _onMarkerClick(e) {
    this.goToId(e.unique_id);
    this.fire("change", { unique_id: e.unique_id });
  },

  _onMouseScroll: function _onMouseScroll(e) {

    var delta = 0,
        scroll_to = 0,
        constraint = {
      right: -(this.timescale.getPixelWidth() - this.options.width / 2),
      left: this.options.width / 2
    };
    if (!e) {
      e = window.event;
    }
    if (e.originalEvent) {
      e = e.originalEvent;
    }

    if (typeof e.wheelDeltaX != 'undefined') {
      delta = e.wheelDeltaY / 6;
      if (Math.abs(e.wheelDeltaX) > Math.abs(e.wheelDeltaY)) {
        delta = e.wheelDeltaX / 6;
      } else {
        delta = 0;
      }
    }
    if (delta) {
      if (e.preventDefault) {
        e.preventDefault();
      }
      e.returnValue = false;
    }

    scroll_to = parseInt(this._el.slider.style.left.replace("px", "")) + delta;

    if (scroll_to > constraint.left) {
      scroll_to = constraint.left;
    } else if (scroll_to < constraint.right) {
      scroll_to = constraint.right;
    }

    if (this.animate_css) {
      this._el.slider.className = "tl-timenav-slider";
      this.animate_css = false;
    }

    this._el.slider.style.left = scroll_to + "px";
  },

  _onDragMove: function _onDragMove(e) {
    if (this.animate_css) {
      this._el.slider.className = "tl-timenav-slider";
      this.animate_css = false;
    }
  },

  _updateDisplay: function _updateDisplay(width, height, animate) {

    if (width) {
      this.options.width = width;
    }
    if (height && height != this.options.height) {
      this.options.height = height;
      this.timescale = this._getTimeScale();
    }

    this._assignRowsToMarkers();

    this._el.slider_background.style.width = this.timescale.getPixelWidth() + this.options.width + "px";
    this._el.slider_background.style.left = -(this.options.width / 2) + "px";
    this._el.slider.style.width = this.timescale.getPixelWidth() + this.options.width + "px";

    this._swipable.updateConstraint({ top: false, bottom: false, left: this.options.width / 2, right: -(this.timescale.getPixelWidth() - this.options.width / 2) });

    this.goToId(this.current_id, true);
  },

  _drawTimeline: function _drawTimeline(fast) {
    this.timescale = this._getTimeScale();
    this.timeaxis.drawTicks(this.timescale, this.options.optimal_tick_width);
    this._positionMarkers(fast);
    this._assignRowsToMarkers();
    this._createGroups();
    this._positionGroups();

    if (this.has_eras) {

      this._positionEras(fast);
    }
  },

  _updateDrawTimeline: function _updateDrawTimeline(check_update) {
    var do_update = false;

    if (check_update) {
      var temp_timescale = new TL.TimeScale(this.config, {
        display_width: this._el.container.offsetWidth,
        screen_multiplier: this.options.scale_factor,
        max_rows: this.max_rows

      });

      if (this.timescale.getMajorScale() == temp_timescale.getMajorScale() && this.timescale.getMinorScale() == temp_timescale.getMinorScale()) {
        do_update = true;
      }
    } else {
      do_update = true;
    }

    if (do_update) {
      this.timescale = this._getTimeScale();
      this.timeaxis.positionTicks(this.timescale, this.options.optimal_tick_width);
      this._positionMarkers();
      this._assignRowsToMarkers();
      this._positionGroups();
      if (this.has_eras) {
        this._positionEras();
      }
      this._updateDisplay();
    } else {
      this._drawTimeline(true);
    }

    return do_update;
  },

  _initLayout: function _initLayout() {
    this._el.attribution = TL.Dom.create('div', 'tl-attribution', this._el.container);
    this._el.line = TL.Dom.create('div', 'tl-timenav-line', this._el.container);
    this._el.slider = TL.Dom.create('div', 'tl-timenav-slider', this._el.container);
    this._el.slider_background = TL.Dom.create('div', 'tl-timenav-slider-background', this._el.slider);
    this._el.marker_container_mask = TL.Dom.create('div', 'tl-timenav-container-mask', this._el.slider);
    this._el.marker_container = TL.Dom.create('div', 'tl-timenav-container', this._el.marker_container_mask);
    this._el.marker_item_container = TL.Dom.create('div', 'tl-timenav-item-container', this._el.marker_container);
    this._el.timeaxis = TL.Dom.create('div', 'tl-timeaxis', this._el.slider);
    this._el.timeaxis_background = TL.Dom.create('div', 'tl-timeaxis-background', this._el.container);

    this._el.attribution.innerHTML = "<a href='http://timeline.knightlab.com' target='_blank'><span class='tl-knightlab-logo'></span>Timeline JS</a>";

    this.timeaxis = new TL.TimeAxis(this._el.timeaxis, this.options);

    this._swipable = new TL.Swipable(this._el.slider_background, this._el.slider, {
      enable: { x: true, y: false },
      constraint: { top: false, bottom: false, left: this.options.width / 2, right: false },
      snap: false
    });
    this._swipable.enable();
  },

  _initEvents: function _initEvents() {
    this._swipable.on('dragmove', this._onDragMove, this);

    TL.DomEvent.addListener(this._el.container, 'mousewheel', this._onMouseScroll, this);
    TL.DomEvent.addListener(this._el.container, 'DOMMouseScroll', this._onMouseScroll, this);
  },

  _initData: function _initData() {
    this._createMarkers(this.config.events);

    if (this.config.eras) {
      this.has_eras = true;
      this._createEras(this.config.eras);
    }

    this._drawTimeline();
  }

});

TL.TimeMarker = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins],

  _el: {},

  initialize: function initialize(data, options) {
    this._el = {
      container: {},
      content_container: {},
      media_container: {},
      timespan: {},
      line_left: {},
      line_right: {},
      content: {},
      text: {},
      media: {}
    };

    this._text = {};

    this._state = {
      loaded: false
    };

    this.data = {
      unique_id: "",
      background: null,
      date: {
        year: 0,
        month: 0,
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        thumbnail: "",
        format: ""
      },
      text: {
        headline: "",
        text: ""
      },
      media: null
    };

    this.options = {
      duration: 1000,
      ease: TL.Ease.easeInSpline,
      width: 600,
      height: 600,
      marker_width_min: 100 };

    this.active = false;

    this.animator = {};

    this.has_end_date = false;

    TL.Util.mergeData(this.options, options);
    TL.Util.mergeData(this.data, data);

    this._initLayout();
    this._initEvents();
  },

  show: function show() {},

  hide: function hide() {},

  setActive: function setActive(is_active) {
    this.active = is_active;

    if (this.active && this.has_end_date) {
      this._el.container.className = 'tl-timemarker tl-timemarker-with-end tl-timemarker-active';
    } else if (this.active) {
      this._el.container.className = 'tl-timemarker tl-timemarker-active';
    } else if (this.has_end_date) {
      this._el.container.className = 'tl-timemarker tl-timemarker-with-end';
    } else {
      this._el.container.className = 'tl-timemarker';
    }
  },

  addTo: function addTo(container) {
    container.appendChild(this._el.container);
  },

  removeFrom: function removeFrom(container) {
    container.removeChild(this._el.container);
  },

  updateDisplay: function updateDisplay(w, h) {
    this._updateDisplay(w, h);
  },

  loadMedia: function loadMedia() {

    if (this._media && !this._state.loaded) {
      this._media.loadMedia();
      this._state.loaded = true;
    }
  },

  stopMedia: function stopMedia() {
    if (this._media && this._state.loaded) {
      this._media.stopMedia();
    }
  },

  getLeft: function getLeft() {
    return this._el.container.style.left.slice(0, -2);
  },

  getTime: function getTime() {
    return this.data.start_date.getTime();
  },

  getEndTime: function getEndTime() {

    if (this.data.end_date) {
      return this.data.end_date.getTime();
    } else {
      return false;
    }
  },

  setHeight: function setHeight(h) {
    var text_line_height = 12,
        text_lines = 1;

    this._el.content_container.style.height = h + "px";
    this._el.timespan_content.style.height = h + "px";

    if (h <= 30) {
      this._el.content.className = "tl-timemarker-content tl-timemarker-content-small";
    } else {
      this._el.content.className = "tl-timemarker-content";
    }

    if (h <= 56) {
      TL.DomUtil.addClass(this._el.content_container, "tl-timemarker-content-container-small");
    } else {
      TL.DomUtil.removeClass(this._el.content_container, "tl-timemarker-content-container-small");
    }

    if (TL.Browser.webkit) {
      text_lines = Math.floor(h / (text_line_height + 2));
      if (text_lines < 1) {
        text_lines = 1;
      }
      this._text.className = "tl-headline";
      this._text.style.webkitLineClamp = text_lines;
    } else {
      text_lines = h / text_line_height;
      if (text_lines > 1) {
        this._text.className = "tl-headline tl-headline-fadeout";
      } else {
        this._text.className = "tl-headline";
      }
      this._text.style.height = text_lines * text_line_height + "px";
    }
  },

  setWidth: function setWidth(w) {
    if (this.data.end_date) {
      this._el.container.style.width = w + "px";

      if (w > this.options.marker_width_min) {
        this._el.content_container.style.width = w + "px";
        this._el.content_container.className = "tl-timemarker-content-container tl-timemarker-content-container-long";
      } else {
        this._el.content_container.style.width = this.options.marker_width_min + "px";
        this._el.content_container.className = "tl-timemarker-content-container";
      }
    }
  },

  setClass: function setClass(n) {
    this._el.container.className = n;
  },

  setRowPosition: function setRowPosition(n, remainder) {
    this.setPosition({ top: n });
    this._el.timespan.style.height = remainder + "px";

    if (remainder < 56) {}
  },

  _onMarkerClick: function _onMarkerClick(e) {
    this.fire("markerclick", { unique_id: this.data.unique_id });
  },

  _initLayout: function _initLayout() {
    this._el.container = TL.Dom.create("div", "tl-timemarker");
    if (this.data.unique_id) {
      this._el.container.id = this.data.unique_id + "-marker";
    }

    if (this.data.end_date) {
      this.has_end_date = true;
      this._el.container.className = 'tl-timemarker tl-timemarker-with-end';
    }

    this._el.timespan = TL.Dom.create("div", "tl-timemarker-timespan", this._el.container);
    this._el.timespan_content = TL.Dom.create("div", "tl-timemarker-timespan-content", this._el.timespan);
    this._el.content_container = TL.Dom.create("div", "tl-timemarker-content-container", this._el.container);

    this._el.content = TL.Dom.create("div", "tl-timemarker-content", this._el.content_container);

    this._el.line_left = TL.Dom.create("div", "tl-timemarker-line-left", this._el.timespan);
    this._el.line_right = TL.Dom.create("div", "tl-timemarker-line-right", this._el.timespan);

    if (this.data.media) {
      this._el.media_container = TL.Dom.create("div", "tl-timemarker-media-container", this._el.content);

      var mtd = { url: this.data.media.thumbnail };
      var thumbnail_media_type = this.data.media.thumbnail ? TL.MediaType(mtd, true) : null;
      if (thumbnail_media_type) {
        var thumbnail_media = new thumbnail_media_type.cls(mtd);
        thumbnail_media.on("loaded", function () {
          this._el.media = TL.Dom.create("img", "tl-timemarker-media", this._el.media_container);
          this._el.media.src = thumbnail_media.getImageURL();
        }.bind(this));
        thumbnail_media.loadMedia();
      } else {
        var media_type = TL.MediaType(this.data.media).type;
        this._el.media = TL.Dom.create("span", "tl-icon-" + media_type, this._el.media_container);
      }
    }

    this._el.text = TL.Dom.create("div", "tl-timemarker-text", this._el.content);
    this._text = TL.Dom.create("h2", "tl-headline", this._el.text);
    if (this.data.text.headline && this.data.text.headline != "") {
      this._text.innerHTML = TL.Util.unlinkify(this.data.text.headline);
    } else if (this.data.text.text && this.data.text.text != "") {
      this._text.innerHTML = TL.Util.unlinkify(this.data.text.text);
    } else if (this.data.media && this.data.media.caption && this.data.media.caption != "") {
      this._text.innerHTML = TL.Util.unlinkify(this.data.media.caption);
    }

    this.onLoaded();
  },

  _initEvents: function _initEvents() {
    TL.DomEvent.addListener(this._el.container, 'click', this._onMarkerClick, this);
  },

  _updateDisplay: function _updateDisplay(width, height, layout) {

    if (width) {
      this.options.width = width;
    }

    if (height) {
      this.options.height = height;
    }
  }

});

TL.TimeEra = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins],

  _el: {},

  initialize: function initialize(data, options) {
    this._el = {
      container: {},
      background: {},
      content_container: {},
      content: {},
      text: {}
    };

    this._text = {};

    this._state = {
      loaded: false
    };

    this.data = {
      unique_id: "",
      date: {
        year: 0,
        month: 0,
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        thumbnail: "",
        format: ""
      },
      text: {
        headline: "",
        text: ""
      }
    };

    this.options = {
      duration: 1000,
      ease: TL.Ease.easeInSpline,
      width: 600,
      height: 600,
      marker_width_min: 100 };

    this.active = false;

    this.animator = {};

    this.has_end_date = false;

    TL.Util.mergeData(this.options, options);
    TL.Util.mergeData(this.data, data);

    this._initLayout();
    this._initEvents();
  },

  show: function show() {},

  hide: function hide() {},

  setActive: function setActive(is_active) {},

  addTo: function addTo(container) {
    container.appendChild(this._el.container);
  },

  removeFrom: function removeFrom(container) {
    container.removeChild(this._el.container);
  },

  updateDisplay: function updateDisplay(w, h) {
    this._updateDisplay(w, h);
  },

  getLeft: function getLeft() {
    return this._el.container.style.left.slice(0, -2);
  },

  getTime: function getTime() {
    return this.data.start_date.getTime();
  },

  getEndTime: function getEndTime() {

    if (this.data.end_date) {
      return this.data.end_date.getTime();
    } else {
      return false;
    }
  },

  setHeight: function setHeight(h) {
    var text_line_height = 12,
        text_lines = 1;

    this._el.content_container.style.height = h + "px";
    this._el.content.className = "tl-timeera-content";

    if (TL.Browser.webkit) {
      text_lines = Math.floor(h / (text_line_height + 2));
      if (text_lines < 1) {
        text_lines = 1;
      }
      this._text.className = "tl-headline";
      this._text.style.webkitLineClamp = text_lines;
    } else {
      text_lines = h / text_line_height;
      if (text_lines > 1) {
        this._text.className = "tl-headline tl-headline-fadeout";
      } else {
        this._text.className = "tl-headline";
      }
      this._text.style.height = text_lines * text_line_height + "px";
    }
  },

  setWidth: function setWidth(w) {
    if (this.data.end_date) {
      this._el.container.style.width = w + "px";

      if (w > this.options.marker_width_min) {
        this._el.content_container.style.width = w + "px";
        this._el.content_container.className = "tl-timeera-content-container tl-timeera-content-container-long";
      } else {
        this._el.content_container.style.width = this.options.marker_width_min + "px";
        this._el.content_container.className = "tl-timeera-content-container";
      }
    }
  },

  setClass: function setClass(n) {
    this._el.container.className = n;
  },

  setRowPosition: function setRowPosition(n, remainder) {
    this.setPosition({ top: n });

    if (remainder < 56) {}
  },

  setColor: function setColor(color_num) {
    this._el.container.className = 'tl-timeera tl-timeera-color' + color_num;
  },

  _initLayout: function _initLayout() {
    this._el.container = TL.Dom.create("div", "tl-timeera");
    if (this.data.unique_id) {
      this._el.container.id = this.data.unique_id + "-era";
    }

    if (this.data.end_date) {
      this.has_end_date = true;
      this._el.container.className = 'tl-timeera tl-timeera-with-end';
    }

    this._el.content_container = TL.Dom.create("div", "tl-timeera-content-container", this._el.container);

    this._el.background = TL.Dom.create("div", "tl-timeera-background", this._el.content_container);

    this._el.content = TL.Dom.create("div", "tl-timeera-content", this._el.content_container);

    this._el.text = TL.Dom.create("div", "tl-timeera-text", this._el.content);
    this._text = TL.Dom.create("h2", "tl-headline", this._el.text);
    if (this.data.text.headline && this.data.text.headline != "") {
      this._text.innerHTML = TL.Util.unlinkify(this.data.text.headline);
    }

    this.onLoaded();
  },

  _initEvents: function _initEvents() {},

  _updateDisplay: function _updateDisplay(width, height, layout) {

    if (width) {
      this.options.width = width;
    }

    if (height) {
      this.options.height = height;
    }
  }

});

TL.TimeGroup = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins],

  _el: {},

  initialize: function initialize(data) {
    this._el = {
      parent: {},
      container: {},
      message: {}
    };

    this.options = {
      width: 600,
      height: 600
    };

    this.data = {
      label: "",
      rows: 1
    };

    this._el.container = TL.Dom.create("div", "tl-timegroup");

    TL.Util.mergeData(this.data, data);

    this.animator = {};

    this._initLayout();
    this._initEvents();
  },

  updateDisplay: function updateDisplay(w, h) {},

  setRowPosition: function setRowPosition(n, h) {
    this.options.height = h * this.data.rows;
    this.setPosition({ top: n });
    this._el.container.style.height = this.options.height + "px";
  },

  setAlternateRowColor: function setAlternateRowColor(alternate, hide) {
    var class_name = "tl-timegroup";
    if (alternate) {
      class_name += " tl-timegroup-alternate";
    }
    if (hide) {
      class_name += " tl-timegroup-hidden";
    }
    this._el.container.className = class_name;
  },

  _onMouseClick: function _onMouseClick() {
    this.fire("clicked", this.options);
  },

  _initLayout: function _initLayout() {
    this._el.message = TL.Dom.create("div", "tl-timegroup-message", this._el.container);
    this._el.message.innerHTML = this.data.label;
  },

  _initEvents: function _initEvents() {
    TL.DomEvent.addListener(this._el.container, 'click', this._onMouseClick, this);
  },

  _updateDisplay: function _updateDisplay(width, height, animate) {}

});

TL.TimeScale = TL.Class.extend({

  initialize: function initialize(timeline_config, options) {

    var slides = timeline_config.events;
    this._scale = timeline_config.scale;

    options = TL.Util.mergeData({
      display_width: 500,
      screen_multiplier: 3,
      max_rows: null
    }, options);

    this._display_width = options.display_width;
    this._screen_multiplier = options.screen_multiplier;
    this._pixel_width = this._screen_multiplier * this._display_width;

    this._group_labels = undefined;
    this._positions = [];
    this._pixels_per_milli = 0;

    this._earliest = timeline_config.getEarliestDate().getTime();
    this._latest = timeline_config.getLatestDate().getTime();
    this._span_in_millis = this._latest - this._earliest;
    if (this._span_in_millis <= 0) {
      this._span_in_millis = this._computeDefaultSpan(timeline_config);
    }
    this._average = this._span_in_millis / slides.length;

    this._pixels_per_milli = this.getPixelWidth() / this._span_in_millis;

    this._axis_helper = TL.AxisHelper.getBestHelper(this);

    this._scaled_padding = 1 / this.getPixelsPerTick() * (this._display_width / 2);
    this._computePositionInfo(slides, options.max_rows);
  },

  _computeDefaultSpan: function _computeDefaultSpan(timeline_config) {
    if (timeline_config.scale == 'human') {
      var formats = {};
      for (var i = 0; i < timeline_config.events.length; i++) {
        var fmt = timeline_config.events[i].start_date.findBestFormat();
        formats[fmt] = formats[fmt] ? formats[fmt] + 1 : 1;
      };

      for (var i = TL.Date.SCALES.length - 1; i >= 0; i--) {
        if (formats.hasOwnProperty(TL.Date.SCALES[i][0])) {
          var scale = TL.Date.SCALES[TL.Date.SCALES.length - 1];
          if (TL.Date.SCALES[i + 1]) {
            scale = TL.Date.SCALES[i + 1];
          }
          return scale[1];
        }
      };
      return 365 * 24 * 60 * 60 * 1000;
    }

    return 200000;
  },
  getGroupLabels: function getGroupLabels() {
    return this._group_labels || [];
  },

  getScale: function getScale() {
    return this._scale;
  },

  getNumberOfRows: function getNumberOfRows() {
    return this._number_of_rows;
  },

  getPixelWidth: function getPixelWidth() {
    return this._pixel_width;
  },

  getPosition: function getPosition(time_in_millis) {
    return (time_in_millis - this._earliest) * this._pixels_per_milli;
  },

  getPositionInfo: function getPositionInfo(idx) {
    return this._positions[idx];
  },

  getPixelsPerTick: function getPixelsPerTick() {
    return this._axis_helper.getPixelsPerTick(this._pixels_per_milli);
  },

  getTicks: function getTicks() {
    return {
      major: this._axis_helper.getMajorTicks(this),
      minor: this._axis_helper.getMinorTicks(this) };
  },

  getDateFromTime: function getDateFromTime(t) {
    if (this._scale == 'human') {
      return new TL.Date(t);
    } else if (this._scale == 'cosmological') {
      return new TL.BigDate(new TL.BigYear(t));
    }
    throw new TL.Error("time_scale_scale_err", this._scale);
  },

  getMajorScale: function getMajorScale() {
    return this._axis_helper.major.name;
  },

  getMinorScale: function getMinorScale() {
    return this._axis_helper.minor.name;
  },

  _assessGroups: function _assessGroups(slides) {
    var groups = [];
    var empty_group = false;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].group) {
        if (groups.indexOf(slides[i].group) < 0) {
          groups.push(slides[i].group);
        } else {
          empty_group = true;
        }
      }
    };
    if (groups.length && empty_group) {
      groups.push('');
    }
    return groups;
  },

  _computeRowInfo: function _computeRowInfo(positions, rows_left) {
    var lasts_in_row = [];
    var n_overlaps = 0;

    for (var i = 0; i < positions.length; i++) {
      var pos_info = positions[i];
      var overlaps = [];

      delete pos_info.row;

      for (var j = 0; j < lasts_in_row.length; j++) {
        overlaps.push(lasts_in_row[j].end - pos_info.start);
        if (overlaps[j] <= 0) {
          pos_info.row = j;
          lasts_in_row[j] = pos_info;
          break;
        }
      }

      if (typeof pos_info.row == 'undefined') {
        if (rows_left === null) {
          pos_info.row = lasts_in_row.length;
          lasts_in_row.push(pos_info);
        } else if (rows_left > 0) {
          pos_info.row = lasts_in_row.length;
          lasts_in_row.push(pos_info);
          rows_left--;
        } else {
          var min_overlap = Math.min.apply(null, overlaps);
          var idx = overlaps.indexOf(min_overlap);
          pos_info.row = idx;
          if (pos_info.end > lasts_in_row[idx].end) {
            lasts_in_row[idx] = pos_info;
          }
          n_overlaps++;
        }
      }
    }

    return { n_rows: lasts_in_row.length, n_overlaps: n_overlaps };
  },

  _computePositionInfo: function _computePositionInfo(slides, max_rows, default_marker_width) {
    default_marker_width = default_marker_width || 100;

    var groups = [];
    var empty_group = false;

    for (var i = 0; i < slides.length; i++) {
      var pos_info = {
        start: this.getPosition(slides[i].start_date.getTime())
      };
      this._positions.push(pos_info);

      if (typeof slides[i].end_date != 'undefined') {
        var end_pos = this.getPosition(slides[i].end_date.getTime());
        pos_info.width = end_pos - pos_info.start;
        if (pos_info.width > default_marker_width) {
          pos_info.end = pos_info.start + pos_info.width;
        } else {
          pos_info.end = pos_info.start + default_marker_width;
        }
      } else {
        pos_info.width = default_marker_width;
        pos_info.end = pos_info.start + default_marker_width;
      }

      if (slides[i].group) {
        if (groups.indexOf(slides[i].group) < 0) {
          groups.push(slides[i].group);
        }
      } else {
        empty_group = true;
      }
    }

    if (!groups.length) {
      var result = this._computeRowInfo(this._positions, max_rows);
      this._number_of_rows = result.n_rows;
    } else {
      if (empty_group) {
        groups.push("");
      }

      var group_info = [];

      for (var i = 0; i < groups.length; i++) {
        group_info[i] = {
          label: groups[i],
          idx: i,
          positions: [],
          n_rows: 1,
          n_overlaps: 0
        };
      }

      for (var i = 0; i < this._positions.length; i++) {
        var pos_info = this._positions[i];

        pos_info.group = groups.indexOf(slides[i].group || "");
        pos_info.row = 0;

        var gi = group_info[pos_info.group];
        for (var j = gi.positions.length - 1; j >= 0; j--) {
          if (gi.positions[j].end > pos_info.start) {
            gi.n_overlaps++;
          }
        }

        gi.positions.push(pos_info);
      }

      var n_rows = groups.length;

      while (true) {
        var rows_left = Math.max(0, max_rows - n_rows);
        if (!rows_left) {
          break;
        }

        group_info.sort(function (a, b) {
          if (a.n_overlaps > b.n_overlaps) {
            return -1;
          } else if (a.n_overlaps < b.n_overlaps) {
            return 1;
          }
          return a.idx - b.idx;
        });
        if (!group_info[0].n_overlaps) {
          break;
        }

        var n_rows = 0;
        for (var i = 0; i < group_info.length; i++) {
          var gi = group_info[i];

          if (gi.n_overlaps && rows_left) {
            var res = this._computeRowInfo(gi.positions, gi.n_rows + 1);
            gi.n_rows = res.n_rows;
            gi.n_overlaps = res.n_overlaps;
            rows_left--;
          }

          n_rows += gi.n_rows;
        }
      }

      this._number_of_rows = n_rows;

      this._group_labels = [];

      group_info.sort(function (a, b) {
        return a.idx - b.idx;
      });

      for (var i = 0, row_offset = 0; i < group_info.length; i++) {
        this._group_labels.push({
          label: group_info[i].label,
          rows: group_info[i].n_rows
        });

        for (var j = 0; j < group_info[i].positions.length; j++) {
          var pos_info = group_info[i].positions[j];
          pos_info.row += row_offset;
        }

        row_offset += group_info[i].n_rows;
      }
    }
  }
});

TL.TimeAxis = TL.Class.extend({

  includes: [TL.Events, TL.DomMixins, TL.I18NMixins],

  _el: {},

  initialize: function initialize(elem, options) {
    this._el = {
      container: {},
      content_container: {},
      major: {},
      minor: {}
    };

    this._text = {};

    this._state = {
      loaded: false
    };

    this.data = {};

    this.options = {
      duration: 1000,
      ease: TL.Ease.easeInSpline,
      width: 600,
      height: 600
    };

    this.active = false;

    this.animator = {};

    this.axis_helper = {};

    this.minor_ticks = [];

    this.major_ticks = [];

    this.dateformat_lookup = {
      millisecond: 'time_milliseconds',
      second: 'time_short',
      minute: 'time_no_seconds_short',
      hour: 'time_no_minutes_short',
      day: 'full_short',
      month: 'month_short',
      year: 'year',
      decade: 'year',
      century: 'year',
      millennium: 'year',
      age: 'compact',
      epoch: 'compact',
      era: 'compact',
      eon: 'compact',
      eon2: 'compact'
    };

    if ((typeof elem === 'undefined' ? 'undefined' : (0, _typeof3.default)(elem)) === 'object') {
      this._el.container = elem;
    } else {
      this._el.container = TL.Dom.get(elem);
    }

    TL.Util.mergeData(this.options, options);

    this._initLayout();
    this._initEvents();
  },

  show: function show() {},

  hide: function hide() {},

  addTo: function addTo(container) {
    container.appendChild(this._el.container);
  },

  removeFrom: function removeFrom(container) {
    container.removeChild(this._el.container);
  },

  updateDisplay: function updateDisplay(w, h) {
    this._updateDisplay(w, h);
  },

  getLeft: function getLeft() {
    return this._el.container.style.left.slice(0, -2);
  },

  drawTicks: function drawTicks(timescale, optimal_tick_width) {

    var ticks = timescale.getTicks();

    var controls = {
      minor: {
        el: this._el.minor,
        dateformat: this.dateformat_lookup[ticks['minor'].name],
        ts_ticks: ticks['minor'].ticks,
        tick_elements: this.minor_ticks
      },
      major: {
        el: this._el.major,
        dateformat: this.dateformat_lookup[ticks['major'].name],
        ts_ticks: ticks['major'].ticks,
        tick_elements: this.major_ticks
      }
    };

    this._el.major.className = "tl-timeaxis-major";
    this._el.minor.className = "tl-timeaxis-minor";
    this._el.major.style.opacity = 0;
    this._el.minor.style.opacity = 0;

    this.major_ticks = this._createTickElements(ticks['major'].ticks, this._el.major, this.dateformat_lookup[ticks['major'].name]);

    this.minor_ticks = this._createTickElements(ticks['minor'].ticks, this._el.minor, this.dateformat_lookup[ticks['minor'].name], ticks['major'].ticks);

    this.positionTicks(timescale, optimal_tick_width, true);

    this._el.major.className = "tl-timeaxis-major tl-animate-opacity tl-timeaxis-animate-opacity";
    this._el.minor.className = "tl-timeaxis-minor tl-animate-opacity tl-timeaxis-animate-opacity";
    this._el.major.style.opacity = 1;
    this._el.minor.style.opacity = 1;
  },

  _createTickElements: function _createTickElements(ts_ticks, tick_element, dateformat, ticks_to_skip) {
    tick_element.innerHTML = "";
    var skip_times = {};

    var yearZero = new Date(-1, 13, -30);
    skip_times[yearZero.getTime()] = true;

    if (ticks_to_skip) {
      for (var i = 0; i < ticks_to_skip.length; i++) {
        skip_times[ticks_to_skip[i].getTime()] = true;
      }
    }

    var tick_elements = [];

    var minYear = 9999;
    var maxYear = 0;

    for (var i = 0; i < ts_ticks.length; i++) {
      var ts_tick = ts_ticks[i];
      if (!(ts_tick.getTime() in skip_times)) {

        var date = ts_tick.getDisplayDate(this.getLanguage(), dateformat);

        if (date !== '' + parseInt(date)) {
          continue;
        } else {

          var tick = TL.Dom.create("div", "tl-timeaxis-tick", tick_element),
              tick_text = TL.Dom.create("span", "tl-timeaxis-tick-text tl-animate-opacity", tick);

          tick_text.innerHTML = ts_tick.getDisplayDate(this.getLanguage(), dateformat);

          tick_elements.push({
            tick: tick,
            tick_text: tick_text,
            display_date: ts_tick.getDisplayDate(this.getLanguage(), dateformat),
            date: ts_tick
          });
        }
      }
    }
    return tick_elements;
  },

  positionTicks: function positionTicks(timescale, optimal_tick_width, no_animate) {
    if (no_animate) {
      this._el.major.className = "tl-timeaxis-major";
      this._el.minor.className = "tl-timeaxis-minor";
    } else {
      this._el.major.className = "tl-timeaxis-major tl-timeaxis-animate";
      this._el.minor.className = "tl-timeaxis-minor tl-timeaxis-animate";
    }

    this._positionTickArray(this.major_ticks, timescale, optimal_tick_width);
    this._positionTickArray(this.minor_ticks, timescale, optimal_tick_width);
  },

  _positionTickArray: function _positionTickArray(tick_array, timescale, optimal_tick_width) {
    if (tick_array[1] && tick_array[0]) {
      var distance = timescale.getPosition(tick_array[1].date.getMillisecond()) - timescale.getPosition(tick_array[0].date.getMillisecond()),
          fraction_of_array = 1;

      if (distance < optimal_tick_width) {
        fraction_of_array = Math.round(optimal_tick_width / timescale.getPixelsPerTick());
      }

      var show = 1;

      for (var i = 0; i < tick_array.length; i++) {

        var tick = tick_array[i];

        tick.tick.style.left = timescale.getPosition(tick.date.getMillisecond()) + "px";
        tick.tick_text.innerHTML = tick.display_date;

        if (fraction_of_array > 1) {
          if (show >= fraction_of_array) {
            show = 1;
            tick.tick_text.style.opacity = 1;
            tick.tick.className = "tl-timeaxis-tick";
          } else {
            show++;
            tick.tick_text.style.opacity = 0;
            tick.tick.className = "tl-timeaxis-tick tl-timeaxis-tick-hidden";
          }
        } else {
          tick.tick_text.style.opacity = 1;
          tick.tick.className = "tl-timeaxis-tick";
        }
      };
    }
  },

  _initLayout: function _initLayout() {
    this._el.content_container = TL.Dom.create("div", "tl-timeaxis-content-container", this._el.container);
    this._el.major = TL.Dom.create("div", "tl-timeaxis-major", this._el.content_container);
    this._el.minor = TL.Dom.create("div", "tl-timeaxis-minor", this._el.content_container);

    this.onLoaded();
  },

  _initEvents: function _initEvents() {},

  _updateDisplay: function _updateDisplay(width, height, layout) {

    if (width) {
      this.options.width = width;
    }

    if (height) {
      this.options.height = height;
    }
  }

});

TL.AxisHelper = TL.Class.extend({
  initialize: function initialize(options) {
    if (options) {
      this.scale = options.scale;
      this.minor = options.minor;
      this.major = options.major;
    } else {
      throw new TL.Error("axis_helper_no_options_err");
    }
  },

  getPixelsPerTick: function getPixelsPerTick(pixels_per_milli) {
    return pixels_per_milli * this.minor.factor;
  },

  getMajorTicks: function getMajorTicks(timescale) {
    return this._getTicks(timescale, this.major);
  },

  getMinorTicks: function getMinorTicks(timescale) {
    return this._getTicks(timescale, this.minor);
  },

  _getTicks: function _getTicks(timescale, option) {

    var factor_scale = timescale._scaled_padding * option.factor;
    var first_tick_time = timescale._earliest - factor_scale;
    var last_tick_time = timescale._latest + factor_scale;
    var ticks = [];
    for (var i = first_tick_time; i < last_tick_time; i += option.factor) {
      ticks.push(timescale.getDateFromTime(i).floor(option.name));
    }

    return {
      name: option.name,
      ticks: ticks
    };
  }

});

(function (cls) {

  var HELPERS = {};

  var setHelpers = function setHelpers(scale_type, scales) {
    HELPERS[scale_type] = [];

    for (var idx = 0; idx < scales.length - 1; idx++) {
      var minor = scales[idx];
      var major = scales[idx + 1];
      HELPERS[scale_type].push(new cls({
        scale: minor[3],
        minor: { name: minor[0], factor: minor[1] },
        major: { name: major[0], factor: major[1] }
      }));
    }
  };

  setHelpers('human', TL.Date.SCALES);
  setHelpers('cosmological', TL.BigDate.SCALES);

  cls.HELPERS = HELPERS;

  cls.getBestHelper = function (ts, optimal_tick_width) {
    if (typeof optimal_tick_width != 'number') {
      optimal_tick_width = 100;
    }
    var ts_scale = ts.getScale();
    var helpers = HELPERS[ts_scale];

    if (!helpers) {
      throw new TL.Error("axis_helper_scale_err", ts_scale);
    }

    var prev = null;
    for (var idx = 0; idx < helpers.length; idx++) {
      var curr = helpers[idx];
      var pixels_per_tick = curr.getPixelsPerTick(ts._pixels_per_milli);
      if (pixels_per_tick > optimal_tick_width) {
        if (prev == null) return curr;
        var curr_dist = Math.abs(optimal_tick_width - pixels_per_tick);
        var prev_dist = Math.abs(optimal_tick_width - pixels_per_tick);
        if (curr_dist < prev_dist) {
          return curr;
        } else {
          return prev;
        }
      }
      prev = curr;
    }
    return helpers[helpers.length - 1];
  };
})(TL.AxisHelper);

TL.Timeline = TL.Class.extend({
  includes: [TL.Events, TL.I18NMixins],

  initialize: function initialize(elem, data, options) {
    var self = this;
    if (!options) {
      options = {};
    };

    this.version = "3.2.6";

    this.ready = false;

    this._el = {
      container: {},
      storyslider: {},
      timenav: {},
      menubar: {}
    };

    if ((typeof elem === 'undefined' ? 'undefined' : (0, _typeof3.default)(elem)) === 'object') {
      this._el.container = elem;
    } else {
      this._el.container = TL.Dom.get(elem);
    }

    this._storyslider = {};

    this._style_sheet = new TL.StyleSheet();

    this._timenav = {};

    this._menubar = {};

    this._loaded = { storyslider: false, timenav: false };

    this.config = null;

    this.options = {
      script_path: "",
      height: this._el.container.offsetHeight,
      width: this._el.container.offsetWidth,
      debug: false,
      is_embed: false,
      is_full_embed: false,
      hash_bookmark: false,
      default_bg_color: { r: 255, g: 255, b: 255 },
      scale_factor: 2,
      layout: "landscape",
      timenav_position: "bottom",
      optimal_tick_width: 60,
      base_class: "tl-timeline",
      timenav_height: null,
      timenav_height_percentage: 25,
      timenav_mobile_height_percentage: 40,
      timenav_height_min: 175,
      marker_height_min: 30,
      marker_width_min: 100,
      marker_padding: 5,
      start_at_slide: 0,
      start_at_end: false,
      menubar_height: 0,
      skinny_size: 650,
      medium_size: 800,
      relative_date: false,
      use_bc: false,
      duration: 1000,
      ease: TL.Ease.easeInOutQuint,

      dragging: true,
      trackResize: true,
      map_type: "stamen:toner-lite",
      slide_padding_lr: 100,
      slide_default_fade: "0%",
      zoom_sequence: [0.5, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89],
      language: "en",
      ga_property_id: null,
      track_events: ['back_to_start', 'nav_next', 'nav_previous', 'zoom_in', 'zoom_out']
    };

    this.animator_timenav = null;
    this.animator_storyslider = null;
    this.animator_menubar = null;

    this.message = new TL.Message({}, { message_class: "tl-message-full" }, this._el.container);

    if (typeof options.default_bg_color == "string") {
      var parsed = TL.Util.hexToRgb(options.default_bg_color);
      if (parsed) {
        options.default_bg_color = parsed;
      } else {
        delete options.default_bg_color;
        TL.trace("Invalid default background color. Ignoring.");
      }
    }
    TL.Util.mergeData(this.options, options);

    window.addEventListener("resize", function (e) {
      self.updateDisplay();
    });

    TL.debug = this.options.debug;

    TL.DomUtil.addClass(this._el.container, 'tl-timeline');

    if (this.options.is_embed) {
      TL.DomUtil.addClass(this._el.container, 'tl-timeline-embed');
    }

    if (this.options.is_full_embed) {
      TL.DomUtil.addClass(this._el.container, 'tl-timeline-full-embed');
    }

    document.addEventListener("keydown", function (event) {
      var keyName = event.key;
      var currentSlide = self._getSlideIndex(self.current_id);
      var _n = self.config.events.length - 1;
      var lastSlide = self.config.title ? _n + 1 : _n;
      var firstSlide = 0;

      if (keyName == 'ArrowLeft') {
        if (currentSlide != firstSlide) {
          self.goToPrev();
        }
      } else if (keyName == 'ArrowRight') {
        if (currentSlide != lastSlide) {
          self.goToNext();
        }
      }
    });

    if (this.options.relative_date) {
      if (typeof moment !== 'undefined') {
        self._loadLanguage(data);
      } else {
        TL.Load.js(this.options.script_path + "/library/moment.js", function () {
          self._loadLanguage(data);
          TL.trace("LOAD MOMENTJS");
        });
      }
    } else {
      self._loadLanguage(data);
    }
  },
  _translateError: function _translateError(e) {
    if (e.hasOwnProperty('stack')) {
      TL.trace(e.stack);
    }
    if (e.message_key) {
      return this._(e.message_key) + (e.detail ? ' [' + e.detail + ']' : '');
    }
    return e;
  },

  _loadLanguage: function _loadLanguage(data) {
    try {
      this.options.language = new TL.Language(this.options);

      this._initData(data);
    } catch (e) {
      this.showMessage(this._translateError(e));
    }
  },

  goToId: function goToId(id) {
    if (this.current_id != id) {
      this.current_id = id;
      this._timenav.goToId(this.current_id);
      this._storyslider.goToId(this.current_id, false, true);
      this.fire("change", { unique_id: this.current_id }, this);
    }
  },

  goTo: function goTo(n) {
    if (this.config.title) {
      if (n == 0) {
        this.goToId(this.config.title.unique_id);
      } else {
        this.goToId(this.config.events[n - 1].unique_id);
      }
    } else {
      this.goToId(this.config.events[n].unique_id);
    }
  },

  goToStart: function goToStart() {
    this.goTo(0);
  },

  goToEnd: function goToEnd() {
    var _n = this.config.events.length - 1;
    this.goTo(this.config.title ? _n + 1 : _n);
  },

  goToPrev: function goToPrev() {
    this.goTo(this._getSlideIndex(this.current_id) - 1);
  },

  goToNext: function goToNext() {
    this.goTo(this._getSlideIndex(this.current_id) + 1);
  },

  add: function add(data) {
    var unique_id = this.config.addEvent(data);

    var n = this._getEventIndex(unique_id);
    var d = this.config.events[n];

    this._storyslider.createSlide(d, this.config.title ? n + 1 : n);
    this._storyslider._updateDrawSlides();

    this._timenav.createMarker(d, n);
    this._timenav._updateDrawTimeline(false);

    this.fire("added", { unique_id: unique_id });
  },

  remove: function remove(n) {
    if (n >= 0 && n < this.config.events.length) {
      if (this.config.events[n].unique_id == this.current_id) {
        if (n < this.config.events.length - 1) {
          this.goTo(n + 1);
        } else {
          this.goTo(n - 1);
        }
      }

      var event = this.config.events.splice(n, 1);
      delete this.config.event_dict[event[0].unique_id];
      this._storyslider.destroySlide(this.config.title ? n + 1 : n);
      this._storyslider._updateDrawSlides();

      this._timenav.destroyMarker(n);
      this._timenav._updateDrawTimeline(false);

      this.fire("removed", { unique_id: event[0].unique_id });
    }
  },

  removeId: function removeId(id) {
    this.remove(this._getEventIndex(id));
  },

  getData: function getData(n) {
    if (this.config.title) {
      if (n == 0) {
        return this.config.title;
      } else if (n > 0 && n <= this.config.events.length) {
        return this.config.events[n - 1];
      }
    } else if (n >= 0 && n < this.config.events.length) {
      return this.config.events[n];
    }
    return null;
  },

  getDataById: function getDataById(id) {
    return this.getData(this._getSlideIndex(id));
  },

  getSlide: function getSlide(n) {
    if (n >= 0 && n < this._storyslider._slides.length) {
      return this._storyslider._slides[n];
    }
    return null;
  },

  getSlideById: function getSlideById(id) {
    return this.getSlide(this._getSlideIndex(id));
  },

  getCurrentSlide: function getCurrentSlide() {
    return this.getSlideById(this.current_id);
  },

  updateDisplay: function updateDisplay() {
    if (this.ready) {
      this._updateDisplay();
    }
  },

  _calculateTimeNavHeight: function _calculateTimeNavHeight(timenav_height, timenav_height_percentage) {

    var height = 0;

    if (timenav_height) {
      height = timenav_height;
    } else {
      if (this.options.timenav_height_percentage || timenav_height_percentage) {
        if (timenav_height_percentage) {
          height = Math.round(this.options.height / 100 * timenav_height_percentage);
        } else {
          height = Math.round(this.options.height / 100 * this.options.timenav_height_percentage);
        }
      }
    }

    if (this._timenav.ready) {
      if (this.options.timenav_height_min < this._timenav.getMinimumHeight()) {
        this.options.timenav_height_min = this._timenav.getMinimumHeight();
      }
    }

    if (height < this.options.timenav_height_min) {
      height = this.options.timenav_height_min;
    }

    height = height - this.options.marker_padding * 2;

    return height;
  },

  _updateDisplay: function _updateDisplay(timenav_height, animate, d) {
    var duration = this.options.duration,
        display_class = this.options.base_class,
        menu_position = 0,
        self = this;

    if (d) {
      duration = d;
    }

    this.options.width = this._el.container.offsetWidth;
    this.options.height = this._el.container.offsetHeight;

    if (this.options.width <= this.options.skinny_size) {
      display_class += " tl-skinny";
      this.options.layout = "portrait";
    } else if (this.options.width <= this.options.medium_size) {
      display_class += " tl-medium";
      this.options.layout = "landscape";
    } else {
      this.options.layout = "landscape";
    }

    if (TL.Browser.touch) {
      this.options.layout = TL.Browser.orientation();
    }

    if (TL.Browser.mobile) {
      display_class += " tl-mobile";

      this.options.timenav_height = this._calculateTimeNavHeight(timenav_height, this.options.timenav_mobile_height_percentage);
    } else {
      this.options.timenav_height = this._calculateTimeNavHeight(timenav_height);
    }

    if (this.options.layout == "portrait") {
      display_class += " tl-layout-portrait";
    } else {
      display_class += " tl-layout-landscape";
    }

    this.options.storyslider_height = this.options.height - this.options.timenav_height;

    if (this.options.timenav_position == "top") {
      menu_position = Math.ceil(this.options.timenav_height) / 2 - this._el.menubar.offsetHeight / 2 - 39 / 2;
    } else {
      menu_position = Math.round(this.options.storyslider_height + 1 + Math.ceil(this.options.timenav_height) / 2 - this._el.menubar.offsetHeight / 2 - 35 / 2);
    }

    if (animate) {

      this._el.timenav.style.height = Math.ceil(this.options.timenav_height) + "px";

      if (this.animator_storyslider) {
        this.animator_storyslider.stop();
      }
      this.animator_storyslider = TL.Animate(this._el.storyslider, {
        height: this.options.storyslider_height + "px",
        duration: duration / 2,
        easing: TL.Ease.easeOutStrong
      });

      if (this.animator_menubar) {
        this.animator_menubar.stop();
      }

      this.animator_menubar = TL.Animate(this._el.menubar, {
        top: menu_position + "px",
        duration: duration / 2,
        easing: TL.Ease.easeOutStrong
      });
    } else {
      this._el.timenav.style.height = Math.ceil(this.options.timenav_height) + "px";

      this._el.storyslider.style.height = this.options.storyslider_height + "px";

      this._el.menubar.style.top = menu_position + "px";
    }

    if (this.message) {
      this.message.updateDisplay(this.options.width, this.options.height);
    }

    this._timenav.updateDisplay(this.options.width, this.options.timenav_height, animate);
    this._storyslider.updateDisplay(this.options.width, this.options.storyslider_height, animate, this.options.layout);

    if (this.options.language.direction == 'rtl') {
      display_class += ' tl-rtl';
    }

    this._el.container.className = display_class;
  },

  _updateHashBookmark: function _updateHashBookmark(id) {
    var hash = "#" + "event-" + id.toString();
    if (window.location.protocol != 'file:') {
      window.history.replaceState(null, "Browsing TimelineJS", hash);
    }
    this.fire("hash_updated", { unique_id: this.current_id, hashbookmark: "#" + "event-" + id.toString() }, this);
  },

  _initData: function _initData(data) {
    var self = this;

    if (typeof data == 'string') {
      var self = this;
      TL.ConfigFactory.makeConfig(data, function (config) {
        self.setConfig(config);
      });
    } else if (TL.TimelineConfig == data.constructor) {
      this.setConfig(data);
    } else {
      this.setConfig(new TL.TimelineConfig(data));
    }
  },

  setConfig: function setConfig(config) {
    this.config = config;
    this.config.validate();
    this._validateOptions();
    if (this.config.isValid()) {
      try {
        this._onDataLoaded();
      } catch (e) {
        this.showMessage("<strong>" + this._('error') + ":</strong> " + this._translateError(e));
      }
    } else {
      var translated_errs = [];

      for (var i = 0, errs = this.config.getErrors(); i < errs.length; i++) {
        translated_errs.push(this._translateError(errs[i]));
      }

      this.showMessage("<strong>" + this._('error') + ":</strong> " + translated_errs.join('<br>'));
    }
  },
  _validateOptions: function _validateOptions() {
    var INTEGER_PROPERTIES = ['timenav_height', 'timenav_height_min', 'marker_height_min', 'marker_width_min', 'marker_padding', 'start_at_slide', 'slide_padding_lr'];

    for (var i = 0; i < INTEGER_PROPERTIES.length; i++) {
      var opt = INTEGER_PROPERTIES[i];
      var value = this.options[opt];
      var valid = true;
      if (typeof value == 'number') {
        valid = value == parseInt(value);
      } else if (typeof value == "string") {
        valid = value.match(/^\s*(\-?\d+)?\s*$/);
      }
      if (!valid) {
        this.config.logError({ message_key: 'invalid_integer_option', detail: opt });
      }
    }
  },

  _initLayout: function _initLayout() {
    var self = this;

    this.message.removeFrom(this._el.container);
    this._el.container.innerHTML = "";

    if (this.options.timenav_position == "top") {
      this._el.timenav = TL.Dom.create('div', 'tl-timenav', this._el.container);
      this._el.storyslider = TL.Dom.create('div', 'tl-storyslider', this._el.container);
    } else {
      this._el.storyslider = TL.Dom.create('div', 'tl-storyslider', this._el.container);
      this._el.timenav = TL.Dom.create('div', 'tl-timenav', this._el.container);
    }

    this._el.menubar = TL.Dom.create('div', 'tl-menubar', this._el.container);

    this.options.width = this._el.container.offsetWidth;
    this.options.height = this._el.container.offsetHeight;

    this.options.timenav_height = this._calculateTimeNavHeight(this.options.timenav_height);

    this._timenav = new TL.TimeNav(this._el.timenav, this.config, this.options);
    this._timenav.on('loaded', this._onTimeNavLoaded, this);
    this._timenav.on('update_timenav_min', this._updateTimeNavHeightMin, this);
    this._timenav.options.height = this.options.timenav_height;
    this._timenav.init();

    if (this.options.initial_zoom) {
      this.setZoom(this.options.initial_zoom);
    }

    this._storyslider = new TL.StorySlider(this._el.storyslider, this.config, this.options);
    this._storyslider.on('loaded', this._onStorySliderLoaded, this);
    this._storyslider.init();

    this._menubar = new TL.MenuBar(this._el.menubar, this._el.container, this.options);

    if (this.options.layout == "portrait") {
      this.options.storyslider_height = this.options.height - this.options.timenav_height - 1;
    } else {
      this.options.storyslider_height = this.options.height - 1;
    }

    this._updateDisplay(this._timenav.options.height, true, 2000);
  },

  _initEvents: function _initEvents() {
    this._timenav.on('change', this._onTimeNavChange, this);
    this._timenav.on('zoomtoggle', this._onZoomToggle, this);

    this._storyslider.on('change', this._onSlideChange, this);
    this._storyslider.on('colorchange', this._onColorChange, this);
    this._storyslider.on('nav_next', this._onStorySliderNext, this);
    this._storyslider.on('nav_previous', this._onStorySliderPrevious, this);

    this._menubar.on('zoom_in', this._onZoomIn, this);
    this._menubar.on('zoom_out', this._onZoomOut, this);
    this._menubar.on('back_to_start', this._onBackToStart, this);
  },

  _initGoogleAnalytics: function _initGoogleAnalytics() {
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

    ga('create', this.options.ga_property_id, 'auto');
  },

  _initAnalytics: function _initAnalytics() {
    if (this.options.ga_property_id === null) {
      return;
    }
    this._initGoogleAnalytics();
    ga('send', 'pageview');
    var events = this.options.track_events;
    for (i = 0; i < events.length; i++) {
      var event_ = events[i];
      this.addEventListener(event_, function (e) {
        ga('send', 'event', e.type, 'clicked');
      });
    }
  },

  _onZoomToggle: function _onZoomToggle(e) {
    if (e.zoom == "in") {
      this._menubar.toogleZoomIn(e.show);
    } else if (e.zoom == "out") {
      this._menubar.toogleZoomOut(e.show);
    }
  },

  _getEventIndex: function _getEventIndex(id) {
    for (var i = 0; i < this.config.events.length; i++) {
      if (id == this.config.events[i].unique_id) {
        return i;
      }
    }
    return -1;
  },

  _getSlideIndex: function _getSlideIndex(id) {
    if (this.config.title && this.config.title.unique_id == id) {
      return 0;
    }
    for (var i = 0; i < this.config.events.length; i++) {
      if (id == this.config.events[i].unique_id) {
        return this.config.title ? i + 1 : i;
      }
    }
    return -1;
  },

  _onDataLoaded: function _onDataLoaded(e) {
    this.fire("dataloaded");
    this._initLayout();
    this._initEvents();
    this._initAnalytics();
    if (this.message) {
      this.message.hide();
    }

    this.ready = true;
  },

  showMessage: function showMessage(msg) {
    if (this.message) {
      this.message.updateMessage(msg);
    } else {
      TL.trace("No message display available.");
      TL.trace(msg);
    }
  },

  _onColorChange: function _onColorChange(e) {
    this.fire("color_change", { unique_id: this.current_id }, this);
    if (e.color || e.image) {} else {}
  },

  _onSlideChange: function _onSlideChange(e) {
    if (this.current_id != e.unique_id) {
      this.current_id = e.unique_id;
      this._timenav.goToId(this.current_id);
      this._onChange(e);
    }
  },

  _onTimeNavChange: function _onTimeNavChange(e) {
    if (this.current_id != e.unique_id) {
      this.current_id = e.unique_id;
      this._storyslider.goToId(this.current_id);
      this._onChange(e);
    }
  },

  _onChange: function _onChange(e) {
    this.fire("change", { unique_id: this.current_id }, this);
    if (this.options.hash_bookmark && this.current_id) {
      this._updateHashBookmark(this.current_id);
    }
  },

  _onBackToStart: function _onBackToStart(e) {
    this._storyslider.goTo(0);
    this.fire("back_to_start", { unique_id: this.current_id }, this);
  },

  zoomIn: function zoomIn() {
    this._timenav.zoomIn();
  },
  zoomOut: function zoomOut() {
    this._timenav.zoomOut();
  },

  setZoom: function setZoom(level) {
    this._timenav.setZoom(level);
  },

  _onZoomIn: function _onZoomIn(e) {
    this._timenav.zoomIn();
    this.fire("zoom_in", { zoom_level: this._timenav.options.scale_factor }, this);
  },

  _onZoomOut: function _onZoomOut(e) {
    this._timenav.zoomOut();
    this.fire("zoom_out", { zoom_level: this._timenav.options.scale_factor }, this);
  },

  _onTimeNavLoaded: function _onTimeNavLoaded() {
    this._loaded.timenav = true;
    this._onLoaded();
  },

  _onStorySliderLoaded: function _onStorySliderLoaded() {
    this._loaded.storyslider = true;
    this._onLoaded();
  },

  _onStorySliderNext: function _onStorySliderNext(e) {
    this.fire("nav_next", e);
  },

  _onStorySliderPrevious: function _onStorySliderPrevious(e) {
    this.fire("nav_previous", e);
  },

  _onLoaded: function _onLoaded() {
    if (this._loaded.storyslider && this._loaded.timenav) {
      this.fire("loaded", this.config);

      if (this.options.hash_bookmark && window.location.hash != "") {
        this.goToId(window.location.hash.replace("#event-", ""));
      } else {
        if (TL.Util.isTrue(this.options.start_at_end) || this.options.start_at_slide > this.config.events.length) {
          this.goToEnd();
        } else {
          this.goTo(this.options.start_at_slide);
        }
        if (this.options.hash_bookmark) {
          this._updateHashBookmark(this.current_id);
        }
      }
    }
  }

});

TL.Timeline.source_path = function () {
  var script_tags = document.getElementsByTagName('script');
  var src = script_tags[script_tags.length - 1].src;
  return src.substr(0, src.lastIndexOf('/'));
}();

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _difference_in_minutes = __webpack_require__(1191);

var _difference_in_minutes2 = _interopRequireDefault(_difference_in_minutes);

var _difference_in_hours = __webpack_require__(1190);

var _difference_in_hours2 = _interopRequireDefault(_difference_in_hours);

var _difference_in_days = __webpack_require__(1189);

var _difference_in_days2 = _interopRequireDefault(_difference_in_days);

var _format = __webpack_require__(1027);

var _format2 = _interopRequireDefault(_format);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    articleDateFormatter: function articleDateFormatter(date) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Published';
      var minuteTxt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'minute';
      var hourTxt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hour';
      var dayTxt = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'day';

      if (!date) return '';

      var isAgo = true;
      var content = '';
      var result = '';
      var now = new Date();
      var compareDate = new Date(date);
      var diffInMins = (0, _difference_in_minutes2.default)(now, compareDate);
      var diffInHours = (0, _difference_in_hours2.default)(now, compareDate);
      var diffInDays = (0, _difference_in_days2.default)(now, compareDate);
      if (diffInDays > 3) {
        isAgo = false;
        var dateString = (0, _format2.default)(compareDate, 'D MMM, YYYY h:mma');
        var timezoneString = compareDate.toString().match(/\(([A-Za-z\s].*)\)/);
        var timezone = '';

        if (!(0, _isEmpty2.default)(timezoneString) && timezoneString.length === 2) {
          timezone = timezoneString[1];
        }

        content = prefix + ' on ' + dateString + ' ' + timezone;
      } else if (diffInDays >= 1) {
        content = prefix + ' ' + diffInDays + ' ' + dayTxt;
        content += diffInDays > 1 ? 's' : '';
      } else if (diffInHours >= 1) {
        content = prefix + ' ' + diffInHours + ' ' + hourTxt;
        content += diffInHours > 1 ? 's' : '';
      } else {
        content = prefix + ' ' + diffInMins + ' ' + minuteTxt;
        content += diffInMins > 1 ? 's' : '';
      }
      result = isAgo ? content += ' ago' : content;
      return result;
    }
  }
};

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _concat = __webpack_require__(1036);

var _concat2 = _interopRequireDefault(_concat);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _Gallery = __webpack_require__(1318);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _ProgressiveImage = __webpack_require__(917);

var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);

var _lazyloadImage = __webpack_require__(914);

var _lazyloadImage2 = _interopRequireDefault(_lazyloadImage);

var _icon_gallery = __webpack_require__(1107);

var _icon_gallery2 = _interopRequireDefault(_icon_gallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-gallery',
  props: {
    nid: [Number, String],
    theme: {
      type: String,
      default: ''
    }
  },
  mixins: [_lazyloadImage2.default],
  data: function data() {
    return {
      slideshow: []
    };
  },

  components: {
    Gallery: _Gallery2.default,
    SvgIconGallery: _icon_gallery2.default,
    ProgressiveImage: _ProgressiveImage2.default
  },
  created: function created() {
    var _this = this;

    if (!(0, _isEmpty2.default)(this.node.images)) {
      (0, _forEach2.default)(this.node.images, function (v) {
        if (v.slideshow) {
          _this.slideshow = (0, _concat2.default)(_this.slideshow, v);
        }
      });
    }
  },

  computed: {
    node: function node() {
      return this.$store.getters.node(this.nid);
    },
    progressiveImages: function progressiveImages() {
      return (0, _map2.default)(this.slideshow, function (item) {
        return {
          src: item.style_600x600,
          loading: item.style_140x140,
          holder: '/image/placeholder/1/1/transparent',
          error: '/image/placeholder/1/1/transparent'
        };
      });
    }
  }
};

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(39);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _CusCarousel = __webpack_require__(1161);

var _CusCarousel2 = _interopRequireDefault(_CusCarousel);

var _NodeBody = __webpack_require__(1699);

var _NodeBody2 = _interopRequireDefault(_NodeBody);

var _CardCover = __webpack_require__(1698);

var _CardCover2 = _interopRequireDefault(_CardCover);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

var _navHeaderMobile = __webpack_require__(354);

var _navHeaderMobile2 = _interopRequireDefault(_navHeaderMobile);

var _navHeaderDesktop = __webpack_require__(364);

var _navHeaderDesktop2 = _interopRequireDefault(_navHeaderDesktop);

var _animationHandler = __webpack_require__(348);

var _animationHandler2 = _interopRequireDefault(_animationHandler);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

var _get2 = __webpack_require__(5);

var _get3 = _interopRequireDefault(_get2);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _indexOf = __webpack_require__(1651);

var _indexOf2 = _interopRequireDefault(_indexOf);

var _toInteger = __webpack_require__(147);

var _toInteger2 = _interopRequireDefault(_toInteger);

var _unionBy = __webpack_require__(1659);

var _unionBy2 = _interopRequireDefault(_unionBy);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _find = __webpack_require__(228);

var _find2 = _interopRequireDefault(_find);

var _has = __webpack_require__(102);

var _has2 = _interopRequireDefault(_has);

var _isBoolean = __webpack_require__(383);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _last = __webpack_require__(146);

var _last2 = _interopRequireDefault(_last);

var _throttle = __webpack_require__(965);

var _throttle2 = _interopRequireDefault(_throttle);

var _isFunction = __webpack_require__(84);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _xor = __webpack_require__(387);

var _xor2 = _interopRequireDefault(_xor);

var _values = __webpack_require__(360);

var _values2 = _interopRequireDefault(_values);

var _utilities = __webpack_require__(51);

var _PopUpWrapper = __webpack_require__(1696);

var _PopUpWrapper2 = _interopRequireDefault(_PopUpWrapper);

var _ShareButtons = __webpack_require__(335);

var _ShareButtons2 = _interopRequireDefault(_ShareButtons);

var _MonsterNewsletterForm = __webpack_require__(1099);

var _MonsterNewsletterForm2 = _interopRequireDefault(_MonsterNewsletterForm);

var _MonsterNewsletterFormDesktop = __webpack_require__(1171);

var _MonsterNewsletterFormDesktop2 = _interopRequireDefault(_MonsterNewsletterFormDesktop);

var _CardVideo = __webpack_require__(367);

var _CardVideo2 = _interopRequireDefault(_CardVideo);

var _PersonBody = __webpack_require__(1320);

var _PersonBody2 = _interopRequireDefault(_PersonBody);

var _Header = __webpack_require__(1712);

var _Header2 = _interopRequireDefault(_Header);

var _ShareBar = __webpack_require__(1714);

var _ShareBar2 = _interopRequireDefault(_ShareBar);

var _icon_videoplay = __webpack_require__(238);

var _icon_videoplay2 = _interopRequireDefault(_icon_videoplay);

var _icon_arrow_left = __webpack_require__(1181);

var _icon_arrow_left2 = _interopRequireDefault(_icon_arrow_left);

var _icon_arrow_right = __webpack_require__(368);

var _icon_arrow_right2 = _interopRequireDefault(_icon_arrow_right);

var _icon_arrow_down = __webpack_require__(988);

var _icon_arrow_down2 = _interopRequireDefault(_icon_arrow_down);

var _icon_arrow_down3 = __webpack_require__(1323);

var _icon_arrow_down4 = _interopRequireDefault(_icon_arrow_down3);

var _icon_bottom_card_invader = __webpack_require__(1805);

var _icon_bottom_card_invader2 = _interopRequireDefault(_icon_bottom_card_invader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var articleLimit = 10;

exports.default = {
  name: 'article-view',
  props: ['nid'],
  mixins: [_section2.default, _navHeaderMobile2.default, _navHeaderDesktop2.default, _animationHandler2.default],
  components: {
    NodeBody: _NodeBody2.default,
    CardCover: _CardCover2.default,
    CusCarousel: _CusCarousel2.default,
    WidgetShareButtons: _ShareButtons2.default,
    MonsterNewsletterForm: _MonsterNewsletterForm2.default,
    MonsterNewsletterFormDesktop: _MonsterNewsletterFormDesktop2.default,
    PopUpWrapper: _PopUpWrapper2.default,
    CardVideo: _CardVideo2.default,
    SvgVideoPlayIcon: _icon_videoplay2.default,
    IconArrowLeft: _icon_arrow_left2.default,
    IconArrowRight: _icon_arrow_right2.default,
    SvgIconArrowDownOne: _icon_arrow_down2.default,
    SvgArrowDown: _icon_arrow_down4.default,
    RelatedPersonOverlay: _PersonBody2.default,
    RelatedPersonOverlayHeader: _Header2.default,
    RelatedPersonOverlayShareBar: _ShareBar2.default,
    IconBottomCardInvader: _icon_bottom_card_invader2.default,
    TechLiftFooter: function TechLiftFooter() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 159));
    }
  },
  created: function created() {
    this.setActiveNID(this.nid);
  },
  data: function data() {
    return {
      sliderOptions: {
        allowScroll: true,
        realTimeAnimate: true,
        sensitivity: 15,
        exactAngle: [{
          min: -20,
          max: 20,
          abs: true
        }, {
          min: 160,
          max: 180,
          abs: true
        }],
        childScrolling: false,
        setScrolling: false,
        childProcessed: false,
        forceStop: false,
        disableSwipe: true,
        articleLimit: articleLimit,
        initFromMount: false
      },
      articleList: [this.nid],
      articleListLimit: articleLimit,
      articleListOffset: 0,
      atTop: false,
      nextCard: false,
      showTopCover: true,
      showPrevCardCover: false,
      touchTimeStamp: 0,
      touchStartX: 0,
      touchStartY: 0,
      cardMargintop: 0,
      prevCardMargintop: 0,
      prevCardTransformY: 0,
      inCard: true,
      touching: false,
      bounce: false,
      bounceBottom: false,
      cardReset: false,
      cardAnimate: false,
      bottomCardReset: false,
      bodyMarginTop: 0,
      bodyMaxHeight: 'auto',
      nextBybottom: false,
      lastPosition: {},
      lastScrollPosition: 0,
      isVideoFullScreen: false,
      bindVideoAction: {
        fullscreen: this.actionOnVideoFullScreen,
        pause: this.actionOnVideoPause,
        idle: this.actionOnVideoIdle,
        play: this.actionOnVideoPlay
      },
      reachTopBottom: false,
      newsletterCheckCount: 0,
      currentViewPort: false,
      shareBarActive: 'hide',
      shareBarNoAnimation: false,
      shareBarWaitForActive: false,
      allowHeaderToggle: true,
      isShowVideo: {},
      showVideoPlayButton: false,
      newsLetterWidgetXPadding: 0,
      nextPrevByArrow: false,
      arrowPrev: false,
      arrowNext: true,
      arrowVisible: false,
      arrowInit: false,
      newArrowTopPercentage: {},
      slideChanging: false,
      articleScrollY: 0,
      hoverCover: false,
      showCoverArrowOnce: true,
      hideVideoPromise: undefined,
      pageScroll: true,
      pageScrollCounter: false,
      bodyFadeIn: false,
      scrollEnd: true,
      scrollTimer: '',
      preventPan: false,
      allowSwipePrevCard: false,
      initCarousel: false,
      disableCardAnimate: false,
      showNodeBody: true,
      listenWheel: false,
      isCardMounted: false,
      isBodyMounted: false,
      bottomBlankSpace: false,
      carouselExtraSlots: [{
        key: 'sharebar',
        animationClass: 'share-buttons-wrapper'
      }],
      bottomCardScale: 1,
      initBottomCardScale: 0.3,
      showBottomCover: true,
      allowNextByBottom: true,
      touchSpeed: false,
      bottomCardSmoothAnimate: false,
      firstScrollTimeStamp: false,
      firstScrollPos: false,
      cardActionAnimate: false,
      scrollToTopFlag: false,
      preventScroll: false,
      showSeoTitle: true
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['nodes', 'scaleHeaderBar', 'nodeHeader', 'nodeQueue', 'viewportHeight', 'showNewsletter', 'activeNID', 'relatedPersonOverlay', 'articleListTid', 'showDesktopHeaderMenu', 'allowNewsletterWidgetPopup', 'isRefreshedToRoutedArticle']), {
    node: function node() {
      return this.$store.getters.node(this.activeNID);
    },
    nodeType: function nodeType() {
      return (0, _get3.default)(this, 'node.type', 'article');
    },
    shareData: function shareData() {
      var obj = {
        url: '' + this.requestDomain() + (0, _get3.default)(this.node, 'relative_url', ''),
        shortenUrl: (0, _get3.default)(this.node, 'shorten_url', ''),
        title: (0, _utilities.updateTitleByNodeType)({ type: (0, _get3.default)(this, 'node.type', ''), originalTitle: (0, _get3.default)(this.node, 'title', '') }),
        thumbnail: (0, _get3.default)(this, 'node.images[0].style_700x400')
      };
      return obj;
    },
    articleType: function articleType() {
      return (0, _utilities.getArticleType)(this.node);
    },
    firstRelatedPerson: function firstRelatedPerson() {
      return (0, _get3.default)(this, 'node.related_people[0].nid');
    },
    hasRelatedPersonInBody: function hasRelatedPersonInBody() {
      return (0, _find2.default)((0, _get3.default)(this, 'node.contentList', []), ['type', 'person']);
    },
    fetchNodeQueueFromLiftigniter: function fetchNodeQueueFromLiftigniter() {
      return (0, _get3.default)(this.settings(), 'LIFTIGNITER.RECOMMENDATION', false) && this.isLiftigniterInit();
    },

    articleCover: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, '$refs[' + this.getCoverRef(this.activeNID) + ']', false);
      }
    },
    articleBody: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, '$refs[' + this.getArticleRef(this.activeNID) + ']', false);
      }
    },
    articleBodyCardWrapper: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, '$refs[' + this.getBodyCardWrapperRef(this.activeNID) + ']', false);
      }
    },
    nextArticleCover: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, '$refs[' + this.getCoverRef(this.nextArticleNID) + ']', false);
      }
    },
    articleWrapper: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, '$refs[' + this.getWrapperRef(this.activeNID) + '][0]', []);
      }
    },
    nextArticleNID: {
      cache: false,
      get: function get() {
        if ((0, _indexOf2.default)(this.articleList, this.activeNID) < (0, _get3.default)(this, 'articleList.length', 0) - 1) {
          return this.articleList[(0, _indexOf2.default)(this.articleList, this.activeNID) + 1];
        }
        return false;
      }
    },
    prevArticleNID: {
      cache: false,
      get: function get() {
        if ((0, _indexOf2.default)(this.articleList, this.activeNID) > 0 && (0, _get3.default)(this, 'articleList.length', 0) > 1) {
          return this.articleList[(0, _indexOf2.default)(this.articleList, this.activeNID) - 1];
        }
        return false;
      }
    },
    cardVideoNID: function cardVideoNID() {
      return 'cardVideo-' + this.activeNID;
    },
    sections: function sections() {
      var _this = this;

      var sections = [];
      (0, _forEach2.default)((0, _get3.default)(this, 'node.sections', []), function (sectionLineage) {
        var sectionList = (0, _map2.default)(sectionLineage, _this.$store.getters.term);
        sections.push(sectionList);
      });
      return sections;
    },
    nextCoverHeaderText: function nextCoverHeaderText() {
      if ((0, _get3.default)(this, 'nextArticleNID')) {
        var nextNode = this.$store.getters.node((0, _get3.default)(this, 'nextArticleNID'));

        if ((0, _get3.default)(nextNode, 'sections')) {
          return (0, _get3.default)(this.getLastSection((0, _get3.default)(nextNode, 'sections')), 'name', '');
        }
      }
      return '';
    },
    viewPortHeightVh: function viewPortHeightVh() {
      if (typeof window !== 'undefined') {
        return window.innerHeight / this.viewportHeight * 100;
      }
      return 100;
    },

    cardVideoContainer: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, '$refs.cardVideoContainer', false);
      }
    },
    videoCard: function videoCard() {
      return (0, _get3.default)(this, '$refs.' + this.cardVideoNID + '[0]', {});
    },

    cardCoverIsVideo: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, 'node.isCardVideo', false);
      }
    },
    cardCoverVideoOrientation: {
      cache: false,
      get: function get() {
        return (0, _get3.default)(this, 'node.videoOrientation', '');
      }
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    _eventBus2.default.$on('bodyMounted', function () {
      _this2.bodyMounted();
    });
    this.setHeaderTitle((0, _get3.default)(this, 'firstSectionLineage', []));
    this.innerHeight = __webpack_require__(1638);
  },
  mounted: function mounted() {
    this.showSeoTitle = false;
    this.$store.commit('setIsRefreshedToRoutedArticle', false);
    (0, _utilities.bindInputForAndroid)(this.articleWrapper);
    this.showCoverArrowsOnce(3000);
    this.resetMobileHeader();
    this.resetDesktopHeader();
    this.shareButtons = this.$refs.shareButtons.$el;
    this.bindTopCoverTouchSupport();
    this.bindVidoeCardConatinerTouchSupport();
    this.bindBodyTouchSupport();
    this.bindBottomCoverTouchSupport();
    this.handleViewportChange();
    this.currentViewPort = (0, _utilities.isDesktop)() ? 'desktop' : 'mobile';
    this.sliderOptions.disableSwipe = (0, _utilities.isDesktop)();
    this.showVideoPlayButton = true;
    this.isShowVideo[this.activeNID] = !(0, _utilities.isDesktop)() && this.cardCoverIsVideo;
    if (!(0, _utilities.isDesktop)()) {
      this.showPrevCardCover = true;
      this.allowSwipePrevCard = true;
      this.prevCardMargintop = this.viewportHeight * -1;
      this.prevCardTransformY = this.viewportHeight - this.viewportHeight * (this.viewPortHeightVh / 100);
      this.bottomCardScale = this.initBottomCardScale;
    }
    _eventBus2.default.$emit('liftigniter-SendPageView');

    this.fetchArticleList(true, this.fetchNodeQueueFromLiftigniter);
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleHeaderBar', 'setHeaderTitle', 'toggleNewsletter', 'enableNewsletterWidgetPopup', 'setActiveNID', 'setDesktopReadingPosition', 'enableLandscapeBlock', 'toggleHeaderTitle', 'setIsLiftigniterInit']), (0, _vuex.mapMutations)(['setArticleListTid']), (0, _vuex.mapGetters)({
    requestDomain: 'requestDomain',
    settings: 'settings',
    fetchNodeBypassSection: 'fetchNodeBypassSection',
    isLiftigniterInit: 'isLiftigniterInit'
  }), {
    viewportChangeHandler: function viewportChangeHandler() {
      if (!(0, _utilities.isDesktop)()) {
        this.allowSwipePrevCard = true;
        if (this.currentViewPort === 'desktop') {
          if ((0, _get3.default)(this.articleWrapper, 'scrollTop', false) && this.articleWrapper.scrollTop <= window.innerHeight) {
            this.articleWrapper.scrollTo(0, 0);
          }
        }
        this.currentViewPort = 'mobile';
        this.sliderOptions.disableSwipe = false;
        this.showPrevCardCover = true;
      } else {
        this.allowSwipePrevCard = false;
        if (this.currentViewPort === 'mobile') {
          this.triggerTopCover();
        }
        this.setCoverArrowsPosition();
        this.currentViewPort = 'desktop';
        this.sliderOptions.disableSwipe = true;
        this.showPrevCardCover = false;
        this.resetscaleBottomCard();
      }

      var cardCover = this.getCardChild(this.activeNID);
      if (cardCover) this.bottomBlankSpace = !(cardCover.$el.offsetHeight > this.viewportHeight);
    },
    showCoverArrowsOnce: function showCoverArrowsOnce(second) {
      var _this3 = this;

      if (this.showCoverArrowOnce) {
        this.hoverCover = true;
        this.setCoverArrowsPosition();
        this.arrowVisible = true;
        setTimeout(function () {
          _this3.arrowVisible = false;
        }, second || 3000);
      }
    },
    lazyCover: function lazyCover(index) {
      if (Math.abs(index - (0, _indexOf2.default)(this.articleList, this.activeNID)) <= 2) {
        return true;
      }
      return false;
    },
    forceShowArrows: function forceShowArrows(direction) {
      if (direction === 'left' && (0, _indexOf2.default)(this.articleList, this.activeNID) === 0) return;
      if (direction === 'right' && (0, _indexOf2.default)(this.articleList, this.activeNID) + 1 === this.articleList.length) return;
      this.hoverCover = true;
      this.arrowVisible = true;
      this.setCoverArrowsPosition();
    },
    forceHideArrows: function forceHideArrows() {
      var _this4 = this;

      this.arrowVisible = false;
      setTimeout(function () {
        _this4.hoverCover = false;
      }, 200);
    },
    setCoverArrowsPosition: function setCoverArrowsPosition() {
      var arrowHover = (0, _get3.default)(this, '$refs.arrowsHoverWrapper[0]');
      if (arrowHover) {
        var arrowHoverPosTop = arrowHover.querySelector('.card-middle').getBoundingClientRect().top;
        if ((0, _get3.default)(this, '$refs.articleArrowLeft')) this.$refs.articleArrowLeft.style.top = (arrowHoverPosTop - 35) * 0.0625 + 'rem';
        if ((0, _get3.default)(this, '$refs.articleArrowRight')) this.$refs.articleArrowRight.style.top = (arrowHoverPosTop - 35) * 0.0625 + 'rem';
      }
    },
    shareBarAndHeaderBarToggle: function shareBarAndHeaderBarToggle(showHeaderText) {
      var toggleHeaderText = (0, _isBoolean2.default)(showHeaderText) ? showHeaderText : true;

      if (!(0, _get3.default)(this, 'articleBody[0]', false)) return;
      var newScrollPosition = this.articleWrapper.scrollTop;

      this.toggleMobileHeaderText(true);

      if ((0, _utilities.isDesktop)()) {
        this.desktopShareHeaderControl();
        this.lastScrollPosition = newScrollPosition;
      }

      var allTags = this.articleBody[0].$el.getElementsByClassName('tags-wrapper');

      var lastTag = (0, _last2.default)(allTags);
      var tagsWrapperOffsetTop = (0, _utilities.isDomElement)(lastTag) ? Math.round(lastTag.getBoundingClientRect().top) : 0;

      var InTags = tagsWrapperOffsetTop + this.shareButtons.offsetHeight - window.innerHeight <= 0;

      var shareBar = this.articleBody[0].$el.getElementsByClassName('share-toolbar')[0];
      if (shareBar) {
        var shareBarOffsetTop = shareBar.getBoundingClientRect().top;
        if (shareBarOffsetTop <= '-' + shareBar.offsetHeight) {
          this.inCard = InTags;
        }

        if (shareBarOffsetTop <= '-' + shareBar.offsetHeight && newScrollPosition > this.lastScrollPosition) {
          if (this.articleType !== 'live') {
            this.showMiniHeader();
          }
          this.toggleShareBarActive(true);
          this.lastScrollPosition = newScrollPosition;

          if (InTags) {
            this.toggleShareBarActive(false);
          } else {
            this.toggleShareBarActive(true);
          }
          return;
        }
      }

      if (this.allowHeaderToggle) {
        if (toggleHeaderText) this.toggleShareBarActive(false);
        if (toggleHeaderText && this.articleType !== 'live' && !this.bottomCardOnScreen()) this.showHeaderText();
      }

      this.lastScrollPosition = newScrollPosition;
    },
    desktopShareHeaderControl: function desktopShareHeaderControl() {
      if ((0, _get3.default)(this, 'articleWrapper')) {
        var article = this.articleWrapper.getElementsByClassName('article-parent-wrapper')[0];
        var tags = this.articleWrapper.getElementsByClassName('tags-wrapper')[0];
        var articleOffsetTop = article ? article.getBoundingClientRect().top : 0;
        var tagsOffsetTop = tags ? tags.getBoundingClientRect().top : 1;

        this.updateReadingPosition();

        if (articleOffsetTop < 0 && tagsOffsetTop > 0) {
          this.setDesktopShareHeader(true);
        } else {
          this.setDesktopShareHeader(false);
        }
      }
    },
    updateReadingPosition: function updateReadingPosition() {
      var article = this.articleBodyCardWrapper[0];
      var card = (0, _get3.default)(article.getElementsByClassName('card-cover'), '[0].offsetHeight', 0);
      var wrapper = (0, _get3.default)(article.getElementsByClassName('article-parent-wrapper'), '[0].offsetHeight', false);
      if (wrapper) {
        var totalHeight = card + wrapper;
        var progress = Math.abs(this.articleWrapper.scrollTop / totalHeight * 100);
        this.setDesktopReadingPosition(progress);
      }
    },
    resetShareBar: function resetShareBar() {
      this.shareButtons.style.transform = '';
      if (this.$refs.shareButtons.nativeShare) {
        this.shareBarActive = 'reset';
      } else {
        this.toggleShareBarActive(false);
      }
    },
    isActive: function isActive(nid) {
      if (nid === this.activeNID) {
        return true;
      }
      return false;
    },
    toggleShareBarActive: function toggleShareBarActive(value) {
      if (this.shareBarWaitForActive && this.shareBarActive === 'reset') {
        return;
      }

      this.shareBarActive = value || this.$refs.shareButtons.nativeShare ? 'active' : 'hide';
    },
    setArticleList: function setArticleList(list) {
      var _this5 = this;

      return _promise2.default.all((0, _map2.default)(list, function (nid) {
        return _this5.$store.dispatch('fetchNode', { nid: nid });
      })).then(function (_result) {
        _this5.articleList = list;
      });
    },
    fetchArticleList: function fetchArticleList() {
      var _this6 = this;

      var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var liftigniterFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.articleListTid) {
        this.setArticleListTid((0, _get3.default)(this, 'lastSection.tid'));
      }

      if (this.articleListTid === '325779' || this.articleListTid === '325780') {
        this.setArticleListTid((0, _utilities.getNodeQueueTid)('whois_and_whatis'));
      }

      if (!this.noMoreContent && this.articleListTid) {
        var maxOfList = this.articleListLimit;

        if (liftigniterFetch) {
          if (this.articleListOffset === 0) maxOfList -= 1;

          var liftigniterFetchOptions = {
            excludeIds: this.articleList,
            requestFields: ['id']
          };
          var tid = (0, _get3.default)(this, 'articleListTid', '').toString();
          if (!this.fetchNodeBypassSection() && tid !== '325163') {
            if (tid === '325165') {
              liftigniterFetchOptions.section = ['What is', 'Who is'];
            } else if ((0, _get3.default)(this, 'lastSection.name', false)) {
              liftigniterFetchOptions.section = (0, _get3.default)(this, 'lastSection.name', false);
            }
          }
          new _promise2.default(function (resolve) {
            _eventBus2.default.$emit('liftigniter-FetchInventory', maxOfList, liftigniterFetchOptions, resolve);
          }).then(function (nids) {
            var articleList = _this6.articleListCheck(nids, maxOfList);
            if (append) {
              _this6.articleListOffset += maxOfList;
              _this6.appendArticleList(articleList);
            }
          });
        } else {
          this.$store.dispatch('fetchNodeQueueDynamic', { queueName: 'section_top', tid: this.articleListTid, offset: this.articleListOffset, limit: maxOfList }).then(function (nids) {
            var articleList = _this6.articleListCheck(nids, maxOfList);
            if (append) {
              _this6.articleListOffset += maxOfList;
              _this6.appendArticleList(articleList);
            }
          });
        }
      }
    },
    articleListCheck: function articleListCheck(nids, maxOfList) {
      var articleList = (0, _xor2.default)(this.articleList, (0, _values2.default)(nids));

      if (nids.length < maxOfList) {
        this.noMoreContent = true;
      } else {
        this.arrowNext = true;
      }

      return articleList;
    },
    getWrapperRef: function getWrapperRef(nid) {
      return 'articleWrapper-' + nid;
    },
    getBodyCardWrapperRef: function getBodyCardWrapperRef(nid) {
      return 'articleBodyCardWrapper-' + nid;
    },
    getCoverRef: function getCoverRef(nid) {
      return 'articleCover-' + nid;
    },
    getArticleRef: function getArticleRef(nid) {
      return 'articleBody-' + nid;
    },
    getCardChild: function getCardChild(nid) {
      return (0, _get3.default)(this, '$refs[' + this.getCoverRef(nid) + '][0]', false);
    },
    appendArticleList: function appendArticleList(nids) {
      return this.setArticleList((0, _unionBy2.default)(this.articleList, nids, _toInteger2.default));
    },
    slideProgress: function slideProgress(e) {
      this.newsLetterWidgetXPadding = (0, _get3.default)(e, 'deltaX', 0);
      this.toggleMobileHeaderText(false);
    },
    slideChangeEnd: function slideChangeEnd(e) {
      this.scrollEnd = true;
      this.activeBottom = false;
      this.setDesktopReadingPosition(0);
      if ((0, _get3.default)(e, 'response.change')) {
        var carouselSlideCount = (0, _get3.default)(e, 'response.slideCount', 0);
        var carouselCurrentSlide = (0, _get3.default)(e, 'response.activeSlide', 0) + 1;

        if (carouselSlideCount % this.articleListLimit === 0 && carouselCurrentSlide >= carouselSlideCount - 3) {
          this.fetchArticleList(true, this.fetchNodeQueueFromLiftigniter);
        }

        this.videoPlayerEnd(false, true);

        if (this.nextBybottom) {
          this.articleWrapper.scrollTop = 0;
          this.lastPosition[this.activeNID] = 0;
        } else {
          if (!this.inCard) {
            this.shareBarWaitForActive = true;
            this.shareBarNoAnimation = true;
            this.shareBarActive = 'hide';
          } else {
            this.shareBarNoAnimation = false;
            this.toggleShareBarActive(true);
          }
          this.lastPosition[this.activeNID] = this.articleWrapper.scrollTop;
        }

        this.showTopCover = true;
        this.triggerTopCover();
        this.setActiveNID(this.articleList[e.response.activeSlide]);
        this.actionOnCardCoverPerpareNextAnimation();
        this.updateRoute();
        this.resetShareBar();

        this.arrowNext = this.hasNext();

        if (!this.nextBybottom && !(0, _utilities.isDesktop)()) {
          var lastPos = this.lastPosition[this.activeNID];
          if (!lastPos) {
            this.resetMobileHeader();
            return;
          }
          this.inCard = false;

          var shareBar = this.articleBody[0].$el.getElementsByClassName('share-toolbar')[0];
          var shareBarScrollTop = shareBar.getBoundingClientRect().top + shareBar.style.height;

          if (!lastPos > shareBarScrollTop) {
            this.showMiniHeader();
            this.showTopCover = false;

            this.toggleShareBarActive(true);
          } else {
            this.showHeaderText();
            this.showTopCover = false;
          }
        } else {
          this.inCard = true;
        }

        this.cardCoverAfterDragIn();

        this.nextBybottom = false;
        if ((0, _utilities.isDesktop)()) {
          this.lastPosition[this.activeNID] = 0;
          this.arrowPrev = this.hasPrev();
          this.resetArrow();
        }
      } else {
        this.shareBarAndHeaderBarToggle(false);
        if (!this.showTopCover) {
          this.inCard = false;
        } else {
          this.inCard = true;
        }
      }
      this.slideChanging = false;
    },
    updateRoute: function updateRoute() {
      var _this7 = this;

      this.$store.dispatch('fetchNode', { nid: this.activeNID }).then(function () {
        var activeNode = _this7.$store.getters.node(_this7.activeNID);
        var routeData = {
          type: activeNode.type,
          nid: activeNode.nid,
          url: activeNode.relative_url,
          title: activeNode.title,

          props: {
            nid: activeNode.nid
          }
        };
        _this7.$router.addRouteByNode({ routeData: routeData });
        _this7.$router.push(routeData.url);
        _this7.cardCoverAfterDragIn();
      });
    },
    slideChangeStart: function slideChangeStart(e) {
      if (this.nextBybottom) this.cardActionAnimate = true;
      this.slideChanging = true;
      this.disableCardAnimate = true;

      if ((0, _utilities.isDesktop)()) {
        this.bodyFadeIn = true;
      }
      this.arrowVisible = false;

      if (this.nextBybottom) {
        this.toggleShareBarActive(false);
        _gtmManager2.default.pushTracker({
          category: 'Perpetual Scroll',
          action: (0, _get3.default)(this, 'node.relative_url', ''),
          label: (0, _get3.default)(this, 'nodes[' + this.articleList[e.response.activeSlide] + '].relative_url', '')
        });
      }
    },
    handleTouchStart: function handleTouchStart(e) {
      window.scrollTo(0, 0);

      this.touchStartX = e.changedTouches[0].clientX;
      this.touchStartY = e.changedTouches[0].clientY;
      this.touching = true;
      this.touchTimeStamp = e.timeStamp;
      this.bounce = false;
      this.bottomCardReset = false;
      this.bounceBottom = false;
      this.newsLetterWidgetXPadding = 0;
      this.cardReset = false;
    },
    toggleTopCover: function toggleTopCover() {
      var articleBody = (0, _get3.default)(this, 'articleBody[0]', false);
      if ((0, _utilities.isDomElement)(articleBody.$el) && this.articleWrapper.scrollTop > articleBody.$el.offsetTop && !(0, _utilities.isDesktop)()) {
        this.showTopCover = false;
      }
    },
    handleTouchMove: function handleTouchMove(e) {
      var moveDistanceY = e.changedTouches[0].clientY - this.touchStartY;
      var moveDistanceX = e.changedTouches[0].clientX - this.touchStartX;
      if (!this.sliderOptions.setScrolling) {
        this.sliderOptions.setScrolling = true;
        if (Math.abs(moveDistanceY) > Math.abs(moveDistanceX)) {
          this.sliderOptions.childScrolling = true;
        } else {
          this.sliderOptions.childScrolling = !this.scrollEnd;
        }
        this.sliderOptions.childProcessed = (!this.bottomDividerOnScreen() || !this.nextArticleCover) && !this.isVideoFullScreen;
        this.sliderOptions.forceStop = this.bottomDividerOnScreen() && this.nextArticleCover;
      }
      if (!this.sliderOptions.childScrolling && !this.bottomCardOnScreen()) this.newsLetterWidgetXPadding = moveDistanceX;

      if (this.sliderOptions.childScrolling) {
        if (moveDistanceY > 0 && this.articleWrapper.scrollTop <= 0) {
          e.preventDefault();
        }

        if (this.showTopCover && this.articleCover) {
          if (!(0, _isEmpty2.default)(this.articleCover)) {
            if (moveDistanceY > 0) {
              if ((0, _get3.default)(this, 'articleCover[0].$el')) {
                if (!(0, _utilities.isDesktop)()) this.cardMargintop = (moveDistanceY + this.articleWrapper.scrollTop) / this.articleCover[0].$el.offsetHeight * 100 - this.viewPortHeightVh;
                this.inCard = false;
              }
            }
          } else {
            if (moveDistanceY > 0) {
              this.allowHeaderToggle = true;
            }
            this.inCard = true;
            this.cardMargintop = 0;
          }

          if (moveDistanceY > 0) {
            var absMoveDistance = Math.abs(moveDistanceY);
            this.toggleHeaderBar({ position: 50 - absMoveDistance / this.innerHeight() * 100, animate: false });
          }
        } else {
          if (moveDistanceY > 0) {
            this.allowHeaderToggle = true;
          }

          this.reachTopBottom = moveDistanceY < 0 && this.checkAtBottom();
        }
      }
      this.toggleTopCover();
    },
    handleTouchEnd: function handleTouchEnd(e) {
      this.reachTopBottom = false;
      if (this.scrollEnd) {
        this.sliderOptions.childProcessed = false;
        this.sliderOptions.setScrolling = false;
        this.sliderOptions.childScrolling = false;
        this.newsLetterWidgetXPadding = 0;
      }

      this.touching = false;

      var speed = (this.touchStartY - e.changedTouches[0].clientY) / (this.touchTimeStamp - e.timeStamp);

      if (this.showTopCover && this.articleCover) {
        this.cardReset = true;
        if ((Math.abs(this.cardMargintop) < 80 || speed > 0.6) && !this.isVideoFullScreen) {
          this.triggerTopCover();
        } else if (this.touchStartY - e.changedTouches[0].clientY < 0) {
          this.bouceBackToBodyTop();
        } else {
          this.topCovertoBody();
        }
      } else if (!this.showTopCover && this.articleWrapper.scrollTop === 0) {
        this.showTopCover = true;
        this.atTop = true;
        this.topCovertoBody();
        if (!(0, _utilities.isIOS)()) {
          this.bounce = true;
        }
      } else if (this.nextCard && this.nextArticleCover) {
        if (!this.checkAtBottom()) {
          this.resetBottomCover();
        }

        this.bottomCardReset = true;
        if (Math.abs(this.bodyMarginTop) > 40 || speed < -0.6) {
          this.nextBybottom = true;
          this.bodyMarginTop = -100;
          this.atTop = false;
          this.showTopCover = true;
          this.triggerTopCover();
          this.actionOnCardCoverAnimation();
          this.bounce = false;
          this.cardReset = false;
        } else {
          this.bodyMarginTop = 0;
        }
      } else if (this.hasNext() && this.checkAtBottom()) {
        this.activeBottomCover();
      }
    },
    showArrow: function showArrow() {
      return (!(0, _get3.default)(this, 'articleCover[0].$el') || this.articleWrapper.scrollTop > this.articleCover[0].$el.offsetHeight) && (0, _utilities.isDesktop)();
    },
    handleArrowFadeOut: function handleArrowFadeOut() {
      if ((0, _utilities.isDesktop)()) {
        var articleWrapperOffsetHeight = (0, _get3.default)(this, 'articleCover[0].$el.offsetHeight');
        var bodyWrapperOffsetHeight = (0, _get3.default)(this, 'articleBodyCardWrapper[0].offsetHeight');
        var monsterNewsletterHeight = (0, _get3.default)(this, '$refs.monsterNewsletter[0].$el.offsetHeight', 0);
        if (this.bottomCardOnScreen() && articleWrapperOffsetHeight && bodyWrapperOffsetHeight) {
          var wrapperScrollPos = articleWrapperOffsetHeight + bodyWrapperOffsetHeight - (0, _get3.default)(this, 'articleWrapper.scrollTop', 0);
          if (articleWrapperOffsetHeight >= window.innerHeight) {
            wrapperScrollPos -= articleWrapperOffsetHeight - window.innerHeight;
          }
          wrapperScrollPos -= monsterNewsletterHeight;
          var arrowPos = window.innerHeight + 190;
          if (wrapperScrollPos <= arrowPos) {
            var arrowTopMarginTotal = Math.abs(window.innerHeight - arrowPos);
            var crossArrowPos = arrowPos - wrapperScrollPos;
            var newArrowTopPercentage = (arrowTopMarginTotal - crossArrowPos - 70) * 0.0625 + 'rem';
            this.newArrowTopPercentage = { top: '' + newArrowTopPercentage };
          } else {
            this.newArrowTopPercentage = {};
          }
        }
      }
    },
    resetArrow: function resetArrow() {
      this.newArrowTopPercentage = {};
      this.arrowInit = false;
    },
    handleWheel: function handleWheel(e) {
      e.preventDefault();
    },
    handleScroll: function handleScroll(e) {
      var _this8 = this;

      if (!this.firstScrollTimeStamp && !this.firstScrollPos) {
        this.firstScrollTimeStamp = e.timeStamp;
        this.firstScrollPos = (0, _get3.default)(this, 'articleWrapper.scrollTop', 0);
      } else {
        var timestampDiff = e.timeStamp - this.firstScrollTimeStamp;
        var posDiff = (0, _get3.default)(this, 'articleWrapper.scrollTop', 0) - this.firstScrollPos;
        this.touchSpeed = posDiff / timestampDiff;
      }
      this.scaleBottomCard();
      clearTimeout(this.scrollTimer);
      this.scrollEnd = false;
      this.scrollTimer = setTimeout(function () {
        _this8.scrollEnd = true;
        _this8.sliderOptions.setScrolling = false;
        _this8.firstScrollTimeStamp = false;
        _this8.firstScrollPos = false;
        _this8.touchSpeed = false;
      }, 100);

      var currentScrollY = (0, _get3.default)(this, 'articleWrapper.scrollTop', 0);

      if ((0, _utilities.isDesktop)()) {
        if (!this.slideChanging) {
          if ((0, _get3.default)(this, '$refs.articleArrowLeft', false)) {
            if (this.showArrow()) {
              this.hoverCover = false;
              this.arrowVisible = this.showArrow();
              this.arrowInit = this.showArrow();
              if ((0, _utilities.isDomElement)(this.$refs.articleArrowLeft)) this.$refs.articleArrowLeft.style.top = '';
              if ((0, _utilities.isDomElement)(this.$refs.articleArrowRight)) this.$refs.articleArrowRight.style.top = '';
            } else {
              this.arrowVisible = this.hoverCover;
              if (this.hoverCover) {
                this.setCoverArrowsPosition();
              }
            }
            this.handleArrowFadeOut();
          }
        }
      }

      if (currentScrollY > this.articleScrollY) {
        this.allowHeaderToggle = true;
      }

      this.shareBarAndHeaderBarToggle();
      this.sliderOptions.childScrolling = true;
      if (this.hasNext && this.checkAtBottom()) {
        this.activeBottomCover();
      }

      if (!this.touching) {
        var articleBody = (0, _get3.default)(this, 'articleBody[0]', false);


        if (!this.showTopCover && articleBody && this.articleWrapper.scrollTop === articleBody.$el.offsetTop) {
          this.atTop = true;
          this.showTopCover = true;
          this.topCovertoBody();
          if (!(0, _utilities.isIOS)()) {
            this.bounce = true;
          }
          this.cardReset = false;
        } else if (articleBody) {
          this.atTop = false;
          this.bounce = false;

          this.resetBottomCover();
        }
      }

      this.articleScrollY = currentScrollY;

      if ((0, _utilities.isDesktop)()) {
        if (this.articleWrapper.scrollTop < 200) {
          this.toggleHeaderTitle(true);
          this.updateDesktopHeaderTitlePosiiton(Math.abs(this.articleWrapper.scrollTop) * -1);
        } else {
          this.toggleHeaderTitle(false);
        }
      }
      this.toggleTopCover();
    },
    bindTopCoverTouchSupport: function bindTopCoverTouchSupport() {
      var _this9 = this;

      if ((0, _utilities.isDesktop)() && (0, _utilities.isTablet)()) return;

      var self = this;

      if ((0, _get3.default)(self, 'articleCover[0].$el') && !(0, _get3.default)(self, 'articleCover[0].$hammer')) {
        var Hammer = __webpack_require__(1055);

        self.articleCover[0].$hammer = new Hammer.Manager(self.articleCover[0].$el, {
          recognizers: [[Hammer.Pan, { direction: Hammer.DIRECTION_ALL }]]
        });

        self.articleCover[0].$hammer.on('panstart', function (e) {
          self.preventPan = self.cardMargintop !== 0;
          if (self.preventPan) return;
          if (!self.showTopCover) return;
          self.sliderOptions.childScrolling = e.additionalEvent === 'panup';
          if (!self.scrollEnd) self.sliderOptions.childScrolling = true;
          self.cardReset = false;
          self.touchStartY = e.center.y;
        });

        self.articleCover[0].$hammer.on('panmove', function (e) {
          if (!(0, _utilities.isDesktop)()) {
            if (self.preventPan) return;
            if (!_this9.showTopCover) return;
            if (!_this9.isVideoFullScreen && !self.sliderOptions.setScrolling) {
              self.sliderOptions.setScrolling = true;
              if (e.additionalEvent === 'panup' || e.additionalEvent === 'pandown') {
                self.sliderOptions.childScrolling = e.additionalEvent === 'panup' || e.additionalEvent === 'pandown' && e.angle >= 80 && e.angle <= 100;
              } else {
                self.sliderOptions.childScrolling = !(e.additionalEvent === 'pandown' && e.angle >= 80 && e.angle <= 100) ? false : !self.scrollEnd;
              }
              self.sliderOptions.childProcessed = true;
            }
            if (self.sliderOptions.childScrolling && (0, _get3.default)(self, 'articleCover[0].$el', false)) {
              var move = Math.round((e.center.y - self.touchStartY + self.articleWrapper.scrollTop) / self.articleCover[0].$el.offsetHeight * 100);
              if (move <= 0) {
                self.toggleHeaderBar({
                  position: Math.min(100, Math.abs(move)) * 50 / 100,
                  animate: true,
                  lock: false
                });
                self.cardMargintop = move;
              } else if (self.allowSwipePrevCard && self.prevArticleNID) {
                self.prevCardMargintop = self.viewportHeight * -1 + e.deltaY;
                self.cardMargintop = 0;
              }
            }
          }
        });

        self.articleCover[0].$hammer.on('panend', function (e) {
          if (!(0, _utilities.isDesktop)()) {
            if (self.preventPan) return;
            if (!_this9.showTopCover) return;
            self.sliderOptions.childProcessed = false;
            self.sliderOptions.setScrolling = false;
            self.scrollEnd = false;
            if (self.sliderOptions.childScrolling) {
              self.cardReset = true;
              var triggerPointOfBackToCard = 100 * 0.10;
              if ((Math.abs(self.cardMargintop) > triggerPointOfBackToCard || e.additionEvent === 'panup' && e.velocityY < -0.8) && !(0, _utilities.isDesktop)()) {
                self.prevCardMargintop = self.viewportHeight * -1;
                if (self.cardCoverIsVideo && self.scaleHeaderBar <= 0) {
                  self.topCovertoBody();
                } else if (Math.abs(self.cardMargintop) <= 100) {
                  self.topCovertoBody();
                }
              } else if (!(0, _utilities.isDesktop)() && self.allowSwipePrevCard && self.prevArticleNID && (e.deltaY / self.viewportHeight > 0.2 || e.velocityY > 0.8 && e.deltaY > 0)) {
                self.prevCardMargintop = (self.viewportHeight - self.viewportHeight * (self.viewPortHeightVh / 100)) * -1;
                self.lastPosition[self.prevArticleNID] = 0;
                setTimeout(function () {
                  self.$refs.cusCarousel.prev(false);
                }, 350);
              } else {
                self.triggerTopCover();
              }
              setTimeout(function () {
                self.preventPan = false;
              }, 400);
            }
          } else {
            self.sliderOptions.childProcessed = true;
          }
        });
      }
    },
    bindVidoeCardConatinerTouchSupport: function bindVidoeCardConatinerTouchSupport() {
      if (!(0, _utilities.isDesktop)()) {
        var videoCardContainer = (0, _get3.default)(this, 'cardVideoContainer[0]', false);
        if (videoCardContainer && !(0, _get3.default)(videoCardContainer, 'touchInit', false)) {
          videoCardContainer.touchInit = true;
          var passive = (0, _utilities.supportPassive)() ? { passive: true } : false;
          videoCardContainer.addEventListener('touchstart', this.handleTouchStart, passive);
          videoCardContainer.addEventListener('touchmove', this.handleTouchMove);
          videoCardContainer.addEventListener('touchend', this.handleTouchEnd, passive);
        }
      }
    },
    bindBodyTouchSupport: function bindBodyTouchSupport() {
      var articleBody = (0, _get3.default)(this, 'articleBody[0]', false);
      if (articleBody && !(0, _get3.default)(articleBody, 'touchInit', false)) {
        articleBody.touchInit = true;
        var passive = (0, _utilities.supportPassive)() ? { passive: true } : false;
        if ((0, _get3.default)(this, '$root.appBrowser') === 'safari' && (0, _get3.default)(this, '$root.appOs') === 'macOs') {
          this.articleWrapper.addEventListener('scroll', (0, _throttle2.default)(this.handleScroll, 300), passive);
        } else {
          this.articleWrapper.addEventListener('scroll', this.handleScroll, passive);
        }
        articleBody.$el.addEventListener('touchstart', this.handleTouchStart, passive);
        articleBody.$el.addEventListener('touchmove', this.handleTouchMove);
        articleBody.$el.addEventListener('touchend', this.handleTouchEnd, passive);
      }
    },
    bindBottomCoverTouchSupport: function bindBottomCoverTouchSupport() {
      var articleWrapper = (0, _get3.default)(this, '$refs.articleBottomCardWrapper[0]', false);
      if (articleWrapper && !(0, _get3.default)(articleWrapper, 'touchInit', false)) {
        articleWrapper.touchInit = true;
        var passive = (0, _utilities.supportPassive)() ? { passive: true } : false;
        articleWrapper.addEventListener('touchstart', this.handleTouchStart, passive);
        articleWrapper.addEventListener('touchmove', this.handleTouchMove);
        articleWrapper.addEventListener('touchend', this.handleTouchEnd, passive);
      }
    },
    checkAtBottom: function checkAtBottom() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var articleBody = this.articleBody;
      var articleBodyWrapperOffsetHeight = (0, _get3.default)(this, 'articleBodyCardWrapper[0].offsetHeight', 0);
      var articleCoverWrapperOffsetHeight = (0, _get3.default)(this, 'articleCover[0].$el.offsetHeight', 0);
      var articleWrapperScrollTop = (0, _get3.default)(this, 'articleWrapper.scrollTop', 0);
      if ((0, _utilities.isDesktop)()) {
        if (articleBodyWrapperOffsetHeight + articleCoverWrapperOffsetHeight - articleWrapperScrollTop <= document.body.clientHeight) {
          return true;
        }
      } else {
        var diffOfBodyAndArticleWrapper = articleBodyWrapperOffsetHeight - articleWrapperScrollTop;
        if (!(0, _utilities.isIOS)()) {
          if (this.articleBodyCardWrapper && diffOfBodyAndArticleWrapper === document.body.clientHeight) {
            return true;
          }
          if (this.touching && this.nextCard && diffOfBodyAndArticleWrapper - offset >= document.body.clientHeight) {
            return true;
          }
        } else {
          var height = document.body.clientHeight === this.articleWrapper.offsetHeight ? document.body.clientHeight : window.innerHeight;
          if (articleBody && this.articleBodyCardWrapper && diffOfBodyAndArticleWrapper === height) {
            return true;
          }
          if (this.touching && this.nextCard && diffOfBodyAndArticleWrapper - offset >= height) {
            return true;
          }
        }
        return false;
      }
      return false;
    },
    resetBottomCover: function resetBottomCover() {
      this.bodyMaxHeight = 'auto';
      this.bodyMarginTop = 0;
      this.nextCard = false;
      this.bounceBottom = false;
    },
    activeBottomCover: function activeBottomCover() {
      var _this10 = this;

      if (this.isCardMounted && this.isBodyMounted && this.showBottomCover && this.allowNextByBottom && this.hasNext()) {
        if (this.showNodeBody) {
          this.isCardMounted = false;
          this.isBodyMounted = false;
          if (!this.listenWheel) {
            this.$refs.articlePage.addEventListener('wheel', this.handleWheel);
            this.listenWheel = true;
          }

          setTimeout(function () {
            if (_this10.videoCard && (0, _isFunction2.default)(_this10.videoCard.resetCardVideo)) _this10.videoCard.resetCardVideo();
            _this10.preventScroll = true;
            _this10.pageScroll = false;
            if ((0, _utilities.isDesktop)()) _this10.showNodeBody = false;
            _this10.sliderOptions.childScrolling = true;
            _this10.bottomCardReset = true;
            _this10.bodyMaxHeight = (0, _get3.default)(_this10, 'articleBodyCardWrapper[0].offsetHeight', 0) + 'px';
            if (_this10.nextArticleCover) _this10.nextBybottom = true;
            if ((0, _has2.default)(_this10.$refs, 'cusCarousel.next')) _this10.$refs.cusCarousel.next(false);
            _this10.nextCard = true;
            if (!(0, _utilities.isIOS)()) {
              _this10.bounceBottom = true;
            }
          }, 0);

          setTimeout(function () {
            _this10.pageScroll = true;
            _this10.showNodeBody = true;
            if ((0, _get3.default)(_this10, 'articleWrapper.classList')) _this10.preventScroll = false;
            if ((0, _get3.default)(_this10, '$refs.articlePage')) _this10.$refs.articlePage.removeEventListener('wheel', _this10.handleWheel);
            _this10.listenWheel = false;
          }, 1200);
        }
      }
    },
    topCovertoBody: function topCovertoBody() {
      var _this11 = this;

      if (this.showTopCover) {
        this.allowHeaderToggle = true;
        this.lastPosition = {};
        this.cardReset = true;
        this.inCard = false;
        this.shareBarNoAnimation = false;
        setTimeout(function () {
          _this11.scrollEnd = true;
        }, 300);
        this.cardMargintop = this.viewPortHeightVh * -1;
        this.showHeaderText();

        _gtmManager2.default.pushTracker({
          category: 'Scroll Card',
          action: 'Scroll Card/Scroll down',
          label: 'Scroll Card'
        });
      }
    },
    bouceBackToBodyTop: function bouceBackToBodyTop() {
      var _this12 = this;

      this.allowHeaderToggle = true;
      this.lastPosition = {};
      setTimeout(function () {
        _this12.inCard = false;
      }, 300);
      this.cardMargintop = this.viewPortHeightVh * -1;
      this.toggleHeaderBar({ position: 50 });
    },
    triggerTopCover: function triggerTopCover() {
      this.cardCoverAfterDragIn(true);
      this.inCard = true;
      this.cardMargintop = 0;
      this.cardAnimate = true;

      this.prevCardMargintop = this.viewportHeight * -1;
      this.resetMobileHeader();

      if (!this.disableCardAnimate) {
        this.actionOnCardCoverAnimation();
      } else {
        this.disableCardAnimate = false;
      }
      this.cardAnimate = false;
    },
    remainPosition: function remainPosition(nid) {
      if ((0, _get3.default)(this, 'lastPosition[' + nid + ']') > 0 && !(0, _utilities.isDesktop)()) {
        return true;
      }
      return false;
    },
    playVideo: function playVideo(isFullScreen) {
      if (!(0, _isEmpty2.default)(this.videoCard)) (0, _get3.default)(this, 'videoCard.playVideo')(isFullScreen);
    },
    hideVideo: function hideVideo() {
      this.isShowVideo[this.activeNID] = false;
    },
    stopVideo: function stopVideo() {
      if (!(0, _isEmpty2.default)(this.videoCard)) (0, _get3.default)(this, 'videoCard.stopVideo')();
    },
    videoPlayerEnd: function videoPlayerEnd(toBody, stopVideo) {
      var cardCover = this.getCardChild(this.activeNID);
      if (cardCover) {
        if ((0, _utilities.isDesktop)()) {
          this.isShowVideo[this.activeNID] = false;
          this.showVideoPlayButton = true;
        }
        if (stopVideo) this.stopVideo();
      }
      if (toBody) this.topCovertoBody();
    },
    cardCoverAfterDragIn: function cardCoverAfterDragIn(fromArticleBody) {
      if (this.cardCoverIsVideo) {
        if ((0, _utilities.isDesktop)()) {
          this.isShowVideo[this.activeNID] = false;
          this.showVideoPlayButton = true;
        } else {
          this.isShowVideo[this.activeNID] = true;
          this.showVideoPlayButton = true;
          if (fromArticleBody) this.stopVideo();
        }
      } else {
        this.isShowVideo[this.activeNID] = false;
      }
    },
    actionOnCardCoverAnimation: function actionOnCardCoverAnimation() {
      var cardCover = this.getCardChild(this.activeNID);
      if (cardCover) {
        cardCover.showCardAnimation();
      }
    },
    actionOnCardCoverPerpareNextAnimation: function actionOnCardCoverPerpareNextAnimation() {
      var cardCover = this.getCardChild(this.activeNID);
      if (cardCover) {
        cardCover.hideAnimationElement();
      }
    },
    actionOnVideoFullScreen: function actionOnVideoFullScreen(event) {
      if (!(0, _get3.default)(event, 'isDesktop', false) && (0, _get3.default)(event, 'isPreviousFullScreen') && !(0, _get3.default)(event, 'isFullScreen')) {
        this.videoPlayerEnd(true, false);
        this.isVideoFullScreen = false;
        this.sliderOptions.childProcessed = true;
        this.sliderOptions.showAnimation = undefined;
      } else {
        this.sliderOptions.showAnimation = false;
        this.sliderOptions.childProcessed = false;
        this.isVideoFullScreen = true;
        this.enableLandscapeBlock(false);
      }
    },
    actionOnVideoIdle: function actionOnVideoIdle(event) {
      if ((0, _get3.default)(event, 'isDesktop', false)) {
        this.hideVideoOnDesktop((0, _get3.default)(event, 'isOnComplete', false));
      } else {
        this.videoPlayerEnd(false);
      }
    },
    actionOnVideoPause: function actionOnVideoPause(event) {
      if (!(0, _get3.default)(event, 'isDesktop', false)) {
        this.videoPlayerEnd(false);
      }
    },
    actionOnVideoPlay: function actionOnVideoPlay() {
      this.isShowVideo[this.activeNID] = true;
      if ((0, _utilities.isDesktop)()) {
        this.showVideoPlayButton = false;
        this.hideVideoPromise = undefined;
        this.actionOnCardCoverPerpareNextAnimation();
      }
    },
    hideVideoOnDesktop: function hideVideoOnDesktop(delay) {
      var _this13 = this;

      if (!this.hideVideoPromise) {
        var handleCardAnimation = function handleCardAnimation() {
          _this13.actionOnCardCoverAnimation();
          var cardCover = _this13.getCardChild(_this13.activeNID);
          if (cardCover) {
            _this13.isShowVideo[_this13.activeNID] = false;
            _this13.showVideoPlayButton = true;
          }
        };

        if (delay) {
          this.hideVideoPromise = new _promise2.default(function (resolve) {
            setTimeout(function () {
              if (_this13.hideVideoPromise) {
                handleCardAnimation();
                resolve(true);
              }
            }, 2000);
          });
          this.hideVideoPromise.then(function () {
            _this13.hideVideoPromise = undefined;
          });
        } else {
          handleCardAnimation();
        }
      }
    },
    actionOnVideoHide: function actionOnVideoHide() {
      this.hideVideoOnDesktop(false);
    },
    bottomCardOnScreen: function bottomCardOnScreen() {
      var articleCoverOffsetHeight = (0, _get3.default)(this, 'articleCover[0].$el.offsetHeight', 0);
      var articleBodyCardWrapperOffsetHeight = (0, _get3.default)(this, 'articleBodyCardWrapper[0].offsetHeight', 0);
      if ((0, _utilities.isDesktop)()) {
        var calScroll = articleCoverOffsetHeight + articleBodyCardWrapperOffsetHeight - (0, _get3.default)(this, 'articleWrapper.scrollTop', 0);
        if (articleCoverOffsetHeight >= window.innerHeight) {
          calScroll -= articleCoverOffsetHeight - window.innerHeight;
        }
        if ((0, _get3.default)(this, 'articleCover[0].$el') && calScroll < window.innerHeight * 2) {
          return true;
        }
      } else {
        if (articleBodyCardWrapperOffsetHeight - (0, _get3.default)(this, 'articleWrapper.scrollTop', 0) < window.innerHeight * 2) {
          return true;
        }
        return false;
      }
      return false;
    },
    bottomDividerOnScreen: function bottomDividerOnScreen() {
      var bottomDivider = (0, _get3.default)(this, '$refs.bottomDivider[0]');
      if ((0, _utilities.isDomElement)(bottomDivider)) {
        return bottomDivider.getBoundingClientRect().top < window.innerHeight;
      }
      return false;
    },
    scaleBottomCard: function scaleBottomCard() {
      if ((0, _utilities.isDesktop)()) return;
      if (this.bottomDividerOnScreen()) this.sliderOptions.forceStop = true;
      var bottomCardRef = this.getCoverRef(this.nextArticleNID);
      var bottomCardHeight = (0, _get3.default)(this, '$refs[' + bottomCardRef + '][0].$el.offsetHeight');
      if (this.showBottomCover && this.bottomCardOnScreen() && bottomCardHeight) {
        this.allowNextByBottom = true;
        var articleBodyCardWrapperOffsetHeight = (0, _get3.default)(this, 'articleBodyCardWrapper[0].offsetHeight', 0);
        var calScale = this.initBottomCardScale + (1 - Math.abs(articleBodyCardWrapperOffsetHeight - (0, _get3.default)(this, 'articleWrapper.scrollTop', 0) - window.innerHeight) / window.innerHeight) * (1 - this.initBottomCardScale);
        this.bottomCardScale = calScale <= 1 ? calScale : 1;

        if (/Android/.test(navigator.appVersion)) this.bottomCardSmoothAnimate = true;
      }
      if (this.checkAtBottom()) this.showBottomCover = true;
    },
    resetscaleBottomCard: function resetscaleBottomCard() {
      if (!(0, _utilities.isDesktop)()) {
        this.showBottomCover = false;
        this.allowNextByBottom = false;
        this.bottomCardScale = 0.3;
        this.bottomCardSmoothAnimate = false;
        this.firstScrollTimeStamp = false;
        this.firstScrollPos = false;
        this.touchSpeed = false;
      } else {
        this.showBottomCover = true;
        this.allowNextByBottom = true;
        this.bottomCardScale = 1;
      }
    },
    videoAutoStart: function videoAutoStart() {
      return (0, _utilities.isDesktop)();
    },
    handleViewportChange: function handleViewportChange() {
      window.addEventListener('resize', this.viewportChangeHandler);
    },
    prevArticle: function prevArticle() {
      this.nextPrevByArrow = true;
      if ((0, _has2.default)(this.$refs, 'cusCarousel.prev')) this.$refs.cusCarousel.prev(true);
      this.resetDesktopHeader();
      if (this.videoCard) this.videoCard.resetCardVideo();
    },
    nextArticle: function nextArticle() {
      this.nextPrevByArrow = true;
      if ((0, _has2.default)(this.$refs, 'cusCarousel.next')) this.$refs.cusCarousel.next(true);
      this.resetDesktopHeader();
      if (this.videoCard) this.videoCard.resetCardVideo();
    },
    cardMounted: function cardMounted(nid) {
      if (nid === this.activeNID) {
        if (!(0, _utilities.isDesktop)()) this.resetscaleBottomCard();
        if (this.cardActionAnimate) {
          this.getCardChild(this.activeNID).cardActionAnimate();
        }
        this.sliderOptions.forceStop = false;
        this.isCardMounted = true;
        var cardCover = this.getCardChild(this.activeNID);
        if (cardCover) this.bottomBlankSpace = !(cardCover.$el.offsetHeight > this.viewportHeight);
        if (cardCover) this.bindAnimation(cardCover.$el, [this.checkCardReset]);
        (0, _utilities.unbindInputForAndroid)(this.articleWrapper);
        (0, _utilities.bindInputForAndroid)(this.articleWrapper);
        this.allowHeaderToggle = false;
        if (this.showTopCover && (0, _get3.default)(this, '$refs[' + this.getCoverRef(this.activeNID) + '][0].$el')) {
          this.bindTopCoverTouchSupport();
          this.bindBodyTouchSupport();
          this.bindBottomCoverTouchSupport();
          this.bindVidoeCardConatinerTouchSupport();
        }

        if (this.scrollToTopFlag) {
          this.scrollToTopFlag = false;

          if ((0, _get3.default)(this, 'articleWrapper.scrollTop', false)) {
            this.articleWrapper.scrollTop = 0;
          }
        }
      }
    },
    bodyMounted: function bodyMounted() {
      this.isBodyMounted = true;
    },
    resetArticleView: function resetArticleView() {
      this.showTopCover = true;
      this.$refs.cusCarousel.goTo(0);
      this.triggerTopCover();
      this.resetDesktopHeader();
      this.resetMobileHeader();
      this.arrowNext = this.articleList > 0;
      this.scrollToTopFlag = true;
    },
    hasNext: function hasNext(nid) {
      if (!nid) {
        return (0, _indexOf2.default)(this.articleList, this.activeNID) + 1 < this.articleList.length;
      }
      return (0, _indexOf2.default)(this.articleList, nid) + 1 < this.articleList.length;
    },
    hasPrev: function hasPrev(nid) {
      if (!nid) {
        return (0, _indexOf2.default)(this.articleList, this.activeNID) + 1 > 1;
      }
      return (0, _indexOf2.default)(this.articleList, nid) + 1 > 1;
    },
    refreshToRoutedArticle: function refreshToRoutedArticle(routeNid, routeTid) {
      var _this14 = this;

      if (routeNid) {
        this.noMoreContent = false;
        this.$store.dispatch('fetchNode', { nid: routeNid }).then(function () {
          _this14.setActiveNID(routeNid);
          _this14.articleListOffset = 0;
          _this14.articleList = [routeNid];

          if (routeTid && routeTid !== _this14.articleListTid) {
            _this14.$store.commit('setArticleListTid', routeTid);
          }

          _this14.fetchArticleList(true, _this14.fetchNodeQueueFromLiftigniter);
          _this14.resetArticleView();
        });
      }
    }
  }),
  watch: {
    articleList: function articleList() {
      if (!this.sliderOptions.initFromMount) {
        this.sliderOptions.initFromMount = true;
        this.$refs.cusCarousel.init();
      }
    },
    sections: function sections() {
      this.setHeaderTitle((0, _get3.default)(this, 'firstSectionLineage', []));
    },
    $route: function $route() {
      var routeProps = (0, _get3.default)(this, '$route.matched[0].props.default', {});
      var routeNid = (0, _get3.default)(routeProps, 'nid', false);
      var routeTid = (0, _get3.default)(routeProps, 'destinationTid', false);

      if (this.isRefreshedToRoutedArticle) {
        this.$store.commit('setIsRefreshedToRoutedArticle', false);
        this.refreshToRoutedArticle(routeNid, this.articleListTid ? this.articleListTid : routeTid);
        return;
      }

      if (routeNid && this.node.nid !== routeNid) {
        var oldArticleIndex = (0, _indexOf2.default)(this.articleList, this.node.nid);
        var articleIndex = (0, _indexOf2.default)(this.articleList, routeNid);

        if (articleIndex !== -1) {
          var isAnimated = Math.abs(articleIndex - oldArticleIndex) === 1;
          this.$refs.cusCarousel.goTo(articleIndex, isAnimated);
          this.resetDesktopHeader();
          this.$refs.cusCarousel.updateSlideCount();
        } else {
          this.refreshToRoutedArticle(routeNid, routeTid);
        }
      }
      _eventBus2.default.$emit('liftigniter-ResetPageview');
    }
  },
  beforeDestroy: function beforeDestroy() {
    (0, _utilities.unbindInputForAndroid)(this.articleWrapper);
  },
  destroyed: function destroyed() {
    if (this.allowNewsletterWidgetPopup) {
      this.enableNewsletterWidgetPopup(false);
    }
    window.removeEventListener('resize', this.viewportChangeHandler);
    this.setArticleListTid(false);
    this.resetDesktopHeader();
    this.resetMobileHeader();
  }
};

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _icon_cancel = __webpack_require__(369);

var _icon_cancel2 = _interopRequireDefault(_icon_cancel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    SvgCancelIcon: _icon_cancel2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['allowNewsletterWidgetPopup'])),
  data: function data() {
    return {
      closePopUp: false
    };
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleNewsletter', 'enableNewsletterWidgetPopup']), {
    closeNewsletter: function closeNewsletter() {
      this.toggleNewsletter();
      this.enableNewsletterWidgetPopup(false);
    }
  })
};

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(351);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _drop = __webpack_require__(1649);

var _drop2 = _interopRequireDefault(_drop);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    articleTitle: {
      type: String
    },
    theme: {
      type: String,
      default: 'desktop'
    }
  },
  data: function data() {
    return {
      items: [],
      galleryItems: []
    };
  },
  mounted: function mounted() {
    this.initFullScreen();
    this.openFromBeginning();
  },

  methods: {
    openFromBeginning: function openFromBeginning() {
      var getPhotoFromUrl = (0, _get2.default)(this, '$route.fullPath').match(/(gallery)\/(\d{1,2})\/?/);
      if (getPhotoFromUrl && (0, _utilities.isDomElement)((0, _get2.default)(this, '$refs.galleryContainer'))) {
        var photos = this.$refs.galleryContainer.querySelectorAll('.photos');
        if ((0, _get2.default)(photos, '[' + (parseInt(getPhotoFromUrl[2], 0) - 1) + ']')) photos[parseInt(getPhotoFromUrl[2], 0) - 1].click();
      }
    },
    initFullScreen: function initFullScreen() {
      var galleryElements = this.$refs.galleryContainer;

      if (!(0, _isEmpty2.default)(galleryElements)) {
        galleryElements.onclick = this.onThumbnailsClick;
      }
    },
    onThumbnailsClick: function onThumbnailsClick(e) {
      e = e || window.event;
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      var eTarget = e.target || e.srcElement;
      var clickedListItem = this.closest(eTarget, function (el) {
        var className = el.className instanceof window.SVGAnimatedString ? el.className.baseVal : el.className;
        return className && className.match(/THUMBNAIL/gi);
      });

      if (!clickedListItem) {
        return;
      }

      var clickedGallery = clickedListItem.parentNode.parentNode;
      var childNodes = [];
      (0, _forEach2.default)(clickedGallery.childNodes, function (nodes) {
        childNodes = [].concat((0, _toConsumableArray3.default)(childNodes), (0, _toConsumableArray3.default)(nodes.childNodes));
      });
      var numChildNodes = childNodes.length;
      var nodeIndex = 0;
      var index = 0;

      for (var i = 0; i < numChildNodes; i += 1) {
        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex += 1;
      }

      if (index >= 0) {
        _eventBus2.default.$emit('openPhotoSlider', index, clickedGallery.childNodes, {}, this.articleTitle);
      }
    },
    closest: function closest(el, fn) {
      return el && (fn(el) ? el : this.closest(el.parentNode, fn));
    }
  },
  render: function render(createElement) {
    var renderElements = [];

    if (this.$slots.thumbnail) {
      var thumbnails = this.$slots.thumbnail;
      var wrapperTwoElement = (0, _drop2.default)(thumbnails);

      while (wrapperTwoElement.length > 0 && wrapperTwoElement.length < 3) {
        wrapperTwoElement.push(createElement('div', { class: { thumbnail: true }, style: { 'background-image': "url('/image/placeholder/1/1/5A9CB5/20')" } }));
      }

      var galleryContainerClass = {
        'gallery-container': true,
        clear: true
      };
      galleryContainerClass['length-' + thumbnails.length] = true;
      galleryContainerClass['' + this.theme] = true;

      renderElements.push(createElement('div', {
        class: galleryContainerClass,
        ref: 'galleryContainer'
      }, [createElement('div', {
        class: {
          gallery: true,
          clear: true
        },
        attrs: {
          articleTitle: this.articleTitle
        }
      }), createElement('div', { class: { 'wrapper-one': true } }, [(0, _head2.default)(thumbnails)]), createElement('div', { class: { 'wrapper-two': true } }, wrapperTwoElement), createElement('div', { class: { clear: true } }, '')]));
    }

    return createElement('div', {
      class: {
        'gallery-wrapper': true,
        'no-article-gutter-mobile': true
      }
    }, renderElements);
  }
};

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _has = __webpack_require__(102);

var _has2 = _interopRequireDefault(_has);

var _get3 = __webpack_require__(5);

var _get4 = _interopRequireDefault(_get3);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _icon_arrow_down = __webpack_require__(1323);

var _icon_arrow_down2 = _interopRequireDefault(_icon_arrow_down);

var _utilities = __webpack_require__(51);

var _icon_videoplay = __webpack_require__(238);

var _icon_videoplay2 = _interopRequireDefault(_icon_videoplay);

var _vueResize = __webpack_require__(338);

var _CountDown = __webpack_require__(1322);

var _CountDown2 = _interopRequireDefault(_CountDown);

var _SpeechBalloonLabel = __webpack_require__(915);

var _SpeechBalloonLabel2 = _interopRequireDefault(_SpeechBalloonLabel);

var _animationHandler = __webpack_require__(348);

var _animationHandler2 = _interopRequireDefault(_animationHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'card-cover',
  mixins: [_animationHandler2.default],
  components: {
    SvgArrowDown: _icon_arrow_down2.default,
    SvgVideoPlayIcon: _icon_videoplay2.default,
    ResizeObserver: _vueResize.ResizeObserver,
    WidgetCountDown: _CountDown2.default,
    SpeechBalloonLabel: _SpeechBalloonLabel2.default
  },
  props: {
    nid: [String, Number],
    isHideAnimationElement: [Boolean],
    showVideoPlayButton: [Boolean],
    cardPosition: [String],
    actionToggle: {
      type: Boolean,
      default: false
    },
    showAction: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isShowAnimation: false,
      isLoaded: false,
      parentInitFunctions: ['resizeCards'],
      actionUp: false
    };
  },
  mounted: function mounted() {
    this.isShowAnimation = !this.isHideAnimationElement;
    this.$emit('cardMounted', (0, _get4.default)(this, 'nid', false));
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    registeredArticleCovers: 'registeredArticleCovers',
    articleCover: 'articleCover'
  }), (0, _vuex.mapState)(['activeNID']), {
    node: function node() {
      return this.$store.getters.node(this.nid) || {};
    },
    cardID: function cardID() {
      return 'card-id-' + this.nid;
    },
    isCoverReady: function isCoverReady() {
      return (0, _includes2.default)(this.registeredArticleCovers, this.nid.toString());
    },

    isCountDownCard: {
      cache: false,
      get: function get() {
        return (0, _get4.default)(this, 'node.isCountDown', false);
      }
    },
    isVideoCard: {
      cache: false,
      get: function get() {
        return (0, _get4.default)(this, 'node.isCardVideo', false);
      }
    },
    actionText: function actionText() {
      return this.isVideoCard && this.articleType === 'video' ? 'Watch' : 'Read';
    },
    showAnimation: function showAnimation() {
      if (this.isHideAnimationElement) {
        return false;
      }
      return this.isShowAnimation;
    },
    countDown: function countDown() {
      if ((0, _get4.default)(this, 'node.display_countdown', false)) {
        var _get2 = (0, _get4.default)(this, 'product', {}),
            _get2$launch_date = _get2.launch_date,
            launchDate = _get2$launch_date === undefined ? '' : _get2$launch_date,
            _get2$title = _get2.title,
            title = _get2$title === undefined ? '' : _get2$title;

        return {
          countDate: launchDate,
          header: title
        };
      }
      return {};
    },
    product: function product() {
      if ((0, _get4.default)(this, 'node.product')) {
        return this.$store.getters.node(this.node.product);
      }
      return {};
    },
    articleType: function articleType() {
      return (0, _utilities.getArticleType)(this.node);
    }
  }),
  methods: {
    isEmpty: _isEmpty2.default,
    showCardAnimation: function showCardAnimation() {
      var _this = this;

      if (!this.isHideAnimationElement) {
        if (this.isShowAnimation) {
          this.isShowAnimation = false;
          setTimeout(function () {
            _this.isShowAnimation = true;
          }, 300);
        } else {
          this.isShowAnimation = true;
        }
      }
    },
    hideAnimationElement: function hideAnimationElement() {
      this.isShowAnimation = false;
    },
    toArticle: function toArticle() {
      if (this.articleType === 'video') {
        this.playVideo();
      } else if ((0, _has2.default)(this, '$parent.$parent.topCovertoBody')) {
        this.$parent.$parent.topCovertoBody();
      }
    },
    playVideo: function playVideo() {
      (0, _get4.default)(this, '$parent.$parent.playVideo', function () {})(!(0, _utilities.isDesktop)());
    },
    hideVideo: function hideVideo() {
      (0, _get4.default)(this, '$parent.$parent.hideVideo', function () {})();
    },
    resizeCards: function resizeCards() {
      var width = document.documentElement.clientWidth;
      var cardContainer = (0, _get4.default)(this, '$refs.cardCoverContent.$refs.cardContainer');
      var mobileHeight = (0, _get4.default)(this, '$refs.cardCoverContent.$refs.mobileHeightWrap');

      if (cardContainer && mobileHeight) {
        if (width >= 1024 || window.matchMedia('(orientation: landscape)').matches) {
          var scale = width / 1440;
          cardContainer.style.transform = 'scale(' + scale + ')';
        } else {
          var _scale = width / 375;
          cardContainer.style.transform = 'none';
          mobileHeight.style.transform = 'scale(' + _scale + ')';
          var mhHeightScale = mobileHeight.clientHeight * _scale / 2;
          mobileHeight.style.marginTop = '-' + mhHeightScale + 'px';
        }
      }
    },
    cardActionAnimate: function cardActionAnimate() {
      var _this2 = this;

      this.actionUp = true;
      setTimeout(function () {
        _this2.actionUp = false;
        _this2.$parent.$parent.cardActionAnimate = false;
      }, 300);
    }
  },
  watch: {
    activeNID: function activeNID(nid) {
      if ((0, _get4.default)(this, 'cardPosition') === 'top' && nid === (0, _get4.default)(this, 'node.nid')) {
        this.$emit('cardMounted', nid || false);
        this.isShowAnimation = !this.isHideAnimationElement;
      }
    }
  }
};

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'node-body',
  props: ['nid', 'cover'],
  components: {
    ArticleBody: function ArticleBody() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1702));
    },
    ComparisonBody: function ComparisonBody() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1710));
    },
    PersonBody: function PersonBody() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1320));
    },
    PageBody: function PageBody() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1098));
    }
  },
  computed: {
    node: function node() {
      return this.$store.getters.node(this.nid);
    },
    nodeType: function nodeType() {
      return (0, _get2.default)(this, 'node.type', 'comparison');
    }
  },
  mounted: function mounted() {
    if (!(0, _get2.default)(_eventBus2.default, '_events.nodeBodyMounted')) {
      _eventBus2.default.$on('nodeBodyMounted', function () {
        _eventBus2.default.$emit('bodyMounted');
      });
    }
  }
};

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _last = __webpack_require__(146);

var _last2 = _interopRequireDefault(_last);

var _concat = __webpack_require__(1036);

var _concat2 = _interopRequireDefault(_concat);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _Link = __webpack_require__(103);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'tag',
  props: ['node', 'truncateLength'],
  components: {
    TermLink: _Link2.default
  },
  computed: {
    topics: function topics() {
      return (0, _map2.default)((0, _get2.default)(this, 'node.topics', []), this.$store.getters.term);
    },
    sections: function sections() {
      var _this = this;

      var sections = [];
      (0, _forEach2.default)((0, _get2.default)(this, 'node.sections', []), function (sectionLineage) {
        var sectionList = (0, _map2.default)(sectionLineage, _this.$store.getters.term);
        sections.push(sectionList);
      });
      return sections;
    },
    tags: function tags() {
      var sectionTags = (0, _map2.default)(this.sections, function (lineage) {
        return (0, _last2.default)(lineage);
      });
      return (0, _concat2.default)(this.topics, sectionTags);
    }
  }
};

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _Label = __webpack_require__(927);

var _Label2 = _interopRequireDefault(_Label);

var _SpeechBalloonLabel = __webpack_require__(915);

var _SpeechBalloonLabel2 = _interopRequireDefault(_SpeechBalloonLabel);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['node'],
  components: {
    NodeLabel: _Label2.default,
    SpeechBalloonLabel: _SpeechBalloonLabel2.default
  },
  computed: {
    title: function title() {
      if ((0, _get2.default)(this, 'node.default_head')) {
        return (0, _get2.default)(this, 'node.default_head');
      }
      return (0, _get2.default)(this, 'node.title', '');
    },
    articleType: function articleType() {
      return (0, _utilities.getArticleType)(this.node);
    }
  }
};

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateFormatter = __webpack_require__(1330);

var _dateFormatter2 = _interopRequireDefault(_dateFormatter);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'field-date',
  props: ['node'],
  mixins: [_dateFormatter2.default],
  data: function data() {
    return {
      dateWithTimezone: ''
    };
  },

  methods: {
    date: function date() {
      var published = (0, _get2.default)(this, 'node.published') || (0, _get2.default)(this, 'node.created');
      return this.articleDateFormatter(published);
    }
  },
  created: function created() {
    this.dateWithTimezone = this.date();
  },
  mounted: function mounted() {
    this.dateWithTimezone = this.date();
  }
};

/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _Section = __webpack_require__(959);

var _Section2 = _interopRequireDefault(_Section);

var _icon_arrow_left = __webpack_require__(1181);

var _icon_arrow_left2 = _interopRequireDefault(_icon_arrow_left);

var _icon_cancel = __webpack_require__(369);

var _icon_cancel2 = _interopRequireDefault(_icon_cancel);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'person-overlay-header',
  components: {
    FieldSection: _Section2.default,
    SvgIconArrowLeft: _icon_arrow_left2.default,
    SvgIconCancel: _icon_cancel2.default
  },
  props: {
    nid: [Number, String],
    overlayBody: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    theme: {
      type: [String, Boolean],
      default: ''
    },
    width: {
      type: String
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleRelatedPersonOverlay']), {
    closeOverlay: function closeOverlay() {
      window.location.hash = '';
    }
  }),
  computed: {
    style: function style() {
      var width = this.theme === 'desktop' && this.width ? this.width : '100%';
      return { width: width };
    },
    label: function label() {
      var label = (0, _get2.default)(this, 'node.short_title', (0, _get2.default)(this, 'node.title', ''));
      return label;
    },
    node: function node() {
      return this.$store.getters.node(this.nid) || {};
    },
    mode: function mode() {
      return (0, _get2.default)(this, 'overlayBody.headerMode', '');
    },
    sections: function sections() {
      var _this = this;

      var sections = [];
      (0, _forEach2.default)((0, _get2.default)(this, 'node.sections', []), function (sectionLineage) {
        var sectionList = (0, _map2.default)(sectionLineage, _this.$store.getters.term);
        sections.push(sectionList);
      });
      return sections;
    }
  }
};

/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _filter = __webpack_require__(156);

var _filter2 = _interopRequireDefault(_filter);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _keys = __webpack_require__(38);

var _keys2 = _interopRequireDefault(_keys);

var _slice = __webpack_require__(1000);

var _slice2 = _interopRequireDefault(_slice);

var _concat = __webpack_require__(1036);

var _concat2 = _interopRequireDefault(_concat);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _throttle = __webpack_require__(965);

var _throttle2 = _interopRequireDefault(_throttle);

var _set = __webpack_require__(386);

var _set2 = _interopRequireDefault(_set);

var _values = __webpack_require__(360);

var _values2 = _interopRequireDefault(_values);

var _shuffle = __webpack_require__(1657);

var _shuffle2 = _interopRequireDefault(_shuffle);

var _Lv = __webpack_require__(1039);

var _Lv2 = _interopRequireDefault(_Lv);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _Label = __webpack_require__(927);

var _Label2 = _interopRequireDefault(_Label);

var _SharePane = __webpack_require__(340);

var _SharePane2 = _interopRequireDefault(_SharePane);

var _Tag = __webpack_require__(983);

var _Tag2 = _interopRequireDefault(_Tag);

var _ShareButtons = __webpack_require__(335);

var _ShareButtons2 = _interopRequireDefault(_ShareButtons);

var _CardVideo = __webpack_require__(367);

var _CardVideo2 = _interopRequireDefault(_CardVideo);

var _PropertyPane = __webpack_require__(1713);

var _PropertyPane2 = _interopRequireDefault(_PropertyPane);

var _ArticleGallery = __webpack_require__(1116);

var _ArticleGallery2 = _interopRequireDefault(_ArticleGallery);

var _Loader = __webpack_require__(362);

var _Loader2 = _interopRequireDefault(_Loader);

var _Date = __webpack_require__(1095);

var _Date2 = _interopRequireDefault(_Date);

var _Body = __webpack_require__(951);

var _Body2 = _interopRequireDefault(_Body);

var _BodyHead = __webpack_require__(1003);

var _BodyHead2 = _interopRequireDefault(_BodyHead);

var _Section = __webpack_require__(959);

var _Section2 = _interopRequireDefault(_Section);

var _QuoteBlock = __webpack_require__(1163);

var _QuoteBlock2 = _interopRequireDefault(_QuoteBlock);

var _Timeline = __webpack_require__(1321);

var _Timeline2 = _interopRequireDefault(_Timeline);

var _Gallery = __webpack_require__(1318);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _lazyloadImage = __webpack_require__(914);

var _lazyloadImage2 = _interopRequireDefault(_lazyloadImage);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

var _icon_arrow_down = __webpack_require__(988);

var _icon_arrow_down2 = _interopRequireDefault(_icon_arrow_down);

var _icon_arrow_left = __webpack_require__(1181);

var _icon_arrow_left2 = _interopRequireDefault(_icon_arrow_left);

var _icon_gallery = __webpack_require__(1107);

var _icon_gallery2 = _interopRequireDefault(_icon_gallery);

var _vuex = __webpack_require__(12);

var _utilities = __webpack_require__(51);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var relatedNodeLimit = 5;

exports.default = {
  name: 'person-body',
  props: {
    nid: [Number, String],
    overlay: {
      type: Boolean,
      default: false
    },
    showingOverlay: false,
    theme: {
      type: [String, Boolean],
      default: ''
    }
  },
  data: function data() {
    return {
      bodyOptions: {
        countDown: false,
        photoOverlay: true,
        inlineNewsletter: false
      },
      atBottom: false,
      headerMode: '',
      direction: false,
      lastPosition: 0,
      offset: 0,
      noMoreContent: false,
      loading: false,
      showQuotes: false
    };
  },

  mixins: [_lazyloadImage2.default, _section2.default],
  components: {
    SharePane: _SharePane2.default,
    NodeLink: _Link2.default,
    NodeLabel: _Label2.default,
    Tag: _Tag2.default,
    FieldBody: _Body2.default,
    FieldDate: _Date2.default,
    FieldSection: _Section2.default,
    BodyHead: _BodyHead2.default,
    PropertyPane: _PropertyPane2.default,
    Gallery: _Gallery2.default,
    SvgIconArrowDownOne: _icon_arrow_down2.default,
    SvgIconArrowLeft: _icon_arrow_left2.default,
    SvgGallery: _icon_gallery2.default,
    Loader: _Loader2.default,
    ShareButtons: _ShareButtons2.default,
    CardVideo: _CardVideo2.default,
    ArticleLevelOne: _Lv2.default,
    ArticleGallery: _ArticleGallery2.default,
    QuoteBlock: _QuoteBlock2.default,
    Timeline: _Timeline2.default
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleRelatedPersonOverlay']), {
    isEmpty: _isEmpty2.default,
    fetchRelated: function fetchRelated(nid) {
      var _this = this;

      this.$store.dispatch('fetchRelatedNodes', { type: this.type, nid: nid, offset: this.offset, limit: relatedNodeLimit }).then(function (hasContent) {
        _this.noMoreContent = !hasContent;
      });
      if (this.type === 'person') {
        this.$store.dispatch('fetchRandomPeople', { limit: 6 });
      }
    },
    loadMoreRelatedArticles: function loadMoreRelatedArticles() {
      var _this2 = this;

      if (!this.noMoreContent) {
        this.loading = true;
        this.offset += relatedNodeLimit;
        this.$store.dispatch('fetchRelatedNodes', { type: this.type, nid: this.nid, offset: this.offset, limit: relatedNodeLimit }).then(function (hasContent) {
          _this2.noMoreContent = !hasContent;
          setTimeout(function () {
            _this2.loading = false;
          }, 800);
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    _eventBus2.default.$emit('nodeBodyMounted');

    if ((0, _get2.default)(this, 'nid')) {
      this.fetchRelated(this.nid);
    }

    var personOverlayWrapper = this.$refs.personOverlay.parentElement;
    var passive = (0, _utilities.supportPassive)() ? { passive: true } : false;
    personOverlayWrapper.addEventListener('scroll', (0, _throttle2.default)(function (_e) {
      var scrollY = personOverlayWrapper.scrollTop;
      _this3.direction = scrollY > _this3.lastPosition ? 'down' : 'up';
      _this3.lastPosition = scrollY;
      _this3.atBottom = scrollY > 60 && _this3.direction === 'down';
      _this3.headerMode = _this3.atBottom ? 'collapse' : '';
    }, 300), passive);
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['relatedPersonOverlay', 'nodes']), {
    type: function type() {
      if ((0, _get2.default)(this, 'node.type') === 'person') {
        return 'person';
      }
      return 'whatis';
    },
    isEmptyTimeline: function isEmptyTimeline() {
      if (!(0, _isEmpty2.default)(this.node.timeline)) {
        var result = true;
        (0, _forEach2.default)(this.node.timeline, function (timeline) {
          result = result && !(0, _isEmpty2.default)(timeline);
        });
        return result;
      }
      return false;
    },
    node: function node() {
      return this.$store.getters.node(this.nid) || {};
    },
    coverStyle: function coverStyle() {
      if (!this.showVideo && this.overlay) {
        if ((0, _get2.default)(this, 'node.images[0].style_600x600', false)) {
          return {
            'background-image': 'url(\'' + (0, _get2.default)(this, 'node.images[0].style_600x600') + '\')'
          };
        }
      }
      return {};
    },
    showVideo: function showVideo() {
      return (0, _get2.default)(this, 'node.related_video[0].orientation') === 'square';
    },
    relatedArticles: function relatedArticles() {
      var queue = this.$store.getters.personRelatedNodesQueue('node-related-nodes-' + this.nid) || {};
      return (0, _map2.default)((0, _keys2.default)(queue), function (o) {
        return queue[o];
      });
    },
    sections: function sections() {
      var _this4 = this;

      var sections = [];
      (0, _forEach2.default)((0, _get2.default)(this, 'node.sections', []), function (sectionLineage) {
        var sectionList = (0, _map2.default)(sectionLineage, _this4.$store.getters.term);
        sections.push(sectionList);
      });
      return sections;
    },
    slideshow: function slideshow() {
      var images = (0, _get2.default)(this, 'node.images', []);
      return (0, _filter2.default)(images, 'slideshow');
    },
    randomPeople: function randomPeople() {
      var _this5 = this;

      if (this.type === 'person') {
        return (0, _shuffle2.default)((0, _slice2.default)((0, _filter2.default)((0, _values2.default)(this.nodes), function (person) {
          return person.type === 'person' && person.nid !== _this5.nid;
        }), 0, 5));
      }
      return [];
    },
    layout: function layout() {
      var node = this.node;
      var output = [];
      var properties = (0, _map2.default)((0, _keys2.default)(node.properties), function (key) {
        return { type: 'property', data: node.properties[key] };
      });

      var firstProperty = (0, _head2.default)(properties);
      if (!(0, _isEmpty2.default)(firstProperty)) {
        output.push(firstProperty);
      }

      if (!(0, _isEmpty2.default)(node.history)) {
        output.push({
          type: 'history',
          data: node.history
        });
      }

      var secondProperty = (0, _head2.default)((0, _slice2.default)(properties, 1, 2));
      if (!(0, _isEmpty2.default)(secondProperty)) {
        output.push(secondProperty);
      }

      if (!(0, _isEmpty2.default)(node.awards) || !(0, _isEmpty2.default)(node.publications)) {
        output.push({
          type: 'awards',
          data: {
            awards: node.awards,
            publications: node.publications
          }
        });
      }

      output = (0, _concat2.default)(output, (0, _slice2.default)(properties, 2));

      if (!(0, _isEmpty2.default)(node.quotes)) {
        output.push({
          type: 'quote',
          data: node.quotes
        });
      }

      if (!(0, _isEmpty2.default)(this.relatedArticles)) {
        output.push({
          type: 'relatedArticles',
          data: this.relatedArticles
        });
      }

      if (!(0, _isEmpty2.default)(this.slideshow)) {
        output.push({
          type: 'slideshow',
          data: this.slideshow
        });
      }

      output.push({
        type: 'tag',
        data: []
      });

      return output;
    },
    desktopGridLayout: function desktopGridLayout() {
      var layout = this.layout;

      if ((0, _get2.default)(layout, '[3].type', false) === 'awards') {
        layout.splice(3, 0, { type: 'placeholder' });
        layout.splice(5, 0, { type: 'placeholder' });
      }

      var thirdCol = (0, _filter2.default)(layout, function (item, index) {
        return index % 3 === 2;
      });
      if (!(0, _isEmpty2.default)(this.randomPeople)) {
        thirdCol.push({
          type: 'random-people',
          data: []
        });
      }
      return [(0, _filter2.default)(layout, function (item, index) {
        return index % 3 === 0;
      }), (0, _filter2.default)(layout, function (item, index) {
        return index % 3 === 1;
      }), thirdCol];
    }
  }),
  watch: {
    relatedPersonOverlay: function relatedPersonOverlay(value) {
      var _this6 = this;

      if (!value.toggle) {
        setTimeout(function () {
          (0, _set2.default)(_this6, '$refs.personOverlay.parentElement.scrollTop', 0);
        }, 400);
      }
    },
    nid: function nid(newNid) {
      if (newNid && this.overlay) {
        this.fetchRelated(newNid);
        this.$store.dispatch('fetchNode', { nid: newNid });
      }
    }
  }
};

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utilities = __webpack_require__(51);

exports.default = {
  name: 'property-pane',
  props: ['property'],
  methods: {
    isUrl: _utilities.isUrl
  }
};

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _ShareButtons = __webpack_require__(335);

var _ShareButtons2 = _interopRequireDefault(_ShareButtons);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _vuex = __webpack_require__(12);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'related-person-share-bar',
  components: {
    ShareButtons: _ShareButtons2.default
  },
  props: {
    nid: [Number, String],
    overlayBody: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    theme: {
      type: [String, Boolean],
      default: ''
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['requestDomain'])),
  computed: {
    shareData: function shareData() {
      var obj = {
        url: '' + this.requestDomain() + (0, _get2.default)(this.node, 'relative_url', ''),
        shortenUrl: (0, _get2.default)(this.node, 'shorten_url', ''),
        title: (0, _utilities.updateTitleByNodeType)({ type: (0, _get2.default)(this, 'node.type', ''), originalTitle: (0, _get2.default)(this.node, 'title', '') })
      };
      return obj;
    },
    node: function node() {
      return this.$store.getters.node(this.nid) || {};
    },
    sharebarMode: function sharebarMode() {
      return this.theme === 'desktop' ? 'inline' : 'sticky';
    },
    mode: function mode() {
      return this.theme === 'mobile' ? (0, _get2.default)(this, 'overlayBody.headerMode', '') : 'collapse';
    }
  }
};

/***/ }),

/***/ 1392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _throttle = __webpack_require__(965);

var _throttle2 = _interopRequireDefault(_throttle);

var _utilities = __webpack_require__(51);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'timeline',
  props: {
    nid: {
      type: [String, Number],
      required: true
    },
    isOverlay: {
      type: Boolean,
      default: false
    },
    timelineConfig: {
      type: Object,
      default: function _default() {
        return {
          scale_factor: 1,
          height: 600,
          marker_padding: 5
        };
      }
    }
  },
  data: function data() {
    return {
      tlLoaded: false,
      resizeHandler: false
    };
  },

  methods: {
    timelineReady: function timelineReady(selector) {
      var _this = this;

      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;

      var timer = 0;
      var domIsReady = setInterval(function () {
        timer += interval;
        if (timer < time && !_this.tlLoaded) {
          _this.tlLoaded = !(0, _isEmpty2.default)(document.querySelectorAll(selector));
        } else {
          clearInterval(domIsReady);
        }
      }, interval);
    },
    timelineResize: function timelineResize() {
      var resize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var trianglePadding = 17;
      var timenav = document.querySelector('.tl-timenav');
      var timenavAxis = document.querySelector('.tl-timeaxis-background');
      var timelineHeight = timenav.offsetHeight - timenavAxis.offsetHeight;

      var timelineTimemarkers = document.querySelectorAll('.tl-timemarker');
      (0, _forEach2.default)(timelineTimemarkers, function (timelineTimemarker) {
        var resizeMarkerLine = function resizeMarkerLine(el) {
          el.style.height = timelineHeight + trianglePadding + 'px';
          el.style.transform = 'translateY(-' + (parseInt(timelineTimemarker.style.top, 10) + trianglePadding) + 'px)';
        };
        if (!resize) {
          var lineElement = document.createElement('div');
          lineElement.classList.add('timeline-marker-line');
          resizeMarkerLine(lineElement);
          timelineTimemarker.appendChild(lineElement);
        } else {
          var _lineElement = timelineTimemarker.querySelector('.timeline-marker-line');
          if (_lineElement) {
            resizeMarkerLine(_lineElement);
          }
        }
      });
    },
    updateDisplayHandler: function updateDisplayHandler() {
      if (!(0, _isEmpty2.default)(window.timeline)) {
        setTimeout(function () {
          window.timeline.updateDisplay();
        }, 50);
      }
    },
    initTimeline: function initTimeline() {
      var _this2 = this;

      window.timeline = new window.TL.Timeline(this.$refs.timelineEmbed, '/api/timeline/feed/' + this.nid, this.timelineConfig);

      window.TL.Browser.touch = false;
      this.timelineReady('.tl-timemarker-timespan', 3000);

      var swiping = true;
      var hammer = __webpack_require__(1055);
      var timelineHammerManager = new hammer.Manager(this.$refs.container, {
        touchAction: 'pan-y',
        recognizers: [[hammer.Pan, { direction: hammer.DIRECTION_ALL, threshold: 10 }], [hammer.Tap]]
      });

      window.addEventListener('orientationchange', this.updateDisplayHandler);

      timelineHammerManager.on('panstart', function (_e) {
        swiping = false;
      });

      timelineHammerManager.on('panleft', function (_e) {
        if (!swiping && !(0, _utilities.isDesktop)()) {
          swiping = true;
          var arrowRightKeydown = new window.Event('keydown');
          arrowRightKeydown.key = 'ArrowRight';
          document.dispatchEvent(arrowRightKeydown);
        }
      });
      timelineHammerManager.on('panright', function (_e) {
        if (!swiping && !(0, _utilities.isDesktop)()) {
          swiping = true;
          var arrowLeftKeydown = new window.Event('keydown');
          arrowLeftKeydown.key = 'ArrowLeft';
          document.dispatchEvent(arrowLeftKeydown);
        }
      });

      this.resizeHandler = (0, _throttle2.default)(function (_e) {
        setTimeout(function () {
          _this2.timelineResize(true);
        }, 50);
      }, 100);
      window.addEventListener('resize', this.resizeHandler);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$watch('$refs.lazy.state.loaded', function () {
      if (_this3.$refs.lazy.state.loaded) {
        if (!(0, _get2.default)(window, 'TL')) {
          __webpack_require__(1325);
        }
        _this3.initTimeline();
      }
    });
  },
  destroyed: function destroyed() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    window.removeEventListener('orientationchange', this.updateDisplayHandler);
  },

  watch: {
    tlLoaded: function tlLoaded(val) {
      if (val) {
        this.timelineResize();
      }
    },
    nid: function nid() {
      this.initTimeline();
    }
  }
};

/***/ }),

/***/ 1400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _get_time = __webpack_require__(1551);

var _get_time2 = _interopRequireDefault(_get_time);

var _format = __webpack_require__(1027);

var _format2 = _interopRequireDefault(_format);

var _difference_in_seconds = __webpack_require__(1550);

var _difference_in_seconds2 = _interopRequireDefault(_difference_in_seconds);

var _difference_in_minutes = __webpack_require__(1191);

var _difference_in_minutes2 = _interopRequireDefault(_difference_in_minutes);

var _difference_in_hours = __webpack_require__(1190);

var _difference_in_hours2 = _interopRequireDefault(_difference_in_hours);

var _difference_in_days = __webpack_require__(1189);

var _difference_in_days2 = _interopRequireDefault(_difference_in_days);

var _is_after = __webpack_require__(377);

var _is_after2 = _interopRequireDefault(_is_after);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'widget-count-down',
  components: {
    NodeLink: _Link2.default
  },
  mounted: function mounted() {
    var _this = this;

    this.intervalID = window.setInterval(function () {
      _this.now = new Date();
    }, 1000);
  },

  props: {
    countDown: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: true
    },
    product: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    }
  },
  data: function data() {
    return {
      now: new Date(),
      intervalID: -1
    };
  },

  computed: {
    header: function header() {
      return (0, _get2.default)(this, 'countDown.header', ' ');
    },
    countDownDate: function countDownDate() {
      return (0, _get2.default)(this, 'countDown.countDate', false);
    },
    compareDate: function compareDate() {
      if (this.countDownDate) {
        var passDate = new Date(this.countDownDate);
        var now = new Date();
        return now < passDate;
      }
      return false;
    },
    date: function date() {
      if (this.countDownDate) {
        return (0, _get_time2.default)(this.countDownDate);
      }
      return false;
    },
    seconds: function seconds() {
      return (0, _difference_in_seconds2.default)(this.countDownDate, this.now) % 60;
    },
    minutes: function minutes() {
      return (0, _difference_in_minutes2.default)(this.countDownDate, this.now) % 60;
    },
    hours: function hours() {
      return (0, _difference_in_hours2.default)(this.countDownDate, this.now) % 24;
    },
    days: function days() {
      return (0, _difference_in_days2.default)(this.countDownDate, this.now);
    },
    isCountdownExpired: function isCountdownExpired() {
      if (this.compareDate && (0, _is_after2.default)(this.countDownDate, this.now)) {
        return false;
      }
      return true;
    },
    productRelatedReviewArticleNode: function productRelatedReviewArticleNode() {
      var ishidden = false;
      return ishidden;
    }
  },
  filters: {
    two_digits: function two_digits(value, compare) {
      if (!compare) {
        return '00';
      }
      if (value.toString().length <= 1) {
        return '0' + value.toString();
      }
      return value.toString();
    },
    date_format_to: function date_format_to(value, dateFnsToken) {
      var formatted = (0, _format2.default)(new Date(value), dateFnsToken);
      return formatted;
    }
  },
  destroyed: function destroyed() {
    if (this.destroyed !== -1) {
      clearInterval(this.intervalID);
    }
  }
};

/***/ }),

/***/ 1409:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1459), __esModule: true };

/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1460), __esModule: true };

/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1461);
var $Object = __webpack_require__(16).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1462);
module.exports = __webpack_require__(16).Object.getPrototypeOf;


/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(47);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(239) });


/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(112);
var $getPrototypeOf = __webpack_require__(375);

__webpack_require__(376)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 1463:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".tl-storyjs div *{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.tl-storyjs .active,.tl-storyjs .caption,.tl-storyjs .content-container,.tl-storyjs .credit,.tl-storyjs .date,.tl-storyjs .dot,.tl-storyjs .era,.tl-storyjs .flag,.tl-storyjs .line,.tl-storyjs .major,.tl-storyjs .map,.tl-storyjs .marker,.tl-storyjs .media,.tl-storyjs .message,.tl-storyjs .minor,.tl-storyjs .slider,.tl-storyjs .start,.tl-storyjs .text,.tl-storyjs .time,.tl-storyjs .title,.tl-storyjs .tl-container,.tl-storyjs .tl-feature,.tl-storyjs .tl-feedback,.tl-storyjs .tl-navigation,.tl-storyjs .tl-slider,.tl-storyjs .toolbar,.tl-storyjs a,.tl-storyjs abbr,.tl-storyjs acronym,.tl-storyjs address,.tl-storyjs blockquote,.tl-storyjs button,.tl-storyjs caption,.tl-storyjs cite,.tl-storyjs code,.tl-storyjs dd,.tl-storyjs del,.tl-storyjs dfn,.tl-storyjs dl,.tl-storyjs dt,.tl-storyjs em,.tl-storyjs fieldset,.tl-storyjs form,.tl-storyjs h1,.tl-storyjs h2,.tl-storyjs h3,.tl-storyjs h4,.tl-storyjs h5,.tl-storyjs h6,.tl-storyjs img,.tl-storyjs label,.tl-storyjs legend,.tl-storyjs li,.tl-storyjs ol,.tl-storyjs p,.tl-storyjs pre,.tl-storyjs q,.tl-storyjs s,.tl-storyjs samp,.tl-storyjs small,.tl-storyjs strike,.tl-storyjs strong,.tl-storyjs sub,.tl-storyjs sup,.tl-storyjs table,.tl-storyjs tbody,.tl-storyjs td,.tl-storyjs tfoot,.tl-storyjs th,.tl-storyjs thead,.tl-storyjs tr,.tl-storyjs tt,.tl-storyjs ul,.tl-storyjs var{margin:0;padding:0;border:0;font-weight:400;font-style:normal;font-size:100%;line-height:1;font-family:inherit;width:auto;float:none}.tl-storyjs h1,.tl-storyjs h2,.tl-storyjs h3,.tl-storyjs h4,.tl-storyjs h5,.tl-storyjs h6{clear:none}.tl-storyjs table{border-collapse:collapse;border-spacing:0}.tl-storyjs ol,.tl-storyjs ul{list-style:none}.tl-storyjs blockquote:after,.tl-storyjs blockquote:before,.tl-storyjs q:after,.tl-storyjs q:before{content:\"\"}.tl-storyjs a:focus{outline:thin dotted}.tl-storyjs a:active,.tl-storyjs a:hover{outline:0}.tl-storyjs article,.tl-storyjs aside,.tl-storyjs details,.tl-storyjs figcaption,.tl-storyjs figure,.tl-storyjs footer,.tl-storyjs header,.tl-storyjs hgroup,.tl-storyjs nav,.tl-storyjs section{display:block}.tl-storyjs audio,.tl-storyjs canvas,.tl-storyjs video{display:inline-block}.tl-storyjs audio:not([controls]){display:none}.tl-storyjs div{max-width:none}.tl-storyjs sub,.tl-storyjs sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}.tl-storyjs sup{top:-.5em}.tl-storyjs sub{bottom:-.25em}.tl-storyjs img{border:0;-ms-interpolation-mode:bicubic}.tl-storyjs button,.tl-storyjs input,.tl-storyjs select,.tl-storyjs textarea{font-size:100%;margin:0;vertical-align:baseline}.tl-storyjs button,.tl-storyjs input{line-height:normal}.tl-storyjs button::-moz-focus-inner,.tl-storyjs input::-moz-focus-inner{border:0;padding:0}.tl-storyjs button,.tl-storyjs input[type=button],.tl-storyjs input[type=reset],.tl-storyjs input[type=submit]{cursor:pointer;-webkit-appearance:button}.tl-storyjs input[type=search]{-webkit-appearance:textfield;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.tl-storyjs input[type=search]::-webkit-search-decoration{-webkit-appearance:none}.tl-storyjs textarea{overflow:auto;vertical-align:top}.tl-timeline{font-family:Barlow}.tl-timeline h1,.tl-timeline h2,.tl-timeline h3,.tl-timeline h4,.tl-timeline h5,.tl-timeline h6{color:#000}.tl-timeline h1,.tl-timeline h2,.tl-timeline h3{font-size:28px;line-height:28px}.tl-timeline h1 small,.tl-timeline h2 small,.tl-timeline h3 small{font-size:24px;line-height:24px}.tl-timeline h4,.tl-timeline h5,.tl-timeline h6{font-size:24px;line-height:24px;margin-bottom:0}.tl-timeline h4 small,.tl-timeline h5 small,.tl-timeline h6 small{font-size:15px;line-height:15px}.tl-timeline h2.tl-headline-title{font-size:38px;line-height:38px}.tl-timeline h2.tl-headline-title small{display:block;margin-top:5px;font-size:24px;line-height:24px}.tl-timeline h2{margin-top:20px;margin-bottom:5px}.tl-timeline p{margin-top:5px;margin-bottom:10px;font-size:15px;line-height:1.42857143;color:#666}.tl-timeline p.lead{font-size:24px}.tl-timeline p a{color:#666;text-decoration:underline}.tl-timeline p a:focus,.tl-timeline p a:hover{color:#c34528}@media (-webkit-min-device-pixel-ratio:1.5),(min-resolution:144dpi){.tl-timeline p a{text-decoration:underline;background-image:none;text-shadow:none}.tl-timeline p a:focus,.tl-timeline p a:hover{color:#c34528;text-decoration:underline}}.tl-timeline b,.tl-timeline strong{font-weight:700}.tl-timeline em,.tl-timeline i{font-style:italic}.tl-timeline a{text-decoration:none;color:#c34528}.tl-timeline a:hover{text-decoration:underline;color:#6e2717}.tl-timeline .tl-caption,.tl-timeline .tl-credit,.tl-timeline .tl-slidenav-next,.tl-timeline .tl-slidenav-previous{font-size:11px;line-height:11px}.tl-timeline .tl-caption a,.tl-timeline .tl-credit a,.tl-timeline .tl-slidenav-next a,.tl-timeline .tl-slidenav-previous a{color:#000}.tl-timeline .tl-makelink{word-break:break-all;word-break:break-word;-webkit-hyphens:auto;-moz-hyphens:auto;hyphens:auto}.tl-timeline blockquote,.tl-timeline blockquote p{font-family:Barlow,sans-serif;color:#999;font-size:24px;line-height:24px;text-align:left;background:0 0;border:0;padding:0}.tl-timeline blockquote cite,.tl-timeline blockquote p cite{font-family:Barlow,sans-serif;font-size:11px;color:#666;display:block;text-align:right;font-style:normal}.tl-timeline blockquote cite:before,.tl-timeline blockquote p cite:before{content:\"\\2014\"}.tl-timeline blockquote p:before{content:open-quote;display:inline-block;font-size:28px;position:relative;top:8px;margin-right:5px}.tl-timeline blockquote p:after{content:close-quote;display:inline-block;font-size:28px;position:relative;top:8px;margin-left:3px}.tl-timeline blockquote{margin:10px}.tl-timeline blockquote p{margin:0}.tl-timeline .vcard{font-family:Barlow,sans-serif;font-size:15px;line-height:15px;margin-bottom:15px;margin-top:10px}.tl-timeline .vcard:after,.tl-timeline .vcard:before{display:table;content:\"\"}.tl-timeline .vcard:after{clear:both}.tl-timeline .vcard .twitter-date{text-align:left;font-size:11px}.tl-timeline .vcard .author{float:right}.tl-timeline .vcard a{color:#333;text-decoration:none}.tl-timeline .vcard a:hover{text-decoration:none}.tl-timeline .vcard a:hover .fn,.tl-timeline .vcard a:hover .nickname{color:#c34528}.tl-timeline .vcard .fn,.tl-timeline .vcard .nickname{padding-left:42px}.tl-timeline .vcard .fn{display:block;font-weight:700}.tl-timeline .vcard .nickname{margin-top:1px;display:block;color:#666}.tl-timeline .vcard .avatar{float:left;display:block;width:32px;height:32px}.tl-timeline .vcard .avatar img{-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px}.tl-timeline .tl-text ul{padding:0;padding-left:30px;margin:0}.tl-timeline .tl-text ul li{margin-bottom:5px}.tl-timeline .tl-button-calltoaction{cursor:pointer;font-weight:700;padding-top:10px;margin-bottom:10px;padding-bottom:10px}.tl-timeline .tl-button-calltoaction .tl-button-calltoaction-text{display:inline-block;background-color:#c34528;color:#fff;padding:10px 15px;border-radius:7px}.tl-timeline .tl-note{display:block;font-family:Barlow,sans-serif;font-style:italic;background-color:#e6e6e6;font-size:15px;line-height:17px;padding:10px;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;color:#8a6d3b;background-color:#fcf8e3;border:1px solid #faebcc;text-shadow:none}@media only screen and (max-device-width:800px),only screen and (max-width:800px){.tl-timeline h1,.tl-timeline h2,.tl-timeline h3{font-size:28px;line-height:28px}}@media only screen and (max-device-width:500px),only screen and (max-width:500px){.tl-timeline h1,.tl-timeline h2,.tl-timeline h3{font-size:24px;line-height:24px}}.tl-skinny h2{margin-top:0}[class*=\" tl-icon-\"],[class^=tl-icon-]{font-family:tl-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.tl-icon-vine:after{content:\"\\E64D\"}.tl-icon-wikipedia:after{content:\"\\E64E\"}.tl-icon-chevron-right:after{content:\"\\E64F\"}.tl-icon-chevron-left:after{content:\"\\E650\"}.tl-icon-youtube-logo:after{content:\"\\E651\"}.tl-icon-foursquare:after{content:\"\\E652\"}.tl-icon-camera-retro:after{content:\"\\E653\"}.tl-icon-doc:after{content:\"\\E654\"}.tl-icon-weibo:after{content:\"\\E655\"}.tl-icon-resize-horizontal:after{content:\"\\E656\"}.tl-icon-resize-vertical:after{content:\"\\E657\"}.tl-icon-resize-full:after{content:\"\\E658\"}.tl-icon-resize-small:after{content:\"\\E659\"}.tl-icon-twitter:after{content:\"\\E62B\"}.tl-icon-google-plus:after{content:\"\\E62C\"}.tl-icon-video:after,.tl-icon-youtube:after{content:\"\\E62D\"}.tl-icon-plaintext:after,.tl-icon-storify:after{content:\"\\E62E\"}.tl-icon-image-v2:after{content:\"\\E62F\"}.tl-icon-quote-v2:after{content:\"\\E630\"}.tl-icon-zoom-in:after{content:\"\\E631\"}.tl-icon-zoom-out:after{content:\"\\E632\"}.tl-icon-list:after{content:\"\\E633\"}.tl-icon-music:after,.tl-icon-spotify:after{content:\"\\E634\"}.tl-icon-googlemaps:after,.tl-icon-location:after{content:\"\\E635\"}.tl-icon-web:after{content:\"\\E636\"}.tl-icon-share-v2:after{content:\"\\E637\"}.tl-icon-soundcloud:after{content:\"\\E639\"}.tl-icon-dailymotion:after,.tl-icon-video-v2:after{content:\"\\E63A\"}.tl-icon-tumblr:after{content:\"\\E63B\"}.tl-icon-lastfm:after{content:\"\\E63C\"}.tl-icon-github:after{content:\"\\E63D\"}.tl-icon-goback:after{content:\"\\E63E\"}.tl-icon-doc-v2:after{content:\"\\E63F\"}.tl-icon-googledrive:after{content:\"\\E640\"}.tl-icon-facebook:after{content:\"\\E641\"}.tl-icon-flickr:after{content:\"\\E642\"}.tl-icon-dribbble:after{content:\"\\E643\"}.tl-icon-image:after{content:\"\\E605\"}.tl-icon-vimeo:after{content:\"\\E606\"}.tl-icon-instagram:after{content:\"\\E644\"}.tl-icon-pinterest:after{content:\"\\E645\"}.tl-icon-arrow-left:after{content:\"\\E646\"}.tl-icon-arrow-down:after{content:\"\\E647\"}.tl-icon-arrow-up:after{content:\"\\E648\"}.tl-icon-arrow-right:after{content:\"\\E649\"}.tl-icon-share:after{content:\"\\E64A\"}.tl-icon-blockquote:after{content:\"\\E64B\"}.tl-icon-evernote:after{content:\"\\E64C\"}.tl-icon-mappin:after{content:\"\\E600\"}.tl-icon-swipe-right:after{content:\"\\E601\"}.tl-icon-swipe-left:after{content:\"\\E602\"}.tl-icon-touch-spread:after{content:\"\\E603\"}.tl-icon-touch-pinch:after{content:\"\\E604\"}.tl-dragging{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.tl-menubar{position:absolute;z-index:11;text-align:center;color:#333;overflow:hidden;border-bottom-right-radius:10px;border-top-right-radius:10px;top:100%;left:50%;left:0}.tl-menubar-button{font-size:18px;line-height:18px;background-color:hsla(0,0%,95%,.9);cursor:pointer;padding:6px 12px;display:inline-block;display:block;color:#bfbfbf}.tl-menubar-button.tl-menubar-button-inactive{opacity:.33}.tl-menubar-button:hover{background:#333;color:#fff}.tl-menubar-button:hover.tl-menubar-button-inactive{color:#bfbfbf;background-color:hsla(0,0%,95%,.9)}.tl-mobile .tl-menubar-button{display:block}.tl-mobile .tl-menubar-button:hover{background-color:hsla(0,0%,95%,.67);color:#737373}.tl-mobile .tl-menubar-button:active{background:#c34528;color:#fff}@keyframes invertToBlack{0%{background-color:#fff}to{background-color:#000}}@-webkit-keyframes invertToBlack{0%{background:#fff}to{background:#000}}@keyframes invertToWhite{0%{background-color:#000}to{background-color:#fff}}@-webkit-keyframes invertToWhite{0%{background:#000}to{background:#fff}}.tl-message,.tl-message-full{width:100%;height:100%;position:absolute;display:table;overflow:hidden;top:0;left:0;z-index:99;margin:auto;text-align:center}.tl-message-full .tl-message-container,.tl-message .tl-message-container{padding:20px;margin:20px;text-align:center;vertical-align:middle;display:table-cell}.tl-message-full .tl-message-container .tl-message-content,.tl-message .tl-message-container .tl-message-content{color:#666;text-align:center;font-size:11px;line-height:13px;text-transform:uppercase;margin-top:7.5px;margin-bottom:7.5px;text-shadow:1px 1px 1px #fff}.tl-message-full .tl-message-container .tl-message-content strong,.tl-message .tl-message-container .tl-message-content strong{text-transform:uppercase}.tl-message-full .tl-message-container .tl-loading-icon,.tl-message .tl-message-container .tl-loading-icon{width:30px;height:30px;background-color:#666;vertical-align:middle;-webkit-box-shadow:inset 0 1px 2px hsla(0,0%,100%,.1);-moz-box-shadow:inset 0 1px 2px hsla(0,0%,100%,.1);box-shadow:inset 0 1px 2px hsla(0,0%,100%,.1);margin-left:auto;margin-right:auto;text-align:center;-webkit-animation:rotateplane 1.2s infinite ease-in-out;animation:rotateplane 1.2s infinite ease-in-out}@-webkit-keyframes rotateplane{0%{-webkit-transform:perspective(120px)}50%{-webkit-transform:perspective(120px) rotateY(180deg)}to{-webkit-transform:perspective(120px) rotateY(180deg) rotateX(180deg)}}@keyframes rotateplane{0%{transform:perspective(120px) rotateX(0) rotateY(0)}50%{transform:perspective(120px) rotateX(-180.1deg) rotateY(0)}to{transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}.tl-message-full{background-color:hsla(0,0%,100%,.8)}.tl-message-full [class*=\" tl-icon-\"],.tl-message-full [class^=tl-icon-]{color:#666;font-size:72px}.tl-message-full .tl-message-container .tl-message-content{font-size:22px;line-height:22px;text-shadow:none;color:#666;text-transform:none;font-weight:400}.tl-message-full .tl-message-container .tl-message-content .tl-button{display:inline-block;cursor:pointer;background-color:#fff;color:#333;padding:10px;margin-top:10px;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px}.tl-timenav{width:100%;background-color:#f2f2f2;position:relative;overflow:hidden;border-top:1px solid #e5e5e5}.tl-timenav .tl-attribution{cursor:pointer;z-index:9;position:absolute;bottom:2px;left:0;font-size:10px;line-height:10px;font-family:Barlow,sans-serif!important;background-color:hsla(0,0%,100%,.85);padding:3px}.tl-timenav .tl-attribution a{color:#ccc}.tl-timenav .tl-attribution a:hover{color:#000;text-decoration:none}.tl-timenav .tl-attribution a:hover .tl-knightlab-logo{background-color:#c34528}.tl-timenav .tl-attribution .tl-knightlab-logo{display:inline-block;vertical-align:middle;height:8px;width:8px;margin-right:3px;background-color:#c34528;background-color:#ccc;transform:rotate(45deg);-ms-transform:rotate(45deg);-webkit-transform:rotate(45deg)}.tl-timenav .tl-timenav-line{position:absolute;top:0;left:50%;width:1px;height:100%;background-color:#d9d9d9;z-index:2;display:none}.tl-timenav .tl-timenav-line:after,.tl-timenav .tl-timenav-line:before{font-family:tl-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#c34528;font-size:32px;line-height:32px;position:absolute;left:-14px}.tl-timenav .tl-timenav-line:before{top:-10px}.tl-timenav .tl-timenav-line:after{content:\"\\E648\";bottom:24px}.tl-timenav .tl-timenav-slider{position:absolute;height:100%;width:100%;top:0}.tl-timenav .tl-timenav-slider.tl-timenav-slider-animate{-webkit-transition:all 1s cubic-bezier(.77,0,.175,1);-moz-transition:all 1s cubic-bezier(.77,0,.175,1);-o-transition:all 1s cubic-bezier(.77,0,.175,1);transition:all 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timenav .tl-timenav-slider .tl-timenav-slider-background{position:absolute;height:100%;width:100%;cursor:move;z-index:6}.tl-timenav .tl-timenav-slider .tl-timenav-container-mask{position:absolute;height:100%;top:0}.tl-timenav .tl-timenav-slider .tl-timenav-container-mask .tl-timenav-container,.tl-timenav .tl-timenav-slider .tl-timenav-container-mask .tl-timenav-container .tl-timenav-item-container{position:absolute;height:100%}.tl-timemarker{height:100%;position:absolute;top:0;left:0;cursor:pointer;-webkit-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-moz-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-o-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timemarker.tl-timemarker-fast{-webkit-transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-moz-transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-o-transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timemarker.tl-timemarker-fast .tl-timemarker-content-container{-webkit-transition:width .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1);-moz-transition:width .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1);-o-transition:width .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1);transition:width .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1)}.tl-timemarker.tl-timemarker-fast .tl-timemarker-timespan{-webkit-transition:height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-moz-transition:height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-o-transition:height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);transition:height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1)}.tl-timemarker .tl-timemarker-timespan{pointer-events:none;position:absolute;margin:0;width:100%;height:100%;background-color:hsla(0,0%,90%,.15);border-top-right-radius:4px;border-top-left-radius:4px;-webkit-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-moz-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-o-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timemarker .tl-timemarker-timespan .tl-timemarker-timespan-content{display:none;position:absolute;width:100%;background-color:#e5e5e5;border-top-left-radius:4px;border-top-right-radius:4px;height:100px;box-sizing:border-box}.tl-timemarker .tl-timemarker-line-right{display:none;right:0}.tl-timemarker .tl-timemarker-line-left{width:1px;left:0}.tl-timemarker .tl-timemarker-line-left,.tl-timemarker .tl-timemarker-line-right{margin-top:7px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;border-left:1px solid #d9d9d9;z-index:5;content:\" \";position:absolute;height:100%;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-shadow:1px 1px 1px #fff}.tl-timemarker .tl-timemarker-line-left:after,.tl-timemarker .tl-timemarker-line-right:after{display:block;content:\" \";position:absolute;left:-4px;bottom:0;height:6px;width:6px;background-color:#919191;z-index:8;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}.tl-timemarker .tl-timemarker-content-container{position:absolute;background-color:#e5e5e5;border:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;height:100%;width:100px;z-index:6;-webkit-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-moz-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-o-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1);box-sizing:border-box;border:1px solid #d9d9d9;box-shadow:1px 1px 1px #fff}.tl-timemarker .tl-timemarker-content-container:hover{z-index:9}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content{position:relative;height:100%;z-index:8;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text{position:relative}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline,.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline p{line-clamp:unset!important;-webkit-line-clamp:unset!important;font-size:12px;line-height:13px;height:100%;overflow:hidden;font-weight:400;margin:0;font-family:Roboto,sans-serif;position:relative}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container{float:left;max-width:24px;max-height:24px;overflow:hidden;margin-right:5px;height:100%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-timemarker-media{max-width:24px;max-height:100%;opacity:.25}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class*=\" tl-icon-\"],.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class^=tl-icon-]{display:block;font-size:24px;color:#bfbfbf;margin-top:0}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-icon-wikipedia{font-size:16px}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content.tl-timemarker-content-small .tl-timemarker-text h2.tl-headline{display:block;white-space:nowrap;text-overflow:ellipsis}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content.tl-timemarker-content-small .tl-timemarker-media-container [class*=\" tl-icon-\"],.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content.tl-timemarker-content-small .tl-timemarker-media-container [class^=tl-icon-]{font-size:12px}.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline.tl-headline-fadeout:after{background:-moz-linear-gradient(top,hsla(0,0%,75%,0) 0,#bfbfbf 80%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,hsla(0,0%,75%,0)),color-stop(80%,#bfbfbf));background:-webkit-linear-gradient(top,hsla(0,0%,75%,0),#bfbfbf 80%);background:-o-linear-gradient(top,hsla(0,0%,75%,0) 0,#bfbfbf 80%);background:-ms-linear-gradient(top,hsla(0,0%,75%,0) 0,#bfbfbf 80%);background:linear-gradient(180deg,hsla(0,0%,75%,0) 0,#bfbfbf 80%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"@thecolor\",endColorstr=\"@thecolor\",GradientType=0)}.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-timemarker-media{opacity:1}.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class*=\" tl-icon-\"],.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class^=tl-icon-]{color:#fff}.tl-timemarker:hover.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline.tl-headline-fadeout:after{background:-moz-linear-gradient(top,hsla(0,0%,100%,0) 0,#fff 80%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,hsla(0,0%,100%,0)),color-stop(80%,#fff));background:-webkit-linear-gradient(top,hsla(0,0%,100%,0),#fff 80%);background:-o-linear-gradient(top,hsla(0,0%,100%,0) 0,#fff 80%);background:-ms-linear-gradient(top,hsla(0,0%,100%,0) 0,#fff 80%);background:linear-gradient(180deg,hsla(0,0%,100%,0) 0,#fff 80%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"@thecolor\",endColorstr=\"@thecolor\",GradientType=0)}.tl-timemarker.tl-timemarker-active .tl-timemarker-timespan{background-color:hsla(0,0%,100%,.5);z-index:8}.tl-timemarker.tl-timemarker-active .tl-timemarker-timespan .tl-timemarker-timespan-content{background-color:#333}.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left,.tl-timemarker.tl-timemarker-active .tl-timemarker-line-right{border-color:rgba(51,51,51,.5);border-width:1px;z-index:8;box-shadow:0 1px 3px hsla(0,0%,57%,.5)}.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left:after,.tl-timemarker.tl-timemarker-active .tl-timemarker-line-right:after{background-color:#333}.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-timemarker-media{opacity:1}.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class*=\" tl-icon-\"],.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class^=tl-icon-]{color:#333}.tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan .tl-timemarker-timespan-content{display:block}.tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan .tl-timemarker-line-left,.tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan .tl-timemarker-line-right{z-index:5}.tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan:after{display:block;content:\" \";position:absolute;left:0;bottom:-7px;height:6px;width:100%;background-color:hsla(0,0%,45%,.15);z-index:6;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px}.tl-timemarker.tl-timemarker-with-end .tl-timemarker-content-container.tl-timemarker-content-container-long{box-shadow:none}.tl-timemarker.tl-timemarker-with-end .tl-timemarker-line-right{display:block}.tl-timemarker.tl-timemarker-with-end .tl-timemarker-line-left{box-shadow:none}.tl-timemarker.tl-timemarker-with-end:hover .tl-timemarker-timespan:after{background-color:rgba(0,0,0,.25)}.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-timespan:after{background-color:rgba(51,51,51,.5)}.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-left,.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-right{border-width:1px}.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-left:after,.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-right:after{background-color:#333!important}.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-left{box-shadow:none}.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active:hover .tl-timemarker-timespan:after{background-color:rgba(51,51,51,.5)}.tl-timeera{height:100%;height:40px;position:absolute;bottom:0;left:0;pointer-events:none;z-index:3;-webkit-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-moz-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-o-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timeera.tl-timeera-fast{-webkit-transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-moz-transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-o-transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);transition:top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width .5s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timeera .tl-timeera-background{position:absolute;background-color:#28a6c3;width:100%;height:100%;opacity:1}.tl-timeera.tl-timeera-color0 .tl-timeera-background{background-color:#c34528}.tl-timeera.tl-timeera-color1 .tl-timeera-background{background-color:#28a6c3}.tl-timeera.tl-timeera-color2 .tl-timeera-background{background-color:#2832c3}.tl-timeera.tl-timeera-color3 .tl-timeera-background{background-color:#28c36c}.tl-timeera.tl-timeera-color4 .tl-timeera-background{background-color:#286dc3}.tl-timeera.tl-timeera-color5 .tl-timeera-background{background-color:#28c3a7}.tl-timeera .tl-timeera-content-container{position:absolute;border:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;height:100%;width:100px;overflow:hidden;-webkit-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-moz-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-o-transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);transition:height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1);box-sizing:border-box;border:1px solid #d9d9d9}.tl-timeera .tl-timeera-content-container .tl-timeera-content{position:relative;overflow:hidden;height:100%;padding:5px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.tl-timeera .tl-timeera-content-container .tl-timeera-content .tl-timeera-text{overflow:hidden;position:relative;height:100%}.tl-timeera .tl-timeera-content-container .tl-timeera-content .tl-timeera-text h2.tl-headline{bottom:0;position:absolute;display:-webkit-box;line-clamp:4;-webkit-line-clamp:4;box-orient:vertical;-webkit-box-orient:vertical;text-overflow:ellipsis;font-size:10px;line-height:10px;overflow:hidden;font-weight:400;margin:0;color:#fff;margin-left:10px}.tl-timeera .tl-timeera-content-container .tl-timeera-content .tl-timeera-text h2.tl-headline.tl-headline-fadeout:after{content:\"\";text-align:right;position:absolute;bottom:0;right:0;width:100%;height:50%;background:-moz-linear-gradient(top,hsla(0,0%,90%,0) 0,#e5e5e5 50%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,hsla(0,0%,90%,0)),color-stop(50%,#e5e5e5));background:-webkit-linear-gradient(top,hsla(0,0%,90%,0),#e5e5e5 50%);background:-o-linear-gradient(top,hsla(0,0%,90%,0) 0,#e5e5e5 50%);background:-ms-linear-gradient(top,hsla(0,0%,90%,0) 0,#e5e5e5 50%);background:linear-gradient(180deg,hsla(0,0%,90%,0) 0,#e5e5e5 50%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"@thecolor\",endColorstr=\"@thecolor\",GradientType=0)}.tl-timegroup{width:100%;position:absolute;top:0;left:0;background-color:#f2f2f2;display:-ms-flexbox;display:-webkit-flex;display:flex;align-items:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-webkit-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-moz-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-o-transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);transition:left 1s cubic-bezier(.77,0,.175,1),top .5s cubic-bezier(.77,0,.175,1),height .5s cubic-bezier(.77,0,.175,1),width 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timegroup .tl-timegroup-message{color:#e0e0e0;text-shadow:#fff 0 2px 2px;margin-left:80px}.tl-timegroup.tl-timegroup-alternate{background-color:#fafafa}.tl-timegroup.tl-timegroup-hidden{display:none}.tl-timeaxis-background{height:62px;width:100%;position:absolute;bottom:0;left:0;background-color:#fff;border-top:1px solid #e5e5e5;z-index:2}.tl-skinny .tl-timeaxis-background{height:52px}.tl-timeaxis{height:62px;width:100%;position:absolute;bottom:0;left:0;z-index:3}.tl-skinny .tl-timeaxis{height:52px}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major,.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor{opacity:0;position:absolute}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick,.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick{position:absolute;display:block;top:0;left:0;text-align:center;font-weight:400}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick .tl-timeaxis-tick-text,.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text{display:inline-block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick .tl-timeaxis-tick-text{padding-left:35px}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text{display:none}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick:before,.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick:before{content:\"\";display:block;color:#d8d8d8;border-left:1px solid #d8d8d8;width:0;height:10px;overflow:hidden;text-align:center}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major.tl-timeaxis-animate .tl-timeaxis-tick,.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor.tl-timeaxis-animate .tl-timeaxis-tick{-webkit-transition:all 1s cubic-bezier(.77,0,.175,1);-moz-transition:all 1s cubic-bezier(.77,0,.175,1);-o-transition:all 1s cubic-bezier(.77,0,.175,1);transition:all 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major.tl-timeaxis-animate-opacity .tl-timeaxis-tick,.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor.tl-timeaxis-animate-opacity .tl-timeaxis-tick{-webkit-transition:opacity 1s cubic-bezier(.77,0,.175,1);-moz-transition:opacity 1s cubic-bezier(.77,0,.175,1);-o-transition:opacity 1s cubic-bezier(.77,0,.175,1);transition:opacity 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major{z-index:1;background-color:#fff}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick{font-size:12px;line-height:14px;color:#5a9cb5;width:100px;margin-left:-50px}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick:before{border-color:#d8d8d8;font-size:18px;line-height:18px;height:36px;margin-bottom:-14px;margin-left:50px}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick{font-size:11px;line-height:13px;color:#5a9cb5;width:50px;margin-left:-25px}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text{opacity:0;white-space:normal;padding-left:2px;padding-right:2px}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text span{display:block;font-size:9px;line-height:9px;margin-top:-2px;color:#5a9cb5}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick:before{font-size:9px;line-height:9px;margin-left:25px}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick.tl-timeaxis-tick-hidden .tl-timeaxis-tick-text{opacity:0!important}.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick.tl-timeaxis-tick-hidden:before{opacity:1}.tlanimate{-webkit-transform:translateZ(0);-webkit-perspective:1000;-webkit-backface-visibility:hidden}.tl-animate{-webkit-transition:all 1s cubic-bezier(.77,0,.175,1);-moz-transition:all 1s cubic-bezier(.77,0,.175,1);-o-transition:all 1s cubic-bezier(.77,0,.175,1);transition:all 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-animate-opacity{-webkit-transition:opacity 1s cubic-bezier(.77,0,.175,1);-moz-transition:opacity 1s cubic-bezier(.77,0,.175,1);-o-transition:opacity 1s cubic-bezier(.77,0,.175,1);transition:opacity 1s cubic-bezier(.77,0,.175,1);-webkit-transition-timing-function:cubic-bezier(.77,0,.175,1);-moz-transition-timing-function:cubic-bezier(.77,0,.175,1);-o-transition-timing-function:cubic-bezier(.77,0,.175,1);transition-timing-function:cubic-bezier(.77,0,.175,1)}.tl-slide{position:absolute;width:100%;height:100%;padding:0;margin:0;overflow-x:hidden;overflow-y:auto}.tl-slide .tl-slide-background{position:absolute;left:0;top:0;width:100%;height:100%;z-index:-1;overflow:hidden;display:none;filter:alpha(opacity = 50);-khtml-opacity:.5;-moz-opacity:.5;opacity:.5;background:no-repeat 50%;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}.tl-slide .tl-slide-scrollable-container{display:table;table-layout:fixed;height:100%;z-index:1}.tl-slide .tl-slide-content-container{display:table-cell;vertical-align:middle;position:relative;width:100%;height:100%;z-index:3}.tl-slide .tl-slide-content-container .tl-slide-content{display:table;vertical-align:middle;padding-left:100px;padding-right:100px;position:relative;max-width:100%}.tl-slide .tl-slide-content-container .tl-slide-content .tl-media{position:relative;width:100%;min-width:50%;float:left;margin-top:auto;margin-bottom:auto}.tl-slide .tl-slide-content-container .tl-slide-content .tl-text{width:50%;max-width:50%;min-width:120px;padding:0 20px;display:table-cell;vertical-align:middle;text-align:left}.tl-slide-media-only .tl-slide-content-container .tl-slide-content{text-align:center}.tl-slide-media-only .tl-slide-content-container .tl-slide-content .tl-media{text-align:center;position:relative;width:100%;min-width:50%;max-width:100%;float:none;margin-top:auto;margin-bottom:auto}.tl-slide-media-only .tl-slide-content-container .tl-slide-content .tl-text{width:100%;max-width:100%;display:block;margin-left:auto;margin-right:auto;text-align:center}.tl-slide-text-only .tl-slide-content-container .tl-slide-content{text-align:center}.tl-slide-text-only .tl-slide-content-container .tl-slide-content .tl-text{max-width:80%;width:80%;display:block;margin-left:auto;margin-right:auto}.tl-slide.tl-full-color-background,.tl-slide.tl-full-color-background h1,.tl-slide.tl-full-color-background h2,.tl-slide.tl-full-color-background h3,.tl-slide.tl-full-color-background h4,.tl-slide.tl-full-color-background h5,.tl-slide.tl-full-color-background h6,.tl-slide.tl-full-color-background p,.tl-slide.tl-full-image-background,.tl-slide.tl-full-image-background h1,.tl-slide.tl-full-image-background h2,.tl-slide.tl-full-image-background h3,.tl-slide.tl-full-image-background h4,.tl-slide.tl-full-image-background h5,.tl-slide.tl-full-image-background h6,.tl-slide.tl-full-image-background p{color:#fff!important;text-shadow:1px 1px 1px #000!important}.tl-slide.tl-full-color-background a,.tl-slide.tl-full-color-background a:hover,.tl-slide.tl-full-color-background b,.tl-slide.tl-full-color-background blockquote,.tl-slide.tl-full-color-background blockquote p,.tl-slide.tl-full-color-background i,.tl-slide.tl-full-image-background a,.tl-slide.tl-full-image-background a:hover,.tl-slide.tl-full-image-background b,.tl-slide.tl-full-image-background blockquote,.tl-slide.tl-full-image-background blockquote p,.tl-slide.tl-full-image-background i{color:#fff!important;text-shadow:1px 1px 1px #000!important;color:#fff}.tl-slide.tl-full-color-background .tl-caption,.tl-slide.tl-full-color-background .tl-credit,.tl-slide.tl-full-color-background .tl-media-blockquote blockquote,.tl-slide.tl-full-color-background .tl-media-blockquote blockquote p,.tl-slide.tl-full-color-background .tl-media-twitter blockquote,.tl-slide.tl-full-color-background .tl-media-twitter blockquote p,.tl-slide.tl-full-color-background .vcard .nickname,.tl-slide.tl-full-color-background .vcard a,.tl-slide.tl-full-image-background .tl-caption,.tl-slide.tl-full-image-background .tl-credit,.tl-slide.tl-full-image-background .tl-media-blockquote blockquote,.tl-slide.tl-full-image-background .tl-media-blockquote blockquote p,.tl-slide.tl-full-image-background .tl-media-twitter blockquote,.tl-slide.tl-full-image-background .tl-media-twitter blockquote p,.tl-slide.tl-full-image-background .vcard .nickname,.tl-slide.tl-full-image-background .vcard a{color:#fff!important;text-shadow:1px 1px 1px #000!important}.tl-slide.tl-full-image-background{background:no-repeat 50%;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-position:center 25%;text-shadow:1px 1px 2px #000}.tl-slide.tl-full-image-background .tl-caption,.tl-slide.tl-full-image-background .tl-credit,.tl-slide.tl-full-image-background h1,.tl-slide.tl-full-image-background h2,.tl-slide.tl-full-image-background h3,.tl-slide.tl-full-image-background h4,.tl-slide.tl-full-image-background h5,.tl-slide.tl-full-image-background h6,.tl-slide.tl-full-image-background p{text-shadow:1px 1px 2px #000}.tl-slide.tl-full-image-background .tl-media-blockquote blockquote,.tl-slide.tl-full-image-background .tl-media-blockquote blockquote p,.tl-slide.tl-full-image-background .tl-media-twitter blockquote,.tl-slide.tl-full-image-background .tl-media-twitter blockquote p{text-shadow:1px 1px 2px #000!important}.tl-slide.tl-text-background .tl-text .tl-text-content-container{padding:20px;background:#000 transparent;background:rgba(0,0,0,.6);-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px}.tl-slide.tl-text-background .tl-text .tl-text-content-container h2{margin-top:5px}.tl-skinny .tl-slide{display:block;padding-top:10px}.tl-skinny .tl-slide .tl-slide-content-container{display:block;position:static;height:auto;height:100%;display:-webkit-flex;display:flex;align-items:center;-webkit-align-items:center}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content{display:block;display:-webkit-flex;display:flex;flex-direction:column-reverse;-webkit-flex-direction:column-reverse;position:static;height:auto;padding-left:50px;padding-right:50px}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media{position:static;width:100%;height:auto;float:none;display:block;padding-top:20px}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text{display:block;height:auto;vertical-align:initial;position:static;width:100%;max-width:100%;min-width:0;float:none;padding:0}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container{padding-left:10px;padding-right:10px;padding-bottom:10px}.tl-skinny .tl-slide.tl-full-image-background .tl-slide-content-container .tl-slide-content .tl-media,.tl-skinny .tl-slide.tl-slide.tl-full-color-background .tl-slide-content-container .tl-slide-content .tl-media{border-color:hsla(0,0%,90%,.25)}.tl-skinny .tl-slide.tl-slide-media-only .tl-slide-content-container .tl-slide-content{flex-direction:column;-webkit-flex-direction:column}.tl-skinny .tl-slide.tl-slide-media-only .tl-slide-content-container .tl-slide-content .tl-media{border-top:none;padding-top:0}.tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media embed,.tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media iframe,.tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media img,.tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media object,.tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media video{max-height:175px}.tl-slidenav-next,.tl-slidenav-previous{position:absolute;top:45%;z-index:10;cursor:pointer}.tl-slidenav-next .tl-slidenav-content-container,.tl-slidenav-previous .tl-slidenav-content-container{height:200px;width:100px;position:absolute}.tl-slidenav-next .tl-slidenav-description,.tl-slidenav-next .tl-slidenav-title,.tl-slidenav-previous .tl-slidenav-description,.tl-slidenav-previous .tl-slidenav-title{-webkit-line-clamp:2;line-clamp:2;text-overflow:ellipsis;filter:alpha(opacity = 40);-khtml-opacity:.4;-moz-opacity:.4;opacity:.4}.tl-slidenav-next .tl-slidenav-description small,.tl-slidenav-next .tl-slidenav-title small,.tl-slidenav-previous .tl-slidenav-description small,.tl-slidenav-previous .tl-slidenav-title small{display:block}.tl-slidenav-next .tl-slidenav-title,.tl-slidenav-previous .tl-slidenav-title{margin-top:10px;font-size:11px;line-height:11px}.tl-slidenav-next .tl-slidenav-description,.tl-slidenav-previous .tl-slidenav-description{font-size:11px;margin-top:5px;filter:alpha(opacity = 0);-khtml-opacity:0;-moz-opacity:0;opacity:0}.tl-slidenav-next .tl-slidenav-description small,.tl-slidenav-previous .tl-slidenav-description small{display:none}.tl-slidenav-next .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-description,.tl-slidenav-next .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-icon,.tl-slidenav-next .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-title,.tl-slidenav-previous .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-description,.tl-slidenav-previous .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-icon,.tl-slidenav-previous .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-title{color:#f2f2f2;text-shadow:1px 1px 1px #333}.tl-slidenav-next .tl-slidenav-icon,.tl-slidenav-previous .tl-slidenav-icon{font-family:tl-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:32px;margin-bottom:5px}.tl-slidenav-next{text-align:right;margin-right:10px;right:100px}.tl-slidenav-next .tl-slidenav-description,.tl-slidenav-next .tl-slidenav-title{margin-left:20px}.tl-slidenav-next .tl-slidenav-icon{margin-left:76px}.tl-slidenav-next .tl-slidenav-icon:before{content:\"\\E64F\"}.tl-slidenav-previous{text-align:left;margin-left:10px}.tl-slidenav-previous .tl-slidenav-icon{margin-left:0}.tl-slidenav-previous .tl-slidenav-icon:before{content:\"\\E650\"}.tl-skinny .tl-slidenav-next{right:32px}.tl-skinny .tl-slidenav-next .tl-slidenav-icon{margin-left:8px}.tl-skinny .tl-slidenav-next .tl-slidenav-content-container,.tl-skinny .tl-slidenav-previous .tl-slidenav-content-container{width:32px;height:32px}.tl-skinny .tl-slidenav-next .tl-slidenav-description,.tl-skinny .tl-slidenav-next .tl-slidenav-title,.tl-skinny .tl-slidenav-previous .tl-slidenav-description,.tl-skinny .tl-slidenav-previous .tl-slidenav-title{display:none}.tl-skinny .tl-slidenav-next .tl-slidenav-icon,.tl-skinny .tl-slidenav-previous .tl-slidenav-icon{filter:alpha(opacity = 33);-khtml-opacity:.33;-moz-opacity:.33;opacity:.33}.tl-layout-landscape.tl-mobile .tl-slidenav-next:active .tl-slidenav-icon{margin-left:0;filter:alpha(opacity = 100);-khtml-opacity:1;-moz-opacity:1;opacity:1}.tl-storyslider{width:100%;height:100%;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;position:relative;box-sizing:content-box;z-index:8}.tl-storyslider embed,.tl-storyslider iframe,.tl-storyslider img,.tl-storyslider object,.tl-storyslider video{max-width:100%;position:relative}.tl-storyslider .tl-slider-background{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1}.tl-storyslider .tl-slider-touch-mask{width:100%;height:100%;z-index:25;top:0;left:0;position:absolute}.tl-storyslider .tl-slider-container-mask{text-align:center;width:100%;height:100%;position:relative;z-index:5}.tl-storyslider .tl-slider-container-mask .tl-slider-container{position:absolute;top:0;left:0;width:100%;height:100%;text-align:center}.tl-storyslider .tl-slider-container-mask .tl-slider-container .tl-slider-item-container{width:100%;height:100%;display:table-cell;vertical-align:middle}.tl-media{width:100%;min-width:50%;height:100%;float:left;margin-top:auto;margin-bottom:auto;position:relative}.tl-media .tl-media-content-container.tl-media-content-container-text{border-right:1px solid #e6e6e6;padding-right:20px}.tl-media .tl-media-content-container .tl-media-content{position:relative}.tl-media .tl-media-content-container .tl-media-content:after,.tl-media .tl-media-content-container .tl-media-content:before{display:table;content:\"\"}.tl-media .tl-media-content-container .tl-media-content:after{clear:both}.tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror p{color:#f2f2f2;text-align:center}.tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror p span{color:#f2f2f2}.tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror [class*=\" tl-icon-\"],.tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror [class^=tl-icon-]{font-size:28px;color:#f2f2f2;text-align:center}.tl-media .tl-media-content-container .tl-media-content embed,.tl-media .tl-media-content-container .tl-media-content img,.tl-media .tl-media-content-container .tl-media-content object,.tl-media .tl-media-content-container .tl-media-content video{max-width:100%;max-height:100%}.tl-slide-media-only .tl-media .tl-media-content-container.tl-media-content-container-text{border-right:none;padding-right:0}.tl-media-shadow{position:relative;z-index:1;-webkit-box-shadow:0 12px 10px -10px rgba(0,0,0,.6);-moz-box-shadow:0 12px 10px -10px rgba(0,0,0,.6);box-shadow:0 12px 10px -10px rgba(0,0,0,.6)}.tl-slide.tl-full-color-background .vcard a,.tl-slide.tl-full-color-background a,.tl-slide.tl-full-image-background .vcard a,.tl-slide.tl-full-image-background a{color:#fff!important;text-shadow:1px 1px 1px #000!important;color:#fff}.tl-credit{color:#999;text-align:right;display:block;margin:0 auto;margin-top:6px;font-size:10px;line-height:13px}.tl-caption{text-align:left;margin-right:auto;margin-left:auto;margin-top:10px;color:#666;font-size:11px;line-height:14px;text-rendering:optimizeLegibility;word-wrap:break-word}.tl-full-color-background .tl-media-shadow:after,.tl-full-color-background .tl-media-shadow:before,.tl-full-image-background .tl-media-shadow:after,.tl-full-image-background .tl-media-shadow:before{background:0 0;-webkit-box-shadow:0 0 0 #000;-moz-box-shadow:0 0 0 #000;box-shadow:0 0 0 #000}.tl-skinny .tl-media{width:100%;height:auto;float:none;display:block}.tl-skinny .tl-media .tl-media-content-container.tl-media-content-container-text{border-right:0;padding-right:0}.tl-skinny .tl-media .tl-media-content-container .tl-caption,.tl-skinny .tl-media .tl-media-content-container .tl-credit{margin-top:2px;padding-left:10px;padding-right:10px;font-size:8px}.tl-skinny .tl-media .tl-media-content-container .tl-credit{margin-top:0}.tl-mobile.tl-skinny .tl-media{width:100%;height:auto;float:none;display:block}.tl-mobile.tl-skinny .tl-media .tl-media-content-container.tl-media-content-container-text{border-right:0;padding-right:0}.tl-text{width:50%;max-width:50%;min-width:120px;padding:0 20px;display:table-cell;vertical-align:middle;text-align:left;text-shadow:none}.tl-text,.tl-text p{color:#737373}.tl-text h2.tl-headline,.tl-text h2.tl-headline-title{margin-top:0}.tl-text .tl-headline-date,.tl-text h3.tl-headline-date{font-family:Barlow,sans-serif;margin:0 0 3px}.tl-text .tl-headline-date,.tl-text .tl-headline-date small,.tl-text h3.tl-headline-date,.tl-text h3.tl-headline-date small{font-size:15px;line-height:15px;font-weight:400;color:#b3b3b3}.tl-text .tl-text-date{display:inline-block;font-family:Barlow,sans-serif;font-weight:400;margin-top:10px;font-size:12px;color:#b3b3b3}.tl-full-color-background .tl-text,.tl-full-color-background .tl-text p,.tl-full-image-background .tl-text,.tl-full-image-background .tl-text p{color:#f2f2f2!important;text-shadow:1px 1px 2px #000}.tl-full-color-background .tl-text .tl-headline-date,.tl-full-color-background .tl-text .tl-headline-date small,.tl-full-color-background .tl-text h3.tl-headline-date,.tl-full-color-background .tl-text h3.tl-headline-date small,.tl-full-color-background .tl-text p .tl-headline-date,.tl-full-color-background .tl-text p .tl-headline-date small,.tl-full-color-background .tl-text p h3.tl-headline-date,.tl-full-color-background .tl-text p h3.tl-headline-date small,.tl-full-image-background .tl-text .tl-headline-date,.tl-full-image-background .tl-text .tl-headline-date small,.tl-full-image-background .tl-text h3.tl-headline-date,.tl-full-image-background .tl-text h3.tl-headline-date small,.tl-full-image-background .tl-text p .tl-headline-date,.tl-full-image-background .tl-text p .tl-headline-date small,.tl-full-image-background .tl-text p h3.tl-headline-date,.tl-full-image-background .tl-text p h3.tl-headline-date small{color:#f2f2f2!important}.tl-skinny .tl-text{width:100%;max-width:100%;min-width:auto;float:none;margin-top:20px}.tl-medium .tl-text h2.tl-headline,.tl-medium .tl-text h2.tl-headline-title{font-size:32px;line-height:36px}.tl-mobile.tl-skinny .tl-media .tl-media-image{max-height:250px!important}.tl-media .tl-media-twitter{text-align:left;clear:both}.tl-media .tl-media-twitter blockquote{margin:0;margin-right:15px;font-size:15px;line-height:21px;color:#333}.tl-media .tl-media-twitter blockquote p{font-size:28px;line-height:30px;color:#000}.tl-media .tl-media-twitter blockquote p:after,.tl-media .tl-media-twitter blockquote p:before{display:none}.tl-media .tl-media-twitter .tl-icon-twitter{color:#55acee}.tl-media .tl-media-twitter .vcard a.tl-date:hover,.tl-media .tl-media-twitter .vcard a:hover{text-decoration:none;color:#55acee}.tl-media .tl-media-twitter .vcard a.tl-date:hover .fn,.tl-media .tl-media-twitter .vcard a.tl-date:hover .nickname,.tl-media .tl-media-twitter .vcard a:hover .fn,.tl-media .tl-media-twitter .vcard a:hover .nickname{color:#55acee}.tl-slide-media-only .tl-media .tl-media-twitter{width:80%;margin-left:auto;margin-right:auto}.tl-mobile.tl-skinny .tl-media .tl-media-twitter blockquote p{font-size:15px;line-height:21px}.tl-skinny .tl-media .tl-media-twitter{margin-left:10px;margin-right:10px}.tl-skinny .tl-media .tl-media-twitter blockquote p{font-size:24px;line-height:26px}.tl-media .tl-media-blockquote{text-align:left;clear:both}.tl-media .tl-media-blockquote blockquote{margin:0;margin-right:15px;text-align:left}.tl-media .tl-media-blockquote blockquote,.tl-media .tl-media-blockquote blockquote p{font-size:28px;line-height:30px;color:#333}.tl-media .tl-media-blockquote blockquote p:after,.tl-media .tl-media-blockquote blockquote p:before{display:inline-block;font-size:36px}.tl-media .tl-media-blockquote blockquote p:before{content:open-quote;margin-right:5px}.tl-media .tl-media-blockquote blockquote p:after{content:close-quote;margin-left:3px}.tl-media .tl-media-blockquote blockquote cite{font-size:15px;line-height:21px;color:#999;text-align:right;margin-top:15px}.tl-slide-media-only .tl-media .tl-media-blockquote{border-right:0;width:80%;margin-left:auto;margin-right:auto}@media only screen and (max-device-width:800px),only screen and (max-width:800px){.tl-media .tl-media-blockquote blockquote p{font-size:24px;line-height:26px}}@media only screen and (max-device-width:500px),only screen and (max-width:500px){.tl-media .tl-media-blockquote blockquote p{font-size:15px;line-height:21px}}.tl-mobile.tl-skinny .tl-media .tl-media-instagram{max-height:250px!important}.tl-media .tl-media-profile{border-radius:50%}.tl-media .tl-media-iframe,.tl-media .tl-media-iframe iframe{width:100%;height:100%}.tl-media .tl-media-wikipedia{text-align:left;margin-left:auto;margin-right:auto;clear:both}.tl-media .tl-media-wikipedia .tl-icon-wikipedia{font-size:32px;margin-right:10px;float:left;padding-top:3px}.tl-media .tl-media-wikipedia .tl-wikipedia-pageimage{float:left;margin-right:10px;margin-bottom:5px;margin-top:5px}.tl-media .tl-media-wikipedia .tl-wikipedia-title{margin-left:60px;padding-left:10px;border-left:1px solid #e6e6e6;margin-bottom:10px}.tl-media .tl-media-wikipedia .tl-wikipedia-source{font-size:13px;line-height:15px;font-style:italic;margin-top:3px;display:block;color:rgba(0,0,0,.5)}.tl-media .tl-media-wikipedia h4{margin-top:0;margin-bottom:0}.tl-media .tl-media-wikipedia h4 a{color:#000;text-decoration:none}.tl-media .tl-media-wikipedia h4 a:hover{text-decoration:underline}.tl-media .tl-media-wikipedia p{font-size:13px;line-height:19px}.tl-slide-media-only .tl-media .tl-media-wikipedia{border-right:0;border-top:1px solid #e6e6e6;width:80%;margin-left:auto;margin-right:auto;margin-top:25px;padding-top:25px}.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia,.tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia{padding:20px;background:#000 transparent;background:rgba(0,0,0,.6);-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px}.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia h4 a,.tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia h4 a{color:#fff!important;text-shadow:1px 1px 1px #000!important}.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia .tl-wikipedia-title,.tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia .tl-wikipedia-title{border-color:hsla(0,0%,90%,.25)}.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia .tl-wikipedia-source,.tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia .tl-wikipedia-source{color:hsla(0,0%,90%,.85)}.tl-mobile.tl-skinny .tl-media .tl-media-wikipedia,.tl-skinny .tl-media .tl-media-wikipedia{margin-left:10px;margin-right:10px}.tl-media .tl-media-website{text-align:left;margin-left:auto;margin-right:auto;clear:both}.tl-media .tl-media-website .tl-media-website-description{font-size:16px;line-height:19px;font-style:italic;margin-bottom:10px;text-transform:uppercase}.tl-media .tl-media-website h4{margin-top:0;margin-bottom:0;line-height:1}.tl-media .tl-media-website h4 a{color:#000;text-decoration:none}.tl-media .tl-media-website h4 a:hover{text-decoration:underline}.tl-media .tl-media-website p{font-size:13px;line-height:19px}.tl-media .tl-media-content-container .tl-media-content .tl-media-website img{float:right;max-width:120px;max-height:120px;margin:4px 0 0 15px}.tl-media .tl-media-content-container .tl-media-content .tl-media-website img.tl-media-website-icon{max-width:16px;max-height:16px;float:none;margin:0;margin-right:3px}.tl-slide.tl-full-color-background .tl-media .tl-media-website,.tl-slide.tl-full-image-background .tl-media .tl-media-website{padding:20px;background:#000 transparent;background:rgba(0,0,0,.6);-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px}.tl-slide.tl-full-color-background .tl-media .tl-media-website h4 a,.tl-slide.tl-full-image-background .tl-media .tl-media-website h4 a{color:#fff!important;text-shadow:1px 1px 1px #000!important}.tl-mobile.tl-skinny .tl-media .tl-media-website{margin-left:10px;margin-right:10px}.tl-timeline{width:100%;height:100%;font-size:16px;line-height:normal;overflow:hidden;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;background-color:#fff;color:#737373;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.tl-timeline.tl-timeline-embed{box-sizing:border-box;border-top:1px solid #ccc;border-bottom:1px solid #ccc;border-radius:0}.tl-timeline.tl-timeline-full-embed{box-sizing:border-box;border:1px solid #ccc;border-radius:8px}.tl-layout-portrait .tl-storyslider{-webkit-box-shadow:0 -3px 6px rgba(0,0,0,.2);-moz-box-shadow:0 -3px 6px rgba(0,0,0,.2);box-shadow:0 -3px 6px rgba(0,0,0,.2)}.tl-rtl .blockquote,.tl-rtl .tl-headline,.tl-rtl .tl-headline-date,.tl-rtl .tl-media-blockquote,.tl-rtl .tl-media-website,.tl-rtl .tl-media-wikipedia,.tl-rtl .tl-media .tl-media-blockquote blockquote,.tl-rtl .tl-text-content,.tl-rtl .tl-text-content p,.tl-rtl .tl-timeline blockquote p,.tl-rtl blockquote p{text-align:right;direction:rtl}.tl-rtl .tl-slide-media-only .tl-headline,.tl-rtl .tl-slide-media-only .tl-headline-date{text-align:center}.tl-rtl .tl-timemarker-text{margin-right:35px}.tl-rtl .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container{float:right}.tl-rtl .tl-caption{text-align:right}.tl-rtl .tl-credit{text-align:left}", "", {"version":3,"sources":["/app/assets/css/timeline/timeline.css"],"names":[],"mappings":"AAQA,kBACE,+BAAgC,AAChC,4BAA6B,AAC7B,sBAAwB,CACzB,AAED,mzCACE,SAAU,AACV,UAAW,AACX,SAAU,AACV,gBAAiB,AACjB,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,oBAAqB,AACrB,WAAY,AACZ,UAAY,CACb,AAED,0FACE,UAAY,CACb,AAED,kBACE,yBAA0B,AAC1B,gBAAkB,CACnB,AAED,8BACE,eAAiB,CAClB,AAED,oGACE,UAAY,CACb,AAED,oBACE,mBAAqB,CACtB,AAED,yCACE,SAAW,CACZ,AAED,iMACE,aAAe,CAChB,AAED,uDACE,oBAAsB,CACvB,AAED,kCACE,YAAc,CACf,AAED,gBACE,cAAgB,CACjB,AAED,gCACE,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,uBAAyB,CAC1B,AAED,gBACE,SAAW,CACZ,AAED,gBACE,aAAe,CAChB,AAED,gBACE,SAAU,AACV,8BAAgC,CACjC,AAED,6EACE,eAAgB,AAChB,SAAU,AACV,uBAAyB,CAC1B,AAED,qCACE,kBAAoB,CACrB,AAED,yEACE,SAAU,AACV,SAAW,CACZ,AAED,+GACE,eAAgB,AAChB,yBAA2B,CAC5B,AAED,+BACE,6BAA8B,AAC9B,+BAAgC,AAChC,4BAA6B,AAC7B,sBAAwB,CACzB,AAED,0DACE,uBAAyB,CAC1B,AAED,qBACE,cAAe,AACf,kBAAoB,CACrB,AAED,aACE,kBAAoB,CACrB,AAED,gGACE,UAAY,CACb,AAED,gDACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,kEACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,gDACE,eAAgB,AAChB,iBAAkB,AAClB,eAAiB,CAClB,AAED,kEACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,kCACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,wCACE,cAAe,AACf,eAAgB,AAChB,eAAgB,AAChB,gBAAkB,CACnB,AAED,gBACE,gBAAiB,AACjB,iBAAmB,CACpB,AAED,eACE,eAAgB,AAChB,mBAAoB,AACpB,eAAgB,AAChB,uBAAwB,AACxB,UAAY,CACb,AAED,oBACE,cAAgB,CACjB,AAED,iBACE,WAAY,AACZ,yBAA2B,CAC5B,AAED,8CACE,aAAe,CAChB,AAED,oEACE,iBACE,0BAA2B,AAC3B,sBAAuB,AACvB,gBAAkB,CACnB,AAED,8CACE,cAAe,AACf,yBAA2B,CAC5B,CACF,AAED,mCACE,eAAiB,CAClB,AAED,+BACE,iBAAmB,CACpB,AAED,eACE,qBAAsB,AACtB,aAAe,CAChB,AAED,qBACE,0BAA2B,AAC3B,aAAe,CAChB,AAED,mHACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,2HACE,UAAY,CACb,AAED,0BACE,qBAAsB,AACtB,sBAAuB,AACvB,qBAAsB,AACtB,kBAAmB,AACnB,YAAc,CACf,AAED,kDACE,8BAAgC,AAChC,WAAY,AACZ,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AACjB,eAAgB,AAChB,SAAU,AACV,SAAW,CACZ,AAED,4DACE,8BAAgC,AAChC,eAAgB,AAChB,WAAY,AACZ,cAAe,AACf,iBAAkB,AAClB,iBAAmB,CACpB,AAED,0EACE,eAAiB,CAClB,AAED,iCACE,mBAAoB,AACpB,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,gBAAkB,CACnB,AAED,gCACE,oBAAqB,AACrB,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,eAAiB,CAClB,AAED,wBACE,WAAa,CACd,AAED,0BACE,QAAU,CACX,AAED,oBACE,8BAA+B,AAC/B,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CAClB,AAED,qDACE,cAAe,AACf,UAAY,CACb,AAED,0BACE,UAAY,CACb,AAED,kCACE,gBAAiB,AACjB,cAAgB,CACjB,AAED,4BACE,WAAa,CACd,AAED,sBACE,WAAY,AACZ,oBAAsB,CACvB,AAED,4BACE,oBAAsB,CACvB,AAED,sEACE,aAAe,CAChB,AAED,sDACE,iBAAmB,CACpB,AAED,wBACE,cAAe,AACf,eAAiB,CAClB,AAED,8BACE,eAAgB,AAChB,cAAe,AACf,UAAY,CACb,AAED,4BACE,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,WAAa,CACd,AAED,gCACE,uBAAwB,AACxB,0BAA2B,AAC3B,iBAAmB,CACpB,AAED,yBACE,UAAW,AACX,kBAAmB,AACnB,QAAU,CACX,AAED,4BACE,iBAAmB,CACpB,AAED,qCACE,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,mBAAoB,AACpB,mBAAqB,CACtB,AAED,kEACE,qBAAsB,AACtB,yBAA0B,AAC1B,WAAY,AACZ,kBAA6B,AAC7B,iBAAmB,CACpB,AAED,sBACE,cAAe,AACf,8BAA+B,AAC/B,kBAAmB,AACnB,yBAA0B,AAC1B,eAAgB,AAChB,iBAAkB,AAClB,aAAc,AACd,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,cAAe,AACf,yBAA0B,AAC1B,yBAA0B,AAC1B,gBAAkB,CACnB,AAED,kFACE,gDACE,eAAgB,AAChB,gBAAkB,CACnB,CACF,AAED,kFACE,gDACE,eAAgB,AAChB,gBAAkB,CACnB,CACF,AAED,cACE,YAAc,CACf,AAUD,uCACE,qBAAsB,AACtB,WAAY,AACZ,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,cAAe,AACf,mCAAoC,AACpC,iCAAmC,CACpC,AAED,oBACE,eAAiB,CAClB,AAED,yBACE,eAAiB,CAClB,AAED,6BACE,eAAiB,CAClB,AAED,4BACE,eAAiB,CAClB,AAED,4BACE,eAAiB,CAClB,AAED,0BACE,eAAiB,CAClB,AAED,4BACE,eAAiB,CAClB,AAED,mBACE,eAAiB,CAClB,AAED,qBACE,eAAiB,CAClB,AAED,iCACE,eAAiB,CAClB,AAED,+BACE,eAAiB,CAClB,AAED,2BACE,eAAiB,CAClB,AAED,4BACE,eAAiB,CAClB,AAED,uBACE,eAAiB,CAClB,AAED,2BACE,eAAiB,CAClB,AAMD,4CACE,eAAiB,CAClB,AAMD,gDACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,uBACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,oBACE,eAAiB,CAClB,AAMD,4CACE,eAAiB,CAClB,AAMD,kDACE,eAAiB,CAClB,AAED,mBACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,0BACE,eAAiB,CAClB,AAMD,mDACE,eAAiB,CAClB,AAED,sBACE,eAAiB,CAClB,AAED,sBACE,eAAiB,CAClB,AAED,sBACE,eAAiB,CAClB,AAED,sBACE,eAAiB,CAClB,AAED,sBACE,eAAiB,CAClB,AAED,2BACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,sBACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,qBACE,eAAiB,CAClB,AAED,qBACE,eAAiB,CAClB,AAED,yBACE,eAAiB,CAClB,AAED,yBACE,eAAiB,CAClB,AAED,0BACE,eAAiB,CAClB,AAED,0BACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,2BACE,eAAiB,CAClB,AAED,qBACE,eAAiB,CAClB,AAED,0BACE,eAAiB,CAClB,AAED,wBACE,eAAiB,CAClB,AAED,sBACE,eAAiB,CAClB,AAED,2BACE,eAAiB,CAClB,AAED,0BACE,eAAiB,CAClB,AAED,4BACE,eAAiB,CAClB,AAED,2BACE,eAAiB,CAClB,AAED,aACE,2BAA4B,AAC5B,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,oBAAqB,AACrB,gBAAkB,CACnB,AAED,YACE,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,gCAAiC,AACjC,6BAA8B,AAC9B,SAAU,AACV,SAAU,AACV,MAAQ,CACT,AA0CD,mBACE,eAAgB,AAChB,iBAAkB,AAClB,mCAA2C,AAC3C,eAAgB,AAChB,iBAA2B,AAC3B,qBAAsB,AACtB,cAAe,AACf,aAAe,CAChB,AAED,8CACE,WAAa,CACd,AAED,yBACE,gBAAiB,AACjB,UAAY,CACb,AAED,oDACE,cAAe,AACf,kCAA2C,CAC5C,AAED,8BACE,aAAe,CAChB,AAED,oCACE,oCAA4C,AAC5C,aAAe,CAChB,AAED,qCACE,mBAAoB,AACpB,UAAY,CACb,AAED,yBACE,GACE,qBAAuB,CACxB,AAED,GACE,qBAAuB,CACxB,CACF,AAED,iCACE,GACE,eAAiB,CAClB,AAED,GACE,eAAiB,CAClB,CACF,AAED,yBACE,GACE,qBAAuB,CACxB,AAED,GACE,qBAAuB,CACxB,CACF,AAED,iCACE,GACE,eAAiB,CAClB,AAED,GACE,eAAiB,CAClB,CACF,AAED,6BACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AAED,yEACE,aAAc,AACd,YAAa,AACb,kBAAmB,AACnB,sBAAuB,AACvB,kBAAoB,CACrB,AAED,iHACE,WAAY,AACZ,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,yBAA0B,AAC1B,iBAAkB,AAClB,oBAAqB,AACrB,4BAA8B,CAC/B,AAED,+HACE,wBAA0B,CAC3B,AAED,2GACE,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,sBAAuB,AACvB,sDAA6D,AAC7D,mDAA0D,AAC1D,8CAAqD,AACrD,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,wDAAyD,AACzD,+CAAiD,CAClD,AAED,+BACE,GACE,oCAAsC,CACvC,AAED,IACE,oDAAsD,CACvD,AAED,GACE,oEAAsE,CACvE,CACF,AAED,uBACE,GACE,kDAAoD,CACrD,AAED,IACE,0DAA4D,CAC7D,AAED,GACE,gEAAkE,CACnE,CACF,AAED,iBACE,mCAA2C,CAC5C,AAED,yEACE,WAAY,AACZ,cAAgB,CACjB,AAED,2DACE,eAAgB,AAChB,iBAAkB,AAClB,iBAAkB,AAClB,WAAY,AACZ,oBAAqB,AACrB,eAAiB,CAClB,AAED,sEACE,qBAAsB,AACtB,eAAgB,AAChB,sBAAuB,AACvB,WAAY,AACZ,aAAc,AACd,gBAAiB,AACjB,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AAED,YACE,WAAY,AACZ,yBAA0B,AAC1B,kBAAmB,AACnB,gBAAiB,AACjB,4BAA8B,CAC/B,AAED,4BACE,eAAgB,AAChB,UAAW,AACX,kBAAmB,AACnB,WAAY,AACZ,OAAQ,AACR,eAAgB,AAChB,iBAAkB,AAClB,wCAA2C,AAC3C,qCAA4C,AAC5C,WAAa,CACd,AAED,8BACE,UAAY,CACb,AAED,oCACE,WAAY,AACZ,oBAAsB,CACvB,AAED,uDACE,wBAA0B,CAC3B,AAED,+CACE,qBAAsB,AACtB,sBAAuB,AACvB,WAAY,AACZ,UAAW,AACX,iBAAkB,AAClB,yBAA0B,AAC1B,sBAAuB,AACvB,wBAAyB,AACzB,4BAA6B,AAC7B,+BAAiC,CAClC,AAED,6BACE,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,UAAW,AACX,YAAa,AACb,yBAA0B,AAC1B,UAAW,AACX,YAAc,CACf,AAED,uEACE,qBAAsB,AACtB,WAAY,AACZ,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,cAAe,AACf,mCAAoC,AACpC,kCAAmC,AACnC,cAAe,AACf,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACb,AAED,oCACE,SAAW,CACZ,AAED,mCACE,gBAAiB,AACjB,WAAa,CACd,AAED,+BACE,kBAAmB,AACnB,YAAa,AACb,WAAY,AACZ,KAAO,CACR,AAED,yDACE,qDAA2D,AAC3D,kDAAwD,AACxD,gDAAsD,AACtD,6CAAmD,AACnD,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,6DACE,kBAAmB,AACnB,YAAa,AACb,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AAED,0DACE,kBAAmB,AACnB,YAAa,AACb,KAAO,CACR,AAOD,2LACE,kBAAmB,AACnB,WAAa,CACd,AAED,eACE,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,eAAgB,AAChB,mKAA6L,AAC7L,gKAA0L,AAC1L,8JAAwL,AACxL,2JAAqL,AACrL,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,kCACE,iIAAsJ,AACtJ,8HAAmJ,AACnJ,4HAAiJ,AACjJ,yHAA8I,AAC9I,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,mEACE,8FAA4G,AAC5G,2FAAyG,AACzG,yFAAuG,AACvG,qFAAoG,CACrG,AAED,0DACE,8FAA4G,AAC5G,2FAAyG,AACzG,yFAAuG,AACvG,qFAAoG,CACrG,AAED,uCACE,oBAAqB,AACrB,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,YAAa,AACb,oCAA4C,AAC5C,4BAA6B,AAC7B,2BAA4B,AAC5B,6FAA0G,AAC1G,0FAAuG,AACvG,wFAAqG,AACrG,qFAAkG,AAClG,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,uEACE,aAAc,AACd,kBAAmB,AACnB,WAAY,AACZ,yBAA0B,AAC1B,2BAA4B,AAC5B,4BAA6B,AAC7B,aAAc,AACd,qBAAuB,CACxB,AAED,yCACE,aAAc,AACd,OAAS,CACV,AAED,wCACE,UAAW,AACX,MAAQ,CACT,AAED,iFACE,eAAgB,AAChB,8BAA+B,AAC/B,2BAA4B,AAC5B,sBAAuB,AACvB,8BAA+B,AAC/B,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,2BAA4B,AAC5B,yBAA0B,AAC1B,wBAAyB,AACzB,sBAAuB,AACvB,qBAAsB,AACtB,iBAAkB,AAClB,2BAA6B,CAC9B,AAED,6FACE,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,WAAY,AACZ,UAAW,AACX,yBAA0B,AAC1B,UAAW,AACX,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AAED,gDACE,kBAAmB,AACnB,yBAA0B,AAC1B,SAAU,AACV,2BAA4B,AAC5B,4BAA6B,AAC7B,+BAAgC,AAChC,YAAa,AACb,YAAa,AAGb,UAAW,AACX,6FAA0G,AAC1G,0FAAuG,AACvG,wFAAqG,AACrG,qFAAkG,AAClG,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,sDAA4D,AAC5D,sBAAuB,AACvB,yBAA0B,AAC1B,2BAA6B,CAC9B,AAED,sDACE,SAAW,CACZ,AAED,uEACE,kBAAmB,AAGnB,YAAa,AACb,UAAW,AAGX,8BAA+B,AAC/B,2BAA4B,AAC5B,qBAAuB,CACxB,AAED,2FAEE,iBAAmB,CACpB,AAED,sNAEE,2BAA6B,AAC7B,mCAAqC,AAIrC,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,gBAAiB,AACjB,gBAAiB,AACjB,SAAU,AACV,8BAAgC,AAGhC,iBAAmB,CACpB,AAmBD,sGACE,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,iBAAkB,AAClB,YAAa,AACb,8BAA+B,AAC/B,2BAA4B,AAC5B,qBAAuB,CACxB,AAED,2HACE,eAAgB,AAChB,gBAAiB,AACjB,WAAa,CACd,AAED,mPACE,cAAe,AACf,eAAgB,AAChB,cAAe,AACf,YAAc,CACf,AAED,yHACE,cAAgB,CACjB,AAED,sIACE,cAAe,AACf,mBAAoB,AACpB,sBAAwB,CACzB,AAED,2SACE,cAAgB,CACjB,AAqCD,0IACE,oEAA6E,AAC7E,gHAA6H,AAC7H,qEAAgF,AAChF,kEAA2E,AAC3E,mEAA4E,AAC5E,kEAA8E,AAC9E,mHAAuH,CACxH,AAED,iIACE,SAAW,CACZ,AAED,+PACE,UAAY,CACb,AAED,+JACE,kEAA0E,AAC1E,8GAA0H,AAC1H,mEAA6E,AAC7E,gEAAwE,AACxE,iEAAyE,AACzE,gEAA2E,AAC3E,mHAAuH,CACxH,AAUD,4DACE,oCAA2C,AAC3C,SAAW,CACZ,AAED,4FACE,qBAAuB,CACxB,AAED,2HACE,+BAAoC,AACpC,iBAAkB,AAClB,UAAW,AACX,sCAA+C,CAChD,AAED,uIACE,qBAAuB,CACxB,AAwBD,gJACE,SAAW,CACZ,AAED,6RACE,UAAY,CACb,AAED,8FACE,aAAe,CAChB,AAED,+KACE,SAAW,CACZ,AAED,oEACE,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,WAAY,AACZ,oCAA4C,AAC5C,UAAW,AACX,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AAED,4GACE,eAAiB,CAClB,AAED,gEACE,aAAe,CAChB,AAED,+DACE,eAAiB,CAClB,AAED,0EACE,gCAAsC,CACvC,AAED,yFACE,kCAAwC,CACzC,AAED,yKACE,gBAAkB,CACnB,AAED,qLACE,+BAAkC,CACnC,AAED,oFACE,eAAiB,CAClB,AAED,+FACE,kCAAwC,CACzC,AAED,YACE,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,oBAAqB,AACrB,UAAW,AACX,mKAA6L,AAC7L,gKAA0L,AAC1L,8JAAwL,AACxL,2JAAqL,AACrL,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,4BACE,iIAAsJ,AACtJ,8HAAmJ,AACnJ,4HAAiJ,AACjJ,yHAA8I,AAC9I,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,mCACE,kBAAmB,AACnB,yBAA0B,AAC1B,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AAED,qDACE,wBAA0B,CAC3B,AAED,qDACE,wBAA0B,CAC3B,AAED,qDACE,wBAA0B,CAC3B,AAED,qDACE,wBAA0B,CAC3B,AAED,qDACE,wBAA0B,CAC3B,AAED,qDACE,wBAA0B,CAC3B,AAED,0CACE,kBAAmB,AACnB,SAAU,AACV,2BAA4B,AAC5B,4BAA6B,AAC7B,+BAAgC,AAChC,YAAa,AACb,YAAa,AACb,gBAAiB,AACjB,6FAA0G,AAC1G,0FAAuG,AACvG,wFAAqG,AACrG,qFAAkG,AAClG,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,sDAA4D,AAC5D,sBAAuB,AACvB,wBAA0B,CAC3B,AAED,8DACE,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,YAAa,AACb,8BAA+B,AAC/B,2BAA4B,AAC5B,qBAAuB,CACxB,AAED,+EACE,gBAAiB,AACjB,kBAAmB,AACnB,WAAa,CACd,AAED,8FACE,SAAU,AACV,kBAAmB,AACnB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AACtB,oBAAqB,AACrB,4BAA6B,AAC7B,uBAAwB,AACxB,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AACjB,gBAAiB,AACjB,SAAU,AACV,WAAY,AACZ,gBAAkB,CACnB,AAED,wHACE,WAAY,AACZ,iBAAkB,AAClB,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,WAAY,AACZ,WAAY,AACZ,oEAA6E,AAC7E,gHAA6H,AAC7H,qEAAgF,AAChF,kEAA2E,AAC3E,mEAA4E,AAC5E,kEAA8E,AAC9E,mHAAuH,CACxH,AAED,cACE,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,yBAA0B,AAC1B,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,mBAAoB,AACpB,sBAAuB,AACvB,2BAA4B,AAC5B,yBAA0B,AAC1B,mKAA6L,AAC7L,gKAA0L,AAC1L,8JAAwL,AACxL,2JAAqL,AACrL,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,oCACE,cAAe,AACf,2BAA4B,AAC5B,gBAAkB,CACnB,AAED,qCACE,wBAA0B,CAC3B,AAED,kCACE,YAAc,CACf,AACD,wBACE,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,sBAAuB,AACvB,6BAA8B,AAC9B,SAAW,CACZ,AAED,mCACE,WAAa,CACd,AAED,aACE,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,SAAW,CACZ,AAED,wBACE,WAAa,CACd,AAED,8HACE,UAAW,AACX,iBAAmB,CACpB,AAED,kKACE,kBAAmB,AACnB,cAAe,AACf,MAAO,AACP,OAAQ,AACR,kBAAmB,AACnB,eAAiB,CAClB,AAED,gNACE,qBAAsB,AACtB,mBAAoB,AACpB,uBAAwB,AACxB,eAAiB,CAClB,AAED,wGACE,iBAAmB,CACpB,AACD,wGACE,YAAa,CACd,AACD,gLACE,WAAY,AACZ,cAAe,AACf,cAAe,AACf,8BAA+B,AAC/B,QAAS,AACT,YAAa,AACb,gBAAiB,AACjB,iBAAmB,CACpB,AAED,0MACE,qDAA2D,AAC3D,kDAAwD,AACxD,gDAAsD,AACtD,6CAAmD,AACnD,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,0NACE,yDAA+D,AAC/D,sDAA4D,AAC5D,oDAA0D,AAC1D,iDAAuD,AACvD,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,+DACE,UAAW,AACX,qBAAuB,CACxB,AAED,iFACE,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,YAAa,AACb,iBAAmB,CACpB,AAED,wFACE,qBAAsB,AACtB,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,oBAAqB,AACrB,gBAAkB,CACnB,AAED,iFACE,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,WAAY,AACZ,iBAAmB,CACpB,AAED,wGACE,UAAW,AACX,mBAAoB,AACpB,iBAAkB,AAClB,iBAAmB,CACpB,AAED,6GACE,cAAe,AACf,cAAe,AACf,gBAAiB,AACjB,gBAAiB,AACjB,aAAe,CAChB,AAED,wFACE,cAAe,AACf,gBAAiB,AACjB,gBAAkB,CACnB,AAED,gIACE,mBAAsB,CACvB,AAED,gHACE,SAAW,CACZ,AAED,WACE,gCAAiC,AACjC,yBAA0B,AAC1B,kCAAoC,CACrC,AAED,YACE,qDAA2D,AAC3D,kDAAwD,AACxD,gDAAsD,AACtD,6CAAmD,AACnD,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,oBACE,yDAA+D,AAC/D,sDAA4D,AAC5D,oDAA0D,AAC1D,iDAAuD,AACvD,8DAAoE,AACpE,2DAAiE,AACjE,yDAA+D,AAC/D,qDAA4D,CAC7D,AAED,UACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,UAAW,AACX,SAAU,AACV,kBAAmB,AACnB,eAAiB,CAClB,AAED,+BACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,gBAAiB,AACjB,aAAc,AACd,2BAA4B,AAC5B,kBAAmB,AACnB,gBAAiB,AACjB,WAAY,AACZ,yBAAoC,AACpC,8BAA+B,AAC/B,2BAA4B,AAC5B,yBAA0B,AAC1B,qBAAuB,CACxB,AAED,yCACE,cAAe,AACf,mBAAoB,AACpB,YAAa,AACb,SAAW,CACZ,AAED,sCACE,mBAAoB,AACpB,sBAAuB,AACvB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AAED,wDACE,cAAe,AACf,sBAAuB,AACvB,mBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,cAAgB,CACjB,AAED,kEACE,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,gBAAiB,AACjB,kBAAoB,CACrB,AAED,iEACE,UAAW,AACX,cAAe,AACf,gBAAiB,AACjB,eAAuB,AACvB,mBAAoB,AACpB,sBAAuB,AACvB,eAAiB,CAClB,AAED,mEACE,iBAAmB,CACpB,AAED,6EACE,kBAAmB,AACnB,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,eAAgB,AAChB,WAAY,AACZ,gBAAiB,AACjB,kBAAoB,CACrB,AAED,4EACE,WAAY,AACZ,eAAgB,AAChB,cAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,iBAAmB,CACpB,AAED,kEACE,iBAAmB,CACpB,AAED,2EACE,cAAe,AACf,UAAW,AACX,cAAe,AACf,iBAAkB,AAClB,iBAAmB,CACpB,AAOD,wlBACE,qBAAuB,AACvB,sCAAyC,CAC1C,AAED,gfACE,qBAAuB,AACvB,uCAAyC,AACzC,UAAY,CACb,AAiBD,84BACE,qBAAuB,AACvB,sCAAyC,CAC1C,AAED,mCACE,yBAAoC,AACpC,8BAA+B,AAC/B,2BAA4B,AAC5B,yBAA0B,AAC1B,sBAAuB,AACvB,+BAAgC,AAChC,4BAA8B,CAC/B,AAMD,sWACE,4BAA8B,CAC/B,AAMD,0QACE,sCAAyC,CAC1C,AAED,iEACE,aAAc,AACd,4BAA6B,AAC7B,0BAA+B,AAC/B,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AAED,oEACE,cAAgB,CACjB,AAED,qBACE,cAAe,AACf,gBAAkB,CACnB,AAED,iDACE,cAAe,AACf,gBAAiB,AACjB,YAAa,AACb,YAAa,AACb,qBAAsB,AACtB,aAAc,AACd,mBAAoB,AACpB,0BAA4B,CAC7B,AAED,mEACE,cAAe,AACf,qBAAsB,AACtB,aAAc,AACd,8BAA+B,AAC/B,sCAAuC,AACvC,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,kBAAoB,CACrB,AAED,6EACE,gBAAiB,AACjB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,cAAe,AACf,gBAAkB,CAGnB,AAED,4EACE,cAAe,AACf,YAAa,AACb,uBAAwB,AACxB,gBAAiB,AACjB,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,WAAY,AACZ,SAAW,CACZ,AAED,uGACE,kBAAmB,AACnB,mBAAoB,AACpB,mBAAqB,CACtB,AAED,qNACE,+BAAwC,CACzC,AAED,uFACE,sBAAuB,AACvB,6BAA+B,CAChC,AAED,iGACE,gBAAiB,AACjB,aAAe,CAChB,AAED,idACE,gBAAkB,CACnB,AAED,wCACE,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,cAAgB,CACjB,AAED,sGACE,aAAc,AACd,YAAa,AACb,iBAAmB,CACpB,AAED,wKAEE,qBAAsB,AACtB,aAAc,AACd,uBAAwB,AACxB,2BAA4B,AAC5B,kBAAmB,AACnB,gBAAiB,AACjB,UAAY,CACb,AAED,gMACE,aAAe,CAChB,AAED,8EACE,gBAAiB,AACjB,eAAgB,AAChB,gBAAkB,CACnB,AAED,0FACE,eAAgB,AAChB,eAAgB,AAChB,0BAA2B,AAC3B,iBAAkB,AAClB,eAAgB,AAChB,SAAW,CACZ,AAED,sGACE,YAAc,CACf,AAOD,4iBACE,cAAe,AACf,4BAA8B,CAC/B,AAED,4EACE,qBAAsB,AACtB,WAAY,AACZ,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,cAAe,AACf,mCAAoC,AACpC,kCAAmC,AACnC,eAAgB,AAChB,iBAAmB,CACpB,AAED,kBACE,iBAAkB,AAClB,kBAAmB,AACnB,WAAa,CACd,AAED,gFACE,gBAAkB,CACnB,AAED,oCACE,gBAAkB,CACnB,AAED,2CACE,eAAiB,CAClB,AAED,sBACE,gBAAiB,AACjB,gBAAkB,CACnB,AAED,wCACE,aAAe,CAChB,AAED,+CACE,eAAiB,CAClB,AAwBD,6BACE,UAAY,CACb,AAED,+CACE,eAAiB,CAClB,AAED,4HACE,WAAY,AACZ,WAAa,CACd,AAED,oNACE,YAAc,CACf,AAED,kGACE,2BAA4B,AAC5B,mBAAoB,AACpB,iBAAkB,AAClB,WAAa,CACd,AA8BD,0EACE,cAAe,AACf,4BAA6B,AAC7B,iBAAkB,AAClB,eAAgB,AAChB,SAAW,CACZ,AAkDD,gBACE,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,oBAAqB,AACrB,iBAAkB,AAClB,kBAAmB,AACnB,uBAAwB,AACxB,SAAW,CACZ,AAED,8GACE,eAAgB,AAChB,iBAAmB,CACpB,AAED,sCACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,SAAW,CACZ,AAED,sCACE,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,MAAO,AACP,OAAQ,AACR,iBAAmB,CACpB,AAED,0CACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,SAAW,CACZ,AAED,+DACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AAED,yFACE,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,qBAAuB,CACxB,AAED,UACE,WAAY,AACZ,cAAe,AACf,YAAa,AACb,WAAY,AACZ,gBAAiB,AACjB,mBAAoB,AACpB,iBAAmB,CACpB,AAED,sEACE,+BAAgC,AAChC,kBAAoB,CACrB,AAED,wDACE,iBAAmB,CACpB,AAED,6HACE,cAAe,AACf,UAAY,CACb,AAED,8DACE,UAAY,CACb,AAED,8EACE,cAAe,AACf,iBAAmB,CACpB,AAED,mFACE,aAAe,CAChB,AAED,+LACE,eAAgB,AAChB,cAAe,AACf,iBAAmB,CACpB,AAED,uPACE,eAAgB,AAChB,eAAiB,CAClB,AAED,2FACE,kBAAmB,AACnB,eAAiB,CAClB,AAED,iBACE,kBAAmB,AACnB,UAAW,AACX,oDAAyD,AACzD,iDAAsD,AACtD,2CAAiD,CAClD,AAED,kKACE,qBAAuB,AACvB,uCAAyC,AACzC,UAAY,CACb,AAED,WACE,WAAY,AACZ,iBAAkB,AAClB,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,eAAgB,AAChB,gBAAkB,CACnB,AAED,YACE,gBAAiB,AACjB,kBAAmB,AACnB,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,eAAgB,AAChB,iBAAkB,AAClB,kCAAmC,AACnC,oBAAsB,CACvB,AAED,sMACE,eAAgB,AAChB,8BAA+B,AAC/B,2BAA4B,AAC5B,qBAAuB,CACxB,AAED,qBACE,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,aAAe,CAChB,AAED,iFACE,eAAgB,AAChB,eAAiB,CAClB,AAED,yHACE,eAAgB,AAChB,kBAAmB,AACnB,mBAAoB,AACpB,aAAe,CAChB,AAED,4DACE,YAAc,CACf,AAED,+BACE,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,aAAe,CAChB,AAED,2FACE,eAAgB,AAChB,eAAiB,CAClB,AAED,SACE,UAAW,AACX,cAAe,AACf,gBAAiB,AACjB,eAAuB,AACvB,mBAAoB,AACpB,sBAAuB,AACvB,gBAAiB,AACjB,gBAAkB,CAEnB,AAED,oBAHE,aAAe,CAKhB,AAED,sDACE,YAAc,CACf,AAED,wDACE,8BAA+B,AAI/B,cAAkB,CAEnB,AAED,4HAPE,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AAEjB,aAAe,CAQhB,AAED,uBACE,qBAAsB,AACtB,8BAA+B,AAC/B,gBAAiB,AACjB,gBAAiB,AACjB,eAAgB,AAChB,aAAe,CAChB,AAED,gJACE,wBAA0B,AAC1B,4BAA8B,CAC/B,AAMD,g6BACE,uBAA0B,CAC3B,AAED,oBACE,WAAY,AACZ,eAAgB,AAChB,eAAgB,AAChB,WAAY,AACZ,eAAiB,CAClB,AAOD,4EACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,+CACE,0BAA6B,CAC9B,AAED,4BACE,gBAAiB,AACjB,UAAY,CACb,AAED,uCACE,SAAU,AACV,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CACb,AAED,yCACE,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CACb,AAMD,+FACE,YAAc,CACf,AAED,6CACE,aAAe,CAChB,AAED,8FACE,qBAAsB,AACtB,aAAe,CAChB,AAED,wNACE,aAAe,CAChB,AAED,iDACE,UAAW,AACX,iBAAkB,AAClB,iBAAmB,CACpB,AAED,8DACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,uCACE,iBAAkB,AAClB,iBAAmB,CACpB,AAED,oDACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,+BACE,gBAAiB,AACjB,UAAY,CACb,AAED,0CACE,SAAU,AACV,kBAAmB,AACnB,eAAiB,CAIlB,AAED,sFALE,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CAOb,AAED,qGACE,qBAAsB,AACtB,cAAgB,CACjB,AAED,mDACE,mBAAoB,AACpB,gBAAkB,CACnB,AAED,kDACE,oBAAqB,AACrB,eAAiB,CAClB,AAED,+CACE,eAAgB,AAChB,iBAAkB,AAClB,WAAY,AACZ,iBAAkB,AAClB,eAAiB,CAClB,AAED,oDACE,eAAgB,AAChB,UAAW,AACX,iBAAkB,AAClB,iBAAmB,CACpB,AAED,kFACE,4CACE,eAAgB,AAChB,gBAAkB,CACnB,CACF,AAED,kFACE,4CACE,eAAgB,AAChB,gBAAkB,CACnB,CACF,AAED,mDACE,0BAA6B,CAC9B,AAED,4BACE,iBAAmB,CACpB,AAOD,6DACE,WAAY,AACZ,WAAa,CACd,AAED,8BACE,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACb,AAED,iDACE,eAAgB,AAChB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CAClB,AAED,sDACE,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,cAAgB,CACjB,AAED,kDACE,iBAAkB,AAClB,kBAAmB,AACnB,8BAA+B,AAC/B,kBAAoB,CACrB,AAED,mDACE,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,oBAA0B,CAC3B,AAED,iCACE,aAAc,AACd,eAAiB,CAClB,AAED,mCACE,WAAY,AACZ,oBAAsB,CACvB,AAED,yCACE,yBAA2B,CAC5B,AAED,gCACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,mDACE,eAAgB,AAChB,6BAA8B,AAC9B,UAAW,AACX,iBAAkB,AAClB,kBAAmB,AACnB,gBAAiB,AACjB,gBAAkB,CACnB,AAED,kIACE,aAAc,AACd,4BAA6B,AAC7B,0BAA+B,AAC/B,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AAED,4IACE,qBAAuB,AACvB,sCAAyC,CAC1C,AAED,0KACE,+BAAwC,CACzC,AAED,4KACE,wBAAiC,CAClC,AAED,4FACE,iBAAkB,AAClB,iBAAmB,CACpB,AAED,4BACE,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACb,AAED,0DACE,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,mBAAoB,AACpB,wBAA0B,CAC3B,AAED,+BACE,aAAc,AACd,gBAAiB,AACjB,aAAe,CAChB,AAED,iCACE,WAAY,AACZ,oBAAsB,CACvB,AAED,uCACE,yBAA2B,CAC5B,AAED,8BACE,eAAgB,AAChB,gBAAkB,CACnB,AAED,8EACE,YAAa,AACb,gBAAiB,AACjB,iBAAkB,AAClB,mBAAqB,CACtB,AAED,oGACE,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,SAAU,AACV,gBAAkB,CACnB,AAED,8HACE,aAAc,AACd,4BAA6B,AAC7B,0BAA+B,AAC/B,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AAED,wIACE,qBAAuB,AACvB,sCAAyC,CAC1C,AAED,iDACE,iBAAkB,AAClB,iBAAmB,CACpB,AAED,aACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,oBAAqB,AACrB,iBAAkB,AAClB,sBAAuB,AACvB,cAAe,AACf,+BAAgC,AAChC,4BAA6B,AAC7B,sBAAwB,CACzB,AAED,+BACE,sBAAuB,AACvB,0BAA2B,AAC3B,6BAA8B,AAC9B,eAAiB,CAClB,AAED,oCACE,sBAAuB,AACvB,sBAAuB,AACvB,iBAAmB,CACpB,AAED,oCACE,6CAAkD,AAClD,0CAA+C,AAC/C,oCAA0C,CAC3C,AAED,mTACE,iBAAkB,AAClB,aAAe,CAChB,AAED,yFACE,iBAAmB,CACpB,AAED,4BACE,iBAAmB,CACpB,AAED,+FACE,WAAa,CACd,AAED,oBACE,gBAAkB,CACnB,AAED,mBACE,eAAiB,CAClB","file":"timeline.css","sourcesContent":["/*\n    TimelineJS - ver. 2017-11-07-20-35-04 - 2017-11-07\n    Copyright (c) 2012-2016 Northwestern University\n    a project of the Northwestern University Knight Lab, originally created by Zach Wise\n    https://github.com/NUKnightLab/TimelineJS3\n    This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0.\n    If a copy of the MPL was not distributed with this file, You can obtain one at http://mozilla.org/MPL/2.0/.\n*/\n.tl-storyjs div * {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.tl-storyjs .active, .tl-storyjs .caption, .tl-storyjs .content-container, .tl-storyjs .credit, .tl-storyjs .date, .tl-storyjs .dot, .tl-storyjs .era, .tl-storyjs .flag, .tl-storyjs .line, .tl-storyjs .major, .tl-storyjs .map, .tl-storyjs .marker, .tl-storyjs .media, .tl-storyjs .message, .tl-storyjs .minor, .tl-storyjs .slider, .tl-storyjs .start, .tl-storyjs .text, .tl-storyjs .time, .tl-storyjs .title, .tl-storyjs .tl-container, .tl-storyjs .tl-feature, .tl-storyjs .tl-feedback, .tl-storyjs .tl-navigation, .tl-storyjs .tl-slider, .tl-storyjs .toolbar, .tl-storyjs a, .tl-storyjs abbr, .tl-storyjs acronym, .tl-storyjs address, .tl-storyjs blockquote, .tl-storyjs button, .tl-storyjs caption, .tl-storyjs cite, .tl-storyjs code, .tl-storyjs dd, .tl-storyjs del, .tl-storyjs dfn, .tl-storyjs dl, .tl-storyjs dt, .tl-storyjs em, .tl-storyjs fieldset, .tl-storyjs form, .tl-storyjs h1, .tl-storyjs h2, .tl-storyjs h3, .tl-storyjs h4, .tl-storyjs h5, .tl-storyjs h6, .tl-storyjs img, .tl-storyjs label, .tl-storyjs legend, .tl-storyjs li, .tl-storyjs ol, .tl-storyjs p, .tl-storyjs pre, .tl-storyjs q, .tl-storyjs s, .tl-storyjs samp, .tl-storyjs small, .tl-storyjs strike, .tl-storyjs strong, .tl-storyjs sub, .tl-storyjs sup, .tl-storyjs table, .tl-storyjs tbody, .tl-storyjs td, .tl-storyjs tfoot, .tl-storyjs th, .tl-storyjs thead, .tl-storyjs tr, .tl-storyjs tt, .tl-storyjs ul, .tl-storyjs var {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 100%;\n  line-height: 1;\n  font-family: inherit;\n  width: auto;\n  float: none;\n}\n\n.tl-storyjs h1, .tl-storyjs h2, .tl-storyjs h3, .tl-storyjs h4, .tl-storyjs h5, .tl-storyjs h6 {\n  clear: none;\n}\n\n.tl-storyjs table {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.tl-storyjs ol, .tl-storyjs ul {\n  list-style: none;\n}\n\n.tl-storyjs blockquote:after, .tl-storyjs blockquote:before, .tl-storyjs q:after, .tl-storyjs q:before {\n  content: \"\";\n}\n\n.tl-storyjs a:focus {\n  outline: thin dotted;\n}\n\n.tl-storyjs a:active, .tl-storyjs a:hover {\n  outline: 0;\n}\n\n.tl-storyjs article, .tl-storyjs aside, .tl-storyjs details, .tl-storyjs figcaption, .tl-storyjs figure, .tl-storyjs footer, .tl-storyjs header, .tl-storyjs hgroup, .tl-storyjs nav, .tl-storyjs section {\n  display: block;\n}\n\n.tl-storyjs audio, .tl-storyjs canvas, .tl-storyjs video {\n  display: inline-block;\n}\n\n.tl-storyjs audio:not([controls]) {\n  display: none;\n}\n\n.tl-storyjs div {\n  max-width: none;\n}\n\n.tl-storyjs sub, .tl-storyjs sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\n.tl-storyjs sup {\n  top: -.5em;\n}\n\n.tl-storyjs sub {\n  bottom: -.25em;\n}\n\n.tl-storyjs img {\n  border: 0;\n  -ms-interpolation-mode: bicubic;\n}\n\n.tl-storyjs button, .tl-storyjs input, .tl-storyjs select, .tl-storyjs textarea {\n  font-size: 100%;\n  margin: 0;\n  vertical-align: baseline;\n}\n\n.tl-storyjs button, .tl-storyjs input {\n  line-height: normal;\n}\n\n.tl-storyjs button::-moz-focus-inner, .tl-storyjs input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.tl-storyjs button, .tl-storyjs input[type=button], .tl-storyjs input[type=reset], .tl-storyjs input[type=submit] {\n  cursor: pointer;\n  -webkit-appearance: button;\n}\n\n.tl-storyjs input[type=search] {\n  -webkit-appearance: textfield;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.tl-storyjs input[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n.tl-storyjs textarea {\n  overflow: auto;\n  vertical-align: top;\n}\n\n.tl-timeline {\n  font-family: Barlow;\n}\n\n.tl-timeline h1, .tl-timeline h2, .tl-timeline h3, .tl-timeline h4, .tl-timeline h5, .tl-timeline h6 {\n  color: #000;\n}\n\n.tl-timeline h1, .tl-timeline h2, .tl-timeline h3 {\n  font-size: 28px;\n  line-height: 28px;\n}\n\n.tl-timeline h1 small, .tl-timeline h2 small, .tl-timeline h3 small {\n  font-size: 24px;\n  line-height: 24px;\n}\n\n.tl-timeline h4, .tl-timeline h5, .tl-timeline h6 {\n  font-size: 24px;\n  line-height: 24px;\n  margin-bottom: 0;\n}\n\n.tl-timeline h4 small, .tl-timeline h5 small, .tl-timeline h6 small {\n  font-size: 15px;\n  line-height: 15px;\n}\n\n.tl-timeline h2.tl-headline-title {\n  font-size: 38px;\n  line-height: 38px;\n}\n\n.tl-timeline h2.tl-headline-title small {\n  display: block;\n  margin-top: 5px;\n  font-size: 24px;\n  line-height: 24px;\n}\n\n.tl-timeline h2 {\n  margin-top: 20px;\n  margin-bottom: 5px;\n}\n\n.tl-timeline p {\n  margin-top: 5px;\n  margin-bottom: 10px;\n  font-size: 15px;\n  line-height: 1.42857143;\n  color: #666;\n}\n\n.tl-timeline p.lead {\n  font-size: 24px;\n}\n\n.tl-timeline p a {\n  color: #666;\n  text-decoration: underline;\n}\n\n.tl-timeline p a:focus, .tl-timeline p a:hover {\n  color: #c34528;\n}\n\n@media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 144dpi) {\n  .tl-timeline p a {\n    text-decoration: underline;\n    background-image: none;\n    text-shadow: none;\n  }\n\n  .tl-timeline p a:focus, .tl-timeline p a:hover {\n    color: #c34528;\n    text-decoration: underline;\n  }\n}\n\n.tl-timeline b, .tl-timeline strong {\n  font-weight: 700;\n}\n\n.tl-timeline em, .tl-timeline i {\n  font-style: italic;\n}\n\n.tl-timeline a {\n  text-decoration: none;\n  color: #c34528;\n}\n\n.tl-timeline a:hover {\n  text-decoration: underline;\n  color: #6e2717;\n}\n\n.tl-timeline .tl-caption, .tl-timeline .tl-credit, .tl-timeline .tl-slidenav-next, .tl-timeline .tl-slidenav-previous {\n  font-size: 11px;\n  line-height: 11px;\n}\n\n.tl-timeline .tl-caption a, .tl-timeline .tl-credit a, .tl-timeline .tl-slidenav-next a, .tl-timeline .tl-slidenav-previous a {\n  color: #000;\n}\n\n.tl-timeline .tl-makelink {\n  word-break: break-all;\n  word-break: break-word;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  hyphens: auto;\n}\n\n.tl-timeline blockquote, .tl-timeline blockquote p {\n  font-family: Barlow, sans-serif;\n  color: #999;\n  font-size: 24px;\n  line-height: 24px;\n  text-align: left;\n  background: 0 0;\n  border: 0;\n  padding: 0;\n}\n\n.tl-timeline blockquote cite, .tl-timeline blockquote p cite {\n  font-family: Barlow, sans-serif;\n  font-size: 11px;\n  color: #666;\n  display: block;\n  text-align: right;\n  font-style: normal;\n}\n\n.tl-timeline blockquote cite:before, .tl-timeline blockquote p cite:before {\n  content: \"\\2014\";\n}\n\n.tl-timeline blockquote p:before {\n  content: open-quote;\n  display: inline-block;\n  font-size: 28px;\n  position: relative;\n  top: 8px;\n  margin-right: 5px;\n}\n\n.tl-timeline blockquote p:after {\n  content: close-quote;\n  display: inline-block;\n  font-size: 28px;\n  position: relative;\n  top: 8px;\n  margin-left: 3px;\n}\n\n.tl-timeline blockquote {\n  margin: 10px;\n}\n\n.tl-timeline blockquote p {\n  margin: 0;\n}\n\n.tl-timeline .vcard {\n  font-family: Barlow,sans-serif;\n  font-size: 15px;\n  line-height: 15px;\n  margin-bottom: 15px;\n  margin-top: 10px;\n}\n\n.tl-timeline .vcard:after, .tl-timeline .vcard:before {\n  display: table;\n  content: \"\";\n}\n\n.tl-timeline .vcard:after {\n  clear: both;\n}\n\n.tl-timeline .vcard .twitter-date {\n  text-align: left;\n  font-size: 11px;\n}\n\n.tl-timeline .vcard .author {\n  float: right;\n}\n\n.tl-timeline .vcard a {\n  color: #333;\n  text-decoration: none;\n}\n\n.tl-timeline .vcard a:hover {\n  text-decoration: none;\n}\n\n.tl-timeline .vcard a:hover .fn, .tl-timeline .vcard a:hover .nickname {\n  color: #c34528;\n}\n\n.tl-timeline .vcard .fn, .tl-timeline .vcard .nickname {\n  padding-left: 42px;\n}\n\n.tl-timeline .vcard .fn {\n  display: block;\n  font-weight: 700;\n}\n\n.tl-timeline .vcard .nickname {\n  margin-top: 1px;\n  display: block;\n  color: #666;\n}\n\n.tl-timeline .vcard .avatar {\n  float: left;\n  display: block;\n  width: 32px;\n  height: 32px;\n}\n\n.tl-timeline .vcard .avatar img {\n  -moz-border-radius: 5px;\n  -webkit-border-radius: 5px;\n  border-radius: 5px;\n}\n\n.tl-timeline .tl-text ul {\n  padding: 0;\n  padding-left: 30px;\n  margin: 0;\n}\n\n.tl-timeline .tl-text ul li {\n  margin-bottom: 5px;\n}\n\n.tl-timeline .tl-button-calltoaction {\n  cursor: pointer;\n  font-weight: 700;\n  padding-top: 10px;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n}\n\n.tl-timeline .tl-button-calltoaction .tl-button-calltoaction-text {\n  display: inline-block;\n  background-color: #c34528;\n  color: #fff;\n  padding: 10px 15px 10px 15px;\n  border-radius: 7px;\n}\n\n.tl-timeline .tl-note {\n  display: block;\n  font-family: Barlow,sans-serif;\n  font-style: italic;\n  background-color: #e6e6e6;\n  font-size: 15px;\n  line-height: 17px;\n  padding: 10px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border: 1px solid #faebcc;\n  text-shadow: none;\n}\n\n@media only screen and (max-width: 800px), only screen and (max-device-width: 800px) {\n  .tl-timeline h1, .tl-timeline h2, .tl-timeline h3 {\n    font-size: 28px;\n    line-height: 28px;\n  }\n}\n\n@media only screen and (max-width: 500px), only screen and (max-device-width: 500px) {\n  .tl-timeline h1, .tl-timeline h2, .tl-timeline h3 {\n    font-size: 24px;\n    line-height: 24px;\n  }\n}\n\n.tl-skinny h2 {\n  margin-top: 0;\n}\n\n/*@font-face {\n  font-family: tl-icons;\n  src: url(\"icons/tl-icons.eot\");\n  src: url(\"icons/tl-icons.eot?#iefix\") format(\"embedded-opentype\"), url(\"icons/tl-icons.ttf\") format(\"truetype\"), url(\"icons/tl-icons.woff\") format(\"woff\"), url(\"icons/tl-icons.svg#tl-icons\") format(\"svg\");\n  font-weight: 400;\n  font-style: normal;\n}*/\n\n[class*=\" tl-icon-\"], [class^=tl-icon-] {\n  font-family: tl-icons;\n  speak: none;\n  font-style: normal;\n  font-weight: 400;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.tl-icon-vine:after {\n  content: \"\\e64d\";\n}\n\n.tl-icon-wikipedia:after {\n  content: \"\\e64e\";\n}\n\n.tl-icon-chevron-right:after {\n  content: \"\\e64f\";\n}\n\n.tl-icon-chevron-left:after {\n  content: \"\\e650\";\n}\n\n.tl-icon-youtube-logo:after {\n  content: \"\\e651\";\n}\n\n.tl-icon-foursquare:after {\n  content: \"\\e652\";\n}\n\n.tl-icon-camera-retro:after {\n  content: \"\\e653\";\n}\n\n.tl-icon-doc:after {\n  content: \"\\e654\";\n}\n\n.tl-icon-weibo:after {\n  content: \"\\e655\";\n}\n\n.tl-icon-resize-horizontal:after {\n  content: \"\\e656\";\n}\n\n.tl-icon-resize-vertical:after {\n  content: \"\\e657\";\n}\n\n.tl-icon-resize-full:after {\n  content: \"\\e658\";\n}\n\n.tl-icon-resize-small:after {\n  content: \"\\e659\";\n}\n\n.tl-icon-twitter:after {\n  content: \"\\e62b\";\n}\n\n.tl-icon-google-plus:after {\n  content: \"\\e62c\";\n}\n\n.tl-icon-video:after {\n  content: \"\\e62d\";\n}\n\n.tl-icon-youtube:after {\n  content: \"\\e62d\";\n}\n\n.tl-icon-plaintext:after {\n  content: \"\\e62e\";\n}\n\n.tl-icon-storify:after {\n  content: \"\\e62e\";\n}\n\n.tl-icon-image-v2:after {\n  content: \"\\e62f\";\n}\n\n.tl-icon-quote-v2:after {\n  content: \"\\e630\";\n}\n\n.tl-icon-zoom-in:after {\n  content: \"\\e631\";\n}\n\n.tl-icon-zoom-out:after {\n  content: \"\\e632\";\n}\n\n.tl-icon-list:after {\n  content: \"\\e633\";\n}\n\n.tl-icon-music:after {\n  content: \"\\e634\";\n}\n\n.tl-icon-spotify:after {\n  content: \"\\e634\";\n}\n\n.tl-icon-location:after {\n  content: \"\\e635\";\n}\n\n.tl-icon-googlemaps:after {\n  content: \"\\e635\";\n}\n\n.tl-icon-web:after {\n  content: \"\\e636\";\n}\n\n.tl-icon-share-v2:after {\n  content: \"\\e637\";\n}\n\n.tl-icon-soundcloud:after {\n  content: \"\\e639\";\n}\n\n.tl-icon-video-v2:after {\n  content: \"\\e63a\";\n}\n\n.tl-icon-dailymotion:after {\n  content: \"\\e63a\";\n}\n\n.tl-icon-tumblr:after {\n  content: \"\\e63b\";\n}\n\n.tl-icon-lastfm:after {\n  content: \"\\e63c\";\n}\n\n.tl-icon-github:after {\n  content: \"\\e63d\";\n}\n\n.tl-icon-goback:after {\n  content: \"\\e63e\";\n}\n\n.tl-icon-doc-v2:after {\n  content: \"\\e63f\";\n}\n\n.tl-icon-googledrive:after {\n  content: \"\\e640\";\n}\n\n.tl-icon-facebook:after {\n  content: \"\\e641\";\n}\n\n.tl-icon-flickr:after {\n  content: \"\\e642\";\n}\n\n.tl-icon-dribbble:after {\n  content: \"\\e643\";\n}\n\n.tl-icon-image:after {\n  content: \"\\e605\";\n}\n\n.tl-icon-vimeo:after {\n  content: \"\\e606\";\n}\n\n.tl-icon-instagram:after {\n  content: \"\\e644\";\n}\n\n.tl-icon-pinterest:after {\n  content: \"\\e645\";\n}\n\n.tl-icon-arrow-left:after {\n  content: \"\\e646\";\n}\n\n.tl-icon-arrow-down:after {\n  content: \"\\e647\";\n}\n\n.tl-icon-arrow-up:after {\n  content: \"\\e648\";\n}\n\n.tl-icon-arrow-right:after {\n  content: \"\\e649\";\n}\n\n.tl-icon-share:after {\n  content: \"\\e64a\";\n}\n\n.tl-icon-blockquote:after {\n  content: \"\\e64b\";\n}\n\n.tl-icon-evernote:after {\n  content: \"\\e64c\";\n}\n\n.tl-icon-mappin:after {\n  content: \"\\e600\";\n}\n\n.tl-icon-swipe-right:after {\n  content: \"\\e601\";\n}\n\n.tl-icon-swipe-left:after {\n  content: \"\\e602\";\n}\n\n.tl-icon-touch-spread:after {\n  content: \"\\e603\";\n}\n\n.tl-icon-touch-pinch:after {\n  content: \"\\e604\";\n}\n\n.tl-dragging {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n.tl-menubar {\n  position: absolute;\n  z-index: 11;\n  text-align: center;\n  color: #333;\n  overflow: hidden;\n  border-bottom-right-radius: 10px;\n  border-top-right-radius: 10px;\n  top: 100%;\n  left: 50%;\n  left: 0;\n}\n\n@keyframes invertToBlack {\n  from {\n    background-color: #FFF;\n  }\n\n  to {\n    background-color: #000;\n  }\n}\n\n@-webkit-keyframes invertToBlack {\n  from {\n    background: #FFF;\n  }\n\n  to {\n    background: #000;\n  }\n}\n\n@keyframes invertToWhite {\n  from {\n    background-color: #000;\n  }\n\n  to {\n    background-color: #FFF;\n  }\n}\n\n@-webkit-keyframes invertToWhite {\n  from {\n    background: #000;\n  }\n\n  to {\n    background: #FFF;\n  }\n}\n\n.tl-menubar-button {\n  font-size: 18px;\n  line-height: 18px;\n  background-color: rgba(242, 242, 242, 0.9);\n  cursor: pointer;\n  padding: 6px 12px 6px 12px;\n  display: inline-block;\n  display: block;\n  color: #bfbfbf;\n}\n\n.tl-menubar-button.tl-menubar-button-inactive {\n  opacity: .33;\n}\n\n.tl-menubar-button:hover {\n  background: #333;\n  color: #FFF;\n}\n\n.tl-menubar-button:hover.tl-menubar-button-inactive {\n  color: #bfbfbf;\n  background-color: rgba(242, 242, 242, 0.9);\n}\n\n.tl-mobile .tl-menubar-button {\n  display: block;\n}\n\n.tl-mobile .tl-menubar-button:hover {\n  background-color: rgba(242, 242, 242, 0.67);\n  color: #737373;\n}\n\n.tl-mobile .tl-menubar-button:active {\n  background: #c34528;\n  color: #FFF;\n}\n\n@keyframes invertToBlack {\n  from {\n    background-color: #FFF;\n  }\n\n  to {\n    background-color: #000;\n  }\n}\n\n@-webkit-keyframes invertToBlack {\n  from {\n    background: #FFF;\n  }\n\n  to {\n    background: #000;\n  }\n}\n\n@keyframes invertToWhite {\n  from {\n    background-color: #000;\n  }\n\n  to {\n    background-color: #FFF;\n  }\n}\n\n@-webkit-keyframes invertToWhite {\n  from {\n    background: #000;\n  }\n\n  to {\n    background: #FFF;\n  }\n}\n\n.tl-message, .tl-message-full {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: table;\n  overflow: hidden;\n  top: 0;\n  left: 0;\n  z-index: 99;\n  margin: auto;\n  text-align: center;\n}\n\n.tl-message .tl-message-container, .tl-message-full .tl-message-container {\n  padding: 20px;\n  margin: 20px;\n  text-align: center;\n  vertical-align: middle;\n  display: table-cell;\n}\n\n.tl-message .tl-message-container .tl-message-content, .tl-message-full .tl-message-container .tl-message-content {\n  color: #666;\n  text-align: center;\n  font-size: 11px;\n  line-height: 13px;\n  text-transform: uppercase;\n  margin-top: 7.5px;\n  margin-bottom: 7.5px;\n  text-shadow: 1px 1px 1px #FFF;\n}\n\n.tl-message .tl-message-container .tl-message-content strong, .tl-message-full .tl-message-container .tl-message-content strong {\n  text-transform: uppercase;\n}\n\n.tl-message .tl-message-container .tl-loading-icon, .tl-message-full .tl-message-container .tl-loading-icon {\n  width: 30px;\n  height: 30px;\n  background-color: #666;\n  vertical-align: middle;\n  -webkit-box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.1);\n  -moz-box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.1);\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  -webkit-animation: rotateplane 1.2s infinite ease-in-out;\n  animation: rotateplane 1.2s infinite ease-in-out;\n}\n\n@-webkit-keyframes rotateplane {\n  0% {\n    -webkit-transform: perspective(120px);\n  }\n\n  50% {\n    -webkit-transform: perspective(120px) rotateY(180deg);\n  }\n\n  100% {\n    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);\n  }\n}\n\n@keyframes rotateplane {\n  0% {\n    transform: perspective(120px) rotateX(0) rotateY(0);\n  }\n\n  50% {\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0);\n  }\n\n  100% {\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n  }\n}\n\n.tl-message-full {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.tl-message-full [class*=\" tl-icon-\"], .tl-message-full [class^=tl-icon-] {\n  color: #666;\n  font-size: 72px;\n}\n\n.tl-message-full .tl-message-container .tl-message-content {\n  font-size: 22px;\n  line-height: 22px;\n  text-shadow: none;\n  color: #666;\n  text-transform: none;\n  font-weight: 400;\n}\n\n.tl-message-full .tl-message-container .tl-message-content .tl-button {\n  display: inline-block;\n  cursor: pointer;\n  background-color: #FFF;\n  color: #333;\n  padding: 10px;\n  margin-top: 10px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.tl-timenav {\n  width: 100%;\n  background-color: #f2f2f2;\n  position: relative;\n  overflow: hidden;\n  border-top: 1px solid #e5e5e5;\n}\n\n.tl-timenav .tl-attribution {\n  cursor: pointer;\n  z-index: 9;\n  position: absolute;\n  bottom: 2px;\n  left: 0;\n  font-size: 10px;\n  line-height: 10px;\n  font-family: Barlow, sans-serif !important;\n  background-color: rgba(255, 255, 255, 0.85);\n  padding: 3px;\n}\n\n.tl-timenav .tl-attribution a {\n  color: #ccc;\n}\n\n.tl-timenav .tl-attribution a:hover {\n  color: #000;\n  text-decoration: none;\n}\n\n.tl-timenav .tl-attribution a:hover .tl-knightlab-logo {\n  background-color: #c34528;\n}\n\n.tl-timenav .tl-attribution .tl-knightlab-logo {\n  display: inline-block;\n  vertical-align: middle;\n  height: 8px;\n  width: 8px;\n  margin-right: 3px;\n  background-color: #c34528;\n  background-color: #ccc;\n  transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n\n.tl-timenav .tl-timenav-line {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 1px;\n  height: 100%;\n  background-color: #d9d9d9;\n  z-index: 2;\n  display: none;\n}\n\n.tl-timenav .tl-timenav-line:after, .tl-timenav .tl-timenav-line:before {\n  font-family: tl-icons;\n  speak: none;\n  font-style: normal;\n  font-weight: 400;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #c34528;\n  font-size: 32px;\n  line-height: 32px;\n  position: absolute;\n  left: -14px;\n}\n\n.tl-timenav .tl-timenav-line:before {\n  top: -10px;\n}\n\n.tl-timenav .tl-timenav-line:after {\n  content: \"\\e648\";\n  bottom: 24px;\n}\n\n.tl-timenav .tl-timenav-slider {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n}\n\n.tl-timenav .tl-timenav-slider.tl-timenav-slider-animate {\n  -webkit-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timenav .tl-timenav-slider .tl-timenav-slider-background {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  cursor: move;\n  z-index: 6;\n}\n\n.tl-timenav .tl-timenav-slider .tl-timenav-container-mask {\n  position: absolute;\n  height: 100%;\n  top: 0;\n}\n\n.tl-timenav .tl-timenav-slider .tl-timenav-container-mask .tl-timenav-container {\n  position: absolute;\n  height: 100%;\n}\n\n.tl-timenav .tl-timenav-slider .tl-timenav-container-mask .tl-timenav-container .tl-timenav-item-container {\n  position: absolute;\n  height: 100%;\n}\n\n.tl-timemarker {\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  -webkit-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timemarker.tl-timemarker-fast {\n  -webkit-transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timemarker.tl-timemarker-fast .tl-timemarker-content-container {\n  -webkit-transition: width 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: width 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: width 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: width 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timemarker.tl-timemarker-fast .tl-timemarker-timespan {\n  -webkit-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timemarker .tl-timemarker-timespan {\n  pointer-events: none;\n  position: absolute;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(229, 229, 229, 0.15);\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  -webkit-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timemarker .tl-timemarker-timespan .tl-timemarker-timespan-content {\n  display: none;\n  position: absolute;\n  width: 100%;\n  background-color: #e5e5e5;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  height: 100px;\n  box-sizing: border-box;\n}\n\n.tl-timemarker .tl-timemarker-line-right {\n  display: none;\n  right: 0;\n}\n\n.tl-timemarker .tl-timemarker-line-left {\n  width: 1px;\n  left: 0;\n}\n\n.tl-timemarker .tl-timemarker-line-left, .tl-timemarker .tl-timemarker-line-right {\n  margin-top: 7px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border-left: 1px solid #d9d9d9;\n  z-index: 5;\n  content: \" \";\n  position: absolute;\n  height: 100%;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  box-shadow: 1px 1px 1px #FFF;\n}\n\n.tl-timemarker .tl-timemarker-line-left:after, .tl-timemarker .tl-timemarker-line-right:after {\n  display: block;\n  content: \" \";\n  position: absolute;\n  left: -4px;\n  bottom: 0;\n  height: 6px;\n  width: 6px;\n  background-color: #919191;\n  z-index: 8;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n}\n\n.tl-timemarker .tl-timemarker-content-container {\n  position: absolute;\n  background-color: #e5e5e5;\n  border: 0;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: 100%;\n  width: 100px;\n\n  /*overflow: hidden;*/\n  z-index: 6;\n  -webkit-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  box-sizing: border-box;\n  border: 1px solid #d9d9d9;\n  box-shadow: 1px 1px 1px #FFF;\n}\n\n.tl-timemarker .tl-timemarker-content-container:hover {\n  z-index: 9;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content {\n  position: relative;\n\n  /*overflow: hidden;*/\n  height: 100%;\n  z-index: 8;\n\n  /*padding: 5px;*/\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text {\n  /*overflow: hidden;*/\n  position: relative;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline, .tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline p {\n  /*display: -webkit-box;*/\n  line-clamp: unset !important; /*override timeline.js logic of adding it's own line-clamp, use js to truncate instead*/\n  -webkit-line-clamp: unset !important; /*override timeline.js logic of adding it's own line-clamp, use js truncate instead*/\n  /*box-orient: vertical;*/\n  /*-webkit-box-orient: vertical;*/\n  /*text-overflow: ellipsis;*/\n  font-size: 12px;\n  line-height: 13px;\n  height: 100%;\n  overflow: hidden;\n  font-weight: 400;\n  margin: 0;\n  font-family: Roboto, sans-serif;\n\n  /*color: #bfbfbf;*/\n  position: relative;\n}\n\n/*.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline p.tl-headline-fadeout:after, .tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline.tl-headline-fadeout:after {\n  content: \"\";\n  text-align: right;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 50%;\n  background: -moz-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(229, 229, 229, 0)), color-stop(50%, #e5e5e5));\n  background: -webkit-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: -o-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: -ms-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: linear-gradient(to bottom, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='@thecolor', endColorstr='@thecolor', GradientType=0);\n}*/\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container {\n  float: left;\n  max-width: 24px;\n  max-height: 24px;\n  overflow: hidden;\n  margin-right: 5px;\n  height: 100%;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-timemarker-media {\n  max-width: 24px;\n  max-height: 100%;\n  opacity: .25;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class*=\" tl-icon-\"], .tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class^=tl-icon-] {\n  display: block;\n  font-size: 24px;\n  color: #bfbfbf;\n  margin-top: 0;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-icon-wikipedia {\n  font-size: 16px;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content.tl-timemarker-content-small .tl-timemarker-text h2.tl-headline {\n  display: block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content.tl-timemarker-content-small .tl-timemarker-media-container [class*=\" tl-icon-\"], .tl-timemarker .tl-timemarker-content-container .tl-timemarker-content.tl-timemarker-content-small .tl-timemarker-media-container [class^=tl-icon-] {\n  font-size: 12px;\n}\n\n/*.tl-timemarker:hover .tl-timemarker-timespan {\n  background-color: rgba(191, 191, 191, 0.15);\n}\n\n.tl-timemarker:hover .tl-timemarker-timespan .tl-timemarker-timespan-content {\n  background-color: #bfbfbf;\n}\n\n.tl-timemarker:hover .tl-timemarker-timespan .tl-timemarker-line-left, .tl-timemarker:hover .tl-timemarker-timespan .tl-timemarker-line-right {\n  border-color: #a6a6a6;\n}\n\n.tl-timemarker:hover .tl-timemarker-timespan .tl-timemarker-line-left:after, .tl-timemarker:hover .tl-timemarker-timespan .tl-timemarker-line-right:after {\n  background-color: #3d3d3d;\n}\n\n.tl-timemarker:hover .tl-timemarker-content-container {\n  background-color: #bfbfbf;\n  border-color: #a6a6a6;\n  -webkit-transition: height 250ms cubic-bezier(0.77, 0, 0.175, 1), width 250ms cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: height 250ms cubic-bezier(0.77, 0, 0.175, 1), width 250ms cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: height 250ms cubic-bezier(0.77, 0, 0.175, 1), width 250ms cubic-bezier(0.77, 0, 0.175, 1);\n  transition: height 250ms cubic-bezier(0.77, 0, 0.175, 1), width 250ms cubic-bezier(0.77, 0, 0.175, 1);\n}*/\n\n/*This is the code that extends the div on hover*/\n/*.tl-timemarker:hover .tl-timemarker-content-container.tl-timemarker-content-container-small {\n  width: 200px;\n}\n*/\n\n/*.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline {\n  color: #FFF;\n}\n*/\n.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline.tl-headline-fadeout:after {\n  background: -moz-linear-gradient(top, rgba(191, 191, 191, 0) 0, #bfbfbf 80%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(191, 191, 191, 0)), color-stop(80%, #bfbfbf));\n  background: -webkit-linear-gradient(top, rgba(191, 191, 191, 0) 0, #bfbfbf 80%);\n  background: -o-linear-gradient(top, rgba(191, 191, 191, 0) 0, #bfbfbf 80%);\n  background: -ms-linear-gradient(top, rgba(191, 191, 191, 0) 0, #bfbfbf 80%);\n  background: linear-gradient(to bottom, rgba(191, 191, 191, 0) 0, #bfbfbf 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='@thecolor', endColorstr='@thecolor', GradientType=0);\n}\n\n.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-timemarker-media {\n  opacity: 1;\n}\n\n.tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class*=\" tl-icon-\"], .tl-timemarker:hover .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class^=tl-icon-] {\n  color: #FFF;\n}\n\n.tl-timemarker:hover.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline.tl-headline-fadeout:after {\n  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(255, 255, 255, 0)), color-stop(80%, #FFF));\n  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='@thecolor', endColorstr='@thecolor', GradientType=0);\n}\n\n.tl-timemarker:hover.tl-timemarker-active .tl-timemarker-line-left, .tl-timemarker:hover.tl-timemarker-active .tl-timemarker-line-right {\n  /*border-color: #000;*/\n}\n\n.tl-timemarker:hover.tl-timemarker-active .tl-timemarker-line-left:after, .tl-timemarker:hover.tl-timemarker-active .tl-timemarker-line-right:after {\n  /*background-color: #000;*/\n}\n\n.tl-timemarker.tl-timemarker-active .tl-timemarker-timespan {\n  background-color: rgba(255, 255, 255, 0.5);\n  z-index: 8;\n}\n\n.tl-timemarker.tl-timemarker-active .tl-timemarker-timespan .tl-timemarker-timespan-content {\n  background-color: #333;\n}\n\n.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left, .tl-timemarker.tl-timemarker-active .tl-timemarker-line-right {\n  border-color: rgba(51, 51, 51, 0.5);\n  border-width: 1px;\n  z-index: 8;\n  box-shadow: 0 1px 3px rgba(145, 145, 145, 0.5);\n}\n\n.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left:after, .tl-timemarker.tl-timemarker-active .tl-timemarker-line-right:after {\n  background-color: #333;\n}\n\n/*.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container {\n  background-color: #FFF;\n  color: #333;\n  z-index: 9;\n  border-color: rgba(51, 51, 51, 0.5);\n  box-shadow: 1px 1px 3px rgba(145, 145, 145, 0.5);\n}*/\n\n/*.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline {\n  color: #333;\n}\n\n.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline.tl-headline-fadeout:after {\n  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(255, 255, 255, 0)), color-stop(80%, #FFF));\n  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, #FFF 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='@thecolor', endColorstr='@thecolor', GradientType=0);\n}\n*/\n.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container .tl-timemarker-media {\n  opacity: 1;\n}\n\n.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class*=\" tl-icon-\"], .tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container [class^=tl-icon-] {\n  color: #333;\n}\n\n.tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan .tl-timemarker-timespan-content {\n  display: block;\n}\n\n.tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan .tl-timemarker-line-left, .tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan .tl-timemarker-line-right {\n  z-index: 5;\n}\n\n.tl-timemarker.tl-timemarker-with-end .tl-timemarker-timespan:after {\n  display: block;\n  content: \" \";\n  position: absolute;\n  left: 0;\n  bottom: -7px;\n  height: 6px;\n  width: 100%;\n  background-color: rgba(115, 115, 115, 0.15);\n  z-index: 6;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.tl-timemarker.tl-timemarker-with-end .tl-timemarker-content-container.tl-timemarker-content-container-long {\n  box-shadow: none;\n}\n\n.tl-timemarker.tl-timemarker-with-end .tl-timemarker-line-right {\n  display: block;\n}\n\n.tl-timemarker.tl-timemarker-with-end .tl-timemarker-line-left {\n  box-shadow: none;\n}\n\n.tl-timemarker.tl-timemarker-with-end:hover .tl-timemarker-timespan:after {\n  background-color: rgba(0, 0, 0, 0.25);\n}\n\n.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-timespan:after {\n  background-color: rgba(51, 51, 51, 0.5);\n}\n\n.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-left, .tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-right {\n  border-width: 1px;\n}\n\n.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-left:after, .tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-right:after {\n  background-color: #333 !important;\n}\n\n.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active .tl-timemarker-line-left {\n  box-shadow: none;\n}\n\n.tl-timemarker.tl-timemarker-with-end.tl-timemarker-active:hover .tl-timemarker-timespan:after {\n  background-color: rgba(51, 51, 51, 0.5);\n}\n\n.tl-timeera {\n  height: 100%;\n  height: 40px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  z-index: 3;\n  -webkit-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timeera.tl-timeera-fast {\n  -webkit-transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timeera .tl-timeera-background {\n  position: absolute;\n  background-color: #28a6c3;\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n}\n\n.tl-timeera.tl-timeera-color0 .tl-timeera-background {\n  background-color: #c34528;\n}\n\n.tl-timeera.tl-timeera-color1 .tl-timeera-background {\n  background-color: #28a6c3;\n}\n\n.tl-timeera.tl-timeera-color2 .tl-timeera-background {\n  background-color: #2832c3;\n}\n\n.tl-timeera.tl-timeera-color3 .tl-timeera-background {\n  background-color: #28c36c;\n}\n\n.tl-timeera.tl-timeera-color4 .tl-timeera-background {\n  background-color: #286dc3;\n}\n\n.tl-timeera.tl-timeera-color5 .tl-timeera-background {\n  background-color: #28c3a7;\n}\n\n.tl-timeera .tl-timeera-content-container {\n  position: absolute;\n  border: 0;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: 100%;\n  width: 100px;\n  overflow: hidden;\n  -webkit-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  box-sizing: border-box;\n  border: 1px solid #d9d9d9;\n}\n\n.tl-timeera .tl-timeera-content-container .tl-timeera-content {\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  padding: 5px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.tl-timeera .tl-timeera-content-container .tl-timeera-content .tl-timeera-text {\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n}\n\n.tl-timeera .tl-timeera-content-container .tl-timeera-content .tl-timeera-text h2.tl-headline {\n  bottom: 0;\n  position: absolute;\n  display: -webkit-box;\n  line-clamp: 4;\n  -webkit-line-clamp: 4;\n  box-orient: vertical;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  font-size: 10px;\n  line-height: 10px;\n  overflow: hidden;\n  font-weight: 400;\n  margin: 0;\n  color: #FFF;\n  margin-left: 10px;\n}\n\n.tl-timeera .tl-timeera-content-container .tl-timeera-content .tl-timeera-text h2.tl-headline.tl-headline-fadeout:after {\n  content: \"\";\n  text-align: right;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 50%;\n  background: -moz-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(229, 229, 229, 0)), color-stop(50%, #e5e5e5));\n  background: -webkit-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: -o-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: -ms-linear-gradient(top, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  background: linear-gradient(to bottom, rgba(229, 229, 229, 0) 0, #e5e5e5 50%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='@thecolor', endColorstr='@thecolor', GradientType=0);\n}\n\n.tl-timegroup {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #f2f2f2;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  -ms-flex-align: center;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -webkit-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: left 1s cubic-bezier(0.77, 0, 0.175, 1), top 0.5s cubic-bezier(0.77, 0, 0.175, 1), height 0.5s cubic-bezier(0.77, 0, 0.175, 1), width 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timegroup .tl-timegroup-message {\n  color: #e0e0e0;\n  text-shadow: #FFF 0 2px 2px;\n  margin-left: 80px;\n}\n\n.tl-timegroup.tl-timegroup-alternate {\n  background-color: #fafafa;\n}\n\n.tl-timegroup.tl-timegroup-hidden {\n  display: none;\n}\n.tl-timeaxis-background {\n  height: 62px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background-color: #FFF;\n  border-top: 1px solid #e5e5e5;\n  z-index: 2;\n}\n\n.tl-skinny .tl-timeaxis-background {\n  height: 52px;\n}\n\n.tl-timeaxis {\n  height: 62px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 3;\n}\n\n.tl-skinny .tl-timeaxis {\n  height: 52px;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major, .tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor {\n  opacity: 0;\n  position: absolute;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick, .tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  text-align: center;\n  font-weight: 400;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick .tl-timeaxis-tick-text, .tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text {\n  display: inline-block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick .tl-timeaxis-tick-text {\n  padding-left: 35px;\n}\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text {\n  display: none\n}\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick:before, .tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick:before {\n  content: \"\";\n  display: block;\n  color: #d8d8d8;\n  border-left: #d8d8d8 solid 1px;\n  width: 0;\n  height: 10px;\n  overflow: hidden;\n  text-align: center;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major.tl-timeaxis-animate .tl-timeaxis-tick, .tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor.tl-timeaxis-animate .tl-timeaxis-tick {\n  -webkit-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major.tl-timeaxis-animate-opacity .tl-timeaxis-tick, .tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor.tl-timeaxis-animate-opacity .tl-timeaxis-tick {\n  -webkit-transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major {\n  z-index: 1;\n  background-color: #FFF;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick {\n  font-size: 12px;\n  line-height: 14px;\n  color: #5a9cb5;\n  width: 100px;\n  margin-left: -50px;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-major .tl-timeaxis-tick:before {\n  border-color: #d8d8d8;\n  font-size: 18px;\n  line-height: 18px;\n  height: 36px;\n  margin-bottom: -14px;\n  margin-left: 50px;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick {\n  font-size: 11px;\n  line-height: 13px;\n  color: #5a9cb5;\n  width: 50px;\n  margin-left: -25px;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text {\n  opacity: 0;\n  white-space: normal;\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick .tl-timeaxis-tick-text span {\n  display: block;\n  font-size: 9px;\n  line-height: 9px;\n  margin-top: -2px;\n  color: #5a9cb5;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick:before {\n  font-size: 9px;\n  line-height: 9px;\n  margin-left: 25px;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick.tl-timeaxis-tick-hidden .tl-timeaxis-tick-text {\n  opacity: 0 !important;\n}\n\n.tl-timeaxis .tl-timeaxis-content-container .tl-timeaxis-minor .tl-timeaxis-tick.tl-timeaxis-tick-hidden:before {\n  opacity: 1;\n}\n\n.tlanimate {\n  -webkit-transform: translateZ(0);\n  -webkit-perspective: 1000;\n  -webkit-backface-visibility: hidden;\n}\n\n.tl-animate {\n  -webkit-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-animate-opacity {\n  -webkit-transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  transition: opacity 1s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  -o-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.tl-slide {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.tl-slide .tl-slide-background {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  overflow: hidden;\n  display: none;\n  filter: alpha(opacity = 50);\n  -khtml-opacity: .5;\n  -moz-opacity: .5;\n  opacity: .5;\n  background: no-repeat center center;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n}\n\n.tl-slide .tl-slide-scrollable-container {\n  display: table;\n  table-layout: fixed;\n  height: 100%;\n  z-index: 1;\n}\n\n.tl-slide .tl-slide-content-container {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n}\n\n.tl-slide .tl-slide-content-container .tl-slide-content {\n  display: table;\n  vertical-align: middle;\n  padding-left: 100px;\n  padding-right: 100px;\n  position: relative;\n  max-width: 100%;\n}\n\n.tl-slide .tl-slide-content-container .tl-slide-content .tl-media {\n  position: relative;\n  width: 100%;\n  min-width: 50%;\n  float: left;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.tl-slide .tl-slide-content-container .tl-slide-content .tl-text {\n  width: 50%;\n  max-width: 50%;\n  min-width: 120px;\n  padding: 0 20px 0 20px;\n  display: table-cell;\n  vertical-align: middle;\n  text-align: left;\n}\n\n.tl-slide-media-only .tl-slide-content-container .tl-slide-content {\n  text-align: center;\n}\n\n.tl-slide-media-only .tl-slide-content-container .tl-slide-content .tl-media {\n  text-align: center;\n  position: relative;\n  width: 100%;\n  min-width: 50%;\n  max-width: 100%;\n  float: none;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.tl-slide-media-only .tl-slide-content-container .tl-slide-content .tl-text {\n  width: 100%;\n  max-width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n\n.tl-slide-text-only .tl-slide-content-container .tl-slide-content {\n  text-align: center;\n}\n\n.tl-slide-text-only .tl-slide-content-container .tl-slide-content .tl-text {\n  max-width: 80%;\n  width: 80%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.tl-slide.tl-full-color-background, .tl-slide.tl-full-image-background {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-slide.tl-full-color-background h1, .tl-slide.tl-full-color-background h2, .tl-slide.tl-full-color-background h3, .tl-slide.tl-full-color-background h4, .tl-slide.tl-full-color-background h5, .tl-slide.tl-full-color-background h6, .tl-slide.tl-full-color-background p, .tl-slide.tl-full-image-background h1, .tl-slide.tl-full-image-background h2, .tl-slide.tl-full-image-background h3, .tl-slide.tl-full-image-background h4, .tl-slide.tl-full-image-background h5, .tl-slide.tl-full-image-background h6, .tl-slide.tl-full-image-background p {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-slide.tl-full-color-background a, .tl-slide.tl-full-color-background a:hover, .tl-slide.tl-full-color-background b, .tl-slide.tl-full-color-background blockquote, .tl-slide.tl-full-color-background blockquote p, .tl-slide.tl-full-color-background i, .tl-slide.tl-full-image-background a, .tl-slide.tl-full-image-background a:hover, .tl-slide.tl-full-image-background b, .tl-slide.tl-full-image-background blockquote, .tl-slide.tl-full-image-background blockquote p, .tl-slide.tl-full-image-background i {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n  color: #fff;\n}\n\n.tl-slide.tl-full-color-background .tl-caption, .tl-slide.tl-full-color-background .tl-credit, .tl-slide.tl-full-image-background .tl-caption, .tl-slide.tl-full-image-background .tl-credit {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-slide.tl-full-color-background .tl-media-blockquote blockquote, .tl-slide.tl-full-color-background .tl-media-twitter blockquote, .tl-slide.tl-full-image-background .tl-media-blockquote blockquote, .tl-slide.tl-full-image-background .tl-media-twitter blockquote {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-slide.tl-full-color-background .tl-media-blockquote blockquote p, .tl-slide.tl-full-color-background .tl-media-twitter blockquote p, .tl-slide.tl-full-image-background .tl-media-blockquote blockquote p, .tl-slide.tl-full-image-background .tl-media-twitter blockquote p {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-slide.tl-full-color-background .vcard .nickname, .tl-slide.tl-full-color-background .vcard a, .tl-slide.tl-full-image-background .vcard .nickname, .tl-slide.tl-full-image-background .vcard a {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-slide.tl-full-image-background {\n  background: no-repeat center center;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  background-position: center 25%;\n  text-shadow: 1px 1px 2px #000;\n}\n\n.tl-slide.tl-full-image-background h1, .tl-slide.tl-full-image-background h2, .tl-slide.tl-full-image-background h3, .tl-slide.tl-full-image-background h4, .tl-slide.tl-full-image-background h5, .tl-slide.tl-full-image-background h6, .tl-slide.tl-full-image-background p {\n  text-shadow: 1px 1px 2px #000;\n}\n\n.tl-slide.tl-full-image-background .tl-caption, .tl-slide.tl-full-image-background .tl-credit {\n  text-shadow: 1px 1px 2px #000;\n}\n\n.tl-slide.tl-full-image-background .tl-media-blockquote blockquote, .tl-slide.tl-full-image-background .tl-media-twitter blockquote {\n  text-shadow: 1px 1px 2px #000 !important;\n}\n\n.tl-slide.tl-full-image-background .tl-media-blockquote blockquote p, .tl-slide.tl-full-image-background .tl-media-twitter blockquote p {\n  text-shadow: 1px 1px 2px #000 !important;\n}\n\n.tl-slide.tl-text-background .tl-text .tl-text-content-container {\n  padding: 20px;\n  background: #000 transparent;\n  background: rgba(0, 0, 0, 0.6);\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.tl-slide.tl-text-background .tl-text .tl-text-content-container h2 {\n  margin-top: 5px;\n}\n\n.tl-skinny .tl-slide {\n  display: block;\n  padding-top: 10px;\n}\n\n.tl-skinny .tl-slide .tl-slide-content-container {\n  display: block;\n  position: static;\n  height: auto;\n  height: 100%;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  -webkit-align-items: center;\n}\n\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content {\n  display: block;\n  display: -webkit-flex;\n  display: flex;\n  flex-direction: column-reverse;\n  -webkit-flex-direction: column-reverse;\n  position: static;\n  height: auto;\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media {\n  position: static;\n  width: 100%;\n  height: auto;\n  float: none;\n  display: block;\n  padding-top: 20px;\n\n  /*border-top: 1px solid #e6e6e6;*/\n}\n\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text {\n  display: block;\n  height: auto;\n  vertical-align: initial;\n  position: static;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  float: none;\n  padding: 0;\n}\n\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-bottom: 10px;\n}\n\n.tl-skinny .tl-slide.tl-full-image-background .tl-slide-content-container .tl-slide-content .tl-media, .tl-skinny .tl-slide.tl-slide.tl-full-color-background .tl-slide-content-container .tl-slide-content .tl-media {\n  border-color: rgba(230, 230, 230, 0.25);\n}\n\n.tl-skinny .tl-slide.tl-slide-media-only .tl-slide-content-container .tl-slide-content {\n  flex-direction: column;\n  -webkit-flex-direction: column;\n}\n\n.tl-skinny .tl-slide.tl-slide-media-only .tl-slide-content-container .tl-slide-content .tl-media {\n  border-top: none;\n  padding-top: 0;\n}\n\n.tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media embed, .tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media iframe, .tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media img, .tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media object, .tl-mobile.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media video {\n  max-height: 175px;\n}\n\n.tl-slidenav-next, .tl-slidenav-previous {\n  position: absolute;\n  top: 45%;\n  z-index: 10;\n  cursor: pointer;\n}\n\n.tl-slidenav-next .tl-slidenav-content-container, .tl-slidenav-previous .tl-slidenav-content-container {\n  height: 200px;\n  width: 100px;\n  position: absolute;\n}\n\n.tl-slidenav-next .tl-slidenav-description, .tl-slidenav-next .tl-slidenav-title, .tl-slidenav-previous .tl-slidenav-description, .tl-slidenav-previous .tl-slidenav-title {\n  /*width: 80px;*/\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  text-overflow: ellipsis;\n  filter: alpha(opacity = 40);\n  -khtml-opacity: .4;\n  -moz-opacity: .4;\n  opacity: .4;\n}\n\n.tl-slidenav-next .tl-slidenav-description small, .tl-slidenav-next .tl-slidenav-title small, .tl-slidenav-previous .tl-slidenav-description small, .tl-slidenav-previous .tl-slidenav-title small {\n  display: block;\n}\n\n.tl-slidenav-next .tl-slidenav-title, .tl-slidenav-previous .tl-slidenav-title {\n  margin-top: 10px;\n  font-size: 11px;\n  line-height: 11px;\n}\n\n.tl-slidenav-next .tl-slidenav-description, .tl-slidenav-previous .tl-slidenav-description {\n  font-size: 11px;\n  margin-top: 5px;\n  filter: alpha(opacity = 0);\n  -khtml-opacity: 0;\n  -moz-opacity: 0;\n  opacity: 0;\n}\n\n.tl-slidenav-next .tl-slidenav-description small, .tl-slidenav-previous .tl-slidenav-description small {\n  display: none;\n}\n\n.tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-description, .tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-icon, .tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-title, .tl-slidenav-previous .tl-slidenav-content-container .tl-slidenav-description, .tl-slidenav-previous .tl-slidenav-content-container .tl-slidenav-icon, .tl-slidenav-previous .tl-slidenav-content-container .tl-slidenav-title {\n  /*  text-shadow: 1px 1px 1px #FFF;\n    color: #333;*/\n}\n\n.tl-slidenav-next .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-description, .tl-slidenav-next .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-icon, .tl-slidenav-next .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-title, .tl-slidenav-previous .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-description, .tl-slidenav-previous .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-icon, .tl-slidenav-previous .tl-slidenav-content-container.tl-slidenav-inverted .tl-slidenav-title {\n  color: #f2f2f2;\n  text-shadow: 1px 1px 1px #333;\n}\n\n.tl-slidenav-next .tl-slidenav-icon, .tl-slidenav-previous .tl-slidenav-icon {\n  font-family: tl-icons;\n  speak: none;\n  font-style: normal;\n  font-weight: 400;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 32px;\n  margin-bottom: 5px;\n}\n\n.tl-slidenav-next {\n  text-align: right;\n  margin-right: 10px;\n  right: 100px;\n}\n\n.tl-slidenav-next .tl-slidenav-description, .tl-slidenav-next .tl-slidenav-title {\n  margin-left: 20px;\n}\n\n.tl-slidenav-next .tl-slidenav-icon {\n  margin-left: 76px;\n}\n\n.tl-slidenav-next .tl-slidenav-icon:before {\n  content: \"\\e64f\";\n}\n\n.tl-slidenav-previous {\n  text-align: left;\n  margin-left: 10px;\n}\n\n.tl-slidenav-previous .tl-slidenav-icon {\n  margin-left: 0;\n}\n\n.tl-slidenav-previous .tl-slidenav-icon:before {\n  content: \"\\e650\";\n}\n\n/*.tl-slidenav-next:hover .tl-slidenav-title, .tl-slidenav-previous:hover .tl-slidenav-title {\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n\n.tl-slidenav-next:hover .tl-slidenav-description, .tl-slidenav-previous:hover .tl-slidenav-description {\n  filter: alpha(opacity = 50);\n  -khtml-opacity: .5;\n  -moz-opacity: .5;\n  opacity: .5;\n}*/\n\n/*.tl-slidenav-next:hover .tl-slidenav-icon {\n  margin-left: 80px;\n}\n\n.tl-slidenav-previous:hover .tl-slidenav-icon {\n  margin-left: -4px;\n}\n*/\n.tl-skinny .tl-slidenav-next {\n  right: 32px;\n}\n\n.tl-skinny .tl-slidenav-next .tl-slidenav-icon {\n  margin-left: 8px;\n}\n\n.tl-skinny .tl-slidenav-next .tl-slidenav-content-container, .tl-skinny .tl-slidenav-previous .tl-slidenav-content-container {\n  width: 32px;\n  height: 32px;\n}\n\n.tl-skinny .tl-slidenav-next .tl-slidenav-description, .tl-skinny .tl-slidenav-next .tl-slidenav-title, .tl-skinny .tl-slidenav-previous .tl-slidenav-description, .tl-skinny .tl-slidenav-previous .tl-slidenav-title {\n  display: none;\n}\n\n.tl-skinny .tl-slidenav-next .tl-slidenav-icon, .tl-skinny .tl-slidenav-previous .tl-slidenav-icon {\n  filter: alpha(opacity = 33);\n  -khtml-opacity: .33;\n  -moz-opacity: .33;\n  opacity: .33;\n}\n\n/*.tl-skinny .tl-slidenav-next:hover .tl-slidenav-icon {\n  margin-left: 12px;\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n\n.tl-skinny .tl-slidenav-previous:hover .tl-slidenav-icon {\n  margin-left: -4px;\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}*/\n\n/*.tl-layout-landscape.tl-mobile .tl-slidenav-next:hover {\n  right: 70px;\n}\n\n.tl-layout-landscape.tl-mobile .tl-slidenav-next:hover .tl-slidenav-icon {\n  margin-left: 8px;\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n*/\n.tl-layout-landscape.tl-mobile .tl-slidenav-next:active .tl-slidenav-icon {\n  margin-left: 0;\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n\n/*.tl-layout-landscape.tl-mobile .tl-slidenav-previous:hover .tl-slidenav-icon {\n  margin-left: 80px;\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}*/\n\n/*.tl-layout-landscape.tl-mobile .tl-slidenav-previous:active .tl-slidenav-icon {\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n  margin-left: -4px;\n}\n\n.tl-layout-portrait.tl-mobile .tl-slidenav-next:hover .tl-slidenav-icon {\n  filter: alpha(opacity = 33);\n  -khtml-opacity: .33;\n  -moz-opacity: .33;\n  opacity: .33;\n}\n\n.tl-layout-portrait.tl-mobile .tl-slidenav-next:active .tl-slidenav-icon {\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}\n\n.tl-layout-portrait.tl-mobile .tl-slidenav-previous:hover .tl-slidenav-icon {\n  filter: alpha(opacity = 33);\n  -khtml-opacity: .33;\n  -moz-opacity: .33;\n  opacity: .33;\n}\n\n.tl-layout-portrait.tl-mobile .tl-slidenav-previous:active .tl-slidenav-icon {\n  filter: alpha(opacity = 100);\n  -khtml-opacity: 1;\n  -moz-opacity: 1;\n  opacity: 1;\n}*/\n\n/*.tl-mobile .tl-slidenav-next, .tl-mobile .tl-slidenav-previous, .tl-skinny.tl-layout-landscape.tl-mobile .tl-slidenav-next, .tl-skinny.tl-layout-landscape.tl-mobile .tl-slidenav-previous, .tl-skinny.tl-layout-portrait.tl-mobile .tl-slidenav-next, .tl-skinny.tl-layout-portrait.tl-mobile .tl-slidenav-previous, .tl-skinny.tl-mobile .tl-slidenav-next, .tl-skinny.tl-mobile .tl-slidenav-previous {\n  display: none;\n}*/\n\n.tl-storyslider {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  position: relative;\n  box-sizing: content-box;\n  z-index: 8;\n}\n\n.tl-storyslider embed, .tl-storyslider iframe, .tl-storyslider img, .tl-storyslider object, .tl-storyslider video {\n  max-width: 100%;\n  position: relative;\n}\n\n.tl-storyslider .tl-slider-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.tl-storyslider .tl-slider-touch-mask {\n  width: 100%;\n  height: 100%;\n  z-index: 25;\n  top: 0;\n  left: 0;\n  position: absolute;\n}\n\n.tl-storyslider .tl-slider-container-mask {\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 5;\n}\n\n.tl-storyslider .tl-slider-container-mask .tl-slider-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n\n.tl-storyslider .tl-slider-container-mask .tl-slider-container .tl-slider-item-container {\n  width: 100%;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.tl-media {\n  width: 100%;\n  min-width: 50%;\n  height: 100%;\n  float: left;\n  margin-top: auto;\n  margin-bottom: auto;\n  position: relative;\n}\n\n.tl-media .tl-media-content-container.tl-media-content-container-text {\n  border-right: 1px solid #e6e6e6;\n  padding-right: 20px;\n}\n\n.tl-media .tl-media-content-container .tl-media-content {\n  position: relative;\n}\n\n.tl-media .tl-media-content-container .tl-media-content:after, .tl-media .tl-media-content-container .tl-media-content:before {\n  display: table;\n  content: \"\";\n}\n\n.tl-media .tl-media-content-container .tl-media-content:after {\n  clear: both;\n}\n\n.tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror p {\n  color: #f2f2f2;\n  text-align: center;\n}\n\n.tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror p span {\n  color: #f2f2f2;\n}\n\n.tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror [class*=\" tl-icon-\"], .tl-media .tl-media-content-container .tl-media-content .tl-media-loaderror [class^=tl-icon-] {\n  font-size: 28px;\n  color: #f2f2f2;\n  text-align: center;\n}\n\n.tl-media .tl-media-content-container .tl-media-content embed, .tl-media .tl-media-content-container .tl-media-content img, .tl-media .tl-media-content-container .tl-media-content object, .tl-media .tl-media-content-container .tl-media-content video {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.tl-slide-media-only .tl-media .tl-media-content-container.tl-media-content-container-text {\n  border-right: none;\n  padding-right: 0;\n}\n\n.tl-media-shadow {\n  position: relative;\n  z-index: 1;\n  -webkit-box-shadow: 0 12px 10px -10px rgba(0, 0, 0, 0.6);\n  -moz-box-shadow: 0 12px 10px -10px rgba(0, 0, 0, 0.6);\n  box-shadow: 0 12px 10px -10px rgba(0, 0, 0, 0.6);\n}\n\n.tl-slide.tl-full-color-background .vcard a, .tl-slide.tl-full-color-background a, .tl-slide.tl-full-image-background .vcard a, .tl-slide.tl-full-image-background a {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n  color: #fff;\n}\n\n.tl-credit {\n  color: #999;\n  text-align: right;\n  display: block;\n  margin: 0 auto;\n  margin-top: 6px;\n  font-size: 10px;\n  line-height: 13px;\n}\n\n.tl-caption {\n  text-align: left;\n  margin-right: auto;\n  margin-left: auto;\n  margin-top: 10px;\n  color: #666;\n  font-size: 11px;\n  line-height: 14px;\n  text-rendering: optimizeLegibility;\n  word-wrap: break-word;\n}\n\n.tl-full-color-background .tl-media-shadow:after, .tl-full-color-background .tl-media-shadow:before, .tl-full-image-background .tl-media-shadow:after, .tl-full-image-background .tl-media-shadow:before {\n  background: 0 0;\n  -webkit-box-shadow: 0 0 0 #000;\n  -moz-box-shadow: 0 0 0 #000;\n  box-shadow: 0 0 0 #000;\n}\n\n.tl-skinny .tl-media {\n  width: 100%;\n  height: auto;\n  float: none;\n  display: block;\n}\n\n.tl-skinny .tl-media .tl-media-content-container.tl-media-content-container-text {\n  border-right: 0;\n  padding-right: 0;\n}\n\n.tl-skinny .tl-media .tl-media-content-container .tl-caption, .tl-skinny .tl-media .tl-media-content-container .tl-credit {\n  margin-top: 2px;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 8px;\n}\n\n.tl-skinny .tl-media .tl-media-content-container .tl-credit {\n  margin-top: 0;\n}\n\n.tl-mobile.tl-skinny .tl-media {\n  width: 100%;\n  height: auto;\n  float: none;\n  display: block;\n}\n\n.tl-mobile.tl-skinny .tl-media .tl-media-content-container.tl-media-content-container-text {\n  border-right: 0;\n  padding-right: 0;\n}\n\n.tl-text {\n  width: 50%;\n  max-width: 50%;\n  min-width: 120px;\n  padding: 0 20px 0 20px;\n  display: table-cell;\n  vertical-align: middle;\n  text-align: left;\n  text-shadow: none;\n  color: #737373;\n}\n\n.tl-text p {\n  color: #737373;\n}\n\n.tl-text h2.tl-headline, .tl-text h2.tl-headline-title {\n  margin-top: 0;\n}\n\n.tl-text .tl-headline-date, .tl-text h3.tl-headline-date {\n  font-family: Barlow,sans-serif;\n  font-size: 15px;\n  line-height: 15px;\n  font-weight: 400;\n  margin: 0 0 3px 0;\n  color: #b3b3b3;\n}\n\n.tl-text .tl-headline-date small, .tl-text h3.tl-headline-date small {\n  font-size: 15px;\n  line-height: 15px;\n  font-weight: 400;\n  color: #b3b3b3;\n}\n\n.tl-text .tl-text-date {\n  display: inline-block;\n  font-family: Barlow,sans-serif;\n  font-weight: 400;\n  margin-top: 10px;\n  font-size: 12px;\n  color: #b3b3b3;\n}\n\n.tl-full-color-background .tl-text, .tl-full-color-background .tl-text p, .tl-full-image-background .tl-text, .tl-full-image-background .tl-text p {\n  color: #f2f2f2 !important;\n  text-shadow: 1px 1px 2px #000;\n}\n\n.tl-full-color-background .tl-text .tl-headline-date, .tl-full-color-background .tl-text h3.tl-headline-date, .tl-full-color-background .tl-text p .tl-headline-date, .tl-full-color-background .tl-text p h3.tl-headline-date, .tl-full-image-background .tl-text .tl-headline-date, .tl-full-image-background .tl-text h3.tl-headline-date, .tl-full-image-background .tl-text p .tl-headline-date, .tl-full-image-background .tl-text p h3.tl-headline-date {\n  color: #f2f2f2 !important;\n}\n\n.tl-full-color-background .tl-text .tl-headline-date small, .tl-full-color-background .tl-text h3.tl-headline-date small, .tl-full-color-background .tl-text p .tl-headline-date small, .tl-full-color-background .tl-text p h3.tl-headline-date small, .tl-full-image-background .tl-text .tl-headline-date small, .tl-full-image-background .tl-text h3.tl-headline-date small, .tl-full-image-background .tl-text p .tl-headline-date small, .tl-full-image-background .tl-text p h3.tl-headline-date small {\n  color: #f2f2f2 !important;\n}\n\n.tl-skinny .tl-text {\n  width: 100%;\n  max-width: 100%;\n  min-width: auto;\n  float: none;\n  margin-top: 20px;\n}\n\n.tl-skinny .tl-text h2.tl-headline, .tl-skinny .tl-text h2.tl-headline-title {\n  /*  font-size: 32px;\n    line-height: 36px;*/\n}\n\n.tl-medium .tl-text h2.tl-headline, .tl-medium .tl-text h2.tl-headline-title {\n  font-size: 32px;\n  line-height: 36px;\n}\n\n.tl-mobile.tl-skinny .tl-media .tl-media-image {\n  max-height: 250px !important;\n}\n\n.tl-media .tl-media-twitter {\n  text-align: left;\n  clear: both;\n}\n\n.tl-media .tl-media-twitter blockquote {\n  margin: 0;\n  margin-right: 15px;\n  font-size: 15px;\n  line-height: 21px;\n  color: #333;\n}\n\n.tl-media .tl-media-twitter blockquote p {\n  font-size: 28px;\n  line-height: 30px;\n  color: #000;\n}\n\n.tl-media .tl-media-twitter blockquote p:before {\n  display: none;\n}\n\n.tl-media .tl-media-twitter blockquote p:after {\n  display: none;\n}\n\n.tl-media .tl-media-twitter .tl-icon-twitter {\n  color: #55ACEE;\n}\n\n.tl-media .tl-media-twitter .vcard a.tl-date:hover, .tl-media .tl-media-twitter .vcard a:hover {\n  text-decoration: none;\n  color: #55ACEE;\n}\n\n.tl-media .tl-media-twitter .vcard a.tl-date:hover .fn, .tl-media .tl-media-twitter .vcard a.tl-date:hover .nickname, .tl-media .tl-media-twitter .vcard a:hover .fn, .tl-media .tl-media-twitter .vcard a:hover .nickname {\n  color: #55ACEE;\n}\n\n.tl-slide-media-only .tl-media .tl-media-twitter {\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.tl-mobile.tl-skinny .tl-media .tl-media-twitter blockquote p {\n  font-size: 15px;\n  line-height: 21px;\n}\n\n.tl-skinny .tl-media .tl-media-twitter {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.tl-skinny .tl-media .tl-media-twitter blockquote p {\n  font-size: 24px;\n  line-height: 26px;\n}\n\n.tl-media .tl-media-blockquote {\n  text-align: left;\n  clear: both;\n}\n\n.tl-media .tl-media-blockquote blockquote {\n  margin: 0;\n  margin-right: 15px;\n  text-align: left;\n  font-size: 28px;\n  line-height: 30px;\n  color: #333;\n}\n\n.tl-media .tl-media-blockquote blockquote p {\n  font-size: 28px;\n  line-height: 30px;\n  color: #333;\n}\n\n.tl-media .tl-media-blockquote blockquote p:after, .tl-media .tl-media-blockquote blockquote p:before {\n  display: inline-block;\n  font-size: 36px;\n}\n\n.tl-media .tl-media-blockquote blockquote p:before {\n  content: open-quote;\n  margin-right: 5px;\n}\n\n.tl-media .tl-media-blockquote blockquote p:after {\n  content: close-quote;\n  margin-left: 3px;\n}\n\n.tl-media .tl-media-blockquote blockquote cite {\n  font-size: 15px;\n  line-height: 21px;\n  color: #999;\n  text-align: right;\n  margin-top: 15px;\n}\n\n.tl-slide-media-only .tl-media .tl-media-blockquote {\n  border-right: 0;\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n@media only screen and (max-width: 800px), only screen and (max-device-width: 800px) {\n  .tl-media .tl-media-blockquote blockquote p {\n    font-size: 24px;\n    line-height: 26px;\n  }\n}\n\n@media only screen and (max-width: 500px), only screen and (max-device-width: 500px) {\n  .tl-media .tl-media-blockquote blockquote p {\n    font-size: 15px;\n    line-height: 21px;\n  }\n}\n\n.tl-mobile.tl-skinny .tl-media .tl-media-instagram {\n  max-height: 250px !important;\n}\n\n.tl-media .tl-media-profile {\n  border-radius: 50%;\n}\n\n.tl-media .tl-media-iframe {\n  width: 100%;\n  height: 100%;\n}\n\n.tl-media .tl-media-iframe iframe {\n  width: 100%;\n  height: 100%;\n}\n\n.tl-media .tl-media-wikipedia {\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n  clear: both;\n}\n\n.tl-media .tl-media-wikipedia .tl-icon-wikipedia {\n  font-size: 32px;\n  margin-right: 10px;\n  float: left;\n  padding-top: 3px;\n}\n\n.tl-media .tl-media-wikipedia .tl-wikipedia-pageimage {\n  float: left;\n  margin-right: 10px;\n  margin-bottom: 5px;\n  margin-top: 5px;\n}\n\n.tl-media .tl-media-wikipedia .tl-wikipedia-title {\n  margin-left: 60px;\n  padding-left: 10px;\n  border-left: 1px solid #e6e6e6;\n  margin-bottom: 10px;\n}\n\n.tl-media .tl-media-wikipedia .tl-wikipedia-source {\n  font-size: 13px;\n  line-height: 15px;\n  font-style: italic;\n  margin-top: 3px;\n  display: block;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.tl-media .tl-media-wikipedia h4 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.tl-media .tl-media-wikipedia h4 a {\n  color: #000;\n  text-decoration: none;\n}\n\n.tl-media .tl-media-wikipedia h4 a:hover {\n  text-decoration: underline;\n}\n\n.tl-media .tl-media-wikipedia p {\n  font-size: 13px;\n  line-height: 19px;\n}\n\n.tl-slide-media-only .tl-media .tl-media-wikipedia {\n  border-right: 0;\n  border-top: 1px solid #e6e6e6;\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 25px;\n  padding-top: 25px;\n}\n\n.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia, .tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia {\n  padding: 20px;\n  background: #000 transparent;\n  background: rgba(0, 0, 0, 0.6);\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia h4 a, .tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia h4 a {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia .tl-wikipedia-title, .tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia .tl-wikipedia-title {\n  border-color: rgba(230, 230, 230, 0.25);\n}\n\n.tl-slide.tl-full-color-background .tl-media .tl-media-wikipedia .tl-wikipedia-source, .tl-slide.tl-full-image-background .tl-media .tl-media-wikipedia .tl-wikipedia-source {\n  color: rgba(230, 230, 230, 0.85);\n}\n\n.tl-mobile.tl-skinny .tl-media .tl-media-wikipedia, .tl-skinny .tl-media .tl-media-wikipedia {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.tl-media .tl-media-website {\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n  clear: both;\n}\n\n.tl-media .tl-media-website .tl-media-website-description {\n  font-size: 16px;\n  line-height: 19px;\n  font-style: italic;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n}\n\n.tl-media .tl-media-website h4 {\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 1;\n}\n\n.tl-media .tl-media-website h4 a {\n  color: #000;\n  text-decoration: none;\n}\n\n.tl-media .tl-media-website h4 a:hover {\n  text-decoration: underline;\n}\n\n.tl-media .tl-media-website p {\n  font-size: 13px;\n  line-height: 19px;\n}\n\n.tl-media .tl-media-content-container .tl-media-content .tl-media-website img {\n  float: right;\n  max-width: 120px;\n  max-height: 120px;\n  margin: 4px 0 0 15px;\n}\n\n.tl-media .tl-media-content-container .tl-media-content .tl-media-website img.tl-media-website-icon {\n  max-width: 16px;\n  max-height: 16px;\n  float: none;\n  margin: 0;\n  margin-right: 3px;\n}\n\n.tl-slide.tl-full-color-background .tl-media .tl-media-website, .tl-slide.tl-full-image-background .tl-media .tl-media-website {\n  padding: 20px;\n  background: #000 transparent;\n  background: rgba(0, 0, 0, 0.6);\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.tl-slide.tl-full-color-background .tl-media .tl-media-website h4 a, .tl-slide.tl-full-image-background .tl-media .tl-media-website h4 a {\n  color: #FFF !important;\n  text-shadow: 1px 1px 1px #000 !important;\n}\n\n.tl-mobile.tl-skinny .tl-media .tl-media-website {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.tl-timeline {\n  width: 100%;\n  height: 100%;\n  font-size: 16px;\n  line-height: normal;\n  overflow: hidden;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  background-color: #FFF;\n  color: #737373;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.tl-timeline.tl-timeline-embed {\n  box-sizing: border-box;\n  border-top: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;\n  border-radius: 0;\n}\n\n.tl-timeline.tl-timeline-full-embed {\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.tl-layout-portrait .tl-storyslider {\n  -webkit-box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.2);\n}\n\n.tl-rtl .blockquote, .tl-rtl .tl-headline, .tl-rtl .tl-headline-date, .tl-rtl .tl-media .tl-media-blockquote blockquote, .tl-rtl .tl-media-blockquote, .tl-rtl .tl-media-website, .tl-rtl .tl-media-wikipedia, .tl-rtl .tl-text-content, .tl-rtl .tl-text-content p, .tl-rtl .tl-timeline blockquote p, .tl-rtl blockquote p {\n  text-align: right;\n  direction: rtl;\n}\n\n.tl-rtl .tl-slide-media-only .tl-headline, .tl-rtl .tl-slide-media-only .tl-headline-date {\n  text-align: center;\n}\n\n.tl-rtl .tl-timemarker-text {\n  margin-right: 35px;\n}\n\n.tl-rtl .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-media-container {\n  float: right;\n}\n\n.tl-rtl .tl-caption {\n  text-align: right;\n}\n\n.tl-rtl .tl-credit {\n  text-align: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1497:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports
exports.i(__webpack_require__(1463), "");

// module
exports.push([module.i, ".timeline-title{position:absolute;font-size:1.375rem;line-height:1.875rem;width:100%;color:#f8008e;font-weight:700;text-transform:uppercase;max-width:43.75rem;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);top:.625rem;padding-left:1.25rem;z-index:5}@media (min-width:1024px){.timeline-title{top:.9375rem}}@media (min-width:1024px){.related-person-overlay .timeline-title{top:.625rem}}@media (min-width:1024px){.overlay .timeline-lazy-wrapper{margin:0 -.5rem}}.timeline-pane{position:relative;min-height:33.125rem;width:100%}.gradient-cover{width:100%;height:100%;position:absolute;border-top:1px solid #5d7ba0;top:0;left:0;background-image:-webkit-gradient(linear,left top,left bottom,from(#0b447c),color-stop(55%,#012b55));background-image:-o-linear-gradient(#0b447c 0,#012b55 55%);background-image:linear-gradient(#0b447c,#012b55 55%)}.tl-timeline{background-color:transparent;position:absolute;height:37.5rem}@media (min-width:0) and (max-width:1023px){.tl-timeline{height:33.125rem}}.overlay .tl-timeline{height:33.125rem}.tl-caption{display:none}.tl-text-content-container{max-width:37.5rem;margin:0 auto;color:#fff}.tl-text-content-container .tl-headline-date,.tl-text-content-container h3.tl-headline-date{font-size:1rem;line-height:1.375rem;color:currentColor}.tl-text-content-container .tl-headline,.tl-text-content-container h2.tl-headline{text-transform:uppercase;color:currentColor;font-size:1.875rem;line-height:1.875rem;font-weight:600;overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}@media (min-width:1024px){.tl-text-content-container .tl-headline,.tl-text-content-container h2.tl-headline{width:31.25rem}}.tl-text-content-container .tl-text-content{width:95%}.tl-text-content-container .tl-text-content p{color:currentColor;font-size:1rem;line-height:1.5rem;font-family:Roboto,sans-serif;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}.tl-timenav{overflow:visible;background-color:#0e2039;bottom:0;position:absolute;border:none;z-index:4}.tl-timenav:after{content:\" \";background-image:url(\"/static/svg/timeline_triangle.svg\");background-size:contain;width:2.1875rem;height:1.0625rem;left:50%;top:-1.125rem;position:absolute;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);z-index:10}.tl-timeaxis-background{background:#012b55;border:none}.tl-layout-portrait .tl-storyslider{-webkit-box-shadow:none;box-shadow:none}.tl-storyslider{background-color:transparent;z-index:3}.tl-storyslider:before{content:\" \";position:absolute;bottom:0;width:100%;left:0;background-color:#0e2039;height:1.0625rem;border-top:.0625rem solid #304055}.tl-storyslider .tl-slider-background{visibility:hidden}.tl-media-content-container{text-align:left}.tl-timemarker.tl-timemarker-active .tl-timemarker-timespan{visibility:hidden}.tl-timemarker-media-container{display:none}.tl-timemarker.tl-timemarker-active .tl-timemarker-content{background-color:#fff}.tl-timemarker.tl-timemarker-active .tl-timemarker-content:after{border-color:#fff transparent transparent}.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left{display:none;border-color:#f8008e;border-left-width:.125rem;-webkit-box-shadow:none;box-shadow:none;margin-top:0}.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left:after{background-color:#f8008e}.tl-timemarker.tl-timemarker-active .tl-headline{color:#000}.tl-timemarker .tl-timemarker-line-left{-webkit-box-shadow:none;box-shadow:none;display:none;margin-top:0}.tl-timemarker .tl-timemarker-content-container{border-radius:0;background-color:transparent;border:none;-webkit-box-shadow:none;box-shadow:none;width:9.375rem}.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content{height:1.875rem}.tl-timemarker .tl-timemarker-content{padding:.5rem .375rem .5rem .25rem;background-color:#000}.tl-timemarker .tl-timemarker-content:after{content:\" \";width:0;height:0;border-style:solid;border-width:.4375rem .4375rem 0 0;border-color:#000 transparent transparent;bottom:0;left:0;position:absolute;-webkit-transform:translateY(100%);-ms-transform:translateY(100%);transform:translateY(100%)}.tl-timemarker .tl-timemarker-text .tl-headline{width:8.75rem;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}.tl-timemarker .tl-headline{color:hsla(0,0%,100%,.5)}.tl-slidenav-title{overflow:hidden;max-height:4.0625rem}.tl-slidenav-next,.tl-slidenav-previous{top:65%!important}.tl-slidenav-next .tl-slidenav-icon,.tl-slidenav-previous .tl-slidenav-icon{margin-bottom:0;margin-right:0;margin-left:0;display:inline-block;width:1.125rem;height:1.875rem}.tl-slidenav-next .tl-slidenav-icon:before,.tl-slidenav-previous .tl-slidenav-icon:before{width:100%;height:100%;display:inline-block;content:\" \";background-size:100%}.tl-slidenav-next .tl-slidenav-title,.tl-slidenav-previous .tl-slidenav-title{font-size:.875rem;line-height:1rem;color:#fff;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;margin-top:-.625rem}.tl-slidenav-next .tl-slidenav-content-container,.tl-slidenav-previous .tl-slidenav-content-container{z-index:21}.tl-slidenav-next .tl-slidenav-description,.tl-slidenav-previous .tl-slidenav-description{opacity:.4;color:#fff;font-size:.75rem;line-height:1.125rem}.tl-slidenav-next{z-index:21}@media (min-width:0) and (max-width:1023px){.tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-icon{margin-right:0}}.tl-slidenav-next .tl-slidenav-icon:before{right:0;background-image:url(\"/static/svg/icon_arrow_right_8bit_white.svg\")}.tl-slidenav-previous{z-index:21}.tl-slidenav-previous .tl-slidenav-icon:before{left:0;background-image:url(\"/static/svg/icon_arrow_left_8bit_white.svg\")}.tl-menubar{display:none}.tl-timemarker-active .timeline-marker-line,.tl-timemarker-active .timeline-marker-line:after{background-color:#f8008e}.timeline-marker-line{width:.0625rem;background-color:#d8d8d8;position:relative;z-index:4}.timeline-marker-line:after{content:\" \";position:absolute;bottom:-.1875rem;left:-.1875rem;width:.375rem;height:.375rem;border-radius:50%;display:inline-block;background-color:#d8d8d8}.tl-slide{-webkit-box-sizing:border-box;box-sizing:border-box;padding-top:3.125rem;height:90%}.tl-slide,.tl-slide-scrollable-container{overflow-y:hidden}.tl-slide .tl-slide-content-container{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.tl-slide .tl-slide-content-container .tl-slide-content{display:table-row}.tl-slide .tl-slide-content-container .tl-slide-content .tl-media{min-width:0;width:23.75rem;height:13.75rem;margin-right:1.25rem;display:table-cell}.tl-slide .tl-slide-content-container .tl-slide-content .tl-text{max-width:100%;width:auto;padding-left:0;padding-right:0}.tl-slide .tl-slide-content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%!important;padding-left:13.75rem!important;padding-right:6.25rem!important}.tl-slide:not(.tl-slide-text-only) .tl-slide-content-container{padding-top:1.8125rem}.tl-slide:not(.tl-slide-text-only) .tl-slide-content-container .tl-text{padding-top:1.25rem}.tl-slide.tl-slide-text-only .tl-slide-content-container .tl-text{padding-top:4.375rem}.tl-timenav{height:15.125rem!important}.tl-storyslider{height:22.375rem!important}.tl-skinny .tl-timenav{height:10.875rem!important}.tl-skinny .tl-storyslider{height:22.25rem!important}.tl-skinny .tl-media-content{width:94%;text-align:left}@media (min-width:0) and (max-width:1023px){.tl-skinny .tl-media-content{width:100%}}.tl-skinny .tl-text-content-container .tl-headline-date,.tl-skinny .tl-text-content-container h3.tl-headline-date{font-size:.875rem;line-height:.875rem;font-weight:600}.tl-skinny .tl-text-content-container .tl-headline,.tl-skinny .tl-text-content-container h2.tl-headline{font-size:1.25rem;line-height:1.5rem}.tl-skinny .tl-slide{padding-top:0;height:80%;margin-top:1.75rem;overflow-y:auto;height:300px}.tl-skinny .tl-slide-scrollable-container{overflow-y:auto;width:100%}.tl-skinny .tl-slide .tl-slide-content-container{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding-top:0}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%!important;padding-left:1.5625rem!important;padding-right:1.5625rem!important}@media (min-width:1024px){.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content{width:90%!important}}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media{max-width:100%!important;padding-top:0}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text{padding-left:0;padding-top:0;margin-top:1.0625rem}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container{padding-left:0;padding-right:0;padding-bottom:.75rem}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container p{margin-bottom:0}.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container .tl-headline,.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container h2.tl-headline{height:auto}@media (min-width:0) and (max-width:1023px){.tl-skinny .tl-slidenav-next,.tl-skinny .tl-slidenav-previous{display:none}}.tl-skinny .tl-slidenav-next .tl-slidenav-icon,.tl-skinny .tl-slidenav-previous .tl-slidenav-icon{width:.75rem;height:1.25rem}.tl-skinny .tl-media{height:10.375rem}.tl-skinny .tl-media-item{max-height:10.375rem!important;height:10.375rem!important;width:auto}.tl-layout-landscape .tl-slide{padding-left:.9375rem;padding-right:.625rem}.tl-attribution{display:none!important}", "", {"version":3,"sources":["/app/components/node/person/Timeline.vue"],"names":[],"mappings":"AAiCA,gBACE,kBAAmB,AACnB,mBAAoB,AACpB,qBAAsB,AACtB,WAAY,AACZ,cAAe,AACf,gBAAkB,AAClB,yBAA0B,AAC1B,mBAAoB,AACpB,SAAU,AACV,mCAAoC,AAChC,+BAAgC,AAC5B,2BAA4B,AACpC,YAAc,AACd,qBAAsB,AACtB,SAAW,CAEZ,AACD,0BACA,gBACM,YAAe,CACpB,CACA,AAID,0BACA,wCACQ,WAAc,CACrB,CACA,AAID,0BACA,gCACM,eAAkB,CACvB,CACA,AACD,eACE,kBAAmB,AACnB,qBAAsB,AACtB,UAAY,CACb,AACD,gBACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,6BAA8B,AAC9B,MAAO,AACP,OAAQ,AACR,qGAA2G,AAC3G,2DAA8D,AAC9D,qDAA2D,CAC5D,AACD,aACE,6BAA8B,AAC9B,kBAAmB,AACnB,cAAgB,CAEjB,AACD,4CACA,aACM,gBAAkB,CACvB,CACA,AACD,sBACI,gBAAkB,CACrB,AACD,YACE,YAAc,CACf,AACD,2BACE,kBAAmB,AACnB,cAAe,AACf,UAAe,CAChB,AACD,4FAEI,eAAgB,AAChB,qBAAsB,AACtB,kBAAoB,CACvB,AACD,kFAGI,yBAA0B,AAC1B,mBAAoB,AACpB,mBAAoB,AACpB,qBAAsB,AACtB,gBAAiB,AACjB,gBAAiB,AACjB,oBAAqB,AACrB,qBAAsB,AACtB,2BAA6B,CAChC,AACD,0BACA,kFAEQ,cAAgB,CACvB,CACA,AACD,4CACI,SAAW,CACd,AACD,8CACM,mBAAoB,AACpB,eAAgB,AAChB,mBAAoB,AACpB,8BAAkC,AAClC,oBAAqB,AACrB,4BAA6B,AAC7B,qBAAsB,AACtB,gBAAiB,AACjB,0BAA2B,AACxB,sBAAwB,CAChC,AACD,YACE,iBAAkB,AAClB,yBAA0B,AAC1B,SAAU,AACV,kBAAmB,AACnB,YAAa,AACb,SAAW,CACZ,AACD,kBACI,YAAa,AACb,0DAA2D,AAC3D,wBAAyB,AACzB,gBAAiB,AACjB,iBAAkB,AAClB,SAAU,AACV,cAAe,AACf,kBAAmB,AACnB,mCAAoC,AAChC,+BAAgC,AAC5B,2BAA4B,AACpC,UAAY,CACf,AACD,wBACE,mBAAoB,AACpB,WAAa,CACd,AACD,oCACE,wBAAyB,AACjB,eAAiB,CAC1B,AACD,gBACE,6BAA8B,AAC9B,SAAW,CACZ,AACD,uBACI,YAAa,AACb,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,OAAQ,AACR,yBAA0B,AAC1B,iBAAkB,AAClB,iCAAoC,CACvC,AACD,sCACI,iBAAmB,CACtB,AACD,4BACE,eAAiB,CAClB,AACD,4DACE,iBAAmB,CACpB,AACD,+BACE,YAAc,CACf,AACD,2DACE,qBAA0B,CAC3B,AACD,iEACI,yCAA0D,CAC7D,AACD,6DACE,aAAc,AACd,qBAAsB,AACtB,0BAA4B,AAC5B,wBAAyB,AACjB,gBAAiB,AACzB,YAAc,CACf,AACD,mEACI,wBAA0B,CAC7B,AACD,iDACE,UAAe,CAChB,AACD,wCACE,wBAAyB,AACjB,gBAAiB,AACzB,aAAc,AACd,YAAc,CACf,AACD,gDACE,gBAAiB,AACjB,6BAA8B,AAC9B,YAAa,AACb,wBAAyB,AACjB,gBAAiB,AACzB,cAAgB,CACjB,AACD,uEACI,eAAiB,CACpB,AACD,sCACE,mCAAwC,AACxC,qBAA0B,CAC3B,AACD,4CACI,YAAa,AACb,QAAS,AACT,SAAU,AACV,mBAAoB,AACpB,mCAAsC,AACtC,0CAA0D,AAC1D,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,mCAAoC,AAChC,+BAAgC,AAC5B,0BAA4B,CACvC,AACD,gDACE,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,0BAA2B,AACxB,sBAAwB,CAC5B,AACD,4BACE,wBAAgC,CACjC,AACD,mBACE,gBAAiB,AACjB,oBAAsB,CACvB,AACD,wCAEE,iBAAoB,CACrB,AACD,4EAEI,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,qBAAsB,AACtB,eAAgB,AAChB,eAAiB,CACpB,AACD,0FAEM,WAAY,AACZ,YAAa,AACb,qBAAsB,AACtB,YAAa,AACb,oBAAsB,CAC3B,AACD,8EAEI,kBAAoB,AACpB,iBAAkB,AAClB,WAAe,AACf,oBAAqB,AACrB,4BAA6B,AAC7B,qBAAsB,AACtB,gBAAiB,AACjB,0BAA2B,AACxB,uBAAwB,AAC3B,mBAAsB,CACzB,AACD,sGAEI,UAAY,CACf,AACD,0FAEI,WAAY,AACZ,WAAe,AACf,iBAAmB,AACnB,oBAAsB,CACzB,AACD,kBACE,UAAY,CACb,AAID,4CACA,mEACQ,cAAgB,CACvB,CACA,AACD,2CACI,QAAS,AACT,mEAAqE,CACxE,AACD,sBACE,UAAY,CACb,AACD,+CACI,OAAQ,AACR,kEAAoE,CACvE,AACD,YACE,YAAc,CACf,AAID,8FACI,wBAA0B,CAC7B,AACD,sBACE,eAAiB,AACjB,yBAA0B,AAC1B,kBAAmB,AACnB,SAAW,CACZ,AACD,4BACI,YAAa,AACb,kBAAmB,AACnB,iBAAmB,AACnB,eAAiB,AACjB,cAAgB,AAChB,eAAiB,AACjB,kBAAmB,AACnB,qBAAsB,AACtB,wBAA0B,CAC7B,AACD,UACE,8BAA+B,AACvB,sBAAuB,AAC/B,qBAAsB,AACtB,UAAY,CAEb,AACD,yCAFE,iBAAmB,CAIpB,AACD,sCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAY,AACZ,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,wDACM,iBAAmB,CACxB,AACD,kEACQ,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,qBAAsB,AACtB,kBAAoB,CAC3B,AACD,iEACQ,eAAgB,AAChB,WAAY,AACZ,eAAgB,AAChB,eAAiB,CACxB,AACD,4BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AACvB,sBAAuB,AAC/B,qBAAuB,AACvB,gCAAkC,AAClC,+BAAkC,CACrC,AACD,+DACI,qBAAuB,CAC1B,AACD,wEACM,mBAAqB,CAC1B,AACD,kEACI,oBAAsB,CACzB,AACD,YACE,0BAA6B,CAC9B,AACD,gBACE,0BAA6B,CAC9B,AAID,uBACE,0BAA6B,CAC9B,AACD,2BACE,yBAA4B,CAC7B,AACD,6BAEE,UAAW,AACX,eAAiB,CAClB,AACD,4CACA,6BACM,UAAY,CACjB,CACA,AACD,kHAEE,kBAAoB,AACpB,oBAAsB,AACtB,eAAiB,CAClB,AACD,wGAEE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,qBACE,cAAe,AACf,WAAY,AACZ,mBAAoB,AACpB,gBAAiB,AACjB,YAAc,CACf,AACD,0CACI,gBAAiB,AACjB,UAAY,CACf,AACD,iDACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,aAAe,CAClB,AACD,mEAEM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAuB,AACvB,iCAAmC,AACnC,iCAAoC,CACzC,AACD,0BACA,mEACU,mBAAsB,CAC/B,CACA,AACD,6EACQ,yBAA2B,AAC3B,aAAe,CACtB,AACD,4EACQ,eAAgB,AAChB,cAAe,AACf,oBAAsB,CAC7B,AACD,uGACU,eAAgB,AAChB,gBAAiB,AACjB,qBAAwB,CACjC,AACD,yGACY,eAAiB,CAC5B,AACD,0OAEY,WAAa,CACxB,AAKD,4CACA,8DAEM,YAAc,CACnB,CACA,AACD,kGAEI,aAAe,AACf,cAAgB,CACnB,AACD,qBACE,gBAAkB,CACnB,AACD,0BACE,+BAAiC,AACjC,2BAA6B,AAC7B,UAAY,CACb,AACD,+BACE,sBAAwB,AACxB,qBAAwB,CACzB,AACD,gBACE,sBAAyB,CAC1B","file":"Timeline.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n@import url(./../../../assets/css/timeline/timeline.css);\n.timeline-title {\n  position: absolute;\n  font-size: 1.375rem;\n  line-height: 1.875rem;\n  width: 100%;\n  color: #F8008E;\n  font-weight: bold;\n  text-transform: uppercase;\n  max-width: 43.75rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n      -ms-transform: translateX(-50%);\n          transform: translateX(-50%);\n  top: 0.625rem;\n  padding-left: 1.25rem;\n  z-index: 5;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.timeline-title {\n      top: 0.9375rem;\n}\n}\n.related-person-overlay .timeline-title {\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.related-person-overlay .timeline-title {\n        top: 0.625rem;\n}\n}\n.overlay .timeline-lazy-wrapper {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.overlay .timeline-lazy-wrapper {\n      margin: 0 -0.5rem;\n}\n}\n.timeline-pane {\n  position: relative;\n  min-height: 33.125rem;\n  width: 100%;\n}\n.gradient-cover {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  border-top: 1px solid #5D7BA0;\n  top: 0;\n  left: 0;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#0b447c), color-stop(55%, #012b55));\n  background-image: -o-linear-gradient(#0b447c 0%, #012b55 55%);\n  background-image: linear-gradient(#0b447c 0%, #012b55 55%);\n}\n.tl-timeline {\n  background-color: transparent;\n  position: absolute;\n  height: 37.5rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tl-timeline {\n      height: 33.125rem;\n}\n}\n.overlay .tl-timeline {\n    height: 33.125rem;\n}\n.tl-caption {\n  display: none;\n}\n.tl-text-content-container {\n  max-width: 37.5rem;\n  margin: 0 auto;\n  color: #FFFFFF;\n}\n.tl-text-content-container h3.tl-headline-date,\n  .tl-text-content-container .tl-headline-date {\n    font-size: 1rem;\n    line-height: 1.375rem;\n    color: currentColor;\n}\n.tl-text-content-container h2.tl-headline,\n  .tl-text-content-container .tl-headline {\n    /* Mobile breakpoints */\n    text-transform: uppercase;\n    color: currentColor;\n    font-size: 1.875rem;\n    line-height: 1.875rem;\n    font-weight: 600;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n}\n@media (min-width: 1024px) {\n.tl-text-content-container h2.tl-headline,\n      .tl-text-content-container .tl-headline {\n        width: 31.25rem;\n}\n}\n.tl-text-content-container .tl-text-content {\n    width: 95%;\n}\n.tl-text-content-container .tl-text-content p {\n      color: currentColor;\n      font-size: 1rem;\n      line-height: 1.5rem;\n      font-family: \"Roboto\", sans-serif;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 3;\n      overflow: hidden;\n      -o-text-overflow: ellipsis;\n         text-overflow: ellipsis;\n}\n.tl-timenav {\n  overflow: visible;\n  background-color: #0E2039;\n  bottom: 0;\n  position: absolute;\n  border: none;\n  z-index: 4;\n}\n.tl-timenav:after {\n    content: ' ';\n    background-image: url(\"/static/svg/timeline_triangle.svg\");\n    background-size: contain;\n    width: 2.1875rem;\n    height: 1.0625rem;\n    left: 50%;\n    top: -1.125rem;\n    position: absolute;\n    -webkit-transform: translateX(-50%);\n        -ms-transform: translateX(-50%);\n            transform: translateX(-50%);\n    z-index: 10;\n}\n.tl-timeaxis-background {\n  background: #012b55;\n  border: none;\n}\n.tl-layout-portrait .tl-storyslider {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.tl-storyslider {\n  background-color: transparent;\n  z-index: 3;\n}\n.tl-storyslider:before {\n    content: ' ';\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    left: 0;\n    background-color: #0E2039;\n    height: 1.0625rem;\n    border-top: 0.0625rem solid #304055;\n}\n.tl-storyslider .tl-slider-background {\n    visibility: hidden;\n}\n.tl-media-content-container {\n  text-align: left;\n}\n.tl-timemarker.tl-timemarker-active .tl-timemarker-timespan {\n  visibility: hidden;\n}\n.tl-timemarker-media-container {\n  display: none;\n}\n.tl-timemarker.tl-timemarker-active .tl-timemarker-content {\n  background-color: #FFFFFF;\n}\n.tl-timemarker.tl-timemarker-active .tl-timemarker-content:after {\n    border-color: #FFFFFF transparent transparent transparent;\n}\n.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left {\n  display: none;\n  border-color: #F8008E;\n  border-left-width: 0.125rem;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  margin-top: 0;\n}\n.tl-timemarker.tl-timemarker-active .tl-timemarker-line-left:after {\n    background-color: #F8008E;\n}\n.tl-timemarker.tl-timemarker-active .tl-headline {\n  color: #000000;\n}\n.tl-timemarker .tl-timemarker-line-left {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  display: none;\n  margin-top: 0;\n}\n.tl-timemarker .tl-timemarker-content-container {\n  border-radius: 0;\n  background-color: transparent;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  width: 9.375rem;\n}\n.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content {\n    height: 1.875rem;\n}\n.tl-timemarker .tl-timemarker-content {\n  padding: 0.5rem 0.375rem 0.5rem 0.25rem;\n  background-color: #000000;\n}\n.tl-timemarker .tl-timemarker-content:after {\n    content: ' ';\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0.4375rem 0.4375rem 0 0;\n    border-color: #000000 transparent transparent transparent;\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    -webkit-transform: translateY(100%);\n        -ms-transform: translateY(100%);\n            transform: translateY(100%);\n}\n.tl-timemarker .tl-timemarker-text .tl-headline {\n  width: 8.75rem;\n  white-space: nowrap;\n  overflow: hidden;\n  -o-text-overflow: ellipsis;\n     text-overflow: ellipsis;\n}\n.tl-timemarker .tl-headline {\n  color: rgba(255, 255, 255, 0.5);\n}\n.tl-slidenav-title {\n  overflow: hidden;\n  max-height: 4.0625rem;\n}\n.tl-slidenav-next,\n.tl-slidenav-previous {\n  top: 65% !important;\n}\n.tl-slidenav-next .tl-slidenav-icon,\n  .tl-slidenav-previous .tl-slidenav-icon {\n    margin-bottom: 0;\n    margin-right: 0;\n    margin-left: 0;\n    display: inline-block;\n    width: 1.125rem;\n    height: 1.875rem;\n}\n.tl-slidenav-next .tl-slidenav-icon:before,\n    .tl-slidenav-previous .tl-slidenav-icon:before {\n      width: 100%;\n      height: 100%;\n      display: inline-block;\n      content: ' ';\n      background-size: 100%;\n}\n.tl-slidenav-next .tl-slidenav-title,\n  .tl-slidenav-previous .tl-slidenav-title {\n    font-size: 0.875rem;\n    line-height: 1rem;\n    color: #FFFFFF;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    -o-text-overflow: ellipsis;\n       text-overflow: ellipsis;\n    margin-top: -0.625rem;\n}\n.tl-slidenav-next .tl-slidenav-content-container,\n  .tl-slidenav-previous .tl-slidenav-content-container {\n    z-index: 21;\n}\n.tl-slidenav-next .tl-slidenav-description,\n  .tl-slidenav-previous .tl-slidenav-description {\n    opacity: .4;\n    color: #FFFFFF;\n    font-size: 0.75rem;\n    line-height: 1.125rem;\n}\n.tl-slidenav-next {\n  z-index: 21;\n}\n.tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-icon {\n    /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-icon {\n        margin-right: 0;\n}\n}\n.tl-slidenav-next .tl-slidenav-icon:before {\n    right: 0;\n    background-image: url(\"/static/svg/icon_arrow_right_8bit_white.svg\");\n}\n.tl-slidenav-previous {\n  z-index: 21;\n}\n.tl-slidenav-previous .tl-slidenav-icon:before {\n    left: 0;\n    background-image: url(\"/static/svg/icon_arrow_left_8bit_white.svg\");\n}\n.tl-menubar {\n  display: none;\n}\n.tl-timemarker-active .timeline-marker-line {\n  background-color: #F8008E;\n}\n.tl-timemarker-active .timeline-marker-line:after {\n    background-color: #F8008E;\n}\n.timeline-marker-line {\n  width: 0.0625rem;\n  background-color: #D8D8D8;\n  position: relative;\n  z-index: 4;\n}\n.timeline-marker-line:after {\n    content: ' ';\n    position: absolute;\n    bottom: -0.1875rem;\n    left: -0.1875rem;\n    width: 0.375rem;\n    height: 0.375rem;\n    border-radius: 50%;\n    display: inline-block;\n    background-color: #D8D8D8;\n}\n.tl-slide {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding-top: 3.125rem;\n  height: 90%;\n  overflow-y: hidden;\n}\n.tl-slide-scrollable-container {\n    overflow-y: hidden;\n}\n.tl-slide .tl-slide-content-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n}\n.tl-slide .tl-slide-content-container .tl-slide-content {\n      display: table-row;\n}\n.tl-slide .tl-slide-content-container .tl-slide-content .tl-media {\n        min-width: 0;\n        width: 23.75rem;\n        height: 13.75rem;\n        margin-right: 1.25rem;\n        display: table-cell;\n}\n.tl-slide .tl-slide-content-container .tl-slide-content .tl-text {\n        max-width: 100%;\n        width: auto;\n        padding-left: 0;\n        padding-right: 0;\n}\n.tl-slide .tl-slide-content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100% !important;\n    padding-left: 13.75rem !important;\n    padding-right: 6.25rem !important;\n}\n.tl-slide:not(.tl-slide-text-only) .tl-slide-content-container {\n    padding-top: 1.8125rem;\n}\n.tl-slide:not(.tl-slide-text-only) .tl-slide-content-container .tl-text {\n      padding-top: 1.25rem;\n}\n.tl-slide.tl-slide-text-only .tl-slide-content-container .tl-text {\n    padding-top: 4.375rem;\n}\n.tl-timenav {\n  height: 15.125rem !important;\n}\n.tl-storyslider {\n  height: 22.375rem !important;\n}\n.tl-skinny .tl-slide .tl-slide-content-container {\n  padding-top: 0;\n}\n.tl-skinny .tl-timenav {\n  height: 10.875rem !important;\n}\n.tl-skinny .tl-storyslider {\n  height: 22.25rem !important;\n}\n.tl-skinny .tl-media-content {\n  /* Mobile breakpoints */\n  width: 94%;\n  text-align: left;\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tl-skinny .tl-media-content {\n      width: 100%;\n}\n}\n.tl-skinny .tl-text-content-container h3.tl-headline-date,\n.tl-skinny .tl-text-content-container .tl-headline-date {\n  font-size: 0.875rem;\n  line-height: 0.875rem;\n  font-weight: 600;\n}\n.tl-skinny .tl-text-content-container h2.tl-headline,\n.tl-skinny .tl-text-content-container .tl-headline {\n  font-size: 1.25rem;\n  line-height: 1.5rem;\n}\n.tl-skinny .tl-slide {\n  padding-top: 0;\n  height: 80%;\n  margin-top: 1.75rem;\n  overflow-y: auto;\n  height: 300px;\n}\n.tl-skinny .tl-slide-scrollable-container {\n    overflow-y: auto;\n    width: 100%;\n}\n.tl-skinny .tl-slide .tl-slide-content-container {\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    padding-top: 0;\n}\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content {\n      /* Mobile breakpoints */\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      width: 100% !important;\n      padding-left: 1.5625rem !important;\n      padding-right: 1.5625rem !important;\n}\n@media (min-width: 1024px) {\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content {\n          width: 90% !important;\n}\n}\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-media {\n        max-width: 100% !important;\n        padding-top: 0;\n}\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text {\n        padding-left: 0;\n        padding-top: 0;\n        margin-top: 1.0625rem;\n}\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container {\n          padding-left: 0;\n          padding-right: 0;\n          padding-bottom: 0.75rem;\n}\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container p {\n            margin-bottom: 0;\n}\n.tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container h2.tl-headline,\n          .tl-skinny .tl-slide .tl-slide-content-container .tl-slide-content .tl-text .tl-text-content-container .tl-headline {\n            height: auto;\n}\n.tl-skinny .tl-slidenav-next,\n.tl-skinny .tl-slidenav-previous {\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tl-skinny .tl-slidenav-next,\n    .tl-skinny .tl-slidenav-previous {\n      display: none;\n}\n}\n.tl-skinny .tl-slidenav-next .tl-slidenav-icon,\n  .tl-skinny .tl-slidenav-previous .tl-slidenav-icon {\n    width: 0.75rem;\n    height: 1.25rem;\n}\n.tl-skinny .tl-media {\n  height: 10.375rem;\n}\n.tl-skinny .tl-media-item {\n  max-height: 10.375rem !important;\n  height: 10.375rem !important;\n  width: auto;\n}\n.tl-layout-landscape .tl-slide {\n  padding-left: 0.9375rem;\n  padding-right: 0.625rem;\n}\n.tl-attribution {\n  display: none !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1498:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper a{width:3.125rem;height:3.125rem;min-height:3.125rem;background-color:rgba(0,0,0,.5);border-radius:50%;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:1rem}.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper a:hover{background:#f8008e}.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper svg{display:-webkit-box;display:-ms-flexbox;display:flex}.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper svg.facebook{width:.6875rem;height:1.5rem}.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper svg.email{width:1.375rem;height:1rem}.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper a:hover>svg{fill:#00113d!important}", "", {"version":3,"sources":["/app/components/node/person/ShareBar.vue"],"names":[],"mappings":"AAgCA,kFACE,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,oFACI,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AACrB,gCAAqC,AACrC,kBAAmB,AACnB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAoB,CACvB,AACD,0FACM,kBAAoB,CACzB,AACD,sFACI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,+FACM,eAAiB,AACjB,aAAe,CACpB,AACD,4FACM,eAAgB,AAChB,WAAa,CAClB,AACD,8FACI,sBAAyB,CAC5B","file":"ShareBar.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper a {\n    width: 3.125rem;\n    height: 3.125rem;\n    min-height: 3.125rem;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin-bottom: 1rem;\n}\n.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper a:hover {\n      background: #F8008E;\n}\n.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper svg {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper svg.facebook {\n      width: 0.6875rem;\n      height: 1.5rem;\n}\n.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper svg.email {\n      width: 1.375rem;\n      height: 1rem;\n}\n.related-person-overlay-sharebar.mode-inline.theme-desktop .share-buttons-wrapper a:hover > svg {\n    fill: #00113d !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1499:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".related-person-overlay-sharebar[data-v-5311e48e]{bottom:0;position:fixed;-webkit-transition:bottom .4s ease,-webkit-transform .4s ease .02s;transition:bottom .4s ease,-webkit-transform .4s ease .02s;-o-transition:bottom .4s ease,transform .4s ease .02s;transition:bottom .4s ease,transform .4s ease .02s;transition:bottom .4s ease,transform .4s ease .02s,-webkit-transform .4s ease .02s}.related-person-overlay-sharebar.theme-desktop[data-v-5311e48e]{top:0;right:0;margin-right:35.3125rem;margin-top:11.375rem}.related-person-overlay-sharebar.active[data-v-5311e48e]{bottom:0}.related-person-overlay-sharebar.hide[data-v-5311e48e]{bottom:-3.125rem}", "", {"version":3,"sources":["/app/components/node/person/ShareBar.vue"],"names":[],"mappings":"AAgCA,kDACE,SAAU,AACV,eAAgB,AAChB,mEAAqE,AACrE,2DAA6D,AAC7D,sDAAwD,AACxD,mDAAqD,AACrD,kFAAsF,CACvF,AACD,gEACI,MAAO,AACP,QAAS,AAET,wBAAyB,AACzB,oBAAsB,CACzB,AACD,yDACI,QAAU,CACb,AACD,uDACI,gBAAkB,CACrB","file":"ShareBar.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.related-person-overlay-sharebar[data-v-5311e48e] {\n  bottom: 0;\n  position: fixed;\n  -webkit-transition: bottom .4s ease, -webkit-transform .4s ease .02s;\n  transition: bottom .4s ease, -webkit-transform .4s ease .02s;\n  -o-transition: bottom .4s ease, transform .4s ease .02s;\n  transition: bottom .4s ease, transform .4s ease .02s;\n  transition: bottom .4s ease, transform .4s ease .02s, -webkit-transform .4s ease .02s;\n}\n.related-person-overlay-sharebar.theme-desktop[data-v-5311e48e] {\n    top: 0;\n    right: 0;\n    /* width: 640px; */\n    margin-right: 35.3125rem;\n    margin-top: 11.375rem;\n}\n.related-person-overlay-sharebar.active[data-v-5311e48e] {\n    bottom: 0;\n}\n.related-person-overlay-sharebar.hide[data-v-5311e48e] {\n    bottom: -3.125rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".property-title[data-v-54b37392]{font-family:Barlow,sans-serif;margin-bottom:1rem}@media (min-width:1024px){.property-title[data-v-54b37392]{line-height:1.875rem}}.attribute-label[data-v-54b37392]{font-weight:700;font-family:Barlow,sans-serif;color:#5a9cb5;text-transform:uppercase;margin-bottom:.25rem}@media (min-width:1024px){.attribute-label[data-v-54b37392]{font-size:1.125rem;line-height:1.3125rem}}@media (min-width:0) and (max-width:1023px){.attribute-label[data-v-54b37392]{font-size:1rem;line-height:1.1875rem}}.attribute-value[data-v-54b37392]{margin-bottom:1.25rem}@media (min-width:1024px){.attribute-value[data-v-54b37392]{font-size:1.125rem;line-height:1.5rem}}@media (min-width:0) and (max-width:1023px){.attribute-value[data-v-54b37392]{font-size:1.125rem;line-height:1.3125rem}}.attribute-value a[data-v-54b37392]{color:#fff;text-decoration:none;border-bottom:.0625rem solid #f8008e}", "", {"version":3,"sources":["/app/components/node/person/PropertyPane.vue"],"names":[],"mappings":"AAgCA,iCACE,8BAAkC,AAElC,kBAAoB,CACrB,AACD,0BACA,iCACM,oBAAsB,CAC3B,CACA,AACD,kCACE,gBAAkB,AAClB,8BAAkC,AAClC,cAAe,AACf,yBAA0B,AAC1B,oBAAuB,CAGxB,AACD,0BACA,kCACM,mBAAoB,AACpB,qBAAuB,CAC5B,CACA,AACD,4CACA,kCACM,eAAgB,AAChB,qBAAuB,CAC5B,CACA,AACD,kCACE,qBAAuB,CAGxB,AACD,0BACA,kCACM,mBAAoB,AACpB,kBAAoB,CACzB,CACA,AACD,4CACA,kCACM,mBAAoB,AACpB,qBAAuB,CAC5B,CACA,AACD,oCACI,WAAe,AACf,qBAAsB,AACtB,oCAAuC,CAC1C","file":"PropertyPane.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.property-title[data-v-54b37392] {\n  font-family: \"Barlow\", sans-serif;\n  /* Mobile breakpoints */\n  margin-bottom: 1rem;\n}\n@media (min-width: 1024px) {\n.property-title[data-v-54b37392] {\n      line-height: 1.875rem;\n}\n}\n.attribute-label[data-v-54b37392] {\n  font-weight: bold;\n  font-family: \"Barlow\", sans-serif;\n  color: #5A9CB5;\n  text-transform: uppercase;\n  margin-bottom: 0.25rem;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.attribute-label[data-v-54b37392] {\n      font-size: 1.125rem;\n      line-height: 1.3125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.attribute-label[data-v-54b37392] {\n      font-size: 1rem;\n      line-height: 1.1875rem;\n}\n}\n.attribute-value[data-v-54b37392] {\n  margin-bottom: 1.25rem;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.attribute-value[data-v-54b37392] {\n      font-size: 1.125rem;\n      line-height: 1.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.attribute-value[data-v-54b37392] {\n      font-size: 1.125rem;\n      line-height: 1.3125rem;\n}\n}\n.attribute-value a[data-v-54b37392] {\n    color: #FFFFFF;\n    text-decoration: none;\n    border-bottom: 0.0625rem solid #F8008E;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".popup-wrapper[data-v-57e8c72e]{position:relative}.popup-wrapper .close-icon-box[data-v-57e8c72e]{z-index:2;position:absolute;right:0;top:-1.875rem;width:1.875rem;height:1.875rem;background:#999}.popup-wrapper .close-icon-box .icon[data-v-57e8c72e]{width:.9375rem;height:.9375rem}", "", {"version":3,"sources":["/app/components/common/PopUpWrapper.vue"],"names":[],"mappings":"AAgCA,gCACE,iBAAmB,CACpB,AACD,gDACI,UAAW,AACX,kBAAmB,AACnB,QAAS,AACT,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,eAAoB,CACvB,AACD,sDACM,eAAiB,AACjB,eAAkB,CACvB","file":"PopUpWrapper.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.popup-wrapper[data-v-57e8c72e] {\n  position: relative;\n}\n.popup-wrapper .close-icon-box[data-v-57e8c72e] {\n    z-index: 2;\n    position: absolute;\n    right: 0;\n    top: -1.875rem;\n    width: 1.875rem;\n    height: 1.875rem;\n    background: #999999;\n}\n.popup-wrapper .close-icon-box .icon[data-v-57e8c72e] {\n      width: 0.9375rem;\n      height: 0.9375rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".placeholder[data-v-64caa5e2]{width:100%;height:auto}", "", {"version":3,"sources":["/app/components/article/ArticleGallery.vue"],"names":[],"mappings":"AAgCA,8BACE,WAAY,AACZ,WAAa,CACd","file":"ArticleGallery.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.placeholder[data-v-64caa5e2] {\n  width: 100%;\n  height: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".clear{clear:both}.gallery-wrapper{width:100%}.gallery-wrapper .gallery-container{margin:0 0 2.5rem}@media (min-width:1024px){.gallery-wrapper .gallery-container:not(.mobile){height:32.6875rem}}@media (min-width:1024px){.gallery-wrapper .gallery-container:not(.mobile) .gallery-icon svg{bottom:1.4375rem;left:1.25rem;width:3.75rem;height:3.75rem;padding:.9375rem}}@media (min-width:1024px){.gallery-wrapper .gallery-container:not(.mobile) .wrapper-one{float:left;height:100%;width:75%;border-right:.4375rem solid transparent}.gallery-wrapper .gallery-container:not(.mobile) .wrapper-one .thumbnail{height:100%;width:100%}}@media (min-width:1024px){.gallery-wrapper .gallery-container:not(.mobile) .wrapper-two{float:left;height:100%;width:25%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.gallery-wrapper .gallery-container:not(.mobile) .wrapper-two .thumbnail{width:100%;height:33.33333%;border-bottom:.4375rem solid transparent}.gallery-wrapper .gallery-container:not(.mobile) .wrapper-two .thumbnail:nth-child(3){border-bottom:none}}@media (min-width:1024px){.gallery-wrapper .gallery-container:not(.mobile).length-1 .wrapper-one{width:100%}.gallery-wrapper .gallery-container:not(.mobile).length-1 .wrapper-one .thumbnail img{height:auto;width:100%}.gallery-wrapper .gallery-container:not(.mobile).length-1 .wrapper-two{width:0}}.gallery-wrapper .gallery-container.mobile .gallery-icon svg{bottom:4.19%;left:3.98%;width:7%;height:7%;padding:1.75%}.gallery-wrapper .gallery-container.mobile .wrapper-one{margin-bottom:.1875rem;-webkit-box-sizing:content-box;box-sizing:content-box}.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail,.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail .photos{width:100%;height:auto}.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail .photos img{width:100%}.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail .gallery-icon{-webkit-box-sizing:border-box;box-sizing:border-box}.gallery-wrapper .gallery-container.mobile .wrapper-two{-webkit-box-sizing:content-box;box-sizing:content-box}.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail{width:calc(100% / 3 - 2px);height:calc(100% / 3 - 2px)}.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail .photos{width:100%;height:100%}.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail .photos img{width:100%}.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail:first-child,.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail:nth-child(2){border-right:3px solid transparent}.gallery-wrapper .gallery-container{width:100%;position:relative}.gallery-wrapper .gallery-container .gallery{cursor:pointer}.gallery-wrapper .gallery-container .gallery-icon svg{fill:#fff;background:#f90e95;position:absolute}@media (min-width:0) and (max-width:1023px){.gallery-wrapper .gallery-container .gallery-icon svg{bottom:4.19%;left:3.98%;width:7%;height:7%;padding:1.75%}}@media (min-width:0) and (max-width:1023px){.gallery-wrapper .gallery-container .wrapper-one{margin-bottom:.1875rem;-webkit-box-sizing:content-box;box-sizing:content-box}.gallery-wrapper .gallery-container .wrapper-one .thumbnail,.gallery-wrapper .gallery-container .wrapper-one .thumbnail .photos{width:100vw;height:100vw}.gallery-wrapper .gallery-container .wrapper-one .thumbnail .photos img{width:100%}.gallery-wrapper .gallery-container .wrapper-one .thumbnail .gallery-icon{-webkit-box-sizing:border-box;box-sizing:border-box}}@media (min-width:0) and (max-width:1023px){.gallery-wrapper .gallery-container .wrapper-two{-webkit-box-sizing:content-box;box-sizing:content-box;width:100vw}.gallery-wrapper .gallery-container .wrapper-two .thumbnail{width:calc(100vw / 3 - 2px);height:calc(100vw / 3 - 2px);float:left}.gallery-wrapper .gallery-container .wrapper-two .thumbnail .photos{width:calc(100vw / 3 - 2px);height:calc(100vw / 3 - 2px)}.gallery-wrapper .gallery-container .wrapper-two .thumbnail .photos img{width:100%}.gallery-wrapper .gallery-container .wrapper-two .thumbnail:first-child,.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(2){border-right:3px solid #fff}}.gallery-wrapper .gallery-container .wrapper-two .thumbnail .gallery-icon.number-two svg{display:none}.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(3) .overlay{opacity:1}@media (min-width:1024px){.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(3) .overlay span{font-size:3.6875rem}}.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(n+4){display:none}.gallery-wrapper .gallery-container.length-1 .wrapper-one{border-right:none}.gallery-wrapper .gallery-container .thumbnail{display:inline-block;position:relative;margin:auto;overflow:hidden}.gallery-wrapper .gallery-container .thumbnail.first{display:block}.gallery-wrapper .gallery-container .thumbnail:focus .photos,.gallery-wrapper .gallery-container .thumbnail:hover .photos{-webkit-filter:brightness(70%)}.gallery-wrapper .gallery-container .thumbnail .photos{height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.gallery-wrapper .gallery-container .thumbnail .photos div{height:100%;width:100%;background-position:50%;background-repeat:no-repeat;background-size:cover}.gallery-wrapper .gallery-container .thumbnail:last-child:after{clear:both}.gallery-wrapper .gallery-container .thumbnail .overlay{opacity:0;color:#fff;width:100%;height:100%;background:rgba(0,0,0,.5);position:absolute;top:0;left:0}.gallery-wrapper .gallery-container .thumbnail .overlay span{font-size:8.5vw;position:relative;float:left;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", "", {"version":3,"sources":["/app/components/gallery/Gallery.vue"],"names":[],"mappings":"AAgCA,OACE,UAAY,CACb,AACD,iBACE,UAAY,CACb,AACD,oCACI,iBAAqB,CACxB,AAID,0BACA,iDACQ,iBAAmB,CAC1B,CACA,AAID,0BACA,mEACU,iBAAkB,AAClB,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,gBAAmB,CAC5B,CACA,AAID,0BACA,8DACU,WAAY,AACZ,YAAa,AACb,UAAW,AACX,uCAA0C,CACnD,AACD,yEACY,YAAa,AACb,UAAY,CACvB,CACA,AAID,0BACA,8DACU,WAAY,AACZ,YAAa,AACb,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACxC,AACD,yEACY,WAAY,AACZ,iBAAuB,AACvB,wCAA2C,CACtD,AACD,sFACc,kBAAoB,CACjC,CACA,AAID,0BACA,uEACU,UAAY,CACrB,AACD,sFACY,YAAa,AACb,UAAY,CACvB,AACD,uEACU,OAAU,CACnB,CACA,AACD,6DACI,aAAc,AACd,WAAY,AACZ,SAAU,AACV,UAAW,AACX,aAAe,CAClB,AACD,wDACI,uBAAyB,AACzB,+BAAgC,AACxB,sBAAwB,CACnC,AAKD,8IACQ,WAAY,AACZ,WAAa,CACpB,AACD,+EACU,UAAY,CACrB,AACD,iFACQ,8BAA+B,AACvB,qBAAuB,CACtC,AACD,wDACI,+BAAgC,AACxB,sBAAwB,CACnC,AACD,mEACM,2BAA4B,AAC5B,2BAA6B,CAClC,AACD,2EACQ,WAAY,AACZ,WAAa,CACpB,AACD,+EACU,UAAY,CACrB,AAID,+JACQ,kCAAoC,CAC3C,AACD,oCACI,WAAY,AACZ,iBAAmB,CACtB,AACD,6CACM,cAAgB,CACrB,AACD,sDACM,UAAc,AACd,mBAAoB,AACpB,iBAAmB,CAExB,AACD,4CACA,sDACU,aAAc,AACd,WAAY,AACZ,SAAU,AACV,UAAW,AACX,aAAe,CACxB,CACA,AAID,4CACA,iDACU,uBAAyB,AACzB,+BAAgC,AACxB,sBAAwB,CACzC,AAKD,gIACc,YAAa,AACb,YAAc,CAC3B,AACD,wEACgB,UAAY,CAC3B,AACD,0EACc,8BAA+B,AACvB,qBAAuB,CAC5C,CACA,AAID,4CACA,iDACU,+BAAgC,AACxB,uBAAwB,AAChC,WAAa,CACtB,AACD,4DACY,4BAA6B,AAC7B,6BAA8B,AAC9B,UAAY,CACvB,AACD,oEACc,4BAA6B,AAC7B,4BAA8B,CAC3C,AACD,wEACgB,UAAY,CAC3B,AAID,iJACc,2BAAgC,CAC7C,CACA,AACD,yFACQ,YAAc,CACrB,AACD,kFACQ,SAAW,CAClB,AAID,0BACA,uFACc,mBAAqB,CAClC,CACA,AACD,2EACQ,YAAc,CACrB,AACD,0DACM,iBAAmB,CACxB,AACD,+CACM,qBAAsB,AACtB,kBAAmB,AACnB,YAAa,AACb,eAAiB,CACtB,AACD,qDACQ,aAAe,CACtB,AACD,0HACQ,8BAAgC,CACvC,AACD,uDACQ,YAAa,AACb,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACnC,AACD,2DACU,YAAa,AACb,WAAY,AACZ,wBAA4B,AAC5B,4BAA6B,AAC7B,qBAAuB,CAChC,AACD,gEACQ,UAAY,CACnB,AACD,wDACQ,UAAW,AACX,WAAe,AACf,WAAY,AACZ,YAAa,AACb,0BAA+B,AAC/B,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACf,AACD,6DACU,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,SAAU,AACV,uCAAyC,AACrC,mCAAqC,AACjC,8BAAiC,CAClD","file":"Gallery.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.clear {\n  clear: both;\n}\n.gallery-wrapper {\n  width: 100%;\n}\n.gallery-wrapper .gallery-container {\n    margin: 0 0 2.5rem 0;\n}\n.gallery-wrapper .gallery-container:not(.mobile) {\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.gallery-wrapper .gallery-container:not(.mobile) {\n        height: 32.6875rem;\n}\n}\n.gallery-wrapper .gallery-container:not(.mobile) .gallery-icon svg {\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.gallery-wrapper .gallery-container:not(.mobile) .gallery-icon svg {\n          bottom: 1.4375rem;\n          left: 1.25rem;\n          width: 3.75rem;\n          height: 3.75rem;\n          padding: 0.9375rem;\n}\n}\n.gallery-wrapper .gallery-container:not(.mobile) .wrapper-one {\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.gallery-wrapper .gallery-container:not(.mobile) .wrapper-one {\n          float: left;\n          height: 100%;\n          width: 75%;\n          border-right: 0.4375rem solid transparent;\n}\n.gallery-wrapper .gallery-container:not(.mobile) .wrapper-one .thumbnail {\n            height: 100%;\n            width: 100%;\n}\n}\n.gallery-wrapper .gallery-container:not(.mobile) .wrapper-two {\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.gallery-wrapper .gallery-container:not(.mobile) .wrapper-two {\n          float: left;\n          height: 100%;\n          width: 25%;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n}\n.gallery-wrapper .gallery-container:not(.mobile) .wrapper-two .thumbnail {\n            width: 100%;\n            height: calc(100% / 3);\n            border-bottom: 0.4375rem solid transparent;\n}\n.gallery-wrapper .gallery-container:not(.mobile) .wrapper-two .thumbnail:nth-child(3) {\n              border-bottom: none;\n}\n}\n.gallery-wrapper .gallery-container:not(.mobile).length-1 {\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.gallery-wrapper .gallery-container:not(.mobile).length-1 .wrapper-one {\n          width: 100%;\n}\n.gallery-wrapper .gallery-container:not(.mobile).length-1 .wrapper-one .thumbnail img {\n            height: auto;\n            width: 100%;\n}\n.gallery-wrapper .gallery-container:not(.mobile).length-1 .wrapper-two {\n          width: 0%;\n}\n}\n.gallery-wrapper .gallery-container.mobile .gallery-icon svg {\n    bottom: 4.19%;\n    left: 3.98%;\n    width: 7%;\n    height: 7%;\n    padding: 1.75%;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-one {\n    margin-bottom: 0.1875rem;\n    -webkit-box-sizing: content-box;\n            box-sizing: content-box;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail {\n      width: 100%;\n      height: auto;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail .photos {\n        width: 100%;\n        height: auto;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail .photos img {\n          width: 100%;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-one .thumbnail .gallery-icon {\n        -webkit-box-sizing: border-box;\n                box-sizing: border-box;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-two {\n    -webkit-box-sizing: content-box;\n            box-sizing: content-box;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail {\n      width: calc(100% / 3 - 2px);\n      height: calc(100% / 3 - 2px);\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail .photos {\n        width: 100%;\n        height: 100%;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail .photos img {\n          width: 100%;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail:first-child {\n        border-right: 3px solid transparent;\n}\n.gallery-wrapper .gallery-container.mobile .wrapper-two .thumbnail:nth-child(2) {\n        border-right: 3px solid transparent;\n}\n.gallery-wrapper .gallery-container {\n    width: 100%;\n    position: relative;\n}\n.gallery-wrapper .gallery-container .gallery {\n      cursor: pointer;\n}\n.gallery-wrapper .gallery-container .gallery-icon svg {\n      fill: #FFFFFF;\n      background: #F90E95;\n      position: absolute;\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.gallery-wrapper .gallery-container .gallery-icon svg {\n          bottom: 4.19%;\n          left: 3.98%;\n          width: 7%;\n          height: 7%;\n          padding: 1.75%;\n}\n}\n.gallery-wrapper .gallery-container .wrapper-one {\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.gallery-wrapper .gallery-container .wrapper-one {\n          margin-bottom: 0.1875rem;\n          -webkit-box-sizing: content-box;\n                  box-sizing: content-box;\n}\n.gallery-wrapper .gallery-container .wrapper-one .thumbnail {\n            width: 100vw;\n            height: 100vw;\n}\n.gallery-wrapper .gallery-container .wrapper-one .thumbnail .photos {\n              width: 100vw;\n              height: 100vw;\n}\n.gallery-wrapper .gallery-container .wrapper-one .thumbnail .photos img {\n                width: 100%;\n}\n.gallery-wrapper .gallery-container .wrapper-one .thumbnail .gallery-icon {\n              -webkit-box-sizing: border-box;\n                      box-sizing: border-box;\n}\n}\n.gallery-wrapper .gallery-container .wrapper-two {\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.gallery-wrapper .gallery-container .wrapper-two {\n          -webkit-box-sizing: content-box;\n                  box-sizing: content-box;\n          width: 100vw;\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail {\n            width: calc(100vw / 3 - 2px);\n            height: calc(100vw / 3 - 2px);\n            float: left;\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail .photos {\n              width: calc(100vw / 3 - 2px);\n              height: calc(100vw / 3 - 2px);\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail .photos img {\n                width: 100%;\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail:first-child {\n              border-right: 3px solid #FFFFFF;\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(2) {\n              border-right: 3px solid #FFFFFF;\n}\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail .gallery-icon.number-two svg {\n        display: none;\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(3) .overlay {\n        opacity: 1;\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(3) .overlay span {\n          /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(3) .overlay span {\n              font-size: 3.6875rem;\n}\n}\n.gallery-wrapper .gallery-container .wrapper-two .thumbnail:nth-child(n+4) {\n        display: none;\n}\n.gallery-wrapper .gallery-container.length-1 .wrapper-one {\n      border-right: none;\n}\n.gallery-wrapper .gallery-container .thumbnail {\n      display: inline-block;\n      position: relative;\n      margin: auto;\n      overflow: hidden;\n}\n.gallery-wrapper .gallery-container .thumbnail.first {\n        display: block;\n}\n.gallery-wrapper .gallery-container .thumbnail:hover .photos, .gallery-wrapper .gallery-container .thumbnail:focus .photos {\n        -webkit-filter: brightness(70%);\n}\n.gallery-wrapper .gallery-container .thumbnail .photos {\n        height: 100%;\n        width: 100%;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.gallery-wrapper .gallery-container .thumbnail .photos div {\n          height: 100%;\n          width: 100%;\n          background-position: center;\n          background-repeat: no-repeat;\n          background-size: cover;\n}\n.gallery-wrapper .gallery-container .thumbnail:last-child:after {\n        clear: both;\n}\n.gallery-wrapper .gallery-container .thumbnail .overlay {\n        opacity: 0;\n        color: #FFFFFF;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.5);\n        position: absolute;\n        top: 0;\n        left: 0;\n}\n.gallery-wrapper .gallery-container .thumbnail .overlay span {\n          font-size: 8.5vw;\n          position: relative;\n          float: left;\n          top: 50%;\n          left: 50%;\n          -webkit-transform: translate(-50%, -50%);\n              -ms-transform: translate(-50%, -50%);\n                  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".overlay-header[data-v-7a27b132]{padding:0 .625rem;background-color:#012b5b;-webkit-transition:all .2s ease,-webkit-transform .4s ease .02s;transition:all .2s ease,-webkit-transform .4s ease .02s;-o-transition:all .2s ease,transform .4s ease .02s;transition:all .2s ease,transform .4s ease .02s;transition:all .2s ease,transform .4s ease .02s,-webkit-transform .4s ease .02s;position:fixed;z-index:1200;width:100%;top:0}@media (min-width:1024px){.overlay-header[data-v-7a27b132]{max-width:40rem}}.overlay-header.right[data-v-7a27b132]{right:0}.overlay-header.collapse[data-v-7a27b132]{padding:.5rem .375rem;background-color:#000}.overlay-header.collapse .overlay-header-section[data-v-7a27b132]{font-size:.6875rem;line-height:.8125rem}.overlay-header.collapse .overlay-back-btn[data-v-7a27b132]{width:.75rem;height:.6875rem}.overlay-header .overlay-header-wrapper[data-v-7a27b132]{padding:.4375rem .375rem;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:.0625rem solid hsla(0,0%,100%,.4)}.overlay-header .overlay-header-title[data-v-7a27b132]{color:#fff;font-family:Bungee,sans-serif;font-size:1.125rem;line-height:1.125rem}.overlay-header .overlay-header-meta[data-v-7a27b132]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.overlay-header .overlay-back-wrapper[data-v-7a27b132],.overlay-header .overlay-header-meta[data-v-7a27b132],.overlay-header .overlay-header-section[data-v-7a27b132],.overlay-header .overlay-header-title[data-v-7a27b132]{display:-webkit-box;display:-ms-flexbox;display:flex}.overlay-header .overlay-header-section[data-v-7a27b132]{font-size:.875rem;line-height:1rem;font-weight:700;color:#fff;text-transform:uppercase;margin-bottom:.125rem}.overlay-header.theme-desktop[data-v-7a27b132]{-webkit-transition:all .4s ease .02s;-o-transition:all .4s ease .02s;transition:all .4s ease .02s;padding:0 1.875rem 0 1.625rem}.overlay-header.theme-desktop .overlay-header-wrapper[data-v-7a27b132]{padding:.75rem 0 .875rem}.overlay-header.theme-desktop .overlay-header-section[data-v-7a27b132]{font-size:1.25rem;line-height:1.5rem;margin-bottom:0;font-weight:700}.overlay-header.theme-desktop .overlay-header-title[data-v-7a27b132]{font-size:1.5rem;line-height:1.5rem}", "", {"version":3,"sources":["/app/components/node/person/Header.vue"],"names":[],"mappings":"AAgCA,iCAEE,kBAAoB,AACpB,yBAA0B,AAC1B,gEAAkE,AAClE,wDAA0D,AAC1D,mDAAqD,AACrD,gDAAkD,AAClD,gFAAmF,AACnF,eAAgB,AAChB,aAAc,AACd,WAAY,AACZ,KAAO,CACR,AACD,0BACA,iCACM,eAAiB,CACtB,CACA,AACD,uCACI,OAAS,CACZ,AACD,0CACI,sBAAyB,AACzB,qBAA0B,CAC7B,AACD,kEACM,mBAAqB,AACrB,oBAAuB,CAC5B,AACD,4DACM,aAAe,AACf,eAAkB,CACvB,AACD,yDACI,yBAA4B,AAC5B,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,+CAAwD,CAC3D,AACD,uDACI,WAAe,AACf,8BAAgC,AAChC,mBAAoB,AACpB,oBAAsB,CACzB,AACD,sDACI,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CACjC,AACD,6NAII,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,yDACI,kBAAoB,AACpB,iBAAkB,AAClB,gBAAkB,AAClB,WAAe,AACf,yBAA0B,AAC1B,qBAAwB,CAC3B,AACD,+CACI,qCAAsC,AACtC,gCAAiC,AACjC,6BAA8B,AAC9B,6BAA+B,CAClC,AACD,uEACM,wBAA4B,CACjC,AACD,uEACM,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,eAAkB,CACvB,AACD,qEACM,iBAAkB,AAClB,kBAAoB,CACzB","file":"Header.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.overlay-header[data-v-7a27b132] {\n  /* Mobile breakpoints */\n  padding: 0 0.625rem;\n  background-color: #012b5b;\n  -webkit-transition: all .2s ease, -webkit-transform .4s ease .02s;\n  transition: all .2s ease, -webkit-transform .4s ease .02s;\n  -o-transition: all .2s ease, transform .4s ease .02s;\n  transition: all .2s ease, transform .4s ease .02s;\n  transition: all .2s ease, transform .4s ease .02s, -webkit-transform .4s ease .02s;\n  position: fixed;\n  z-index: 1200;\n  width: 100%;\n  top: 0;\n}\n@media (min-width: 1024px) {\n.overlay-header[data-v-7a27b132] {\n      max-width: 40rem;\n}\n}\n.overlay-header.right[data-v-7a27b132] {\n    right: 0;\n}\n.overlay-header.collapse[data-v-7a27b132] {\n    padding: 0.5rem 0.375rem;\n    background-color: #000000;\n}\n.overlay-header.collapse .overlay-header-section[data-v-7a27b132] {\n      font-size: 0.6875rem;\n      line-height: 0.8125rem;\n}\n.overlay-header.collapse .overlay-back-btn[data-v-7a27b132] {\n      width: 0.75rem;\n      height: 0.6875rem;\n}\n.overlay-header .overlay-header-wrapper[data-v-7a27b132] {\n    padding: 0.4375rem 0.375rem;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.4);\n}\n.overlay-header .overlay-header-title[data-v-7a27b132] {\n    color: #FFFFFF;\n    font-family: Bungee, sans-serif;\n    font-size: 1.125rem;\n    line-height: 1.125rem;\n}\n.overlay-header .overlay-header-meta[data-v-7a27b132] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n}\n.overlay-header .overlay-back-wrapper[data-v-7a27b132],\n  .overlay-header .overlay-header-meta[data-v-7a27b132],\n  .overlay-header .overlay-header-title[data-v-7a27b132],\n  .overlay-header .overlay-header-section[data-v-7a27b132] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.overlay-header .overlay-header-section[data-v-7a27b132] {\n    font-size: 0.875rem;\n    line-height: 1rem;\n    font-weight: bold;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    margin-bottom: 0.125rem;\n}\n.overlay-header.theme-desktop[data-v-7a27b132] {\n    -webkit-transition: all .4s ease .02s;\n    -o-transition: all .4s ease .02s;\n    transition: all .4s ease .02s;\n    padding: 0 1.875rem 0 1.625rem;\n}\n.overlay-header.theme-desktop .overlay-header-wrapper[data-v-7a27b132] {\n      padding: 0.75rem 0 0.875rem;\n}\n.overlay-header.theme-desktop .overlay-header-section[data-v-7a27b132] {\n      font-size: 1.25rem;\n      line-height: 1.5rem;\n      margin-bottom: 0;\n      font-weight: bold;\n}\n.overlay-header.theme-desktop .overlay-header-title[data-v-7a27b132] {\n      font-size: 1.5rem;\n      line-height: 1.5rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1525:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, "@media (min-width:0) and (max-width:1023px){.article-carousel .no-article-gutter-mobile{margin-left:-1.25rem;margin-right:-1.25rem}}@media (min-width:1024px){.article-carousel .no-article-gutter-desktop{margin-left:-1.25rem;margin-right:-1.25rem}}.article-carousel.has-slider .slider-pagination{top:0;position:fixed;z-index:1030;height:.1875rem;font-size:0;padding-top:.375rem}.article-carousel.has-slider .slider-pagination>div{margin:0;-webkit-box-shadow:none;box-shadow:none;background:#fff;opacity:.5;font-size:0}@media (min-width:1024px){.article-carousel.has-slider .slider-pagination>div{width:.3125rem;height:.3125rem}}@media (min-width:0) and (max-width:1023px){.article-carousel.has-slider .slider-pagination>div{width:.1875rem;height:.1875rem}}.article-carousel.has-slider .slider-pagination>div.is-active{opacity:1}@media (min-width:1024px){.article-carousel.has-slider .slider-pagination>div~div{margin-left:.5625rem}}@media (min-width:0) and (max-width:1023px){.article-carousel.has-slider .slider-pagination>div~div{margin-left:.375rem}}@media (min-width:0) and (max-width:1023px){.article-carousel .card-video-container .card-video .video-player{position:relative;width:100%;display:block;padding:70px 27px 0}}.article-carousel .article-body-card-wrapper{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.article-carousel .article-body-card-wrapper.with-card-video{background-color:#000}.article-carousel .article-body-card-wrapper.with-card-video .node-type-article .article-header-wrapper .article-header{padding-top:1.5rem}", "", {"version":3,"sources":["/app/components/article/ArticleView.vue"],"names":[],"mappings":"AAsCA,4CACA,4CACQ,qBAAsB,AACtB,qBAAuB,CAC9B,CACA,AAID,0BACA,6CACQ,qBAAsB,AACtB,qBAAuB,CAC9B,CACA,AACD,gDACI,MAAO,AACP,eAAgB,AAChB,aAAc,AACd,gBAAkB,AAClB,YAAa,AACb,mBAAsB,CACzB,AACD,oDAGM,SAAU,AACV,wBAAyB,AACjB,gBAAiB,AACzB,gBAAoB,AACpB,WAAa,AACb,WAAa,CAClB,AACD,0BACA,oDACU,eAAiB,AACjB,eAAkB,CAC3B,CACA,AACD,4CACA,oDACU,eAAiB,AACjB,eAAkB,CAC3B,CACA,AACD,8DACQ,SAAW,CAClB,AAKD,0BACA,wDACY,oBAAuB,CAClC,CACA,AACD,4CACA,wDACY,mBAAsB,CACjC,CACA,AACD,4CACA,kEACM,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,mBAA4B,CACjC,CACA,AACD,6CACI,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC7B,AACD,6DACM,qBAA0B,CAC/B,AACD,wHACQ,kBAAoB,CAC3B","file":"ArticleView.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-carousel {\n  /* Mobile breakpoints */\n}\n.article-carousel .no-article-gutter-mobile {\n    /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-carousel .no-article-gutter-mobile {\n        margin-left: -1.25rem;\n        margin-right: -1.25rem;\n}\n}\n.article-carousel .no-article-gutter-desktop {\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-carousel .no-article-gutter-desktop {\n        margin-left: -1.25rem;\n        margin-right: -1.25rem;\n}\n}\n.article-carousel.has-slider .slider-pagination {\n    top: 0;\n    position: fixed;\n    z-index: 1030;\n    height: 0.1875rem;\n    font-size: 0;\n    padding-top: 0.375rem;\n}\n.article-carousel.has-slider .slider-pagination > div {\n      /* Mobile breakpoints */\n      /* Mobile breakpoints */\n      margin: 0;\n      -webkit-box-shadow: none;\n              box-shadow: none;\n      background: #FFFFFF;\n      opacity: 0.5;\n      font-size: 0;\n}\n@media (min-width: 1024px) {\n.article-carousel.has-slider .slider-pagination > div {\n          width: 0.3125rem;\n          height: 0.3125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-carousel.has-slider .slider-pagination > div {\n          width: 0.1875rem;\n          height: 0.1875rem;\n}\n}\n.article-carousel.has-slider .slider-pagination > div.is-active {\n        opacity: 1;\n}\n.article-carousel.has-slider .slider-pagination > div ~ div {\n        /* Mobile breakpoints */\n        /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-carousel.has-slider .slider-pagination > div ~ div {\n            margin-left: 0.5625rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-carousel.has-slider .slider-pagination > div ~ div {\n            margin-left: 0.375rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-carousel .card-video-container .card-video .video-player {\n      position: relative;\n      width: 100%;\n      display: block;\n      padding: 70px 27px 0px 27px;\n}\n}\n.article-carousel .article-body-card-wrapper {\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n}\n.article-carousel .article-body-card-wrapper.with-card-video {\n      background-color: #000000;\n}\n.article-carousel .article-body-card-wrapper.with-card-video .node-type-article .article-header-wrapper .article-header {\n        padding-top: 1.5rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1526:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".articleView__shareButtons[data-v-9db8fe76]{position:fixed;top:var(--window-height,100vh);z-index:100;left:0;-webkit-transition:-webkit-transform 0ms;transition:-webkit-transform 0ms;-o-transition:transform 0ms;transition:transform 0ms;transition:transform 0ms,-webkit-transform 0ms}.articleView__shareButtons.active[data-v-9db8fe76]{-webkit-transform:translateY(-50px);-ms-transform:translateY(-50px);transform:translateY(-50px)}.articleView__shareButtons.active[data-v-9db8fe76],.articleView__shareButtons.hide[data-v-9db8fe76]{-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;-o-transition:transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s}.articleView__shareButtons.hide[data-v-9db8fe76],.articleView__shareButtons:not(.share-button-native-container).inCard[data-v-9db8fe76]{-webkit-transform:translateY(50px);-ms-transform:translateY(50px);transform:translateY(50px)}.articleView__shareButtons.share-button-native-container[data-v-9db8fe76]{right:1rem;bottom:1.25rem;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);left:inherit;top:inherit}.articleView__shareButtons.share-button-native-container.hide[data-v-9db8fe76]{-webkit-transform:translateY(85px)!important;-ms-transform:translateY(85px)!important;transform:translateY(85px)!important}.articleView__shareButtons.share-button-native-container.reset[data-v-9db8fe76]{-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;-o-transition:transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s}.articleView__shareButtons.share-button-native-container.inCard[data-v-9db8fe76]{-webkit-transition:-webkit-transform 0ms;transition:-webkit-transform 0ms;-o-transition:transform 0ms;transition:transform 0ms;transition:transform 0ms,-webkit-transform 0ms;-webkit-transform:translateY(85px)!important;-ms-transform:translateY(85px)!important;transform:translateY(85px)!important}.articleView__shareButtons.share-button-native-container.inCard.active[data-v-9db8fe76]{-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;-o-transition:transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s}.articleView__shareButtons.no-animation[data-v-9db8fe76]{-webkit-transition:-webkit-transform 0ms!important;transition:-webkit-transform 0ms!important;-o-transition:transform 0ms!important;transition:transform 0ms!important;transition:transform 0ms,-webkit-transform 0ms!important}.next-article-indication[data-v-9db8fe76]{background-color:#fff;position:relative}.next-article-indication .coming-next[data-v-9db8fe76]{text-align:center;color:#f8008e;font-family:Silkscreen,sans-serif;font-size:1.5rem;font-weight:700;line-height:1.5625rem}.next-article-indication .bottom-card-invader[data-v-9db8fe76]{padding-top:.5rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.next-article-indication .bottom-card-invader svg[data-v-9db8fe76]{fill:#f8008e}.article-bottom-card-wrapper[data-v-9db8fe76]{position:relative}@media (min-width:1024px){.article-bottom-card-wrapper[data-v-9db8fe76]{height:100vh;height:var(--window-height,100vh);max-height:100vh}.article-bottom-card-wrapper .fullHeight[data-v-9db8fe76]{height:100vh}}@media (min-width:0) and (max-width:1023px){.article-bottom-card-wrapper[data-v-9db8fe76]{background-color:#fff}.article-bottom-card-wrapper .smooth-animate[data-v-9db8fe76]{-webkit-transition-duration:.1s;-o-transition-duration:.1s;transition-duration:.1s}}.article-view-wrapper[data-v-9db8fe76]{overscroll-behavior-y:contain;background-color:#fff;height:100vh;height:var(--window-height,100vh);overflow-y:auto;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-overflow-scrolling:touch}.article-view-wrapper.preventScroll[data-v-9db8fe76]{overflow-y:hidden}.article-view-wrapper .arrow-down-wrapper[data-v-9db8fe76]{background-color:#fff;position:relative;text-align:center;padding:0 0 2.5rem}.article-view-wrapper .arrow-down-wrapper svg[data-v-9db8fe76]{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:arrow-down-animation-data-v-9db8fe76;animation-name:arrow-down-animation-data-v-9db8fe76;fill:#f8008e}.article-view-wrapper .arrow-down-wrapper.opinion[data-v-9db8fe76]{background-color:#e7e7e7}@media (min-width:0) and (max-width:1023px){.article-view-wrapper .arrow-down-wrapper.opinion[data-v-9db8fe76]{background-color:#fff}}.article-view-wrapper .arrow-down-wrapper.photo-essay[data-v-9db8fe76],.article-view-wrapper .arrow-down-wrapper.video[data-v-9db8fe76]{background-color:#000}@media (min-width:0) and (max-width:1023px){.article-view-wrapper .arrow-down-wrapper.photo-essay[data-v-9db8fe76],.article-view-wrapper .arrow-down-wrapper.video[data-v-9db8fe76]{background-color:#fff}}@media (min-width:0) and (max-width:1023px){.article-view-wrapper .arrow-down-wrapper[data-v-9db8fe76]{padding:0 0 1.25rem;background-color:#fff}.article-view-wrapper .arrow-down-wrapper .bottom-divider[data-v-9db8fe76]{width:100vw;border-bottom:.1875rem solid #f8008e;margin-bottom:1.25rem}}@-webkit-keyframes arrow-down-animation{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(.625rem);transform:translateY(.625rem)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes arrow-down-animation-data-v-9db8fe76{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(.625rem);transform:translateY(.625rem)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.news-title[data-v-9db8fe76]{position:absolute;font-size:12.5rem;z-index:-999}.card-cover[data-v-9db8fe76]{color:#000}.card-cover.cardInvisible[data-v-9db8fe76]{display:block}.card-cover .arrowsHover[data-v-9db8fe76]{position:absolute;top:0;width:inherit;height:inherit;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-flex:3;-ms-flex:3;flex:3}.card-cover .arrowsHover .center-area[data-v-9db8fe76]{-webkit-box-flex:1;-ms-flex:auto;flex:auto;height:100%}.card-cover .arrowsHover .left-area[data-v-9db8fe76],.card-cover .arrowsHover .right-area[data-v-9db8fe76]{width:25rem;height:100%}.card-cover .arrowsHover .card-middle[data-v-9db8fe76]{width:100vw;height:1px;position:absolute;top:50%}.card-cover.animate[data-v-9db8fe76],.card-cover.reset[data-v-9db8fe76]{-webkit-transition:margin .5s;-o-transition:margin .5s;transition:margin .5s}.card-cover.to-top[data-v-9db8fe76]{margin-top:-100vh;margin-top:calc(var(--window-height, 100vh) * -1)}.card-cover.to-top.bounce[data-v-9db8fe76]{-webkit-animation:bounce-in-data-v-9db8fe76 .5s;animation:bounce-in-data-v-9db8fe76 .5s}.node-body.bounce-bottom[data-v-9db8fe76]{-webkit-animation:bounce-bottom-data-v-9db8fe76 .5s;animation:bounce-bottom-data-v-9db8fe76 .5s}@-webkit-keyframes bounce-bottom{0%{margin-top:0}50%{margin-top:-20vh}to{margin-top:0}}@keyframes bounce-bottom-data-v-9db8fe76{0%{margin-top:0}50%{margin-top:-20vh}to{margin-top:0}}@-webkit-keyframes bounce-in{0%{margin-top:-100vh;margin-top:calc(var(--window-height, 100vh) * -1)}50%{margin-top:-70vh}to{margin-top:-100vh;margin-top:calc(var(--window-height, 100vh) * -1)}}@keyframes bounce-in-data-v-9db8fe76{0%{margin-top:-100vh;margin-top:calc(var(--window-height, 100vh) * -1)}50%{margin-top:-70vh}to{margin-top:-100vh;margin-top:calc(var(--window-height, 100vh) * -1)}}.article-body-card-wrapper .reset[data-v-9db8fe76]{-webkit-transition:.5s;-o-transition:.5s;transition:.5s}.resetBottom[data-v-9db8fe76]{-webkit-animation-name:bottom-bounce-in-data-v-9db8fe76;animation-name:bottom-bounce-in-data-v-9db8fe76;-webkit-animation-duration:.5s;animation-duration:.5s}@-webkit-keyframes bottom-bounce-in{50%{-webkit-transform:translateY(-20%);transform:translateY(-20%)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes bottom-bounce-in-data-v-9db8fe76{50%{-webkit-transform:translateY(-20%);transform:translateY(-20%)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.article-card-headerbar[data-v-9db8fe76]{height:3.125rem;width:100%;background:#002e3e;opacity:.8;z-index:1030;position:absolute;top:0;left:0}.header_text[data-v-9db8fe76]{margin-top:1.5625rem;width:100%;position:absolute;z-index:1031;top:0;left:0;text-align:center}.card-video-container[data-v-9db8fe76]{background-color:#000}.fixed-bottom .newsletter[data-v-9db8fe76]{position:relative;right:0;bottom:0;left:0}.article-arrow[data-v-9db8fe76]{fill:hsla(0,0%,80%,.5);position:fixed;top:7.5rem;cursor:pointer;z-index:1}@media (min-width:0) and (max-width:1023px){.article-arrow[data-v-9db8fe76]{display:none}}@media (min-width:1024px){.article-arrow.onCover[data-v-9db8fe76]{position:absolute!important;top:0;fill:hsla(0,0%,100%,.9)}}.arrow-prev[data-v-9db8fe76]{-webkit-transform:translateX(-150%);-ms-transform:translateX(-150%);transform:translateX(-150%);left:1%;-webkit-animation-name:arrow-prev-fadeOut-data-v-9db8fe76;animation-name:arrow-prev-fadeOut-data-v-9db8fe76;-webkit-animation-duration:.5s;animation-duration:.5s}.arrow-prev.arrowFadeIn[data-v-9db8fe76]{-webkit-animation-name:arrow-prev-fadeIn-data-v-9db8fe76;animation-name:arrow-prev-fadeIn-data-v-9db8fe76;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.arrow-next[data-v-9db8fe76]{right:1%;-webkit-transform:translateX(150%);-ms-transform:translateX(150%);transform:translateX(150%);-webkit-animation-name:arrow-next-fadeOut-data-v-9db8fe76;animation-name:arrow-next-fadeOut-data-v-9db8fe76;-webkit-animation-duration:.5s;animation-duration:.5s}.arrow-next.arrowFadeIn[data-v-9db8fe76]{-webkit-animation-name:arrow-next-fadeIn-data-v-9db8fe76;animation-name:arrow-next-fadeIn-data-v-9db8fe76;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.related-person-overlay-header.theme-desktop.showing-desktop-header[data-v-9db8fe76],.related-person-overlay.theme-desktop.showing-desktop-header[data-v-9db8fe76]{margin-top:4.25rem}.related-person-overlay-layer[data-v-9db8fe76]{width:100vw;height:100vh;height:var(--window-height,100vh);position:fixed;top:0;left:0;z-index:1198}.related-person-overlay[data-v-9db8fe76]{position:absolute;height:100vh;height:var(--window-height,100vh);width:100vw;top:0;right:0;z-index:1199;-webkit-transition:-webkit-transform .4s ease .02s;transition:-webkit-transform .4s ease .02s;-o-transition:transform .4s ease .02s;transition:transform .4s ease .02s;transition:transform .4s ease .02s,-webkit-transform .4s ease .02s;overflow-y:scroll;-webkit-overflow-scrolling:touch}@media (min-width:0) and (max-width:1023px){.related-person-overlay[data-v-9db8fe76]{width:100vw}}@media (min-width:1024px){.related-person-overlay[data-v-9db8fe76]{width:640px}}.related-person-overlay-sharebar[data-v-9db8fe76]{z-index:1200}.hidden-right[data-v-9db8fe76]{-webkit-transform:translateX(100vw);-ms-transform:translateX(100vw);transform:translateX(100vw)}@-webkit-keyframes arrow-prev-fadeIn{0%{opacity:0;-webkit-transform:translateX(-150%);transform:translateX(-150%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes arrow-prev-fadeIn-data-v-9db8fe76{0%{opacity:0;-webkit-transform:translateX(-150%);transform:translateX(-150%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes arrow-next-fadeIn{0%{opacity:0;-webkit-transform:translateX(150%);transform:translateX(150%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes arrow-next-fadeIn-data-v-9db8fe76{0%{opacity:0;-webkit-transform:translateX(150%);transform:translateX(150%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes arrow-prev-fadeOut{0%{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}to{opacity:0;-webkit-transform:translateX(-150%);transform:translateX(-150%)}}@keyframes arrow-prev-fadeOut-data-v-9db8fe76{0%{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}to{opacity:0;-webkit-transform:translateX(-150%);transform:translateX(-150%)}}@-webkit-keyframes arrow-next-fadeOut{0%{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}to{opacity:0;-webkit-transform:translateX(150%);transform:translateX(150%)}}@keyframes arrow-next-fadeOut-data-v-9db8fe76{0%{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}to{opacity:0;-webkit-transform:translateX(150%);transform:translateX(150%)}}@-webkit-keyframes scroll-down-arrow{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(1.25rem);transform:translateY(1.25rem)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes scroll-down-arrow-data-v-9db8fe76{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(1.25rem);transform:translateY(1.25rem)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@media (min-width:1024px){.bottom-card-cover-blank-space[data-v-9db8fe76]{height:calc(100vh - 56.25vw);background-color:#fff;overflow:hidden}.bottom-card-cover-blank-space .scroll-to-continue[data-v-9db8fe76]{color:#aaa;text-align:center;font-family:Barlow,sans-serif;font-size:1.75rem;font-weight:700;padding:1.75rem 0 .75rem}.bottom-card-cover-blank-space .scroll-down-arrow[data-v-9db8fe76]{text-align:center;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:scroll-down-arrow-data-v-9db8fe76;animation-name:scroll-down-arrow-data-v-9db8fe76}.bottom-card-cover-blank-space .scroll-down-arrow svg[data-v-9db8fe76]{width:2rem;height:1.875rem;fill:#999}}@-webkit-keyframes body-fade-in{0%{opacity:0}to{opacity:1}}@keyframes body-fade-in-data-v-9db8fe76{0%{opacity:0}to{opacity:1}}.bodyFadeIn[data-v-9db8fe76]{opacity:1;-webkit-animation-name:body-fade-in-data-v-9db8fe76;animation-name:body-fade-in-data-v-9db8fe76;-webkit-animation-duration:1s;animation-duration:1s}.prevCardCover[data-v-9db8fe76]{width:100vw;overflow:hidden;transfrom:translateY(11vh)}.prevCardCover.reset[data-v-9db8fe76]{-webkit-transition:margin .5s;-o-transition:margin .5s;transition:margin .5s}", "", {"version":3,"sources":["/app/components/article/ArticleView.vue"],"names":[],"mappings":"AAgCA,4CACE,eAAgB,AAChB,+BAAiC,AACjC,YAAa,AACb,OAAQ,AACR,yCAA0C,AAC1C,iCAAkC,AAClC,4BAA6B,AAC7B,yBAA0B,AAC1B,8CAAiD,CAClD,AACD,mDAMI,oCAAqC,AACjC,gCAAiC,AAC7B,2BAA6B,CACxC,AACD,oGATI,yCAA4C,AAC5C,iCAAoC,AACpC,4BAA+B,AAC/B,yBAA4B,AAC5B,8CAAqD,CAcxD,AACD,wIACI,mCAAoC,AAChC,+BAAgC,AAC5B,0BAA4B,CACvC,AACD,0EACI,WAAY,AACZ,eAAgB,AAChB,gCAAmC,AAC/B,4BAA+B,AAC3B,wBAA2B,AACnC,aAAc,AACd,WAAa,CAChB,AACD,+EACM,6CAA+C,AAC3C,yCAA2C,AACvC,oCAAuC,CACpD,AACD,gFACM,yCAA4C,AAC5C,iCAAoC,AACpC,4BAA+B,AAC/B,yBAA4B,AAC5B,8CAAqD,CAC1D,AACD,iFACM,yCAA0C,AAC1C,iCAAkC,AAClC,4BAA6B,AAC7B,yBAA0B,AAC1B,+CAAiD,AACjD,6CAA+C,AAC3C,yCAA2C,AACvC,oCAAuC,CACpD,AACD,wFACQ,yCAA4C,AAC5C,iCAAoC,AACpC,4BAA+B,AAC/B,yBAA4B,AAC5B,8CAAqD,CAC5D,AACD,yDACI,mDAAqD,AACrD,2CAA6C,AAC7C,sCAAwC,AACxC,mCAAqC,AACrC,wDAA4D,CAC/D,AACD,0CACE,sBAA0B,AAC1B,iBAAmB,CACpB,AACD,uDACI,kBAAmB,AACnB,cAAe,AACf,kCAAoC,AACpC,iBAAkB,AAClB,gBAAkB,AAClB,qBAAuB,CAC1B,AACD,+DACI,kBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,mEACM,YAAc,CACnB,AACD,8CACE,iBAAmB,CAGpB,AACD,0BACA,8CACM,aAAc,AACd,kCAAoC,AACpC,gBAAkB,CACvB,AACD,0DACQ,YAAc,CACrB,CACA,AACD,4CACA,8CACM,qBAA0B,CAC/B,AACD,8DACQ,gCAAmC,AAC9B,2BAA8B,AAC3B,uBAA2B,CAC1C,CACA,AACD,uCACE,8BAA+B,AAC/B,sBAA0B,AAC1B,aAAc,AACd,kCAAoC,AACpC,gBAAiB,AACjB,uBAAwB,AACpB,mBAAoB,AACxB,gCAAkC,CACnC,AACD,qDACI,iBAAmB,CACtB,AACD,2DACI,sBAA0B,AAC1B,kBAAmB,AACnB,kBAAmB,AACnB,kBAAsB,CAEzB,AACD,+DACM,8BAA+B,AACvB,sBAAuB,AAC/B,2CAA4C,AACpC,mCAAoC,AAC5C,4DAA6D,AACrD,oDAAqD,AAC7D,YAAc,CACnB,AACD,mEACM,wBAA0B,CAE/B,AACD,4CACA,mEACU,qBAA0B,CACnC,CACA,AACD,wIACM,qBAA0B,CAE/B,AACD,4CACA,wIACU,qBAA0B,CACnC,CACA,AACD,4CACA,2DACQ,oBAAuB,AACvB,qBAA0B,CACjC,AACD,2EACU,YAAa,AACb,qCAAuC,AACvC,qBAAuB,CAChC,CACA,AACD,wCACA,GACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,IACI,sCAAwC,AAChC,6BAAgC,CAC3C,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,gDACA,GACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,IACI,sCAAwC,AAChC,6BAAgC,CAC3C,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,6BACE,kBAAmB,AACnB,kBAAmB,AACnB,YAAc,CACf,AACD,6BACE,UAAe,CAChB,AACD,2CACI,aAAe,CAClB,AACD,0CACI,kBAAmB,AACnB,MAAO,AACP,cAAe,AACf,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,mBAAoB,AAChB,WAAY,AACR,MAAQ,CACnB,AACD,uDACM,mBAAoB,AAChB,cAAe,AACX,UAAW,AACnB,WAAa,CAClB,AAKD,2GAHM,YAAa,AACb,WAAa,CAKlB,AACD,uDACM,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,OAAS,CACd,AACD,wEACE,8BAAgC,AAChC,yBAA2B,AAC3B,qBAAwB,CACzB,AACD,oCACE,kBAAmB,AACnB,iDAAmD,CACpD,AACD,2CACE,gDAAkD,AAC1C,uCAA0C,CACnD,AACD,0CACE,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,iCACA,GACI,YAAgB,CACnB,AACD,IACI,gBAAkB,CACrB,AACD,GACI,YAAgB,CACnB,CACA,AACD,yCACA,GACI,YAAgB,CACnB,AACD,IACI,gBAAkB,CACrB,AACD,GACI,YAAgB,CACnB,CACA,AACD,6BACA,GACI,kBAAmB,AACnB,iDAAmD,CACtD,AACD,IACI,gBAAkB,CACrB,AACD,GACI,kBAAmB,AACnB,iDAAmD,CACtD,CACA,AACD,qCACA,GACI,kBAAmB,AACnB,iDAAmD,CACtD,AACD,IACI,gBAAkB,CACrB,AACD,GACI,kBAAmB,AACnB,iDAAmD,CACtD,CACA,AACD,mDACE,uBAAyB,AACzB,kBAAoB,AACpB,cAAiB,CAClB,AACD,8BACE,wDAAyD,AACjD,gDAAiD,AACzD,+BAAiC,AACzB,sBAAyB,CAClC,AACD,oCACA,IACI,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,4CACA,IACI,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,yCACE,gBAAiB,AACjB,WAAY,AACZ,mBAAoB,AACpB,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT,AACD,8BACE,qBAAsB,AACtB,WAAY,AACZ,kBAAmB,AACnB,aAAc,AACd,MAAO,AACP,OAAQ,AACR,iBAAmB,CACpB,AACD,uCACE,qBAA0B,CAC3B,AACD,2CACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,MAAQ,CACT,AACD,gCAEE,uBAA+B,AAC/B,eAAgB,AAChB,WAAY,AACZ,eAAgB,AAChB,SAAW,CAEZ,AACD,4CACA,gCACM,YAAc,CACnB,CACA,AACD,0BACA,wCACM,4BAA8B,AAC9B,MAAO,AACP,uBAA+B,CACpC,CACA,AACD,6BACE,oCAAqC,AACjC,gCAAiC,AAC7B,4BAA6B,AACrC,QAAS,AACT,0DAA2D,AACnD,kDAAmD,AAC3D,+BAAiC,AACzB,sBAAyB,CAClC,AACD,yCACI,yDAA0D,AAClD,iDAAkD,AAC1D,+BAAiC,AACzB,uBAAyB,AACjC,gCAAiC,AAC7B,4BAA6B,AACzB,uBAAyB,CACpC,AACD,6BACE,SAAU,AACV,mCAAoC,AAChC,+BAAgC,AAC5B,2BAA4B,AACpC,0DAA2D,AACnD,kDAAmD,AAC3D,+BAAiC,AACzB,sBAAyB,CAClC,AACD,yCACI,yDAA0D,AAClD,iDAAkD,AAC1D,+BAAiC,AACzB,uBAAyB,AACjC,gCAAiC,AAC7B,4BAA6B,AACzB,uBAAyB,CACpC,AACD,mKAEE,kBAAoB,CACrB,AACD,+CACE,YAAa,AACb,aAAc,AACd,kCAAoC,AACpC,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,YAAc,CACf,AACD,yCACE,kBAAmB,AACnB,aAAc,AACd,kCAAoC,AACpC,YAAa,AACb,MAAO,AACP,QAAS,AACT,aAAc,AACd,mDAAoD,AACpD,2CAA4C,AAC5C,sCAAuC,AACvC,mCAAoC,AACpC,mEAAqE,AACrE,kBAAmB,AACnB,gCAAkC,CAGnC,AACD,4CACA,yCACM,WAAa,CAClB,CACA,AACD,0BACA,yCACM,WAAa,CAClB,CACA,AACD,kDACE,YAAc,CACf,AACD,+BACE,oCAAqC,AACjC,gCAAiC,AAC7B,2BAA6B,CACtC,AACD,qCACA,GACI,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,6CACA,GACI,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,qCACA,GACI,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,6CACA,GACI,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,sCACA,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,AACD,GACI,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACxC,CACA,AACD,8CACA,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,AACD,GACI,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACxC,CACA,AACD,sCACA,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,AACD,GACI,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACvC,CACA,AACD,8CACA,GACI,UAAW,AACX,gCAAkC,AAC1B,uBAA0B,CACrC,AACD,GACI,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACvC,CACA,AACD,qCACA,GACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,IACI,sCAAuC,AAC/B,6BAA+B,CAC1C,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,6CACA,GACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,IACI,sCAAuC,AAC/B,6BAA+B,CAC1C,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AAGD,0BACA,gDACI,6BAA8B,AAC9B,sBAAwB,AACxB,eAAiB,CACpB,AACD,oEACM,WAAe,AACf,kBAAmB,AACnB,8BAAkC,AAClC,kBAAmB,AACnB,gBAAkB,AAClB,wBAA6B,CAClC,AACD,mEACM,kBAAmB,AACnB,8BAA+B,AACvB,sBAAuB,AAC/B,2CAA4C,AACpC,mCAAoC,AAC5C,yDAA0D,AAClD,gDAAkD,CAC/D,AACD,uEACQ,WAAY,AACZ,gBAAiB,AACjB,SAAc,CACrB,CACA,AACD,gCACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AACD,wCACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AACD,6BACE,UAAW,AACX,oDAAqD,AAC7C,4CAA6C,AACrD,8BAA+B,AACvB,qBAAuB,CAChC,AACD,gCACE,YAAa,AAEb,gBAAiB,AACjB,0BAA4B,CAC7B,AACD,sCACI,8BAAgC,AAChC,yBAA2B,AAC3B,qBAAwB,CAC3B","file":"ArticleView.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.articleView__shareButtons[data-v-9db8fe76] {\n  position: fixed;\n  top: var(--window-height, 100vh);\n  z-index: 100;\n  left: 0;\n  -webkit-transition: -webkit-transform 0ms;\n  transition: -webkit-transform 0ms;\n  -o-transition: transform 0ms;\n  transition: transform 0ms;\n  transition: transform 0ms, -webkit-transform 0ms;\n}\n.articleView__shareButtons.active[data-v-9db8fe76] {\n    -webkit-transition: -webkit-transform 400ms;\n    transition: -webkit-transform 400ms;\n    -o-transition: transform 400ms;\n    transition: transform 400ms;\n    transition: transform 400ms, -webkit-transform 400ms;\n    -webkit-transform: translateY(-50px);\n        -ms-transform: translateY(-50px);\n            transform: translateY(-50px);\n}\n.articleView__shareButtons.hide[data-v-9db8fe76] {\n    -webkit-transition: -webkit-transform 400ms;\n    transition: -webkit-transform 400ms;\n    -o-transition: transform 400ms;\n    transition: transform 400ms;\n    transition: transform 400ms, -webkit-transform 400ms;\n    -webkit-transform: translateY(50px);\n        -ms-transform: translateY(50px);\n            transform: translateY(50px);\n}\n.articleView__shareButtons:not(.share-button-native-container).inCard[data-v-9db8fe76] {\n    -webkit-transform: translateY(50px);\n        -ms-transform: translateY(50px);\n            transform: translateY(50px);\n}\n.articleView__shareButtons.share-button-native-container[data-v-9db8fe76] {\n    right: 1rem;\n    bottom: 1.25rem;\n    -webkit-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n            transform: translateY(0px);\n    left: inherit;\n    top: inherit;\n}\n.articleView__shareButtons.share-button-native-container.hide[data-v-9db8fe76] {\n      -webkit-transform: translateY(85px) !important;\n          -ms-transform: translateY(85px) !important;\n              transform: translateY(85px) !important;\n}\n.articleView__shareButtons.share-button-native-container.reset[data-v-9db8fe76] {\n      -webkit-transition: -webkit-transform 400ms;\n      transition: -webkit-transform 400ms;\n      -o-transition: transform 400ms;\n      transition: transform 400ms;\n      transition: transform 400ms, -webkit-transform 400ms;\n}\n.articleView__shareButtons.share-button-native-container.inCard[data-v-9db8fe76] {\n      -webkit-transition: -webkit-transform 0ms;\n      transition: -webkit-transform 0ms;\n      -o-transition: transform 0ms;\n      transition: transform 0ms;\n      transition: transform 0ms, -webkit-transform 0ms;\n      -webkit-transform: translateY(85px) !important;\n          -ms-transform: translateY(85px) !important;\n              transform: translateY(85px) !important;\n}\n.articleView__shareButtons.share-button-native-container.inCard.active[data-v-9db8fe76] {\n        -webkit-transition: -webkit-transform 400ms;\n        transition: -webkit-transform 400ms;\n        -o-transition: transform 400ms;\n        transition: transform 400ms;\n        transition: transform 400ms, -webkit-transform 400ms;\n}\n.articleView__shareButtons.no-animation[data-v-9db8fe76] {\n    -webkit-transition: -webkit-transform 0ms !important;\n    transition: -webkit-transform 0ms !important;\n    -o-transition: transform 0ms !important;\n    transition: transform 0ms !important;\n    transition: transform 0ms, -webkit-transform 0ms !important;\n}\n.next-article-indication[data-v-9db8fe76] {\n  background-color: #FFFFFF;\n  position: relative;\n}\n.next-article-indication .coming-next[data-v-9db8fe76] {\n    text-align: center;\n    color: #F8008E;\n    font-family: Silkscreen, sans-serif;\n    font-size: 1.5rem;\n    font-weight: bold;\n    line-height: 1.5625rem;\n}\n.next-article-indication .bottom-card-invader[data-v-9db8fe76] {\n    padding-top: 0.5rem;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.next-article-indication .bottom-card-invader svg[data-v-9db8fe76] {\n      fill: #F8008E;\n}\n.article-bottom-card-wrapper[data-v-9db8fe76] {\n  position: relative;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-bottom-card-wrapper[data-v-9db8fe76] {\n      height: 100vh;\n      height: var(--window-height, 100vh);\n      max-height: 100vh;\n}\n.article-bottom-card-wrapper .fullHeight[data-v-9db8fe76] {\n        height: 100vh;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-bottom-card-wrapper[data-v-9db8fe76] {\n      background-color: #FFFFFF;\n}\n.article-bottom-card-wrapper .smooth-animate[data-v-9db8fe76] {\n        -webkit-transition-duration: 100ms;\n             -o-transition-duration: 100ms;\n                transition-duration: 100ms;\n}\n}\n.article-view-wrapper[data-v-9db8fe76] {\n  overscroll-behavior-y: contain;\n  background-color: #FFFFFF;\n  height: 100vh;\n  height: var(--window-height, 100vh);\n  overflow-y: auto;\n  -ms-touch-action: pan-y;\n      touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n}\n.article-view-wrapper.preventScroll[data-v-9db8fe76] {\n    overflow-y: hidden;\n}\n.article-view-wrapper .arrow-down-wrapper[data-v-9db8fe76] {\n    background-color: #FFFFFF;\n    position: relative;\n    text-align: center;\n    padding: 0 0 2.5rem 0;\n    /* Mobile breakpoints */\n}\n.article-view-wrapper .arrow-down-wrapper svg[data-v-9db8fe76] {\n      -webkit-animation-duration: 1s;\n              animation-duration: 1s;\n      -webkit-animation-iteration-count: infinite;\n              animation-iteration-count: infinite;\n      -webkit-animation-name: arrow-down-animation-data-v-9db8fe76;\n              animation-name: arrow-down-animation-data-v-9db8fe76;\n      fill: #F8008E;\n}\n.article-view-wrapper .arrow-down-wrapper.opinion[data-v-9db8fe76] {\n      background-color: #E7E7E7;\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-view-wrapper .arrow-down-wrapper.opinion[data-v-9db8fe76] {\n          background-color: #FFFFFF;\n}\n}\n.article-view-wrapper .arrow-down-wrapper.video[data-v-9db8fe76], .article-view-wrapper .arrow-down-wrapper.photo-essay[data-v-9db8fe76] {\n      background-color: #000000;\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-view-wrapper .arrow-down-wrapper.video[data-v-9db8fe76], .article-view-wrapper .arrow-down-wrapper.photo-essay[data-v-9db8fe76] {\n          background-color: #FFFFFF;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-view-wrapper .arrow-down-wrapper[data-v-9db8fe76] {\n        padding: 0 0 1.25rem 0;\n        background-color: #FFFFFF;\n}\n.article-view-wrapper .arrow-down-wrapper .bottom-divider[data-v-9db8fe76] {\n          width: 100vw;\n          border-bottom: 0.1875rem solid #F8008E;\n          margin-bottom: 1.25rem;\n}\n}\n@-webkit-keyframes arrow-down-animation {\nfrom {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(0.625rem);\n            transform: translateY(0.625rem);\n}\n100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes arrow-down-animation-data-v-9db8fe76 {\nfrom {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(0.625rem);\n            transform: translateY(0.625rem);\n}\n100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n.news-title[data-v-9db8fe76] {\n  position: absolute;\n  font-size: 12.5rem;\n  z-index: -999;\n}\n.card-cover[data-v-9db8fe76] {\n  color: #000000;\n}\n.card-cover.cardInvisible[data-v-9db8fe76] {\n    display: block;\n}\n.card-cover .arrowsHover[data-v-9db8fe76] {\n    position: absolute;\n    top: 0;\n    width: inherit;\n    height: inherit;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-flex: 3;\n        -ms-flex: 3;\n            flex: 3;\n}\n.card-cover .arrowsHover .center-area[data-v-9db8fe76] {\n      -webkit-box-flex: 1;\n          -ms-flex: auto;\n              flex: auto;\n      height: 100%;\n}\n.card-cover .arrowsHover .left-area[data-v-9db8fe76] {\n      width: 25rem;\n      height: 100%;\n}\n.card-cover .arrowsHover .right-area[data-v-9db8fe76] {\n      width: 25rem;\n      height: 100%;\n}\n.card-cover .arrowsHover .card-middle[data-v-9db8fe76] {\n      width: 100vw;\n      height: 1px;\n      position: absolute;\n      top: 50%;\n}\n.card-cover.reset[data-v-9db8fe76], .card-cover.animate[data-v-9db8fe76] {\n  -webkit-transition: margin 0.5s;\n  -o-transition: margin 0.5s;\n  transition: margin 0.5s;\n}\n.card-cover.to-top[data-v-9db8fe76] {\n  margin-top: -100vh;\n  margin-top: calc(var(--window-height, 100vh) * -1);\n}\n.card-cover.to-top.bounce[data-v-9db8fe76] {\n  -webkit-animation: bounce-in-data-v-9db8fe76 0.5s;\n          animation: bounce-in-data-v-9db8fe76 0.5s;\n}\n.node-body.bounce-bottom[data-v-9db8fe76] {\n  -webkit-animation: bounce-bottom-data-v-9db8fe76 0.5s;\n          animation: bounce-bottom-data-v-9db8fe76 0.5s;\n}\n@-webkit-keyframes bounce-bottom {\n0% {\n    margin-top: 0vh;\n}\n50% {\n    margin-top: -20vh;\n}\n100% {\n    margin-top: 0vh;\n}\n}\n@keyframes bounce-bottom-data-v-9db8fe76 {\n0% {\n    margin-top: 0vh;\n}\n50% {\n    margin-top: -20vh;\n}\n100% {\n    margin-top: 0vh;\n}\n}\n@-webkit-keyframes bounce-in {\n0% {\n    margin-top: -100vh;\n    margin-top: calc(var(--window-height, 100vh) * -1);\n}\n50% {\n    margin-top: -70vh;\n}\n100% {\n    margin-top: -100vh;\n    margin-top: calc(var(--window-height, 100vh) * -1);\n}\n}\n@keyframes bounce-in-data-v-9db8fe76 {\n0% {\n    margin-top: -100vh;\n    margin-top: calc(var(--window-height, 100vh) * -1);\n}\n50% {\n    margin-top: -70vh;\n}\n100% {\n    margin-top: -100vh;\n    margin-top: calc(var(--window-height, 100vh) * -1);\n}\n}\n.article-body-card-wrapper .reset[data-v-9db8fe76] {\n  -webkit-transition: 0.5s;\n  -o-transition: 0.5s;\n  transition: 0.5s;\n}\n.resetBottom[data-v-9db8fe76] {\n  -webkit-animation-name: bottom-bounce-in-data-v-9db8fe76;\n          animation-name: bottom-bounce-in-data-v-9db8fe76;\n  -webkit-animation-duration: 0.5s;\n          animation-duration: 0.5s;\n}\n@-webkit-keyframes bottom-bounce-in {\n50% {\n    -webkit-transform: translateY(-20%);\n            transform: translateY(-20%);\n}\n100% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n}\n}\n@keyframes bottom-bounce-in-data-v-9db8fe76 {\n50% {\n    -webkit-transform: translateY(-20%);\n            transform: translateY(-20%);\n}\n100% {\n    -webkit-transform: translateY(0%);\n            transform: translateY(0%);\n}\n}\n.article-card-headerbar[data-v-9db8fe76] {\n  height: 3.125rem;\n  width: 100%;\n  background: #002E3E;\n  opacity: .8;\n  z-index: 1030;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.header_text[data-v-9db8fe76] {\n  margin-top: 1.5625rem;\n  width: 100%;\n  position: absolute;\n  z-index: 1031;\n  top: 0;\n  left: 0;\n  text-align: center;\n}\n.card-video-container[data-v-9db8fe76] {\n  background-color: #000000;\n}\n.fixed-bottom .newsletter[data-v-9db8fe76] {\n  position: relative;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.article-arrow[data-v-9db8fe76] {\n  /* Mobile breakpoints */\n  fill: rgba(204, 204, 204, 0.5);\n  position: fixed;\n  top: 7.5rem;\n  cursor: pointer;\n  z-index: 1;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-arrow[data-v-9db8fe76] {\n      display: none;\n}\n}\n@media (min-width: 1024px) {\n.article-arrow.onCover[data-v-9db8fe76] {\n      position: absolute !important;\n      top: 0;\n      fill: rgba(255, 255, 255, 0.9);\n}\n}\n.arrow-prev[data-v-9db8fe76] {\n  -webkit-transform: translateX(-150%);\n      -ms-transform: translateX(-150%);\n          transform: translateX(-150%);\n  left: 1%;\n  -webkit-animation-name: arrow-prev-fadeOut-data-v-9db8fe76;\n          animation-name: arrow-prev-fadeOut-data-v-9db8fe76;\n  -webkit-animation-duration: 0.5s;\n          animation-duration: 0.5s;\n}\n.arrow-prev.arrowFadeIn[data-v-9db8fe76] {\n    -webkit-animation-name: arrow-prev-fadeIn-data-v-9db8fe76;\n            animation-name: arrow-prev-fadeIn-data-v-9db8fe76;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-transform: translateX(0);\n        -ms-transform: translateX(0);\n            transform: translateX(0);\n}\n.arrow-next[data-v-9db8fe76] {\n  right: 1%;\n  -webkit-transform: translateX(150%);\n      -ms-transform: translateX(150%);\n          transform: translateX(150%);\n  -webkit-animation-name: arrow-next-fadeOut-data-v-9db8fe76;\n          animation-name: arrow-next-fadeOut-data-v-9db8fe76;\n  -webkit-animation-duration: 0.5s;\n          animation-duration: 0.5s;\n}\n.arrow-next.arrowFadeIn[data-v-9db8fe76] {\n    -webkit-animation-name: arrow-next-fadeIn-data-v-9db8fe76;\n            animation-name: arrow-next-fadeIn-data-v-9db8fe76;\n    -webkit-animation-duration: 0.5s;\n            animation-duration: 0.5s;\n    -webkit-transform: translateX(0);\n        -ms-transform: translateX(0);\n            transform: translateX(0);\n}\n.related-person-overlay-header.theme-desktop.showing-desktop-header[data-v-9db8fe76],\n.related-person-overlay.theme-desktop.showing-desktop-header[data-v-9db8fe76] {\n  margin-top: 4.25rem;\n}\n.related-person-overlay-layer[data-v-9db8fe76] {\n  width: 100vw;\n  height: 100vh;\n  height: var(--window-height, 100vh);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1198;\n}\n.related-person-overlay[data-v-9db8fe76] {\n  position: absolute;\n  height: 100vh;\n  height: var(--window-height, 100vh);\n  width: 100vw;\n  top: 0;\n  right: 0;\n  z-index: 1199;\n  -webkit-transition: -webkit-transform .4s ease .02s;\n  transition: -webkit-transform .4s ease .02s;\n  -o-transition: transform .4s ease .02s;\n  transition: transform .4s ease .02s;\n  transition: transform .4s ease .02s, -webkit-transform .4s ease .02s;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.related-person-overlay[data-v-9db8fe76] {\n      width: 100vw;\n}\n}\n@media (min-width: 1024px) {\n.related-person-overlay[data-v-9db8fe76] {\n      width: 640px;\n}\n}\n.related-person-overlay-sharebar[data-v-9db8fe76] {\n  z-index: 1200;\n}\n.hidden-right[data-v-9db8fe76] {\n  -webkit-transform: translateX(100vw);\n      -ms-transform: translateX(100vw);\n          transform: translateX(100vw);\n}\n@-webkit-keyframes arrow-prev-fadeIn {\n0% {\n    opacity: 0;\n    -webkit-transform: translateX(-150%);\n            transform: translateX(-150%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n}\n@keyframes arrow-prev-fadeIn-data-v-9db8fe76 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateX(-150%);\n            transform: translateX(-150%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n}\n@-webkit-keyframes arrow-next-fadeIn {\n0% {\n    opacity: 0;\n    -webkit-transform: translateX(150%);\n            transform: translateX(150%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n}\n@keyframes arrow-next-fadeIn-data-v-9db8fe76 {\n0% {\n    opacity: 0;\n    -webkit-transform: translateX(150%);\n            transform: translateX(150%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n}\n@-webkit-keyframes arrow-prev-fadeOut {\n0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n100% {\n    opacity: 0;\n    -webkit-transform: translateX(-150%);\n            transform: translateX(-150%);\n}\n}\n@keyframes arrow-prev-fadeOut-data-v-9db8fe76 {\n0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n100% {\n    opacity: 0;\n    -webkit-transform: translateX(-150%);\n            transform: translateX(-150%);\n}\n}\n@-webkit-keyframes arrow-next-fadeOut {\n0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n100% {\n    opacity: 0;\n    -webkit-transform: translateX(150%);\n            transform: translateX(150%);\n}\n}\n@keyframes arrow-next-fadeOut-data-v-9db8fe76 {\n0% {\n    opacity: 1;\n    -webkit-transform: translateX(0%);\n            transform: translateX(0%);\n}\n100% {\n    opacity: 0;\n    -webkit-transform: translateX(150%);\n            transform: translateX(150%);\n}\n}\n@-webkit-keyframes scroll-down-arrow {\n0% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(1.25rem);\n            transform: translateY(1.25rem);\n}\n100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes scroll-down-arrow-data-v-9db8fe76 {\n0% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(1.25rem);\n            transform: translateY(1.25rem);\n}\n100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n\n/* Mobile breakpoints */\n@media (min-width: 1024px) {\n.bottom-card-cover-blank-space[data-v-9db8fe76] {\n    height: calc(100vh - 56.25vw);\n    background-color: white;\n    overflow: hidden;\n}\n.bottom-card-cover-blank-space .scroll-to-continue[data-v-9db8fe76] {\n      color: #aaaaaa;\n      text-align: center;\n      font-family: \"Barlow\", sans-serif;\n      font-size: 1.75rem;\n      font-weight: bold;\n      padding: 1.75rem 0 0.75rem 0;\n}\n.bottom-card-cover-blank-space .scroll-down-arrow[data-v-9db8fe76] {\n      text-align: center;\n      -webkit-animation-duration: 1s;\n              animation-duration: 1s;\n      -webkit-animation-iteration-count: infinite;\n              animation-iteration-count: infinite;\n      -webkit-animation-name: scroll-down-arrow-data-v-9db8fe76;\n              animation-name: scroll-down-arrow-data-v-9db8fe76;\n}\n.bottom-card-cover-blank-space .scroll-down-arrow svg[data-v-9db8fe76] {\n        width: 2rem;\n        height: 1.875rem;\n        fill: #999999;\n}\n}\n@-webkit-keyframes body-fade-in {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n@keyframes body-fade-in-data-v-9db8fe76 {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n.bodyFadeIn[data-v-9db8fe76] {\n  opacity: 1;\n  -webkit-animation-name: body-fade-in-data-v-9db8fe76;\n          animation-name: body-fade-in-data-v-9db8fe76;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n}\n.prevCardCover[data-v-9db8fe76] {\n  width: 100vw;\n  /*height: 100vh;*/\n  overflow: hidden;\n  transfrom: translateY(11vh);\n}\n.prevCardCover.reset[data-v-9db8fe76] {\n    -webkit-transition: margin 0.5s;\n    -o-transition: margin 0.5s;\n    transition: margin 0.5s;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".page-type-person .card-video-container{background-color:#002a3f}.page-type-person .article-view-wrapper .arrow-down-wrapper{background-color:#0a3765}@media (min-width:0) and (max-width:1023px){.page-type-person .article-view-wrapper .arrow-down-wrapper{padding-top:1.375rem;background-color:#fff}}.node-type-person{font-family:Roboto,sans-serif}.node-type-person .article-body a,.node-type-person a,.node-type-person a.link{color:#fff;text-shadow:none}.node-type-person.theme-desktop .arrow-right-wrapper{margin-left:-2.1875rem}@media (min-width:1024px){.node-type-person .share-pane .share-toolbar{padding-top:1.6875rem}}.node-type-person .share-pane .shareCount{color:#fff}.node-type-person .share-pane .shareCount .shareText{padding-top:.625rem}.node-type-person .related-articles-pane .article-level-one .card-title{font-size:1rem;line-height:1.25rem}.node-type-person .related-articles-pane .article-level-one .card-section{color:#5a9cb5;font-size:.75rem;line-height:1rem}@media (min-width:1024px){.node-type-person .related-articles-pane .article-level-one .card-section{font-size:.875rem;line-height:1.125rem}}.node-type-person .tags-wrapper{font-family:Barlow,sans-serif}.node-type-person .tags-wrapper .tags-title{color:#f8008e;font-size:1.375rem;line-height:1.625rem;text-transform:uppercase;font-weight:700;font-family:Barlow,sans-serif;display:block}@media (min-width:1024px){.node-type-person .tags-wrapper .tags-title{line-height:1.875rem;font-size:1.5rem;margin-bottom:1.0625rem}}@media (min-width:1024px){.node-type-person .tags-wrapper .tags h5{margin-top:0}.node-type-person .tags-wrapper .tags h5.first{margin-bottom:.9375rem;font-size:1.25rem;line-height:1.875rem}}@media (min-width:0) and (max-width:1023px){.node-type-person .tags-wrapper .tags h5.first{margin-top:.5rem}.node-type-person .tags-wrapper .tags h5.first,.node-type-person .tags-wrapper .tags h5.first a{font-size:3rem;line-height:3.5625rem}.node-type-person .tags-wrapper .tags h5,.node-type-person .tags-wrapper .tags h5 a{color:#00e8ff;font-size:1.125rem;line-height:1.875rem}}.node-type-person .article-body h3{font-family:Barlow,sans-serif}@media (min-width:1024px){.node-type-person .article-body h3{line-height:1.875rem;margin-bottom:.5rem}}@media (min-width:0) and (max-width:1023px){.node-type-person .article-body h3{font-size:1.375rem;line-height:1.625rem;margin-bottom:.75rem}}@media (min-width:1024px){.node-type-person .article-body p{font-size:1.125rem;line-height:1.875rem;margin-bottom:1.875rem}}@media (min-width:0) and (max-width:1023px){.node-type-person .article-body p{margin-bottom:1.75rem}}.node-type-person .gallery-wrapper{padding-bottom:0;margin-left:0;margin-right:0}.node-type-person .gallery-wrapper .gallery-container{overflow:hidden}.node-type-person .gallery-wrapper .gallery-container .thumbnail{border-color:transparent}.node-type-person .gallery-wrapper .gallery-container .gallery{margin-left:-.09375rem;margin-right:-.09375rem}.node-type-person .person-header .person-top{position:relative;z-index:1}.node-type-person .person-header .person-top .person-brief{font-size:1.375rem;line-height:1.875rem;margin-top:-.5rem;color:#95c6e8;margin-bottom:1rem}.node-type-person .person-header .person-top .person-brief ul{padding-left:1.5rem}.node-type-person:not(.overlay) .person-header .person-top .person-brief{font-size:1.125rem;line-height:1.625rem}.pane{background-color:#012b55}@media (min-width:1024px){.pane{margin-bottom:.75rem;padding-top:1.75rem;padding-bottom:1.875rem}}@media (min-width:0) and (max-width:1023px){.pane{margin-bottom:.25rem;padding-top:1.5rem;padding-bottom:1.6875rem}}.pane h3{font-family:Barlow,sans-serif;font-weight:700}@media (min-width:1024px){.pane h3{line-height:1.875rem;font-size:1.5rem;margin-bottom:1.25rem}}@media (min-width:0) and (max-width:1023px){.pane h3{margin-bottom:1rem;font-size:1.375rem;line-height:1.625rem}}.pane.gallery-pane{padding-top:0;padding-bottom:0}", "", {"version":3,"sources":["/app/components/node/person/PersonBody.vue"],"names":[],"mappings":"AAgCA,wCACE,wBAA0B,CAC3B,AACD,4DACE,wBAA0B,CAE3B,AACD,4CACA,4DACM,qBAAsB,AACtB,qBAA0B,CAC/B,CACA,AACD,kBACE,6BAAkC,CACnC,AACD,+EACI,WAAe,AACf,gBAAkB,CACrB,AACD,qDACI,sBAAwB,CAC3B,AAID,0BACA,6CACQ,qBAAuB,CAC9B,CACA,AACD,0CACI,UAAe,CAClB,AACD,qDACM,mBAAsB,CAC3B,AACD,wEACI,eAAgB,AAChB,mBAAqB,CACxB,AACD,0EACI,cAAe,AACf,iBAAmB,AACnB,gBAAkB,CAErB,AACD,0BACA,0EACQ,kBAAoB,AACpB,oBAAsB,CAC7B,CACA,AACD,gCACI,6BAAkC,CACrC,AACD,4CACM,cAAe,AACf,mBAAoB,AACpB,qBAAsB,AACtB,yBAA0B,AAC1B,gBAAkB,AAClB,8BAAkC,AAClC,aAAe,CAEpB,AACD,0BACA,4CACU,qBAAsB,AACtB,iBAAkB,AAClB,uBAAyB,CAClC,CACA,AAKD,0BACA,yCACU,YAAc,CACvB,AACD,+CACY,uBAAyB,AACzB,kBAAmB,AACnB,oBAAsB,CACjC,CACA,AACD,4CACA,+CACU,gBAAmB,CAC5B,AACD,gGACY,eAAgB,AAChB,qBAAuB,CAClC,AACD,oFACU,cAAe,AACf,mBAAoB,AACpB,oBAAsB,CAC/B,CACA,AACD,mCACI,6BAAkC,CAGrC,AACD,0BACA,mCACQ,qBAAsB,AACtB,mBAAsB,CAC7B,CACA,AACD,4CACA,mCACQ,mBAAoB,AACpB,qBAAsB,AACtB,oBAAuB,CAC9B,CACA,AAKD,0BACA,kCACQ,mBAAoB,AACpB,qBAAsB,AACtB,sBAAwB,CAC/B,CACA,AACD,4CACA,kCACQ,qBAAuB,CAC9B,CACA,AACD,mCACI,iBAAkB,AAClB,cAAe,AACf,cAAgB,CACnB,AACD,sDACM,eAAiB,CACtB,AACD,iEACQ,wBAA0B,CACjC,AACD,+DACQ,uBAAyB,AACzB,uBAA0B,CACjC,AACD,6CACE,kBAAmB,AACnB,SAAW,CACZ,AACD,2DACI,mBAAoB,AACpB,qBAAsB,AACtB,kBAAoB,AACpB,cAAe,AACf,kBAAoB,CACvB,AACD,8DACM,mBAAqB,CAC1B,AACD,yEACE,mBAAoB,AACpB,oBAAsB,CACvB,AACD,MACE,wBAA0B,CAG3B,AACD,0BACA,MACM,qBAAuB,AACvB,oBAAqB,AACrB,uBAAyB,CAC9B,CACA,AACD,4CACA,MACM,qBAAuB,AACvB,mBAAoB,AACpB,wBAA0B,CAC/B,CACA,AACD,SACI,8BAAkC,AAClC,eAAkB,CAGrB,AACD,0BACA,SACQ,qBAAsB,AACtB,iBAAkB,AAClB,qBAAuB,CAC9B,CACA,AACD,4CACA,SACQ,mBAAoB,AACpB,mBAAoB,AACpB,oBAAsB,CAC7B,CACA,AACD,mBACI,cAAe,AACf,gBAAkB,CACrB","file":"PersonBody.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.page-type-person .card-video-container {\n  background-color: #002A3F;\n}\n.page-type-person .article-view-wrapper .arrow-down-wrapper {\n  background-color: #0A3765;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.page-type-person .article-view-wrapper .arrow-down-wrapper {\n      padding-top: 1.375rem;\n      background-color: #FFFFFF;\n}\n}\n.node-type-person {\n  font-family: \"Roboto\", sans-serif;\n}\n.node-type-person a, .node-type-person .article-body a, .node-type-person a.link {\n    color: #FFFFFF;\n    text-shadow: none;\n}\n.node-type-person.theme-desktop .arrow-right-wrapper {\n    margin-left: -2.1875rem;\n}\n.node-type-person .share-pane .share-toolbar {\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-person .share-pane .share-toolbar {\n        padding-top: 1.6875rem;\n}\n}\n.node-type-person .share-pane .shareCount {\n    color: #FFFFFF;\n}\n.node-type-person .share-pane .shareCount .shareText {\n      padding-top: 0.625rem;\n}\n.node-type-person .related-articles-pane .article-level-one .card-title {\n    font-size: 1rem;\n    line-height: 1.25rem;\n}\n.node-type-person .related-articles-pane .article-level-one .card-section {\n    color: #5A9CB5;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-person .related-articles-pane .article-level-one .card-section {\n        font-size: 0.875rem;\n        line-height: 1.125rem;\n}\n}\n.node-type-person .tags-wrapper {\n    font-family: \"Barlow\", sans-serif;\n}\n.node-type-person .tags-wrapper .tags-title {\n      color: #F8008E;\n      font-size: 1.375rem;\n      line-height: 1.625rem;\n      text-transform: uppercase;\n      font-weight: bold;\n      font-family: \"Barlow\", sans-serif;\n      display: block;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-person .tags-wrapper .tags-title {\n          line-height: 1.875rem;\n          font-size: 1.5rem;\n          margin-bottom: 1.0625rem;\n}\n}\n.node-type-person .tags-wrapper .tags h5 {\n      /* Mobile breakpoints */\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-person .tags-wrapper .tags h5 {\n          margin-top: 0;\n}\n.node-type-person .tags-wrapper .tags h5.first {\n            margin-bottom: 0.9375rem;\n            font-size: 1.25rem;\n            line-height: 1.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.node-type-person .tags-wrapper .tags h5.first {\n          margin-top: 0.5rem;\n}\n.node-type-person .tags-wrapper .tags h5.first, .node-type-person .tags-wrapper .tags h5.first a {\n            font-size: 3rem;\n            line-height: 3.5625rem;\n}\n.node-type-person .tags-wrapper .tags h5, .node-type-person .tags-wrapper .tags h5 a {\n          color: #00E8FF;\n          font-size: 1.125rem;\n          line-height: 1.875rem;\n}\n}\n.node-type-person .article-body h3 {\n    font-family: \"Barlow\", sans-serif;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-person .article-body h3 {\n        line-height: 1.875rem;\n        margin-bottom: 0.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.node-type-person .article-body h3 {\n        font-size: 1.375rem;\n        line-height: 1.625rem;\n        margin-bottom: 0.75rem;\n}\n}\n.node-type-person .article-body p {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-person .article-body p {\n        font-size: 1.125rem;\n        line-height: 1.875rem;\n        margin-bottom: 1.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.node-type-person .article-body p {\n        margin-bottom: 1.75rem;\n}\n}\n.node-type-person .gallery-wrapper {\n    padding-bottom: 0;\n    margin-left: 0;\n    margin-right: 0;\n}\n.node-type-person .gallery-wrapper .gallery-container {\n      overflow: hidden;\n}\n.node-type-person .gallery-wrapper .gallery-container .thumbnail {\n        border-color: transparent;\n}\n.node-type-person .gallery-wrapper .gallery-container .gallery {\n        margin-left: -0.09375rem;\n        margin-right: -0.09375rem;\n}\n.node-type-person .person-header .person-top {\n  position: relative;\n  z-index: 1;\n}\n.node-type-person .person-header .person-top .person-brief {\n    font-size: 1.375rem;\n    line-height: 1.875rem;\n    margin-top: -0.5rem;\n    color: #95c6e8;\n    margin-bottom: 1rem;\n}\n.node-type-person .person-header .person-top .person-brief ul {\n      padding-left: 1.5rem;\n}\n.node-type-person:not(.overlay) .person-header .person-top .person-brief {\n  font-size: 1.125rem;\n  line-height: 1.625rem;\n}\n.pane {\n  background-color: #012b55;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pane {\n      margin-bottom: 0.75rem;\n      padding-top: 1.75rem;\n      padding-bottom: 1.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.pane {\n      margin-bottom: 0.25rem;\n      padding-top: 1.5rem;\n      padding-bottom: 1.6875rem;\n}\n}\n.pane h3 {\n    font-family: \"Barlow\", sans-serif;\n    font-weight: bold;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pane h3 {\n        line-height: 1.875rem;\n        font-size: 1.5rem;\n        margin-bottom: 1.25rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.pane h3 {\n        margin-bottom: 1rem;\n        font-size: 1.375rem;\n        line-height: 1.625rem;\n}\n}\n.pane.gallery-pane {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".list-enter-active[data-v-a6d8d51e],.list-leave-active[data-v-a6d8d51e]{-webkit-transition:all 1s;-o-transition:all 1s;transition:all 1s}.list-enter[data-v-a6d8d51e],.list-leave-to[data-v-a6d8d51e]{opacity:0}.node-type-person[data-v-a6d8d51e]{color:#fff;background-color:#0a3765}.node-type-person .field-date[data-v-a6d8d51e],.node-type-person .share-pane[data-v-a6d8d51e]{color:#fff;font-family:Barlow,sans-serif}@media (min-width:1024px){.node-type-person .field-date[data-v-a6d8d51e]{font-size:.875rem;line-height:1rem;text-align:left}}.node-type-person .share-pane[data-v-a6d8d51e]{padding-top:.625rem}.node-type-person .share-pane .share-count[data-v-a6d8d51e]{margin-bottom:1.25rem}@media (min-width:1024px){.node-type-person .share-pane[data-v-a6d8d51e]{padding-top:.375rem;margin-bottom:2.5rem}}.node-type-person[data-v-a6d8d51e]:not(.overlay) .tl-skinny .tl-slidenav-next,.node-type-person[data-v-a6d8d51e]:not(.overlay) .tl-skinny .tl-slidenav-previous{visibility:hidden}.node-type-person.overlay[data-v-a6d8d51e]{width:100%;min-height:100%;height:auto;padding-top:3.125rem;padding-bottom:3.125rem}.node-type-person.overlay .image-holder[data-v-a6d8d51e]{position:absolute;top:0;left:0;right:0;bottom:0;background-position:50%;background-size:cover;background-repeat:no-repeat}.node-type-person.overlay.theme-desktop[data-v-a6d8d51e]{padding-top:4.6875rem}.node-type-person.overlay .person-header[data-v-a6d8d51e]:after{background:-webkit-gradient(linear,left top,left bottom,from(transparent),to(rgba(0,0,0,.5)));background:-o-linear-gradient(top,transparent 0,rgba(0,0,0,.5) 100%);background:linear-gradient(180deg,transparent 0,rgba(0,0,0,.5));content:\" \";position:absolute;height:25rem;width:100%;bottom:0;left:0;right:0}.node-type-person .loader[data-v-a6d8d51e]{padding-top:1.25rem;height:auto}.timeline-wrapper[data-v-a6d8d51e]{max-width:78.75rem;margin-bottom:.625rem}@media (min-width:1024px){.timeline-wrapper[data-v-a6d8d51e]{margin-bottom:6.875rem}}.prevent-article-swiping[data-v-a6d8d51e]{width:100%;position:fixed}.overlay-header[data-v-a6d8d51e]{padding:1rem 1rem .9375rem;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:.0625rem solid #000;background-color:#002e3e;-webkit-transition:all .5s ease;-o-transition:all .5s ease;transition:all .5s ease;position:fixed;background-color:red;z-index:1200;width:100%}.overlay-header.collapse .overlay-header-section[data-v-a6d8d51e]{font-size:.6875rem;line-height:.8125rem}.overlay-header.collapse .overlay-back-btn[data-v-a6d8d51e]{width:.75rem;height:.6875rem}.overlay-header .overlay-back-btn[data-v-a6d8d51e],.overlay-header .overlay-header-section[data-v-a6d8d51e]{display:-webkit-box;display:-ms-flexbox;display:flex}.overlay-header .overlay-header-section[data-v-a6d8d51e]{font-size:.875rem;line-height:1rem;font-weight:700}.no-article-gutter[data-v-a6d8d51e]{margin-left:-1.25rem;margin-right:-1.25rem}.article-gutter[data-v-a6d8d51e]{padding-left:1.25rem;padding-right:1.25rem}@media (min-width:1024px){.inner-content[data-v-a6d8d51e]{padding-top:2.5rem}}@media (min-width:0) and (max-width:1023px){.inner-content[data-v-a6d8d51e]{padding-top:.75rem;margin-bottom:2.5rem}}.attr-label-tag[data-v-a6d8d51e]{font-weight:700;font-family:Barlow,sans-serif;color:#5a9cb5;text-transform:uppercase;margin-bottom:.375rem}@media (min-width:1024px){.attr-label-tag[data-v-a6d8d51e]{font-size:1.125rem;line-height:1.3125rem}}@media (min-width:0) and (max-width:1023px){.attr-label-tag[data-v-a6d8d51e]{font-size:1rem;line-height:1.1875rem}}@media (min-width:1024px){.content-wrapper[data-v-a6d8d51e]{max-width:43.75rem}}.person-header[data-v-a6d8d51e]{background-color:#012b55;padding-top:2.125rem;padding-bottom:0;color:#fff}@media (min-width:1024px){.person-header[data-v-a6d8d51e]{padding-bottom:.6875rem}}.person-header.hasCover[data-v-a6d8d51e]{background-size:cover;background-repeat:no-repeat;background-position:50%;padding-top:72%}.person-header .node-label[data-v-a6d8d51e]{text-transform:uppercase;margin-bottom:.25rem;color:#fc4861;font-weight:700}@media (min-width:1024px){.person-header .node-label[data-v-a6d8d51e]{font-size:1.25rem;line-height:1.5rem}}@media (min-width:0) and (max-width:1023px){.person-header .node-label[data-v-a6d8d51e]{font-size:.875rem;line-height:1rem}}.person-header .person-name[data-v-a6d8d51e]{color:#fff;font-weight:400;font-family:Bungee,sans-serif;text-transform:uppercase;margin-bottom:.25rem}@media (min-width:1024px){.person-header .person-name[data-v-a6d8d51e]{font-size:3.125rem;line-height:3.125rem}}@media (min-width:0) and (max-width:1023px){.person-header .person-name[data-v-a6d8d51e]{font-size:2.5rem;line-height:2.5rem}}.person-header .person-name span[data-v-a6d8d51e]{font-size:0;color:transparent}.person-header .person-brief[data-v-a6d8d51e]{font-family:Barlow,sans-serif}@media (min-width:1024px){.person-header .person-brief[data-v-a6d8d51e]{font-size:2rem;line-height:2.5rem}}@media (min-width:0) and (max-width:1023px){.person-header .person-brief[data-v-a6d8d51e]{font-size:1.375rem;line-height:1.75rem}}.pane-list[data-v-a6d8d51e]{padding-left:1.25rem}.pane-list li[data-v-a6d8d51e]{padding-left:.75rem;margin-bottom:.9375rem}@media (min-width:1024px){.pane-list li[data-v-a6d8d51e]{font-size:1.125rem;line-height:1.5rem}}.pane-column[data-v-a6d8d51e]{padding-left:.65625rem;padding-right:.65625rem}.pane-column h3[data-v-a6d8d51e]{font-size:1.5rem;line-height:1.875rem}.panes-wrapper[data-v-a6d8d51e]:not(.overlay){max-width:1281px}@media (min-width:1024px){.panes-wrapper[data-v-a6d8d51e]:not(.overlay){padding-bottom:11.375rem}}@media (min-width:0) and (max-width:1023px){.tags-wrapper[data-v-a6d8d51e]{margin-bottom:0}}.awards-publication-pane .pane-list[data-v-a6d8d51e]{text-transform:uppercase}.random-people-pane[data-v-a6d8d51e]{background-color:#fff;padding-top:1.25rem;padding-bottom:1.25rem}@media (min-width:0) and (max-width:1023px){.random-people-pane[data-v-a6d8d51e]{margin-bottom:0}}.random-people-pane h3[data-v-a6d8d51e]{font-family:Barlow,sans-serif;color:#fc4861;line-height:2.6875rem;margin-bottom:.5rem;font-size:2.25rem}.random-people-pane .random-person[data-v-a6d8d51e]{font-family:Barlow,sans-serif;font-size:1.25rem;line-height:2.25rem;text-transform:capitalize;color:#000;font-weight:700;border-bottom:1px solid #f8008e;text-decoration:none}.quotes-pane[data-v-a6d8d51e]{padding-top:.625rem;padding-bottom:0}.quotes-pane .quote-block[data-v-a6d8d51e]{background-color:transparent}.related-articles-pane .article-level-one[data-v-a6d8d51e],.related-articles-pane[data-v-a6d8d51e]{font-family:Barlow,sans-serif}.related-articles-pane .load-more-button[data-v-a6d8d51e]{margin-top:1.9375rem}.related-articles-pane h3[data-v-a6d8d51e]{font-family:Barlow,sans-serif;margin-bottom:1.75rem}.card-video-container[data-v-a6d8d51e]{margin-bottom:1.25rem}.card-video-container[data-v-a6d8d51e] .video-container .button-wrapper.close-button-wrapper{display:none}.article-level-one[data-v-a6d8d51e]:not(.last){margin-bottom:1.75rem}.article-parent-wrapper[data-v-a6d8d51e]{background:none}.load-more-button[data-v-a6d8d51e]{font-size:.9375rem;line-height:1.625rem;display:block;background-color:#00e8ff;font-family:Barlow,sans-serif;font-weight:700;color:#000;text-align:center;text-transform:uppercase}.theme-desktop .content-wrapper[data-v-a6d8d51e]{padding-left:7.34375rem;padding-right:2.65625rem}.theme-desktop .timeline-wrapper[data-v-a6d8d51e]{padding-left:132.5px;padding-right:57.5px}.theme-desktop .panes-wrapper[data-v-a6d8d51e]{padding-left:144.5px;padding-right:69.5px}.theme-desktop .card-video-container[data-v-a6d8d51e]{margin-bottom:0}.theme-desktop .card-video-container[data-v-a6d8d51e] .card-video{margin-bottom:2.5rem}.theme-desktop .person-name[data-v-a6d8d51e]{margin-bottom:.5rem}.theme-desktop .overlay .person-header[data-v-a6d8d51e]{padding-bottom:.125rem}.theme-desktop .inner-content[data-v-a6d8d51e]{padding-top:2.53125rem}.theme-desktop .timeline-wrapper[data-v-a6d8d51e]{margin-bottom:1.875rem}.overlay .timeline-wrapper[data-v-a6d8d51e]{margin-bottom:.25rem}.overlay.theme-desktop .timeline-wrapper[data-v-a6d8d51e]{margin-bottom:.75rem}.field-section[data-v-a6d8d51e]{font-family:Barlow,sans-serif}", "", {"version":3,"sources":["/app/components/node/person/PersonBody.vue"],"names":[],"mappings":"AAgCA,wEACE,0BAA2B,AAC3B,qBAAsB,AACtB,iBAAmB,CACpB,AACD,6DACE,SAAW,CACZ,AACD,mCACE,WAAe,AACf,wBAA0B,CAC3B,AACD,8FAEI,WAAe,AACf,6BAAkC,CACrC,AAID,0BACA,+CACQ,kBAAoB,AACpB,iBAAkB,AAClB,eAAiB,CACxB,CACA,AACD,+CACI,mBAAsB,CAEzB,AACD,4DACM,qBAAuB,CAC5B,AACD,0BACA,+CACQ,oBAAsB,AACtB,oBAAsB,CAC7B,CACA,AACD,gKAEI,iBAAmB,CACtB,AACD,2CACI,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,qBAAsB,AACtB,uBAAyB,CAC5B,AACD,yDACM,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,wBAAyB,AACzB,sBAAuB,AACvB,2BAA6B,CAClC,AACD,yDACM,qBAAuB,CAC5B,AACD,gEACM,8FAAuG,AACvG,qEAA6E,AAC7E,gEAAgF,AAChF,YAAa,AACb,kBAAmB,AACnB,aAAc,AACd,WAAY,AACZ,SAAU,AACV,OAAQ,AACR,OAAS,CACd,AACD,2CACI,oBAAqB,AACrB,WAAa,CAChB,AACD,mCACE,mBAAoB,AACpB,qBAAwB,CAEzB,AACD,0BACA,mCACM,sBAAwB,CAC7B,CACA,AACD,0CACE,WAAY,AACZ,cAAgB,CACjB,AACD,iCACE,2BAA6B,AAC7B,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,kCAAuC,AACvC,yBAA0B,AAC1B,gCAAiC,AACjC,2BAA4B,AAC5B,wBAAyB,AACzB,eAAgB,AAChB,qBAAsB,AACtB,aAAc,AACd,UAAY,CACb,AACD,kEACI,mBAAqB,AACrB,oBAAuB,CAC1B,AACD,4DACI,aAAe,AACf,eAAkB,CACrB,AACD,4GAEI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,yDACI,kBAAoB,AACpB,iBAAkB,AAClB,eAAkB,CACrB,AACD,oCACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,iCACE,qBAAsB,AACtB,qBAAuB,CACxB,AAKD,0BACA,gCACM,kBAAoB,CACzB,CACA,AACD,4CACA,gCACM,mBAAqB,AACrB,oBAAsB,CAC3B,CACA,AACD,iCACE,gBAAkB,AAClB,8BAAkC,AAClC,cAAe,AACf,yBAA0B,AAC1B,qBAAwB,CAGzB,AACD,0BACA,iCACM,mBAAoB,AACpB,qBAAuB,CAC5B,CACA,AACD,4CACA,iCACM,eAAgB,AAChB,qBAAuB,CAC5B,CACA,AAID,0BACA,kCACM,kBAAoB,CACzB,CACA,AACD,gCACE,yBAA0B,AAC1B,qBAAsB,AACtB,iBAAkB,AAClB,UAAe,CAEhB,AACD,0BACA,gCACM,uBAA0B,CAC/B,CACA,AACD,yCACI,sBAAuB,AACvB,4BAA6B,AAC7B,wBAA4B,AAC5B,eAAiB,CACpB,AACD,4CACI,yBAA0B,AAC1B,qBAAuB,AACvB,cAAe,AACf,eAAkB,CAGrB,AACD,0BACA,4CACQ,kBAAmB,AACnB,kBAAoB,CAC3B,CACA,AACD,4CACA,4CACQ,kBAAoB,AACpB,gBAAkB,CACzB,CACA,AACD,6CACI,WAAe,AACf,gBAAoB,AACpB,8BAAgC,AAChC,yBAA0B,AAC1B,oBAAuB,CAG1B,AACD,0BACA,6CACQ,mBAAoB,AACpB,oBAAsB,CAC7B,CACA,AACD,4CACA,6CACQ,iBAAkB,AAClB,kBAAoB,CAC3B,CACA,AACD,kDACM,YAAa,AACb,iBAAmB,CACxB,AACD,8CACI,6BAAkC,CAGrC,AACD,0BACA,8CACQ,eAAgB,AAChB,kBAAoB,CAC3B,CACA,AACD,4CACA,8CACQ,mBAAoB,AACpB,mBAAqB,CAC5B,CACA,AACD,4BACE,oBAAsB,CACvB,AACD,+BACI,oBAAsB,AACtB,sBAAyB,CAE5B,AACD,0BACA,+BACQ,mBAAoB,AACpB,kBAAoB,CAC3B,CACA,AACD,8BACE,uBAAyB,AACzB,uBAA0B,CAC3B,AACD,iCACI,iBAAkB,AAClB,oBAAsB,CACzB,AACD,8CACE,gBAA+B,CAEhC,AACD,0BACA,8CACM,wBAA0B,CAC/B,CACA,AAID,4CACA,+BACM,eAAiB,CACtB,CACA,AACD,qDACE,wBAA0B,CAC3B,AACD,qCACE,sBAA0B,AAC1B,oBAAqB,AACrB,sBAAwB,CAEzB,AACD,4CACA,qCACM,eAAiB,CACtB,CACA,AACD,wCACI,8BAAkC,AAClC,cAAe,AACf,sBAAuB,AACvB,oBAAsB,AACtB,iBAAmB,CACtB,AACD,oDACI,8BAAkC,AAClC,kBAAmB,AACnB,oBAAqB,AACrB,0BAA2B,AAC3B,WAAe,AACf,gBAAkB,AAClB,gCAAiC,AACjC,oBAAsB,CACzB,AACD,8BACE,oBAAsB,AACtB,gBAAkB,CACnB,AACD,2CACI,4BAA8B,CACjC,AAID,mGACI,6BAAkC,CACrC,AACD,0DACI,oBAAsB,CACzB,AACD,2CACI,8BAAkC,AAClC,qBAAuB,CAC1B,AACD,uCACE,qBAAuB,CACxB,AACD,6FACI,YAAc,CACjB,AACD,+CACE,qBAAuB,CACxB,AACD,yCACE,eAAiB,CAClB,AACD,mCACE,mBAAqB,AACrB,qBAAsB,AACtB,cAAe,AACf,yBAA0B,AAC1B,8BAAkC,AAClC,gBAAkB,AAClB,WAAe,AACf,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,iDACE,wBAAyB,AACzB,wBAA0B,CAC3B,AACD,kDACE,qBAAmC,AACnC,oBAAmC,CACpC,AACD,+CACE,qBAAmC,AACnC,oBAAmC,CACpC,AACD,sDACE,eAAiB,CAClB,AACD,kEACI,oBAAsB,CACzB,AACD,6CACE,mBAAsB,CACvB,AACD,wDACE,sBAAyB,CAC1B,AACD,+CACE,sBAAwB,CACzB,AACD,kDACE,sBAAwB,CACzB,AACD,4CACE,oBAAuB,CACxB,AACD,0DACE,oBAAuB,CACxB,AACD,gCACE,6BAAkC,CACnC","file":"PersonBody.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.list-enter-active[data-v-a6d8d51e], .list-leave-active[data-v-a6d8d51e] {\n  -webkit-transition: all 1s;\n  -o-transition: all 1s;\n  transition: all 1s;\n}\n.list-enter[data-v-a6d8d51e], .list-leave-to[data-v-a6d8d51e] {\n  opacity: 0;\n}\n.node-type-person[data-v-a6d8d51e] {\n  color: #FFFFFF;\n  background-color: #0A3765;\n}\n.node-type-person .field-date[data-v-a6d8d51e],\n  .node-type-person .share-pane[data-v-a6d8d51e] {\n    color: #FFFFFF;\n    font-family: \"Barlow\", sans-serif;\n}\n.node-type-person .field-date[data-v-a6d8d51e] {\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-person .field-date[data-v-a6d8d51e] {\n        font-size: 0.875rem;\n        line-height: 1rem;\n        text-align: left;\n}\n}\n.node-type-person .share-pane[data-v-a6d8d51e] {\n    padding-top: 0.625rem;\n    /* Mobile breakpoints */\n}\n.node-type-person .share-pane .share-count[data-v-a6d8d51e] {\n      margin-bottom: 1.25rem;\n}\n@media (min-width: 1024px) {\n.node-type-person .share-pane[data-v-a6d8d51e] {\n        padding-top: 0.375rem;\n        margin-bottom: 2.5rem;\n}\n}\n.node-type-person[data-v-a6d8d51e]:not(.overlay) .tl-skinny .tl-slidenav-next,\n  .node-type-person[data-v-a6d8d51e]:not(.overlay) .tl-skinny .tl-slidenav-previous {\n    visibility: hidden;\n}\n.node-type-person.overlay[data-v-a6d8d51e] {\n    width: 100%;\n    min-height: 100%;\n    height: auto;\n    padding-top: 3.125rem;\n    padding-bottom: 3.125rem;\n}\n.node-type-person.overlay .image-holder[data-v-a6d8d51e] {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-position: 50%;\n      background-size: cover;\n      background-repeat: no-repeat;\n}\n.node-type-person.overlay.theme-desktop[data-v-a6d8d51e] {\n      padding-top: 4.6875rem;\n}\n.node-type-person.overlay .person-header[data-v-a6d8d51e]::after {\n      background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.5)));\n      background: -o-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.5) 100%);\n      background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.5) 100%);\n      content: \" \";\n      position: absolute;\n      height: 25rem;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n      right: 0;\n}\n.node-type-person .loader[data-v-a6d8d51e] {\n    padding-top: 1.25rem;\n    height: auto;\n}\n.timeline-wrapper[data-v-a6d8d51e] {\n  max-width: 78.75rem;\n  margin-bottom: 0.625rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.timeline-wrapper[data-v-a6d8d51e] {\n      margin-bottom: 6.875rem;\n}\n}\n.prevent-article-swiping[data-v-a6d8d51e] {\n  width: 100%;\n  position: fixed;\n}\n.overlay-header[data-v-a6d8d51e] {\n  padding: 1rem 1rem 0.9375rem;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-bottom: 0.0625rem solid #000000;\n  background-color: #002E3E;\n  -webkit-transition: all .5s ease;\n  -o-transition: all .5s ease;\n  transition: all .5s ease;\n  position: fixed;\n  background-color: red;\n  z-index: 1200;\n  width: 100%;\n}\n.overlay-header.collapse .overlay-header-section[data-v-a6d8d51e] {\n    font-size: 0.6875rem;\n    line-height: 0.8125rem;\n}\n.overlay-header.collapse .overlay-back-btn[data-v-a6d8d51e] {\n    width: 0.75rem;\n    height: 0.6875rem;\n}\n.overlay-header .overlay-back-btn[data-v-a6d8d51e],\n  .overlay-header .overlay-header-section[data-v-a6d8d51e] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.overlay-header .overlay-header-section[data-v-a6d8d51e] {\n    font-size: 0.875rem;\n    line-height: 1rem;\n    font-weight: bold;\n}\n.no-article-gutter[data-v-a6d8d51e] {\n  margin-left: -1.25rem;\n  margin-right: -1.25rem;\n}\n.article-gutter[data-v-a6d8d51e] {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.inner-content[data-v-a6d8d51e] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.inner-content[data-v-a6d8d51e] {\n      padding-top: 2.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.inner-content[data-v-a6d8d51e] {\n      padding-top: 0.75rem;\n      margin-bottom: 2.5rem;\n}\n}\n.attr-label-tag[data-v-a6d8d51e] {\n  font-weight: bold;\n  font-family: \"Barlow\", sans-serif;\n  color: #5A9CB5;\n  text-transform: uppercase;\n  margin-bottom: 0.375rem;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.attr-label-tag[data-v-a6d8d51e] {\n      font-size: 1.125rem;\n      line-height: 1.3125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.attr-label-tag[data-v-a6d8d51e] {\n      font-size: 1rem;\n      line-height: 1.1875rem;\n}\n}\n.content-wrapper[data-v-a6d8d51e] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.content-wrapper[data-v-a6d8d51e] {\n      max-width: 43.75rem;\n}\n}\n.person-header[data-v-a6d8d51e] {\n  background-color: #012b55;\n  padding-top: 2.125rem;\n  padding-bottom: 0;\n  color: #FFFFFF;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.person-header[data-v-a6d8d51e] {\n      padding-bottom: 0.6875rem;\n}\n}\n.person-header.hasCover[data-v-a6d8d51e] {\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    padding-top: 72%;\n}\n.person-header .node-label[data-v-a6d8d51e] {\n    text-transform: uppercase;\n    margin-bottom: 0.25rem;\n    color: #FC4861;\n    font-weight: bold;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.person-header .node-label[data-v-a6d8d51e] {\n        font-size: 1.25rem;\n        line-height: 1.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.person-header .node-label[data-v-a6d8d51e] {\n        font-size: 0.875rem;\n        line-height: 1rem;\n}\n}\n.person-header .person-name[data-v-a6d8d51e] {\n    color: #FFFFFF;\n    font-weight: normal;\n    font-family: Bungee, sans-serif;\n    text-transform: uppercase;\n    margin-bottom: 0.25rem;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.person-header .person-name[data-v-a6d8d51e] {\n        font-size: 3.125rem;\n        line-height: 3.125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.person-header .person-name[data-v-a6d8d51e] {\n        font-size: 2.5rem;\n        line-height: 2.5rem;\n}\n}\n.person-header .person-name span[data-v-a6d8d51e] {\n      font-size: 0;\n      color: transparent;\n}\n.person-header .person-brief[data-v-a6d8d51e] {\n    font-family: \"Barlow\", sans-serif;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.person-header .person-brief[data-v-a6d8d51e] {\n        font-size: 2rem;\n        line-height: 2.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.person-header .person-brief[data-v-a6d8d51e] {\n        font-size: 1.375rem;\n        line-height: 1.75rem;\n}\n}\n.pane-list[data-v-a6d8d51e] {\n  padding-left: 1.25rem;\n}\n.pane-list li[data-v-a6d8d51e] {\n    padding-left: 0.75rem;\n    margin-bottom: 0.9375rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pane-list li[data-v-a6d8d51e] {\n        font-size: 1.125rem;\n        line-height: 1.5rem;\n}\n}\n.pane-column[data-v-a6d8d51e] {\n  padding-left: 0.65625rem;\n  padding-right: 0.65625rem;\n}\n.pane-column h3[data-v-a6d8d51e] {\n    font-size: 1.5rem;\n    line-height: 1.875rem;\n}\n.panes-wrapper[data-v-a6d8d51e]:not(.overlay) {\n  max-width: calc(1260px + 21px);\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.panes-wrapper[data-v-a6d8d51e]:not(.overlay) {\n      padding-bottom: 11.375rem;\n}\n}\n.tags-wrapper[data-v-a6d8d51e] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tags-wrapper[data-v-a6d8d51e] {\n      margin-bottom: 0;\n}\n}\n.awards-publication-pane .pane-list[data-v-a6d8d51e] {\n  text-transform: uppercase;\n}\n.random-people-pane[data-v-a6d8d51e] {\n  background-color: #FFFFFF;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.random-people-pane[data-v-a6d8d51e] {\n      margin-bottom: 0;\n}\n}\n.random-people-pane h3[data-v-a6d8d51e] {\n    font-family: \"Barlow\", sans-serif;\n    color: #FC4861;\n    line-height: 2.6875rem;\n    margin-bottom: 0.5rem;\n    font-size: 2.25rem;\n}\n.random-people-pane .random-person[data-v-a6d8d51e] {\n    font-family: \"Barlow\", sans-serif;\n    font-size: 1.25rem;\n    line-height: 2.25rem;\n    text-transform: capitalize;\n    color: #000000;\n    font-weight: bold;\n    border-bottom: 1px solid #F8008E;\n    text-decoration: none;\n}\n.quotes-pane[data-v-a6d8d51e] {\n  padding-top: 0.625rem;\n  padding-bottom: 0;\n}\n.quotes-pane .quote-block[data-v-a6d8d51e] {\n    background-color: transparent;\n}\n.related-articles-pane[data-v-a6d8d51e] {\n  font-family: \"Barlow\", sans-serif;\n}\n.related-articles-pane .article-level-one[data-v-a6d8d51e] {\n    font-family: \"Barlow\", sans-serif;\n}\n.related-articles-pane .load-more-button[data-v-a6d8d51e] {\n    margin-top: 1.9375rem;\n}\n.related-articles-pane h3[data-v-a6d8d51e] {\n    font-family: \"Barlow\", sans-serif;\n    margin-bottom: 1.75rem;\n}\n.card-video-container[data-v-a6d8d51e] {\n  margin-bottom: 1.25rem;\n}\n.card-video-container[data-v-a6d8d51e] .video-container .button-wrapper.close-button-wrapper {\n    display: none;\n}\n.article-level-one[data-v-a6d8d51e]:not(.last) {\n  margin-bottom: 1.75rem;\n}\n.article-parent-wrapper[data-v-a6d8d51e] {\n  background: none;\n}\n.load-more-button[data-v-a6d8d51e] {\n  font-size: 0.9375rem;\n  line-height: 1.625rem;\n  display: block;\n  background-color: #00E8FF;\n  font-family: \"Barlow\", sans-serif;\n  font-weight: bold;\n  color: #000000;\n  text-align: center;\n  text-transform: uppercase;\n}\n.theme-desktop .content-wrapper[data-v-a6d8d51e] {\n  padding-left: 7.34375rem;\n  padding-right: 2.65625rem;\n}\n.theme-desktop .timeline-wrapper[data-v-a6d8d51e] {\n  padding-left: calc(117.5px + 15px);\n  padding-right: calc(42.5px + 15px);\n}\n.theme-desktop .panes-wrapper[data-v-a6d8d51e] {\n  padding-left: calc(117.5px + 27px);\n  padding-right: calc(42.5px + 27px);\n}\n.theme-desktop .card-video-container[data-v-a6d8d51e] {\n  margin-bottom: 0;\n}\n.theme-desktop .card-video-container[data-v-a6d8d51e] .card-video {\n    margin-bottom: 2.5rem;\n}\n.theme-desktop .person-name[data-v-a6d8d51e] {\n  margin-bottom: 0.5rem;\n}\n.theme-desktop .overlay .person-header[data-v-a6d8d51e] {\n  padding-bottom: 0.125rem;\n}\n.theme-desktop .inner-content[data-v-a6d8d51e] {\n  padding-top: 2.53125rem;\n}\n.theme-desktop .timeline-wrapper[data-v-a6d8d51e] {\n  margin-bottom: 1.875rem;\n}\n.overlay .timeline-wrapper[data-v-a6d8d51e] {\n  margin-bottom: 0.25rem;\n}\n.overlay.theme-desktop .timeline-wrapper[data-v-a6d8d51e] {\n  margin-bottom: 0.75rem;\n}\n.field-section[data-v-a6d8d51e] {\n  font-family: \"Barlow\", sans-serif;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".tags-title[data-v-a904b68c]{color:#002e3e;font-weight:700;font-size:1.5rem;line-height:1.5rem;text-transform:uppercase;display:inline}@media (min-width:0) and (max-width:1023px){.tags-title[data-v-a904b68c]{display:inline-block;font-size:1.25rem;vertical-align:top}}@media (min-width:0) and (max-width:1023px){.tags[data-v-a904b68c]{display:inline-block;padding-left:1rem}}.tags h5[data-v-a904b68c]{margin:0 .5rem 0 0;text-transform:lowercase;display:inline-block;font-size:1.25rem;margin-top:1rem}@media (min-width:0) and (max-width:1023px){.tags h5[data-v-a904b68c]{font-size:1.125rem;margin-top:.25rem}}.tags h5.first[data-v-a904b68c]{display:block;font-size:1.875rem;line-height:1.75rem;margin-top:1.25rem}@media (min-width:0) and (max-width:1023px){.tags h5.first[data-v-a904b68c]{font-size:1.75rem;line-height:1.25rem;margin-top:0}}.tags h5[data-v-a904b68c]:before{content:\"#\"}", "", {"version":3,"sources":["/app/components/node/Tag.vue"],"names":[],"mappings":"AAgCA,6BAEE,cAAe,AACf,gBAAkB,AAClB,iBAAkB,AAClB,mBAAoB,AACpB,yBAA0B,AAC1B,cAAgB,CACjB,AACD,4CACA,6BACM,qBAAsB,AACtB,kBAAmB,AACnB,kBAAoB,CACzB,CACA,AAID,4CACA,uBACM,qBAAsB,AACtB,iBAAmB,CACxB,CACA,AACD,0BACI,mBAAqB,AACrB,yBAA0B,AAC1B,qBAAsB,AACtB,kBAAmB,AACnB,eAAiB,CAEpB,AACD,4CACA,0BACQ,mBAAoB,AACpB,iBAAoB,CAC3B,CACA,AACD,gCACM,cAAe,AACf,mBAAoB,AACpB,oBAAqB,AACrB,kBAAoB,CAEzB,AACD,4CACA,gCACU,kBAAmB,AACnB,oBAAqB,AACrB,YAAc,CACvB,CACA,AACD,iCACM,WAAa,CAClB","file":"Tag.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.tags-title[data-v-a904b68c] {\n  /* Mobile breakpoints */\n  color: #002E3E;\n  font-weight: bold;\n  font-size: 1.5rem;\n  line-height: 1.5rem;\n  text-transform: uppercase;\n  display: inline;\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tags-title[data-v-a904b68c] {\n      display: inline-block;\n      font-size: 1.25rem;\n      vertical-align: top;\n}\n}\n.tags[data-v-a904b68c] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tags[data-v-a904b68c] {\n      display: inline-block;\n      padding-left: 1rem;\n}\n}\n.tags h5[data-v-a904b68c] {\n    margin: 0 0.5rem 0 0;\n    text-transform: lowercase;\n    display: inline-block;\n    font-size: 1.25rem;\n    margin-top: 1rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tags h5[data-v-a904b68c] {\n        font-size: 1.125rem;\n        margin-top: 0.25rem;\n}\n}\n.tags h5.first[data-v-a904b68c] {\n      display: block;\n      font-size: 1.875rem;\n      line-height: 1.75rem;\n      margin-top: 1.25rem;\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.tags h5.first[data-v-a904b68c] {\n          font-size: 1.75rem;\n          line-height: 1.25rem;\n          margin-top: 0;\n}\n}\n.tags h5[data-v-a904b68c]:before {\n      content: '#';\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".count-down[data-v-c0028458]{-webkit-font-smoothing:antialiased;font-family:Barlow,sans-serif;line-height:1;color:#f8008e;background:#00e8ff;min-height:8rem;max-width:23.4375rem;padding:1rem 1.1875rem 1.25rem;margin-left:auto;margin-right:auto}.count-down .header[data-v-c0028458]{font-size:1rem;color:#f8008e;font-weight:700;line-height:1.1875rem;margin-bottom:.25rem}.count-down .title[data-v-c0028458]{margin-bottom:.625rem;color:#000;font-family:Bungee,sans-serif;font-size:1.75rem;line-height:1.75rem}.count-down .count-number .block[data-v-c0028458]{width:3.125rem}.count-down .count-number .block .text[data-v-c0028458]{font-size:.5rem;font-weight:700;line-height:.625rem}.count-down .count-number .block .digit[data-v-c0028458]{font-size:1.375rem;line-height:1.625rem;margin-bottom:.125rem}.count-down .product-review-btn[data-v-c0028458]{cursor:pointer;font-size:1.125rem;line-height:1.375rem;text-transform:uppercase;color:#fff;display:inline-block;background-color:#f8008e;margin-top:.6875rem;padding:.625rem;width:100%;max-width:20.0625rem}.count-down .product-review-btn[data-v-c0028458]:active,.count-down .product-review-btn[data-v-c0028458]:focus,.count-down .product-review-btn[data-v-c0028458]:hover{color:#fff}.count-down--expired .title[data-v-c0028458]{margin-bottom:.5rem}.count-down--expired .expired__text[data-v-c0028458]{font-size:1.25rem;line-height:1.5rem}.count-down--expired .expired__date[data-v-c0028458]{font-size:1.5rem;line-height:1.8125rem}.isCountdownCard .count-down[data-v-c0028458]{position:absolute;left:0;right:0;bottom:0;background:rgba(0,0,0,.7);color:#f8008e;z-index:1;max-width:none;padding:1.25rem .3125rem 4.375rem}@media (min-width:0) and (max-width:1023px){.isCountdownCard .count-down[data-v-c0028458]{z-index:10}}@media (orientation:landscape),screen and (min-width:1024px){.isCountdownCard .count-down[data-v-c0028458]{padding:1.25rem 0 1.6875rem;font-size:1.75rem}}.isCountdownCard .count-down>.header[data-v-c0028458]{font-size:1rem;line-height:.9375rem;margin-bottom:.375rem;color:#fff}@media (orientation:landscape),screen and (min-width:1024px){.isCountdownCard .count-down>.header[data-v-c0028458]{font-size:1.75rem;line-height:1.4375rem;margin-bottom:.625rem}}.isCountdownCard .count-down>.product-review-btn[data-v-c0028458],.isCountdownCard .count-down>.title[data-v-c0028458]{display:none}@media (orientation:landscape),screen and (min-width:1024px){.isCountdownCard .count-down .count-number .block[data-v-c0028458]{width:4rem;margin-bottom:.125rem}}.isCountdownCard .count-down .count-number .block .text[data-v-c0028458]{font-size:.5rem;line-height:.5625rem;margin-bottom:.125rem;font-weight:700}@media (orientation:landscape),screen and (min-width:1024px){.isCountdownCard .count-down .count-number .block .text[data-v-c0028458]{font-size:.75rem;line-height:.875rem;height:auto}}@media (orientation:landscape),screen and (min-width:1024px){.isCountdownCard .count-down .count-number .block .digit[data-v-c0028458]{font-size:2.125rem;line-height:2.5rem;height:auto;margin-bottom:.25rem}}.isCountdownCard .count-down--expired[data-v-c0028458]{display:none}", "", {"version":3,"sources":["/app/components/widgets/CountDown.vue"],"names":[],"mappings":"AAgCA,6BACE,mCAAoC,AACpC,8BAAkC,AAClC,cAAe,AACf,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,qBAAsB,AACtB,+BAA0C,AAC1C,iBAAkB,AAClB,iBAAmB,CACpB,AACD,qCACI,eAAgB,AAChB,cAAe,AACf,gBAAkB,AAClB,sBAAuB,AACvB,oBAAuB,CAC1B,AACD,oCACI,sBAAwB,AACxB,WAAe,AACf,8BAAgC,AAChC,kBAAmB,AACnB,mBAAqB,CACxB,AACD,kDACI,cAAgB,CACnB,AACD,wDACM,gBAAkB,AAClB,gBAAkB,AAClB,mBAAsB,CAC3B,AACD,yDACM,mBAAoB,AACpB,qBAAsB,AACtB,qBAAwB,CAC7B,AACD,iDACI,eAAgB,AAChB,mBAAoB,AACpB,qBAAsB,AACtB,yBAA0B,AAC1B,WAAe,AACf,qBAAsB,AACtB,yBAA0B,AAC1B,oBAAsB,AACtB,gBAA2B,AAC3B,WAAY,AACZ,oBAAsB,CACzB,AACD,sKACM,UAAe,CACpB,AACD,6CACI,mBAAsB,CACzB,AACD,qDACI,kBAAmB,AACnB,kBAAoB,CACvB,AACD,qDACI,iBAAkB,AAClB,qBAAuB,CAC1B,AACD,8CACI,kBAAmB,AACnB,OAAQ,AACR,QAAS,AACT,SAAU,AACV,0BAA+B,AAC/B,cAAe,AACf,UAAW,AACX,eAAgB,AAChB,iCAAoC,CAGvC,AACD,4CACA,8CACQ,UAAY,CACnB,CACA,AACD,6DACA,8CACQ,4BAA+B,AAC/B,iBAAmB,CAC1B,CACA,AACD,sDACM,eAAgB,AAChB,qBAAuB,AACvB,sBAAwB,AAExB,UAAe,CACpB,AACD,6DACA,sDACU,kBAAmB,AACnB,sBAAuB,AACvB,qBAAwB,CACjC,CACA,AAID,uHACM,YAAc,CACnB,AAID,6DACA,mEACU,WAAY,AACZ,qBAAwB,CACjC,CACA,AACD,yEACQ,gBAAkB,AAClB,qBAAuB,AACvB,sBAAwB,AAExB,eAAkB,CACzB,AACD,6DACA,yEACY,iBAAmB,AACnB,oBAAsB,AACtB,WAAa,CACxB,CACA,AAID,6DACA,0EACY,mBAAoB,AACpB,mBAAoB,AACpB,YAAa,AACb,oBAAuB,CAClC,CACA,AACD,uDACM,YAAc,CACnB","file":"CountDown.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.count-down[data-v-c0028458] {\n  -webkit-font-smoothing: antialiased;\n  font-family: \"Barlow\", sans-serif;\n  line-height: 1;\n  color: #F8008E;\n  background: #00E8FF;\n  min-height: 8rem;\n  max-width: 23.4375rem;\n  padding: 1rem 1.1875rem 1.25rem 1.1875rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n.count-down .header[data-v-c0028458] {\n    font-size: 1rem;\n    color: #F8008E;\n    font-weight: bold;\n    line-height: 1.1875rem;\n    margin-bottom: 0.25rem;\n}\n.count-down .title[data-v-c0028458] {\n    margin-bottom: 0.625rem;\n    color: #000000;\n    font-family: Bungee, sans-serif;\n    font-size: 1.75rem;\n    line-height: 1.75rem;\n}\n.count-down .count-number .block[data-v-c0028458] {\n    width: 3.125rem;\n}\n.count-down .count-number .block .text[data-v-c0028458] {\n      font-size: 0.5rem;\n      font-weight: bold;\n      line-height: 0.625rem;\n}\n.count-down .count-number .block .digit[data-v-c0028458] {\n      font-size: 1.375rem;\n      line-height: 1.625rem;\n      margin-bottom: 0.125rem;\n}\n.count-down .product-review-btn[data-v-c0028458] {\n    cursor: pointer;\n    font-size: 1.125rem;\n    line-height: 1.375rem;\n    text-transform: uppercase;\n    color: #FFFFFF;\n    display: inline-block;\n    background-color: #F8008E;\n    margin-top: 0.6875rem;\n    padding: 0.625rem 0.625rem;\n    width: 100%;\n    max-width: 20.0625rem;\n}\n.count-down .product-review-btn[data-v-c0028458]:hover, .count-down .product-review-btn[data-v-c0028458]:focus, .count-down .product-review-btn[data-v-c0028458]:active {\n      color: #FFFFFF;\n}\n.count-down--expired .title[data-v-c0028458] {\n    margin-bottom: 0.5rem;\n}\n.count-down--expired .expired__text[data-v-c0028458] {\n    font-size: 1.25rem;\n    line-height: 1.5rem;\n}\n.count-down--expired .expired__date[data-v-c0028458] {\n    font-size: 1.5rem;\n    line-height: 1.8125rem;\n}\n.isCountdownCard .count-down[data-v-c0028458] {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    color: #F8008E;\n    z-index: 1;\n    max-width: none;\n    padding: 1.25rem 0.3125rem 4.375rem;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.isCountdownCard .count-down[data-v-c0028458] {\n        z-index: 10;\n}\n}\n@media screen and (min-width: 1024px), (orientation: landscape) {\n.isCountdownCard .count-down[data-v-c0028458] {\n        padding: 1.25rem 0 1.6875rem 0;\n        font-size: 1.75rem;\n}\n}\n.isCountdownCard .count-down > .header[data-v-c0028458] {\n      font-size: 1rem;\n      line-height: 0.9375rem;\n      margin-bottom: 0.375rem;\n      /* Mobile breakpoints */\n      color: #FFFFFF;\n}\n@media screen and (min-width: 1024px), (orientation: landscape) {\n.isCountdownCard .count-down > .header[data-v-c0028458] {\n          font-size: 1.75rem;\n          line-height: 1.4375rem;\n          margin-bottom: 0.625rem;\n}\n}\n.isCountdownCard .count-down > .title[data-v-c0028458] {\n      display: none;\n}\n.isCountdownCard .count-down > .product-review-btn[data-v-c0028458] {\n      display: none;\n}\n.isCountdownCard .count-down .count-number .block[data-v-c0028458] {\n      /* Mobile breakpoints */\n}\n@media screen and (min-width: 1024px), (orientation: landscape) {\n.isCountdownCard .count-down .count-number .block[data-v-c0028458] {\n          width: 4rem;\n          margin-bottom: 0.125rem;\n}\n}\n.isCountdownCard .count-down .count-number .block .text[data-v-c0028458] {\n        font-size: 0.5rem;\n        line-height: 0.5625rem;\n        margin-bottom: 0.125rem;\n        /* Mobile breakpoints */\n        font-weight: bold;\n}\n@media screen and (min-width: 1024px), (orientation: landscape) {\n.isCountdownCard .count-down .count-number .block .text[data-v-c0028458] {\n            font-size: 0.75rem;\n            line-height: 0.875rem;\n            height: auto;\n}\n}\n.isCountdownCard .count-down .count-number .block .digit[data-v-c0028458] {\n        /* Mobile breakpoints */\n}\n@media screen and (min-width: 1024px), (orientation: landscape) {\n.isCountdownCard .count-down .count-number .block .digit[data-v-c0028458] {\n            font-size: 2.125rem;\n            line-height: 2.5rem;\n            height: auto;\n            margin-bottom: 0.25rem;\n}\n}\n.isCountdownCard .count-down--expired[data-v-c0028458] {\n      display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".card-cover{background:#000}.card-cover .progressive-image{background-image:none}.card-cover .blur-image{-webkit-transition:opacity 1s;-o-transition:opacity 1s;transition:opacity 1s;-webkit-transition-delay:6s;-o-transition-delay:6s;transition-delay:6s;opacity:1;-webkit-filter:url(\"#blur-effect--20\");filter:url(\"#blur-effect--20\");overflow:hidden}.card-cover .blur-image,.card-cover .loaded-image{width:100%;height:100%;position:absolute;left:0;top:0}.card-cover .loaded-image{opacity:0;-webkit-transition:opacity 2s ease-in-out;-o-transition:opacity 2s ease-in-out;transition:opacity 2s ease-in-out}.card-cover .lazyload:not(.loaded){-webkit-filter:url(\"#blur-effect--20\");filter:url(\"#blur-effect--20\")}.card-cover [data-card]>*{border:none!important}.card-cover [data-type=text]{height:auto!important}.card-cover .loaded.lazyload{background-image:none!important}.card-cover .loaded.lazyload .blur-image{opacity:0}@media (min-width:0) and (max-width:1023px){.card-cover .article-cover-card-wrapper,.card-cover .article-cover-card-wrapper .card-container{height:100vh;height:var(--window-height,100vh)}.card-cover .mobile-height-wrap{position:absolute;top:50%;height:559px;width:375px;-webkit-transform-origin:top left;-ms-transform-origin:top left;transform-origin:top left;z-index:3;will-change:transform}}@media (orientation:landscape),screen and (min-width:1024px){.card-cover .article-cover-card-wrapper{height:56.25vw;height:calc(var(--window-height, 100vh) * 56.25 / 100);min-height:56.25vw}.card-cover .article-cover-card-wrapper .card-container{height:810px;width:1440px;top:0;left:0;-webkit-transform-origin:top left;-ms-transform-origin:top left;transform-origin:top left}.card-cover .mobile-height-wrap{position:static;height:auto;top:auto;left:auto;-webkit-transform:none!important;-ms-transform:none!important;transform:none!important;-webkit-transform-origin:none!important;-ms-transform-origin:none!important;transform-origin:none!important;margin-top:0!important}}", "", {"version":3,"sources":["/app/components/node/CardCover.vue"],"names":[],"mappings":"AAgCA,YACE,eAAoB,CAGrB,AACD,+BACI,qBAAuB,CAC1B,AACD,wBAGI,8BAA+B,AAC/B,yBAA0B,AAC1B,sBAAuB,AACvB,4BAA6B,AACxB,uBAAwB,AACrB,oBAAqB,AAC7B,UAAW,AAMX,uCAAwC,AAChC,+BAAgC,AACxC,eAAiB,CACpB,AACD,kDATI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,OAAS,AACT,KAAQ,CAeX,AAVD,0BACI,UAAW,AAMX,0CAA2C,AAC3C,qCAAsC,AACtC,iCAAmC,CACtC,AACD,mCACI,uCAAwC,AAChC,8BAAgC,CAC3C,AACD,0BACI,qBAAwB,CAC3B,AACD,6BACI,qBAAwB,CAC3B,AACD,6BACI,+BAAkC,CACrC,AACD,yCACM,SAAW,CAChB,AACD,4CAKA,gGACQ,aAAc,AACd,iCAAoC,CAC3C,AACD,gCACM,kBAAmB,AACnB,QAAS,AACT,aAAc,AAEd,YAAa,AACb,kCAAmC,AAC/B,8BAA+B,AAC3B,0BAA2B,AACnC,UAAW,AACX,qBAAuB,CAC5B,CACA,AACD,6DACA,wCACM,eAAgB,AAChB,uDAAwD,AACxD,kBAAoB,CACzB,AACD,wDACQ,aAAc,AACd,aAAc,AACd,MAAO,AACP,OAAQ,AACR,kCAAmC,AAC/B,8BAA+B,AAC3B,yBAA2B,CAC1C,AACD,gCACM,gBAAiB,AACjB,YAAa,AACb,SAAU,AACV,UAAW,AACX,iCAAmC,AAC/B,6BAA+B,AAC3B,yBAA2B,AACnC,wCAA0C,AACtC,oCAAsC,AAClC,gCAAkC,AAC1C,sBAAyB,CAC9B,CACA","file":"CardCover.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.card-cover {\n  background: #000000;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n.card-cover .progressive-image {\n    background-image: none;\n}\n.card-cover .blur-image {\n    width: 100%;\n    height: 100%;\n    -webkit-transition: opacity 1s;\n    -o-transition: opacity 1s;\n    transition: opacity 1s;\n    -webkit-transition-delay: 6s;\n         -o-transition-delay: 6s;\n            transition-delay: 6s;\n    opacity: 1;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0%;\n    top: 0%;\n    -webkit-filter: url(\"#blur-effect--20\");\n            filter: url(\"#blur-effect--20\");\n    overflow: hidden;\n}\n.card-cover .loaded-image {\n    opacity: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    -webkit-transition: opacity 2s ease-in-out;\n    -o-transition: opacity 2s ease-in-out;\n    transition: opacity 2s ease-in-out;\n}\n.card-cover .lazyload:not(.loaded) {\n    -webkit-filter: url(\"#blur-effect--20\");\n            filter: url(\"#blur-effect--20\");\n}\n.card-cover [data-card] > * {\n    border: none !important;\n}\n.card-cover [data-type=\"text\"] {\n    height: auto !important;\n}\n.card-cover .loaded.lazyload {\n    background-image: none !important;\n}\n.card-cover .loaded.lazyload .blur-image {\n      opacity: 0;\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.card-cover .article-cover-card-wrapper {\n      height: 100vh;\n      height: var(--window-height, 100vh);\n}\n.card-cover .article-cover-card-wrapper .card-container {\n        height: 100vh;\n        height: var(--window-height, 100vh);\n}\n.card-cover .mobile-height-wrap {\n      position: absolute;\n      top: 50%;\n      height: 559px;\n      /*height: 100vh;*/\n      width: 375px;\n      -webkit-transform-origin: top left;\n          -ms-transform-origin: top left;\n              transform-origin: top left;\n      z-index: 3;\n      will-change: transform;\n}\n}\n@media screen and (min-width: 1024px), (orientation: landscape) {\n.card-cover .article-cover-card-wrapper {\n      height: 56.25vw;\n      height: calc(var(--window-height, 100vh) * 56.25 / 100);\n      min-height: 56.25vw;\n}\n.card-cover .article-cover-card-wrapper .card-container {\n        height: 810px;\n        width: 1440px;\n        top: 0;\n        left: 0;\n        -webkit-transform-origin: top left;\n            -ms-transform-origin: top left;\n                transform-origin: top left;\n}\n.card-cover .mobile-height-wrap {\n      position: static;\n      height: auto;\n      top: auto;\n      left: auto;\n      -webkit-transform: none !important;\n          -ms-transform: none !important;\n              transform: none !important;\n      -webkit-transform-origin: none !important;\n          -ms-transform-origin: none !important;\n              transform-origin: none !important;\n      margin-top: 0 !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".card-cover[data-v-caa199b2]{width:100vw;border:0;border-radius:0;overflow:hidden;position:relative;-webkit-transform:translateZ(0);transform:translateZ(0)}@media (min-width:0) and (max-width:1023px){.card-cover[data-v-caa199b2]{height:100vh;height:var(--window-height,100vh)}}.card-cover .play-button svg[data-v-caa199b2]{width:4.375rem;height:4.375rem}@media (orientation:landscape),screen and (min-width:1024px){.card-cover .button-wrapper[data-v-caa199b2],.card-cover[data-v-caa199b2]{height:56.25vw}.card-cover .play-button[data-v-caa199b2]{cursor:pointer}.card-cover .play-button svg[data-v-caa199b2]{width:9.722vw;height:9.722vw;max-height:8.75rem;max-width:8.75rem}}.card-cover .button-wrapper[data-v-caa199b2]{z-index:9999;width:100vw;position:absolute;top:0}.card-cover .button-wrapper.play-button-wrapper[data-v-caa199b2]{display:inline;height:auto;width:auto;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@media (min-width:1024px){.card-cover .button-wrapper[data-v-caa199b2]{height:56.25vw}}@media (min-width:0) and (max-width:1023px){.card-cover .button-wrapper[data-v-caa199b2]{height:100vh}}.card-cover .card-action[data-v-caa199b2]{position:absolute;z-index:13;left:50%;width:0;height:0;border-style:solid;border-width:0 3.4375rem 3.4375rem;border-color:transparent transparent rgba(0,0,0,.7);-webkit-transform:translate(-50%);-ms-transform:translate(-50%);transform:translate(-50%)}@media (min-width:1024px){.card-cover .card-action[data-v-caa199b2]{display:none}}.card-cover .card-action[data-v-caa199b2]:not(.cardInvisible){bottom:0}.card-cover .card-action.cardInvisible[data-v-caa199b2]{bottom:-3.4375rem}.card-cover .card-action.cardInvisible.up[data-v-caa199b2]{-webkit-animation:cardActionAnimate-data-v-caa199b2 .2s;animation:cardActionAnimate-data-v-caa199b2 .2s;bottom:0}.card-cover .card-action .card-action-icon-wrapper[data-v-caa199b2]{-webkit-animation:arrowupdown-data-v-caa199b2 1s;animation:arrowupdown-data-v-caa199b2 1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.card-cover .card-action svg[data-v-caa199b2]{fill:#fff;top:.75rem;width:1.3125rem;height:1.1875rem}.card-cover .card-action .card-action-text[data-v-caa199b2],.card-cover .card-action svg[data-v-caa199b2]{position:absolute;-webkit-transform:translate(-50%);-ms-transform:translate(-50%);transform:translate(-50%);left:50%}.card-cover .card-action .card-action-text[data-v-caa199b2]{color:#fff;text-transform:uppercase;font:700 .75rem Barlow,sans-serif;top:2.25rem}@-webkit-keyframes arrowupdown{0%{-webkit-transform:translate(-50%,-2px);transform:translate(-50%,-2px)}50%{-webkit-transform:translate(-50%,2px);transform:translate(-50%,2px)}to{-webkit-transform:translate(-50%,-2px);transform:translate(-50%,-2px)}}@keyframes arrowupdown-data-v-caa199b2{0%{-webkit-transform:translate(-50%,-2px);transform:translate(-50%,-2px)}50%{-webkit-transform:translate(-50%,2px);transform:translate(-50%,2px)}to{-webkit-transform:translate(-50%,-2px);transform:translate(-50%,-2px)}}@-webkit-keyframes cardActionAnimate{0%{bottom:-3.4375rem}to{bottom:0}}@keyframes cardActionAnimate-data-v-caa199b2{0%{bottom:-3.4375rem}to{bottom:0}}", "", {"version":3,"sources":["/app/components/node/CardCover.vue"],"names":[],"mappings":"AAgCA,6BAIE,YAAa,AACb,SAAU,AACV,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,gCAAiC,AACzB,uBAAyB,CAClC,AACD,4CACA,6BACM,aAAc,AACd,iCAAoC,CACzC,CACA,AACD,8CACI,eAAgB,AAChB,eAAiB,CACpB,AACD,6DAIA,0EACQ,cAA6B,CACpC,AACD,0CACQ,cAAgB,CACvB,AACD,8CACU,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,iBAAmB,CAC5B,CACA,AACD,6CACI,aAAc,AAGd,YAAa,AACb,kBAAmB,AACnB,KAAO,CACV,AACD,iEACM,eAAgB,AAChB,YAAa,AACb,WAAY,AACZ,QAAS,AACT,SAAU,AACV,uCAAyC,AACrC,mCAAqC,AACjC,8BAAiC,CAC9C,AACD,0BACA,6CACQ,cAAgB,CACvB,CACA,AACD,4CACA,6CACQ,YAAc,CACrB,CACA,AACD,0CAEI,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,QAAS,AACT,SAAU,AACV,mBAAoB,AACpB,mCAA8C,AAC9C,oDAAqE,AACrE,kCAAsC,AAClC,8BAAkC,AAC9B,yBAA8B,CACzC,AACD,0BACA,0CACQ,YAAc,CACrB,CACA,AACD,8DACM,QAAU,CACf,AACD,wDACM,iBAAmB,CACxB,AACD,2DACQ,wDAA2D,AACnD,gDAAmD,AAC3D,QAAU,CACjB,AACD,oEACM,iDAAkD,AAC1C,yCAA0C,AAClD,2CAA4C,AACpC,kCAAoC,CACjD,AACD,8CACM,UAAW,AAMX,WAAa,AACb,gBAAiB,AACjB,gBAAkB,CACvB,AACD,0GATM,kBAAmB,AACnB,kCAAsC,AAClC,8BAAkC,AAC9B,0BAA8B,AACtC,QAAU,CAef,AAVD,4DACM,WAAY,AACZ,yBAA0B,AAC1B,kCAAwC,AAMxC,WAAa,CAClB,AACD,+BACA,GACI,uCAAyC,AACjC,8BAAiC,CAC5C,AACD,IACI,sCAAwC,AAChC,6BAAgC,CAC3C,AACD,GACI,uCAAyC,AACjC,8BAAiC,CAC5C,CACA,AACD,uCACA,GACI,uCAAyC,AACjC,8BAAiC,CAC5C,AACD,IACI,sCAAwC,AAChC,6BAAgC,CAC3C,AACD,GACI,uCAAyC,AACjC,8BAAiC,CAC5C,CACA,AACD,qCACA,GACI,iBAAmB,CACtB,AACD,GACI,QAAU,CACb,CACA,AACD,6CACA,GACI,iBAAmB,CACtB,AACD,GACI,QAAU,CACb,CACA","file":"CardCover.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.card-cover[data-v-caa199b2] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n  position: relative;\n  width: 100vw;\n  border: 0;\n  border-radius: 0;\n  overflow: hidden;\n  position: relative;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.card-cover[data-v-caa199b2] {\n      height: 100vh;\n      height: var(--window-height, 100vh);\n}\n}\n.card-cover .play-button svg[data-v-caa199b2] {\n    width: 4.375rem;\n    height: 4.375rem;\n}\n@media screen and (min-width: 1024px), (orientation: landscape) {\n.card-cover[data-v-caa199b2] {\n      height: calc(100vw * 0.5625);\n}\n.card-cover .button-wrapper[data-v-caa199b2] {\n        height: calc(100vw * 0.5625);\n}\n.card-cover .play-button[data-v-caa199b2] {\n        cursor: pointer;\n}\n.card-cover .play-button svg[data-v-caa199b2] {\n          width: 9.722vw;\n          height: 9.722vw;\n          max-height: 8.75rem;\n          max-width: 8.75rem;\n}\n}\n.card-cover .button-wrapper[data-v-caa199b2] {\n    z-index: 9999;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n    width: 100vw;\n    position: absolute;\n    top: 0;\n}\n.card-cover .button-wrapper.play-button-wrapper[data-v-caa199b2] {\n      display: inline;\n      height: auto;\n      width: auto;\n      top: 50%;\n      left: 50%;\n      -webkit-transform: translate(-50%, -50%);\n          -ms-transform: translate(-50%, -50%);\n              transform: translate(-50%, -50%);\n}\n@media (min-width: 1024px) {\n.card-cover .button-wrapper[data-v-caa199b2] {\n        height: 56.25vw;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.card-cover .button-wrapper[data-v-caa199b2] {\n        height: 100vh;\n}\n}\n.card-cover .card-action[data-v-caa199b2] {\n    /* Mobile breakpoints */\n    position: absolute;\n    z-index: 13;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 3.4375rem 3.4375rem 3.4375rem;\n    border-color: transparent transparent rgba(0, 0, 0, 0.7) transparent;\n    -webkit-transform: translate(-50%, 0);\n        -ms-transform: translate(-50%, 0);\n            transform: translate(-50%, 0);\n}\n@media (min-width: 1024px) {\n.card-cover .card-action[data-v-caa199b2] {\n        display: none;\n}\n}\n.card-cover .card-action[data-v-caa199b2]:not(.cardInvisible) {\n      bottom: 0;\n}\n.card-cover .card-action.cardInvisible[data-v-caa199b2] {\n      bottom: -3.4375rem;\n}\n.card-cover .card-action.cardInvisible.up[data-v-caa199b2] {\n        -webkit-animation: cardActionAnimate-data-v-caa199b2 200ms;\n                animation: cardActionAnimate-data-v-caa199b2 200ms;\n        bottom: 0;\n}\n.card-cover .card-action .card-action-icon-wrapper[data-v-caa199b2] {\n      -webkit-animation: arrowupdown-data-v-caa199b2 1s;\n              animation: arrowupdown-data-v-caa199b2 1s;\n      -webkit-animation-iteration-count: infinite;\n              animation-iteration-count: infinite;\n}\n.card-cover .card-action svg[data-v-caa199b2] {\n      fill: #fff;\n      position: absolute;\n      -webkit-transform: translate(-50%, 0);\n          -ms-transform: translate(-50%, 0);\n              transform: translate(-50%, 0);\n      left: 50%;\n      top: 0.75rem;\n      width: 1.3125rem;\n      height: 1.1875rem;\n}\n.card-cover .card-action .card-action-text[data-v-caa199b2] {\n      color: #fff;\n      text-transform: uppercase;\n      font: bold 0.75rem \"Barlow\", sans-serif;\n      position: absolute;\n      -webkit-transform: translate(-50%, 0);\n          -ms-transform: translate(-50%, 0);\n              transform: translate(-50%, 0);\n      left: 50%;\n      top: 2.25rem;\n}\n@-webkit-keyframes arrowupdown {\n0% {\n    -webkit-transform: translate(-50%, -2px);\n            transform: translate(-50%, -2px);\n}\n50% {\n    -webkit-transform: translate(-50%, 2px);\n            transform: translate(-50%, 2px);\n}\n100% {\n    -webkit-transform: translate(-50%, -2px);\n            transform: translate(-50%, -2px);\n}\n}\n@keyframes arrowupdown-data-v-caa199b2 {\n0% {\n    -webkit-transform: translate(-50%, -2px);\n            transform: translate(-50%, -2px);\n}\n50% {\n    -webkit-transform: translate(-50%, 2px);\n            transform: translate(-50%, 2px);\n}\n100% {\n    -webkit-transform: translate(-50%, -2px);\n            transform: translate(-50%, -2px);\n}\n}\n@-webkit-keyframes cardActionAnimate {\n0% {\n    bottom: -3.4375rem;\n}\n100% {\n    bottom: 0;\n}\n}\n@keyframes cardActionAnimate-data-v-caa199b2 {\n0% {\n    bottom: -3.4375rem;\n}\n100% {\n    bottom: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".published-date[data-v-d1889cb8]{color:#002e3e;font-size:.6875rem;line-height:.8125rem;text-align:center}", "", {"version":3,"sources":["/app/components/node/fields/Date.vue"],"names":[],"mappings":"AAgCA,iCACE,cAAe,AACf,mBAAqB,AACrB,qBAAuB,AACvB,iBAAmB,CACpB","file":"Date.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.published-date[data-v-d1889cb8] {\n  color: #002E3E;\n  font-size: 0.6875rem;\n  line-height: 0.8125rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1540:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".body-head{font-family:Barlow,sans-serif}@media (min-width:0) and (max-width:1023px){.body-head{display:none}}.body-head .head-text{font-size:1.25rem;font-weight:700;padding-bottom:.9375rem;text-transform:uppercase}.body-head .head-title{font-size:2.375rem;line-height:2.75rem;margin-bottom:1.875rem;font-weight:700}.body-head .head-subheading{margin-top:-1.0625rem;margin-bottom:2.5rem;font-size:1.5625rem;line-height:2.0625rem;color:#666}", "", {"version":3,"sources":["/app/components/node/fields/BodyHead.vue"],"names":[],"mappings":"AAgCA,WACE,6BAAkC,CAEnC,AACD,4CACA,WACM,YAAc,CACnB,CACA,AACD,sBACI,kBAAmB,AACnB,gBAAkB,AAClB,wBAA0B,AAC1B,wBAA0B,CAC7B,AACD,uBACI,mBAAoB,AACpB,oBAAqB,AACrB,uBAAwB,AACxB,eAAkB,CACrB,AACD,4BACI,sBAAuB,AACvB,qBAAsB,AACtB,oBAAqB,AACrB,sBAAuB,AACvB,UAAe,CAClB","file":"BodyHead.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.body-head {\n  font-family: \"Barlow\", sans-serif;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.body-head {\n      display: none;\n}\n}\n.body-head .head-text {\n    font-size: 1.25rem;\n    font-weight: bold;\n    padding-bottom: 0.9375rem;\n    text-transform: uppercase;\n}\n.body-head .head-title {\n    font-size: 2.375rem;\n    line-height: 2.75rem;\n    margin-bottom: 1.875rem;\n    font-weight: bold;\n}\n.body-head .head-subheading {\n    margin-top: -1.0625rem;\n    margin-bottom: 2.5rem;\n    font-size: 1.5625rem;\n    line-height: 2.0625rem;\n    color: #666666;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(1143)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),

/***/ 1586:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1497);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("35a877f2", content, true, {});

/***/ }),

/***/ 1587:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1498);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("d9ef8640", content, true, {});

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1499);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("dd2a6d74", content, true, {});

/***/ }),

/***/ 1589:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1500);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("1733294e", content, true, {});

/***/ }),

/***/ 1591:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("cb1e87ce", content, true, {});

/***/ }),

/***/ 1599:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1510);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("066668ad", content, true, {});

/***/ }),

/***/ 1600:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1511);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("4fac643c", content, true, {});

/***/ }),

/***/ 1607:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1518);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("570bde56", content, true, {});

/***/ }),

/***/ 1614:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1525);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("63e92ca8", content, true, {});

/***/ }),

/***/ 1615:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1526);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("b5cb9ab4", content, true, {});

/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("0f990cfa", content, true, {});

/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("74c53790", content, true, {});

/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("671de04a", content, true, {});

/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("5159d7e2", content, true, {});

/***/ }),

/***/ 1626:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("4ecc28af", content, true, {});

/***/ }),

/***/ 1627:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("5ad14193", content, true, {});

/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("0f277878", content, true, {});

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1540);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("3e092b26", content, true, {});

/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @module ios-inner-height
 *
 * @description Get proper window.innerHeight from iOS devices,
 * excluding URL control and menu bar.
 *
 * @return {function} Callable function to retrieve the
 * cached `window.innerHeight` measurement, specific to the
 * device's current orientation.
 */
module.exports = (function () {
	// Non-iOS browsers return window.innerHeight per usual.
	// No caching here since browsers can be resized, and setting
	// up resize-triggered cache invalidation is not in scope.
	/* istanbul ignore if  */
	if (!navigator.userAgent.match(/iphone|ipod|ipad/i)) {
		/**
		 * Avoids conditional logic in the implementation
		 * @return {number} - window's innerHeight measurement in pixels
		 */
		return function () {
			return window.innerHeight;
		};
	}

	// Store initial orientation
	var axis = Math.abs(window.orientation);
	// And hoist cached dimensions
	var dims = {w: 0, h: 0};

	/**
	 * Creates an element with a height of 100vh since iOS accurately
	 * reports vp height (but not window.innerHeight). Then destroy it.
	 * @return {null}
	 */
	var createRuler = function () {
		var ruler = document.createElement('div');

		ruler.style.position = 'fixed';
		ruler.style.height = '100vh';
		ruler.style.width = 0;
		ruler.style.top = 0;

		document.documentElement.appendChild(ruler);

		// Set cache conscientious of device orientation
		dims.w = axis === 90 ? ruler.offsetHeight : window.innerWidth;
		dims.h = axis === 90 ? window.innerWidth : ruler.offsetHeight;

		// Clean up after ourselves
		document.documentElement.removeChild(ruler);
		ruler = null;
	};

	// Measure once
	createRuler();

	/**
	 * Returns window's cached innerHeight measurement
	 * based on viewport height and device orientation
	 * @return {number} - window's innerHeight measurement in pixels
	 */
	return function () {
		if (Math.abs(window.orientation) !== 90) {
			return dims.h;
		}
		return dims.w;
	};
})();


/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(337),
    shuffleSelf = __webpack_require__(1192);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),

/***/ 1643:
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(1192),
    values = __webpack_require__(360);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),

/***/ 1649:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(346),
    toInteger = __webpack_require__(147);

/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = drop;


/***/ }),

/***/ 1651:
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(113),
    toInteger = __webpack_require__(147);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(1640),
    baseShuffle = __webpack_require__(1644),
    isArray = __webpack_require__(10);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(157),
    baseIteratee = __webpack_require__(74),
    baseRest = __webpack_require__(109),
    baseUniq = __webpack_require__(160),
    isArrayLikeObject = __webpack_require__(149),
    last = __webpack_require__(146);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),

/***/ 1696:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1591)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1356),
  /* template */
  __webpack_require__(1755),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57e8c72e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1698:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1626)
  __webpack_require__(1627)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1362),
  /* template */
  __webpack_require__(1783),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-caa199b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1699:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1363),
  /* template */
  __webpack_require__(1772),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1607)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1388),
  /* template */
  __webpack_require__(1766),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a27b132",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1713:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1589)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1390),
  /* template */
  __webpack_require__(1753),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54b37392",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1714:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1587)
  __webpack_require__(1588)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1391),
  /* template */
  __webpack_require__(1751),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5311e48e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1750:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lazy-component', {
    ref: "lazy",
    staticClass: "timeline-lazy-wrapper"
  }, [_c('div', {
    ref: "container",
    staticClass: "timeline-pane",
    class: {
      overlay: _vm.isOverlay
    }
  }, [_c('div', {
    staticClass: "timeline-title"
  }, [_vm._v("timeline")]), _c('div', {
    staticClass: "gradient-cover"
  }), _c('div', {
    ref: "timelineEmbed",
    staticClass: "timeline-embed ",
    attrs: {
      "id": "timeline-embed"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1751:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('share-buttons', {
    ref: "shareButtons",
    staticClass: "related-person-overlay-sharebar",
    class: [{
      active: _vm.mode === 'collapse',
      hide: _vm.mode !== 'collapse'
    }, ("theme-" + _vm.theme)],
    attrs: {
      "mode": _vm.sharebarMode,
      "url": _vm.shareData.url,
      "shortenUrl": _vm.shareData.shortenUrl,
      "title": _vm.shareData.title,
      "gtmType": this.theme === 'desktop' ? 'gtmType_shareBtn-default' : 'gtmType_shareBtn-adhesiveBar'
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1753:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "property-pane"
  }, [(_vm.property.label) ? _c('h3', {
    staticClass: "property-title"
  }, [_vm._v(_vm._s(_vm.property.label))]) : _vm._e(), (_vm.property.attributes) ? _c('div', {
    staticClass: "attributes-wrapper"
  }, _vm._l((_vm.property.attributes), function(attribute, attrIndex) {
    return (attribute.value) ? _c('div', {
      key: attrIndex,
      staticClass: "attribute-pane"
    }, [_c('div', {
      staticClass: "attribute-label"
    }, [_vm._v(_vm._s(attribute.label))]), (_vm.isUrl(attribute.value)) ? _c('div', {
      staticClass: "attribute-value"
    }, [_c('a', {
      attrs: {
        "href": attribute.value,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attribute.value))])]) : _c('div', {
      staticClass: "attribute-value"
    }, [_vm._v(_vm._s(attribute.value))])]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1755:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "wrapper-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown",
      "appear": ""
    }
  }, [(_vm.allowNewsletterWidgetPopup) ? _c('div', {
    staticClass: "row no-gutters popup-wrapper"
  }, [_c('div', {
    staticClass: "close-icon-box d-flex align-items-center",
    on: {
      "click": _vm.closeNewsletter
    }
  }, [_c('svg-cancel-icon', {
    staticClass: "icon mx-auto",
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  })], 1), _c('div', {
    staticClass: "col-12"
  }, [_vm._t("content")], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1761:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gallery', {
    attrs: {
      "selector": ("gallery-" + (_vm.node.nid)),
      "articleTitle": _vm.node.title,
      "theme": _vm.theme
    }
  }, _vm._l((_vm.slideshow), function(val, key) {
    return _c('div', {
      key: key,
      staticClass: "thumbnail",
      class: {
        first: key === 0
      },
      attrs: {
        "slot": "thumbnail",
        "enLarge": val.style_1320w,
        "thumbnail": val.style_600x600,
        "progressive": val.style_134w,
        "data-w": val.width,
        "data-h": val.height,
        "data-caption": val.title,
        "data-title": val.title
      },
      slot: "thumbnail"
    }, [_c('div', {
      staticClass: "photos"
    }, [_c('progressive-image', {
      attrs: {
        "mode": "background",
        "progressiveImage": _vm.progressiveImages[key],
        "alt": _vm.node.title
      }
    })], 1), (key === 0 || key === 1) ? _c('div', {
      staticClass: "gallery-icon",
      class: {
        'number-one': key === 0, 'number-two': key === 1
      }
    }, [_c('svg-icon-gallery', {
      attrs: {
        "width": "10%",
        "height": "10%"
      }
    })], 1) : _vm._e(), (_vm.slideshow.length > 4 && key === 3) ? _c('div', {
      staticClass: "overlay"
    }, [_c('span', [_vm._v("+" + _vm._s((_vm.slideshow.length - key - 1)))])]) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1766:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay-header",
    class: [{
      right: _vm.theme === 'desktop'
    }, ("theme-" + _vm.theme)],
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "overlay-header-wrapper"
  }, [_c('div', {
    staticClass: "overlay-back-wrapper",
    on: {
      "click": _vm.closeOverlay
    }
  }, [(_vm.theme === 'desktop') ? _c('svg-icon-cancel', {
    staticClass: "overlay-back-btn",
    attrs: {
      "fill": "#FFF",
      "width": "32",
      "height": "32"
    }
  }) : _c('svg-icon-arrow-left', {
    staticClass: "overlay-back-btn",
    attrs: {
      "fill": "#FFF"
    }
  })], 1), _c('div', {
    staticClass: "overlay-header-meta"
  }, [(_vm.sections.length) ? _c('field-section', {
    staticClass: "overlay-header-section",
    attrs: {
      "sections": _vm.sections
    }
  }) : _vm._e(), _c('div', {
    staticClass: "overlay-header-title"
  }, [_vm._v(_vm._s(_vm.label))])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1772:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node-body"
  }, [(_vm.nodeType === 'article') ? _c('article-body', {
    attrs: {
      "nid": _vm.nid
    }
  }) : (_vm.nodeType === 'person') ? _c('person-body', {
    attrs: {
      "nid": _vm.nid
    }
  }) : _c('comparison-body', {
    attrs: {
      "nid": _vm.nid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1773:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "articlePage",
    staticClass: "page-node",
    class: ("page-type-" + _vm.nodeType)
  }, [_c('svg', {
    staticClass: "sr-only",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('def', [_c('filter', {
    attrs: {
      "id": "blur-effect--20"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "edgeMode": "duplicate",
      "stdDeviation": "20"
    }
  }), _c('feComponentTransfer', [_c('feFuncA', {
    attrs: {
      "tableValues": "1 1"
    }
  })], 1)], 1)])], 1), _c('CusCarousel', {
    ref: "cusCarousel",
    staticClass: "article-carousel",
    attrs: {
      "sliderOptions": _vm.sliderOptions,
      "selector": "slider-1",
      "extraSlots": _vm.carouselExtraSlots
    },
    on: {
      "slideProgress": _vm.slideProgress,
      "slideChangeEnd": _vm.slideChangeEnd,
      "slideChangeStart": _vm.slideChangeStart
    }
  }, [_c('widget-share-buttons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.relatedPersonOverlay.toggle),
      expression: "!relatedPersonOverlay.toggle"
    }],
    ref: "shareButtons",
    class: ['articleView__shareButtons', 'hidden-sm-up', _vm.shareBarActive, _vm.shareBarNoAnimation ? 'no-animation' : '', {
      inCard: _vm.inCard
    }],
    attrs: {
      "slot": "sharebar",
      "mode": "sticky",
      "url": _vm.shareData.url,
      "shortenUrl": _vm.shareData.shortenUrl,
      "title": _vm.shareData.title,
      "thumbnail": _vm.shareData.thumbnail,
      "gtmType": "gtmType_shareBtn-adhesiveBar"
    },
    slot: "sharebar"
  }), _c('div', {
    staticClass: "slider-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._l((_vm.articleList), function(articleNID, key) {
    return _c('div', {
      key: key,
      ref: _vm.getWrapperRef(articleNID),
      refInFor: true,
      staticClass: "article-view-wrapper slider-panel scroll-x-hidden",
      class: {
        active: _vm.isActive(articleNID), touchtopbottom: _vm.reachTopBottom, preventScroll: _vm.preventScroll
      },
      attrs: {
        "data-nid": articleNID
      }
    }, [(_vm.showSeoTitle && _vm.node.title) ? _c('h1', {
      staticClass: "news-title"
    }, [_vm._v(_vm._s(_vm.node.title))]) : _vm._e(), (_vm.prevArticleNID && _vm.activeNID == articleNID && _vm.showPrevCardCover) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showTopCover),
        expression: "showTopCover"
      }],
      staticClass: "prevCardCover",
      class: {
        reset: _vm.cardReset, animate: _vm.cardAnimate
      },
      style: ({
        'margin-top': (_vm.prevCardMargintop + "px"),
        height: (_vm.viewportHeight + "px"),
        transform: ("translateY(" + _vm.prevCardTransformY + "px)")
      })
    }, [_c('card-cover', {
      ref: _vm.getCoverRef(_vm.prevArticleNID),
      refInFor: true,
      staticClass: "cardInvisible",
      class: {
        active: _vm.isActive(_vm.prevArticleNID)
      },
      attrs: {
        "isHideAnimationElement": true,
        "nid": _vm.prevArticleNID,
        "showVideoPlayButton": false
      }
    })], 1) : _vm._e(), (articleNID === _vm.activeNID || _vm.remainPosition(articleNID)) ? [(articleNID === _vm.activeNID && _vm.showTopCover && !_vm.remainPosition(articleNID)) ? [_c('card-cover', {
      ref: _vm.getCoverRef(articleNID),
      refInFor: true,
      class: {
        active: _vm.isActive(articleNID), 'to-top': _vm.atTop && _vm.showTopCover, bounce: _vm.bounce, reset: _vm.cardReset
      },
      style: ({
        'margin-top': _vm.cardMargintop + 'vh'
      }),
      attrs: {
        "cardPosition": "top",
        "showVideoPlayButton": _vm.showVideoPlayButton,
        "actionToggle": _vm.cardActionAnimate,
        "isHideAnimationElement": !(articleNID === _vm.activeNID),
        "nid": articleNID
      },
      on: {
        "cardMounted": _vm.cardMounted
      }
    }, [_c('div', {
      ref: "arrowsHoverWrapper",
      refInFor: true,
      staticClass: "arrowsHover hidden-sm-down row",
      attrs: {
        "slot": "arrowsHover"
      },
      slot: "arrowsHover"
    }, [_c('div', {
      ref: "arrowsHover",
      refInFor: true,
      staticClass: "left-area arrow-block",
      on: {
        "mouseover": function($event) {
          _vm.forceShowArrows('left')
        }
      }
    }), _c('div', {
      staticClass: "center-area arrow-block",
      on: {
        "mouseenter": _vm.forceHideArrows
      }
    }), _c('div', {
      ref: "arrowsHover",
      refInFor: true,
      staticClass: "right-area arrow-block",
      on: {
        "mouseover": function($event) {
          _vm.forceShowArrows('right')
        }
      }
    }), _c('div', {
      staticClass: "card-middle"
    })])])] : _vm._e(), _c('div', {
      ref: _vm.getBodyCardWrapperRef(articleNID),
      refInFor: true,
      staticClass: "article-body-card-wrapper vw-100",
      class: {
        bounce: _vm.bounceBottom, 'with-card-video': _vm.isShowVideo[articleNID], bodyFadeIn: _vm.bodyFadeIn
      },
      style: ({
        height: _vm.bodyMaxHeight
      })
    }, [_c('div', {
      ref: "cardVideoContainer",
      refInFor: true,
      staticClass: "card-video-container"
    }, [_c('card-video', {
      ref: _vm.cardVideoNID,
      refInFor: true,
      staticClass: "no-article-swipe",
      class: {
        show: _vm.isShowVideo[articleNID], hide: !_vm.isShowVideo[articleNID]
      },
      attrs: {
        "nid": _vm.activeNID,
        "autoStart": _vm.videoAutoStart(),
        "showCusPlayButton": true,
        "bindOnAction": _vm.bindVideoAction,
        "parentActionOnHide": _vm.actionOnVideoHide
      }
    })], 1), _c('node-body', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      ref: _vm.getArticleRef(articleNID),
      refInFor: true,
      class: {
        reset: _vm.bottomCardReset, 'bounce-bottom': _vm.bounceBottom
      },
      style: ({
        'margin-top': _vm.bodyMarginTop + 'vh'
      }),
      attrs: {
        "nid": articleNID
      }
    }), (_vm.arrowNext && _vm.nextArticleNID) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      staticClass: "arrow-down-wrapper",
      class: _vm.articleType
    }, [_c('div', {
      ref: "bottomDivider",
      refInFor: true,
      staticClass: "bottom-divider"
    }), _c('svg-icon-arrow-down-one')], 1) : _vm._e(), (_vm.nextArticleNID) ? _c('div', {
      staticClass: "next-article-indication"
    }, [_c('div', {
      staticClass: "hidden-sm-up coming-next"
    }, [_vm._v("and now"), _c('br'), _vm._v("this")]), _c('div', {
      staticClass: "bottom-card-invader hidden-sm-up"
    }, [_c('icon-bottom-card-invader')], 1)]) : _vm._e(), _c('monster-newsletter-form-desktop', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      ref: "monsterNewsletter",
      refInFor: true,
      staticClass: "monster-newsletter-widget hidden-sm-down",
      attrs: {
        "slot": "content",
        "sections": _vm.node.sections,
        "gtmType": "gtmType_newsletter-footer"
      },
      slot: "content"
    }), (_vm.nextArticleNID && _vm.activeNID == articleNID) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      ref: "articleBottomCardWrapper",
      refInFor: true,
      staticClass: "article-bottom-card-wrapper"
    }, [_c('card-cover', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showBottomCover),
        expression: "showBottomCover"
      }],
      ref: _vm.getCoverRef(_vm.nextArticleNID),
      refInFor: true,
      staticClass: "cardInvisible bottom-card",
      class: {
        active: _vm.isActive(_vm.nextArticleNID), fullHeight: !_vm.bottomBlankSpace, 'smooth-animate': _vm.bottomCardSmoothAnimate
      },
      style: ({
        transform: ("scale(" + _vm.bottomCardScale + ") translate3d(0,0,0) translateZ(0)"),
        'transform-origin': 'top center'
      }),
      attrs: {
        "isHideAnimationElement": true,
        "nid": _vm.nextArticleNID,
        "showAction": false,
        "showVideoPlayButton": false,
        "cardPosition": "bottom"
      }
    }), (_vm.bottomBlankSpace) ? _c('div', {
      ref: "bottomCardBlankSpace",
      refInFor: true,
      staticClass: "bottom-card-cover-blank-space hidden-xs-down"
    }, [_c('div', {
      staticClass: "scroll-to-continue"
    }, [_vm._v("Scroll to continue")]), _c('div', {
      staticClass: "scroll-down-arrow"
    }, [_c('svg-arrow-down', {
      attrs: {
        "width": "100%",
        "height": "100%"
      }
    })], 1)]) : _vm._e(), _c('div', {
      staticClass: "header_text text-center"
    }, [_vm._v(_vm._s(_vm.nextCoverHeaderText))])], 1) : _vm._e(), (key === _vm.articleList.length - 1 && !_vm.nextArticleNID) ? [_c('tech-lift-footer', {
      staticClass: "vw-100",
      attrs: {
        "logo": "",
        "showTopicList": "",
        "theme": "footer-red",
        "iconColor": "rgba(220, 58, 53, 1)",
        "gtm-event-category": "Footer"
      }
    })] : _vm._e()], 2)] : (_vm.lazyCover(key)) ? [_c('card-cover', {
      attrs: {
        "isHideAnimationElement": _vm.showVideoPlayButton,
        "showVideoPlayButton": true,
        "nid": articleNID,
        "cardPosition": "lazy"
      }
    }), _c('div', {
      staticClass: "card-cover-blank-space hidden-xs-down"
    })] : _vm._e()], 2)
  })], 2), (_vm.hasRelatedPersonInBody) ? _c('related-person-overlay-header', {
    staticClass: "related-person-overlay-header",
    class: {
      'hidden-right': !_vm.relatedPersonOverlay.toggle, 'showing-desktop-header': _vm.showDesktopHeaderMenu
    },
    attrs: {
      "theme": _vm.currentViewPort,
      "nid": _vm.relatedPersonOverlay.nid,
      "overlayBody": this.$refs.relatedPersonOverlay,
      "width": "640px"
    }
  }) : _vm._e(), (_vm.hasRelatedPersonInBody && _vm.relatedPersonOverlay.toggle) ? _c('div', {
    staticClass: "related-person-overlay-layer",
    class: [{
      'hidden-right': !_vm.relatedPersonOverlay.toggle
    }, ("theme-" + _vm.currentViewPort)]
  }) : _vm._e(), (_vm.hasRelatedPersonInBody) ? _c('div', {
    staticClass: "related-person-overlay",
    class: [{
      'hidden-right': !_vm.relatedPersonOverlay.toggle,
      'showing-desktop-header': _vm.showDesktopHeaderMenu
    }, ("theme-" + _vm.currentViewPort)]
  }, [_c('related-person-overlay', {
    ref: "relatedPersonOverlay",
    staticClass: "overlay",
    attrs: {
      "overlay": true,
      "showingOverlay": _vm.relatedPersonOverlay.toggle,
      "nid": _vm.relatedPersonOverlay.nid,
      "theme": _vm.currentViewPort
    }
  })], 1) : _vm._e(), (_vm.hasRelatedPersonInBody) ? _c('related-person-overlay-share-bar', {
    class: {
      'hidden-right': !_vm.relatedPersonOverlay.toggle
    },
    attrs: {
      "theme": _vm.currentViewPort,
      "nid": _vm.relatedPersonOverlay.nid,
      "overlayBody": this.$refs.relatedPersonOverlay
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrowPrev && (_vm.arrowInit || _vm.hoverCover)),
      expression: "arrowPrev && (arrowInit || hoverCover)"
    }],
    ref: "articleArrowLeft",
    staticClass: "arrow-prev article-arrow",
    class: {
      arrowFadeIn: _vm.arrowVisible, onCover: _vm.hoverCover
    },
    style: (_vm.newArrowTopPercentage),
    on: {
      "click": function($event) {
        _vm.prevArticle()
      }
    }
  }, [_c('icon-arrow-left', {
    attrs: {
      "width": "70",
      "height": "70"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrowNext && (_vm.arrowInit || _vm.hoverCover)),
      expression: "arrowNext && (arrowInit || hoverCover)"
    }],
    ref: "articleArrowRight",
    staticClass: "arrow-next article-arrow",
    class: {
      arrowFadeIn: _vm.arrowVisible, onCover: _vm.hoverCover
    },
    style: (_vm.newArrowTopPercentage),
    on: {
      "click": function($event) {
        _vm.nextArticle()
      }
    }
  }, [_c('icon-arrow-right', {
    attrs: {
      "width": "70",
      "height": "70"
    }
  })], 1), _c('div', {
    staticClass: "fixed-bottom"
  }, [(_vm.allowNewsletterWidgetPopup) ? _c('div', {
    staticClass: "newsletter hidden-sm-up",
    style: ({
      'left': _vm.newsLetterWidgetXPadding + 'px'
    })
  }, [_c('pop-up-wrapper', [_c('monster-newsletter-form', {
    attrs: {
      "slot": "content",
      "sections": _vm.node.sections,
      "gtmType": "gtmType_newsletter-adhesive"
    },
    slot: "content"
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1777:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    ref: "personOverlay",
    staticClass: "node node-type-person",
    class: ("theme-" + _vm.theme)
  }, [(!_vm.isEmpty(_vm.node)) ? _c('div', {
    staticClass: "article-parent-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid  person-header article-gutter",
    class: {
      'hasCover': (!_vm.showVideo && _vm.overlay)
    },
    style: (_vm.coverStyle)
  }, [(_vm.overlay) ? _c('div', {
    staticClass: "image-holder grayscale",
    style: (_vm.coverStyle)
  }) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 content-wrapper mx-auto"
  }, [_c('div', {
    staticClass: "person-top"
  }, [(_vm.overlay && _vm.node.related_video && _vm.showingOverlay) ? _c('div', {
    ref: "cardVideoContainer",
    staticClass: "card-video-container"
  }, [_c('card-video', {
    attrs: {
      "nid": _vm.nid,
      "autoStart": false,
      "showCusPlayButton": true,
      "theme": "mobile",
      "isOverlay": _vm.overlay
    }
  })], 1) : _vm._e(), (!_vm.overlay && _vm.sections.length) ? _c('field-section', {
    staticClass: "node-label",
    attrs: {
      "sections": _vm.sections
    }
  }) : _vm._e(), _c('h1', {
    staticClass: "person-name"
  }, [_c('span', [_vm._v("Who Is ")]), _vm._v(_vm._s(_vm.node.title))]), (_vm.node.subheading) ? _c('div', {
    staticClass: "person-brief",
    domProps: {
      "innerHTML": _vm._s(_vm.node.subheading)
    }
  }, [_vm._v(_vm._s(_vm.node.subheading))]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "container-fluid content-wrapper inner-content article-gutter"
  }, [(!_vm.overlay) ? _c('field-date', {
    staticClass: "field-date",
    attrs: {
      "node": _vm.node
    }
  }) : _vm._e(), (!_vm.overlay) ? _c('share-pane', {
    staticClass: "share-pane",
    attrs: {
      "node": _vm.node
    }
  }) : _vm._e(), _c('field-body', {
    ref: "articleBody",
    attrs: {
      "body": _vm.node.body,
      "node": _vm.node,
      "bodyOptions": _vm.bodyOptions
    }
  })], 1), _c('div', {
    staticClass: "container-fluid timeline-wrapper"
  }, [(_vm.isEmptyTimeline) ? _c('timeline', {
    staticClass: "no-article-swipe row",
    attrs: {
      "nid": _vm.nid,
      "isOverlay": _vm.overlay
    }
  }) : _vm._e()], 1), (!_vm.overlay) ? _c('div', {
    staticClass: "container-fluid panes-wrapper hidden-sm-down"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.desktopGridLayout), function(group, index) {
    return _c('div', {
      staticClass: "col-sm-4 pane-column"
    }, [_vm._l((group), function(item, index) {
      return [(item.type === 'property') ? _c('property-pane', {
        staticClass: "property-pane article-gutter pane",
        attrs: {
          "property": item.data
        }
      }) : (item.type === 'history') ? _c('div', {
        staticClass: "career-history-pane article-gutter pane"
      }, [_c('h3', {
        staticClass: "career-history-title"
      }, [_vm._v("career history")]), _c('ul', {
        staticClass: "pane-list"
      }, _vm._l((item.data), function(career, key) {
        return _c('li', {
          key: key
        }, [_vm._v(_vm._s(career))])
      }))]) : (item.type === 'awards') ? _c('div', {
        staticClass: "awards-publication-pane  article-gutter pane"
      }, [_c('h3', {
        staticClass: "awards-publication-title"
      }, [_vm._v("awards & publication")]), (!_vm.isEmpty(item.data.awards)) ? _c('div', {
        staticClass: "attr-label-tag"
      }, [_vm._v("awards")]) : _vm._e(), _c('ul', {
        staticClass: "pane-list"
      }, _vm._l((item.data.awards), function(award, key) {
        return _c('li', {
          key: key
        }, [_vm._v(_vm._s(award))])
      })), (!_vm.isEmpty(item.data.publications)) ? _c('div', {
        staticClass: "attr-label-tag"
      }, [_vm._v("publications")]) : _vm._e(), _c('ul', {
        staticClass: "pane-list"
      }, _vm._l((item.data.publications), function(publication, key) {
        return _c('li', {
          key: key
        }, [_vm._v(_vm._s(publication))])
      }))]) : (item.type === 'quote') ? _c('div', {
        staticClass: "quotes-pane pane article-gutter col-12"
      }, [_c('transition-group', {
        attrs: {
          "name": "list",
          "tag": "div"
        }
      }, _vm._l((_vm.node.quotes), function(quote, index) {
        return (index === 0 || _vm.showQuotes) ? _c('quote-block', {
          key: index,
          staticClass: "quote-block",
          attrs: {
            "value": quote
          }
        }) : _vm._e()
      })), (!_vm.showQuotes && _vm.node.quotes.length > 1) ? _c('div', {
        staticClass: "load-more-button",
        on: {
          "click": function($event) {
            _vm.showQuotes = true
          }
        }
      }, [_vm._v("show more quotes(" + _vm._s(_vm.node.quotes.length - 1) + ")")]) : _vm._e()], 1) : (item.type === 'relatedArticles') ? _c('div', {
        staticClass: "related-articles-pane article-gutter pane"
      }, [_c('h3', [_vm._v("related articles")]), _c('transition-group', {
        attrs: {
          "name": "list",
          "tag": "div"
        }
      }, _vm._l((_vm.relatedArticles), function(nid, index) {
        return _c('article-level-one', {
          key: index,
          staticClass: "article-level-one",
          class: {
            first: index === 0, last: index === _vm.relatedArticles.length - 1
          },
          attrs: {
            "nid": nid
          }
        })
      })), (_vm.loading) ? _c('loader') : (!_vm.noMoreContent) ? _c('div', {
        staticClass: "load-more-button",
        on: {
          "click": _vm.loadMoreRelatedArticles
        }
      }, [_vm._v("show more articles")]) : _vm._e()], 1) : (item.type === 'tag') ? _c('div', {
        staticClass: "tags-wrapper  article-gutter pane"
      }, [_c('tag', {
        attrs: {
          "node": _vm.node
        }
      })], 1) : (item.type === 'slideshow') ? _c('article-gallery', {
        staticClass: "gallery-pane",
        attrs: {
          "nid": _vm.nid,
          "theme": "mobile"
        }
      }) : (item.type === 'random-people') ? _c('div', {
        staticClass: "pane article-gutter random-people-pane"
      }, [_c('h3', [_vm._v(_vm._s(_vm.lastSection.title))]), _vm._l((_vm.randomPeople), function(person, index) {
        return _c('div', [_c('node-link', {
          staticClass: "random-person",
          attrs: {
            "url": person.relative_url,
            "type": person.type,
            "nid": person.nid,
            "title": person.title
          }
        }, [_vm._v(_vm._s(person.title))])], 1)
      })], 2) : _vm._e()]
    })], 2)
  }))]) : _vm._e(), _c('div', {
    staticClass: "container-fluid  article-gutter panes-wrapper",
    class: [{
      'hidden-sm-up': !_vm.overlay
    }, {
      overlay: _vm.overlay
    }]
  }, [_c('div', {
    staticClass: "row no-article-gutter"
  }, [_vm._l((_vm.node.properties), function(property, key, index) {
    return [(!_vm.isEmpty(property)) ? _c('property-pane', {
      key: key,
      staticClass: "property-pane article-gutter pane col-12",
      attrs: {
        "property": property
      }
    }) : _vm._e(), (index === 0 && !_vm.isEmpty(_vm.node.history)) ? _c('div', {
      staticClass: "career-history-pane article-gutter pane col-12"
    }, [_c('h3', {
      staticClass: "career-history-title"
    }, [_vm._v("career history")]), _c('ul', {
      staticClass: "pane-list"
    }, _vm._l((_vm.node.history), function(career, key) {
      return _c('li', {
        key: key
      }, [_vm._v(_vm._s(career))])
    }))]) : _vm._e()]
  }), (_vm.node.awards || _vm.node.publication) ? _c('div', {
    staticClass: "awards-publication-pane  article-gutter pane col-12"
  }, [_c('h3', {
    staticClass: "awards-publication-title"
  }, [_vm._v("awards & publication")]), (!_vm.isEmpty(_vm.node.awards)) ? _c('div', {
    staticClass: "attr-label-tag"
  }, [_vm._v("awards")]) : _vm._e(), _c('ul', {
    staticClass: "pane-list"
  }, _vm._l((_vm.node.awards), function(award, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(award))])
  })), (!_vm.isEmpty(_vm.node.publications)) ? _c('div', {
    staticClass: "attr-label-tag"
  }, [_vm._v("publications")]) : _vm._e(), _c('ul', {
    staticClass: "pane-list"
  }, _vm._l((_vm.node.publications), function(publication, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(publication))])
  }))]) : _vm._e(), (_vm.node.quotes) ? _c('div', {
    staticClass: "quotes-pane pane article-gutter col-12"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.node.quotes), function(quote, index) {
    return (index === 0 || _vm.showQuotes) ? _c('quote-block', {
      key: index,
      staticClass: "quote-block",
      attrs: {
        "value": quote
      }
    }) : _vm._e()
  })), (!_vm.showQuotes && _vm.node.quotes.length > 1) ? _c('div', {
    staticClass: "load-more-button",
    on: {
      "click": function($event) {
        _vm.showQuotes = true
      }
    }
  }, [_vm._v("show more quotes(" + _vm._s(_vm.node.quotes.length - 1) + ")")]) : _vm._e()], 1) : _vm._e(), (!_vm.isEmpty(_vm.relatedArticles)) ? _c('div', {
    staticClass: "related-articles-pane article-gutter pane col-12"
  }, [_c('h3', [_vm._v("related articles")]), _c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.relatedArticles), function(nid, index) {
    return _c('article-level-one', {
      key: index,
      staticClass: "article-level-one",
      class: {
        first: index === 0, last: index === _vm.relatedArticles.length - 1
      },
      attrs: {
        "nid": nid
      }
    })
  })), (_vm.loading) ? _c('loader') : (!_vm.noMoreContent) ? _c('div', {
    staticClass: "load-more-button",
    on: {
      "click": _vm.loadMoreRelatedArticles
    }
  }, [_vm._v("show more articles")]) : _vm._e()], 1) : _vm._e(), _c('article-gallery', {
    staticClass: "gallery-pane",
    attrs: {
      "nid": _vm.nid,
      "theme": "mobile"
    }
  }), _c('div', {
    staticClass: "tags-wrapper article-gutter pane col-12"
  }, [_c('tag', {
    attrs: {
      "node": _vm.node
    }
  })], 1), (!_vm.isEmpty(_vm.randomPeople)) ? _c('div', {
    staticClass: "pane article-gutter random-people-pane col-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.lastSection.title))]), _vm._l((_vm.randomPeople), function(person, index) {
    return _c('div', [_c('node-link', {
      staticClass: "random-person",
      attrs: {
        "url": person.relative_url,
        "type": person.type,
        "nid": person.nid,
        "title": person.title
      }
    }, [_vm._v(_vm._s(person.title))])], 1)
  })], 2) : _vm._e()], 2)])]) : _c('loader', {
    staticClass: "loader"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1778:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-pane"
  }, [_c('div', {
    staticClass: "tags-title"
  }, [_vm._v("tags")]), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag, key) {
    return _c('h5', {
      key: key,
      class: [{
        'first': key === 0
      }]
    }, [(tag.tid) ? _c('term-link', {
      attrs: {
        "tid": tag.tid,
        "title": tag.title,
        "url": tag.relative_url,
        "type": tag.type
      }
    }, [_vm._v(_vm._s(tag.title))]) : _vm._e()], 1)
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 1781:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.countDownDate) ? _c('div', {
    staticClass: "count-down text-center w-100",
    class: {
      'count-down--expired': _vm.isCountdownExpired
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("COUNTDOWN")]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.header))]), _c('div', {
    staticClass: "row align-items-center justify-content-center no-gutters count-number mx-auto"
  }, [_c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.days, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("DAYS")])])]), _c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.hours, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("HOURS")])])]), _c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.minutes, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("MINUTES")])])]), _c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.seconds, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("SECONDS")])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1783:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-cover",
    class: _vm.cardPosition
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.resizeCards
    }
  }), (_vm.isCoverReady) ? _c(("article-cover-card-" + _vm.nid), {
    ref: "cardCoverContent",
    tag: "component",
    attrs: {
      "nid": _vm.nid,
      "showAnimation": _vm.showAnimation,
      "parentInitFunctions": _vm.parentInitFunctions
    }
  }) : _vm._e(), (_vm.articleType === 'live') ? [_c('SpeechBalloonLabel', {
    attrs: {
      "node": _vm.node,
      "size": "large-responsive",
      "mainComponent": "article-cover-card",
      "showShadow": ""
    }
  })] : _vm._e(), _c('div', {
    staticClass: "button-wrapper play-button-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVideoCard && _vm.showVideoPlayButton),
      expression: "isVideoCard && showVideoPlayButton"
    }],
    staticClass: "play-button",
    on: {
      "click": _vm.playVideo
    }
  }, [_c('svg-video-play-icon')], 1)]), _c('div', {
    staticClass: "isCountdownCard",
    attrs: {
      "alt": "isCountDownCard"
    }
  }, [(!_vm.isEmpty(_vm.countDown)) ? _c('widget-count-down', {
    attrs: {
      "countDown": _vm.countDown
    }
  }) : _vm._e()], 1), (_vm.actionText && _vm.showAction) ? _c('div', {
    ref: "card-action",
    staticClass: "card-action",
    class: {
      cardInvisible: _vm.actionToggle, up: _vm.actionUp
    },
    on: {
      "click": _vm.toArticle
    }
  }, [_c('div', {
    staticClass: "card-action-icon-wrapper"
  }, [_c('svg-arrow-down')], 1), _c('div', {
    staticClass: "card-action-text"
  }, [_vm._v(_vm._s(_vm.actionText))])]) : _vm._e(), _vm._t("arrowsHover")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1784:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "published-date"
  }, [_vm._v(_vm._s(_vm.dateWithTimezone))])
},staticRenderFns: []}

/***/ }),

/***/ 1785:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-head"
  }, [_c('node-label', {
    staticClass: "head-text",
    attrs: {
      "node": _vm.node
    }
  }, [(_vm.articleType === 'opinion') ? [_c('SpeechBalloonLabel', {
    attrs: {
      "slot": "speechBalloonLabel",
      "node": _vm.node,
      "size": "large",
      "mainComponent": "body-head__node-label",
      "shadow": ""
    },
    slot: "speechBalloonLabel"
  })] : _vm._e()], 2), (_vm.title) ? _c('div', {
    staticClass: "head-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.node.subheading) ? _c('div', {
    staticClass: "head-subheading"
  }, [_vm._v(_vm._s(_vm.node.subheading))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1805:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="60" height="48" viewBox="0 0 60 48"><path fill-rule="evenodd" d="M12 6V0h6v6h-6zm30 0V0h6v6h-6zm12 0h6v24h-6v6h-6v6h-6v-6H18v6h-6v-6H6v-6H0V6h6v12h6v-6h6V6h6v6h12V6h6v6h6v6h6V6zM18 24h6v-6h-6v6zm18 0h6v-6h-6v6zM6 48v-6h6v6H6zm42 0v-6h6v6h-6z"/></svg>'};

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1614)
  __webpack_require__(1615)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1336),
  /* template */
  __webpack_require__(1773),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9db8fe76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _has = __webpack_require__(102);

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'node-link',
  props: {
    title: {
      type: String
    },
    type: {
      type: String
    },
    nid: {
      type: [String, Number]
    },
    url: {
      type: String
    },
    destinationTid: {
      type: [String, Number, Boolean]
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['setArticleListTid'])),
  render: function render(h) {
    var _this = this;

    var router = this.$router;
    var data = { attrs: { href: this.url } };
    var routeData = {
      type: this.type,
      nid: this.nid,
      url: this.url,
      title: this.title,

      props: {
        nid: this.nid,
        destinationTid: this.destinationTid
      }
    };

    router.addRouteByNode({ routeData: routeData });

    data.on = { click: function click(e) {
        e.preventDefault();
        if (_this.destinationTid) {
          _this.$store.commit('setArticleListTid', _this.destinationTid);

          var route = (0, _get2.default)(_this, '$route', {});
          var components = (0, _get2.default)((0, _head2.default)((0, _get2.default)(route, 'matched', [])), 'components.default.components', false);
          var isArticleToArticle = (0, _has2.default)(components, 'ArticleView');

          if (isArticleToArticle) {
            _this.$store.dispatch('toggleRouteTransition', true);
            _this.$store.commit('setIsRefreshedToRoutedArticle', true);

            if ((0, _includes2.default)(window.location.href, routeData.url)) {
              _this.$store.dispatch('toggleRouteTransition', false);
              _this.$store.commit('setIsRefreshedToRoutedArticle', false);
            }
          }
        }
        router.push(routeData.url);
      } };
    return h('a', data, this.$slots.default);
  }
};

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _isArray = __webpack_require__(10);

var _isArray2 = _interopRequireDefault(_isArray);

var _last = __webpack_require__(146);

var _last2 = _interopRequireDefault(_last);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    sectionColor: function sectionColor() {
      if ((0, _get2.default)(this, 'sections')) {
        var section = (0, _last2.default)((0, _head2.default)(this.sections));
        return (0, _get2.default)(section, 'color_info.hex', '');
      }
      return '';
    },
    firstSectionLineage: function firstSectionLineage() {
      var firstLineage = [];
      if ((0, _get2.default)(this, 'sections') && (0, _isArray2.default)(this.sections)) {
        firstLineage = (0, _head2.default)(this.sections);
      }
      return firstLineage;
    },
    firstSection: function firstSection() {
      var section = {};
      if ((0, _isArray2.default)(this.firstSectionLineage)) {
        section = (0, _head2.default)(this.firstSectionLineage);
      }
      return section;
    },
    lastSection: function lastSection() {
      var section = {};
      if ((0, _isArray2.default)(this.firstSectionLineage)) {
        section = (0, _last2.default)(this.firstSectionLineage);
      }
      return section;
    }
  },
  methods: {
    getLastSection: function getLastSection(sections) {
      if (sections && (0, _isArray2.default)(sections)) {
        return (0, _last2.default)((0, _head2.default)(sections));
      }
      return false;
    }
  }
};

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    getArticleLazyloadImage: function getArticleLazyloadImage(img, w, h, color, opacity) {
      return {
        src: img || "/image/placeholder/" + w + "/" + h + "/" + color + "/" + opacity,
        error: "/image/placeholder/" + w + "/" + h + "/" + color + "/" + opacity,
        loading: "/image/placeholder/" + w + "/" + h + "/" + color + "/" + opacity
      };
    }
  }
};

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(957)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e9e2064",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b77e75d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(152),
    eq = __webpack_require__(105);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 919:
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firebase", function() { return firebase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled || false;
        this.options_ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepCopy"])(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this._automaticDataCollectionEnabled;
        },
        set: function (val) {
            this.checkDestroyed_();
            this._automaticDataCollectionEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: Promise,
        SDK_VERSION: '4.13.0',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"],
            ErrorFactory: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"],
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: Promise,
            deepExtend: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"]
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["patchProperty"])(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["patchProperty"])(app, 'App', FirebaseAppImpl);
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            error('bad-app-name', { name: name + '' });
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new FirebaseAppImpl(options, config, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) { return apps_[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function (appArg) {
            if (appArg === void 0) { appArg = app(); }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
        'account is only allowed in a Node.js environment. On client ' +
        'devices, you should instead initialize the SDK with an api key and ' +
        'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.'
};
var appErrors = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('app', 'Firebase', errors);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firebase = createFirebaseNamespace();

/* harmony default export */ __webpack_exports__["default"] = (firebase);



/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(923);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
var getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
var isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
var isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
var isNodeSdk = function () {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
};

var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error
    .captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
var FirebaseError = /** @class */ (function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        }
        else {
            var err_1 = Error.apply(this, arguments);
            this.name = ERROR_NAME;
            // Make non-enumerable getter for the property.
            Object.defineProperty(this, 'stack', {
                get: function () {
                    return err_1.stack;
                }
            });
        }
    }
    return FirebaseError;
}());
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        }
        else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
 * signature.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return (!!decoded.signature &&
        !!claims &&
        typeof claims === 'object' &&
        claims.hasOwnProperty('iat'));
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function (objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function (obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function (obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = function (querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */ (function () {
    function Hash() {
        /**
         * The block size for the hasher.
         * @type {number}
         */
        this.blockSize = -1;
    }
    return Hash;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function (_super) {
    tslib_1.__extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(Hash));

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.assert = assert;
exports.assertionError = assertionError;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.CONSTANTS = CONSTANTS;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
exports.Deferred = Deferred;
exports.getUA = getUA;
exports.isMobileCordova = isMobileCordova;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.patchCapture = patchCapture;
exports.jsonEval = jsonEval;
exports.stringify = stringify;
exports.decode = decode;
exports.isAdmin = isAdmin;
exports.issuedAtTime = issuedAtTime;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.clone = clone;
exports.contains = contains;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getValues = getValues;
exports.isEmpty = isEmpty;
exports.isNonNullObject = isNonNullObject;
exports.map = map;
exports.safeGet = safeGet;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.Sha1 = Sha1;
exports.async = async;
exports.createSubscribe = createSubscribe;
exports.errorPrefix = errorPrefix;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;


/***/ }),

/***/ 922:
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.hasCookies = hasCookies;

var _cookie = __webpack_require__(947);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var prefix = 'lS_';

var CookieStorage = function () {
  function CookieStorage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CookieStorage);

    this.cookieOptions = Object.assign({ path: '/' }, options);
    prefix = options.prefix || prefix;
  }

  _createClass(CookieStorage, [{
    key: 'getItem',
    value: function getItem(key) {
      var cookies = _cookie2.default.parse(document.cookie);
      if (!cookies || !cookies.hasOwnProperty(prefix + key)) {
        return null;
      }
      return cookies[prefix + key];
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      document.cookie = _cookie2.default.serialize(prefix + key, value, this.cookieOptions);
      return value;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      var options = Object.assign({}, this.cookieOptions, { maxAge: -1 });
      document.cookie = _cookie2.default.serialize(prefix + key, '', options);
      return null;
    }
  }, {
    key: 'clear',
    value: function clear() {
      var cookies = _cookie2.default.parse(document.cookie);
      for (var key in cookies) {
        if (key.indexOf(prefix) === 0) {
          this.removeItem(key.substr(prefix.length));
        }
      }

      return null;
    }
  }]);

  return CookieStorage;
}();

exports.default = CookieStorage;
function hasCookies() {
  var storage = new CookieStorage();

  try {
    var TEST_KEY = '__test';
    storage.setItem(TEST_KEY, '1');
    var value = storage.getItem(TEST_KEY);
    storage.removeItem(TEST_KEY);

    return value === '1';
  } catch (e) {
    return false;
  }
}

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(933),
    createAssigner = __webpack_require__(226);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(966),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _merge = __webpack_require__(926);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    lazyload: {
      type: Boolean,
      default: true
    },
    progressiveImage: {
      type: Object,
      required: true
    },
    alt: {
      type: String
    },
    width: {
      type: [String, Number]
    },
    height: {
      type: [String, Number]
    },
    mode: {
      type: String,
      default: 'image'
    },
    customStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      imageLoaded: false,
      imageSrc: null,
      backgroundImageStyle: {}
    };
  },

  computed: {
    blurBackgroundImageStyle: function blurBackgroundImageStyle() {
      return (0, _merge2.default)({
        backgroundImage: 'url(\'' + (0, _get2.default)(this, 'progressiveImage.loading', '') + '\')'
      }, this.customStyle);
    }
  },
  methods: {
    handler: function handler() {
      var _this = this;

      var imageSrc = (0, _get2.default)(this, 'progressiveImage.src');
      if (typeof window !== 'undefined' && imageSrc) {
        var image = new window.Image();
        this.backgroundImageStyle = (0, _merge2.default)({}, this.customStyle);
        if (this.mode === 'background') {
          image.onload = function () {
            _this.backgroundImageStyle = (0, _merge2.default)({
              backgroundImage: 'url(\'' + imageSrc + '\')'
            }, _this.backgroundImageStyle);
            _this.imageLoaded = true;
          };
          image.onerror = function () {
            _this.backgroundImageStyle = (0, _merge2.default)({
              backgroundImage: 'url(\'' + (0, _get2.default)(_this, 'progressiveImage.error', '') + '\')'
            }, _this.backgroundImageStyle);
          };
        } else {
          image.onload = function () {
            _this.imageSrc = imageSrc;
            _this.imageLoaded = true;
          };
          image.onerror = function () {
            _this.imageSrc = (0, _get2.default)(_this, 'progressiveImage.error', '');
          };
        }
        image.src = imageSrc;
      }
    }
  },
  watch: {
    progressiveImage: function progressiveImage() {
      if ((0, _get2.default)(this, 'progressiveImage.src')) {
        this.handler();
      }
    }
  }
};

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".mode-background .lazy-wrapper[data-v-4b77e75d]{position:absolute;left:0;top:0;width:100%;height:100%}.mode-background .blur-image[data-v-4b77e75d],.mode-background .image[data-v-4b77e75d]{position:absolute;left:0;top:0;width:100%;height:100%;border:none;border-radius:0;background-position:50%;background-repeat:no-repeat;background-color:transparent;margin-left:auto;margin-right:auto;background-size:cover}img[data-v-4b77e75d]{position:absolute;width:100%;height:auto;left:0;top:0}.holder[data-v-4b77e75d]{position:relative;z-index:0}.lazy-wrapper[data-v-4b77e75d]{position:relative;z-index:2}.blur-image[data-v-4b77e75d]{opacity:1;-webkit-transition:opacity 4s;-o-transition:opacity 4s;transition:opacity 4s}.blur-image.fade-out[data-v-4b77e75d]{opacity:0}.image[data-v-4b77e75d]{opacity:0;-webkit-transition:opacity 2s;-o-transition:opacity 2s;transition:opacity 2s}.image.loaded[data-v-4b77e75d]{opacity:1}.progressive-image[data-v-4b77e75d]{position:relative;margin:0}.blur-holder[data-v-4b77e75d]{z-index:1;position:absolute;left:0;top:0}", "", {"version":3,"sources":["/app/components/widgets/ProgressiveImage.vue"],"names":[],"mappings":"AAgCA,gDACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,WAAa,CACd,AACD,uFAEE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,YAAa,AACb,gBAAiB,AACjB,wBAA4B,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC9B,iBAAkB,AAClB,kBAAmB,AACnB,qBAAuB,CACxB,AACD,qBACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,OAAQ,AACR,KAAO,CACR,AACD,yBACE,kBAAmB,AACnB,SAAW,CACZ,AACD,+BACE,kBAAmB,AACnB,SAAW,CACZ,AACD,6BACE,UAAW,AACX,8BAA+B,AAC/B,yBAA0B,AAC1B,qBAAuB,CACxB,AACD,sCACI,SAAW,CACd,AACD,wBACE,UAAW,AACX,8BAA+B,AAC/B,yBAA0B,AAC1B,qBAAuB,CACxB,AACD,+BACI,SAAW,CACd,AACD,oCACE,kBAAmB,AACnB,QAAU,CACX,AACD,8BACE,UAAW,AACX,kBAAmB,AACnB,OAAQ,AACR,KAAO,CACR","file":"ProgressiveImage.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.mode-background .lazy-wrapper[data-v-4b77e75d] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n.mode-background .image[data-v-4b77e75d],\n.mode-background .blur-image[data-v-4b77e75d] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 0;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  margin-left: auto;\n  margin-right: auto;\n  background-size: cover;\n}\nimg[data-v-4b77e75d] {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  left: 0;\n  top: 0;\n}\n.holder[data-v-4b77e75d] {\n  position: relative;\n  z-index: 0;\n}\n.lazy-wrapper[data-v-4b77e75d] {\n  position: relative;\n  z-index: 2;\n}\n.blur-image[data-v-4b77e75d] {\n  opacity: 1;\n  -webkit-transition: opacity 4s;\n  -o-transition: opacity 4s;\n  transition: opacity 4s;\n}\n.blur-image.fade-out[data-v-4b77e75d] {\n    opacity: 0;\n}\n.image[data-v-4b77e75d] {\n  opacity: 0;\n  -webkit-transition: opacity 2s;\n  -o-transition: opacity 2s;\n  transition: opacity 2s;\n}\n.image.loaded[data-v-4b77e75d] {\n    opacity: 1;\n}\n.progressive-image[data-v-4b77e75d] {\n  position: relative;\n  margin: 0;\n}\n.blur-holder[data-v-4b77e75d] {\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(929);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("731e180e", content, true, {});

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(946);
module.exports = __webpack_require__(920).default;


/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemoryStorage = exports.CookieStorage = exports.isSupported = exports.storage = undefined;

var _isSupported = __webpack_require__(950);

var _isSupported2 = _interopRequireDefault(_isSupported);

var _CookieStorage = __webpack_require__(924);

var _CookieStorage2 = _interopRequireDefault(_CookieStorage);

var _MemoryStorage = __webpack_require__(949);

var _MemoryStorage2 = _interopRequireDefault(_MemoryStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storage = null;

if ((0, _isSupported2.default)('localStorage')) {
  // use localStorage
  exports.storage = storage = window.localStorage;
} else if ((0, _isSupported2.default)('sessionStorage')) {
  // use sessionStorage
  exports.storage = storage = window.sessionStorage;
} else if ((0, _isSupported2.default)('cookieStorage')) {
  // use cookies
  exports.storage = storage = new _CookieStorage2.default();
} else {
  // use memory
  exports.storage = storage = new _MemoryStorage2.default();
}

exports.default = storage;
exports.storage = storage;
exports.isSupported = _isSupported2.default;
exports.CookieStorage = _CookieStorage2.default;
exports.MemoryStorage = _MemoryStorage2.default;

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(151),
    assignMergeValue = __webpack_require__(918),
    baseFor = __webpack_require__(341),
    baseMergeDeep = __webpack_require__(934),
    isObject = __webpack_require__(31),
    keysIn = __webpack_require__(148),
    safeGet = __webpack_require__(919);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(918),
    cloneBuffer = __webpack_require__(342),
    cloneTypedArray = __webpack_require__(343),
    copyArray = __webpack_require__(337),
    initCloneObject = __webpack_require__(344),
    isArguments = __webpack_require__(106),
    isArray = __webpack_require__(10),
    isArrayLikeObject = __webpack_require__(149),
    isBuffer = __webpack_require__(107),
    isFunction = __webpack_require__(84),
    isObject = __webpack_require__(31),
    isPlainObject = __webpack_require__(935),
    isTypedArray = __webpack_require__(153),
    safeGet = __webpack_require__(919),
    toPlainObject = __webpack_require__(936);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(52),
    getPrototype = __webpack_require__(227),
    isObjectLike = __webpack_require__(32);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(75),
    keysIn = __webpack_require__(148);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 937:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "progressive-image",
    class: [("mode-" + _vm.mode)],
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('lazy-component', {
    ref: "lazyWrapper",
    staticClass: "lazy-wrapper",
    on: {
      "show": _vm.handler
    }
  }, [(_vm.mode === 'background') ? [_c('div', {
    staticClass: "image",
    class: {
      loaded: _vm.imageLoaded
    },
    style: (_vm.backgroundImageStyle)
  }), _c('div', {
    staticClass: "blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.blurBackgroundImageStyle)
  })] : [(_vm.imageSrc) ? _c('img', {
    staticClass: "image",
    class: {
      loaded: _vm.imageLoaded
    },
    style: (_vm.customStyle),
    attrs: {
      "alt": _vm.progressiveImage.alt,
      "src": _vm.imageSrc
    }
  }) : _vm._e(), _c('img', {
    staticClass: "blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.customStyle),
    attrs: {
      "src": _vm.progressiveImage.loading,
      "alt": _vm.progressiveImage.alt
    }
  })]], 2), (_vm.mode === 'background') ? [_c('div', {
    staticClass: "blur-image blur-holder",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.blurBackgroundImageStyle)
  })] : [_c('img', {
    staticClass: "blur-holder blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    attrs: {
      "src": _vm.progressiveImage.loading,
      "width": _vm.width,
      "height": _vm.height
    }
  })], _c('img', {
    staticClass: "holder",
    attrs: {
      "src": _vm.progressiveImage.holder,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _compact = __webpack_require__(922);

var _compact2 = _interopRequireDefault(_compact);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _has = __webpack_require__(102);

var _has2 = _interopRequireDefault(_has);

var _app = __webpack_require__(931);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(948);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      liveArticleNid: '',
      databaseRef: null,
      databasePath: '',
      databaseMode: '' };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['registeredLiveArticles']), {
    firebaseConfig: function firebaseConfig() {
      return (0, _get2.default)(this.$store.state, 'settings.FCM_CONFIG', false);
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['setNodeLiveContent', 'setNodeLiveStatus', 'appendRegisteredLiveArticles', 'updateNotificationList']), {
    initRealtimeData: function initRealtimeData(_ref) {
      var modeType = _ref.modeType,
          _ref$nid = _ref.nid,
          nid = _ref$nid === undefined ? '' : _ref$nid;

      this.databaseMode = modeType;

      switch (this.databaseMode) {
        case 'live':
          {
            if (nid) {
              this.liveArticleNid = nid;

              if (!(0, _includes2.default)(this.registeredLiveArticles, this.liveArticleNid)) {
                this.appendRegisteredLiveArticles(this.liveArticleNid);
                this.setDatabaseRef({ path: '/node_status/' + this.liveArticleNid });
              }
            }
            break;
          }
        case 'push':
          {
            this.setDatabaseRef({ path: 'notification_list' });
            break;
          }
        default:}

      this.listenToDatabase();
    },
    setDatabaseRef: function setDatabaseRef(_ref2) {
      var path = _ref2.path;

      if (!_app2.default.apps.length) _app2.default.initializeApp(this.firebaseConfig);

      this.databaseRef = _app2.default.database().ref(path);

      console.log('[Realtime - ' + this.databaseMode + '] ' + ((0, _get2.default)(this, 'databaseRef') ? 'connected' : 'not connected') + ' ' + (0, _get2.default)(this, 'liveArticleNid'));
    },
    listenToDatabase: function listenToDatabase() {
      if ((0, _get2.default)(this, 'databaseRef')) {
        this.databaseRef.orderByKey().on('value', this.updateState, function (err) {
          console.log('[Realtime - Error]', err);
        });
      }
    },
    updateState: function updateState(snapshot) {
      var dataObj = snapshot.val();
      if (dataObj !== null) {
        switch (this.databaseMode) {
          case 'live':
            {
              if ((0, _has2.default)(dataObj, 'status')) {
                this.setNodeLiveStatus({ nid: this.liveArticleNid, status: dataObj.status });
              }
              if ((0, _has2.default)(dataObj, 'body')) {
                this.setNodeLiveContent({ nid: this.liveArticleNid, liveContent: (0, _compact2.default)(dataObj.body) });
              }
              break;
            }
          case 'push':
            {
              this.updateNotificationList(dataObj);
              break;
            }
          default:}
      }
    },
    destroyRealtimeListener: function destroyRealtimeListener() {
      if (this.databaseRef !== null) this.databaseRef.off('value', this.updateState);
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.destroyRealtimeListener();

    if (this.databaseMode === 'live') {
      this.appendRegisteredLiveArticles(false);
    }
  }
};

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

// sourced from:
// http://www.leanbackplayer.com/test/h5mt.html
// https://github.com/broofa/node-mime/blob/master/types.json
var mimeTypes = __webpack_require__(969)

var mimeLookup = {}
Object.keys(mimeTypes).forEach(function (key) {
  var extensions = mimeTypes[key]
  extensions.forEach(function (ext) {
    mimeLookup[ext] = key
  })
})

module.exports = function lookup (ext) {
  if (!ext) throw new TypeError('must specify extension string')
  if (ext.indexOf('.') === 0) {
    ext = ext.substring(1)
  }
  return mimeLookup[ext.toLowerCase()]
}


/***/ }),

/***/ 940:
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),

/***/ 941:
/***/ (function(module, exports) {

module.exports = createAudioContext
function createAudioContext () {
  var AudioCtor = window.AudioContext || window.webkitAudioContext
  return new AudioCtor()
}


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

var lookup = __webpack_require__(939)
var audio

module.exports = isSrcPlayable
function isSrcPlayable (src) {
  if (!src) throw new TypeError('src cannot be empty')
  var type
  if (typeof src.getAttribute === 'function') {
    // <source> element
    type = src.getAttribute('type')
  } else if (typeof src === 'string') {
    // 'foo.mp3' string
    var ext = extension(src)
    if (ext) type = lookup(ext)
  } else {
    // { src: 'foo.mp3', type: 'audio/mpeg; codecs..'}
    type = src.type
  }

  // We have an unknown file extension or
  // a <source> tag without an explicit type,
  // just let the browser handle it!
  if (!type) return true

  // handle "no" edge case with super legacy browsers...
  // https://groups.google.com/forum/#!topic/google-web-toolkit-contributors/a8Uy0bXq1Ho
  if (!audio) audio = new window.Audio()
  var canplay = audio.canPlayType(type).replace(/no/, '')
  return Boolean(canplay)
}

module.exports.createError = createError
function createError (sources) {
  // All sources are unplayable
  var err = new Error('This browser does not support any of the following sources:\n    ' +
      sources.join(', ') + '\n' +
      'Try using an array of OGG, MP3 and WAV.')
  err.type = 'AUDIO_FORMAT'
  return err
}

function extension (data) {
  var extIdx = data.lastIndexOf('.')
  if (extIdx <= 0 || extIdx === data.length - 1) {
    return undefined
  }
  return data.substring(extIdx + 1)
}


/***/ }),

/***/ 943:
/***/ (function(module, exports) {

module.exports = function (audioContext) {
  if (audioContext.state === 'suspended' &&
      typeof audioContext.resume === 'function') {
    audioContext.resume()
  }
}


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var util = __webpack_require__(921);
var logger = __webpack_require__(945);
var tslib_1 = __webpack_require__(923);
var firebase = _interopDefault(__webpack_require__(920));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return util.jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (util.contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = createStoragefor('sessionStorage');

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger.Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = function (str) {
    var utf8Bytes = util.stringToByteArray(str);
    var sha1 = new util.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return util.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) ||
            (var_args[i] &&
                typeof var_args[i] === 'object' &&
                typeof var_args[i].length === 'number')) {
            message += buildLogMessage_.apply(null, var_args[i]);
        }
        else if (typeof var_args[i] === 'object') {
            message += util.stringify(var_args[i]);
        }
        else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger$1 = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = function (logger_, persistent) {
    util.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        logClient.logLevel = logger.LogLevel.VERBOSE;
        logger$1 = logClient.log.bind(logClient);
        if (persistent)
            SessionStorage.set('logging_enabled', true);
    }
    else if (typeof logger_ === 'function') {
        logger$1 = logger_;
    }
    else {
        logger$1 = null;
        SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
var log = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger$1 === null && SessionStorage.get('logging_enabled') === true)
            enableLogging(true);
    }
    if (logger$1) {
        var message = buildLogMessage_.apply(null, var_args);
        logger$1(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = function (prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
};
/**
 * @param {...string} var_args
 */
var error = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
};
/**
 * @param {...string} var_args
 */
var fatal = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} var_args
 */
var warn = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        warn('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data != data || // NaN
            data == Number.POSITIVE_INFINITY ||
            data == Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = function (fn) {
    if (util.isNodeSdk() || document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        }
        else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete')
                    wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    }
    else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null)
        return util.stringify(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0)
            key += ',';
        key += util.stringify(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param {!(Object|Array)} obj The object or array to iterate over
 * @param {function(?, ?)} fn The function to apply
 */
var each = function (obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; ++i) {
            fn(i, obj[i]);
        }
    }
    else {
        /**
         * in the conversion of code we removed the goog.object.forEach
         * function which did a value,key callback. We standardized on
         * a single impl that does a key, value callback. So we invert
         * to not have to touch the `each` code points
         */
        util.forEach(obj, function (key, val) { return fn(val, key); });
    }
};
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = function (v) {
    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1)
            hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = function (str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    if (typeof timeout === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length)
            return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
            pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
            pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0)
                    pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0)
                return cmp;
        }
        if (leftKeys.length === rightKeys.length)
            return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += util.stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += util.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= util.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = '5';
var VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = 'r';
var FORGE_REF = 'f';
var FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = 'ls';
var WEBSOCKET = 'websocket';
var LONG_POLLING = 'long_polling';

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
        if (persistenceKey === void 0) { persistenceKey = ''; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return this.host !== this.internalHost || this.isCustomHost();
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        util.assert(typeof type === 'string', 'typeof type must == string');
        util.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        util.forEach(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var results = {};
    if (queryString.startsWith('?')) {
        queryString = queryString.substring(1);
    }
    for (var _i = 0, _a = queryString.split('&'); _i < _a.length; _i++) {
        var segment = _a[_i];
        if (segment.length === 0) {
            continue;
        }
        var kv = segment.split('=');
        if (kv.length === 2) {
            results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        }
        else {
            warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
var parseRepoInfo = function (dataURL) {
    var parsedUrl = parseURL(dataURL), namespace = parsedUrl.subdomain;
    if (parsedUrl.domain === 'firebase') {
        fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace == 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
        path: new Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
 */
var parseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = dataURL.length;
        }
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
        }
        else if (parts.length === 2) {
            domain = parts[0];
        }
        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        // Support `ns` query param if subdomain not already set
        if (subdomain === '' && 'ns' in queryParams) {
            subdomain = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString
    };
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
        (priority && typeof priority === 'object' && util.contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > MAX_LEAF_SIZE_ / 3 &&
        util.stringLength(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false, hasActualChild_1 = false;
        util.forEach(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) {
                // .priority is OK
            }
            else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    util.forEach(data, function (key, value) {
        var curPath = new Path(key);
        validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined)
        return;
    if (isInvalidJSONNumber(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
};
var validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined)
        return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
var validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined)
        return;
    if (!isValidKey(key))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined)
        return;
    if (!isValidPathString(pathString))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
};
var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined)
        return;
    if (typeof bool !== 'boolean')
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validateWritablePath('OnDisconnect.remove', this.path_);
        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.set', this.path_);
        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        util.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
        var newWrapped = new NamedNode(MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    return Index;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    tslib_1.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new NamedNode(MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index));
var KEY_INDEX = new KeyIndex();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = function (priority) {
    if (typeof priority === 'number')
        return 'number:' + doubleToIEEE754String(priority);
    else
        return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        util.assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty())
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        else
            return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty())
                toHash +=
                    'priority:' +
                        priorityHashText(this.priorityNode_.val()) +
                        ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            util.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode$1(val) {
    MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index));
var PRIORITY_INDEX = new PriorityIndex();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_)
            result = this.resultGenerator_(node.key, node.value);
        else
            result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_())
            n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_())
                n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_())
            n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_())
            n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_())
            n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty())
                        node = node.right;
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        }
        else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
        }
        else {
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, LLRBNode.BLACK);
                buildPennant(chunkSize, LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new SortedMap(mapSortFn || cmp, root);
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
/**
 *
 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
 * @param {Object.<string, Index>} indexSet
 * @constructor
 */
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         * @type {!IndexMap}
         * @const
         */
        get: function () {
            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param {!string} indexKey
     * @return {?SortedMap.<NamedNode, Node>}
     */
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = util.safeGet(this.indexes_, indexKey);
        if (!sortedMap)
            throw new Error('No index defined for ' + indexKey);
        if (sortedMap === fallbackObject) {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
        else {
            return sortedMap;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {boolean}
     */
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return util.contains(this.indexSet_, indexDefinition.toString());
    };
    /**
     * @param {!Index} indexDefinition
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = util.clone(this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = util.clone(this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
            var index = util.safeGet(_this.indexSet_, indexName);
            util.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
    return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
    return nameCompare(left, right);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null)
            return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        util.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty())
            return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj)
                array[key] = obj[key];
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty())
                toHash_1 +=
                    'priority:' +
                        priorityHashText(this.getPriority().val()) +
                        ':';
            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '')
                    toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === MAX_NODE$2) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    tslib_1.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
    MIN: {
        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new NamedNode(MAX_NAME, MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON$1(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    util.assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj_1 = json;
        util.forEach(hinzeJsonObj_1, function (key, child) {
            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON$1(hinzeJsonObj_1[key]);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return ChildrenNode.EMPTY_NODE;
        }
        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode.EMPTY_NODE;
        var jsonObj_1 = json;
        util.forEach(jsonObj_1, function (key, childData) {
            if (util.contains(jsonObj_1, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty())
                        node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON$1(priority));
    }
}
setNodeFromJSON(nodeFromJSON$1);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    tslib_1.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        return new NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index));
var VALUE_INDEX = new ValueIndex();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
        return new NamedNode(MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        util.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode())
            return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode())
            return false;
        else
            return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            util.stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return util.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        util.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
        var index = query.getQueryParams().getIndex();
        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherCount = util.getCount(other.callbacks_);
                var thisCount = util.getCount(this.callbacks_);
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    //  If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey /** @type {!string} */ = util.getAnyKey(other.callbacks_);
                        var thisKey /** @type {!string} */ = util.getAnyKey(this.callbacks_);
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return util.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PRIORITY_INDEX) {
            if ((startNode != null && !isValidPriority(startNode)) ||
                (endNode != null && !isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            util.assert(params.getIndex() instanceof PathIndex ||
                params.getIndex() === VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        util.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        util.validateArgCount('Query.on', 2, 4, arguments.length);
        validateEventType('Query.on', 1, eventType, false);
        util.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        util.validateArgCount('Query.off', 0, 3, arguments.length);
        validateEventType('Query.off', 1, eventType, true);
        util.validateCallback('Query.off', 2, callback, true);
        util.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param cancelOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
        var _this = this;
        util.validateArgCount('Query.once', 1, 4, arguments.length);
        validateEventType('Query.once', 1, eventType, false);
        util.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new util.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel)
                ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        util.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error$$1 = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error$$1);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            util.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            util.validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(util.errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements a set with a count of elements.
 *
 * @template K, V
 */
var CountedSet = /** @class */ (function () {
    function CountedSet() {
        this.set = {};
    }
    /**
     * @param {!K} item
     * @param {V} val
     */
    CountedSet.prototype.add = function (item, val) {
        this.set[item] = val !== null ? val : true;
    };
    /**
     * @param {!K} key
     * @return {boolean}
     */
    CountedSet.prototype.contains = function (key) {
        return util.contains(this.set, key);
    };
    /**
     * @param {!K} item
     * @return {V}
     */
    CountedSet.prototype.get = function (item) {
        return this.contains(item) ? this.set[item] : undefined;
    };
    /**
     * @param {!K} item
     */
    CountedSet.prototype.remove = function (item) {
        delete this.set[item];
    };
    /**
     * Deletes everything in the set
     */
    CountedSet.prototype.clear = function () {
        this.set = {};
    };
    /**
     * True if there's nothing in the set
     * @return {boolean}
     */
    CountedSet.prototype.isEmpty = function () {
        return util.isEmpty(this.set);
    };
    /**
     * @return {number} The number of items in the set
     */
    CountedSet.prototype.count = function () {
        return util.getCount(this.set);
    };
    /**
     * Run a function on each k,v pair in the set
     * @param {function(K, V)} fn
     */
    CountedSet.prototype.each = function (fn) {
        util.forEach(this.set, function (k, v) { return fn(k, v); });
    };
    /**
     * Mostly for debugging
     * @return {Array.<K>} The keys present in this CountedSet
     */
    CountedSet.prototype.keys = function () {
        var keys = [];
        util.forEach(this.set, function (k) {
            keys.push(k);
        });
        return keys;
    };
    return CountedSet;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper class to store a sparse set of snapshots.
 *
 * @constructor
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        /**
         * @private
         * @type {Node}
         */
        this.value_ = null;
        /**
         * @private
         * @type {CountedSet}
         */
        this.children_ = null;
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {?Node} The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value_ != null) {
            return this.value_.getChild(path);
        }
        else if (!path.isEmpty() && this.children_ != null) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children_.contains(childKey)) {
                var childTree = this.children_.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @param {!Node} data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value_ = data;
            this.children_ = null;
        }
        else if (this.value_ !== null) {
            this.value_ = this.value_.updateChild(path, data);
        }
        else {
            if (this.children_ == null) {
                this.children_ = new CountedSet();
            }
            var childKey = path.getFront();
            if (!this.children_.contains(childKey)) {
                this.children_.add(childKey, new SparseSnapshotTree());
            }
            var child = this.children_.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {boolean} True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value_ = null;
            this.children_ = null;
            return true;
        }
        else {
            if (this.value_ !== null) {
                if (this.value_.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value_;
                    this.value_ = null;
                    var self_1 = this;
                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children_ !== null) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children_.contains(childKey)) {
                    var safeToRemove = this.children_.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children_.remove(childKey);
                    }
                }
                if (this.children_.isEmpty()) {
                    this.children_ = null;
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param {!Path} prefixPath Path to look up node for.
     * @param {!Function} func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value_ !== null) {
            func(prefixPath, this.value_);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param {!Function} func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        if (this.children_ !== null) {
            this.children_.each(function (key, tree) {
                func(key, tree);
            });
        }
    };
    return SparseSnapshotTree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredValue = function (value, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    else {
        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = function (tree, serverValues) {
    var resolvedTree = new SparseSnapshotTree();
    tree.forEachTree(new Path(''), function (path, node) {
        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = function (node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode(value, nodeFromJSON$1(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode(priority));
        }
        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */ path, 
    /**@inheritDoc */ affectedTree, 
    /**@inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path(childName));
            return new AckUserWrite(Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap(stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        util.forEach(obj, function (childPath, childSnap) {
            tree = tree.set(new Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /**@inheritDoc */ source, 
    /**@inheritDoc */ path, 
    /**@inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite(this.source, Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path.Empty, childTree);
            }
        }
        else {
            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
                }
                else {
                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap_ = {};
    }
    /**
     * @param {!Change} change
     */
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey /** @type {!string} */ = change.childName;
        util.assert(type == Change.CHILD_ADDED ||
            type == Change.CHILD_CHANGED ||
            type == Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = util.safeGet(this.changeMap_, childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == Change.CHILD_ADDED && oldType == Change.CHILD_REMOVED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_ADDED) {
                delete this.changeMap_[childKey];
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childRemovedChange(childKey, oldChange.oldSnap);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_ADDED) {
                this.changeMap_[childKey] = Change.childAddedChange(childKey, change.snapshotNode);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
            }
            else {
                throw util.assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap_[childKey] = change;
        }
    };
    /**
     * @return {!Array.<!Change>}
     */
    ChildChangeAccumulator.prototype.getChanges = function () {
        return util.getValues(this.changeMap_);
    };
    return ChildChangeAccumulator;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        util.assert(viewCache
            .getEventCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        util.assert(viewCache
            .getServerCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw util.assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap
                        .getNode()
                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
                !eventSnap
                    .getNode()
                    .getPriority()
                    .equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode
                        ? serverCache
                        : ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    util.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache
            .getServerCache()
            .getNode()
            .isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache
                    .getEventCache()
                    .getNode()
                    .hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw util.assertionError('Should only compare child_ events.');
        }
        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === OperationType.MERGE &&
            operation.source.queryId !== null) {
            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         *
         * @type {!Object.<!string, !View>}
         * @private
         */
        this.views_ = {};
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
            return __referenceConstructor$1;
        },
        set: function (val) {
            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
            __referenceConstructor$1 = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.isEmpty = function () {
        return util.isEmpty(this.views_);
    };
    /**
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} optCompleteServerCache
     * @return {!Array.<!Event>}
     */
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = util.safeGet(this.views_, queryId);
            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events_1 = [];
            util.forEach(this.views_, function (key, view) {
                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
            });
            return events_1;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = util.safeGet(this.views_, queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache(new CacheNode(
            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode(
            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
            view = new View(query, viewCache);
            this.views_[queryId] = view;
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            // When you do ref.off(...), we search all views for the registration to remove.
            var self_1 = this;
            util.forEach(this.views_, function (viewQueryId, view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete self_1.views_[viewQueryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            });
        }
        else {
            // remove the callback from the specific view.
            var view = util.safeGet(this.views_, queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete this.views_[queryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    /**
     * @return {!Array.<!View>}
     */
    SyncPoint.prototype.getQueryViews = function () {
        var _this = this;
        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
        return values.filter(function (view) {
            return !view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
    };
    /**
     *
     * @param {!Path} path The path to the desired complete snapshot
     * @return {?Node} A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var serverCache = null;
        util.forEach(this.views_, function (key, view) {
            serverCache = serverCache || view.getCompleteServerCache(path);
        });
        return serverCache;
    };
    /**
     * @param {!Query} query
     * @return {?View}
     */
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return util.safeGet(this.views_, queryId);
        }
    };
    /**
     * @param {!Query} query
     * @return {boolean}
     */
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    /**
     * @return {?View}
     */
    SyncPoint.prototype.getCompleteView = function () {
        var completeView = util.findValue(this.views_, function (view) {
            return view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
        return completeView || null;
    };
    return SyncPoint;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.<!Node>} writeTree
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    /**
     * @param {!Path} path
     * @param {!Node} node
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    /**
     * @param {!Path} path
     * @param {!Object.<string, !Node>} updates
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        util.forEach(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param {!Path} path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param {!Path} path The path to check for
     * @return {boolean} Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param {!Path} path The path to get a complete write
     * @return {?Node} The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return {!Array.<NamedNode>} A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    /**
     * @param {!Path} path
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return {boolean} Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param {!Node} node The node to apply this CompoundWrite to
     * @return {!Node} The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return CompoundWrite.applySubtreeWrite_(Path.Empty, this.writeTree_, node);
    };
    /**
     * @type {!CompoundWrite}
     */
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
    /**
     * @param {!Path} relativePath
     * @param {!ImmutableTree.<!Node>} writeTree
     * @param {!Node} node
     * @return {!Node}
     * @private
     */
    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
        if (writeTree.value != null) {
            // Since there a write is always a leaf, we're done here
            return node.updateChild(relativePath, writeTree.value);
        }
        else {
            var priorityWrite_1 = null;
            writeTree.children.inorderTraversal(function (childKey, childTree) {
                if (childKey === '.priority') {
                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                    // to apply priorities to empty nodes that are later filled
                    util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                    priorityWrite_1 = childTree.value;
                }
                else {
                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
                }
            });
            // If there was a priority write, we only apply it if the node is not empty
            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
            }
            return node;
        }
    };
    return CompoundWrite;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                util.forEach(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    /**
     * @param {!WriteRecord} writeRecord
     * @param {!Path} path
     * @return {boolean}
     * @private
     */
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            // findKey can return undefined, so use !! to coerce to boolean
            return !!util.findKey(writeRecord.children, function (childSnap, childName) {
                return writeRecord.path.child(childName).contains(path);
            });
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     * @private
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     *
     * @param {!WriteRecord} write
     * @return {boolean}
     * @private
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     *
     * @param {!Array.<!WriteRecord>} writes
     * @param {!function(!WriteRecord):boolean} filter
     * @param {!Path} treeRoot
     * @return {!CompoundWrite}
     * @private
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
                        }
                        else {
                            var child = util.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
                            }
                        }
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else {
                    throw util.assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         * @type {!ImmutableTree.<!SyncPoint>}
         * @private
         */
        this.syncPointTree_ = ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         * @type {!WriteTree}
         * @private
         */
        this.pendingWriteTree_ = new WriteTree();
        this.tagToQueryMap_ = {};
        this.queryToTagMap_ = {};
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @param {number} writeId
     * @param {boolean=} visible
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param {!number} writeId
     * @param {boolean=} revert True if the given write failed and needs to be reverted
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
            }
            else {
                util.forEach(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @param {!Path} path
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree.fromObject(changedChildren);
            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @param {!Path} path
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            util.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap_[queryKey] = tag;
            // Coerce to string to avoid sparse arrays.
            this.tagToQueryMap_['_' + tag] = queryKey;
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
                else {
                    // There's nothing below us, so nothing we need to start listening on
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        else {
            // No-op, this listener must've been already removed
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     * @param {!Path} path The path to the data we want
     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
     * @return {?Node}
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     *
     * @param {!ImmutableTree.<!SyncPoint>} subtree
     * @return {!Array.<!View>}
     * @private
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                util.forEach(childMap, function (key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    /**
     * @param {!Array.<!Query>} queries
     * @private
     */
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
                delete this.queryToTagMap_[removedQueryKey];
                delete this.tagToQueryMap_['_' + removedQueryTag];
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     * @param {!Query} query
     * @return {!Query} The normalized query
     * @private
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return /** @type {!Query} */ query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @param {!Query} query
     * @param {!View} view
     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
     * @private
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    util.forEach(childMap, function (key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    /**
     *
     * @param {!View} view
     * @return {{hashFn: function(), onComplete: function(!string, *)}}
     * @private
     */
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error$$1 = errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error$$1);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     * @private
     * @param {!Query} query
     * @return {string}
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     * @private
     * @param {!string} queryKey
     * @return {{queryId: !string, path: !Path}}
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     * @param {!number} tag
     * @return {?string}
     * @private
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap_['_' + tag];
    };
    /**
     * Return the tag associated with the given query.
     * @param {!Query} query
     * @return {?number}
     * @private
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return util.safeGet(this.queryToTagMap_, queryKey);
    };
    /**
     * Static accessor for query tags.
     * @return {number}
     * @private
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     *
     * @param {!Path} queryPath
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
  
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
  
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     *
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     * @type {number}
     * @private
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
        // .catch
        function (error$$1) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error$$1 && error$$1.code === 'auth/token-not-initialized') {
                log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error$$1);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        warn(errorMessage);
    };
    return AuthTokenProvider;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!util.contains(this.counters_, name))
            this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return util.deepCopy(this.counters_);
    };
    return StatsCollection;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = util.clone(newStats);
        if (this.last_) {
            util.forEach(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        util.forEach(stats, function (stat, value) {
            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (logger$1) {
                    log('event: ' + eventData.toString());
                }
                exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = this.listeners_[eventType].slice();
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        util.assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !util.isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = 'start';
var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = logWrapper(connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        executeWhenDOMReady(function () {
            if (_this.isClosed_)
                return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var command = args[0], arg1 = args[1], arg2 = args[2];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder)
                    return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pN = args[0], data = args[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (!util.isNodeSdk() &&
                typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(FORGE_DOMAIN) !== -1) {
                urlParams[REFERER_PARAM] = FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return (BrowserPollConnection.forceAllow_ ||
            (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !isChromeExtensionContentScript() &&
                !isWindowsStoreApp() &&
                !util.isNodeSdk()));
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = util.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if (util.isNodeSdk())
            return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = util.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        /**
         * @type {CountedSet.<number, number>}
         */
        this.outstandingRequests = new CountedSet();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!util.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = LUIDGenerator();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                log('frame writing exception');
                if (e.stack) {
                    log(e.stack);
                }
                log(e);
            }
        }
        else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        }
        else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        if (util.isNodeSdk() && this.myID) {
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            var theURL = this.urlFn(urlParams);
            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial, 1);
        var doNewRequest = function () {
            _this.outstandingRequests.remove(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if (util.isNodeSdk()) {
            this.doNodeLongPoll(url, loadCB);
        }
        else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls)
                        return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = logWrapper(this.connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
        if (!util.isNodeSdk() &&
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(FORGE_DOMAIN) !== -1) {
            urlParams[REFERER_PARAM] = FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        PersistentStorage.set('previous_websocket_failure', true);
        try {
            if (util.isNodeSdk()) {
                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + firebase.SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = process['env'];
                var proxy = this.connURL.indexOf('wss://') == 0
                    ? env['HTTPS_PROXY'] || env['https_proxy']
                    : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
            else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error$$1 = e.message || e.data;
            if (error$$1) {
                this.log_(error$$1);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error$$1 = e.message || e.data;
            if (error$$1) {
                _this.log_(error$$1);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (PersistentStorage.isInMemoryStorage ||
            PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = util.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        util.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null)
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection, WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable)
                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection];
        }
        else {
            var transports_1 = (this.transports_ = []);
            each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
                if (transport && transport['isAvailable']()) {
                    transports_1.push(transport);
                }
            });
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        }
        else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (PROTOCOL_VERSION !== version) {
                warn('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param onConnectStatus_
     * @param onServerInfoUpdate_
     * @param authTokenProvider_
     * @param authOverride_
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = logWrapper('p:' + _this.id + ':');
        /** @private {Object} */
        _this.interruptReasons_ = {};
        _this.listens_ = {};
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        /** @private {number|null} */
        _this.establishConnectionTimer_ = null;
        /** @private {boolean} */
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        /** @private {?{
         *   sendRequest(Object),
         *   close()
         * }} */
        _this.realtime_ = null;
        /** @private {string|null} */
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !util.isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    /**
     * @param {!string} action
     * @param {*} body
     * @param {function(*)=} onResponse
     * @protected
     */
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(util.stringify(msg));
        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        this.listens_[pathString] = this.listens_[pathString] || {};
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        util.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens_[pathString][queryId] = listenSpec;
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    /**
     * @param {!{onComplete(),
     *           hashFn():!string,
     *           query: !Query,
     *           tag: ?number}} listenSpec
     * @private
     */
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[ /*hash*/'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message[ /*data*/'d'];
            var status = message[ /*status*/'s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    /**
     * @param {*} payload
     * @param {!Query} query
     * @private
     */
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
            var warnings = util.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' +
                    query
                        .getQueryParams()
                        .getIndex()
                        .toString() +
                    '"';
                var indexPath = query.path.toString();
                warn("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    /**
     * @param {!string} credential
     * @private
     */
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || util.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res[ /*status*/'s'];
                var data = res[ /*data*/'d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined)
            request[ /*hash*/'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete)
                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result[ /*status*/'s'];
                if (status !== 'ok') {
                    var errorReason = result[ /* data */'d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    /**
     * @param {*} message
     * @private
     */
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + util.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[ /*body*/'b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge*/ false, body['t']);
        else if (action === 'm')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge=*/ true, body['t']);
        else if (action === 'c')
            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
        else if (action === 'ac')
            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
        else if (action === 'sd')
            this.onSecurityDebugPacket_(body);
        else
            error('Unrecognized action received from server: ' +
                util.stringify(action) +
                '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    /**
     * @param {boolean} visible
     * @private
     */
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error$$1) {
                self_1.log_('Failed to get token: ' + error$$1);
                if (!canceled_1) {
                    if (util.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        warn(error$$1);
                    }
                    closeFn_1();
                }
            });
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.interrupt = function (reason) {
        log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.resume = function (reason) {
        log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (util.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete)
                    put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0)
            this.outstandingPuts_ = [];
    };
    /**
     * @param {!string} pathString
     * @param {Array.<*>=} query
     * @private
     */
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete)
            listen.onComplete('permission_denied');
    };
    /**
     * @param {!string} pathString
     * @param {!string} queryId
     * @return {{queries:Array.<Query>, onComplete:function(string)}}
     * @private
     */
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens_[normalizedPathString] !== undefined) {
            listen = this.listens_[normalizedPathString][queryId];
            delete this.listens_[normalizedPathString][queryId];
            if (util.getCount(this.listens_[normalizedPathString]) === 0) {
                delete this.listens_[normalizedPathString];
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body) {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var _this = this;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        util.forEach(this.listens_, function (pathString, queries) {
            util.forEach(queries, function (key, listenSpec) {
                _this.sendListen_(listenSpec);
            });
        });
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i])
                this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     * @private
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (util.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        }
        else if (util.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + firebase.SDK_VERSION.replace(/\./g, '-')] = 1;
        if (util.isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (util.isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    /**
     * @return {boolean}
     * @private
     */
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor.getInstance().currentlyOnline();
        return util.isEmpty(this.interruptReasons_) && online;
    };
    /**
     * @private
     */
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     * @type {number}
     * @private
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParamaters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParamaters, function (error$$1, result) {
            var data = result;
            if (error$$1 === 404) {
                data = null;
                error$$1 = null;
            }
            if (error$$1 === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (util.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error$$1) {
                    status_1 = 'ok';
                }
                else if (error$$1 == 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error$$1;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                util.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = util.jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            warn('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            warn('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo_
     * @param {boolean} forceRestClient
     * @param {!FirebaseApp} app
     */
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        // A list of data pieces and paths to be set when this client disconnects.
        this.onDisconnect_ = new SparseSnapshotTree();
        /**
         * TODO: This should be @private but it's used by test_access.js and internal.js
         * @type {?PersistentConnection}
         */
        this.persistentConnection_ = null;
        /** @type {!AuthTokenProvider} */
        var authTokenProvider = new AuthTokenProvider(app);
        this.stats_ = StatsManager.getCollection(repoInfo_);
        if (forceRestClient || beingCrawled()) {
            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    util.stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder();
        this.infoSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return {string}  The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return {!string} The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     * @return {!Object}
     */
    Repo.prototype.generateServerValues = function () {
        return generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     *
     * @private
     * @param {string} pathString
     * @param {*} data
     * @param {boolean} isMerge
     * @param {?number} tag
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = util.map(data, function (raw) {
                    return nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = util.map(data, function (raw) {
                return nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    /**
     * TODO: This should be @private but it's used by test_access.js and internal.js
     * @param {?function(!string, *):*} callback
     * @private
     */
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    /**
     * @param {!boolean} connectStatus
     * @private
     */
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    /**
     * @param {!Object} updates
     * @private
     */
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        each(updates, function (value, key) {
            _this.updateInfo_(key, value);
        });
    };
    /**
     *
     * @param {!string} pathString
     * @param {*} value
     * @private
     */
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path('/.info/' + pathString);
        var newNode = nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    /**
     * @return {!number}
     * @private
     */
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    /**
     * @param {!Path} path
     * @param {*} newVal
     * @param {number|string|null} newPriority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                warn('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    /**
     * @param {!Path} path
     * @param {!Object} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        util.forEach(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = nodeFromJSON$1(changedValue);
            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    warn('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            util.forEach(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     * @private
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
    };
    /**
     * @param {!Path} path
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {*} priority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (util.isEmpty(childrenToMerge)) {
            log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                util.forEach(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON$1(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     */
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    /**
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration
     */
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined')
            return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_)
                this.statsListener_ = new StatsListener(this.stats_);
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        util.forEach(stats, function (stat, value) {
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++)
                stat += ' ';
            console.log(stat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    /**
     * @param {...*} var_args
     * @private
     */
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
    /**
     * @param {?function(?Error, *=)} callback
     * @param {!string} status
     * @param {?string=} errorReason
     */
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            exceptionGuard(function () {
                if (status == 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason)
                        message += ': ' + errorReason;
                    var error$$1 = new Error(message);
                    error$$1.code = code;
                    callback(error$$1);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        util.assert(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        util.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter(this);
        }
        else {
            return new RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference = /** @class */ (function (_super) {
    tslib_1.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        util.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty())
            return null;
        else
            return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        util.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path)) {
            if (this.path.getFront() === null)
                validateRootPathString('Reference.child', 1, pathString, false);
            else
                validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        util.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        util.validateArgCount('Reference.set', 1, 2, arguments.length);
        validateWritablePath('Reference.set', this.path);
        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        util.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('Reference.update', 1, 2, arguments.length);
        validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        util.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('Reference.setWithPriority', this.path);
        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validatePriority('Reference.setWithPriority', 2, newPriority, false);
        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.';
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
        validateWritablePath('Reference.remove', this.path);
        util.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validateWritablePath('Reference.transaction', this.path);
        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        util.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.';
        if (applyLocally === undefined)
            applyLocally = true;
        var deferred = new util.Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error$$1, committed, snapshot) {
            if (error$$1) {
                deferred.reject(error$$1);
            }
            else {
                deferred.resolve(new TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error$$1, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validateWritablePath('Reference.setPriority', this.path);
        validatePriority('Reference.setPriority', 1, priority, false);
        util.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        util.validateArgCount('Reference.push', 0, 2, arguments.length);
        validateWritablePath('Reference.push', this.path);
        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        util.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validateWritablePath('Reference.onDisconnect', this.path);
        return new OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(Query));
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query.__referenceConstructor = Reference;
SyncPoint.__referenceConstructor = Reference;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
        var child = this, next;
        while ((next = path.getFront()) !== null) {
            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        util.forEach(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst)
            action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst)
            action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null)
                action(child);
            else
                child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null)
            this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = util.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            util.contains(newVal, '.priority')) {
            priorityForNode = util.safeGet(newVal, '.priority');
            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        util.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference(_this, queue[i].path);
                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    else
                        queue[i].status = TransactionStatus.RUN;
                }
            }
            else {
                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        util.contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null &&
        transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
                // Already marked.  No action needed.
            }
            else if (queue[i].status === TransactionStatus.SENT) {
                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            exceptionGuard(callbacks[i]);
        }
    }
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @const {string} */
var DATABASE_URL_OPTION = 'databaseURL';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            fatal("Can't determine Firebase Database URL.  Be sure to include " +
                DATABASE_URL_OPTION +
                ' option when calling firebase.initializeApp().');
        }
        var parsedUrl = parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = util.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = util.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = util.safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo)) {
            fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference(repo_, Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    Database.prototype.ref = function (path) {
        this.checkDeleted_('ref');
        util.validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof Reference) {
            return this.refFromURL(path.toString());
        }
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        util.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parseRepoInfo(url);
        validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}());
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.database.checkDeleted_('delete');
                RepoManager.getInstance().deleteRepo(this.database.repo_);
                this.database.repo_ = null;
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
var forceLongPolling = function () {
    WebSocketConnection.forceDisallow();
    BrowserPollConnection.forceAllow();
};
var forceWebSockets = function () {
    BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = function () {
    return WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = function (ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

var INTERNAL = /*#__PURE__*/Object.freeze({
  forceLongPolling: forceLongPolling,
  forceWebSockets: forceWebSockets,
  isWebSocketsAvailable: isWebSocketsAvailable,
  setSecurityDebugCallback: setSecurityDebugCallback,
  stats: stats,
  statsIncrementCounter: statsIncrementCounter,
  dataUpdateCount: dataUpdateCount,
  interceptServerData: interceptServerData
});

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = function (newHash) {
    var oldPut = PersistentConnection.prototype.put;
    PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
var listens = function (firebaseRef) {
    return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = function (forceRestClient) {
    RepoManager.getInstance().forceRestClient(forceRestClient);
};

var TEST_ACCESS = /*#__PURE__*/Object.freeze({
  DataConnection: DataConnection,
  RealTimeConnection: RealTimeConnection,
  hijackHash: hijackHash,
  ConnectionTarget: ConnectionTarget,
  queryIdentifier: queryIdentifier,
  listens: listens,
  forceRestClient: forceRestClient
});

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager.getInstance().databaseFromApp(app, url); }, 
    // firebase.database namespace properties
    {
        Reference: Reference,
        Query: Query,
        Database: Database,
        enableLogging: enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if (util.isNodeSdk()) {
        module.exports = namespace;
    }
}
registerDatabase(firebase);

exports.registerDatabase = registerDatabase;
exports.Database = Database;
exports.Query = Query;
exports.Reference = Reference;
exports.enableLogging = enableLogging;
exports.ServerValue = ServerValue;
exports.DataSnapshot = DataSnapshot;
exports.OnDisconnect = OnDisconnect;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel)
        return;
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    };
    return Logger;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}




/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(setImmediate, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);


// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = Promise;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document) && _isObject(document.createElement);
var _domCreate = function (it) {
  return is ? document.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

_core.inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});
var _shared = function (key) {
  return store[key] || (store[key] = {});
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var SPECIES = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $find = _arrayMethods(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY);

var find = _core.Array.find;

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $find$1 = _arrayMethods(6);
var KEY$1 = 'findIndex';
var forced$1 = true;
// Shouldn't skip holes
if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY$1);

var findIndex = _core.Array.findIndex;

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = _stringContext(this, searchString, STARTS_WITH);
    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

var startsWith = _core.String.startsWith;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(231).setImmediate, __webpack_require__(24)))

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = __webpack_require__(944);


/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemoryStorage = function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);

    this._data = {};
  }

  _createClass(MemoryStorage, [{
    key: "getItem",
    value: function getItem(key) {
      return this._data.hasOwnProperty(key) ? this._data[key] : null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return this._data[key] = String(value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return delete this._data[key];
    }
  }, {
    key: "clear",
    value: function clear() {
      return this._data = {};
    }
  }]);

  return MemoryStorage;
}();

exports.default = MemoryStorage;

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSupported;

var _CookieStorage = __webpack_require__(924);

var TEST_KEY = '__test';

function hasStorage(name) {
  try {
    var storage = window[name];
    storage.setItem(TEST_KEY, '1');
    storage.removeItem(TEST_KEY);
    return true;
  } catch (e) {
    return false;
  }
}

function isSupported() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';

  var storage = String(name).replace(/storage$/i, '').toLowerCase();

  if (storage === 'local') {
    return hasStorage('localStorage');
  }

  if (storage === 'session') {
    return hasStorage('sessionStorage');
  }

  if (storage === 'cookie') {
    return (0, _CookieStorage.hasCookies)();
  }

  if (storage === 'memory') {
    return true;
  }

  throw new Error('Storage method `' + name + '` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage.');
}

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1088)
  __webpack_require__(1089)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(1105),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dc463cd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 952:
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _webAudioPlayer = __webpack_require__(989);

var _webAudioPlayer2 = _interopRequireDefault(_webAudioPlayer);

var _has = __webpack_require__(102);

var _has2 = _interopRequireDefault(_has);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _union = __webpack_require__(230);

var _union2 = _interopRequireDefault(_union);

var _isUndefined = __webpack_require__(85);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _split = __webpack_require__(345);

var _split2 = _interopRequireDefault(_split);

var _compact = __webpack_require__(922);

var _compact2 = _interopRequireDefault(_compact);

var _toString = __webpack_require__(25);

var _toString2 = _interopRequireDefault(_toString);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _axios = __webpack_require__(229);

var _axios2 = _interopRequireDefault(_axios);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

var _localStorageFallback = __webpack_require__(932);

var _localStorageFallback2 = _interopRequireDefault(_localStorageFallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__(349);

exports.default = {
  data: function data() {
    return {
      defaultTermId: 325163,
      defaultSectionName: 'Best of abacus'
    };
  },
  mounted: function mounted() {
    var _this = this;

    try {
      if (!(0, _has2.default)(this, '$root.audio1')) {
        this.$root.audio1 = false;
        var audio1 = (0, _webAudioPlayer2.default)('/static/sounds/littlerobotsoundfactory-03.mp3', {
          buffer: true
        });
        audio1.on('load', function () {
          _this.$root.audio1 = audio1;
          if (!(0, _has2.default)(_this, '$root.audio2')) {
            _this.$root.audio2 = false;
            var audio2 = (0, _webAudioPlayer2.default)('/static/sounds/littlerobotsoundfactory-01.mp3', {
              buffer: true,
              context: _this.$root.audio1.context
            });
            audio2.on('load', function () {
              _this.$root.audio2 = audio2;
            });
          }
        });
      }
    } catch (e) {
      console.log(e);
      console.log('Browser do not support web audio player.');
    }
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleNewsletter']), {
    validateEmail: function validateEmail(email) {
      var checking = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return checking.test(email);
    },
    play1: function play1() {
      if (this.$root.audio1) {
        try {
          this.$root.audio1.play();
          this.$root.audio1.node.connect(this.$root.audio1.context.destination);
        } catch (e) {
          console.log(e);
          console.log('Browser do not support web audio player.');
        }
      }
    },
    play2: function play2() {
      if (this.$root.audio2) {
        try {
          this.$root.audio2.play();
          this.$root.audio2.node.connect(this.$root.audio1.context.destination);
        } catch (e) {
          console.log(e);
          console.log('Browser do not support web audio player.');
        }
      }
    },
    subscribeNewsletter: function subscribeNewsletter(email, section, gtmNewsletterCategory) {
      var _this2 = this;

      var endpoint = (0, _get2.default)(this, '$store.state.settings.NEWSLETTER_API_ENDPOINT');
      var termId = (0, _get2.default)(section, 'tid', this.defaultTermId);
      var appId = (0, _get2.default)(config, 'APP_TID');
      var entityType = 'taxonomy_term';
      var sectionName = (0, _get2.default)(section, 'name', this.defaultSectionName);

      if (email && endpoint && termId && appId) {
        _axios2.default.post('' + endpoint, {
          email: email,
          id: termId,
          entity_type: entityType,
          app_id: appId
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response.data.status === 'success') {
            if (gtmNewsletterCategory) {
              _this2.updateStorageList(termId);

              _gtmManager2.default.pushTracker({
                category: gtmNewsletterCategory,
                action: 'Newsletter Sign Up',
                label: sectionName
              });
            }
            return true;
          }
          return false;
        });
      }
      return false;
    },
    checkSubscribedToList: function checkSubscribedToList(section) {
      var originalList = this.getOriginalStorageList();
      var termId = (0, _get2.default)(section, 'tid', this.defaultTermId);

      if ((0, _includes2.default)(originalList, termId)) {
        this.toggleNewsletter(false);
        return;
      }
      this.toggleNewsletter(true);
    },
    getOriginalStorageList: function getOriginalStorageList() {
      var getStorageData = _localStorageFallback2.default.getItem('nwsltrs_subscribed');
      return !(0, _isUndefined2.default)(getStorageData) ? (0, _compact2.default)((0, _map2.default)((0, _split2.default)(getStorageData, ','), Number)) : [];
    },
    updateStorageList: function updateStorageList(appendTermId) {
      var originalList = this.getOriginalStorageList();
      var newList = (0, _union2.default)(originalList, [appendTermId]);
      _localStorageFallback2.default.setItem('nwsltrs_subscribed', (0, _toString2.default)(newList));
    }
  })
};

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _utilities = __webpack_require__(51);

var _realtimeData = __webpack_require__(938);

var _realtimeData2 = _interopRequireDefault(_realtimeData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'speech-balloon-label',
  mixins: [_realtimeData2.default],
  props: {
    node: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    size: {
      type: String,
      default: 'medium'
    },
    mainComponent: {
      type: String,
      default: 'default'
    },
    showShadow: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.isLiveArticle) {
      this.initRealtimeData({ modeType: 'live', nid: this.node.nid });
    }
  },

  computed: {
    articleType: function articleType() {
      return (0, _utilities.getArticleType)(this.node);
    },
    baseClasses: function baseClasses() {
      return 'articleLabel articleLabel__' + this.articleType + ' font size--' + this.size + ' pos pos--' + this.mainComponent;
    },
    isLiveArticle: function isLiveArticle() {
      return this.articleType === 'live';
    },
    liveStatus: function liveStatus() {
      if (this.isLiveArticle) {
        var status = (0, _get2.default)(this, 'node.live_contents.status', false);
        return status === 1;
      }
      return false;
    },
    showLabel: function showLabel() {
      return this.isLiveArticle ? this.liveStatus : true;
    }
  }
};

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".articleLabel-container[data-v-3e9e2064]{height:0;z-index:1;position:relative}.article-view-wrapper .node-type-opinion .articleLabel-container[data-v-3e9e2064],.articleLabel-container--article-cover-card[data-v-3e9e2064]{position:static}.articleLabel[data-v-3e9e2064]{color:#fff;padding:.3125rem .75rem 0 .6875rem;height:2.1875rem;min-width:4.8125rem;background-color:#000;position:relative;margin-bottom:.6875rem}.articleLabel[data-v-3e9e2064]:after{position:absolute;z-index:1;bottom:-.625rem;left:0;content:\"\";border-top:.6875rem solid #000;border-right:.6875rem solid transparent;border-left:0 solid transparent}.articleLabel__live[data-v-3e9e2064]{background-color:red;position:relative;margin-bottom:.6875rem}.articleLabel__live[data-v-3e9e2064]:after{position:absolute;z-index:1;bottom:-.625rem;left:0;content:\"\";border-top:.6875rem solid red;border-right:.6875rem solid transparent;border-left:0 solid transparent}.articleLabel__live[data-v-3e9e2064]:before{content:\"\";display:inline-block;vertical-align:middle;background-color:#fff;border-radius:50%;height:.4375rem;width:.4375rem;margin-right:.25rem;margin-top:-.3125rem}.articleLabel__live.showShadow[data-v-3e9e2064]{background-color:rgba(0,0,0,.2);position:relative;margin-bottom:.625rem}.articleLabel__live.showShadow[data-v-3e9e2064]:after{position:absolute;z-index:1;bottom:-.625rem;left:0;content:\"\";border-top:.625rem solid rgba(0,0,0,.2);border-right:.6875rem solid transparent;border-left:0 solid transparent}.articleLabel__live.showShadow[data-v-3e9e2064]:before{background-color:transparent}.articleLabel__opinion[data-v-3e9e2064]{background-color:#000;position:relative;margin-bottom:.6875rem}.articleLabel__opinion[data-v-3e9e2064]:after{position:absolute;z-index:1;bottom:-.625rem;left:0;content:\"\";border-top:.6875rem solid #000;border-right:.6875rem solid transparent;border-left:0 solid transparent}.showShadow[data-v-3e9e2064]{color:transparent}.font[data-v-3e9e2064]{font-family:Barlow,sans-serif;font-weight:700;text-transform:uppercase;white-space:nowrap;font-size:1.3125rem;line-height:1.5625rem}.size--small-responsive[data-v-3e9e2064],.size--small[data-v-3e9e2064]{-webkit-transform:scale(.48571);-ms-transform:scale(.48571);transform:scale(.48571)}@media (min-width:1024px){.size--small-responsive[data-v-3e9e2064]{-webkit-transform:scale(.77143);-ms-transform:scale(.77143);transform:scale(.77143)}}.size--small-20-responsive[data-v-3e9e2064]{-webkit-transform:scale(.57143);-ms-transform:scale(.57143);transform:scale(.57143)}@media (min-width:1024px){.size--small-20-responsive[data-v-3e9e2064]{-webkit-transform:scale(.97143);-ms-transform:scale(.97143);transform:scale(.97143)}}.size--medium[data-v-3e9e2064]{-webkit-transform:scale(.77143);-ms-transform:scale(.77143);transform:scale(.77143)}.size--large-responsive[data-v-3e9e2064],.size--large[data-v-3e9e2064]{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}@media (min-width:1024px){.size--large-responsive[data-v-3e9e2064]{-webkit-transform:scale(1.51429);-ms-transform:scale(1.51429);transform:scale(1.51429)}}.pos[data-v-3e9e2064]{position:absolute;z-index:2}.pos.showShadow[data-v-3e9e2064]{position:absolute;z-index:1}.pos--article-cover-card[data-v-3e9e2064]{top:3.75rem;right:auto;left:1.25rem}@media (min-width:1024px){.pos--article-cover-card[data-v-3e9e2064]{top:5.8125rem;right:auto;left:10.625rem}}.pos--article-cover-card.showShadow[data-v-3e9e2064]{top:3.9375rem;right:auto;left:1.4375rem}@media (min-width:1024px){.pos--article-cover-card.showShadow[data-v-3e9e2064]{top:6.0625rem;right:auto;left:10.875rem}}.pos--article-level-one[data-v-3e9e2064]{top:-.25rem;right:auto;left:-.875rem}@media (min-width:1024px){.pos--article-level-one[data-v-3e9e2064]{top:-.25rem;right:auto;left:-.875rem}}.pos--article-level-one.showShadow[data-v-3e9e2064]{top:-.0625rem;right:auto;left:-.6875rem}@media (min-width:1024px){.pos--article-level-one.showShadow[data-v-3e9e2064]{top:0;right:auto;left:-.625rem}}.pos--article-level-one__node-label[data-v-3e9e2064]{top:-1.1875rem;right:auto;left:-1.375rem;position:relative}@media (min-width:1024px){.pos--article-level-one__node-label[data-v-3e9e2064]{top:-1.5rem;right:auto;left:-.125rem}}.pos--article-level-one__node-label.showShadow[data-v-3e9e2064]{top:-1rem;right:auto;left:-1.1875rem}@media (min-width:1024px){.pos--article-level-one__node-label.showShadow[data-v-3e9e2064]{top:-1.25rem;right:auto;left:.125rem}}.pos--article-level-two[data-v-3e9e2064]{top:.125rem;right:auto;left:-.1875rem}@media (min-width:1024px){.pos--article-level-two[data-v-3e9e2064]{top:.125rem;right:auto;left:-.1875rem}}.pos--article-level-two.showShadow[data-v-3e9e2064]{top:.3125rem;right:auto;left:0}@media (min-width:1024px){.pos--article-level-two.showShadow[data-v-3e9e2064]{top:.375rem;right:auto;left:.0625rem}}.pos--article-level-seven[data-v-3e9e2064],.pos--article-level-six[data-v-3e9e2064]{top:.4375rem;right:auto;left:.0625rem}@media (min-width:1024px){.pos--article-level-seven[data-v-3e9e2064],.pos--article-level-six[data-v-3e9e2064]{top:.4375rem;right:auto;left:.0625rem}}.pos--article-level-seven.showShadow[data-v-3e9e2064],.pos--article-level-six.showShadow[data-v-3e9e2064]{top:.625rem;right:auto;left:.25rem}@media (min-width:1024px){.pos--article-level-seven.showShadow[data-v-3e9e2064],.pos--article-level-six.showShadow[data-v-3e9e2064]{top:.6875rem;right:auto;left:.3125rem}}.pos--article-level-eight[data-v-3e9e2064]{top:-.5rem;right:-1.375rem;left:auto}@media (min-width:1024px){.pos--article-level-eight[data-v-3e9e2064]{top:-.5rem;right:-1.375rem;left:auto}}.pos--article-level-eight.showShadow[data-v-3e9e2064]{top:-.3125rem;right:-1.5625rem;left:auto}@media (min-width:1024px){.pos--article-level-eight.showShadow[data-v-3e9e2064]{top:-.25rem;right:-1.625rem;left:auto}}.pos--card-view[data-v-3e9e2064]{top:.9375rem;right:auto;left:-10rem}@media (min-width:1024px){.pos--card-view[data-v-3e9e2064]{top:.9375rem;right:auto;left:-10rem}}.pos--card-view.showShadow[data-v-3e9e2064]{top:1.125rem;right:auto;left:-9.8125rem}@media (min-width:1024px){.pos--card-view.showShadow[data-v-3e9e2064]{top:1.1875rem;right:auto;left:-9.75rem}}.pos--body-head__node-label[data-v-3e9e2064]{top:0;right:0;left:auto}@media (min-width:1024px){.pos--body-head__node-label[data-v-3e9e2064]{top:0;right:0;left:auto}}.pos--body-head__node-label.showShadow[data-v-3e9e2064]{top:.1875rem;right:-.1875rem;left:auto}@media (min-width:1024px){.pos--body-head__node-label.showShadow[data-v-3e9e2064]{top:.25rem;right:-.25rem;left:auto}}.pos--pushPopup[data-v-3e9e2064]{top:-.25rem;right:auto;left:-.9375rem}@media (min-width:1024px){.pos--pushPopup[data-v-3e9e2064]{top:-.25rem;right:auto;left:-.9375rem}}.pos--pushPopup.showShadow[data-v-3e9e2064]{top:-.0625rem;right:auto;left:-.75rem}@media (min-width:1024px){.pos--pushPopup.showShadow[data-v-3e9e2064]{top:0;right:auto;left:-.6875rem}}@media (min-width:1024px){.pos--pushPopup[data-v-3e9e2064]{top:.0625rem;right:auto;left:-.25rem}}@media (min-width:1024px) and (min-width:1024px){.pos--pushPopup[data-v-3e9e2064]{top:.0625rem;right:auto;left:-.25rem}}@media (min-width:1024px){.pos--pushPopup.showShadow[data-v-3e9e2064]{top:.25rem;right:auto;left:-.0625rem}}@media (min-width:1024px) and (min-width:1024px){.pos--pushPopup.showShadow[data-v-3e9e2064]{top:.3125rem;right:auto;left:0}}.animate__live[data-v-3e9e2064]{-webkit-animation:colorchangeBox-data-v-3e9e2064 1s infinite;animation:colorchangeBox-data-v-3e9e2064 1s infinite}.animate__live[data-v-3e9e2064]:before{-webkit-animation:colorchangeDot-data-v-3e9e2064 1s infinite;animation:colorchangeDot-data-v-3e9e2064 1s infinite}.animate__live[data-v-3e9e2064]:after{-webkit-animation:colorchangeArrow-data-v-3e9e2064 1s infinite;animation:colorchangeArrow-data-v-3e9e2064 1s infinite}@-webkit-keyframes colorchangeBox{0%{background-color:red}to{background-color:#f66}}@keyframes colorchangeBox-data-v-3e9e2064{0%{background-color:red}to{background-color:#f66}}@-webkit-keyframes colorchangeDot{0%{opacity:.6}to{opacity:1}}@keyframes colorchangeDot-data-v-3e9e2064{0%{opacity:.6}to{opacity:1}}@-webkit-keyframes colorchangeArrow{0%{border-top-color:red}to{border-top-color:#f66}}@keyframes colorchangeArrow-data-v-3e9e2064{0%{border-top-color:red}to{border-top-color:#f66}}", "", {"version":3,"sources":["/app/components/common/SpeechBalloonLabel.vue"],"names":[],"mappings":"AAgCA,yCACE,SAAU,AACV,UAAW,AACX,iBAAmB,CACpB,AAID,+IACI,eAAiB,CACpB,AACD,+BACE,WAAe,AACf,mCAAuC,AACvC,iBAAkB,AAClB,oBAAqB,AACrB,sBAA0B,AAC1B,kBAAmB,AACnB,sBAAyB,CAC1B,AACD,qCACI,kBAAmB,AACnB,UAAW,AACX,gBAAkB,AAClB,OAAQ,AACR,WAAY,AACZ,+BAAoC,AACpC,wCAA0C,AAC1C,+BAAiC,CACpC,AACD,qCACI,qBAA0B,AAC1B,kBAAmB,AACnB,sBAAyB,CAC5B,AACD,2CACM,kBAAmB,AACnB,UAAW,AACX,gBAAkB,AAClB,OAAQ,AACR,WAAY,AACZ,8BAAoC,AACpC,wCAA0C,AAC1C,+BAAiC,CACtC,AACD,4CACM,WAAY,AACZ,qBAAsB,AACtB,sBAAuB,AACvB,sBAA0B,AAC1B,kBAAmB,AACnB,gBAAkB,AAClB,eAAiB,AACjB,oBAAsB,AACtB,oBAAuB,CAC5B,AACD,gDACM,gCAAqC,AACrC,kBAAmB,AACnB,qBAAwB,CAC7B,AACD,sDACQ,kBAAmB,AACnB,UAAW,AACX,gBAAkB,AAClB,OAAQ,AACR,WAAY,AACZ,wCAA8C,AAC9C,wCAA0C,AAC1C,+BAAiC,CACxC,AACD,uDACQ,4BAA8B,CACrC,AACD,wCACI,sBAA0B,AAC1B,kBAAmB,AACnB,sBAAyB,CAC5B,AACD,8CACM,kBAAmB,AACnB,UAAW,AACX,gBAAkB,AAClB,OAAQ,AACR,WAAY,AACZ,+BAAoC,AACpC,wCAA0C,AAC1C,+BAAiC,CACtC,AACD,6BACE,iBAAmB,CACpB,AACD,uBACE,8BAAkC,AAClC,gBAAkB,AAClB,yBAA0B,AAC1B,mBAAoB,AACpB,oBAAqB,AACrB,qBAAuB,CACxB,AACD,uEACE,gCAAkC,AAC9B,4BAA8B,AAC1B,uBAA0B,CACnC,AAID,0BACA,yCACM,gCAAkC,AAC9B,4BAA8B,AAC1B,uBAA0B,CACvC,CACA,AACD,4CACE,gCAAkC,AAC9B,4BAA8B,AAC1B,uBAA0B,CAEnC,AACD,0BACA,4CACM,gCAAkC,AAC9B,4BAA8B,AAC1B,uBAA0B,CACvC,CACA,AACD,+BACE,gCAAkC,AAC9B,4BAA8B,AAC1B,uBAA0B,CACnC,AACD,uEACE,2BAA4B,AACxB,uBAAwB,AACpB,kBAAoB,CAC7B,AAID,0BACA,yCACM,iCAAkC,AAC9B,6BAA8B,AAC1B,wBAA0B,CACvC,CACA,AACD,sBACE,kBAAmB,AACnB,SAAW,CACZ,AACD,iCACI,kBAAmB,AACnB,SAAW,CACd,AACD,0CACI,YAAa,AACb,WAAY,AACZ,YAAc,CAEjB,AACD,0BACA,0CACQ,cAAe,AACf,WAAY,AACZ,cAAgB,CACvB,CACA,AACD,qDACM,cAAe,AACf,WAAY,AACZ,cAAgB,CAErB,AACD,0BACA,qDACU,cAAe,AACf,WAAY,AACZ,cAAgB,CACzB,CACA,AACD,yCACI,YAAc,AACd,WAAY,AACZ,aAAgB,CAEnB,AACD,0BACA,yCACQ,YAAc,AACd,WAAY,AACZ,aAAgB,CACvB,CACA,AACD,oDACM,cAAgB,AAChB,WAAY,AACZ,cAAiB,CAEtB,AACD,0BACA,oDACU,MAAO,AACP,WAAY,AACZ,aAAgB,CACzB,CACA,AACD,qDACM,eAAgB,AAChB,WAAY,AACZ,eAAgB,AAEhB,iBAAmB,CACxB,AACD,0BACA,qDACU,YAAa,AACb,WAAY,AACZ,aAAgB,CACzB,CACA,AACD,gEACQ,UAAW,AACX,WAAY,AACZ,eAAiB,CAExB,AACD,0BACA,gEACY,aAAc,AACd,WAAY,AACZ,YAAe,CAC1B,CACA,AACD,yCACI,YAAc,AACd,WAAY,AACZ,cAAiB,CAEpB,AACD,0BACA,yCACQ,YAAc,AACd,WAAY,AACZ,cAAiB,CACxB,CACA,AACD,oDACM,aAAe,AACf,WAAY,AACZ,MAAQ,CAEb,AACD,0BACA,oDACU,YAAc,AACd,WAAY,AACZ,aAAgB,CACzB,CACA,AACD,oFACI,aAAe,AACf,WAAY,AACZ,aAAgB,CAEnB,AACD,0BACA,oFACQ,aAAe,AACf,WAAY,AACZ,aAAgB,CACvB,CACA,AACD,0GACM,YAAc,AACd,WAAY,AACZ,WAAc,CAEnB,AACD,0BACA,0GACU,aAAe,AACf,WAAY,AACZ,aAAgB,CACzB,CACA,AACD,2CACI,WAAa,AACb,gBAAiB,AACjB,SAAW,CAEd,AACD,0BACA,2CACQ,WAAa,AACb,gBAAiB,AACjB,SAAW,CAClB,CACA,AACD,sDACM,cAAgB,AAChB,iBAAkB,AAClB,SAAW,CAEhB,AACD,0BACA,sDACU,YAAc,AACd,gBAAiB,AACjB,SAAW,CACpB,CACA,AACD,iCACI,aAAe,AACf,WAAY,AACZ,WAAa,CAEhB,AACD,0BACA,iCACQ,aAAe,AACf,WAAY,AACZ,WAAa,CACpB,CACA,AACD,4CACM,aAAc,AACd,WAAY,AACZ,eAAiB,CAEtB,AACD,0BACA,4CACU,cAAe,AACf,WAAY,AACZ,aAAe,CACxB,CACA,AACD,6CACI,MAAO,AACP,QAAS,AACT,SAAW,CAEd,AACD,0BACA,6CACQ,MAAO,AACP,QAAS,AACT,SAAW,CAClB,CACA,AACD,wDACM,aAAe,AACf,gBAAkB,AAClB,SAAW,CAEhB,AACD,0BACA,wDACU,WAAa,AACb,cAAgB,AAChB,SAAW,CACpB,CACA,AACD,iCACI,YAAc,AACd,WAAY,AACZ,cAAiB,CAGpB,AACD,0BACA,iCACQ,YAAc,AACd,WAAY,AACZ,cAAiB,CACxB,CACA,AACD,4CACM,cAAgB,AAChB,WAAY,AACZ,YAAe,CAEpB,AACD,0BACA,4CACU,MAAO,AACP,WAAY,AACZ,cAAiB,CAC1B,CACA,AACD,0BACA,iCACQ,aAAe,AACf,WAAY,AACZ,YAAe,CAEtB,CACA,AACD,iDACA,iCACM,aAAe,AACf,WAAY,AACZ,YAAe,CACpB,CACA,AACD,0BACA,4CACU,WAAa,AACb,WAAY,AACZ,cAAiB,CAE1B,CACA,AACD,iDACA,4CACQ,aAAe,AACf,WAAY,AACZ,MAAQ,CACf,CACA,AACD,gCACE,6DAA8D,AACtD,oDAAsD,CAC/D,AACD,uCACI,6DAA8D,AACtD,oDAAsD,CACjE,AACD,sCACI,+DAAgE,AACxD,sDAAwD,CACnE,AACD,kCACA,GACI,oBAA0B,CAC7B,AACD,GACI,qBAA0B,CAC7B,CACA,AACD,0CACA,GACI,oBAA0B,CAC7B,AACD,GACI,qBAA0B,CAC7B,CACA,AACD,kCACA,GACI,UAAa,CAChB,AACD,GACI,SAAW,CACd,CACA,AACD,0CACA,GACI,UAAa,CAChB,AACD,GACI,SAAW,CACd,CACA,AACD,oCACA,GACI,oBAA0B,CAC7B,AACD,GACI,qBAA0B,CAC7B,CACA,AACD,4CACA,GACI,oBAA0B,CAC7B,AACD,GACI,qBAA0B,CAC7B,CACA","file":"SpeechBalloonLabel.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.articleLabel-container[data-v-3e9e2064] {\n  height: 0;\n  z-index: 1;\n  position: relative;\n}\n.article-view-wrapper .node-type-opinion .articleLabel-container[data-v-3e9e2064] {\n    position: static;\n}\n.articleLabel-container--article-cover-card[data-v-3e9e2064] {\n    position: static;\n}\n.articleLabel[data-v-3e9e2064] {\n  color: #FFFFFF;\n  padding: 0.3125rem 0.75rem 0 0.6875rem;\n  height: 2.1875rem;\n  min-width: 4.8125rem;\n  background-color: #000000;\n  position: relative;\n  margin-bottom: 0.6875rem;\n}\n.articleLabel[data-v-3e9e2064]::after {\n    position: absolute;\n    z-index: 1;\n    bottom: -0.625rem;\n    left: 0;\n    content: '';\n    border-top: solid 0.6875rem #000000;\n    border-right: solid 0.6875rem transparent;\n    border-left: solid 0 transparent;\n}\n.articleLabel__live[data-v-3e9e2064] {\n    background-color: #ff0000;\n    position: relative;\n    margin-bottom: 0.6875rem;\n}\n.articleLabel__live[data-v-3e9e2064]::after {\n      position: absolute;\n      z-index: 1;\n      bottom: -0.625rem;\n      left: 0;\n      content: '';\n      border-top: solid 0.6875rem #ff0000;\n      border-right: solid 0.6875rem transparent;\n      border-left: solid 0 transparent;\n}\n.articleLabel__live[data-v-3e9e2064]::before {\n      content: '';\n      display: inline-block;\n      vertical-align: middle;\n      background-color: #FFFFFF;\n      border-radius: 50%;\n      height: 0.4375rem;\n      width: 0.4375rem;\n      margin-right: 0.25rem;\n      margin-top: -0.3125rem;\n}\n.articleLabel__live.showShadow[data-v-3e9e2064] {\n      background-color: rgba(0, 0, 0, 0.2);\n      position: relative;\n      margin-bottom: 0.625rem;\n}\n.articleLabel__live.showShadow[data-v-3e9e2064]::after {\n        position: absolute;\n        z-index: 1;\n        bottom: -0.625rem;\n        left: 0;\n        content: '';\n        border-top: solid 0.625rem rgba(0, 0, 0, 0.2);\n        border-right: solid 0.6875rem transparent;\n        border-left: solid 0 transparent;\n}\n.articleLabel__live.showShadow[data-v-3e9e2064]::before {\n        background-color: transparent;\n}\n.articleLabel__opinion[data-v-3e9e2064] {\n    background-color: #000000;\n    position: relative;\n    margin-bottom: 0.6875rem;\n}\n.articleLabel__opinion[data-v-3e9e2064]::after {\n      position: absolute;\n      z-index: 1;\n      bottom: -0.625rem;\n      left: 0;\n      content: '';\n      border-top: solid 0.6875rem #000000;\n      border-right: solid 0.6875rem transparent;\n      border-left: solid 0 transparent;\n}\n.showShadow[data-v-3e9e2064] {\n  color: transparent;\n}\n.font[data-v-3e9e2064] {\n  font-family: \"Barlow\", sans-serif;\n  font-weight: bold;\n  text-transform: uppercase;\n  white-space: nowrap;\n  font-size: 1.3125rem;\n  line-height: 1.5625rem;\n}\n.size--small[data-v-3e9e2064], .size--small-responsive[data-v-3e9e2064] {\n  -webkit-transform: scale(0.48571);\n      -ms-transform: scale(0.48571);\n          transform: scale(0.48571);\n}\n.size--small-responsive[data-v-3e9e2064] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.size--small-responsive[data-v-3e9e2064] {\n      -webkit-transform: scale(0.77143);\n          -ms-transform: scale(0.77143);\n              transform: scale(0.77143);\n}\n}\n.size--small-20-responsive[data-v-3e9e2064] {\n  -webkit-transform: scale(0.57143);\n      -ms-transform: scale(0.57143);\n          transform: scale(0.57143);\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.size--small-20-responsive[data-v-3e9e2064] {\n      -webkit-transform: scale(0.97143);\n          -ms-transform: scale(0.97143);\n              transform: scale(0.97143);\n}\n}\n.size--medium[data-v-3e9e2064] {\n  -webkit-transform: scale(0.77143);\n      -ms-transform: scale(0.77143);\n          transform: scale(0.77143);\n}\n.size--large[data-v-3e9e2064], .size--large-responsive[data-v-3e9e2064] {\n  -webkit-transform: scale(1);\n      -ms-transform: scale(1);\n          transform: scale(1);\n}\n.size--large-responsive[data-v-3e9e2064] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.size--large-responsive[data-v-3e9e2064] {\n      -webkit-transform: scale(1.51429);\n          -ms-transform: scale(1.51429);\n              transform: scale(1.51429);\n}\n}\n.pos[data-v-3e9e2064] {\n  position: absolute;\n  z-index: 2;\n}\n.pos.showShadow[data-v-3e9e2064] {\n    position: absolute;\n    z-index: 1;\n}\n.pos--article-cover-card[data-v-3e9e2064] {\n    top: 3.75rem;\n    right: auto;\n    left: 1.25rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-cover-card[data-v-3e9e2064] {\n        top: 5.8125rem;\n        right: auto;\n        left: 10.625rem;\n}\n}\n.pos--article-cover-card.showShadow[data-v-3e9e2064] {\n      top: 3.9375rem;\n      right: auto;\n      left: 1.4375rem;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-cover-card.showShadow[data-v-3e9e2064] {\n          top: 6.0625rem;\n          right: auto;\n          left: 10.875rem;\n}\n}\n.pos--article-level-one[data-v-3e9e2064] {\n    top: -0.25rem;\n    right: auto;\n    left: -0.875rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-one[data-v-3e9e2064] {\n        top: -0.25rem;\n        right: auto;\n        left: -0.875rem;\n}\n}\n.pos--article-level-one.showShadow[data-v-3e9e2064] {\n      top: -0.0625rem;\n      right: auto;\n      left: -0.6875rem;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-one.showShadow[data-v-3e9e2064] {\n          top: 0;\n          right: auto;\n          left: -0.625rem;\n}\n}\n.pos--article-level-one__node-label[data-v-3e9e2064] {\n      top: -1.1875rem;\n      right: auto;\n      left: -1.375rem;\n      /* Mobile breakpoints */\n      position: relative;\n}\n@media (min-width: 1024px) {\n.pos--article-level-one__node-label[data-v-3e9e2064] {\n          top: -1.5rem;\n          right: auto;\n          left: -0.125rem;\n}\n}\n.pos--article-level-one__node-label.showShadow[data-v-3e9e2064] {\n        top: -1rem;\n        right: auto;\n        left: -1.1875rem;\n        /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-one__node-label.showShadow[data-v-3e9e2064] {\n            top: -1.25rem;\n            right: auto;\n            left: 0.125rem;\n}\n}\n.pos--article-level-two[data-v-3e9e2064] {\n    top: 0.125rem;\n    right: auto;\n    left: -0.1875rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-two[data-v-3e9e2064] {\n        top: 0.125rem;\n        right: auto;\n        left: -0.1875rem;\n}\n}\n.pos--article-level-two.showShadow[data-v-3e9e2064] {\n      top: 0.3125rem;\n      right: auto;\n      left: 0;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-two.showShadow[data-v-3e9e2064] {\n          top: 0.375rem;\n          right: auto;\n          left: 0.0625rem;\n}\n}\n.pos--article-level-six[data-v-3e9e2064], .pos--article-level-seven[data-v-3e9e2064] {\n    top: 0.4375rem;\n    right: auto;\n    left: 0.0625rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-six[data-v-3e9e2064], .pos--article-level-seven[data-v-3e9e2064] {\n        top: 0.4375rem;\n        right: auto;\n        left: 0.0625rem;\n}\n}\n.pos--article-level-six.showShadow[data-v-3e9e2064], .pos--article-level-seven.showShadow[data-v-3e9e2064] {\n      top: 0.625rem;\n      right: auto;\n      left: 0.25rem;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-six.showShadow[data-v-3e9e2064], .pos--article-level-seven.showShadow[data-v-3e9e2064] {\n          top: 0.6875rem;\n          right: auto;\n          left: 0.3125rem;\n}\n}\n.pos--article-level-eight[data-v-3e9e2064] {\n    top: -0.5rem;\n    right: -1.375rem;\n    left: auto;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-eight[data-v-3e9e2064] {\n        top: -0.5rem;\n        right: -1.375rem;\n        left: auto;\n}\n}\n.pos--article-level-eight.showShadow[data-v-3e9e2064] {\n      top: -0.3125rem;\n      right: -1.5625rem;\n      left: auto;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--article-level-eight.showShadow[data-v-3e9e2064] {\n          top: -0.25rem;\n          right: -1.625rem;\n          left: auto;\n}\n}\n.pos--card-view[data-v-3e9e2064] {\n    top: 0.9375rem;\n    right: auto;\n    left: -10rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--card-view[data-v-3e9e2064] {\n        top: 0.9375rem;\n        right: auto;\n        left: -10rem;\n}\n}\n.pos--card-view.showShadow[data-v-3e9e2064] {\n      top: 1.125rem;\n      right: auto;\n      left: -9.8125rem;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--card-view.showShadow[data-v-3e9e2064] {\n          top: 1.1875rem;\n          right: auto;\n          left: -9.75rem;\n}\n}\n.pos--body-head__node-label[data-v-3e9e2064] {\n    top: 0;\n    right: 0;\n    left: auto;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--body-head__node-label[data-v-3e9e2064] {\n        top: 0;\n        right: 0;\n        left: auto;\n}\n}\n.pos--body-head__node-label.showShadow[data-v-3e9e2064] {\n      top: 0.1875rem;\n      right: -0.1875rem;\n      left: auto;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--body-head__node-label.showShadow[data-v-3e9e2064] {\n          top: 0.25rem;\n          right: -0.25rem;\n          left: auto;\n}\n}\n.pos--pushPopup[data-v-3e9e2064] {\n    top: -0.25rem;\n    right: auto;\n    left: -0.9375rem;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--pushPopup[data-v-3e9e2064] {\n        top: -0.25rem;\n        right: auto;\n        left: -0.9375rem;\n}\n}\n.pos--pushPopup.showShadow[data-v-3e9e2064] {\n      top: -0.0625rem;\n      right: auto;\n      left: -0.75rem;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.pos--pushPopup.showShadow[data-v-3e9e2064] {\n          top: 0;\n          right: auto;\n          left: -0.6875rem;\n}\n}\n@media (min-width: 1024px) {\n.pos--pushPopup[data-v-3e9e2064] {\n        top: 0.0625rem;\n        right: auto;\n        left: -0.25rem;\n        /* Mobile breakpoints */\n}\n}\n@media (min-width: 1024px) and (min-width: 1024px) {\n.pos--pushPopup[data-v-3e9e2064] {\n      top: 0.0625rem;\n      right: auto;\n      left: -0.25rem;\n}\n}\n@media (min-width: 1024px) {\n.pos--pushPopup.showShadow[data-v-3e9e2064] {\n          top: 0.25rem;\n          right: auto;\n          left: -0.0625rem;\n          /* Mobile breakpoints */\n}\n}\n@media (min-width: 1024px) and (min-width: 1024px) {\n.pos--pushPopup.showShadow[data-v-3e9e2064] {\n        top: 0.3125rem;\n        right: auto;\n        left: 0;\n}\n}\n.animate__live[data-v-3e9e2064] {\n  -webkit-animation: colorchangeBox-data-v-3e9e2064 1s infinite;\n          animation: colorchangeBox-data-v-3e9e2064 1s infinite;\n}\n.animate__live[data-v-3e9e2064]::before {\n    -webkit-animation: colorchangeDot-data-v-3e9e2064 1s infinite;\n            animation: colorchangeDot-data-v-3e9e2064 1s infinite;\n}\n.animate__live[data-v-3e9e2064]::after {\n    -webkit-animation: colorchangeArrow-data-v-3e9e2064 1s infinite;\n            animation: colorchangeArrow-data-v-3e9e2064 1s infinite;\n}\n@-webkit-keyframes colorchangeBox {\n0% {\n    background-color: #ff0000;\n}\n100% {\n    background-color: #ff6666;\n}\n}\n@keyframes colorchangeBox-data-v-3e9e2064 {\n0% {\n    background-color: #ff0000;\n}\n100% {\n    background-color: #ff6666;\n}\n}\n@-webkit-keyframes colorchangeDot {\n0% {\n    opacity: 0.6;\n}\n100% {\n    opacity: 1;\n}\n}\n@keyframes colorchangeDot-data-v-3e9e2064 {\n0% {\n    opacity: 0.6;\n}\n100% {\n    opacity: 1;\n}\n}\n@-webkit-keyframes colorchangeArrow {\n0% {\n    border-top-color: #ff0000;\n}\n100% {\n    border-top-color: #ff6666;\n}\n}\n@keyframes colorchangeArrow-data-v-3e9e2064 {\n0% {\n    border-top-color: #ff0000;\n}\n100% {\n    border-top-color: #ff6666;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(1082)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(955);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("76e51bbb", content, true, {});

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 960:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showLabel) ? _c('div', {
    class: ("articleLabel-container articleLabel-container--" + _vm.mainComponent)
  }, [(_vm.showShadow) ? _c('div', {
    class: (_vm.baseClasses + " showShadow")
  }, [_vm._v(_vm._s(_vm.articleType))]) : _vm._e(), _c('div', {
    class: (_vm.baseClasses + " animate__" + _vm.articleType)
  }, [_vm._v(_vm._s(_vm.articleType))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="20" height="18" viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg"><path d="M7 0L5.17 2H2C.9 2 0 2.9 0 4v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-3.17L13 0H7zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1.8a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z"/></svg>'};

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="18" height="12" viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg"><path d="M14 4.5V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V7.5l4 4V.5l-4 4z"/></svg>'};

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(147),
    toNumber = __webpack_require__(339),
    toString = __webpack_require__(25);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(1037),
    isObject = __webpack_require__(31);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Topic = __webpack_require__(984);

var _Topic2 = _interopRequireDefault(_Topic);

var _Section = __webpack_require__(959);

var _Section2 = _interopRequireDefault(_Section);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _utilities = __webpack_require__(51);

var _icon_photo = __webpack_require__(961);

var _icon_photo2 = _interopRequireDefault(_icon_photo);

var _icon_video = __webpack_require__(962);

var _icon_video2 = _interopRequireDefault(_icon_video);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'node-label',
  props: {
    node: {
      type: Object,
      default: {}
    },
    truncateLength: {
      type: Number
    },
    noColor: {
      type: Boolean,
      default: false
    }
  },
  mixins: [_section2.default],
  components: {
    FieldTopic: _Topic2.default,
    FieldSection: _Section2.default,
    SvgIconPhoto: _icon_photo2.default,
    SvgIconVideo: _icon_video2.default
  },
  computed: {
    labelColor: function labelColor() {
      var sectionColor = this.sectionColor;
      if (this.sectionColor === '#FCEB40' && (0, _utilities.isDesktop)()) sectionColor = '#C5B900';
      return this.noColor ? '' : sectionColor;
    },
    sections: function sections() {
      var _this = this;

      var sections = [];
      (0, _forEach2.default)((0, _get2.default)(this, 'node.sections', []), function (sectionLineage) {
        var sectionList = (0, _map2.default)(sectionLineage, _this.$store.getters.term);
        sections.push(sectionList);
      });
      return sections;
    },
    topics: function topics() {
      return (0, _map2.default)((0, _get2.default)(this, 'node.topics', []), this.$store.getters.term);
    },
    articleType: function articleType() {
      return (0, _utilities.getArticleType)(this.node);
    }
  }
};

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

var _truncate = __webpack_require__(336);

var _truncate2 = _interopRequireDefault(_truncate);

var _Link = __webpack_require__(103);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'field-section',
  mixins: [_section2.default],
  components: {
    TermLink: _Link2.default
  },
  props: {
    sections: [Array, Object],
    tag: {
      type: String,
      default: 'div'
    },
    truncateLength: {
      type: [Number, String],
      default: 999
    },
    color: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {};
  },

  methods: {
    truncate: _truncate2.default
  }
};

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _isArray = __webpack_require__(10);

var _isArray2 = _interopRequireDefault(_isArray);

var _truncate = __webpack_require__(336);

var _truncate2 = _interopRequireDefault(_truncate);

var _Link = __webpack_require__(103);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'field-topic',
  components: {
    TermLink: _Link2.default
  },
  props: {
    color: {
      type: String,
      default: ''
    },
    topics: [Array, Object],
    tag: {
      type: String,
      default: 'div'
    },
    truncateLength: {
      type: [Number, String],
      default: 999
    }
  },
  computed: {
    firstTopic: function firstTopic() {
      var topic = {};
      if ((0, _isArray2.default)(this.topics)) {
        topic = (0, _head2.default)(this.topics);
      }
      return topic;
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    truncate: _truncate2.default
  }
};

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports = {"audio/midi":["mid","midi","kar","rmi"],"audio/mp4":["mp4a","m4a"],"audio/mpeg":["mpga","mp2","mp2a","mp3","m2a","m3a"],"audio/ogg":["oga","ogg","spx"],"audio/webm":["weba"],"audio/x-matroska":["mka"],"audio/x-mpegurl":["m3u"],"audio/wav":["wav"],"video/3gpp":["3gp"],"video/3gpp2":["3g2"],"video/mp4":["mp4","mp4v","mpg4"],"video/mpeg":["mpeg","mpg","mpe","m1v","m2v"],"video/ogg":["ogv"],"video/quicktime":["qt","mov"],"video/webm":["webm"],"video/x-f4v":["f4v"],"video/x-fli":["fli"],"video/x-flv":["flv"],"video/x-m4v":["m4v"],"video/x-matroska":["mkv","mk3d","mks"]}

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".node-label{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.node-label,.node-label .icon-wrapper{vertical-align:middle;display:-webkit-box;display:-ms-flexbox;display:flex}.node-label .icon-wrapper{margin-left:.5rem;position:relative}.node-label .icon-wrapper svg{position:relative}.node-label .icon-wrapper--video svg{top:.0625rem}.node-label .fields{display:-webkit-box;display:-ms-flexbox;display:flex}.node-label svg{fill:currentColor;width:.9375rem;height:.875rem}", "", {"version":3,"sources":["/app/components/node/Label.vue"],"names":[],"mappings":"AAgCA,YAKE,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,sCAZE,sBAAuB,AACvB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAgBf,AAPD,0BACI,kBAAoB,AAEpB,iBAAmB,CAItB,AACD,8BACM,iBAAmB,CACxB,AACD,qCACI,YAAe,CAClB,AACD,oBACI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,gBACI,kBAAmB,AACnB,eAAiB,AACjB,cAAiB,CACpB","file":"Label.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.node-label {\n  vertical-align: middle;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.node-label .icon-wrapper {\n    margin-left: 0.5rem;\n    vertical-align: middle;\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.node-label .icon-wrapper svg {\n      position: relative;\n}\n.node-label .icon-wrapper--video svg {\n    top: 0.0625rem;\n}\n.node-label .fields {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.node-label svg {\n    fill: currentColor;\n    width: 0.9375rem;\n    height: 0.875rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(971);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("bd45142c", content, true, {});

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(940)

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

module.exports = isNode

function isNode (val) {
  return (!val || typeof val !== 'object')
    ? false
    : (typeof window === 'object' && typeof window.Node === 'object')
      ? (val instanceof window.Node)
      : (typeof val.nodeType === 'number') &&
        (typeof val.nodeName === 'string')
}


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(352),
    baseEach = __webpack_require__(108),
    baseIteratee = __webpack_require__(74),
    baseReduce = __webpack_require__(1035),
    isArray = __webpack_require__(10);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(980)
  , forEach = __webpack_require__(973)
  , isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    }

module.exports = function (headers) {
  if (!headers)
    return {}

  var result = {}

  forEach(
      trim(headers).split('\n')
    , function (row) {
        var index = row.indexOf(':')
          , key = trim(row.slice(0, index)).toLowerCase()
          , value = trim(row.slice(index + 1))

        if (typeof(result[key]) === 'undefined') {
          result[key] = value
        } else if (isArray(result[key])) {
          result[key].push(value)
        } else {
          result[key] = [ result[key], value ]
        }
      }
  )

  return result
}

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports =
  global.performance &&
  global.performance.now ? function now() {
    return performance.now()
  } : Date.now || function now() {
    return +new Date
  }

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

var isDom = __webpack_require__(975)
var lookup = __webpack_require__(939)

module.exports.video = simpleMediaElement.bind(null, 'video')
module.exports.audio = simpleMediaElement.bind(null, 'audio')

function simpleMediaElement (elementName, sources, opt) {
  opt = opt || {}

  if (!Array.isArray(sources)) {
    sources = [ sources ]
  }

  var media = opt.element || document.createElement(elementName)

  if (opt.loop) media.setAttribute('loop', 'loop')
  if (opt.muted) media.setAttribute('muted', 'muted')
  if (opt.autoplay) media.setAttribute('autoplay', 'autoplay')
  if (opt.controls) media.setAttribute('controls', 'controls')
  if (opt.crossOrigin) media.setAttribute('crossorigin', opt.crossOrigin)
  if (opt.preload) media.setAttribute('preload', opt.preload)
  if (opt.poster) media.setAttribute('poster', opt.poster)
  if (typeof opt.volume !== 'undefined') media.setAttribute('volume', opt.volume)

  sources = sources.filter(Boolean)
  sources.forEach(function (source) {
    media.appendChild(createSourceElement(source))
  })

  return media
}

function createSourceElement (data) {
  if (isDom(data)) return data
  if (typeof data === 'string') {
    data = { src: data }
    if (data.src) {
      var ext = extension(data.src)
      if (ext) data.type = lookup(ext)
    }
  }

  var source = document.createElement('source')
  if (data.src) source.setAttribute('src', data.src)
  if (data.type) source.setAttribute('type', data.type)
  return source
}

function extension (data) {
  var extIdx = data.lastIndexOf('.')
  if (extIdx <= 0 || extIdx === data.length - 1) {
    return null
  }
  return data.substring(extIdx + 1)
}


/***/ }),

/***/ 980:
/***/ (function(module, exports) {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1621)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1366),
  /* template */
  __webpack_require__(1778),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a904b68c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(987),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 985:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tag, {
    tag: "component",
    staticClass: "fields field-section",
    style: ({
      'color': _vm.color
    })
  }, [(_vm.lastSection.tid) ? _c('term-link', {
    attrs: {
      "tid": _vm.lastSection.tid,
      "title": _vm.lastSection.title,
      "url": _vm.lastSection.relative_url,
      "type": _vm.lastSection.type
    }
  }, [_vm._v("\n             " + _vm._s(_vm.truncate(_vm.lastSection.title, {
    length: _vm.truncateLength > 0 ? this.truncateLength : 999,
    separator: /,? +/,
  })) + "\n             ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 986:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node-label"
  }, [(_vm.topics.length) ? _c('field-topic', {
    attrs: {
      "color": _vm.labelColor,
      "topics": _vm.topics,
      "truncateLength": _vm.truncateLength
    }
  }) : (_vm.sections.length) ? _c('field-section', {
    attrs: {
      "color": _vm.labelColor,
      "sections": _vm.sections,
      "truncateLength": _vm.truncateLength
    }
  }) : _vm._e(), _vm._t("speechBalloonLabel"), (_vm.articleType === 'photo-essay') ? _c('span', {
    staticClass: "icon-wrapper icon-wrapper--photo"
  }, [_c('svg-icon-photo')], 1) : _vm._e(), (_vm.articleType === 'video') ? _c('span', {
    staticClass: "icon-wrapper icon-wrapper--video"
  }, [_c('svg-icon-video')], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstTopic.title) ? _c(_vm.tag, {
    tag: "component",
    staticClass: "fields field-topic",
    style: ({
      'color': _vm.color
    })
  }, [_c('term-link', {
    attrs: {
      "tid": _vm.firstTopic.tid,
      "title": _vm.firstTopic.title,
      "url": _vm.firstTopic.relative_url,
      "type": _vm.firstTopic.type
    }
  }, [_vm._v(_vm._s(_vm.truncate(_vm.firstTopic.title, {
    length: _vm.truncateLength > 0 ? this.truncateLength : 999,
    separator: /,? +/,
  })))])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 988:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="30" height="18" viewBox="0 0 30 18" xmlns="http://www.w3.org/2000/svg"><path d="M30 0v6h-6v6h-6v6h-6v-6H6V6H0V0z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

var buffer = __webpack_require__(990)
var media = __webpack_require__(992)

module.exports = webAudioPlayer
function webAudioPlayer (src, opt) {
  if (!src) throw new TypeError('must specify a src parameter')
  opt = opt || {}
  if (opt.buffer) return buffer(src, opt)
  else return media(src, opt)
}


/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var canPlaySrc = __webpack_require__(942)
var createAudioContext = __webpack_require__(941)
var xhrAudio = __webpack_require__(993)
var EventEmitter = __webpack_require__(925).EventEmitter
var rightNow = __webpack_require__(978)
var resume = __webpack_require__(943)

module.exports = createBufferSource
function createBufferSource (src, opt) {
  opt = opt || {}
  var emitter = new EventEmitter()
  var audioContext = opt.context || createAudioContext()

  // a pass-through node so user just needs to
  // connect() once
  var bufferNode, buffer, duration
  var node = audioContext.createGain()
  var audioStartTime = null
  var audioPauseTime = null
  var audioCurrentTime = 0
  var playing = false
  var loop = opt.loop

  emitter.play = function () {
    if (playing) return
    playing = true

    if (opt.autoResume !== false) resume(emitter.context)
    disposeBuffer()
    bufferNode = audioContext.createBufferSource()
    bufferNode.connect(emitter.node)
    bufferNode.onended = ended
    if (buffer) {
      // Might be null undefined if we are still loading
      bufferNode.buffer = buffer
    }
    if (loop) {
      bufferNode.loop = true
      if (typeof opt.loopStart === 'number') bufferNode.loopStart = opt.loopStart
      if (typeof opt.loopEnd === 'number') bufferNode.loopEnd = opt.loopEnd
    }

    if (duration && audioCurrentTime > duration) {
      // for when it loops...
      audioCurrentTime = audioCurrentTime % duration
    }
    var nextTime = audioCurrentTime

    bufferNode.start(0, nextTime)
    audioStartTime = rightNow()
  }

  emitter.pause = function () {
    if (!playing) return
    playing = false
    // Don't let the "end" event
    // get triggered on manual pause.
    bufferNode.onended = null
    bufferNode.stop(0)
    audioPauseTime = rightNow()
    audioCurrentTime += (audioPauseTime - audioStartTime) / 1000
  }

  emitter.stop = function () {
    emitter.pause()
    ended()
  }

  emitter.dispose = function () {
    disposeBuffer()
    buffer = null
  }

  emitter.node = node
  emitter.context = audioContext

  Object.defineProperties(emitter, {
    duration: {
      enumerable: true, configurable: true,
      get: function () {
        return duration
      }
    },
    playing: {
      enumerable: true, configurable: true,
      get: function () {
        return playing
      }
    },
    buffer: {
      enumerable: true, configurable: true,
      get: function () {
        return buffer
      }
    },
    volume: {
      enumerable: true, configurable: true,
      get: function () {
        return node.gain.value
      },
      set: function (n) {
        node.gain.value = n
      }
    }
  })

  // set initial volume
  if (typeof opt.volume === 'number') {
    emitter.volume = opt.volume
  }

  // filter down to a list of playable sources
  var sources = Array.isArray(src) ? src : [ src ]
  sources = sources.filter(Boolean)
  var playable = sources.some(canPlaySrc)
  if (playable) {
    var source = sources.filter(canPlaySrc)[0]
    // Support the same source types as in
    // MediaElement mode...
    if (typeof source.getAttribute === 'function') {
      source = source.getAttribute('src')
    } else if (typeof source.src === 'string') {
      source = source.src
    }
    // We have at least one playable source.
    // For now just play the first,
    // ideally this module could attempt each one.
    startLoad(source)
  } else {
    // no sources can be played...
    process.nextTick(function () {
      emitter.emit('error', canPlaySrc.createError(sources))
    })
  }
  return emitter

  function startLoad (src) {
    xhrAudio(audioContext, src, function audioDecoded (err, decoded) {
      if (err) return emitter.emit('error', err)
      buffer = decoded // store for later use
      if (bufferNode) {
        // if play() was called early
        bufferNode.buffer = buffer
      }
      duration = buffer.duration
      node.buffer = buffer
      emitter.emit('load')
    }, function audioProgress (amount, total) {
      emitter.emit('progress', amount, total)
    }, function audioDecoding () {
      emitter.emit('decoding')
    })
  }

  function ended () {
    emitter.emit('end')
    playing = false
    audioCurrentTime = 0
  }

  function disposeBuffer () {
    if (bufferNode) bufferNode.disconnect()
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

module.exports = addOnce
function addOnce (element, event, fn) {
  function tmp (ev) {
    element.removeEventListener(event, tmp, false)
    fn(ev, element)
  }
  element.addEventListener(event, tmp, false)
}

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var EventEmitter = __webpack_require__(925).EventEmitter
var createAudio = __webpack_require__(979).audio
var assign = __webpack_require__(958)

var resume = __webpack_require__(943)
var createAudioContext = __webpack_require__(941)
var canPlaySrc = __webpack_require__(942)
var addOnce = __webpack_require__(991)

module.exports = createMediaSource
function createMediaSource (src, opt) {
  opt = assign({}, opt)
  var emitter = new EventEmitter()

  // Default to Audio instead of HTMLAudioElement
  // There is not much difference except in the following:
  //    x instanceof Audio
  //    x instanceof HTMLAudioElement
  // And in my experience Audio has better support on various
  // platforms like CocoonJS.
  // Please open an issue if there is a concern with this.
  if (!opt.element) opt.element = new window.Audio()

  var desiredVolume = opt.volume
  delete opt.volume // make sure <audio> tag receives full volume
  var audio = createAudio(src, opt)
  var audioContext = opt.context || createAudioContext()
  var node = audioContext.createGain()
  var mediaNode = audioContext.createMediaElementSource(audio)
  mediaNode.connect(node)

  audio.addEventListener('ended', function () {
    emitter.emit('end')
  })

  var loopStart = opt.loopStart
  var loopEnd = opt.loopEnd
  var hasLoopStart = typeof loopStart === 'number' && isFinite(loopStart)
  var hasLoopEnd = typeof loopEnd === 'number' && isFinite(loopEnd)
  var isLoopReady = false
  if (hasLoopStart || hasLoopEnd) {
    window.requestAnimationFrame(function update () {
      // audio hasn't been loaded yet...
      if (typeof audio.duration !== 'number') return
      var currentTime = audio.currentTime

      // where to end the buffer
      var endTime = hasLoopEnd ? Math.min(audio.duration, loopEnd) : audio.duration

      if (currentTime > (loopStart || 0)) {
        isLoopReady = true
      }

      // jump ahead to loop start point
      if (hasLoopStart && isLoopReady && currentTime < loopStart) {
        audio.currentTime = loopStart
      }

      // if we've hit the end of the buffer
      if (currentTime >= endTime) {
        // if there is no loop end point, let native looping take over
        // if we have a loop end point, jump back to start point or zero
        if (hasLoopEnd) {
          audio.currentTime = hasLoopStart ? loopStart : 0
        }
      }
      window.requestAnimationFrame(update)
    });
  }

  emitter.element = audio
  emitter.context = audioContext
  emitter.node = node
  emitter.pause = audio.pause.bind(audio)
  emitter.play = function () {
    if (opt.autoResume !== false) resume(emitter.context)
    return audio.play()
  }

  // This exists currently for parity with Buffer source
  // Open to suggestions for what this should dispose...
  emitter.dispose = function () {}

  emitter.stop = function () {
    var wasPlaying = emitter.playing
    audio.pause()
    audio.currentTime = 0
    isLoopReady = false
    if (wasPlaying) {
      emitter.emit('end')
    }
  }

  Object.defineProperties(emitter, {
    duration: {
      enumerable: true, configurable: true,
      get: function () {
        return audio.duration
      }
    },
    currentTime: {
      enumerable: true, configurable: true,
      get: function () {
        return audio.currentTime
      }
    },
    playing: {
      enumerable: true, configurable: true,
      get: function () {
        return !audio.paused
      }
    },
    volume: {
      enumerable: true, configurable: true,
      get: function () {
        return node.gain.value
      },
      set: function (n) {
        node.gain.value = n
      }
    }
  })

  // Set initial volume
  if (typeof desiredVolume === 'number') {
    emitter.volume = desiredVolume
  }

  // Check if all sources are unplayable,
  // if so we emit an error since the browser
  // might not.
  var sources = Array.isArray(src) ? src : [ src ]
  sources = sources.filter(Boolean)
  var playable = sources.some(canPlaySrc)
  if (playable) {
    // At least one source is probably/maybe playable
    startLoad()
  } else {
    // emit error on next tick so user can catch it
    process.nextTick(function () {
      emitter.emit('error', canPlaySrc.createError(sources))
    })
  }

  return emitter

  function startLoad () {
    // The file errors (like decoding / 404s) appear on <source>
    var srcElements = Array.prototype.slice.call(audio.children)
    var remainingSrcErrors = srcElements.length
    var hasErrored = false
    var sourceError = function (err, el) {
      if (hasErrored) return
      remainingSrcErrors--
      console.warn('Error loading source: ' + el.getAttribute('src'))
      if (remainingSrcErrors <= 0) {
        hasErrored = true
        srcElements.forEach(function (el) {
          el.removeEventListener('error', sourceError, false)
        })
        emitter.emit('error', new Error('Could not play any of the supplied sources'))
      }
    }

    var done = function () {
      emitter.emit('load')
    }

    if (audio.readyState >= audio.HAVE_ENOUGH_DATA) {
      process.nextTick(done)
    } else {
      addOnce(audio, 'canplay', done)
      addOnce(audio, 'error', function (ev) {
        emitter.emit(new Error('Unknown error while loading <audio>'))
      })
      srcElements.forEach(function (el) {
        addOnce(el, 'error', sourceError)
      })
    }

    // On most browsers the loading begins
    // immediately. However, on iOS 9.2 Safari,
    // you need to call load() for events
    // to be triggered.
    audio.load()
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

var xhr = __webpack_require__(995)
var xhrProgress = __webpack_require__(994)

module.exports = xhrAudio
function xhrAudio (audioContext, src, cb, progress, decoding) {
  var xhrObject = xhr({
    uri: src,
    responseType: 'arraybuffer'
  }, function (err, resp, arrayBuf) {
    if (!/^2/.test(resp.statusCode)) {
      err = new Error('status code ' + resp.statusCode + ' requesting ' + src)
    }
    if (err) return cb(err)
    decode(arrayBuf)
  })

  xhrProgress(xhrObject)
    .on('data', function (amount, total) {
      progress(amount, total)
    })

  function decode (arrayBuf) {
    decoding()
    audioContext.decodeAudioData(arrayBuf, function (decoded) {
      cb(null, decoded)
    }, function () {
      var err = new Error('Error decoding audio data')
      err.type = 'DECODE_AUDIO_DATA'
      cb(err)
    })
  }
}


/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

var EventEmitter = __webpack_require__(925).EventEmitter

module.exports = progress

function progress(xhr) {
  var emitter = new EventEmitter
  var finished = false

  if (xhr.attachEvent) {
    xhr.attachEvent('onreadystatechange', done)
    return emitter
  }

  xhr.addEventListener('load', done, false)
  xhr.addEventListener('progress', progress, false)
  function progress(event) {
    var value = event.lengthComputable
      ? event.loaded / event.total
      : 0

    if (!finished) emitter.emit('data'
      , value
      , event.total || null
    )

    finished = value === 1
  }

  function done(event) {
    if (event.type !== 'load' && !/^(ready|complete)$/g.test(
      (event.currentTarget || event.srcElement).readyState
    )) return

    if (finished) return
    if (xhr.removeEventListener) {
      xhr.removeEventListener('load', done, false)
      xhr.removeEventListener('progress', progress, false)
    } else
    if (xhr.detatchEvent) {
      xhr.detatchEvent('onreadystatechange', done)
    }

    emitter.emit('data', 1, event.total || null)
    emitter.emit('done')
    finished = true
  }

  return emitter
}


/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var window = __webpack_require__(974)
var isFunction = __webpack_require__(940)
var parseHeaders = __webpack_require__(977)
var xtend = __webpack_require__(996)

module.exports = createXHR
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest

forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = initParams(uri, options, callback)
        options.method = method.toUpperCase()
        return _createXHR(options)
    }
})

function forEachArray(array, iterator) {
    for (var i = 0; i < array.length; i++) {
        iterator(array[i])
    }
}

function isEmpty(obj){
    for(var i in obj){
        if(obj.hasOwnProperty(i)) return false
    }
    return true
}

function initParams(uri, options, callback) {
    var params = uri

    if (isFunction(options)) {
        callback = options
        if (typeof uri === "string") {
            params = {uri:uri}
        }
    } else {
        params = xtend(options, {uri: uri})
    }

    params.callback = callback
    return params
}

function createXHR(uri, options, callback) {
    options = initParams(uri, options, callback)
    return _createXHR(options)
}

function _createXHR(options) {
    if(typeof options.callback === "undefined"){
        throw new Error("callback argument missing")
    }

    var called = false
    var callback = function cbOnce(err, response, body){
        if(!called){
            called = true
            options.callback(err, response, body)
        }
    }

    function readystatechange() {
        if (xhr.readyState === 4) {
            setTimeout(loadFunc, 0)
        }
    }

    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined

        if (xhr.response) {
            body = xhr.response
        } else {
            body = xhr.responseText || getXml(xhr)
        }

        if (isJson) {
            try {
                body = JSON.parse(body)
            } catch (e) {}
        }

        return body
    }

    function errorFunc(evt) {
        clearTimeout(timeoutTimer)
        if(!(evt instanceof Error)){
            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
        }
        evt.statusCode = 0
        return callback(evt, failureResponse)
    }

    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return
        var status
        clearTimeout(timeoutTimer)
        if(options.useXDR && xhr.status===undefined) {
            //IE8 CORS GET successful response doesn't have a status field, but body is fine
            status = 200
        } else {
            status = (xhr.status === 1223 ? 204 : xhr.status)
        }
        var response = failureResponse
        var err = null

        if (status !== 0){
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            }
            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
                response.headers = parseHeaders(xhr.getAllResponseHeaders())
            }
        } else {
            err = new Error("Internal XMLHttpRequest Error")
        }
        return callback(err, response, response.body)
    }

    var xhr = options.xhr || null

    if (!xhr) {
        if (options.cors || options.useXDR) {
            xhr = new createXHR.XDomainRequest()
        }else{
            xhr = new createXHR.XMLHttpRequest()
        }
    }

    var key
    var aborted
    var uri = xhr.url = options.uri || options.url
    var method = xhr.method = options.method || "GET"
    var body = options.body || options.data
    var headers = xhr.headers = options.headers || {}
    var sync = !!options.sync
    var isJson = false
    var timeoutTimer
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    }

    if ("json" in options && options.json !== false) {
        isJson = true
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json)
        }
    }

    xhr.onreadystatechange = readystatechange
    xhr.onload = loadFunc
    xhr.onerror = errorFunc
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function () {
        // IE must die
    }
    xhr.onabort = function(){
        aborted = true;
    }
    xhr.ontimeout = errorFunc
    xhr.open(method, uri, !sync, options.username, options.password)
    //has to be after open
    if(!sync) {
        xhr.withCredentials = !!options.withCredentials
    }
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0 ) {
        timeoutTimer = setTimeout(function(){
            if (aborted) return
            aborted = true//IE9 may still call readystatechange
            xhr.abort("timeout")
            var e = new Error("XMLHttpRequest timeout")
            e.code = "ETIMEDOUT"
            errorFunc(e)
        }, options.timeout )
    }

    if (xhr.setRequestHeader) {
        for(key in headers){
            if(headers.hasOwnProperty(key)){
                xhr.setRequestHeader(key, headers[key])
            }
        }
    } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error("Headers cannot be set on an XDomainRequest object")
    }

    if ("responseType" in options) {
        xhr.responseType = options.responseType
    }

    if ("beforeSend" in options &&
        typeof options.beforeSend === "function"
    ) {
        options.beforeSend(xhr)
    }

    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null)

    return xhr


}

function getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") {
            return xhr.responseXML
        }
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
        if (xhr.responseType === "" && !firefoxBugTakenEffect) {
            return xhr.responseXML
        }
    } catch (e) {}

    return null
}

function noop() {}


/***/ }),

/***/ 996:
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(334)
var startOfISOWeek = __webpack_require__(956)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(964);

/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */
var floor = createRound('floor');

module.exports = floor;


/***/ })

});


// WEBPACK FOOTER //
// 1.dcba42eed2899798cf07.js